// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23343a40%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23dee2e6%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27m6 10 3 3 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%272%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%280, 0, 0, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgb%28134, 182.5, 254%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%28255, 255, 255, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%23198754%27 d=%27M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 12 12%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23dc3545%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23dc3545%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%2833, 37, 41, 0.75%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27none%27 stroke=%27%23212529%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpath d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27none%27 stroke=%27rgb%285.2, 44, 101.2%29%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpath d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27rgb%28109.8, 168, 253.8%29%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23000%27%3e%3cpath d=%27M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../icons/external-link.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../icons/external-link-grey.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../images/complete-check.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("../images/RON-loader.gif", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*!
 * Bootstrap  v5.3.8 (https://getbootstrap.com/)
 * Copyright 2011-2025 The Bootstrap Authors
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 */
:root,
[data-bs-theme=light] {
  --bs-blue: #0d6efd;
  --bs-indigo: #6610f2;
  --bs-purple: #6f42c1;
  --bs-pink: #d63384;
  --bs-red: #dc3545;
  --bs-orange: #fd7e14;
  --bs-yellow: #ffc107;
  --bs-green: #198754;
  --bs-teal: #20c997;
  --bs-cyan: #0dcaf0;
  --bs-black: #000;
  --bs-white: #fff;
  --bs-gray: #6c757d;
  --bs-gray-dark: #343a40;
  --bs-gray-100: #f8f9fa;
  --bs-gray-200: #e9ecef;
  --bs-gray-300: #dee2e6;
  --bs-gray-400: #ced4da;
  --bs-gray-500: #adb5bd;
  --bs-gray-600: #6c757d;
  --bs-gray-700: #495057;
  --bs-gray-800: #343a40;
  --bs-gray-900: #212529;
  --bs-primary: #0d6efd;
  --bs-secondary: #6c757d;
  --bs-success: #198754;
  --bs-info: #0dcaf0;
  --bs-warning: #ffc107;
  --bs-danger: #dc3545;
  --bs-light: #f8f9fa;
  --bs-dark: #212529;
  --bs-primary-rgb: 13, 110, 253;
  --bs-secondary-rgb: 108, 117, 125;
  --bs-success-rgb: 25, 135, 84;
  --bs-info-rgb: 13, 202, 240;
  --bs-warning-rgb: 255, 193, 7;
  --bs-danger-rgb: 220, 53, 69;
  --bs-light-rgb: 248, 249, 250;
  --bs-dark-rgb: 33, 37, 41;
  --bs-primary-text-emphasis: rgb(5.2, 44, 101.2);
  --bs-secondary-text-emphasis: rgb(43.2, 46.8, 50);
  --bs-success-text-emphasis: rgb(10, 54, 33.6);
  --bs-info-text-emphasis: rgb(5.2, 80.8, 96);
  --bs-warning-text-emphasis: rgb(102, 77.2, 2.8);
  --bs-danger-text-emphasis: rgb(88, 21.2, 27.6);
  --bs-light-text-emphasis: #495057;
  --bs-dark-text-emphasis: #495057;
  --bs-primary-bg-subtle: rgb(206.6, 226, 254.6);
  --bs-secondary-bg-subtle: rgb(225.6, 227.4, 229);
  --bs-success-bg-subtle: rgb(209, 231, 220.8);
  --bs-info-bg-subtle: rgb(206.6, 244.4, 252);
  --bs-warning-bg-subtle: rgb(255, 242.6, 205.4);
  --bs-danger-bg-subtle: rgb(248, 214.6, 217.8);
  --bs-light-bg-subtle: rgb(251.5, 252, 252.5);
  --bs-dark-bg-subtle: #ced4da;
  --bs-primary-border-subtle: rgb(158.2, 197, 254.2);
  --bs-secondary-border-subtle: rgb(196.2, 199.8, 203);
  --bs-success-border-subtle: rgb(163, 207, 186.6);
  --bs-info-border-subtle: rgb(158.2, 233.8, 249);
  --bs-warning-border-subtle: rgb(255, 230.2, 155.8);
  --bs-danger-border-subtle: rgb(241, 174.2, 180.6);
  --bs-light-border-subtle: #e9ecef;
  --bs-dark-border-subtle: #adb5bd;
  --bs-white-rgb: 255, 255, 255;
  --bs-black-rgb: 0, 0, 0;
  --bs-font-sans-serif: system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
  --bs-body-font-family: var(--bs-font-sans-serif);
  --bs-body-font-size: 1rem;
  --bs-body-font-weight: 400;
  --bs-body-line-height: 1.5;
  --bs-body-color: #212529;
  --bs-body-color-rgb: 33, 37, 41;
  --bs-body-bg: #fff;
  --bs-body-bg-rgb: 255, 255, 255;
  --bs-emphasis-color: #000;
  --bs-emphasis-color-rgb: 0, 0, 0;
  --bs-secondary-color: rgba(33, 37, 41, 0.75);
  --bs-secondary-color-rgb: 33, 37, 41;
  --bs-secondary-bg: #e9ecef;
  --bs-secondary-bg-rgb: 233, 236, 239;
  --bs-tertiary-color: rgba(33, 37, 41, 0.5);
  --bs-tertiary-color-rgb: 33, 37, 41;
  --bs-tertiary-bg: #f8f9fa;
  --bs-tertiary-bg-rgb: 248, 249, 250;
  --bs-heading-color: inherit;
  --bs-link-color: #0d6efd;
  --bs-link-color-rgb: 13, 110, 253;
  --bs-link-decoration: underline;
  --bs-link-hover-color: rgb(10.4, 88, 202.4);
  --bs-link-hover-color-rgb: 10, 88, 202;
  --bs-code-color: #d63384;
  --bs-highlight-color: #212529;
  --bs-highlight-bg: rgb(255, 242.6, 205.4);
  --bs-border-width: 1px;
  --bs-border-style: solid;
  --bs-border-color: #dee2e6;
  --bs-border-color-translucent: rgba(0, 0, 0, 0.175);
  --bs-border-radius: 0.375rem;
  --bs-border-radius-sm: 0.25rem;
  --bs-border-radius-lg: 0.5rem;
  --bs-border-radius-xl: 1rem;
  --bs-border-radius-xxl: 2rem;
  --bs-border-radius-2xl: var(--bs-border-radius-xxl);
  --bs-border-radius-pill: 50rem;
  --bs-box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  --bs-box-shadow-sm: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  --bs-box-shadow-lg: 0 1rem 3rem rgba(0, 0, 0, 0.175);
  --bs-box-shadow-inset: inset 0 1px 2px rgba(0, 0, 0, 0.075);
  --bs-focus-ring-width: 0.25rem;
  --bs-focus-ring-opacity: 0.25;
  --bs-focus-ring-color: rgba(13, 110, 253, 0.25);
  --bs-form-valid-color: #198754;
  --bs-form-valid-border-color: #198754;
  --bs-form-invalid-color: #dc3545;
  --bs-form-invalid-border-color: #dc3545;
}

[data-bs-theme=dark] {
  color-scheme: dark;
  --bs-body-color: #dee2e6;
  --bs-body-color-rgb: 222, 226, 230;
  --bs-body-bg: #212529;
  --bs-body-bg-rgb: 33, 37, 41;
  --bs-emphasis-color: #fff;
  --bs-emphasis-color-rgb: 255, 255, 255;
  --bs-secondary-color: rgba(222, 226, 230, 0.75);
  --bs-secondary-color-rgb: 222, 226, 230;
  --bs-secondary-bg: #343a40;
  --bs-secondary-bg-rgb: 52, 58, 64;
  --bs-tertiary-color: rgba(222, 226, 230, 0.5);
  --bs-tertiary-color-rgb: 222, 226, 230;
  --bs-tertiary-bg: rgb(42.5, 47.5, 52.5);
  --bs-tertiary-bg-rgb: 43, 48, 53;
  --bs-primary-text-emphasis: rgb(109.8, 168, 253.8);
  --bs-secondary-text-emphasis: rgb(166.8, 172.2, 177);
  --bs-success-text-emphasis: rgb(117, 183, 152.4);
  --bs-info-text-emphasis: rgb(109.8, 223.2, 246);
  --bs-warning-text-emphasis: rgb(255, 217.8, 106.2);
  --bs-danger-text-emphasis: rgb(234, 133.8, 143.4);
  --bs-light-text-emphasis: #f8f9fa;
  --bs-dark-text-emphasis: #dee2e6;
  --bs-primary-bg-subtle: rgb(2.6, 22, 50.6);
  --bs-secondary-bg-subtle: rgb(21.6, 23.4, 25);
  --bs-success-bg-subtle: rgb(5, 27, 16.8);
  --bs-info-bg-subtle: rgb(2.6, 40.4, 48);
  --bs-warning-bg-subtle: rgb(51, 38.6, 1.4);
  --bs-danger-bg-subtle: rgb(44, 10.6, 13.8);
  --bs-light-bg-subtle: #343a40;
  --bs-dark-bg-subtle: #1a1d20;
  --bs-primary-border-subtle: rgb(7.8, 66, 151.8);
  --bs-secondary-border-subtle: rgb(64.8, 70.2, 75);
  --bs-success-border-subtle: rgb(15, 81, 50.4);
  --bs-info-border-subtle: rgb(7.8, 121.2, 144);
  --bs-warning-border-subtle: rgb(153, 115.8, 4.2);
  --bs-danger-border-subtle: rgb(132, 31.8, 41.4);
  --bs-light-border-subtle: #495057;
  --bs-dark-border-subtle: #343a40;
  --bs-heading-color: inherit;
  --bs-link-color: rgb(109.8, 168, 253.8);
  --bs-link-hover-color: rgb(138.84, 185.4, 254.04);
  --bs-link-color-rgb: 110, 168, 254;
  --bs-link-hover-color-rgb: 139, 185, 254;
  --bs-code-color: rgb(230.4, 132.6, 181.2);
  --bs-highlight-color: #dee2e6;
  --bs-highlight-bg: rgb(102, 77.2, 2.8);
  --bs-border-color: #495057;
  --bs-border-color-translucent: rgba(255, 255, 255, 0.15);
  --bs-form-valid-color: rgb(117, 183, 152.4);
  --bs-form-valid-border-color: rgb(117, 183, 152.4);
  --bs-form-invalid-color: rgb(234, 133.8, 143.4);
  --bs-form-invalid-border-color: rgb(234, 133.8, 143.4);
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

@media (prefers-reduced-motion: no-preference) {
  :root {
    scroll-behavior: smooth;
  }
}

body {
  margin: 0;
  font-family: var(--bs-body-font-family);
  font-size: var(--bs-body-font-size);
  font-weight: var(--bs-body-font-weight);
  line-height: var(--bs-body-line-height);
  color: var(--bs-body-color);
  text-align: var(--bs-body-text-align);
  background-color: var(--bs-body-bg);
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

hr {
  margin: 1rem 0;
  color: inherit;
  border: 0;
  border-top: var(--bs-border-width) solid;
  opacity: 0.25;
}

h6, .h6, h5, .h5, h4, .h4, h3, .h3, h2, .h2, h1, .h1 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
  color: var(--bs-heading-color);
}

h1, .h1 {
  font-size: calc(1.375rem + 1.5vw);
}
@media (min-width: 1200px) {
  h1, .h1 {
    font-size: 2.5rem;
  }
}

h2, .h2 {
  font-size: calc(1.325rem + 0.9vw);
}
@media (min-width: 1200px) {
  h2, .h2 {
    font-size: 2rem;
  }
}

h3, .h3 {
  font-size: calc(1.3rem + 0.6vw);
}
@media (min-width: 1200px) {
  h3, .h3 {
    font-size: 1.75rem;
  }
}

h4, .h4 {
  font-size: calc(1.275rem + 0.3vw);
}
@media (min-width: 1200px) {
  h4, .h4 {
    font-size: 1.5rem;
  }
}

h5, .h5 {
  font-size: 1.25rem;
}

h6, .h6 {
  font-size: 1rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title] {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
  cursor: help;
  text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul {
  padding-left: 2rem;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 700;
}

dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: bolder;
}

small, .small {
  font-size: 0.875em;
}

mark, .mark {
  padding: 0.1875em;
  color: var(--bs-highlight-color);
  background-color: var(--bs-highlight-bg);
}

sub,
sup {
  position: relative;
  font-size: 0.75em;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 1));
  text-decoration: underline;
}
a:hover {
  --bs-link-color-rgb: var(--bs-link-hover-color-rgb);
}

a:not([href]):not([class]), a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}

pre,
code,
kbd,
samp {
  font-family: var(--bs-font-monospace);
  font-size: 1em;
}

pre {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  font-size: 0.875em;
}
pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

code {
  font-size: 0.875em;
  color: var(--bs-code-color);
  word-wrap: break-word;
}
a > code {
  color: inherit;
}

kbd {
  padding: 0.1875rem 0.375rem;
  font-size: 0.875em;
  color: var(--bs-body-bg);
  background-color: var(--bs-body-color);
  border-radius: 0.25rem;
}
kbd kbd {
  padding: 0;
  font-size: 1em;
}

figure {
  margin: 0 0 1rem;
}

img,
svg {
  vertical-align: middle;
}

table {
  caption-side: bottom;
  border-collapse: collapse;
}

caption {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--bs-secondary-color);
  text-align: left;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0;
}

label {
  display: inline-block;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}
select:disabled {
  opacity: 1;
}

[list]:not([type=date]):not([type=datetime-local]):not([type=month]):not([type=week]):not([type=time])::-webkit-calendar-picker-indicator {
  display: none !important;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}
button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

textarea {
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  float: left;
  width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  line-height: inherit;
  font-size: calc(1.275rem + 0.3vw);
}
@media (min-width: 1200px) {
  legend {
    font-size: 1.5rem;
  }
}
legend + * {
  clear: left;
}

::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-year-field {
  padding: 0;
}

::-webkit-inner-spin-button {
  height: auto;
}

[type=search] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}
[type=search]::-webkit-search-cancel-button {
  cursor: pointer;
  filter: grayscale(1);
}

/* rtl:raw:
[type="tel"],
[type="url"],
[type="email"],
[type="number"] {
  direction: ltr;
}
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-color-swatch-wrapper {
  padding: 0;
}

::file-selector-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

iframe {
  border: 0;
}

summary {
  display: list-item;
  cursor: pointer;
}

progress {
  vertical-align: baseline;
}

[hidden] {
  display: none !important;
}

.lead {
  font-size: 1.25rem;
  font-weight: 300;
}

.display-1 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.625rem + 4.5vw);
}
@media (min-width: 1200px) {
  .display-1 {
    font-size: 5rem;
  }
}

.display-2 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.575rem + 3.9vw);
}
@media (min-width: 1200px) {
  .display-2 {
    font-size: 4.5rem;
  }
}

.display-3 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.525rem + 3.3vw);
}
@media (min-width: 1200px) {
  .display-3 {
    font-size: 4rem;
  }
}

.display-4 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.475rem + 2.7vw);
}
@media (min-width: 1200px) {
  .display-4 {
    font-size: 3.5rem;
  }
}

.display-5 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.425rem + 2.1vw);
}
@media (min-width: 1200px) {
  .display-5 {
    font-size: 3rem;
  }
}

.display-6 {
  font-weight: 300;
  line-height: 1.2;
  font-size: calc(1.375rem + 1.5vw);
}
@media (min-width: 1200px) {
  .display-6 {
    font-size: 2.5rem;
  }
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.list-inline {
  padding-left: 0;
  list-style: none;
}

.list-inline-item {
  display: inline-block;
}
.list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}

.initialism {
  font-size: 0.875em;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1rem;
  font-size: 1.25rem;
}
.blockquote > :last-child {
  margin-bottom: 0;
}

.blockquote-footer {
  margin-top: -1rem;
  margin-bottom: 1rem;
  font-size: 0.875em;
  color: #6c757d;
}
.blockquote-footer::before {
  content: "— ";
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: var(--bs-body-bg);
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  max-width: 100%;
  height: auto;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}

.figure-caption {
  font-size: 0.875em;
  color: var(--bs-secondary-color);
}

.container,
.container-fluid,
.container-xxl,
.container-xl,
.container-lg,
.container-md,
.container-sm {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container-sm, .container {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  .container-md, .container-sm, .container {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  .container-lg, .container-md, .container-sm, .container {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1140px;
  }
}
@media (min-width: 1400px) {
  .container-xxl, .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1320px;
  }
}
:root {
  --bs-breakpoint-xs: 0;
  --bs-breakpoint-sm: 576px;
  --bs-breakpoint-md: 768px;
  --bs-breakpoint-lg: 992px;
  --bs-breakpoint-xl: 1200px;
  --bs-breakpoint-xxl: 1400px;
}

.row {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(-1 * var(--bs-gutter-y));
  margin-right: calc(-0.5 * var(--bs-gutter-x));
  margin-left: calc(-0.5 * var(--bs-gutter-x));
}
.row > * {
  flex-shrink: 0;
  width: 100%;
  max-width: 100%;
  padding-right: calc(var(--bs-gutter-x) * 0.5);
  padding-left: calc(var(--bs-gutter-x) * 0.5);
  margin-top: var(--bs-gutter-y);
}

.col {
  flex: 1 0;
}

.row-cols-auto > * {
  flex: 0 0 auto;
  width: auto;
}

.row-cols-1 > * {
  flex: 0 0 auto;
  width: 100%;
}

.row-cols-2 > * {
  flex: 0 0 auto;
  width: 50%;
}

.row-cols-3 > * {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.row-cols-4 > * {
  flex: 0 0 auto;
  width: 25%;
}

.row-cols-5 > * {
  flex: 0 0 auto;
  width: 20%;
}

.row-cols-6 > * {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-auto {
  flex: 0 0 auto;
  width: auto;
}

.col-1 {
  flex: 0 0 auto;
  width: 8.33333333%;
}

.col-2 {
  flex: 0 0 auto;
  width: 16.66666667%;
}

.col-3 {
  flex: 0 0 auto;
  width: 25%;
}

.col-4 {
  flex: 0 0 auto;
  width: 33.33333333%;
}

.col-5 {
  flex: 0 0 auto;
  width: 41.66666667%;
}

.col-6 {
  flex: 0 0 auto;
  width: 50%;
}

.col-7 {
  flex: 0 0 auto;
  width: 58.33333333%;
}

.col-8 {
  flex: 0 0 auto;
  width: 66.66666667%;
}

.col-9 {
  flex: 0 0 auto;
  width: 75%;
}

.col-10 {
  flex: 0 0 auto;
  width: 83.33333333%;
}

.col-11 {
  flex: 0 0 auto;
  width: 91.66666667%;
}

.col-12 {
  flex: 0 0 auto;
  width: 100%;
}

.offset-1 {
  margin-left: 8.33333333%;
}

.offset-2 {
  margin-left: 16.66666667%;
}

.offset-3 {
  margin-left: 25%;
}

.offset-4 {
  margin-left: 33.33333333%;
}

.offset-5 {
  margin-left: 41.66666667%;
}

.offset-6 {
  margin-left: 50%;
}

.offset-7 {
  margin-left: 58.33333333%;
}

.offset-8 {
  margin-left: 66.66666667%;
}

.offset-9 {
  margin-left: 75%;
}

.offset-10 {
  margin-left: 83.33333333%;
}

.offset-11 {
  margin-left: 91.66666667%;
}

.g-0,
.gx-0 {
  --bs-gutter-x: 0;
}

.g-0,
.gy-0 {
  --bs-gutter-y: 0;
}

.g-1,
.gx-1 {
  --bs-gutter-x: 0.25rem;
}

.g-1,
.gy-1 {
  --bs-gutter-y: 0.25rem;
}

.g-2,
.gx-2 {
  --bs-gutter-x: 0.5rem;
}

.g-2,
.gy-2 {
  --bs-gutter-y: 0.5rem;
}

.g-3,
.gx-3 {
  --bs-gutter-x: 1rem;
}

.g-3,
.gy-3 {
  --bs-gutter-y: 1rem;
}

.g-4,
.gx-4 {
  --bs-gutter-x: 1.5rem;
}

.g-4,
.gy-4 {
  --bs-gutter-y: 1.5rem;
}

.g-5,
.gx-5 {
  --bs-gutter-x: 3rem;
}

.g-5,
.gy-5 {
  --bs-gutter-y: 3rem;
}

@media (min-width: 576px) {
  .col-sm {
    flex: 1 0;
  }
  .row-cols-sm-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-sm-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-sm-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-sm-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-sm-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-sm-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-sm-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-sm-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-sm-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-sm-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-sm-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-sm-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-sm-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-sm-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-sm-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-sm-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-sm-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-sm-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-sm-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-sm-0 {
    margin-left: 0;
  }
  .offset-sm-1 {
    margin-left: 8.33333333%;
  }
  .offset-sm-2 {
    margin-left: 16.66666667%;
  }
  .offset-sm-3 {
    margin-left: 25%;
  }
  .offset-sm-4 {
    margin-left: 33.33333333%;
  }
  .offset-sm-5 {
    margin-left: 41.66666667%;
  }
  .offset-sm-6 {
    margin-left: 50%;
  }
  .offset-sm-7 {
    margin-left: 58.33333333%;
  }
  .offset-sm-8 {
    margin-left: 66.66666667%;
  }
  .offset-sm-9 {
    margin-left: 75%;
  }
  .offset-sm-10 {
    margin-left: 83.33333333%;
  }
  .offset-sm-11 {
    margin-left: 91.66666667%;
  }
  .g-sm-0,
  .gx-sm-0 {
    --bs-gutter-x: 0;
  }
  .g-sm-0,
  .gy-sm-0 {
    --bs-gutter-y: 0;
  }
  .g-sm-1,
  .gx-sm-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-sm-1,
  .gy-sm-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-sm-2,
  .gx-sm-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-sm-2,
  .gy-sm-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-sm-3,
  .gx-sm-3 {
    --bs-gutter-x: 1rem;
  }
  .g-sm-3,
  .gy-sm-3 {
    --bs-gutter-y: 1rem;
  }
  .g-sm-4,
  .gx-sm-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-sm-4,
  .gy-sm-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-sm-5,
  .gx-sm-5 {
    --bs-gutter-x: 3rem;
  }
  .g-sm-5,
  .gy-sm-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 768px) {
  .col-md {
    flex: 1 0;
  }
  .row-cols-md-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-md-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-md-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-md-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-md-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-md-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-md-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-md-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-md-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-md-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-md-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-md-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-md-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-md-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-md-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-md-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-md-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-md-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-md-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-md-0 {
    margin-left: 0;
  }
  .offset-md-1 {
    margin-left: 8.33333333%;
  }
  .offset-md-2 {
    margin-left: 16.66666667%;
  }
  .offset-md-3 {
    margin-left: 25%;
  }
  .offset-md-4 {
    margin-left: 33.33333333%;
  }
  .offset-md-5 {
    margin-left: 41.66666667%;
  }
  .offset-md-6 {
    margin-left: 50%;
  }
  .offset-md-7 {
    margin-left: 58.33333333%;
  }
  .offset-md-8 {
    margin-left: 66.66666667%;
  }
  .offset-md-9 {
    margin-left: 75%;
  }
  .offset-md-10 {
    margin-left: 83.33333333%;
  }
  .offset-md-11 {
    margin-left: 91.66666667%;
  }
  .g-md-0,
  .gx-md-0 {
    --bs-gutter-x: 0;
  }
  .g-md-0,
  .gy-md-0 {
    --bs-gutter-y: 0;
  }
  .g-md-1,
  .gx-md-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-md-1,
  .gy-md-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-md-2,
  .gx-md-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-md-2,
  .gy-md-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-md-3,
  .gx-md-3 {
    --bs-gutter-x: 1rem;
  }
  .g-md-3,
  .gy-md-3 {
    --bs-gutter-y: 1rem;
  }
  .g-md-4,
  .gx-md-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-md-4,
  .gy-md-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-md-5,
  .gx-md-5 {
    --bs-gutter-x: 3rem;
  }
  .g-md-5,
  .gy-md-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 992px) {
  .col-lg {
    flex: 1 0;
  }
  .row-cols-lg-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-lg-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-lg-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-lg-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-lg-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-lg-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-lg-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-lg-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-lg-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-lg-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-lg-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-lg-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-lg-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-lg-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-lg-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-lg-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-lg-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-lg-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-lg-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-lg-0 {
    margin-left: 0;
  }
  .offset-lg-1 {
    margin-left: 8.33333333%;
  }
  .offset-lg-2 {
    margin-left: 16.66666667%;
  }
  .offset-lg-3 {
    margin-left: 25%;
  }
  .offset-lg-4 {
    margin-left: 33.33333333%;
  }
  .offset-lg-5 {
    margin-left: 41.66666667%;
  }
  .offset-lg-6 {
    margin-left: 50%;
  }
  .offset-lg-7 {
    margin-left: 58.33333333%;
  }
  .offset-lg-8 {
    margin-left: 66.66666667%;
  }
  .offset-lg-9 {
    margin-left: 75%;
  }
  .offset-lg-10 {
    margin-left: 83.33333333%;
  }
  .offset-lg-11 {
    margin-left: 91.66666667%;
  }
  .g-lg-0,
  .gx-lg-0 {
    --bs-gutter-x: 0;
  }
  .g-lg-0,
  .gy-lg-0 {
    --bs-gutter-y: 0;
  }
  .g-lg-1,
  .gx-lg-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-lg-1,
  .gy-lg-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-lg-2,
  .gx-lg-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-lg-2,
  .gy-lg-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-lg-3,
  .gx-lg-3 {
    --bs-gutter-x: 1rem;
  }
  .g-lg-3,
  .gy-lg-3 {
    --bs-gutter-y: 1rem;
  }
  .g-lg-4,
  .gx-lg-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-lg-4,
  .gy-lg-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-lg-5,
  .gx-lg-5 {
    --bs-gutter-x: 3rem;
  }
  .g-lg-5,
  .gy-lg-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 1200px) {
  .col-xl {
    flex: 1 0;
  }
  .row-cols-xl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-xl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xl-0 {
    margin-left: 0;
  }
  .offset-xl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xl-3 {
    margin-left: 25%;
  }
  .offset-xl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xl-6 {
    margin-left: 50%;
  }
  .offset-xl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xl-9 {
    margin-left: 75%;
  }
  .offset-xl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xl-11 {
    margin-left: 91.66666667%;
  }
  .g-xl-0,
  .gx-xl-0 {
    --bs-gutter-x: 0;
  }
  .g-xl-0,
  .gy-xl-0 {
    --bs-gutter-y: 0;
  }
  .g-xl-1,
  .gx-xl-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-xl-1,
  .gy-xl-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-xl-2,
  .gx-xl-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-xl-2,
  .gy-xl-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-xl-3,
  .gx-xl-3 {
    --bs-gutter-x: 1rem;
  }
  .g-xl-3,
  .gy-xl-3 {
    --bs-gutter-y: 1rem;
  }
  .g-xl-4,
  .gx-xl-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-xl-4,
  .gy-xl-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-xl-5,
  .gx-xl-5 {
    --bs-gutter-x: 3rem;
  }
  .g-xl-5,
  .gy-xl-5 {
    --bs-gutter-y: 3rem;
  }
}
@media (min-width: 1400px) {
  .col-xxl {
    flex: 1 0;
  }
  .row-cols-xxl-auto > * {
    flex: 0 0 auto;
    width: auto;
  }
  .row-cols-xxl-1 > * {
    flex: 0 0 auto;
    width: 100%;
  }
  .row-cols-xxl-2 > * {
    flex: 0 0 auto;
    width: 50%;
  }
  .row-cols-xxl-3 > * {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .row-cols-xxl-4 > * {
    flex: 0 0 auto;
    width: 25%;
  }
  .row-cols-xxl-5 > * {
    flex: 0 0 auto;
    width: 20%;
  }
  .row-cols-xxl-6 > * {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-auto {
    flex: 0 0 auto;
    width: auto;
  }
  .col-xxl-1 {
    flex: 0 0 auto;
    width: 8.33333333%;
  }
  .col-xxl-2 {
    flex: 0 0 auto;
    width: 16.66666667%;
  }
  .col-xxl-3 {
    flex: 0 0 auto;
    width: 25%;
  }
  .col-xxl-4 {
    flex: 0 0 auto;
    width: 33.33333333%;
  }
  .col-xxl-5 {
    flex: 0 0 auto;
    width: 41.66666667%;
  }
  .col-xxl-6 {
    flex: 0 0 auto;
    width: 50%;
  }
  .col-xxl-7 {
    flex: 0 0 auto;
    width: 58.33333333%;
  }
  .col-xxl-8 {
    flex: 0 0 auto;
    width: 66.66666667%;
  }
  .col-xxl-9 {
    flex: 0 0 auto;
    width: 75%;
  }
  .col-xxl-10 {
    flex: 0 0 auto;
    width: 83.33333333%;
  }
  .col-xxl-11 {
    flex: 0 0 auto;
    width: 91.66666667%;
  }
  .col-xxl-12 {
    flex: 0 0 auto;
    width: 100%;
  }
  .offset-xxl-0 {
    margin-left: 0;
  }
  .offset-xxl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xxl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xxl-3 {
    margin-left: 25%;
  }
  .offset-xxl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xxl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xxl-6 {
    margin-left: 50%;
  }
  .offset-xxl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xxl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xxl-9 {
    margin-left: 75%;
  }
  .offset-xxl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xxl-11 {
    margin-left: 91.66666667%;
  }
  .g-xxl-0,
  .gx-xxl-0 {
    --bs-gutter-x: 0;
  }
  .g-xxl-0,
  .gy-xxl-0 {
    --bs-gutter-y: 0;
  }
  .g-xxl-1,
  .gx-xxl-1 {
    --bs-gutter-x: 0.25rem;
  }
  .g-xxl-1,
  .gy-xxl-1 {
    --bs-gutter-y: 0.25rem;
  }
  .g-xxl-2,
  .gx-xxl-2 {
    --bs-gutter-x: 0.5rem;
  }
  .g-xxl-2,
  .gy-xxl-2 {
    --bs-gutter-y: 0.5rem;
  }
  .g-xxl-3,
  .gx-xxl-3 {
    --bs-gutter-x: 1rem;
  }
  .g-xxl-3,
  .gy-xxl-3 {
    --bs-gutter-y: 1rem;
  }
  .g-xxl-4,
  .gx-xxl-4 {
    --bs-gutter-x: 1.5rem;
  }
  .g-xxl-4,
  .gy-xxl-4 {
    --bs-gutter-y: 1.5rem;
  }
  .g-xxl-5,
  .gx-xxl-5 {
    --bs-gutter-x: 3rem;
  }
  .g-xxl-5,
  .gy-xxl-5 {
    --bs-gutter-y: 3rem;
  }
}
.table {
  --bs-table-color-type: initial;
  --bs-table-bg-type: initial;
  --bs-table-color-state: initial;
  --bs-table-bg-state: initial;
  --bs-table-color: var(--bs-emphasis-color);
  --bs-table-bg: var(--bs-body-bg);
  --bs-table-border-color: var(--bs-border-color);
  --bs-table-accent-bg: transparent;
  --bs-table-striped-color: var(--bs-emphasis-color);
  --bs-table-striped-bg: rgba(var(--bs-emphasis-color-rgb), 0.05);
  --bs-table-active-color: var(--bs-emphasis-color);
  --bs-table-active-bg: rgba(var(--bs-emphasis-color-rgb), 0.1);
  --bs-table-hover-color: var(--bs-emphasis-color);
  --bs-table-hover-bg: rgba(var(--bs-emphasis-color-rgb), 0.075);
  width: 100%;
  margin-bottom: 1rem;
  vertical-align: top;
  border-color: var(--bs-table-border-color);
}
.table > :not(caption) > * > * {
  padding: 0.5rem 0.5rem;
  color: var(--bs-table-color-state, var(--bs-table-color-type, var(--bs-table-color)));
  background-color: var(--bs-table-bg);
  border-bottom-width: var(--bs-border-width);
  box-shadow: inset 0 0 0 9999px var(--bs-table-bg-state, var(--bs-table-bg-type, var(--bs-table-accent-bg)));
}
.table > tbody {
  vertical-align: inherit;
}
.table > thead {
  vertical-align: bottom;
}

.table-group-divider {
  border-top: calc(var(--bs-border-width) * 2) solid currentcolor;
}

.caption-top {
  caption-side: top;
}

.table-sm > :not(caption) > * > * {
  padding: 0.25rem 0.25rem;
}

.table-bordered > :not(caption) > * {
  border-width: var(--bs-border-width) 0;
}
.table-bordered > :not(caption) > * > * {
  border-width: 0 var(--bs-border-width);
}

.table-borderless > :not(caption) > * > * {
  border-bottom-width: 0;
}
.table-borderless > :not(:first-child) {
  border-top-width: 0;
}

.table-striped > tbody > tr:nth-of-type(odd) > * {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg);
}

.table-striped-columns > :not(caption) > tr > :nth-child(even) {
  --bs-table-color-type: var(--bs-table-striped-color);
  --bs-table-bg-type: var(--bs-table-striped-bg);
}

.table-active {
  --bs-table-color-state: var(--bs-table-active-color);
  --bs-table-bg-state: var(--bs-table-active-bg);
}

.table-hover > tbody > tr:hover > * {
  --bs-table-color-state: var(--bs-table-hover-color);
  --bs-table-bg-state: var(--bs-table-hover-bg);
}

.table-primary {
  --bs-table-color: #000;
  --bs-table-bg: rgb(206.6, 226, 254.6);
  --bs-table-border-color: rgb(165.28, 180.8, 203.68);
  --bs-table-striped-bg: rgb(196.27, 214.7, 241.87);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(185.94, 203.4, 229.14);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(191.105, 209.05, 235.505);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-secondary {
  --bs-table-color: #000;
  --bs-table-bg: rgb(225.6, 227.4, 229);
  --bs-table-border-color: rgb(180.48, 181.92, 183.2);
  --bs-table-striped-bg: rgb(214.32, 216.03, 217.55);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(203.04, 204.66, 206.1);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(208.68, 210.345, 211.825);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-success {
  --bs-table-color: #000;
  --bs-table-bg: rgb(209, 231, 220.8);
  --bs-table-border-color: rgb(167.2, 184.8, 176.64);
  --bs-table-striped-bg: rgb(198.55, 219.45, 209.76);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(188.1, 207.9, 198.72);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(193.325, 213.675, 204.24);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-info {
  --bs-table-color: #000;
  --bs-table-bg: rgb(206.6, 244.4, 252);
  --bs-table-border-color: rgb(165.28, 195.52, 201.6);
  --bs-table-striped-bg: rgb(196.27, 232.18, 239.4);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(185.94, 219.96, 226.8);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(191.105, 226.07, 233.1);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-warning {
  --bs-table-color: #000;
  --bs-table-bg: rgb(255, 242.6, 205.4);
  --bs-table-border-color: rgb(204, 194.08, 164.32);
  --bs-table-striped-bg: rgb(242.25, 230.47, 195.13);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(229.5, 218.34, 184.86);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(235.875, 224.405, 189.995);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-danger {
  --bs-table-color: #000;
  --bs-table-bg: rgb(248, 214.6, 217.8);
  --bs-table-border-color: rgb(198.4, 171.68, 174.24);
  --bs-table-striped-bg: rgb(235.6, 203.87, 206.91);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(223.2, 193.14, 196.02);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(229.4, 198.505, 201.465);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-light {
  --bs-table-color: #000;
  --bs-table-bg: #f8f9fa;
  --bs-table-border-color: rgb(198.4, 199.2, 200);
  --bs-table-striped-bg: rgb(235.6, 236.55, 237.5);
  --bs-table-striped-color: #000;
  --bs-table-active-bg: rgb(223.2, 224.1, 225);
  --bs-table-active-color: #000;
  --bs-table-hover-bg: rgb(229.4, 230.325, 231.25);
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-dark {
  --bs-table-color: #fff;
  --bs-table-bg: #212529;
  --bs-table-border-color: rgb(77.4, 80.6, 83.8);
  --bs-table-striped-bg: rgb(44.1, 47.9, 51.7);
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: rgb(55.2, 58.8, 62.4);
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: rgb(49.65, 53.35, 57.05);
  --bs-table-hover-color: #fff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

@media (max-width: 575.98px) {
  .table-responsive-sm {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 767.98px) {
  .table-responsive-md {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 991.98px) {
  .table-responsive-lg {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1199.98px) {
  .table-responsive-xl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
@media (max-width: 1399.98px) {
  .table-responsive-xxl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
}
.form-label {
  margin-bottom: 0.5rem;
}

.col-form-label {
  padding-top: calc(0.375rem + var(--bs-border-width));
  padding-bottom: calc(0.375rem + var(--bs-border-width));
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
}

.col-form-label-lg {
  padding-top: calc(0.5rem + var(--bs-border-width));
  padding-bottom: calc(0.5rem + var(--bs-border-width));
  font-size: 1.25rem;
}

.col-form-label-sm {
  padding-top: calc(0.25rem + var(--bs-border-width));
  padding-bottom: calc(0.25rem + var(--bs-border-width));
  font-size: 0.875rem;
}

.form-text {
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--bs-secondary-color);
}

.form-control {
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  appearance: none;
  background-color: var(--bs-body-bg);
  background-clip: padding-box;
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}
.form-control[type=file] {
  overflow: hidden;
}
.form-control[type=file]:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control:focus {
  color: var(--bs-body-color);
  background-color: var(--bs-body-bg);
  border-color: rgb(134, 182.5, 254);
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.form-control::-webkit-date-and-time-value {
  min-width: 85px;
  height: 1.5em;
  margin: 0;
}
.form-control::-webkit-datetime-edit {
  display: block;
  padding: 0;
}
.form-control::placeholder {
  color: var(--bs-secondary-color);
  opacity: 1;
}
.form-control:disabled {
  background-color: var(--bs-secondary-bg);
  opacity: 1;
}
.form-control::file-selector-button {
  padding: 0.375rem 0.75rem;
  margin: -0.375rem -0.75rem;
  margin-inline-end: 0.75rem;
  color: var(--bs-body-color);
  background-color: var(--bs-tertiary-bg);
  pointer-events: none;
  border-color: inherit;
  border-style: solid;
  border-width: 0;
  border-inline-end-width: var(--bs-border-width);
  border-radius: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control::file-selector-button {
    transition: none;
  }
}
.form-control:hover:not(:disabled):not([readonly])::file-selector-button {
  background-color: var(--bs-secondary-bg);
}

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.375rem 0;
  margin-bottom: 0;
  line-height: 1.5;
  color: var(--bs-body-color);
  background-color: transparent;
  border: solid transparent;
  border-width: var(--bs-border-width) 0;
}
.form-control-plaintext:focus {
  outline: 0;
}
.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}

.form-control-sm {
  min-height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  border-radius: var(--bs-border-radius-sm);
}
.form-control-sm::file-selector-button {
  padding: 0.25rem 0.5rem;
  margin: -0.25rem -0.5rem;
  margin-inline-end: 0.5rem;
}

.form-control-lg {
  min-height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  border-radius: var(--bs-border-radius-lg);
}
.form-control-lg::file-selector-button {
  padding: 0.5rem 1rem;
  margin: -0.5rem -1rem;
  margin-inline-end: 1rem;
}

textarea.form-control {
  min-height: calc(1.5em + 0.75rem + calc(var(--bs-border-width) * 2));
}
textarea.form-control-sm {
  min-height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));
}
textarea.form-control-lg {
  min-height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));
}

.form-control-color {
  width: 3rem;
  height: calc(1.5em + 0.75rem + calc(var(--bs-border-width) * 2));
  padding: 0.375rem;
}
.form-control-color:not(:disabled):not([readonly]) {
  cursor: pointer;
}
.form-control-color::-moz-color-swatch {
  border: 0 !important;
  border-radius: var(--bs-border-radius);
}
.form-control-color::-webkit-color-swatch {
  border: 0 !important;
  border-radius: var(--bs-border-radius);
}
.form-control-color.form-control-sm {
  height: calc(1.5em + 0.5rem + calc(var(--bs-border-width) * 2));
}
.form-control-color.form-control-lg {
  height: calc(1.5em + 1rem + calc(var(--bs-border-width) * 2));
}

.form-select {
  --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  display: block;
  width: 100%;
  padding: 0.375rem 2.25rem 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  appearance: none;
  background-color: var(--bs-body-bg);
  background-image: var(--bs-form-select-bg-img), var(--bs-form-select-bg-icon, none);
  background-repeat: no-repeat;
  background-position: right 0.75rem center;
  background-size: 16px 12px;
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-select {
    transition: none;
  }
}
.form-select:focus {
  border-color: rgb(134, 182.5, 254);
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.form-select[multiple], .form-select[size]:not([size="1"]) {
  padding-right: 0.75rem;
  background-image: none;
}
.form-select:disabled {
  background-color: var(--bs-secondary-bg);
}
.form-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 var(--bs-body-color);
}

.form-select-sm {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  font-size: 0.875rem;
  border-radius: var(--bs-border-radius-sm);
}

.form-select-lg {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  font-size: 1.25rem;
  border-radius: var(--bs-border-radius-lg);
}

[data-bs-theme=dark] .form-select {
  --bs-form-select-bg-img: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.form-check {
  display: block;
  min-height: 1.5rem;
  padding-left: 1.5em;
  margin-bottom: 0.125rem;
}
.form-check .form-check-input {
  float: left;
  margin-left: -1.5em;
}

.form-check-reverse {
  padding-right: 1.5em;
  padding-left: 0;
  text-align: right;
}
.form-check-reverse .form-check-input {
  float: right;
  margin-right: -1.5em;
  margin-left: 0;
}

.form-check-input {
  --bs-form-check-bg: var(--bs-body-bg);
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  margin-top: 0.25em;
  vertical-align: top;
  appearance: none;
  background-color: var(--bs-form-check-bg);
  background-image: var(--bs-form-check-bg-image);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: var(--bs-border-width) solid var(--bs-border-color);
  print-color-adjust: exact;
}
.form-check-input[type=checkbox] {
  border-radius: 0.25em;
}
.form-check-input[type=radio] {
  border-radius: 50%;
}
.form-check-input:active {
  filter: brightness(90%);
}
.form-check-input:focus {
  border-color: rgb(134, 182.5, 254);
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.form-check-input:checked {
  background-color: #0d6efd;
  border-color: #0d6efd;
}
.form-check-input:checked[type=checkbox] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.form-check-input:checked[type=radio] {
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
.form-check-input[type=checkbox]:indeterminate {
  background-color: #0d6efd;
  border-color: #0d6efd;
  --bs-form-check-bg-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
.form-check-input:disabled {
  pointer-events: none;
  filter: none;
  opacity: 0.5;
}
.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {
  cursor: default;
  opacity: 0.5;
}

.form-switch {
  padding-left: 2.5em;
}
.form-switch .form-check-input {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  width: 2em;
  margin-left: -2.5em;
  background-image: var(--bs-form-switch-bg);
  background-position: left center;
  border-radius: 2em;
  transition: background-position 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-switch .form-check-input {
    transition: none;
  }
}
.form-switch .form-check-input:focus {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
.form-switch .form-check-input:checked {
  background-position: right center;
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}
.form-switch.form-check-reverse {
  padding-right: 2.5em;
  padding-left: 0;
}
.form-switch.form-check-reverse .form-check-input {
  margin-right: -2.5em;
  margin-left: 0;
}

.form-check-inline {
  display: inline-block;
  margin-right: 1rem;
}

.btn-check {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}
.btn-check[disabled] + .btn, .btn-check:disabled + .btn {
  pointer-events: none;
  filter: none;
  opacity: 0.65;
}

[data-bs-theme=dark] .form-switch .form-check-input:not(:checked):not(:focus) {
  --bs-form-switch-bg: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

.form-range {
  width: 100%;
  height: 1.5rem;
  padding: 0;
  appearance: none;
  background-color: transparent;
}
.form-range:focus {
  outline: 0;
}
.form-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.form-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.form-range::-moz-focus-outer {
  border: 0;
}
.form-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  appearance: none;
  background-color: #0d6efd;
  border: 0;
  border-radius: 1rem;
  -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-webkit-slider-thumb {
    -webkit-transition: none;
    transition: none;
  }
}
.form-range::-webkit-slider-thumb:active {
  background-color: rgb(182.4, 211.5, 254.4);
}
.form-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--bs-secondary-bg);
  border-color: transparent;
  border-radius: 1rem;
}
.form-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  appearance: none;
  background-color: #0d6efd;
  border: 0;
  border-radius: 1rem;
  -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-range::-moz-range-thumb {
    -moz-transition: none;
    transition: none;
  }
}
.form-range::-moz-range-thumb:active {
  background-color: rgb(182.4, 211.5, 254.4);
}
.form-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: var(--bs-secondary-bg);
  border-color: transparent;
  border-radius: 1rem;
}
.form-range:disabled {
  pointer-events: none;
}
.form-range:disabled::-webkit-slider-thumb {
  background-color: var(--bs-secondary-color);
}
.form-range:disabled::-moz-range-thumb {
  background-color: var(--bs-secondary-color);
}

.form-floating {
  position: relative;
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext,
.form-floating > .form-select {
  height: calc(3.5rem + calc(var(--bs-border-width) * 2));
  min-height: calc(3.5rem + calc(var(--bs-border-width) * 2));
  line-height: 1.25;
}
.form-floating > label {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  max-width: 100%;
  height: 100%;
  padding: 1rem 0.75rem;
  overflow: hidden;
  color: rgba(var(--bs-body-color-rgb), 0.65);
  text-align: start;
  text-overflow: ellipsis;
  white-space: nowrap;
  pointer-events: none;
  border: var(--bs-border-width) solid transparent;
  transform-origin: 0 0;
  transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-floating > label {
    transition: none;
  }
}
.form-floating > .form-control,
.form-floating > .form-control-plaintext {
  padding: 1rem 0.75rem;
}
.form-floating > .form-control::placeholder,
.form-floating > .form-control-plaintext::placeholder {
  color: transparent;
}
.form-floating > .form-control:focus, .form-floating > .form-control:not(:placeholder-shown),
.form-floating > .form-control-plaintext:focus,
.form-floating > .form-control-plaintext:not(:placeholder-shown) {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-control:-webkit-autofill,
.form-floating > .form-control-plaintext:-webkit-autofill {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
}
.form-floating > .form-select {
  padding-top: 1.625rem;
  padding-bottom: 0.625rem;
  padding-left: 0.75rem;
}
.form-floating > .form-control:focus ~ label,
.form-floating > .form-control:not(:placeholder-shown) ~ label,
.form-floating > .form-control-plaintext ~ label,
.form-floating > .form-select ~ label {
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > .form-control:-webkit-autofill ~ label {
  transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
}
.form-floating > textarea:focus ~ label::after,
.form-floating > textarea:not(:placeholder-shown) ~ label::after {
  position: absolute;
  inset: 1rem 0.375rem;
  z-index: -1;
  height: 1.5em;
  content: "";
  background-color: var(--bs-body-bg);
  border-radius: var(--bs-border-radius);
}
.form-floating > textarea:disabled ~ label::after {
  background-color: var(--bs-secondary-bg);
}
.form-floating > .form-control-plaintext ~ label {
  border-width: var(--bs-border-width) 0;
}
.form-floating > :disabled ~ label,
.form-floating > .form-control:disabled ~ label {
  color: #6c757d;
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}
.input-group > .form-control,
.input-group > .form-select,
.input-group > .form-floating {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
}
.input-group > .form-control:focus,
.input-group > .form-select:focus,
.input-group > .form-floating:focus-within {
  z-index: 5;
}
.input-group .btn {
  position: relative;
  z-index: 2;
}
.input-group .btn:focus {
  z-index: 5;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--bs-tertiary-bg);
  border: var(--bs-border-width) solid var(--bs-border-color);
  border-radius: var(--bs-border-radius);
}

.input-group-lg > .form-control,
.input-group-lg > .form-select,
.input-group-lg > .input-group-text,
.input-group-lg > .btn {
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  border-radius: var(--bs-border-radius-lg);
}

.input-group-sm > .form-control,
.input-group-sm > .form-select,
.input-group-sm > .input-group-text,
.input-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  border-radius: var(--bs-border-radius-sm);
}

.input-group-lg > .form-select,
.input-group-sm > .form-select {
  padding-right: 3rem;
}

.input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n+3),
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group.has-validation > :nth-last-child(n+3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group.has-validation > .dropdown-toggle:nth-last-child(n+4),
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-control,
.input-group.has-validation > .form-floating:nth-last-child(n+3) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-left: calc(-1 * var(--bs-border-width));
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group > .form-floating:not(:first-child) > .form-control,
.input-group > .form-floating:not(:first-child) > .form-select {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--bs-form-valid-color);
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  color: #fff;
  background-color: var(--bs-success);
  border-radius: var(--bs-border-radius);
}

.was-validated :valid ~ .valid-feedback,
.was-validated :valid ~ .valid-tooltip,
.is-valid ~ .valid-feedback,
.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .form-control:valid, .form-control.is-valid {
  border-color: var(--bs-form-valid-border-color);
  padding-right: calc(1.5em + 0.75rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-control:valid:focus, .form-control.is-valid:focus {
  border-color: var(--bs-form-valid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}

.was-validated textarea.form-control:valid, textarea.form-control.is-valid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}

.was-validated .form-select:valid, .form-select.is-valid {
  border-color: var(--bs-form-valid-border-color);
}
.was-validated .form-select:valid:not([multiple]):not([size]), .was-validated .form-select:valid:not([multiple])[size="1"], .form-select.is-valid:not([multiple]):not([size]), .form-select.is-valid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  padding-right: 4.125rem;
  background-position: right 0.75rem center, center right 2.25rem;
  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-select:valid:focus, .form-select.is-valid:focus {
  border-color: var(--bs-form-valid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}

.was-validated .form-control-color:valid, .form-control-color.is-valid {
  width: calc(3rem + calc(1.5em + 0.75rem));
}

.was-validated .form-check-input:valid, .form-check-input.is-valid {
  border-color: var(--bs-form-valid-border-color);
}
.was-validated .form-check-input:valid:checked, .form-check-input.is-valid:checked {
  background-color: var(--bs-form-valid-color);
}
.was-validated .form-check-input:valid:focus, .form-check-input.is-valid:focus {
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-success-rgb), 0.25);
}
.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
  color: var(--bs-form-valid-color);
}

.form-check-inline .form-check-input ~ .valid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):valid, .input-group > .form-control:not(:focus).is-valid,
.was-validated .input-group > .form-select:not(:focus):valid,
.input-group > .form-select:not(:focus).is-valid,
.was-validated .input-group > .form-floating:not(:focus-within):valid,
.input-group > .form-floating:not(:focus-within).is-valid {
  z-index: 3;
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: var(--bs-form-invalid-color);
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.875rem;
  color: #fff;
  background-color: var(--bs-danger);
  border-radius: var(--bs-border-radius);
}

.was-validated :invalid ~ .invalid-feedback,
.was-validated :invalid ~ .invalid-tooltip,
.is-invalid ~ .invalid-feedback,
.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .form-control:invalid, .form-control.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
  padding-right: calc(1.5em + 0.75rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {
  border-color: var(--bs-form-invalid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}

.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}

.was-validated .form-select:invalid, .form-select.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
}
.was-validated .form-select:invalid:not([multiple]):not([size]), .was-validated .form-select:invalid:not([multiple])[size="1"], .form-select.is-invalid:not([multiple]):not([size]), .form-select.is-invalid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  padding-right: 4.125rem;
  background-position: right 0.75rem center, center right 2.25rem;
  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-select:invalid:focus, .form-select.is-invalid:focus {
  border-color: var(--bs-form-invalid-border-color);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}

.was-validated .form-control-color:invalid, .form-control-color.is-invalid {
  width: calc(3rem + calc(1.5em + 0.75rem));
}

.was-validated .form-check-input:invalid, .form-check-input.is-invalid {
  border-color: var(--bs-form-invalid-border-color);
}
.was-validated .form-check-input:invalid:checked, .form-check-input.is-invalid:checked {
  background-color: var(--bs-form-invalid-color);
}
.was-validated .form-check-input:invalid:focus, .form-check-input.is-invalid:focus {
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-danger-rgb), 0.25);
}
.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
  color: var(--bs-form-invalid-color);
}

.form-check-inline .form-check-input ~ .invalid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):invalid, .input-group > .form-control:not(:focus).is-invalid,
.was-validated .input-group > .form-select:not(:focus):invalid,
.input-group > .form-select:not(:focus).is-invalid,
.was-validated .input-group > .form-floating:not(:focus-within):invalid,
.input-group > .form-floating:not(:focus-within).is-invalid {
  z-index: 4;
}

.btn {
  --bs-btn-padding-x: 0.75rem;
  --bs-btn-padding-y: 0.375rem;
  --bs-btn-font-family: ;
  --bs-btn-font-size: 1rem;
  --bs-btn-font-weight: 400;
  --bs-btn-line-height: 1.5;
  --bs-btn-color: var(--bs-body-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-width: var(--bs-border-width);
  --bs-btn-border-color: transparent;
  --bs-btn-border-radius: var(--bs-border-radius);
  --bs-btn-hover-border-color: transparent;
  --bs-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  --bs-btn-disabled-opacity: 0.65;
  --bs-btn-focus-box-shadow: 0 0 0 0.25rem rgba(var(--bs-btn-focus-shadow-rgb), .5);
  display: inline-block;
  padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);
  font-family: var(--bs-btn-font-family);
  font-size: var(--bs-btn-font-size);
  font-weight: var(--bs-btn-font-weight);
  line-height: var(--bs-btn-line-height);
  color: var(--bs-btn-color);
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);
  border-radius: var(--bs-btn-border-radius);
  background-color: var(--bs-btn-bg);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}
.btn:hover {
  color: var(--bs-btn-hover-color);
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
}
.btn-check + .btn:hover {
  color: var(--bs-btn-color);
  background-color: var(--bs-btn-bg);
  border-color: var(--bs-btn-border-color);
}
.btn:focus-visible {
  color: var(--bs-btn-hover-color);
  background-color: var(--bs-btn-hover-bg);
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:focus-visible + .btn {
  border-color: var(--bs-btn-hover-border-color);
  outline: 0;
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:checked + .btn, :not(.btn-check) + .btn:active, .btn:first-child:active, .btn.active, .btn.show {
  color: var(--bs-btn-active-color);
  background-color: var(--bs-btn-active-bg);
  border-color: var(--bs-btn-active-border-color);
}
.btn-check:checked + .btn:focus-visible, :not(.btn-check) + .btn:active:focus-visible, .btn:first-child:active:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible {
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn-check:checked:focus-visible + .btn {
  box-shadow: var(--bs-btn-focus-box-shadow);
}
.btn:disabled, .btn.disabled, fieldset:disabled .btn {
  color: var(--bs-btn-disabled-color);
  pointer-events: none;
  background-color: var(--bs-btn-disabled-bg);
  border-color: var(--bs-btn-disabled-border-color);
  opacity: var(--bs-btn-disabled-opacity);
}

.btn-primary {
  --bs-btn-color: #fff;
  --bs-btn-bg: #0d6efd;
  --bs-btn-border-color: #0d6efd;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(11.05, 93.5, 215.05);
  --bs-btn-hover-border-color: rgb(10.4, 88, 202.4);
  --bs-btn-focus-shadow-rgb: 49, 132, 253;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(10.4, 88, 202.4);
  --bs-btn-active-border-color: rgb(9.75, 82.5, 189.75);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #0d6efd;
  --bs-btn-disabled-border-color: #0d6efd;
}

.btn-secondary {
  --bs-btn-color: #fff;
  --bs-btn-bg: #6c757d;
  --bs-btn-border-color: #6c757d;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(91.8, 99.45, 106.25);
  --bs-btn-hover-border-color: rgb(86.4, 93.6, 100);
  --bs-btn-focus-shadow-rgb: 130, 138, 145;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(86.4, 93.6, 100);
  --bs-btn-active-border-color: rgb(81, 87.75, 93.75);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #6c757d;
  --bs-btn-disabled-border-color: #6c757d;
}

.btn-success {
  --bs-btn-color: #fff;
  --bs-btn-bg: #198754;
  --bs-btn-border-color: #198754;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(21.25, 114.75, 71.4);
  --bs-btn-hover-border-color: rgb(20, 108, 67.2);
  --bs-btn-focus-shadow-rgb: 60, 153, 110;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(20, 108, 67.2);
  --bs-btn-active-border-color: rgb(18.75, 101.25, 63);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #198754;
  --bs-btn-disabled-border-color: #198754;
}

.btn-info {
  --bs-btn-color: #000;
  --bs-btn-bg: #0dcaf0;
  --bs-btn-border-color: #0dcaf0;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(49.3, 209.95, 242.25);
  --bs-btn-hover-border-color: rgb(37.2, 207.3, 241.5);
  --bs-btn-focus-shadow-rgb: 11, 172, 204;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(61.4, 212.6, 243);
  --bs-btn-active-border-color: rgb(37.2, 207.3, 241.5);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #0dcaf0;
  --bs-btn-disabled-border-color: #0dcaf0;
}

.btn-warning {
  --bs-btn-color: #000;
  --bs-btn-bg: #ffc107;
  --bs-btn-border-color: #ffc107;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(255, 202.3, 44.2);
  --bs-btn-hover-border-color: rgb(255, 199.2, 31.8);
  --bs-btn-focus-shadow-rgb: 217, 164, 6;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(255, 205.4, 56.6);
  --bs-btn-active-border-color: rgb(255, 199.2, 31.8);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #ffc107;
  --bs-btn-disabled-border-color: #ffc107;
}

.btn-danger {
  --bs-btn-color: #fff;
  --bs-btn-bg: #dc3545;
  --bs-btn-border-color: #dc3545;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(187, 45.05, 58.65);
  --bs-btn-hover-border-color: rgb(176, 42.4, 55.2);
  --bs-btn-focus-shadow-rgb: 225, 83, 97;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(176, 42.4, 55.2);
  --bs-btn-active-border-color: rgb(165, 39.75, 51.75);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #dc3545;
  --bs-btn-disabled-border-color: #dc3545;
}

.btn-light {
  --bs-btn-color: #000;
  --bs-btn-bg: #f8f9fa;
  --bs-btn-border-color: #f8f9fa;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: rgb(210.8, 211.65, 212.5);
  --bs-btn-hover-border-color: rgb(198.4, 199.2, 200);
  --bs-btn-focus-shadow-rgb: 211, 212, 213;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: rgb(198.4, 199.2, 200);
  --bs-btn-active-border-color: rgb(186, 186.75, 187.5);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #f8f9fa;
  --bs-btn-disabled-border-color: #f8f9fa;
}

.btn-dark {
  --bs-btn-color: #fff;
  --bs-btn-bg: #212529;
  --bs-btn-border-color: #212529;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: rgb(66.3, 69.7, 73.1);
  --bs-btn-hover-border-color: rgb(55.2, 58.8, 62.4);
  --bs-btn-focus-shadow-rgb: 66, 70, 73;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: rgb(77.4, 80.6, 83.8);
  --bs-btn-active-border-color: rgb(55.2, 58.8, 62.4);
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #212529;
  --bs-btn-disabled-border-color: #212529;
}

.btn-outline-primary {
  --bs-btn-color: #0d6efd;
  --bs-btn-border-color: #0d6efd;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #0d6efd;
  --bs-btn-hover-border-color: #0d6efd;
  --bs-btn-focus-shadow-rgb: 13, 110, 253;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #0d6efd;
  --bs-btn-active-border-color: #0d6efd;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #0d6efd;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #0d6efd;
  --bs-gradient: none;
}

.btn-outline-secondary {
  --bs-btn-color: #6c757d;
  --bs-btn-border-color: #6c757d;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #6c757d;
  --bs-btn-hover-border-color: #6c757d;
  --bs-btn-focus-shadow-rgb: 108, 117, 125;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #6c757d;
  --bs-btn-active-border-color: #6c757d;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #6c757d;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #6c757d;
  --bs-gradient: none;
}

.btn-outline-success {
  --bs-btn-color: #198754;
  --bs-btn-border-color: #198754;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #198754;
  --bs-btn-hover-border-color: #198754;
  --bs-btn-focus-shadow-rgb: 25, 135, 84;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #198754;
  --bs-btn-active-border-color: #198754;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #198754;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #198754;
  --bs-gradient: none;
}

.btn-outline-info {
  --bs-btn-color: #0dcaf0;
  --bs-btn-border-color: #0dcaf0;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #0dcaf0;
  --bs-btn-hover-border-color: #0dcaf0;
  --bs-btn-focus-shadow-rgb: 13, 202, 240;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #0dcaf0;
  --bs-btn-active-border-color: #0dcaf0;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #0dcaf0;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #0dcaf0;
  --bs-gradient: none;
}

.btn-outline-warning {
  --bs-btn-color: #ffc107;
  --bs-btn-border-color: #ffc107;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #ffc107;
  --bs-btn-hover-border-color: #ffc107;
  --bs-btn-focus-shadow-rgb: 255, 193, 7;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #ffc107;
  --bs-btn-active-border-color: #ffc107;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #ffc107;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #ffc107;
  --bs-gradient: none;
}

.btn-outline-danger {
  --bs-btn-color: #dc3545;
  --bs-btn-border-color: #dc3545;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #dc3545;
  --bs-btn-hover-border-color: #dc3545;
  --bs-btn-focus-shadow-rgb: 220, 53, 69;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #dc3545;
  --bs-btn-active-border-color: #dc3545;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #dc3545;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #dc3545;
  --bs-gradient: none;
}

.btn-outline-light {
  --bs-btn-color: #f8f9fa;
  --bs-btn-border-color: #f8f9fa;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #f8f9fa;
  --bs-btn-hover-border-color: #f8f9fa;
  --bs-btn-focus-shadow-rgb: 248, 249, 250;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #f8f9fa;
  --bs-btn-active-border-color: #f8f9fa;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #f8f9fa;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #f8f9fa;
  --bs-gradient: none;
}

.btn-outline-dark {
  --bs-btn-color: #212529;
  --bs-btn-border-color: #212529;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #212529;
  --bs-btn-hover-border-color: #212529;
  --bs-btn-focus-shadow-rgb: 33, 37, 41;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #212529;
  --bs-btn-active-border-color: #212529;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #212529;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #212529;
  --bs-gradient: none;
}

.btn-link {
  --bs-btn-font-weight: 400;
  --bs-btn-color: var(--bs-link-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-color: transparent;
  --bs-btn-hover-color: var(--bs-link-hover-color);
  --bs-btn-hover-border-color: transparent;
  --bs-btn-active-color: var(--bs-link-hover-color);
  --bs-btn-active-border-color: transparent;
  --bs-btn-disabled-color: #6c757d;
  --bs-btn-disabled-border-color: transparent;
  --bs-btn-box-shadow: 0 0 0 #000;
  --bs-btn-focus-shadow-rgb: 49, 132, 253;
  text-decoration: underline;
}
.btn-link:focus-visible {
  color: var(--bs-btn-color);
}
.btn-link:hover {
  color: var(--bs-btn-hover-color);
}

.btn-lg, .btn-group-lg > .btn {
  --bs-btn-padding-y: 0.5rem;
  --bs-btn-padding-x: 1rem;
  --bs-btn-font-size: 1.25rem;
  --bs-btn-border-radius: var(--bs-border-radius-lg);
}

.btn-sm, .btn-group-sm > .btn {
  --bs-btn-padding-y: 0.25rem;
  --bs-btn-padding-x: 0.5rem;
  --bs-btn-font-size: 0.875rem;
  --bs-btn-border-radius: var(--bs-border-radius-sm);
}

.fade {
  transition: opacity 0.15s linear;
}
@media (prefers-reduced-motion: reduce) {
  .fade {
    transition: none;
  }
}
.fade:not(.show) {
  opacity: 0;
}

.collapse:not(.show) {
  display: none;
}

.collapsing {
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing {
    transition: none;
  }
}
.collapsing.collapse-horizontal {
  width: 0;
  height: auto;
  transition: width 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing.collapse-horizontal {
    transition: none;
  }
}

.dropup,
.dropend,
.dropdown,
.dropstart,
.dropup-center,
.dropdown-center {
  position: relative;
}

.dropdown-toggle {
  white-space: nowrap;
}
.dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}
.dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropdown-menu {
  --bs-dropdown-zindex: 1000;
  --bs-dropdown-min-width: 10rem;
  --bs-dropdown-padding-x: 0;
  --bs-dropdown-padding-y: 0.5rem;
  --bs-dropdown-spacer: 0.125rem;
  --bs-dropdown-font-size: 1rem;
  --bs-dropdown-color: var(--bs-body-color);
  --bs-dropdown-bg: var(--bs-body-bg);
  --bs-dropdown-border-color: var(--bs-border-color-translucent);
  --bs-dropdown-border-radius: var(--bs-border-radius);
  --bs-dropdown-border-width: var(--bs-border-width);
  --bs-dropdown-inner-border-radius: calc(var(--bs-border-radius) - var(--bs-border-width));
  --bs-dropdown-divider-bg: var(--bs-border-color-translucent);
  --bs-dropdown-divider-margin-y: 0.5rem;
  --bs-dropdown-box-shadow: var(--bs-box-shadow);
  --bs-dropdown-link-color: var(--bs-body-color);
  --bs-dropdown-link-hover-color: var(--bs-body-color);
  --bs-dropdown-link-hover-bg: var(--bs-tertiary-bg);
  --bs-dropdown-link-active-color: #fff;
  --bs-dropdown-link-active-bg: #0d6efd;
  --bs-dropdown-link-disabled-color: var(--bs-tertiary-color);
  --bs-dropdown-item-padding-x: 1rem;
  --bs-dropdown-item-padding-y: 0.25rem;
  --bs-dropdown-header-color: #6c757d;
  --bs-dropdown-header-padding-x: 1rem;
  --bs-dropdown-header-padding-y: 0.5rem;
  position: absolute;
  z-index: var(--bs-dropdown-zindex);
  display: none;
  min-width: var(--bs-dropdown-min-width);
  padding: var(--bs-dropdown-padding-y) var(--bs-dropdown-padding-x);
  margin: 0;
  font-size: var(--bs-dropdown-font-size);
  color: var(--bs-dropdown-color);
  text-align: left;
  list-style: none;
  background-color: var(--bs-dropdown-bg);
  background-clip: padding-box;
  border: var(--bs-dropdown-border-width) solid var(--bs-dropdown-border-color);
  border-radius: var(--bs-dropdown-border-radius);
}
.dropdown-menu[data-bs-popper] {
  top: 100%;
  left: 0;
  margin-top: var(--bs-dropdown-spacer);
}

.dropdown-menu-start {
  --bs-position: start;
}
.dropdown-menu-start[data-bs-popper] {
  right: auto;
  left: 0;
}

.dropdown-menu-end {
  --bs-position: end;
}
.dropdown-menu-end[data-bs-popper] {
  right: 0;
  left: auto;
}

@media (min-width: 576px) {
  .dropdown-menu-sm-start {
    --bs-position: start;
  }
  .dropdown-menu-sm-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-sm-end {
    --bs-position: end;
  }
  .dropdown-menu-sm-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 768px) {
  .dropdown-menu-md-start {
    --bs-position: start;
  }
  .dropdown-menu-md-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-md-end {
    --bs-position: end;
  }
  .dropdown-menu-md-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 992px) {
  .dropdown-menu-lg-start {
    --bs-position: start;
  }
  .dropdown-menu-lg-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-lg-end {
    --bs-position: end;
  }
  .dropdown-menu-lg-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1200px) {
  .dropdown-menu-xl-start {
    --bs-position: start;
  }
  .dropdown-menu-xl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xl-end {
    --bs-position: end;
  }
  .dropdown-menu-xl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1400px) {
  .dropdown-menu-xxl-start {
    --bs-position: start;
  }
  .dropdown-menu-xxl-start[data-bs-popper] {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xxl-end {
    --bs-position: end;
  }
  .dropdown-menu-xxl-end[data-bs-popper] {
    right: 0;
    left: auto;
  }
}
.dropup .dropdown-menu[data-bs-popper] {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: var(--bs-dropdown-spacer);
}
.dropup .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0;
  border-right: 0.3em solid transparent;
  border-bottom: 0.3em solid;
  border-left: 0.3em solid transparent;
}
.dropup .dropdown-toggle:empty::after {
  margin-left: 0;
}

.dropend .dropdown-menu[data-bs-popper] {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: var(--bs-dropdown-spacer);
}
.dropend .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0;
  border-bottom: 0.3em solid transparent;
  border-left: 0.3em solid;
}
.dropend .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropend .dropdown-toggle::after {
  vertical-align: 0;
}

.dropstart .dropdown-menu[data-bs-popper] {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: var(--bs-dropdown-spacer);
}
.dropstart .dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  vertical-align: 0.255em;
  content: "";
}
.dropstart .dropdown-toggle::after {
  display: none;
}
.dropstart .dropdown-toggle::before {
  display: inline-block;
  margin-right: 0.255em;
  vertical-align: 0.255em;
  content: "";
  border-top: 0.3em solid transparent;
  border-right: 0.3em solid;
  border-bottom: 0.3em solid transparent;
}
.dropstart .dropdown-toggle:empty::after {
  margin-left: 0;
}
.dropstart .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-divider {
  height: 0;
  margin: var(--bs-dropdown-divider-margin-y) 0;
  overflow: hidden;
  border-top: 1px solid var(--bs-dropdown-divider-bg);
  opacity: 1;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  clear: both;
  font-weight: 400;
  color: var(--bs-dropdown-link-color);
  text-align: inherit;
  text-decoration: none;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
  border-radius: var(--bs-dropdown-item-border-radius, 0);
}
.dropdown-item:hover, .dropdown-item:focus {
  color: var(--bs-dropdown-link-hover-color);
  background-color: var(--bs-dropdown-link-hover-bg);
}
.dropdown-item.active, .dropdown-item:active {
  color: var(--bs-dropdown-link-active-color);
  text-decoration: none;
  background-color: var(--bs-dropdown-link-active-bg);
}
.dropdown-item.disabled, .dropdown-item:disabled {
  color: var(--bs-dropdown-link-disabled-color);
  pointer-events: none;
  background-color: transparent;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  display: block;
  padding: var(--bs-dropdown-header-padding-y) var(--bs-dropdown-header-padding-x);
  margin-bottom: 0;
  font-size: 0.875rem;
  color: var(--bs-dropdown-header-color);
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  color: var(--bs-dropdown-link-color);
}

.dropdown-menu-dark {
  --bs-dropdown-color: #dee2e6;
  --bs-dropdown-bg: #343a40;
  --bs-dropdown-border-color: var(--bs-border-color-translucent);
  --bs-dropdown-box-shadow: ;
  --bs-dropdown-link-color: #dee2e6;
  --bs-dropdown-link-hover-color: #fff;
  --bs-dropdown-divider-bg: var(--bs-border-color-translucent);
  --bs-dropdown-link-hover-bg: rgba(255, 255, 255, 0.15);
  --bs-dropdown-link-active-color: #fff;
  --bs-dropdown-link-active-bg: #0d6efd;
  --bs-dropdown-link-disabled-color: #adb5bd;
  --bs-dropdown-header-color: #adb5bd;
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
.btn-group > .btn,
.btn-group-vertical > .btn {
  position: relative;
  flex: 1 1 auto;
}
.btn-group > .btn-check:checked + .btn,
.btn-group > .btn-check:focus + .btn,
.btn-group > .btn:hover,
.btn-group > .btn:focus,
.btn-group > .btn:active,
.btn-group > .btn.active,
.btn-group-vertical > .btn-check:checked + .btn,
.btn-group-vertical > .btn-check:focus + .btn,
.btn-group-vertical > .btn:hover,
.btn-group-vertical > .btn:focus,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn.active {
  z-index: 1;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.btn-toolbar .input-group {
  width: auto;
}

.btn-group {
  border-radius: var(--bs-border-radius);
}
.btn-group > :not(.btn-check:first-child) + .btn,
.btn-group > .btn-group:not(:first-child) {
  margin-left: calc(-1 * var(--bs-border-width));
}
.btn-group > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group > .btn.dropdown-toggle-split:first-child,
.btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.btn-group > .btn:nth-child(n+3),
.btn-group > :not(.btn-check) + .btn,
.btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.dropdown-toggle-split {
  padding-right: 0.5625rem;
  padding-left: 0.5625rem;
}
.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropend .dropdown-toggle-split::after {
  margin-left: 0;
}
.dropstart .dropdown-toggle-split::before {
  margin-right: 0;
}

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem;
}

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.btn-group-vertical > .btn,
.btn-group-vertical > .btn-group {
  width: 100%;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) {
  margin-top: calc(-1 * var(--bs-border-width));
}
.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group-vertical > .btn:nth-child(n+3),
.btn-group-vertical > :not(.btn-check) + .btn,
.btn-group-vertical > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav {
  --bs-nav-link-padding-x: 1rem;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-link-color);
  --bs-nav-link-hover-color: var(--bs-link-hover-color);
  --bs-nav-link-disabled-color: var(--bs-secondary-color);
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-link {
  display: block;
  padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);
  font-size: var(--bs-nav-link-font-size);
  font-weight: var(--bs-nav-link-font-weight);
  color: var(--bs-nav-link-color);
  text-decoration: none;
  background: none;
  border: 0;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .nav-link {
    transition: none;
  }
}
.nav-link:hover, .nav-link:focus {
  color: var(--bs-nav-link-hover-color);
}
.nav-link:focus-visible {
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}
.nav-link.disabled, .nav-link:disabled {
  color: var(--bs-nav-link-disabled-color);
  pointer-events: none;
  cursor: default;
}

.nav-tabs {
  --bs-nav-tabs-border-width: var(--bs-border-width);
  --bs-nav-tabs-border-color: var(--bs-border-color);
  --bs-nav-tabs-border-radius: var(--bs-border-radius);
  --bs-nav-tabs-link-hover-border-color: var(--bs-secondary-bg) var(--bs-secondary-bg) var(--bs-border-color);
  --bs-nav-tabs-link-active-color: var(--bs-emphasis-color);
  --bs-nav-tabs-link-active-bg: var(--bs-body-bg);
  --bs-nav-tabs-link-active-border-color: var(--bs-border-color) var(--bs-border-color) var(--bs-body-bg);
  border-bottom: var(--bs-nav-tabs-border-width) solid var(--bs-nav-tabs-border-color);
}
.nav-tabs .nav-link {
  margin-bottom: calc(-1 * var(--bs-nav-tabs-border-width));
  border: var(--bs-nav-tabs-border-width) solid transparent;
  border-top-left-radius: var(--bs-nav-tabs-border-radius);
  border-top-right-radius: var(--bs-nav-tabs-border-radius);
}
.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
  isolation: isolate;
  border-color: var(--bs-nav-tabs-link-hover-border-color);
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: var(--bs-nav-tabs-link-active-color);
  background-color: var(--bs-nav-tabs-link-active-bg);
  border-color: var(--bs-nav-tabs-link-active-border-color);
}
.nav-tabs .dropdown-menu {
  margin-top: calc(-1 * var(--bs-nav-tabs-border-width));
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav-pills {
  --bs-nav-pills-border-radius: var(--bs-border-radius);
  --bs-nav-pills-link-active-color: #fff;
  --bs-nav-pills-link-active-bg: #0d6efd;
}
.nav-pills .nav-link {
  border-radius: var(--bs-nav-pills-border-radius);
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: var(--bs-nav-pills-link-active-color);
  background-color: var(--bs-nav-pills-link-active-bg);
}

.nav-underline {
  --bs-nav-underline-gap: 1rem;
  --bs-nav-underline-border-width: 0.125rem;
  --bs-nav-underline-link-active-color: var(--bs-emphasis-color);
  gap: var(--bs-nav-underline-gap);
}
.nav-underline .nav-link {
  padding-right: 0;
  padding-left: 0;
  border-bottom: var(--bs-nav-underline-border-width) solid transparent;
}
.nav-underline .nav-link:hover, .nav-underline .nav-link:focus {
  border-bottom-color: currentcolor;
}
.nav-underline .nav-link.active,
.nav-underline .show > .nav-link {
  font-weight: 700;
  color: var(--bs-nav-underline-link-active-color);
  border-bottom-color: currentcolor;
}

.nav-fill > .nav-link,
.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified > .nav-link,
.nav-justified .nav-item {
  flex-grow: 1;
  flex-basis: 0;
  text-align: center;
}

.nav-fill .nav-item .nav-link,
.nav-justified .nav-item .nav-link {
  width: 100%;
}

.tab-content > .tab-pane {
  display: none;
}
.tab-content > .active {
  display: block;
}

.navbar {
  --bs-navbar-padding-x: 0;
  --bs-navbar-padding-y: 0.5rem;
  --bs-navbar-color: rgba(var(--bs-emphasis-color-rgb), 0.65);
  --bs-navbar-hover-color: rgba(var(--bs-emphasis-color-rgb), 0.8);
  --bs-navbar-disabled-color: rgba(var(--bs-emphasis-color-rgb), 0.3);
  --bs-navbar-active-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-brand-padding-y: 0.3125rem;
  --bs-navbar-brand-margin-end: 1rem;
  --bs-navbar-brand-font-size: 1.25rem;
  --bs-navbar-brand-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-brand-hover-color: rgba(var(--bs-emphasis-color-rgb), 1);
  --bs-navbar-nav-link-padding-x: 0.5rem;
  --bs-navbar-toggler-padding-y: 0.25rem;
  --bs-navbar-toggler-padding-x: 0.75rem;
  --bs-navbar-toggler-font-size: 1.25rem;
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  --bs-navbar-toggler-border-color: rgba(var(--bs-emphasis-color-rgb), 0.15);
  --bs-navbar-toggler-border-radius: var(--bs-border-radius);
  --bs-navbar-toggler-focus-width: 0.25rem;
  --bs-navbar-toggler-transition: box-shadow 0.15s ease-in-out;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-navbar-padding-y) var(--bs-navbar-padding-x);
}
.navbar > .container,
.navbar > .container-fluid,
.navbar > .container-sm,
.navbar > .container-md,
.navbar > .container-lg,
.navbar > .container-xl,
.navbar > .container-xxl {
  display: flex;
  flex-wrap: inherit;
  align-items: center;
  justify-content: space-between;
}
.navbar-brand {
  padding-top: var(--bs-navbar-brand-padding-y);
  padding-bottom: var(--bs-navbar-brand-padding-y);
  margin-right: var(--bs-navbar-brand-margin-end);
  font-size: var(--bs-navbar-brand-font-size);
  color: var(--bs-navbar-brand-color);
  text-decoration: none;
  white-space: nowrap;
}
.navbar-brand:hover, .navbar-brand:focus {
  color: var(--bs-navbar-brand-hover-color);
}

.navbar-nav {
  --bs-nav-link-padding-x: 0;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-navbar-color);
  --bs-nav-link-hover-color: var(--bs-navbar-hover-color);
  --bs-nav-link-disabled-color: var(--bs-navbar-disabled-color);
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.navbar-nav .nav-link.active, .navbar-nav .nav-link.show {
  color: var(--bs-navbar-active-color);
}
.navbar-nav .dropdown-menu {
  position: static;
}

.navbar-text {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--bs-navbar-color);
}
.navbar-text a,
.navbar-text a:hover,
.navbar-text a:focus {
  color: var(--bs-navbar-active-color);
}

.navbar-collapse {
  flex-grow: 1;
  flex-basis: 100%;
  align-items: center;
}

.navbar-toggler {
  padding: var(--bs-navbar-toggler-padding-y) var(--bs-navbar-toggler-padding-x);
  font-size: var(--bs-navbar-toggler-font-size);
  line-height: 1;
  color: var(--bs-navbar-color);
  background-color: transparent;
  border: var(--bs-border-width) solid var(--bs-navbar-toggler-border-color);
  border-radius: var(--bs-navbar-toggler-border-radius);
  transition: var(--bs-navbar-toggler-transition);
}
@media (prefers-reduced-motion: reduce) {
  .navbar-toggler {
    transition: none;
  }
}
.navbar-toggler:hover {
  text-decoration: none;
}
.navbar-toggler:focus {
  text-decoration: none;
  outline: 0;
  box-shadow: 0 0 0 var(--bs-navbar-toggler-focus-width);
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  background-image: var(--bs-navbar-toggler-icon-bg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
}

.navbar-nav-scroll {
  max-height: var(--bs-scroll-height, 75vh);
  overflow-y: auto;
}

@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-sm .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-sm .navbar-toggler {
    display: none;
  }
  .navbar-expand-sm .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-sm .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 768px) {
  .navbar-expand-md {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-md .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-md .navbar-toggler {
    display: none;
  }
  .navbar-expand-md .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-md .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-lg .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-lg .navbar-toggler {
    display: none;
  }
  .navbar-expand-lg .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-lg .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-xl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
@media (min-width: 1400px) {
  .navbar-expand-xxl {
    flex-wrap: nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xxl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xxl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xxl .navbar-nav .nav-link {
    padding-right: var(--bs-navbar-nav-link-padding-x);
    padding-left: var(--bs-navbar-nav-link-padding-x);
  }
  .navbar-expand-xxl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xxl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xxl .navbar-toggler {
    display: none;
  }
  .navbar-expand-xxl .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-header {
    display: none;
  }
  .navbar-expand-xxl .offcanvas .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
  }
}
.navbar-expand {
  flex-wrap: nowrap;
  justify-content: flex-start;
}
.navbar-expand .navbar-nav {
  flex-direction: row;
}
.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}
.navbar-expand .navbar-nav .nav-link {
  padding-right: var(--bs-navbar-nav-link-padding-x);
  padding-left: var(--bs-navbar-nav-link-padding-x);
}
.navbar-expand .navbar-nav-scroll {
  overflow: visible;
}
.navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}
.navbar-expand .navbar-toggler {
  display: none;
}
.navbar-expand .offcanvas {
  position: static;
  z-index: auto;
  flex-grow: 1;
  width: auto !important;
  height: auto !important;
  visibility: visible !important;
  background-color: transparent !important;
  border: 0 !important;
  transform: none !important;
  transition: none;
}
.navbar-expand .offcanvas .offcanvas-header {
  display: none;
}
.navbar-expand .offcanvas .offcanvas-body {
  display: flex;
  flex-grow: 0;
  padding: 0;
  overflow-y: visible;
}

.navbar-dark,
.navbar[data-bs-theme=dark] {
  --bs-navbar-color: rgba(255, 255, 255, 0.55);
  --bs-navbar-hover-color: rgba(255, 255, 255, 0.75);
  --bs-navbar-disabled-color: rgba(255, 255, 255, 0.25);
  --bs-navbar-active-color: #fff;
  --bs-navbar-brand-color: #fff;
  --bs-navbar-brand-hover-color: #fff;
  --bs-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}

[data-bs-theme=dark] .navbar-toggler-icon {
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}

.card {
  --bs-card-spacer-y: 1rem;
  --bs-card-spacer-x: 1rem;
  --bs-card-title-spacer-y: 0.5rem;
  --bs-card-title-color: ;
  --bs-card-subtitle-color: ;
  --bs-card-border-width: var(--bs-border-width);
  --bs-card-border-color: var(--bs-border-color-translucent);
  --bs-card-border-radius: var(--bs-border-radius);
  --bs-card-box-shadow: ;
  --bs-card-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));
  --bs-card-cap-padding-y: 0.5rem;
  --bs-card-cap-padding-x: 1rem;
  --bs-card-cap-bg: rgba(var(--bs-body-color-rgb), 0.03);
  --bs-card-cap-color: ;
  --bs-card-height: ;
  --bs-card-color: ;
  --bs-card-bg: var(--bs-body-bg);
  --bs-card-img-overlay-padding: 1rem;
  --bs-card-group-margin: 0.75rem;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: var(--bs-card-height);
  color: var(--bs-body-color);
  word-wrap: break-word;
  background-color: var(--bs-card-bg);
  background-clip: border-box;
  border: var(--bs-card-border-width) solid var(--bs-card-border-color);
  border-radius: var(--bs-card-border-radius);
}
.card > hr {
  margin-right: 0;
  margin-left: 0;
}
.card > .list-group {
  border-top: inherit;
  border-bottom: inherit;
}
.card > .list-group:first-child {
  border-top-width: 0;
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}
.card > .list-group:last-child {
  border-bottom-width: 0;
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}
.card > .card-header + .list-group,
.card > .list-group + .card-footer {
  border-top: 0;
}

.card-body {
  flex: 1 1 auto;
  padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x);
  color: var(--bs-card-color);
}

.card-title {
  margin-bottom: var(--bs-card-title-spacer-y);
  color: var(--bs-card-title-color);
}

.card-subtitle {
  margin-top: calc(-0.5 * var(--bs-card-title-spacer-y));
  margin-bottom: 0;
  color: var(--bs-card-subtitle-color);
}

.card-text:last-child {
  margin-bottom: 0;
}

.card-link + .card-link {
  margin-left: var(--bs-card-spacer-x);
}

.card-header {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  margin-bottom: 0;
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-bottom: var(--bs-card-border-width) solid var(--bs-card-border-color);
}
.card-header:first-child {
  border-radius: var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius) 0 0;
}

.card-footer {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-top: var(--bs-card-border-width) solid var(--bs-card-border-color);
}
.card-footer:last-child {
  border-radius: 0 0 var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius);
}

.card-header-tabs {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-bottom: calc(-1 * var(--bs-card-cap-padding-y));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
  border-bottom: 0;
}
.card-header-tabs .nav-link.active {
  background-color: var(--bs-card-bg);
  border-bottom-color: var(--bs-card-bg);
}

.card-header-pills {
  margin-right: calc(-0.5 * var(--bs-card-cap-padding-x));
  margin-left: calc(-0.5 * var(--bs-card-cap-padding-x));
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: var(--bs-card-img-overlay-padding);
  border-radius: var(--bs-card-inner-border-radius);
}

.card-img,
.card-img-top,
.card-img-bottom {
  width: 100%;
}

.card-img,
.card-img-top {
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius);
}

.card-img,
.card-img-bottom {
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius);
}

.card-group > .card {
  margin-bottom: var(--bs-card-group-margin);
}
@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap;
  }
  .card-group > .card {
    flex: 1 0;
    margin-bottom: 0;
  }
  .card-group > .card + .card {
    margin-left: 0;
    border-left: 0;
  }
  .card-group > .card:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:last-child) > .card-img-top,
  .card-group > .card:not(:last-child) > .card-header {
    border-top-right-radius: 0;
  }
  .card-group > .card:not(:last-child) > .card-img-bottom,
  .card-group > .card:not(:last-child) > .card-footer {
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .card-group > .card:not(:first-child) > .card-img-top,
  .card-group > .card:not(:first-child) > .card-header {
    border-top-left-radius: 0;
  }
  .card-group > .card:not(:first-child) > .card-img-bottom,
  .card-group > .card:not(:first-child) > .card-footer {
    border-bottom-left-radius: 0;
  }
}

.accordion {
  --bs-accordion-color: var(--bs-body-color);
  --bs-accordion-bg: var(--bs-body-bg);
  --bs-accordion-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;
  --bs-accordion-border-color: var(--bs-border-color);
  --bs-accordion-border-width: var(--bs-border-width);
  --bs-accordion-border-radius: var(--bs-border-radius);
  --bs-accordion-inner-border-radius: calc(var(--bs-border-radius) - (var(--bs-border-width)));
  --bs-accordion-btn-padding-x: 1.25rem;
  --bs-accordion-btn-padding-y: 1rem;
  --bs-accordion-btn-color: var(--bs-body-color);
  --bs-accordion-btn-bg: var(--bs-accordion-bg);
  --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  --bs-accordion-btn-icon-width: 1.25rem;
  --bs-accordion-btn-icon-transform: rotate(-180deg);
  --bs-accordion-btn-icon-transition: transform 0.2s ease-in-out;
  --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  --bs-accordion-btn-focus-box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  --bs-accordion-body-padding-x: 1.25rem;
  --bs-accordion-body-padding-y: 1rem;
  --bs-accordion-active-color: var(--bs-primary-text-emphasis);
  --bs-accordion-active-bg: var(--bs-primary-bg-subtle);
}

.accordion-button {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding: var(--bs-accordion-btn-padding-y) var(--bs-accordion-btn-padding-x);
  font-size: 1rem;
  color: var(--bs-accordion-btn-color);
  text-align: left;
  background-color: var(--bs-accordion-btn-bg);
  border: 0;
  border-radius: 0;
  overflow-anchor: none;
  transition: var(--bs-accordion-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button {
    transition: none;
  }
}
.accordion-button:not(.collapsed) {
  color: var(--bs-accordion-active-color);
  background-color: var(--bs-accordion-active-bg);
  box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0 var(--bs-accordion-border-color);
}
.accordion-button:not(.collapsed)::after {
  background-image: var(--bs-accordion-btn-active-icon);
  transform: var(--bs-accordion-btn-icon-transform);
}
.accordion-button::after {
  flex-shrink: 0;
  width: var(--bs-accordion-btn-icon-width);
  height: var(--bs-accordion-btn-icon-width);
  margin-left: auto;
  content: "";
  background-image: var(--bs-accordion-btn-icon);
  background-repeat: no-repeat;
  background-size: var(--bs-accordion-btn-icon-width);
  transition: var(--bs-accordion-btn-icon-transition);
}
@media (prefers-reduced-motion: reduce) {
  .accordion-button::after {
    transition: none;
  }
}
.accordion-button:hover {
  z-index: 2;
}
.accordion-button:focus {
  z-index: 3;
  outline: 0;
  box-shadow: var(--bs-accordion-btn-focus-box-shadow);
}

.accordion-header {
  margin-bottom: 0;
}

.accordion-item {
  color: var(--bs-accordion-color);
  background-color: var(--bs-accordion-bg);
  border: var(--bs-accordion-border-width) solid var(--bs-accordion-border-color);
}
.accordion-item:first-of-type {
  border-top-left-radius: var(--bs-accordion-border-radius);
  border-top-right-radius: var(--bs-accordion-border-radius);
}
.accordion-item:first-of-type > .accordion-header .accordion-button {
  border-top-left-radius: var(--bs-accordion-inner-border-radius);
  border-top-right-radius: var(--bs-accordion-inner-border-radius);
}
.accordion-item:not(:first-of-type) {
  border-top: 0;
}
.accordion-item:last-of-type {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}
.accordion-item:last-of-type > .accordion-header .accordion-button.collapsed {
  border-bottom-right-radius: var(--bs-accordion-inner-border-radius);
  border-bottom-left-radius: var(--bs-accordion-inner-border-radius);
}
.accordion-item:last-of-type > .accordion-collapse {
  border-bottom-right-radius: var(--bs-accordion-border-radius);
  border-bottom-left-radius: var(--bs-accordion-border-radius);
}

.accordion-body {
  padding: var(--bs-accordion-body-padding-y) var(--bs-accordion-body-padding-x);
}

.accordion-flush > .accordion-item {
  border-right: 0;
  border-left: 0;
  border-radius: 0;
}
.accordion-flush > .accordion-item:first-child {
  border-top: 0;
}
.accordion-flush > .accordion-item:last-child {
  border-bottom: 0;
}
.accordion-flush > .accordion-item > .accordion-collapse,
.accordion-flush > .accordion-item > .accordion-header .accordion-button,
.accordion-flush > .accordion-item > .accordion-header .accordion-button.collapsed {
  border-radius: 0;
}

[data-bs-theme=dark] .accordion-button::after {
  --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
}

.breadcrumb {
  --bs-breadcrumb-padding-x: 0;
  --bs-breadcrumb-padding-y: 0;
  --bs-breadcrumb-margin-bottom: 1rem;
  --bs-breadcrumb-bg: ;
  --bs-breadcrumb-border-radius: ;
  --bs-breadcrumb-divider-color: var(--bs-secondary-color);
  --bs-breadcrumb-item-padding-x: 0.5rem;
  --bs-breadcrumb-item-active-color: var(--bs-secondary-color);
  display: flex;
  flex-wrap: wrap;
  padding: var(--bs-breadcrumb-padding-y) var(--bs-breadcrumb-padding-x);
  margin-bottom: var(--bs-breadcrumb-margin-bottom);
  font-size: var(--bs-breadcrumb-font-size);
  list-style: none;
  background-color: var(--bs-breadcrumb-bg);
  border-radius: var(--bs-breadcrumb-border-radius);
}

.breadcrumb-item + .breadcrumb-item {
  padding-left: var(--bs-breadcrumb-item-padding-x);
}
.breadcrumb-item + .breadcrumb-item::before {
  float: left;
  padding-right: var(--bs-breadcrumb-item-padding-x);
  color: var(--bs-breadcrumb-divider-color);
  content: var(--bs-breadcrumb-divider, "/") /* rtl: var(--bs-breadcrumb-divider, "/") */;
}
.breadcrumb-item.active {
  color: var(--bs-breadcrumb-item-active-color);
}

.pagination {
  --bs-pagination-padding-x: 0.75rem;
  --bs-pagination-padding-y: 0.375rem;
  --bs-pagination-font-size: 1rem;
  --bs-pagination-color: var(--bs-link-color);
  --bs-pagination-bg: var(--bs-body-bg);
  --bs-pagination-border-width: var(--bs-border-width);
  --bs-pagination-border-color: var(--bs-border-color);
  --bs-pagination-border-radius: var(--bs-border-radius);
  --bs-pagination-hover-color: var(--bs-link-hover-color);
  --bs-pagination-hover-bg: var(--bs-tertiary-bg);
  --bs-pagination-hover-border-color: var(--bs-border-color);
  --bs-pagination-focus-color: var(--bs-link-hover-color);
  --bs-pagination-focus-bg: var(--bs-secondary-bg);
  --bs-pagination-focus-box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  --bs-pagination-active-color: #fff;
  --bs-pagination-active-bg: #0d6efd;
  --bs-pagination-active-border-color: #0d6efd;
  --bs-pagination-disabled-color: var(--bs-secondary-color);
  --bs-pagination-disabled-bg: var(--bs-secondary-bg);
  --bs-pagination-disabled-border-color: var(--bs-border-color);
  display: flex;
  padding-left: 0;
  list-style: none;
}

.page-link {
  position: relative;
  display: block;
  padding: var(--bs-pagination-padding-y) var(--bs-pagination-padding-x);
  font-size: var(--bs-pagination-font-size);
  color: var(--bs-pagination-color);
  text-decoration: none;
  background-color: var(--bs-pagination-bg);
  border: var(--bs-pagination-border-width) solid var(--bs-pagination-border-color);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .page-link {
    transition: none;
  }
}
.page-link:hover {
  z-index: 2;
  color: var(--bs-pagination-hover-color);
  background-color: var(--bs-pagination-hover-bg);
  border-color: var(--bs-pagination-hover-border-color);
}
.page-link:focus {
  z-index: 3;
  color: var(--bs-pagination-focus-color);
  background-color: var(--bs-pagination-focus-bg);
  outline: 0;
  box-shadow: var(--bs-pagination-focus-box-shadow);
}
.page-link.active, .active > .page-link {
  z-index: 3;
  color: var(--bs-pagination-active-color);
  background-color: var(--bs-pagination-active-bg);
  border-color: var(--bs-pagination-active-border-color);
}
.page-link.disabled, .disabled > .page-link {
  color: var(--bs-pagination-disabled-color);
  pointer-events: none;
  background-color: var(--bs-pagination-disabled-bg);
  border-color: var(--bs-pagination-disabled-border-color);
}

.page-item:not(:first-child) .page-link {
  margin-left: calc(-1 * var(--bs-border-width));
}
.page-item:first-child .page-link {
  border-top-left-radius: var(--bs-pagination-border-radius);
  border-bottom-left-radius: var(--bs-pagination-border-radius);
}
.page-item:last-child .page-link {
  border-top-right-radius: var(--bs-pagination-border-radius);
  border-bottom-right-radius: var(--bs-pagination-border-radius);
}

.pagination-lg {
  --bs-pagination-padding-x: 1.5rem;
  --bs-pagination-padding-y: 0.75rem;
  --bs-pagination-font-size: 1.25rem;
  --bs-pagination-border-radius: var(--bs-border-radius-lg);
}

.pagination-sm {
  --bs-pagination-padding-x: 0.5rem;
  --bs-pagination-padding-y: 0.25rem;
  --bs-pagination-font-size: 0.875rem;
  --bs-pagination-border-radius: var(--bs-border-radius-sm);
}

.badge {
  --bs-badge-padding-x: 0.65em;
  --bs-badge-padding-y: 0.35em;
  --bs-badge-font-size: 0.75em;
  --bs-badge-font-weight: 700;
  --bs-badge-color: #fff;
  --bs-badge-border-radius: var(--bs-border-radius);
  display: inline-block;
  padding: var(--bs-badge-padding-y) var(--bs-badge-padding-x);
  font-size: var(--bs-badge-font-size);
  font-weight: var(--bs-badge-font-weight);
  line-height: 1;
  color: var(--bs-badge-color);
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: var(--bs-badge-border-radius);
}
.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.alert {
  --bs-alert-bg: transparent;
  --bs-alert-padding-x: 1rem;
  --bs-alert-padding-y: 1rem;
  --bs-alert-margin-bottom: 1rem;
  --bs-alert-color: inherit;
  --bs-alert-border-color: transparent;
  --bs-alert-border: var(--bs-border-width) solid var(--bs-alert-border-color);
  --bs-alert-border-radius: var(--bs-border-radius);
  --bs-alert-link-color: inherit;
  position: relative;
  padding: var(--bs-alert-padding-y) var(--bs-alert-padding-x);
  margin-bottom: var(--bs-alert-margin-bottom);
  color: var(--bs-alert-color);
  background-color: var(--bs-alert-bg);
  border: var(--bs-alert-border);
  border-radius: var(--bs-alert-border-radius);
}

.alert-heading {
  color: inherit;
}

.alert-link {
  font-weight: 700;
  color: var(--bs-alert-link-color);
}

.alert-dismissible {
  padding-right: 3rem;
}
.alert-dismissible .btn-close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  padding: 1.25rem 1rem;
}

.alert-primary {
  --bs-alert-color: var(--bs-primary-text-emphasis);
  --bs-alert-bg: var(--bs-primary-bg-subtle);
  --bs-alert-border-color: var(--bs-primary-border-subtle);
  --bs-alert-link-color: var(--bs-primary-text-emphasis);
}

.alert-secondary {
  --bs-alert-color: var(--bs-secondary-text-emphasis);
  --bs-alert-bg: var(--bs-secondary-bg-subtle);
  --bs-alert-border-color: var(--bs-secondary-border-subtle);
  --bs-alert-link-color: var(--bs-secondary-text-emphasis);
}

.alert-success {
  --bs-alert-color: var(--bs-success-text-emphasis);
  --bs-alert-bg: var(--bs-success-bg-subtle);
  --bs-alert-border-color: var(--bs-success-border-subtle);
  --bs-alert-link-color: var(--bs-success-text-emphasis);
}

.alert-info {
  --bs-alert-color: var(--bs-info-text-emphasis);
  --bs-alert-bg: var(--bs-info-bg-subtle);
  --bs-alert-border-color: var(--bs-info-border-subtle);
  --bs-alert-link-color: var(--bs-info-text-emphasis);
}

.alert-warning {
  --bs-alert-color: var(--bs-warning-text-emphasis);
  --bs-alert-bg: var(--bs-warning-bg-subtle);
  --bs-alert-border-color: var(--bs-warning-border-subtle);
  --bs-alert-link-color: var(--bs-warning-text-emphasis);
}

.alert-danger {
  --bs-alert-color: var(--bs-danger-text-emphasis);
  --bs-alert-bg: var(--bs-danger-bg-subtle);
  --bs-alert-border-color: var(--bs-danger-border-subtle);
  --bs-alert-link-color: var(--bs-danger-text-emphasis);
}

.alert-light {
  --bs-alert-color: var(--bs-light-text-emphasis);
  --bs-alert-bg: var(--bs-light-bg-subtle);
  --bs-alert-border-color: var(--bs-light-border-subtle);
  --bs-alert-link-color: var(--bs-light-text-emphasis);
}

.alert-dark {
  --bs-alert-color: var(--bs-dark-text-emphasis);
  --bs-alert-bg: var(--bs-dark-bg-subtle);
  --bs-alert-border-color: var(--bs-dark-border-subtle);
  --bs-alert-link-color: var(--bs-dark-text-emphasis);
}

@keyframes progress-bar-stripes {
  0% {
    background-position-x: var(--bs-progress-height);
  }
}
.progress,
.progress-stacked {
  --bs-progress-height: 1rem;
  --bs-progress-font-size: 0.75rem;
  --bs-progress-bg: var(--bs-secondary-bg);
  --bs-progress-border-radius: var(--bs-border-radius);
  --bs-progress-box-shadow: var(--bs-box-shadow-inset);
  --bs-progress-bar-color: #fff;
  --bs-progress-bar-bg: #0d6efd;
  --bs-progress-bar-transition: width 0.6s ease;
  display: flex;
  height: var(--bs-progress-height);
  overflow: hidden;
  font-size: var(--bs-progress-font-size);
  background-color: var(--bs-progress-bg);
  border-radius: var(--bs-progress-border-radius);
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: var(--bs-progress-bar-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--bs-progress-bar-bg);
  transition: var(--bs-progress-bar-transition);
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar {
    transition: none;
  }
}

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: var(--bs-progress-height) var(--bs-progress-height);
}

.progress-stacked > .progress {
  overflow: visible;
}

.progress-stacked > .progress > .progress-bar {
  width: 100%;
}

.progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes;
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar-animated {
    animation: none;
  }
}

.list-group {
  --bs-list-group-color: var(--bs-body-color);
  --bs-list-group-bg: var(--bs-body-bg);
  --bs-list-group-border-color: var(--bs-border-color);
  --bs-list-group-border-width: var(--bs-border-width);
  --bs-list-group-border-radius: var(--bs-border-radius);
  --bs-list-group-item-padding-x: 1rem;
  --bs-list-group-item-padding-y: 0.5rem;
  --bs-list-group-action-color: var(--bs-secondary-color);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-tertiary-bg);
  --bs-list-group-action-active-color: var(--bs-body-color);
  --bs-list-group-action-active-bg: var(--bs-secondary-bg);
  --bs-list-group-disabled-color: var(--bs-secondary-color);
  --bs-list-group-disabled-bg: var(--bs-body-bg);
  --bs-list-group-active-color: #fff;
  --bs-list-group-active-bg: #0d6efd;
  --bs-list-group-active-border-color: #0d6efd;
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: var(--bs-list-group-border-radius);
}

.list-group-numbered {
  list-style-type: none;
  counter-reset: section;
}
.list-group-numbered > .list-group-item::before {
  content: counters(section, ".") ". ";
  counter-increment: section;
}

.list-group-item {
  position: relative;
  display: block;
  padding: var(--bs-list-group-item-padding-y) var(--bs-list-group-item-padding-x);
  color: var(--bs-list-group-color);
  text-decoration: none;
  background-color: var(--bs-list-group-bg);
  border: var(--bs-list-group-border-width) solid var(--bs-list-group-border-color);
}
.list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}
.list-group-item:last-child {
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}
.list-group-item.disabled, .list-group-item:disabled {
  color: var(--bs-list-group-disabled-color);
  pointer-events: none;
  background-color: var(--bs-list-group-disabled-bg);
}
.list-group-item.active {
  z-index: 2;
  color: var(--bs-list-group-active-color);
  background-color: var(--bs-list-group-active-bg);
  border-color: var(--bs-list-group-active-border-color);
}
.list-group-item + .list-group-item {
  border-top-width: 0;
}
.list-group-item + .list-group-item.active {
  margin-top: calc(-1 * var(--bs-list-group-border-width));
  border-top-width: var(--bs-list-group-border-width);
}

.list-group-item-action {
  width: 100%;
  color: var(--bs-list-group-action-color);
  text-align: inherit;
}
.list-group-item-action:not(.active):hover, .list-group-item-action:not(.active):focus {
  z-index: 1;
  color: var(--bs-list-group-action-hover-color);
  text-decoration: none;
  background-color: var(--bs-list-group-action-hover-bg);
}
.list-group-item-action:not(.active):active {
  color: var(--bs-list-group-action-active-color);
  background-color: var(--bs-list-group-action-active-bg);
}

.list-group-horizontal {
  flex-direction: row;
}
.list-group-horizontal > .list-group-item:first-child:not(:last-child) {
  border-bottom-left-radius: var(--bs-list-group-border-radius);
  border-top-right-radius: 0;
}
.list-group-horizontal > .list-group-item:last-child:not(:first-child) {
  border-top-right-radius: var(--bs-list-group-border-radius);
  border-bottom-left-radius: 0;
}
.list-group-horizontal > .list-group-item.active {
  margin-top: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item {
  border-top-width: var(--bs-list-group-border-width);
  border-left-width: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item.active {
  margin-left: calc(-1 * var(--bs-list-group-border-width));
  border-left-width: var(--bs-list-group-border-width);
}

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row;
  }
  .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row;
  }
  .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row;
  }
  .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row;
  }
  .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
@media (min-width: 1400px) {
  .list-group-horizontal-xxl {
    flex-direction: row;
  }
  .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xxl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0;
  }
  .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {
    margin-left: calc(-1 * var(--bs-list-group-border-width));
    border-left-width: var(--bs-list-group-border-width);
  }
}
.list-group-flush {
  border-radius: 0;
}
.list-group-flush > .list-group-item {
  border-width: 0 0 var(--bs-list-group-border-width);
}
.list-group-flush > .list-group-item:last-child {
  border-bottom-width: 0;
}

.list-group-item-primary {
  --bs-list-group-color: var(--bs-primary-text-emphasis);
  --bs-list-group-bg: var(--bs-primary-bg-subtle);
  --bs-list-group-border-color: var(--bs-primary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-primary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-primary-border-subtle);
  --bs-list-group-active-color: var(--bs-primary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-primary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-primary-text-emphasis);
}

.list-group-item-secondary {
  --bs-list-group-color: var(--bs-secondary-text-emphasis);
  --bs-list-group-bg: var(--bs-secondary-bg-subtle);
  --bs-list-group-border-color: var(--bs-secondary-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-secondary-border-subtle);
  --bs-list-group-active-color: var(--bs-secondary-bg-subtle);
  --bs-list-group-active-bg: var(--bs-secondary-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-secondary-text-emphasis);
}

.list-group-item-success {
  --bs-list-group-color: var(--bs-success-text-emphasis);
  --bs-list-group-bg: var(--bs-success-bg-subtle);
  --bs-list-group-border-color: var(--bs-success-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-success-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-success-border-subtle);
  --bs-list-group-active-color: var(--bs-success-bg-subtle);
  --bs-list-group-active-bg: var(--bs-success-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-success-text-emphasis);
}

.list-group-item-info {
  --bs-list-group-color: var(--bs-info-text-emphasis);
  --bs-list-group-bg: var(--bs-info-bg-subtle);
  --bs-list-group-border-color: var(--bs-info-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-info-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-info-border-subtle);
  --bs-list-group-active-color: var(--bs-info-bg-subtle);
  --bs-list-group-active-bg: var(--bs-info-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-info-text-emphasis);
}

.list-group-item-warning {
  --bs-list-group-color: var(--bs-warning-text-emphasis);
  --bs-list-group-bg: var(--bs-warning-bg-subtle);
  --bs-list-group-border-color: var(--bs-warning-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-warning-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-warning-border-subtle);
  --bs-list-group-active-color: var(--bs-warning-bg-subtle);
  --bs-list-group-active-bg: var(--bs-warning-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-warning-text-emphasis);
}

.list-group-item-danger {
  --bs-list-group-color: var(--bs-danger-text-emphasis);
  --bs-list-group-bg: var(--bs-danger-bg-subtle);
  --bs-list-group-border-color: var(--bs-danger-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-danger-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-danger-border-subtle);
  --bs-list-group-active-color: var(--bs-danger-bg-subtle);
  --bs-list-group-active-bg: var(--bs-danger-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-danger-text-emphasis);
}

.list-group-item-light {
  --bs-list-group-color: var(--bs-light-text-emphasis);
  --bs-list-group-bg: var(--bs-light-bg-subtle);
  --bs-list-group-border-color: var(--bs-light-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-light-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-light-border-subtle);
  --bs-list-group-active-color: var(--bs-light-bg-subtle);
  --bs-list-group-active-bg: var(--bs-light-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-light-text-emphasis);
}

.list-group-item-dark {
  --bs-list-group-color: var(--bs-dark-text-emphasis);
  --bs-list-group-bg: var(--bs-dark-bg-subtle);
  --bs-list-group-border-color: var(--bs-dark-border-subtle);
  --bs-list-group-action-hover-color: var(--bs-emphasis-color);
  --bs-list-group-action-hover-bg: var(--bs-dark-border-subtle);
  --bs-list-group-action-active-color: var(--bs-emphasis-color);
  --bs-list-group-action-active-bg: var(--bs-dark-border-subtle);
  --bs-list-group-active-color: var(--bs-dark-bg-subtle);
  --bs-list-group-active-bg: var(--bs-dark-text-emphasis);
  --bs-list-group-active-border-color: var(--bs-dark-text-emphasis);
}

.btn-close {
  --bs-btn-close-color: #000;
  --bs-btn-close-bg: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  --bs-btn-close-opacity: 0.5;
  --bs-btn-close-hover-opacity: 0.75;
  --bs-btn-close-focus-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
  --bs-btn-close-focus-opacity: 1;
  --bs-btn-close-disabled-opacity: 0.25;
  box-sizing: content-box;
  width: 1em;
  height: 1em;
  padding: 0.25em 0.25em;
  color: var(--bs-btn-close-color);
  background: transparent var(--bs-btn-close-bg) center/1em auto no-repeat;
  filter: var(--bs-btn-close-filter);
  border: 0;
  border-radius: 0.375rem;
  opacity: var(--bs-btn-close-opacity);
}
.btn-close:hover {
  color: var(--bs-btn-close-color);
  text-decoration: none;
  opacity: var(--bs-btn-close-hover-opacity);
}
.btn-close:focus {
  outline: 0;
  box-shadow: var(--bs-btn-close-focus-shadow);
  opacity: var(--bs-btn-close-focus-opacity);
}
.btn-close:disabled, .btn-close.disabled {
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
  opacity: var(--bs-btn-close-disabled-opacity);
}

.btn-close-white {
  --bs-btn-close-filter: invert(1) grayscale(100%) brightness(200%);
}

:root,
[data-bs-theme=light] {
  --bs-btn-close-filter: ;
}

[data-bs-theme=dark] {
  --bs-btn-close-filter: invert(1) grayscale(100%) brightness(200%);
}

.toast {
  --bs-toast-zindex: 1090;
  --bs-toast-padding-x: 0.75rem;
  --bs-toast-padding-y: 0.5rem;
  --bs-toast-spacing: 1.5rem;
  --bs-toast-max-width: 350px;
  --bs-toast-font-size: 0.875rem;
  --bs-toast-color: ;
  --bs-toast-bg: rgba(var(--bs-body-bg-rgb), 0.85);
  --bs-toast-border-width: var(--bs-border-width);
  --bs-toast-border-color: var(--bs-border-color-translucent);
  --bs-toast-border-radius: var(--bs-border-radius);
  --bs-toast-box-shadow: var(--bs-box-shadow);
  --bs-toast-header-color: var(--bs-secondary-color);
  --bs-toast-header-bg: rgba(var(--bs-body-bg-rgb), 0.85);
  --bs-toast-header-border-color: var(--bs-border-color-translucent);
  width: var(--bs-toast-max-width);
  max-width: 100%;
  font-size: var(--bs-toast-font-size);
  color: var(--bs-toast-color);
  pointer-events: auto;
  background-color: var(--bs-toast-bg);
  background-clip: padding-box;
  border: var(--bs-toast-border-width) solid var(--bs-toast-border-color);
  box-shadow: var(--bs-toast-box-shadow);
  border-radius: var(--bs-toast-border-radius);
}
.toast.showing {
  opacity: 0;
}
.toast:not(.show) {
  display: none;
}

.toast-container {
  --bs-toast-zindex: 1090;
  position: absolute;
  z-index: var(--bs-toast-zindex);
  width: max-content;
  max-width: 100%;
  pointer-events: none;
}
.toast-container > :not(:last-child) {
  margin-bottom: var(--bs-toast-spacing);
}

.toast-header {
  display: flex;
  align-items: center;
  padding: var(--bs-toast-padding-y) var(--bs-toast-padding-x);
  color: var(--bs-toast-header-color);
  background-color: var(--bs-toast-header-bg);
  background-clip: padding-box;
  border-bottom: var(--bs-toast-border-width) solid var(--bs-toast-header-border-color);
  border-top-left-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
  border-top-right-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
}
.toast-header .btn-close {
  margin-right: calc(-0.5 * var(--bs-toast-padding-x));
  margin-left: var(--bs-toast-padding-x);
}

.toast-body {
  padding: var(--bs-toast-padding-x);
  word-wrap: break-word;
}

.modal {
  --bs-modal-zindex: 1055;
  --bs-modal-width: 500px;
  --bs-modal-padding: 1rem;
  --bs-modal-margin: 0.5rem;
  --bs-modal-color: var(--bs-body-color);
  --bs-modal-bg: var(--bs-body-bg);
  --bs-modal-border-color: var(--bs-border-color-translucent);
  --bs-modal-border-width: var(--bs-border-width);
  --bs-modal-border-radius: var(--bs-border-radius-lg);
  --bs-modal-box-shadow: var(--bs-box-shadow-sm);
  --bs-modal-inner-border-radius: calc(var(--bs-border-radius-lg) - (var(--bs-border-width)));
  --bs-modal-header-padding-x: 1rem;
  --bs-modal-header-padding-y: 1rem;
  --bs-modal-header-padding: 1rem 1rem;
  --bs-modal-header-border-color: var(--bs-border-color);
  --bs-modal-header-border-width: var(--bs-border-width);
  --bs-modal-title-line-height: 1.5;
  --bs-modal-footer-gap: 0.5rem;
  --bs-modal-footer-bg: ;
  --bs-modal-footer-border-color: var(--bs-border-color);
  --bs-modal-footer-border-width: var(--bs-border-width);
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-modal-zindex);
  display: none;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: var(--bs-modal-margin);
  pointer-events: none;
}
.modal.fade .modal-dialog {
  transform: translate(0, -50px);
  transition: transform 0.3s ease-out;
}
@media (prefers-reduced-motion: reduce) {
  .modal.fade .modal-dialog {
    transition: none;
  }
}
.modal.show .modal-dialog {
  transform: none;
}
.modal.modal-static .modal-dialog {
  transform: scale(1.02);
}

.modal-dialog-scrollable {
  height: calc(100% - var(--bs-modal-margin) * 2);
}
.modal-dialog-scrollable .modal-content {
  max-height: 100%;
  overflow: hidden;
}
.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - var(--bs-modal-margin) * 2);
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  color: var(--bs-modal-color);
  pointer-events: auto;
  background-color: var(--bs-modal-bg);
  background-clip: padding-box;
  border: var(--bs-modal-border-width) solid var(--bs-modal-border-color);
  border-radius: var(--bs-modal-border-radius);
  outline: 0;
}

.modal-backdrop {
  --bs-backdrop-zindex: 1050;
  --bs-backdrop-bg: #000;
  --bs-backdrop-opacity: 0.5;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-backdrop-zindex);
  width: 100vw;
  height: 100vh;
  background-color: var(--bs-backdrop-bg);
}
.modal-backdrop.fade {
  opacity: 0;
}
.modal-backdrop.show {
  opacity: var(--bs-backdrop-opacity);
}

.modal-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  padding: var(--bs-modal-header-padding);
  border-bottom: var(--bs-modal-header-border-width) solid var(--bs-modal-header-border-color);
  border-top-left-radius: var(--bs-modal-inner-border-radius);
  border-top-right-radius: var(--bs-modal-inner-border-radius);
}
.modal-header .btn-close {
  padding: calc(var(--bs-modal-header-padding-y) * 0.5) calc(var(--bs-modal-header-padding-x) * 0.5);
  margin-top: calc(-0.5 * var(--bs-modal-header-padding-y));
  margin-right: calc(-0.5 * var(--bs-modal-header-padding-x));
  margin-bottom: calc(-0.5 * var(--bs-modal-header-padding-y));
  margin-left: auto;
}

.modal-title {
  margin-bottom: 0;
  line-height: var(--bs-modal-title-line-height);
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: var(--bs-modal-padding);
}

.modal-footer {
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: calc(var(--bs-modal-padding) - var(--bs-modal-footer-gap) * 0.5);
  background-color: var(--bs-modal-footer-bg);
  border-top: var(--bs-modal-footer-border-width) solid var(--bs-modal-footer-border-color);
  border-bottom-right-radius: var(--bs-modal-inner-border-radius);
  border-bottom-left-radius: var(--bs-modal-inner-border-radius);
}
.modal-footer > * {
  margin: calc(var(--bs-modal-footer-gap) * 0.5);
}

@media (min-width: 576px) {
  .modal {
    --bs-modal-margin: 1.75rem;
    --bs-modal-box-shadow: var(--bs-box-shadow);
  }
  .modal-dialog {
    max-width: var(--bs-modal-width);
    margin-right: auto;
    margin-left: auto;
  }
  .modal-sm {
    --bs-modal-width: 300px;
  }
}
@media (min-width: 992px) {
  .modal-lg,
  .modal-xl {
    --bs-modal-width: 800px;
  }
}
@media (min-width: 1200px) {
  .modal-xl {
    --bs-modal-width: 1140px;
  }
}
.modal-fullscreen {
  width: 100vw;
  max-width: none;
  height: 100%;
  margin: 0;
}
.modal-fullscreen .modal-content {
  height: 100%;
  border: 0;
  border-radius: 0;
}
.modal-fullscreen .modal-header,
.modal-fullscreen .modal-footer {
  border-radius: 0;
}
.modal-fullscreen .modal-body {
  overflow-y: auto;
}

@media (max-width: 575.98px) {
  .modal-fullscreen-sm-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-sm-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-header,
  .modal-fullscreen-sm-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-sm-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 767.98px) {
  .modal-fullscreen-md-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-md-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-header,
  .modal-fullscreen-md-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-md-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 991.98px) {
  .modal-fullscreen-lg-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-lg-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-header,
  .modal-fullscreen-lg-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-lg-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1199.98px) {
  .modal-fullscreen-xl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-header,
  .modal-fullscreen-xl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xl-down .modal-body {
    overflow-y: auto;
  }
}
@media (max-width: 1399.98px) {
  .modal-fullscreen-xxl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0;
  }
  .modal-fullscreen-xxl-down .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-header,
  .modal-fullscreen-xxl-down .modal-footer {
    border-radius: 0;
  }
  .modal-fullscreen-xxl-down .modal-body {
    overflow-y: auto;
  }
}
.tooltip {
  --bs-tooltip-zindex: 1080;
  --bs-tooltip-max-width: 200px;
  --bs-tooltip-padding-x: 0.5rem;
  --bs-tooltip-padding-y: 0.25rem;
  --bs-tooltip-margin: ;
  --bs-tooltip-font-size: 0.875rem;
  --bs-tooltip-color: var(--bs-body-bg);
  --bs-tooltip-bg: var(--bs-emphasis-color);
  --bs-tooltip-border-radius: var(--bs-border-radius);
  --bs-tooltip-opacity: 0.9;
  --bs-tooltip-arrow-width: 0.8rem;
  --bs-tooltip-arrow-height: 0.4rem;
  z-index: var(--bs-tooltip-zindex);
  display: block;
  margin: var(--bs-tooltip-margin);
  font-family: var(--bs-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-tooltip-font-size);
  word-wrap: break-word;
  opacity: 0;
}
.tooltip.show {
  opacity: var(--bs-tooltip-opacity);
}
.tooltip .tooltip-arrow {
  display: block;
  width: var(--bs-tooltip-arrow-width);
  height: var(--bs-tooltip-arrow-height);
}
.tooltip .tooltip-arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-top .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow {
  bottom: calc(-1 * var(--bs-tooltip-arrow-height));
}
.bs-tooltip-top .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before {
  top: -1px;
  border-width: var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-top-color: var(--bs-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-end .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow {
  left: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}
.bs-tooltip-end .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before {
  right: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * 0.5) 0;
  border-right-color: var(--bs-tooltip-bg);
}

/* rtl:end:ignore */
.bs-tooltip-bottom .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow {
  top: calc(-1 * var(--bs-tooltip-arrow-height));
}
.bs-tooltip-bottom .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before {
  bottom: -1px;
  border-width: 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-bottom-color: var(--bs-tooltip-bg);
}

/* rtl:begin:ignore */
.bs-tooltip-start .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow {
  right: calc(-1 * var(--bs-tooltip-arrow-height));
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width);
}
.bs-tooltip-start .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before {
  left: -1px;
  border-width: calc(var(--bs-tooltip-arrow-width) * 0.5) 0 calc(var(--bs-tooltip-arrow-width) * 0.5) var(--bs-tooltip-arrow-height);
  border-left-color: var(--bs-tooltip-bg);
}

/* rtl:end:ignore */
.tooltip-inner {
  max-width: var(--bs-tooltip-max-width);
  padding: var(--bs-tooltip-padding-y) var(--bs-tooltip-padding-x);
  color: var(--bs-tooltip-color);
  text-align: center;
  background-color: var(--bs-tooltip-bg);
  border-radius: var(--bs-tooltip-border-radius);
}

.popover {
  --bs-popover-zindex: 1070;
  --bs-popover-max-width: 276px;
  --bs-popover-font-size: 0.875rem;
  --bs-popover-bg: var(--bs-body-bg);
  --bs-popover-border-width: var(--bs-border-width);
  --bs-popover-border-color: var(--bs-border-color-translucent);
  --bs-popover-border-radius: var(--bs-border-radius-lg);
  --bs-popover-inner-border-radius: calc(var(--bs-border-radius-lg) - var(--bs-border-width));
  --bs-popover-box-shadow: var(--bs-box-shadow);
  --bs-popover-header-padding-x: 1rem;
  --bs-popover-header-padding-y: 0.5rem;
  --bs-popover-header-font-size: 1rem;
  --bs-popover-header-color: inherit;
  --bs-popover-header-bg: var(--bs-secondary-bg);
  --bs-popover-body-padding-x: 1rem;
  --bs-popover-body-padding-y: 1rem;
  --bs-popover-body-color: var(--bs-body-color);
  --bs-popover-arrow-width: 1rem;
  --bs-popover-arrow-height: 0.5rem;
  --bs-popover-arrow-border: var(--bs-popover-border-color);
  z-index: var(--bs-popover-zindex);
  display: block;
  max-width: var(--bs-popover-max-width);
  font-family: var(--bs-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-popover-font-size);
  word-wrap: break-word;
  background-color: var(--bs-popover-bg);
  background-clip: padding-box;
  border: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-radius: var(--bs-popover-border-radius);
}
.popover .popover-arrow {
  display: block;
  width: var(--bs-popover-arrow-width);
  height: var(--bs-popover-arrow-height);
}
.popover .popover-arrow::before, .popover .popover-arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
  border-width: 0;
}

.bs-popover-top > .popover-arrow, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow {
  bottom: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  border-width: var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}
.bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before {
  bottom: 0;
  border-top-color: var(--bs-popover-arrow-border);
}
.bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after {
  bottom: var(--bs-popover-border-width);
  border-top-color: var(--bs-popover-bg);
}

/* rtl:begin:ignore */
.bs-popover-end > .popover-arrow, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow {
  left: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * 0.5) 0;
}
.bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before {
  left: 0;
  border-right-color: var(--bs-popover-arrow-border);
}
.bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after {
  left: var(--bs-popover-border-width);
  border-right-color: var(--bs-popover-bg);
}

/* rtl:end:ignore */
.bs-popover-bottom > .popover-arrow, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow {
  top: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  border-width: 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}
.bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before {
  top: 0;
  border-bottom-color: var(--bs-popover-arrow-border);
}
.bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after {
  top: var(--bs-popover-border-width);
  border-bottom-color: var(--bs-popover-bg);
}
.bs-popover-bottom .popover-header::before, .bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: var(--bs-popover-arrow-width);
  margin-left: calc(-0.5 * var(--bs-popover-arrow-width));
  content: "";
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-header-bg);
}

/* rtl:begin:ignore */
.bs-popover-start > .popover-arrow, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow {
  right: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  border-width: calc(var(--bs-popover-arrow-width) * 0.5) 0 calc(var(--bs-popover-arrow-width) * 0.5) var(--bs-popover-arrow-height);
}
.bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before {
  right: 0;
  border-left-color: var(--bs-popover-arrow-border);
}
.bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after {
  right: var(--bs-popover-border-width);
  border-left-color: var(--bs-popover-bg);
}

/* rtl:end:ignore */
.popover-header {
  padding: var(--bs-popover-header-padding-y) var(--bs-popover-header-padding-x);
  margin-bottom: 0;
  font-size: var(--bs-popover-header-font-size);
  color: var(--bs-popover-header-color);
  background-color: var(--bs-popover-header-bg);
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-top-left-radius: var(--bs-popover-inner-border-radius);
  border-top-right-radius: var(--bs-popover-inner-border-radius);
}
.popover-header:empty {
  display: none;
}

.popover-body {
  padding: var(--bs-popover-body-padding-y) var(--bs-popover-body-padding-x);
  color: var(--bs-popover-body-color);
}

.carousel {
  position: relative;
}

.carousel.pointer-event {
  touch-action: pan-y;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}
.carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-item {
    transition: none;
  }
}

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block;
}

.carousel-item-next:not(.carousel-item-start),
.active.carousel-item-end {
  transform: translateX(100%);
}

.carousel-item-prev:not(.carousel-item-end),
.active.carousel-item-start {
  transform: translateX(-100%);
}

.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}
.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-start,
.carousel-fade .carousel-item-prev.carousel-item-end {
  z-index: 1;
  opacity: 1;
}
.carousel-fade .active.carousel-item-start,
.carousel-fade .active.carousel-item-end {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-fade .active.carousel-item-start,
  .carousel-fade .active.carousel-item-end {
    transition: none;
  }
}

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  padding: 0;
  color: #fff;
  text-align: center;
  background: none;
  filter: var(--bs-carousel-control-icon-filter);
  border: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-control-prev,
  .carousel-control-next {
    transition: none;
  }
}
.carousel-control-prev:hover, .carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: #fff;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 100% 100%;
}

.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___}) /*rtl:url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708'/%3e%3c/svg%3e")*/;
}

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___}) /*rtl:url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0'/%3e%3c/svg%3e")*/;
}

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  display: flex;
  justify-content: center;
  padding: 0;
  margin-right: 15%;
  margin-bottom: 1rem;
  margin-left: 15%;
}
.carousel-indicators [data-bs-target] {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  padding: 0;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: var(--bs-carousel-indicator-active-bg);
  background-clip: padding-box;
  border: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-indicators [data-bs-target] {
    transition: none;
  }
}
.carousel-indicators .active {
  opacity: 1;
}

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 1.25rem;
  left: 15%;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: var(--bs-carousel-caption-color);
  text-align: center;
}

.carousel-dark {
  --bs-carousel-indicator-active-bg: #000;
  --bs-carousel-caption-color: #000;
  --bs-carousel-control-icon-filter: invert(1) grayscale(100);
}

:root,
[data-bs-theme=light] {
  --bs-carousel-indicator-active-bg: #fff;
  --bs-carousel-caption-color: #fff;
  --bs-carousel-control-icon-filter: ;
}

[data-bs-theme=dark] {
  --bs-carousel-indicator-active-bg: #000;
  --bs-carousel-caption-color: #000;
  --bs-carousel-control-icon-filter: invert(1) grayscale(100);
}

.spinner-grow,
.spinner-border {
  display: inline-block;
  flex-shrink: 0;
  width: var(--bs-spinner-width);
  height: var(--bs-spinner-height);
  vertical-align: var(--bs-spinner-vertical-align);
  border-radius: 50%;
  animation: var(--bs-spinner-animation-speed) linear infinite var(--bs-spinner-animation-name);
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg) /* rtl:ignore */;
  }
}
.spinner-border {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-border-width: 0.25em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-border;
  border: var(--bs-spinner-border-width) solid currentcolor;
  border-right-color: transparent;
}

.spinner-border-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
  --bs-spinner-border-width: 0.2em;
}

@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: none;
  }
}
.spinner-grow {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-grow;
  background-color: currentcolor;
  opacity: 0;
}

.spinner-grow-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
}

@media (prefers-reduced-motion: reduce) {
  .spinner-border,
  .spinner-grow {
    --bs-spinner-animation-speed: 1.5s;
  }
}
.offcanvas, .offcanvas-xxl, .offcanvas-xl, .offcanvas-lg, .offcanvas-md, .offcanvas-sm {
  --bs-offcanvas-zindex: 1045;
  --bs-offcanvas-width: 400px;
  --bs-offcanvas-height: 30vh;
  --bs-offcanvas-padding-x: 1rem;
  --bs-offcanvas-padding-y: 1rem;
  --bs-offcanvas-color: var(--bs-body-color);
  --bs-offcanvas-bg: var(--bs-body-bg);
  --bs-offcanvas-border-width: var(--bs-border-width);
  --bs-offcanvas-border-color: var(--bs-border-color-translucent);
  --bs-offcanvas-box-shadow: var(--bs-box-shadow-sm);
  --bs-offcanvas-transition: transform 0.3s ease-in-out;
  --bs-offcanvas-title-line-height: 1.5;
}

@media (max-width: 575.98px) {
  .offcanvas-sm {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-sm {
    transition: none;
  }
}
@media (max-width: 575.98px) {
  .offcanvas-sm.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-sm.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-sm.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-sm.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-sm.showing, .offcanvas-sm.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-sm.showing, .offcanvas-sm.hiding, .offcanvas-sm.show {
    visibility: visible;
  }
}
@media (min-width: 576px) {
  .offcanvas-sm {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-sm .offcanvas-header {
    display: none;
  }
  .offcanvas-sm .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 767.98px) {
  .offcanvas-md {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 767.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-md {
    transition: none;
  }
}
@media (max-width: 767.98px) {
  .offcanvas-md.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-md.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-md.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-md.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-md.showing, .offcanvas-md.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-md.showing, .offcanvas-md.hiding, .offcanvas-md.show {
    visibility: visible;
  }
}
@media (min-width: 768px) {
  .offcanvas-md {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-md .offcanvas-header {
    display: none;
  }
  .offcanvas-md .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 991.98px) {
  .offcanvas-lg {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-lg {
    transition: none;
  }
}
@media (max-width: 991.98px) {
  .offcanvas-lg.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-lg.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-lg.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-lg.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-lg.showing, .offcanvas-lg.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-lg.showing, .offcanvas-lg.hiding, .offcanvas-lg.show {
    visibility: visible;
  }
}
@media (min-width: 992px) {
  .offcanvas-lg {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-lg .offcanvas-header {
    display: none;
  }
  .offcanvas-lg .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1199.98px) {
  .offcanvas-xl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 1199.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xl {
    transition: none;
  }
}
@media (max-width: 1199.98px) {
  .offcanvas-xl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-xl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-xl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xl.showing, .offcanvas-xl.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-xl.showing, .offcanvas-xl.hiding, .offcanvas-xl.show {
    visibility: visible;
  }
}
@media (min-width: 1200px) {
  .offcanvas-xl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xl .offcanvas-header {
    display: none;
  }
  .offcanvas-xl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

@media (max-width: 1399.98px) {
  .offcanvas-xxl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: var(--bs-offcanvas-transition);
  }
}
@media (max-width: 1399.98px) and (prefers-reduced-motion: reduce) {
  .offcanvas-xxl {
    transition: none;
  }
}
@media (max-width: 1399.98px) {
  .offcanvas-xxl.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%);
  }
  .offcanvas-xxl.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%);
  }
  .offcanvas-xxl.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%);
  }
  .offcanvas-xxl.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%);
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.show:not(.hiding) {
    transform: none;
  }
  .offcanvas-xxl.showing, .offcanvas-xxl.hiding, .offcanvas-xxl.show {
    visibility: visible;
  }
}
@media (min-width: 1400px) {
  .offcanvas-xxl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important;
  }
  .offcanvas-xxl .offcanvas-header {
    display: none;
  }
  .offcanvas-xxl .offcanvas-body {
    display: flex;
    flex-grow: 0;
    padding: 0;
    overflow-y: visible;
    background-color: transparent !important;
  }
}

.offcanvas {
  position: fixed;
  bottom: 0;
  z-index: var(--bs-offcanvas-zindex);
  display: flex;
  flex-direction: column;
  max-width: 100%;
  color: var(--bs-offcanvas-color);
  visibility: hidden;
  background-color: var(--bs-offcanvas-bg);
  background-clip: padding-box;
  outline: 0;
  transition: var(--bs-offcanvas-transition);
}
@media (prefers-reduced-motion: reduce) {
  .offcanvas {
    transition: none;
  }
}
.offcanvas.offcanvas-start {
  top: 0;
  left: 0;
  width: var(--bs-offcanvas-width);
  border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(-100%);
}
.offcanvas.offcanvas-end {
  top: 0;
  right: 0;
  width: var(--bs-offcanvas-width);
  border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateX(100%);
}
.offcanvas.offcanvas-top {
  top: 0;
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(-100%);
}
.offcanvas.offcanvas-bottom {
  right: 0;
  left: 0;
  height: var(--bs-offcanvas-height);
  max-height: 100%;
  border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
  transform: translateY(100%);
}
.offcanvas.showing, .offcanvas.show:not(.hiding) {
  transform: none;
}
.offcanvas.showing, .offcanvas.hiding, .offcanvas.show {
  visibility: visible;
}

.offcanvas-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #000;
}
.offcanvas-backdrop.fade {
  opacity: 0;
}
.offcanvas-backdrop.show {
  opacity: 0.5;
}

.offcanvas-header {
  display: flex;
  align-items: center;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
}
.offcanvas-header .btn-close {
  padding: calc(var(--bs-offcanvas-padding-y) * 0.5) calc(var(--bs-offcanvas-padding-x) * 0.5);
  margin-top: calc(-0.5 * var(--bs-offcanvas-padding-y));
  margin-right: calc(-0.5 * var(--bs-offcanvas-padding-x));
  margin-bottom: calc(-0.5 * var(--bs-offcanvas-padding-y));
  margin-left: auto;
}

.offcanvas-title {
  margin-bottom: 0;
  line-height: var(--bs-offcanvas-title-line-height);
}

.offcanvas-body {
  flex-grow: 1;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
  overflow-y: auto;
}

.placeholder {
  display: inline-block;
  min-height: 1em;
  vertical-align: middle;
  cursor: wait;
  background-color: currentcolor;
  opacity: 0.5;
}
.placeholder.btn::before {
  display: inline-block;
  content: "";
}

.placeholder-xs {
  min-height: 0.6em;
}

.placeholder-sm {
  min-height: 0.8em;
}

.placeholder-lg {
  min-height: 1.2em;
}

.placeholder-glow .placeholder {
  animation: placeholder-glow 2s ease-in-out infinite;
}

@keyframes placeholder-glow {
  50% {
    opacity: 0.2;
  }
}
.placeholder-wave {
  mask-image: linear-gradient(130deg, #000 55%, rgba(0, 0, 0, 0.8) 75%, #000 95%);
  mask-size: 200% 100%;
  animation: placeholder-wave 2s linear infinite;
}

@keyframes placeholder-wave {
  100% {
    mask-position: -200% 0%;
  }
}
.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.text-bg-primary {
  color: #fff !important;
  background-color: RGBA(var(--bs-primary-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-secondary {
  color: #fff !important;
  background-color: RGBA(var(--bs-secondary-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-success {
  color: #fff !important;
  background-color: RGBA(var(--bs-success-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-info {
  color: #000 !important;
  background-color: RGBA(var(--bs-info-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-warning {
  color: #000 !important;
  background-color: RGBA(var(--bs-warning-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-danger {
  color: #fff !important;
  background-color: RGBA(var(--bs-danger-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-light {
  color: #000 !important;
  background-color: RGBA(var(--bs-light-rgb), var(--bs-bg-opacity, 1)) !important;
}

.text-bg-dark {
  color: #fff !important;
  background-color: RGBA(var(--bs-dark-rgb), var(--bs-bg-opacity, 1)) !important;
}

.link-primary {
  color: RGBA(var(--bs-primary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-primary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-primary:hover, .link-primary:focus {
  color: RGBA(10, 88, 202, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(10, 88, 202, var(--bs-link-underline-opacity, 1)) !important;
}

.link-secondary {
  color: RGBA(var(--bs-secondary-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-secondary-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-secondary:hover, .link-secondary:focus {
  color: RGBA(86, 94, 100, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(86, 94, 100, var(--bs-link-underline-opacity, 1)) !important;
}

.link-success {
  color: RGBA(var(--bs-success-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-success-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-success:hover, .link-success:focus {
  color: RGBA(20, 108, 67, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(20, 108, 67, var(--bs-link-underline-opacity, 1)) !important;
}

.link-info {
  color: RGBA(var(--bs-info-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-info-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-info:hover, .link-info:focus {
  color: RGBA(61, 213, 243, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(61, 213, 243, var(--bs-link-underline-opacity, 1)) !important;
}

.link-warning {
  color: RGBA(var(--bs-warning-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-warning-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-warning:hover, .link-warning:focus {
  color: RGBA(255, 205, 57, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(255, 205, 57, var(--bs-link-underline-opacity, 1)) !important;
}

.link-danger {
  color: RGBA(var(--bs-danger-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-danger-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-danger:hover, .link-danger:focus {
  color: RGBA(176, 42, 55, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(176, 42, 55, var(--bs-link-underline-opacity, 1)) !important;
}

.link-light {
  color: RGBA(var(--bs-light-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-light-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-light:hover, .link-light:focus {
  color: RGBA(249, 250, 251, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(249, 250, 251, var(--bs-link-underline-opacity, 1)) !important;
}

.link-dark {
  color: RGBA(var(--bs-dark-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-dark-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-dark:hover, .link-dark:focus {
  color: RGBA(26, 30, 33, var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(26, 30, 33, var(--bs-link-underline-opacity, 1)) !important;
}

.link-body-emphasis {
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 1)) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}
.link-body-emphasis:hover, .link-body-emphasis:focus {
  color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-opacity, 0.75)) !important;
  text-decoration-color: RGBA(var(--bs-emphasis-color-rgb), var(--bs-link-underline-opacity, 0.75)) !important;
}

.focus-ring:focus {
  outline: 0;
  box-shadow: var(--bs-focus-ring-x, 0) var(--bs-focus-ring-y, 0) var(--bs-focus-ring-blur, 0) var(--bs-focus-ring-width) var(--bs-focus-ring-color);
}

.icon-link {
  display: inline-flex;
  gap: 0.375rem;
  align-items: center;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-opacity, 0.5));
  text-underline-offset: 0.25em;
  backface-visibility: hidden;
}
.icon-link > .bi {
  flex-shrink: 0;
  width: 1em;
  height: 1em;
  fill: currentcolor;
  transition: 0.2s ease-in-out transform;
}
@media (prefers-reduced-motion: reduce) {
  .icon-link > .bi {
    transition: none;
  }
}

.icon-link-hover:hover > .bi, .icon-link-hover:focus-visible > .bi {
  transform: var(--bs-icon-link-transform, translate3d(0.25em, 0, 0));
}

.ratio {
  position: relative;
  width: 100%;
}
.ratio::before {
  display: block;
  padding-top: var(--bs-aspect-ratio);
  content: "";
}
.ratio > * {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.ratio-1x1 {
  --bs-aspect-ratio: 100%;
}

.ratio-4x3 {
  --bs-aspect-ratio: 75%;
}

.ratio-16x9 {
  --bs-aspect-ratio: 56.25%;
}

.ratio-21x9 {
  --bs-aspect-ratio: 42.8571428571%;
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

.sticky-top {
  position: sticky;
  top: 0;
  z-index: 1020;
}

.sticky-bottom {
  position: sticky;
  bottom: 0;
  z-index: 1020;
}

@media (min-width: 576px) {
  .sticky-sm-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-sm-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 768px) {
  .sticky-md-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-md-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 992px) {
  .sticky-lg-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-lg-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1200px) {
  .sticky-xl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
@media (min-width: 1400px) {
  .sticky-xxl-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
  .sticky-xxl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020;
  }
}
.hstack {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
}

.vstack {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-self: stretch;
}

.visually-hidden,
.visually-hidden-focusable:not(:focus):not(:focus-within) {
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important;
}
.visually-hidden:not(caption),
.visually-hidden-focusable:not(:focus):not(:focus-within):not(caption) {
  position: absolute !important;
}
.visually-hidden *,
.visually-hidden-focusable:not(:focus):not(:focus-within) * {
  overflow: hidden !important;
}

.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  content: "";
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.vr {
  display: inline-block;
  align-self: stretch;
  width: var(--bs-border-width);
  min-height: 1em;
  background-color: currentcolor;
  opacity: 0.25;
}

.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

.float-start {
  float: left !important;
}

.float-end {
  float: right !important;
}

.float-none {
  float: none !important;
}

.object-fit-contain {
  object-fit: contain !important;
}

.object-fit-cover {
  object-fit: cover !important;
}

.object-fit-fill {
  object-fit: fill !important;
}

.object-fit-scale {
  object-fit: scale-down !important;
}

.object-fit-none {
  object-fit: none !important;
}

.opacity-0 {
  opacity: 0 !important;
}

.opacity-25 {
  opacity: 0.25 !important;
}

.opacity-50 {
  opacity: 0.5 !important;
}

.opacity-75 {
  opacity: 0.75 !important;
}

.opacity-100 {
  opacity: 1 !important;
}

.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.overflow-visible {
  overflow: visible !important;
}

.overflow-scroll {
  overflow: scroll !important;
}

.overflow-x-auto {
  overflow-x: auto !important;
}

.overflow-x-hidden {
  overflow-x: hidden !important;
}

.overflow-x-visible {
  overflow-x: visible !important;
}

.overflow-x-scroll {
  overflow-x: scroll !important;
}

.overflow-y-auto {
  overflow-y: auto !important;
}

.overflow-y-hidden {
  overflow-y: hidden !important;
}

.overflow-y-visible {
  overflow-y: visible !important;
}

.overflow-y-scroll {
  overflow-y: scroll !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-grid {
  display: grid !important;
}

.d-inline-grid {
  display: inline-grid !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

.d-none {
  display: none !important;
}

.shadow {
  box-shadow: var(--bs-box-shadow) !important;
}

.shadow-sm {
  box-shadow: var(--bs-box-shadow-sm) !important;
}

.shadow-lg {
  box-shadow: var(--bs-box-shadow-lg) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.focus-ring-primary {
  --bs-focus-ring-color: rgba(var(--bs-primary-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-secondary {
  --bs-focus-ring-color: rgba(var(--bs-secondary-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-success {
  --bs-focus-ring-color: rgba(var(--bs-success-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-info {
  --bs-focus-ring-color: rgba(var(--bs-info-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-warning {
  --bs-focus-ring-color: rgba(var(--bs-warning-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-danger {
  --bs-focus-ring-color: rgba(var(--bs-danger-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-light {
  --bs-focus-ring-color: rgba(var(--bs-light-rgb), var(--bs-focus-ring-opacity));
}

.focus-ring-dark {
  --bs-focus-ring-color: rgba(var(--bs-dark-rgb), var(--bs-focus-ring-opacity));
}

.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: sticky !important;
}

.top-0 {
  top: 0 !important;
}

.top-50 {
  top: 50% !important;
}

.top-100 {
  top: 100% !important;
}

.bottom-0 {
  bottom: 0 !important;
}

.bottom-50 {
  bottom: 50% !important;
}

.bottom-100 {
  bottom: 100% !important;
}

.start-0 {
  left: 0 !important;
}

.start-50 {
  left: 50% !important;
}

.start-100 {
  left: 100% !important;
}

.end-0 {
  right: 0 !important;
}

.end-50 {
  right: 50% !important;
}

.end-100 {
  right: 100% !important;
}

.translate-middle {
  transform: translate(-50%, -50%) !important;
}

.translate-middle-x {
  transform: translateX(-50%) !important;
}

.translate-middle-y {
  transform: translateY(-50%) !important;
}

.border {
  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-0 {
  border: 0 !important;
}

.border-top {
  border-top: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-top-0 {
  border-top: 0 !important;
}

.border-end {
  border-right: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-end-0 {
  border-right: 0 !important;
}

.border-bottom {
  border-bottom: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

.border-start {
  border-left: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important;
}

.border-start-0 {
  border-left: 0 !important;
}

.border-primary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-primary-rgb), var(--bs-border-opacity)) !important;
}

.border-secondary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-secondary-rgb), var(--bs-border-opacity)) !important;
}

.border-success {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-success-rgb), var(--bs-border-opacity)) !important;
}

.border-info {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-info-rgb), var(--bs-border-opacity)) !important;
}

.border-warning {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-warning-rgb), var(--bs-border-opacity)) !important;
}

.border-danger {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-danger-rgb), var(--bs-border-opacity)) !important;
}

.border-light {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-light-rgb), var(--bs-border-opacity)) !important;
}

.border-dark {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-dark-rgb), var(--bs-border-opacity)) !important;
}

.border-black {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-black-rgb), var(--bs-border-opacity)) !important;
}

.border-white {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-white-rgb), var(--bs-border-opacity)) !important;
}

.border-primary-subtle {
  border-color: var(--bs-primary-border-subtle) !important;
}

.border-secondary-subtle {
  border-color: var(--bs-secondary-border-subtle) !important;
}

.border-success-subtle {
  border-color: var(--bs-success-border-subtle) !important;
}

.border-info-subtle {
  border-color: var(--bs-info-border-subtle) !important;
}

.border-warning-subtle {
  border-color: var(--bs-warning-border-subtle) !important;
}

.border-danger-subtle {
  border-color: var(--bs-danger-border-subtle) !important;
}

.border-light-subtle {
  border-color: var(--bs-light-border-subtle) !important;
}

.border-dark-subtle {
  border-color: var(--bs-dark-border-subtle) !important;
}

.border-1 {
  border-width: 1px !important;
}

.border-2 {
  border-width: 2px !important;
}

.border-3 {
  border-width: 3px !important;
}

.border-4 {
  border-width: 4px !important;
}

.border-5 {
  border-width: 5px !important;
}

.border-opacity-10 {
  --bs-border-opacity: 0.1;
}

.border-opacity-25 {
  --bs-border-opacity: 0.25;
}

.border-opacity-50 {
  --bs-border-opacity: 0.5;
}

.border-opacity-75 {
  --bs-border-opacity: 0.75;
}

.border-opacity-100 {
  --bs-border-opacity: 1;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.mw-100 {
  max-width: 100% !important;
}

.vw-100 {
  width: 100vw !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.mh-100 {
  max-height: 100% !important;
}

.vh-100 {
  height: 100vh !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.justify-content-evenly {
  justify-content: space-evenly !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

.order-first {
  order: -1 !important;
}

.order-0 {
  order: 0 !important;
}

.order-1 {
  order: 1 !important;
}

.order-2 {
  order: 2 !important;
}

.order-3 {
  order: 3 !important;
}

.order-4 {
  order: 4 !important;
}

.order-5 {
  order: 5 !important;
}

.order-last {
  order: 6 !important;
}

.m-0 {
  margin: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.m-3 {
  margin: 1rem !important;
}

.m-4 {
  margin: 1.5rem !important;
}

.m-5 {
  margin: 3rem !important;
}

.m-auto {
  margin: auto !important;
}

.mx-0 {
  margin-right: 0 !important;
  margin-left: 0 !important;
}

.mx-1 {
  margin-right: 0.25rem !important;
  margin-left: 0.25rem !important;
}

.mx-2 {
  margin-right: 0.5rem !important;
  margin-left: 0.5rem !important;
}

.mx-3 {
  margin-right: 1rem !important;
  margin-left: 1rem !important;
}

.mx-4 {
  margin-right: 1.5rem !important;
  margin-left: 1.5rem !important;
}

.mx-5 {
  margin-right: 3rem !important;
  margin-left: 3rem !important;
}

.mx-auto {
  margin-right: auto !important;
  margin-left: auto !important;
}

.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.my-1 {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important;
}

.my-2 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important;
}

.my-3 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important;
}

.my-4 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important;
}

.my-5 {
  margin-top: 3rem !important;
  margin-bottom: 3rem !important;
}

.my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mt-1 {
  margin-top: 0.25rem !important;
}

.mt-2 {
  margin-top: 0.5rem !important;
}

.mt-3 {
  margin-top: 1rem !important;
}

.mt-4 {
  margin-top: 1.5rem !important;
}

.mt-5 {
  margin-top: 3rem !important;
}

.mt-auto {
  margin-top: auto !important;
}

.me-0 {
  margin-right: 0 !important;
}

.me-1 {
  margin-right: 0.25rem !important;
}

.me-2 {
  margin-right: 0.5rem !important;
}

.me-3 {
  margin-right: 1rem !important;
}

.me-4 {
  margin-right: 1.5rem !important;
}

.me-5 {
  margin-right: 3rem !important;
}

.me-auto {
  margin-right: auto !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mb-1 {
  margin-bottom: 0.25rem !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.mb-3 {
  margin-bottom: 1rem !important;
}

.mb-4 {
  margin-bottom: 1.5rem !important;
}

.mb-5 {
  margin-bottom: 3rem !important;
}

.mb-auto {
  margin-bottom: auto !important;
}

.ms-0 {
  margin-left: 0 !important;
}

.ms-1 {
  margin-left: 0.25rem !important;
}

.ms-2 {
  margin-left: 0.5rem !important;
}

.ms-3 {
  margin-left: 1rem !important;
}

.ms-4 {
  margin-left: 1.5rem !important;
}

.ms-5 {
  margin-left: 3rem !important;
}

.ms-auto {
  margin-left: auto !important;
}

.p-0 {
  padding: 0 !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.p-3 {
  padding: 1rem !important;
}

.p-4 {
  padding: 1.5rem !important;
}

.p-5 {
  padding: 3rem !important;
}

.px-0 {
  padding-right: 0 !important;
  padding-left: 0 !important;
}

.px-1 {
  padding-right: 0.25rem !important;
  padding-left: 0.25rem !important;
}

.px-2 {
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
}

.px-3 {
  padding-right: 1rem !important;
  padding-left: 1rem !important;
}

.px-4 {
  padding-right: 1.5rem !important;
  padding-left: 1.5rem !important;
}

.px-5 {
  padding-right: 3rem !important;
  padding-left: 3rem !important;
}

.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}

.py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

.py-3 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}

.py-4 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}

.py-5 {
  padding-top: 3rem !important;
  padding-bottom: 3rem !important;
}

.pt-0 {
  padding-top: 0 !important;
}

.pt-1 {
  padding-top: 0.25rem !important;
}

.pt-2 {
  padding-top: 0.5rem !important;
}

.pt-3 {
  padding-top: 1rem !important;
}

.pt-4 {
  padding-top: 1.5rem !important;
}

.pt-5 {
  padding-top: 3rem !important;
}

.pe-0 {
  padding-right: 0 !important;
}

.pe-1 {
  padding-right: 0.25rem !important;
}

.pe-2 {
  padding-right: 0.5rem !important;
}

.pe-3 {
  padding-right: 1rem !important;
}

.pe-4 {
  padding-right: 1.5rem !important;
}

.pe-5 {
  padding-right: 3rem !important;
}

.pb-0 {
  padding-bottom: 0 !important;
}

.pb-1 {
  padding-bottom: 0.25rem !important;
}

.pb-2 {
  padding-bottom: 0.5rem !important;
}

.pb-3 {
  padding-bottom: 1rem !important;
}

.pb-4 {
  padding-bottom: 1.5rem !important;
}

.pb-5 {
  padding-bottom: 3rem !important;
}

.ps-0 {
  padding-left: 0 !important;
}

.ps-1 {
  padding-left: 0.25rem !important;
}

.ps-2 {
  padding-left: 0.5rem !important;
}

.ps-3 {
  padding-left: 1rem !important;
}

.ps-4 {
  padding-left: 1.5rem !important;
}

.ps-5 {
  padding-left: 3rem !important;
}

.gap-0 {
  gap: 0 !important;
}

.gap-1 {
  gap: 0.25rem !important;
}

.gap-2 {
  gap: 0.5rem !important;
}

.gap-3 {
  gap: 1rem !important;
}

.gap-4 {
  gap: 1.5rem !important;
}

.gap-5 {
  gap: 3rem !important;
}

.row-gap-0 {
  row-gap: 0 !important;
}

.row-gap-1 {
  row-gap: 0.25rem !important;
}

.row-gap-2 {
  row-gap: 0.5rem !important;
}

.row-gap-3 {
  row-gap: 1rem !important;
}

.row-gap-4 {
  row-gap: 1.5rem !important;
}

.row-gap-5 {
  row-gap: 3rem !important;
}

.column-gap-0 {
  column-gap: 0 !important;
}

.column-gap-1 {
  column-gap: 0.25rem !important;
}

.column-gap-2 {
  column-gap: 0.5rem !important;
}

.column-gap-3 {
  column-gap: 1rem !important;
}

.column-gap-4 {
  column-gap: 1.5rem !important;
}

.column-gap-5 {
  column-gap: 3rem !important;
}

.font-monospace {
  font-family: var(--bs-font-monospace) !important;
}

.fs-1 {
  font-size: calc(1.375rem + 1.5vw) !important;
}

.fs-2 {
  font-size: calc(1.325rem + 0.9vw) !important;
}

.fs-3 {
  font-size: calc(1.3rem + 0.6vw) !important;
}

.fs-4 {
  font-size: calc(1.275rem + 0.3vw) !important;
}

.fs-5 {
  font-size: 1.25rem !important;
}

.fs-6 {
  font-size: 1rem !important;
}

.fst-italic {
  font-style: italic !important;
}

.fst-normal {
  font-style: normal !important;
}

.fw-lighter {
  font-weight: lighter !important;
}

.fw-light {
  font-weight: 300 !important;
}

.fw-normal {
  font-weight: 400 !important;
}

.fw-medium {
  font-weight: 500 !important;
}

.fw-semibold {
  font-weight: 600 !important;
}

.fw-bold {
  font-weight: 700 !important;
}

.fw-bolder {
  font-weight: bolder !important;
}

.lh-1 {
  line-height: 1 !important;
}

.lh-sm {
  line-height: 1.25 !important;
}

.lh-base {
  line-height: 1.5 !important;
}

.lh-lg {
  line-height: 2 !important;
}

.text-start {
  text-align: left !important;
}

.text-end {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-decoration-underline {
  text-decoration: underline !important;
}

.text-decoration-line-through {
  text-decoration: line-through !important;
}

.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

/* rtl:begin:remove */
.text-break {
  word-wrap: break-word !important;
  word-break: break-word !important;
}

/* rtl:end:remove */
.text-primary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important;
}

.text-secondary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important;
}

.text-success {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important;
}

.text-info {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important;
}

.text-warning {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important;
}

.text-danger {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important;
}

.text-light {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important;
}

.text-dark {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important;
}

.text-black {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important;
}

.text-white {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important;
}

.text-body {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important;
}

.text-muted {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important;
}

.text-black-50 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, 0.5) !important;
}

.text-white-50 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-body-secondary {
  --bs-text-opacity: 1;
  color: var(--bs-secondary-color) !important;
}

.text-body-tertiary {
  --bs-text-opacity: 1;
  color: var(--bs-tertiary-color) !important;
}

.text-body-emphasis {
  --bs-text-opacity: 1;
  color: var(--bs-emphasis-color) !important;
}

.text-reset {
  --bs-text-opacity: 1;
  color: inherit !important;
}

.text-opacity-25 {
  --bs-text-opacity: 0.25;
}

.text-opacity-50 {
  --bs-text-opacity: 0.5;
}

.text-opacity-75 {
  --bs-text-opacity: 0.75;
}

.text-opacity-100 {
  --bs-text-opacity: 1;
}

.text-primary-emphasis {
  color: var(--bs-primary-text-emphasis) !important;
}

.text-secondary-emphasis {
  color: var(--bs-secondary-text-emphasis) !important;
}

.text-success-emphasis {
  color: var(--bs-success-text-emphasis) !important;
}

.text-info-emphasis {
  color: var(--bs-info-text-emphasis) !important;
}

.text-warning-emphasis {
  color: var(--bs-warning-text-emphasis) !important;
}

.text-danger-emphasis {
  color: var(--bs-danger-text-emphasis) !important;
}

.text-light-emphasis {
  color: var(--bs-light-text-emphasis) !important;
}

.text-dark-emphasis {
  color: var(--bs-dark-text-emphasis) !important;
}

.link-opacity-10 {
  --bs-link-opacity: 0.1;
}

.link-opacity-10-hover:hover {
  --bs-link-opacity: 0.1;
}

.link-opacity-25 {
  --bs-link-opacity: 0.25;
}

.link-opacity-25-hover:hover {
  --bs-link-opacity: 0.25;
}

.link-opacity-50 {
  --bs-link-opacity: 0.5;
}

.link-opacity-50-hover:hover {
  --bs-link-opacity: 0.5;
}

.link-opacity-75 {
  --bs-link-opacity: 0.75;
}

.link-opacity-75-hover:hover {
  --bs-link-opacity: 0.75;
}

.link-opacity-100 {
  --bs-link-opacity: 1;
}

.link-opacity-100-hover:hover {
  --bs-link-opacity: 1;
}

.link-offset-1 {
  text-underline-offset: 0.125em !important;
}

.link-offset-1-hover:hover {
  text-underline-offset: 0.125em !important;
}

.link-offset-2 {
  text-underline-offset: 0.25em !important;
}

.link-offset-2-hover:hover {
  text-underline-offset: 0.25em !important;
}

.link-offset-3 {
  text-underline-offset: 0.375em !important;
}

.link-offset-3-hover:hover {
  text-underline-offset: 0.375em !important;
}

.link-underline-primary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-primary-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-secondary {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-secondary-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-success {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-success-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-info {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-info-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-warning {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-warning-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-danger {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-danger-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-light {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-light-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline-dark {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-dark-rgb), var(--bs-link-underline-opacity)) !important;
}

.link-underline {
  --bs-link-underline-opacity: 1;
  text-decoration-color: rgba(var(--bs-link-color-rgb), var(--bs-link-underline-opacity, 1)) !important;
}

.link-underline-opacity-0 {
  --bs-link-underline-opacity: 0;
}

.link-underline-opacity-0-hover:hover {
  --bs-link-underline-opacity: 0;
}

.link-underline-opacity-10 {
  --bs-link-underline-opacity: 0.1;
}

.link-underline-opacity-10-hover:hover {
  --bs-link-underline-opacity: 0.1;
}

.link-underline-opacity-25 {
  --bs-link-underline-opacity: 0.25;
}

.link-underline-opacity-25-hover:hover {
  --bs-link-underline-opacity: 0.25;
}

.link-underline-opacity-50 {
  --bs-link-underline-opacity: 0.5;
}

.link-underline-opacity-50-hover:hover {
  --bs-link-underline-opacity: 0.5;
}

.link-underline-opacity-75 {
  --bs-link-underline-opacity: 0.75;
}

.link-underline-opacity-75-hover:hover {
  --bs-link-underline-opacity: 0.75;
}

.link-underline-opacity-100 {
  --bs-link-underline-opacity: 1;
}

.link-underline-opacity-100-hover:hover {
  --bs-link-underline-opacity: 1;
}

.bg-primary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-primary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-rgb), var(--bs-bg-opacity)) !important;
}

.bg-success {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-success-rgb), var(--bs-bg-opacity)) !important;
}

.bg-info {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-info-rgb), var(--bs-bg-opacity)) !important;
}

.bg-warning {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-warning-rgb), var(--bs-bg-opacity)) !important;
}

.bg-danger {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-danger-rgb), var(--bs-bg-opacity)) !important;
}

.bg-light {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important;
}

.bg-dark {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important;
}

.bg-black {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important;
}

.bg-white {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-transparent {
  --bs-bg-opacity: 1;
  background-color: transparent !important;
}

.bg-body-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-body-tertiary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-tertiary-bg-rgb), var(--bs-bg-opacity)) !important;
}

.bg-opacity-10 {
  --bs-bg-opacity: 0.1;
}

.bg-opacity-25 {
  --bs-bg-opacity: 0.25;
}

.bg-opacity-50 {
  --bs-bg-opacity: 0.5;
}

.bg-opacity-75 {
  --bs-bg-opacity: 0.75;
}

.bg-opacity-100 {
  --bs-bg-opacity: 1;
}

.bg-primary-subtle {
  background-color: var(--bs-primary-bg-subtle) !important;
}

.bg-secondary-subtle {
  background-color: var(--bs-secondary-bg-subtle) !important;
}

.bg-success-subtle {
  background-color: var(--bs-success-bg-subtle) !important;
}

.bg-info-subtle {
  background-color: var(--bs-info-bg-subtle) !important;
}

.bg-warning-subtle {
  background-color: var(--bs-warning-bg-subtle) !important;
}

.bg-danger-subtle {
  background-color: var(--bs-danger-bg-subtle) !important;
}

.bg-light-subtle {
  background-color: var(--bs-light-bg-subtle) !important;
}

.bg-dark-subtle {
  background-color: var(--bs-dark-bg-subtle) !important;
}

.bg-gradient {
  background-image: var(--bs-gradient) !important;
}

.user-select-all {
  -webkit-user-select: all !important;
          user-select: all !important;
}

.user-select-auto {
  -webkit-user-select: auto !important;
          user-select: auto !important;
}

.user-select-none {
  -webkit-user-select: none !important;
          user-select: none !important;
}

.pe-none {
  pointer-events: none !important;
}

.pe-auto {
  pointer-events: auto !important;
}

.rounded {
  border-radius: var(--bs-border-radius) !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.rounded-1 {
  border-radius: var(--bs-border-radius-sm) !important;
}

.rounded-2 {
  border-radius: var(--bs-border-radius) !important;
}

.rounded-3 {
  border-radius: var(--bs-border-radius-lg) !important;
}

.rounded-4 {
  border-radius: var(--bs-border-radius-xl) !important;
}

.rounded-5 {
  border-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: var(--bs-border-radius-pill) !important;
}

.rounded-top {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-0 {
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

.rounded-top-1 {
  border-top-left-radius: var(--bs-border-radius-sm) !important;
  border-top-right-radius: var(--bs-border-radius-sm) !important;
}

.rounded-top-2 {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important;
}

.rounded-top-3 {
  border-top-left-radius: var(--bs-border-radius-lg) !important;
  border-top-right-radius: var(--bs-border-radius-lg) !important;
}

.rounded-top-4 {
  border-top-left-radius: var(--bs-border-radius-xl) !important;
  border-top-right-radius: var(--bs-border-radius-xl) !important;
}

.rounded-top-5 {
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-top-circle {
  border-top-left-radius: 50% !important;
  border-top-right-radius: 50% !important;
}

.rounded-top-pill {
  border-top-left-radius: var(--bs-border-radius-pill) !important;
  border-top-right-radius: var(--bs-border-radius-pill) !important;
}

.rounded-end {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-end-0 {
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.rounded-end-1 {
  border-top-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
}

.rounded-end-2 {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important;
}

.rounded-end-3 {
  border-top-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
}

.rounded-end-4 {
  border-top-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
}

.rounded-end-5 {
  border-top-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-end-circle {
  border-top-right-radius: 50% !important;
  border-bottom-right-radius: 50% !important;
}

.rounded-end-pill {
  border-top-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
}

.rounded-bottom {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-0 {
  border-bottom-right-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}

.rounded-bottom-1 {
  border-bottom-right-radius: var(--bs-border-radius-sm) !important;
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
}

.rounded-bottom-2 {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important;
}

.rounded-bottom-3 {
  border-bottom-right-radius: var(--bs-border-radius-lg) !important;
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
}

.rounded-bottom-4 {
  border-bottom-right-radius: var(--bs-border-radius-xl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
}

.rounded-bottom-5 {
  border-bottom-right-radius: var(--bs-border-radius-xxl) !important;
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-bottom-circle {
  border-bottom-right-radius: 50% !important;
  border-bottom-left-radius: 50% !important;
}

.rounded-bottom-pill {
  border-bottom-right-radius: var(--bs-border-radius-pill) !important;
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
}

.rounded-start {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}

.rounded-start-0 {
  border-bottom-left-radius: 0 !important;
  border-top-left-radius: 0 !important;
}

.rounded-start-1 {
  border-bottom-left-radius: var(--bs-border-radius-sm) !important;
  border-top-left-radius: var(--bs-border-radius-sm) !important;
}

.rounded-start-2 {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important;
}

.rounded-start-3 {
  border-bottom-left-radius: var(--bs-border-radius-lg) !important;
  border-top-left-radius: var(--bs-border-radius-lg) !important;
}

.rounded-start-4 {
  border-bottom-left-radius: var(--bs-border-radius-xl) !important;
  border-top-left-radius: var(--bs-border-radius-xl) !important;
}

.rounded-start-5 {
  border-bottom-left-radius: var(--bs-border-radius-xxl) !important;
  border-top-left-radius: var(--bs-border-radius-xxl) !important;
}

.rounded-start-circle {
  border-bottom-left-radius: 50% !important;
  border-top-left-radius: 50% !important;
}

.rounded-start-pill {
  border-bottom-left-radius: var(--bs-border-radius-pill) !important;
  border-top-left-radius: var(--bs-border-radius-pill) !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

.z-n1 {
  z-index: -1 !important;
}

.z-0 {
  z-index: 0 !important;
}

.z-1 {
  z-index: 1 !important;
}

.z-2 {
  z-index: 2 !important;
}

.z-3 {
  z-index: 3 !important;
}

@media (min-width: 576px) {
  .float-sm-start {
    float: left !important;
  }
  .float-sm-end {
    float: right !important;
  }
  .float-sm-none {
    float: none !important;
  }
  .object-fit-sm-contain {
    object-fit: contain !important;
  }
  .object-fit-sm-cover {
    object-fit: cover !important;
  }
  .object-fit-sm-fill {
    object-fit: fill !important;
  }
  .object-fit-sm-scale {
    object-fit: scale-down !important;
  }
  .object-fit-sm-none {
    object-fit: none !important;
  }
  .d-sm-inline {
    display: inline !important;
  }
  .d-sm-inline-block {
    display: inline-block !important;
  }
  .d-sm-block {
    display: block !important;
  }
  .d-sm-grid {
    display: grid !important;
  }
  .d-sm-inline-grid {
    display: inline-grid !important;
  }
  .d-sm-table {
    display: table !important;
  }
  .d-sm-table-row {
    display: table-row !important;
  }
  .d-sm-table-cell {
    display: table-cell !important;
  }
  .d-sm-flex {
    display: flex !important;
  }
  .d-sm-inline-flex {
    display: inline-flex !important;
  }
  .d-sm-none {
    display: none !important;
  }
  .flex-sm-fill {
    flex: 1 1 auto !important;
  }
  .flex-sm-row {
    flex-direction: row !important;
  }
  .flex-sm-column {
    flex-direction: column !important;
  }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-sm-start {
    justify-content: flex-start !important;
  }
  .justify-content-sm-end {
    justify-content: flex-end !important;
  }
  .justify-content-sm-center {
    justify-content: center !important;
  }
  .justify-content-sm-between {
    justify-content: space-between !important;
  }
  .justify-content-sm-around {
    justify-content: space-around !important;
  }
  .justify-content-sm-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-sm-start {
    align-items: flex-start !important;
  }
  .align-items-sm-end {
    align-items: flex-end !important;
  }
  .align-items-sm-center {
    align-items: center !important;
  }
  .align-items-sm-baseline {
    align-items: baseline !important;
  }
  .align-items-sm-stretch {
    align-items: stretch !important;
  }
  .align-content-sm-start {
    align-content: flex-start !important;
  }
  .align-content-sm-end {
    align-content: flex-end !important;
  }
  .align-content-sm-center {
    align-content: center !important;
  }
  .align-content-sm-between {
    align-content: space-between !important;
  }
  .align-content-sm-around {
    align-content: space-around !important;
  }
  .align-content-sm-stretch {
    align-content: stretch !important;
  }
  .align-self-sm-auto {
    align-self: auto !important;
  }
  .align-self-sm-start {
    align-self: flex-start !important;
  }
  .align-self-sm-end {
    align-self: flex-end !important;
  }
  .align-self-sm-center {
    align-self: center !important;
  }
  .align-self-sm-baseline {
    align-self: baseline !important;
  }
  .align-self-sm-stretch {
    align-self: stretch !important;
  }
  .order-sm-first {
    order: -1 !important;
  }
  .order-sm-0 {
    order: 0 !important;
  }
  .order-sm-1 {
    order: 1 !important;
  }
  .order-sm-2 {
    order: 2 !important;
  }
  .order-sm-3 {
    order: 3 !important;
  }
  .order-sm-4 {
    order: 4 !important;
  }
  .order-sm-5 {
    order: 5 !important;
  }
  .order-sm-last {
    order: 6 !important;
  }
  .m-sm-0 {
    margin: 0 !important;
  }
  .m-sm-1 {
    margin: 0.25rem !important;
  }
  .m-sm-2 {
    margin: 0.5rem !important;
  }
  .m-sm-3 {
    margin: 1rem !important;
  }
  .m-sm-4 {
    margin: 1.5rem !important;
  }
  .m-sm-5 {
    margin: 3rem !important;
  }
  .m-sm-auto {
    margin: auto !important;
  }
  .mx-sm-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-sm-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-sm-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-sm-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-sm-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-sm-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-sm-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-sm-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-sm-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-sm-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-sm-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-sm-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-sm-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-sm-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-sm-0 {
    margin-top: 0 !important;
  }
  .mt-sm-1 {
    margin-top: 0.25rem !important;
  }
  .mt-sm-2 {
    margin-top: 0.5rem !important;
  }
  .mt-sm-3 {
    margin-top: 1rem !important;
  }
  .mt-sm-4 {
    margin-top: 1.5rem !important;
  }
  .mt-sm-5 {
    margin-top: 3rem !important;
  }
  .mt-sm-auto {
    margin-top: auto !important;
  }
  .me-sm-0 {
    margin-right: 0 !important;
  }
  .me-sm-1 {
    margin-right: 0.25rem !important;
  }
  .me-sm-2 {
    margin-right: 0.5rem !important;
  }
  .me-sm-3 {
    margin-right: 1rem !important;
  }
  .me-sm-4 {
    margin-right: 1.5rem !important;
  }
  .me-sm-5 {
    margin-right: 3rem !important;
  }
  .me-sm-auto {
    margin-right: auto !important;
  }
  .mb-sm-0 {
    margin-bottom: 0 !important;
  }
  .mb-sm-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-sm-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-sm-3 {
    margin-bottom: 1rem !important;
  }
  .mb-sm-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-sm-5 {
    margin-bottom: 3rem !important;
  }
  .mb-sm-auto {
    margin-bottom: auto !important;
  }
  .ms-sm-0 {
    margin-left: 0 !important;
  }
  .ms-sm-1 {
    margin-left: 0.25rem !important;
  }
  .ms-sm-2 {
    margin-left: 0.5rem !important;
  }
  .ms-sm-3 {
    margin-left: 1rem !important;
  }
  .ms-sm-4 {
    margin-left: 1.5rem !important;
  }
  .ms-sm-5 {
    margin-left: 3rem !important;
  }
  .ms-sm-auto {
    margin-left: auto !important;
  }
  .p-sm-0 {
    padding: 0 !important;
  }
  .p-sm-1 {
    padding: 0.25rem !important;
  }
  .p-sm-2 {
    padding: 0.5rem !important;
  }
  .p-sm-3 {
    padding: 1rem !important;
  }
  .p-sm-4 {
    padding: 1.5rem !important;
  }
  .p-sm-5 {
    padding: 3rem !important;
  }
  .px-sm-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-sm-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-sm-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-sm-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-sm-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-sm-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-sm-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-sm-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-sm-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-sm-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-sm-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-sm-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-sm-0 {
    padding-top: 0 !important;
  }
  .pt-sm-1 {
    padding-top: 0.25rem !important;
  }
  .pt-sm-2 {
    padding-top: 0.5rem !important;
  }
  .pt-sm-3 {
    padding-top: 1rem !important;
  }
  .pt-sm-4 {
    padding-top: 1.5rem !important;
  }
  .pt-sm-5 {
    padding-top: 3rem !important;
  }
  .pe-sm-0 {
    padding-right: 0 !important;
  }
  .pe-sm-1 {
    padding-right: 0.25rem !important;
  }
  .pe-sm-2 {
    padding-right: 0.5rem !important;
  }
  .pe-sm-3 {
    padding-right: 1rem !important;
  }
  .pe-sm-4 {
    padding-right: 1.5rem !important;
  }
  .pe-sm-5 {
    padding-right: 3rem !important;
  }
  .pb-sm-0 {
    padding-bottom: 0 !important;
  }
  .pb-sm-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-sm-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-sm-3 {
    padding-bottom: 1rem !important;
  }
  .pb-sm-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-sm-5 {
    padding-bottom: 3rem !important;
  }
  .ps-sm-0 {
    padding-left: 0 !important;
  }
  .ps-sm-1 {
    padding-left: 0.25rem !important;
  }
  .ps-sm-2 {
    padding-left: 0.5rem !important;
  }
  .ps-sm-3 {
    padding-left: 1rem !important;
  }
  .ps-sm-4 {
    padding-left: 1.5rem !important;
  }
  .ps-sm-5 {
    padding-left: 3rem !important;
  }
  .gap-sm-0 {
    gap: 0 !important;
  }
  .gap-sm-1 {
    gap: 0.25rem !important;
  }
  .gap-sm-2 {
    gap: 0.5rem !important;
  }
  .gap-sm-3 {
    gap: 1rem !important;
  }
  .gap-sm-4 {
    gap: 1.5rem !important;
  }
  .gap-sm-5 {
    gap: 3rem !important;
  }
  .row-gap-sm-0 {
    row-gap: 0 !important;
  }
  .row-gap-sm-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-sm-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-sm-3 {
    row-gap: 1rem !important;
  }
  .row-gap-sm-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-sm-5 {
    row-gap: 3rem !important;
  }
  .column-gap-sm-0 {
    column-gap: 0 !important;
  }
  .column-gap-sm-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-sm-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-sm-3 {
    column-gap: 1rem !important;
  }
  .column-gap-sm-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-sm-5 {
    column-gap: 3rem !important;
  }
  .text-sm-start {
    text-align: left !important;
  }
  .text-sm-end {
    text-align: right !important;
  }
  .text-sm-center {
    text-align: center !important;
  }
}
@media (min-width: 768px) {
  .float-md-start {
    float: left !important;
  }
  .float-md-end {
    float: right !important;
  }
  .float-md-none {
    float: none !important;
  }
  .object-fit-md-contain {
    object-fit: contain !important;
  }
  .object-fit-md-cover {
    object-fit: cover !important;
  }
  .object-fit-md-fill {
    object-fit: fill !important;
  }
  .object-fit-md-scale {
    object-fit: scale-down !important;
  }
  .object-fit-md-none {
    object-fit: none !important;
  }
  .d-md-inline {
    display: inline !important;
  }
  .d-md-inline-block {
    display: inline-block !important;
  }
  .d-md-block {
    display: block !important;
  }
  .d-md-grid {
    display: grid !important;
  }
  .d-md-inline-grid {
    display: inline-grid !important;
  }
  .d-md-table {
    display: table !important;
  }
  .d-md-table-row {
    display: table-row !important;
  }
  .d-md-table-cell {
    display: table-cell !important;
  }
  .d-md-flex {
    display: flex !important;
  }
  .d-md-inline-flex {
    display: inline-flex !important;
  }
  .d-md-none {
    display: none !important;
  }
  .flex-md-fill {
    flex: 1 1 auto !important;
  }
  .flex-md-row {
    flex-direction: row !important;
  }
  .flex-md-column {
    flex-direction: column !important;
  }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-md-wrap {
    flex-wrap: wrap !important;
  }
  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-md-start {
    justify-content: flex-start !important;
  }
  .justify-content-md-end {
    justify-content: flex-end !important;
  }
  .justify-content-md-center {
    justify-content: center !important;
  }
  .justify-content-md-between {
    justify-content: space-between !important;
  }
  .justify-content-md-around {
    justify-content: space-around !important;
  }
  .justify-content-md-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-md-start {
    align-items: flex-start !important;
  }
  .align-items-md-end {
    align-items: flex-end !important;
  }
  .align-items-md-center {
    align-items: center !important;
  }
  .align-items-md-baseline {
    align-items: baseline !important;
  }
  .align-items-md-stretch {
    align-items: stretch !important;
  }
  .align-content-md-start {
    align-content: flex-start !important;
  }
  .align-content-md-end {
    align-content: flex-end !important;
  }
  .align-content-md-center {
    align-content: center !important;
  }
  .align-content-md-between {
    align-content: space-between !important;
  }
  .align-content-md-around {
    align-content: space-around !important;
  }
  .align-content-md-stretch {
    align-content: stretch !important;
  }
  .align-self-md-auto {
    align-self: auto !important;
  }
  .align-self-md-start {
    align-self: flex-start !important;
  }
  .align-self-md-end {
    align-self: flex-end !important;
  }
  .align-self-md-center {
    align-self: center !important;
  }
  .align-self-md-baseline {
    align-self: baseline !important;
  }
  .align-self-md-stretch {
    align-self: stretch !important;
  }
  .order-md-first {
    order: -1 !important;
  }
  .order-md-0 {
    order: 0 !important;
  }
  .order-md-1 {
    order: 1 !important;
  }
  .order-md-2 {
    order: 2 !important;
  }
  .order-md-3 {
    order: 3 !important;
  }
  .order-md-4 {
    order: 4 !important;
  }
  .order-md-5 {
    order: 5 !important;
  }
  .order-md-last {
    order: 6 !important;
  }
  .m-md-0 {
    margin: 0 !important;
  }
  .m-md-1 {
    margin: 0.25rem !important;
  }
  .m-md-2 {
    margin: 0.5rem !important;
  }
  .m-md-3 {
    margin: 1rem !important;
  }
  .m-md-4 {
    margin: 1.5rem !important;
  }
  .m-md-5 {
    margin: 3rem !important;
  }
  .m-md-auto {
    margin: auto !important;
  }
  .mx-md-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-md-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-md-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-md-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-md-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-md-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-md-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-md-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-md-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-md-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-md-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-md-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-md-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-md-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-md-0 {
    margin-top: 0 !important;
  }
  .mt-md-1 {
    margin-top: 0.25rem !important;
  }
  .mt-md-2 {
    margin-top: 0.5rem !important;
  }
  .mt-md-3 {
    margin-top: 1rem !important;
  }
  .mt-md-4 {
    margin-top: 1.5rem !important;
  }
  .mt-md-5 {
    margin-top: 3rem !important;
  }
  .mt-md-auto {
    margin-top: auto !important;
  }
  .me-md-0 {
    margin-right: 0 !important;
  }
  .me-md-1 {
    margin-right: 0.25rem !important;
  }
  .me-md-2 {
    margin-right: 0.5rem !important;
  }
  .me-md-3 {
    margin-right: 1rem !important;
  }
  .me-md-4 {
    margin-right: 1.5rem !important;
  }
  .me-md-5 {
    margin-right: 3rem !important;
  }
  .me-md-auto {
    margin-right: auto !important;
  }
  .mb-md-0 {
    margin-bottom: 0 !important;
  }
  .mb-md-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-md-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-md-3 {
    margin-bottom: 1rem !important;
  }
  .mb-md-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-md-5 {
    margin-bottom: 3rem !important;
  }
  .mb-md-auto {
    margin-bottom: auto !important;
  }
  .ms-md-0 {
    margin-left: 0 !important;
  }
  .ms-md-1 {
    margin-left: 0.25rem !important;
  }
  .ms-md-2 {
    margin-left: 0.5rem !important;
  }
  .ms-md-3 {
    margin-left: 1rem !important;
  }
  .ms-md-4 {
    margin-left: 1.5rem !important;
  }
  .ms-md-5 {
    margin-left: 3rem !important;
  }
  .ms-md-auto {
    margin-left: auto !important;
  }
  .p-md-0 {
    padding: 0 !important;
  }
  .p-md-1 {
    padding: 0.25rem !important;
  }
  .p-md-2 {
    padding: 0.5rem !important;
  }
  .p-md-3 {
    padding: 1rem !important;
  }
  .p-md-4 {
    padding: 1.5rem !important;
  }
  .p-md-5 {
    padding: 3rem !important;
  }
  .px-md-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-md-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-md-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-md-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-md-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-md-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-md-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-md-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-md-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-md-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-md-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-md-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-md-0 {
    padding-top: 0 !important;
  }
  .pt-md-1 {
    padding-top: 0.25rem !important;
  }
  .pt-md-2 {
    padding-top: 0.5rem !important;
  }
  .pt-md-3 {
    padding-top: 1rem !important;
  }
  .pt-md-4 {
    padding-top: 1.5rem !important;
  }
  .pt-md-5 {
    padding-top: 3rem !important;
  }
  .pe-md-0 {
    padding-right: 0 !important;
  }
  .pe-md-1 {
    padding-right: 0.25rem !important;
  }
  .pe-md-2 {
    padding-right: 0.5rem !important;
  }
  .pe-md-3 {
    padding-right: 1rem !important;
  }
  .pe-md-4 {
    padding-right: 1.5rem !important;
  }
  .pe-md-5 {
    padding-right: 3rem !important;
  }
  .pb-md-0 {
    padding-bottom: 0 !important;
  }
  .pb-md-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-md-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-md-3 {
    padding-bottom: 1rem !important;
  }
  .pb-md-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-md-5 {
    padding-bottom: 3rem !important;
  }
  .ps-md-0 {
    padding-left: 0 !important;
  }
  .ps-md-1 {
    padding-left: 0.25rem !important;
  }
  .ps-md-2 {
    padding-left: 0.5rem !important;
  }
  .ps-md-3 {
    padding-left: 1rem !important;
  }
  .ps-md-4 {
    padding-left: 1.5rem !important;
  }
  .ps-md-5 {
    padding-left: 3rem !important;
  }
  .gap-md-0 {
    gap: 0 !important;
  }
  .gap-md-1 {
    gap: 0.25rem !important;
  }
  .gap-md-2 {
    gap: 0.5rem !important;
  }
  .gap-md-3 {
    gap: 1rem !important;
  }
  .gap-md-4 {
    gap: 1.5rem !important;
  }
  .gap-md-5 {
    gap: 3rem !important;
  }
  .row-gap-md-0 {
    row-gap: 0 !important;
  }
  .row-gap-md-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-md-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-md-3 {
    row-gap: 1rem !important;
  }
  .row-gap-md-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-md-5 {
    row-gap: 3rem !important;
  }
  .column-gap-md-0 {
    column-gap: 0 !important;
  }
  .column-gap-md-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-md-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-md-3 {
    column-gap: 1rem !important;
  }
  .column-gap-md-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-md-5 {
    column-gap: 3rem !important;
  }
  .text-md-start {
    text-align: left !important;
  }
  .text-md-end {
    text-align: right !important;
  }
  .text-md-center {
    text-align: center !important;
  }
}
@media (min-width: 992px) {
  .float-lg-start {
    float: left !important;
  }
  .float-lg-end {
    float: right !important;
  }
  .float-lg-none {
    float: none !important;
  }
  .object-fit-lg-contain {
    object-fit: contain !important;
  }
  .object-fit-lg-cover {
    object-fit: cover !important;
  }
  .object-fit-lg-fill {
    object-fit: fill !important;
  }
  .object-fit-lg-scale {
    object-fit: scale-down !important;
  }
  .object-fit-lg-none {
    object-fit: none !important;
  }
  .d-lg-inline {
    display: inline !important;
  }
  .d-lg-inline-block {
    display: inline-block !important;
  }
  .d-lg-block {
    display: block !important;
  }
  .d-lg-grid {
    display: grid !important;
  }
  .d-lg-inline-grid {
    display: inline-grid !important;
  }
  .d-lg-table {
    display: table !important;
  }
  .d-lg-table-row {
    display: table-row !important;
  }
  .d-lg-table-cell {
    display: table-cell !important;
  }
  .d-lg-flex {
    display: flex !important;
  }
  .d-lg-inline-flex {
    display: inline-flex !important;
  }
  .d-lg-none {
    display: none !important;
  }
  .flex-lg-fill {
    flex: 1 1 auto !important;
  }
  .flex-lg-row {
    flex-direction: row !important;
  }
  .flex-lg-column {
    flex-direction: column !important;
  }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-lg-start {
    justify-content: flex-start !important;
  }
  .justify-content-lg-end {
    justify-content: flex-end !important;
  }
  .justify-content-lg-center {
    justify-content: center !important;
  }
  .justify-content-lg-between {
    justify-content: space-between !important;
  }
  .justify-content-lg-around {
    justify-content: space-around !important;
  }
  .justify-content-lg-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-lg-start {
    align-items: flex-start !important;
  }
  .align-items-lg-end {
    align-items: flex-end !important;
  }
  .align-items-lg-center {
    align-items: center !important;
  }
  .align-items-lg-baseline {
    align-items: baseline !important;
  }
  .align-items-lg-stretch {
    align-items: stretch !important;
  }
  .align-content-lg-start {
    align-content: flex-start !important;
  }
  .align-content-lg-end {
    align-content: flex-end !important;
  }
  .align-content-lg-center {
    align-content: center !important;
  }
  .align-content-lg-between {
    align-content: space-between !important;
  }
  .align-content-lg-around {
    align-content: space-around !important;
  }
  .align-content-lg-stretch {
    align-content: stretch !important;
  }
  .align-self-lg-auto {
    align-self: auto !important;
  }
  .align-self-lg-start {
    align-self: flex-start !important;
  }
  .align-self-lg-end {
    align-self: flex-end !important;
  }
  .align-self-lg-center {
    align-self: center !important;
  }
  .align-self-lg-baseline {
    align-self: baseline !important;
  }
  .align-self-lg-stretch {
    align-self: stretch !important;
  }
  .order-lg-first {
    order: -1 !important;
  }
  .order-lg-0 {
    order: 0 !important;
  }
  .order-lg-1 {
    order: 1 !important;
  }
  .order-lg-2 {
    order: 2 !important;
  }
  .order-lg-3 {
    order: 3 !important;
  }
  .order-lg-4 {
    order: 4 !important;
  }
  .order-lg-5 {
    order: 5 !important;
  }
  .order-lg-last {
    order: 6 !important;
  }
  .m-lg-0 {
    margin: 0 !important;
  }
  .m-lg-1 {
    margin: 0.25rem !important;
  }
  .m-lg-2 {
    margin: 0.5rem !important;
  }
  .m-lg-3 {
    margin: 1rem !important;
  }
  .m-lg-4 {
    margin: 1.5rem !important;
  }
  .m-lg-5 {
    margin: 3rem !important;
  }
  .m-lg-auto {
    margin: auto !important;
  }
  .mx-lg-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-lg-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-lg-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-lg-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-lg-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-lg-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-lg-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-lg-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-lg-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-lg-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-lg-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-lg-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-lg-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-lg-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-lg-0 {
    margin-top: 0 !important;
  }
  .mt-lg-1 {
    margin-top: 0.25rem !important;
  }
  .mt-lg-2 {
    margin-top: 0.5rem !important;
  }
  .mt-lg-3 {
    margin-top: 1rem !important;
  }
  .mt-lg-4 {
    margin-top: 1.5rem !important;
  }
  .mt-lg-5 {
    margin-top: 3rem !important;
  }
  .mt-lg-auto {
    margin-top: auto !important;
  }
  .me-lg-0 {
    margin-right: 0 !important;
  }
  .me-lg-1 {
    margin-right: 0.25rem !important;
  }
  .me-lg-2 {
    margin-right: 0.5rem !important;
  }
  .me-lg-3 {
    margin-right: 1rem !important;
  }
  .me-lg-4 {
    margin-right: 1.5rem !important;
  }
  .me-lg-5 {
    margin-right: 3rem !important;
  }
  .me-lg-auto {
    margin-right: auto !important;
  }
  .mb-lg-0 {
    margin-bottom: 0 !important;
  }
  .mb-lg-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-lg-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-lg-3 {
    margin-bottom: 1rem !important;
  }
  .mb-lg-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-lg-5 {
    margin-bottom: 3rem !important;
  }
  .mb-lg-auto {
    margin-bottom: auto !important;
  }
  .ms-lg-0 {
    margin-left: 0 !important;
  }
  .ms-lg-1 {
    margin-left: 0.25rem !important;
  }
  .ms-lg-2 {
    margin-left: 0.5rem !important;
  }
  .ms-lg-3 {
    margin-left: 1rem !important;
  }
  .ms-lg-4 {
    margin-left: 1.5rem !important;
  }
  .ms-lg-5 {
    margin-left: 3rem !important;
  }
  .ms-lg-auto {
    margin-left: auto !important;
  }
  .p-lg-0 {
    padding: 0 !important;
  }
  .p-lg-1 {
    padding: 0.25rem !important;
  }
  .p-lg-2 {
    padding: 0.5rem !important;
  }
  .p-lg-3 {
    padding: 1rem !important;
  }
  .p-lg-4 {
    padding: 1.5rem !important;
  }
  .p-lg-5 {
    padding: 3rem !important;
  }
  .px-lg-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-lg-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-lg-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-lg-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-lg-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-lg-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-lg-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-lg-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-lg-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-lg-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-lg-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-lg-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-lg-0 {
    padding-top: 0 !important;
  }
  .pt-lg-1 {
    padding-top: 0.25rem !important;
  }
  .pt-lg-2 {
    padding-top: 0.5rem !important;
  }
  .pt-lg-3 {
    padding-top: 1rem !important;
  }
  .pt-lg-4 {
    padding-top: 1.5rem !important;
  }
  .pt-lg-5 {
    padding-top: 3rem !important;
  }
  .pe-lg-0 {
    padding-right: 0 !important;
  }
  .pe-lg-1 {
    padding-right: 0.25rem !important;
  }
  .pe-lg-2 {
    padding-right: 0.5rem !important;
  }
  .pe-lg-3 {
    padding-right: 1rem !important;
  }
  .pe-lg-4 {
    padding-right: 1.5rem !important;
  }
  .pe-lg-5 {
    padding-right: 3rem !important;
  }
  .pb-lg-0 {
    padding-bottom: 0 !important;
  }
  .pb-lg-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-lg-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-lg-3 {
    padding-bottom: 1rem !important;
  }
  .pb-lg-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-lg-5 {
    padding-bottom: 3rem !important;
  }
  .ps-lg-0 {
    padding-left: 0 !important;
  }
  .ps-lg-1 {
    padding-left: 0.25rem !important;
  }
  .ps-lg-2 {
    padding-left: 0.5rem !important;
  }
  .ps-lg-3 {
    padding-left: 1rem !important;
  }
  .ps-lg-4 {
    padding-left: 1.5rem !important;
  }
  .ps-lg-5 {
    padding-left: 3rem !important;
  }
  .gap-lg-0 {
    gap: 0 !important;
  }
  .gap-lg-1 {
    gap: 0.25rem !important;
  }
  .gap-lg-2 {
    gap: 0.5rem !important;
  }
  .gap-lg-3 {
    gap: 1rem !important;
  }
  .gap-lg-4 {
    gap: 1.5rem !important;
  }
  .gap-lg-5 {
    gap: 3rem !important;
  }
  .row-gap-lg-0 {
    row-gap: 0 !important;
  }
  .row-gap-lg-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-lg-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-lg-3 {
    row-gap: 1rem !important;
  }
  .row-gap-lg-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-lg-5 {
    row-gap: 3rem !important;
  }
  .column-gap-lg-0 {
    column-gap: 0 !important;
  }
  .column-gap-lg-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-lg-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-lg-3 {
    column-gap: 1rem !important;
  }
  .column-gap-lg-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-lg-5 {
    column-gap: 3rem !important;
  }
  .text-lg-start {
    text-align: left !important;
  }
  .text-lg-end {
    text-align: right !important;
  }
  .text-lg-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .float-xl-start {
    float: left !important;
  }
  .float-xl-end {
    float: right !important;
  }
  .float-xl-none {
    float: none !important;
  }
  .object-fit-xl-contain {
    object-fit: contain !important;
  }
  .object-fit-xl-cover {
    object-fit: cover !important;
  }
  .object-fit-xl-fill {
    object-fit: fill !important;
  }
  .object-fit-xl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xl-none {
    object-fit: none !important;
  }
  .d-xl-inline {
    display: inline !important;
  }
  .d-xl-inline-block {
    display: inline-block !important;
  }
  .d-xl-block {
    display: block !important;
  }
  .d-xl-grid {
    display: grid !important;
  }
  .d-xl-inline-grid {
    display: inline-grid !important;
  }
  .d-xl-table {
    display: table !important;
  }
  .d-xl-table-row {
    display: table-row !important;
  }
  .d-xl-table-cell {
    display: table-cell !important;
  }
  .d-xl-flex {
    display: flex !important;
  }
  .d-xl-inline-flex {
    display: inline-flex !important;
  }
  .d-xl-none {
    display: none !important;
  }
  .flex-xl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xl-row {
    flex-direction: row !important;
  }
  .flex-xl-column {
    flex-direction: column !important;
  }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xl-center {
    justify-content: center !important;
  }
  .justify-content-xl-between {
    justify-content: space-between !important;
  }
  .justify-content-xl-around {
    justify-content: space-around !important;
  }
  .justify-content-xl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xl-start {
    align-items: flex-start !important;
  }
  .align-items-xl-end {
    align-items: flex-end !important;
  }
  .align-items-xl-center {
    align-items: center !important;
  }
  .align-items-xl-baseline {
    align-items: baseline !important;
  }
  .align-items-xl-stretch {
    align-items: stretch !important;
  }
  .align-content-xl-start {
    align-content: flex-start !important;
  }
  .align-content-xl-end {
    align-content: flex-end !important;
  }
  .align-content-xl-center {
    align-content: center !important;
  }
  .align-content-xl-between {
    align-content: space-between !important;
  }
  .align-content-xl-around {
    align-content: space-around !important;
  }
  .align-content-xl-stretch {
    align-content: stretch !important;
  }
  .align-self-xl-auto {
    align-self: auto !important;
  }
  .align-self-xl-start {
    align-self: flex-start !important;
  }
  .align-self-xl-end {
    align-self: flex-end !important;
  }
  .align-self-xl-center {
    align-self: center !important;
  }
  .align-self-xl-baseline {
    align-self: baseline !important;
  }
  .align-self-xl-stretch {
    align-self: stretch !important;
  }
  .order-xl-first {
    order: -1 !important;
  }
  .order-xl-0 {
    order: 0 !important;
  }
  .order-xl-1 {
    order: 1 !important;
  }
  .order-xl-2 {
    order: 2 !important;
  }
  .order-xl-3 {
    order: 3 !important;
  }
  .order-xl-4 {
    order: 4 !important;
  }
  .order-xl-5 {
    order: 5 !important;
  }
  .order-xl-last {
    order: 6 !important;
  }
  .m-xl-0 {
    margin: 0 !important;
  }
  .m-xl-1 {
    margin: 0.25rem !important;
  }
  .m-xl-2 {
    margin: 0.5rem !important;
  }
  .m-xl-3 {
    margin: 1rem !important;
  }
  .m-xl-4 {
    margin: 1.5rem !important;
  }
  .m-xl-5 {
    margin: 3rem !important;
  }
  .m-xl-auto {
    margin: auto !important;
  }
  .mx-xl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xl-0 {
    margin-top: 0 !important;
  }
  .mt-xl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xl-3 {
    margin-top: 1rem !important;
  }
  .mt-xl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xl-5 {
    margin-top: 3rem !important;
  }
  .mt-xl-auto {
    margin-top: auto !important;
  }
  .me-xl-0 {
    margin-right: 0 !important;
  }
  .me-xl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xl-3 {
    margin-right: 1rem !important;
  }
  .me-xl-4 {
    margin-right: 1.5rem !important;
  }
  .me-xl-5 {
    margin-right: 3rem !important;
  }
  .me-xl-auto {
    margin-right: auto !important;
  }
  .mb-xl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xl-auto {
    margin-bottom: auto !important;
  }
  .ms-xl-0 {
    margin-left: 0 !important;
  }
  .ms-xl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xl-3 {
    margin-left: 1rem !important;
  }
  .ms-xl-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xl-5 {
    margin-left: 3rem !important;
  }
  .ms-xl-auto {
    margin-left: auto !important;
  }
  .p-xl-0 {
    padding: 0 !important;
  }
  .p-xl-1 {
    padding: 0.25rem !important;
  }
  .p-xl-2 {
    padding: 0.5rem !important;
  }
  .p-xl-3 {
    padding: 1rem !important;
  }
  .p-xl-4 {
    padding: 1.5rem !important;
  }
  .p-xl-5 {
    padding: 3rem !important;
  }
  .px-xl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xl-0 {
    padding-top: 0 !important;
  }
  .pt-xl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xl-3 {
    padding-top: 1rem !important;
  }
  .pt-xl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xl-5 {
    padding-top: 3rem !important;
  }
  .pe-xl-0 {
    padding-right: 0 !important;
  }
  .pe-xl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xl-3 {
    padding-right: 1rem !important;
  }
  .pe-xl-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xl-5 {
    padding-right: 3rem !important;
  }
  .pb-xl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xl-5 {
    padding-bottom: 3rem !important;
  }
  .ps-xl-0 {
    padding-left: 0 !important;
  }
  .ps-xl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xl-3 {
    padding-left: 1rem !important;
  }
  .ps-xl-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xl-5 {
    padding-left: 3rem !important;
  }
  .gap-xl-0 {
    gap: 0 !important;
  }
  .gap-xl-1 {
    gap: 0.25rem !important;
  }
  .gap-xl-2 {
    gap: 0.5rem !important;
  }
  .gap-xl-3 {
    gap: 1rem !important;
  }
  .gap-xl-4 {
    gap: 1.5rem !important;
  }
  .gap-xl-5 {
    gap: 3rem !important;
  }
  .row-gap-xl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xl-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xl-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xl-3 {
    row-gap: 1rem !important;
  }
  .row-gap-xl-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xl-5 {
    row-gap: 3rem !important;
  }
  .column-gap-xl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xl-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-xl-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-xl-3 {
    column-gap: 1rem !important;
  }
  .column-gap-xl-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xl-5 {
    column-gap: 3rem !important;
  }
  .text-xl-start {
    text-align: left !important;
  }
  .text-xl-end {
    text-align: right !important;
  }
  .text-xl-center {
    text-align: center !important;
  }
}
@media (min-width: 1400px) {
  .float-xxl-start {
    float: left !important;
  }
  .float-xxl-end {
    float: right !important;
  }
  .float-xxl-none {
    float: none !important;
  }
  .object-fit-xxl-contain {
    object-fit: contain !important;
  }
  .object-fit-xxl-cover {
    object-fit: cover !important;
  }
  .object-fit-xxl-fill {
    object-fit: fill !important;
  }
  .object-fit-xxl-scale {
    object-fit: scale-down !important;
  }
  .object-fit-xxl-none {
    object-fit: none !important;
  }
  .d-xxl-inline {
    display: inline !important;
  }
  .d-xxl-inline-block {
    display: inline-block !important;
  }
  .d-xxl-block {
    display: block !important;
  }
  .d-xxl-grid {
    display: grid !important;
  }
  .d-xxl-inline-grid {
    display: inline-grid !important;
  }
  .d-xxl-table {
    display: table !important;
  }
  .d-xxl-table-row {
    display: table-row !important;
  }
  .d-xxl-table-cell {
    display: table-cell !important;
  }
  .d-xxl-flex {
    display: flex !important;
  }
  .d-xxl-inline-flex {
    display: inline-flex !important;
  }
  .d-xxl-none {
    display: none !important;
  }
  .flex-xxl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xxl-row {
    flex-direction: row !important;
  }
  .flex-xxl-column {
    flex-direction: column !important;
  }
  .flex-xxl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xxl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xxl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xxl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xxl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xxl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .flex-xxl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xxl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xxl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .justify-content-xxl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xxl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xxl-center {
    justify-content: center !important;
  }
  .justify-content-xxl-between {
    justify-content: space-between !important;
  }
  .justify-content-xxl-around {
    justify-content: space-around !important;
  }
  .justify-content-xxl-evenly {
    justify-content: space-evenly !important;
  }
  .align-items-xxl-start {
    align-items: flex-start !important;
  }
  .align-items-xxl-end {
    align-items: flex-end !important;
  }
  .align-items-xxl-center {
    align-items: center !important;
  }
  .align-items-xxl-baseline {
    align-items: baseline !important;
  }
  .align-items-xxl-stretch {
    align-items: stretch !important;
  }
  .align-content-xxl-start {
    align-content: flex-start !important;
  }
  .align-content-xxl-end {
    align-content: flex-end !important;
  }
  .align-content-xxl-center {
    align-content: center !important;
  }
  .align-content-xxl-between {
    align-content: space-between !important;
  }
  .align-content-xxl-around {
    align-content: space-around !important;
  }
  .align-content-xxl-stretch {
    align-content: stretch !important;
  }
  .align-self-xxl-auto {
    align-self: auto !important;
  }
  .align-self-xxl-start {
    align-self: flex-start !important;
  }
  .align-self-xxl-end {
    align-self: flex-end !important;
  }
  .align-self-xxl-center {
    align-self: center !important;
  }
  .align-self-xxl-baseline {
    align-self: baseline !important;
  }
  .align-self-xxl-stretch {
    align-self: stretch !important;
  }
  .order-xxl-first {
    order: -1 !important;
  }
  .order-xxl-0 {
    order: 0 !important;
  }
  .order-xxl-1 {
    order: 1 !important;
  }
  .order-xxl-2 {
    order: 2 !important;
  }
  .order-xxl-3 {
    order: 3 !important;
  }
  .order-xxl-4 {
    order: 4 !important;
  }
  .order-xxl-5 {
    order: 5 !important;
  }
  .order-xxl-last {
    order: 6 !important;
  }
  .m-xxl-0 {
    margin: 0 !important;
  }
  .m-xxl-1 {
    margin: 0.25rem !important;
  }
  .m-xxl-2 {
    margin: 0.5rem !important;
  }
  .m-xxl-3 {
    margin: 1rem !important;
  }
  .m-xxl-4 {
    margin: 1.5rem !important;
  }
  .m-xxl-5 {
    margin: 3rem !important;
  }
  .m-xxl-auto {
    margin: auto !important;
  }
  .mx-xxl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important;
  }
  .mx-xxl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important;
  }
  .mx-xxl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important;
  }
  .mx-xxl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important;
  }
  .mx-xxl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important;
  }
  .mx-xxl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important;
  }
  .mx-xxl-auto {
    margin-right: auto !important;
    margin-left: auto !important;
  }
  .my-xxl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  .my-xxl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
  }
  .my-xxl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
  }
  .my-xxl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important;
  }
  .my-xxl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
  }
  .my-xxl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important;
  }
  .my-xxl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important;
  }
  .mt-xxl-0 {
    margin-top: 0 !important;
  }
  .mt-xxl-1 {
    margin-top: 0.25rem !important;
  }
  .mt-xxl-2 {
    margin-top: 0.5rem !important;
  }
  .mt-xxl-3 {
    margin-top: 1rem !important;
  }
  .mt-xxl-4 {
    margin-top: 1.5rem !important;
  }
  .mt-xxl-5 {
    margin-top: 3rem !important;
  }
  .mt-xxl-auto {
    margin-top: auto !important;
  }
  .me-xxl-0 {
    margin-right: 0 !important;
  }
  .me-xxl-1 {
    margin-right: 0.25rem !important;
  }
  .me-xxl-2 {
    margin-right: 0.5rem !important;
  }
  .me-xxl-3 {
    margin-right: 1rem !important;
  }
  .me-xxl-4 {
    margin-right: 1.5rem !important;
  }
  .me-xxl-5 {
    margin-right: 3rem !important;
  }
  .me-xxl-auto {
    margin-right: auto !important;
  }
  .mb-xxl-0 {
    margin-bottom: 0 !important;
  }
  .mb-xxl-1 {
    margin-bottom: 0.25rem !important;
  }
  .mb-xxl-2 {
    margin-bottom: 0.5rem !important;
  }
  .mb-xxl-3 {
    margin-bottom: 1rem !important;
  }
  .mb-xxl-4 {
    margin-bottom: 1.5rem !important;
  }
  .mb-xxl-5 {
    margin-bottom: 3rem !important;
  }
  .mb-xxl-auto {
    margin-bottom: auto !important;
  }
  .ms-xxl-0 {
    margin-left: 0 !important;
  }
  .ms-xxl-1 {
    margin-left: 0.25rem !important;
  }
  .ms-xxl-2 {
    margin-left: 0.5rem !important;
  }
  .ms-xxl-3 {
    margin-left: 1rem !important;
  }
  .ms-xxl-4 {
    margin-left: 1.5rem !important;
  }
  .ms-xxl-5 {
    margin-left: 3rem !important;
  }
  .ms-xxl-auto {
    margin-left: auto !important;
  }
  .p-xxl-0 {
    padding: 0 !important;
  }
  .p-xxl-1 {
    padding: 0.25rem !important;
  }
  .p-xxl-2 {
    padding: 0.5rem !important;
  }
  .p-xxl-3 {
    padding: 1rem !important;
  }
  .p-xxl-4 {
    padding: 1.5rem !important;
  }
  .p-xxl-5 {
    padding: 3rem !important;
  }
  .px-xxl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
  .px-xxl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important;
  }
  .px-xxl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important;
  }
  .px-xxl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important;
  }
  .px-xxl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important;
  }
  .px-xxl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important;
  }
  .py-xxl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .py-xxl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
  }
  .py-xxl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }
  .py-xxl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
  }
  .py-xxl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
  }
  .py-xxl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important;
  }
  .pt-xxl-0 {
    padding-top: 0 !important;
  }
  .pt-xxl-1 {
    padding-top: 0.25rem !important;
  }
  .pt-xxl-2 {
    padding-top: 0.5rem !important;
  }
  .pt-xxl-3 {
    padding-top: 1rem !important;
  }
  .pt-xxl-4 {
    padding-top: 1.5rem !important;
  }
  .pt-xxl-5 {
    padding-top: 3rem !important;
  }
  .pe-xxl-0 {
    padding-right: 0 !important;
  }
  .pe-xxl-1 {
    padding-right: 0.25rem !important;
  }
  .pe-xxl-2 {
    padding-right: 0.5rem !important;
  }
  .pe-xxl-3 {
    padding-right: 1rem !important;
  }
  .pe-xxl-4 {
    padding-right: 1.5rem !important;
  }
  .pe-xxl-5 {
    padding-right: 3rem !important;
  }
  .pb-xxl-0 {
    padding-bottom: 0 !important;
  }
  .pb-xxl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pb-xxl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pb-xxl-3 {
    padding-bottom: 1rem !important;
  }
  .pb-xxl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pb-xxl-5 {
    padding-bottom: 3rem !important;
  }
  .ps-xxl-0 {
    padding-left: 0 !important;
  }
  .ps-xxl-1 {
    padding-left: 0.25rem !important;
  }
  .ps-xxl-2 {
    padding-left: 0.5rem !important;
  }
  .ps-xxl-3 {
    padding-left: 1rem !important;
  }
  .ps-xxl-4 {
    padding-left: 1.5rem !important;
  }
  .ps-xxl-5 {
    padding-left: 3rem !important;
  }
  .gap-xxl-0 {
    gap: 0 !important;
  }
  .gap-xxl-1 {
    gap: 0.25rem !important;
  }
  .gap-xxl-2 {
    gap: 0.5rem !important;
  }
  .gap-xxl-3 {
    gap: 1rem !important;
  }
  .gap-xxl-4 {
    gap: 1.5rem !important;
  }
  .gap-xxl-5 {
    gap: 3rem !important;
  }
  .row-gap-xxl-0 {
    row-gap: 0 !important;
  }
  .row-gap-xxl-1 {
    row-gap: 0.25rem !important;
  }
  .row-gap-xxl-2 {
    row-gap: 0.5rem !important;
  }
  .row-gap-xxl-3 {
    row-gap: 1rem !important;
  }
  .row-gap-xxl-4 {
    row-gap: 1.5rem !important;
  }
  .row-gap-xxl-5 {
    row-gap: 3rem !important;
  }
  .column-gap-xxl-0 {
    column-gap: 0 !important;
  }
  .column-gap-xxl-1 {
    column-gap: 0.25rem !important;
  }
  .column-gap-xxl-2 {
    column-gap: 0.5rem !important;
  }
  .column-gap-xxl-3 {
    column-gap: 1rem !important;
  }
  .column-gap-xxl-4 {
    column-gap: 1.5rem !important;
  }
  .column-gap-xxl-5 {
    column-gap: 3rem !important;
  }
  .text-xxl-start {
    text-align: left !important;
  }
  .text-xxl-end {
    text-align: right !important;
  }
  .text-xxl-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .fs-1 {
    font-size: 2.5rem !important;
  }
  .fs-2 {
    font-size: 2rem !important;
  }
  .fs-3 {
    font-size: 1.75rem !important;
  }
  .fs-4 {
    font-size: 1.5rem !important;
  }
}
@media print {
  .d-print-inline {
    display: inline !important;
  }
  .d-print-inline-block {
    display: inline-block !important;
  }
  .d-print-block {
    display: block !important;
  }
  .d-print-grid {
    display: grid !important;
  }
  .d-print-inline-grid {
    display: inline-grid !important;
  }
  .d-print-table {
    display: table !important;
  }
  .d-print-table-row {
    display: table-row !important;
  }
  .d-print-table-cell {
    display: table-cell !important;
  }
  .d-print-flex {
    display: flex !important;
  }
  .d-print-inline-flex {
    display: inline-flex !important;
  }
  .d-print-none {
    display: none !important;
  }
}
.round-bg {
  background-color: #ffffff;
  border-radius: 10px;
  border: 1px solid #C9C9C9;
  box-shadow: 0px 0px 10px 0px rgba(51, 51, 51, 0.15);
  padding: 20px 16px;
}

.p-inputtext {
  font-family: "Inter", sans-serif;
  font-size: 0.875rem;
  line-height: 24px;
  color: #333333;
}

.p-checkbox .p-checkbox-box {
  border: 1px solid #E1E1E1;
}

.p-radiobutton .p-radiobutton-box.p-highlight {
  border-color: #5627D9;
  background: #5627D9;
}

.p-dropdown .p-dropdown-label {
  font-size: 0.875rem;
  line-height: 24px;
  padding: 0.688rem 0.75rem;
  color: #333333;
}

.p-multiselect .p-multiselect-label {
  font-size: 0.875rem;
  line-height: 24px;
  padding: 0.688rem 0.75rem;
  color: #333333;
}

.p-datepicker .p-datepicker-header {
  padding: 0;
}
.p-datepicker .p-datepicker-header .p-datepicker-title .p-datepicker-year,
.p-datepicker .p-datepicker-header .p-datepicker-title .p-datepicker-month {
  padding-block: 0;
}
.p-datepicker table {
  font-size: 14px;
}
.p-datepicker table td {
  padding: 5px;
}
.p-datepicker table td > span {
  width: 26px;
  height: 26px;
}

.mycalls-head {
  display: flex;
  justify-content: space-between;
}
@media (max-width: 1199.98px) {
  .mycalls-head {
    display: block;
  }
}
.mycalls-head .mycalls-head-right {
  display: flex;
  flex-wrap: wrap;
}
@media (max-width: 1199.98px) {
  .mycalls-head .mycalls-head-right {
    width: 100%;
    margin-top: 0.5rem;
  }
}
.mycalls-head .mycalls-head-right .p-dropdown {
  border: none;
}
.mycalls-head .mycalls-head-right .p-dropdown .p-dropdown-label {
  padding: 0;
  font-size: 12px;
}
.mycalls-head .mycalls-head-right .p-multiselect {
  border: none;
}
.mycalls-head .mycalls-head-right .p-multiselect .p-multiselect-label {
  padding: 0;
  font-size: 12px;
  max-width: 100px;
}
.mycalls-head .mycalls-head-right .p-input-icon-left .card {
  padding: 0.5rem;
  border-radius: 4px;
}
.mycalls-head .mycalls-head-right .p-calendar .p-inputtext {
  padding-inline: 1rem;
  line-height: 16px;
  border-radius: 4px;
}

.common-tabnav {
  border-bottom: 1px solid rgba(150, 150, 150, 0.2);
}
.common-tabnav h5, .common-tabnav .h5 {
  font-size: 1rem;
  line-height: 18px;
  color: #5627D9;
  font-weight: 600;
  padding-block: 0.813rem;
  padding-inline: 1.25rem;
  margin: 0;
  border-bottom: 2px solid #5627D9;
}
.common-tabnav h5.active, .common-tabnav .active.h5 {
  color: #333333;
}

.password-toggle2 {
  position: absolute;
  right: 12px;
  top: 5px;
}

.password-toggle3 {
  position: absolute;
  right: 12px;
  cursor: pointer;
}

.password-toggle2 img {
  width: 20px;
  height: auto;
  cursor: pointer;
}

.form-label {
  font-size: 0.87rem;
  color: #717171;
  font-family: "Inter", sans-serif;
  margin-bottom: 0.3rem;
}

.form-control {
  border-radius: 0.3rem;
  border: none;
  background: rgba(201, 201, 201, 0.2);
  font-family: "Inter", sans-serif;
  font-size: 0.875rem;
  color: #333333;
  padding: 0.688rem 0.75rem;
  line-height: 24px;
}
.form-control[type=password] {
  padding-right: 30px;
}
.form-control:focus {
  box-shadow: 0 0 0 1px #5627D9;
}
.form-control:disabled {
  background: rgba(201, 201, 201, 0.2);
  color: rgba(51, 51, 51, 0.6);
}

.form-check-input:focus {
  box-shadow: none;
}
.form-check-input:checked {
  background-color: #01C324;
  border-color: #01C324;
}

.p-inputswitch {
  width: 2.625rem;
  height: 1.375rem;
}
.p-inputswitch .p-inputswitch-slider {
  width: 2.625rem;
  height: 1.375rem;
}
.p-inputswitch .p-inputswitch-slider::before {
  width: 1rem;
  height: 1rem;
  margin-top: -0.5rem;
  left: 0.15rem;
}
.p-inputswitch.p-inputswitch-checked .p-inputswitch-slider {
  background: #01C324;
}
.p-inputswitch.p-inputswitch-checked .p-inputswitch-slider::before {
  margin-top: -0.5rem;
  margin-left: 0;
}

.form-control[type=file] {
  color: rgba(0, 0, 0, 0);
}

.form-control[type=file]::file-selector-button {
  display: none;
}

.p-checkbox.p-highlight .p-checkbox-box {
  border-color: #5627D9;
  background: #5627D9;
}

.p-radiobutton.p-highlight .p-radiobutton-box {
  border-color: #5627D9;
  background: #5627D9;
}

.p-inputswitch.p-highlight .p-inputswitch-slider {
  background: #5627D9;
}

.p-datatable .p-sortable-column.p-highlight .p-sortable-column-icon {
  color: #5627D9;
}

.p-radiobutton.p-highlight .p-radiobutton-box {
  border-color: #5627D9;
  background: #ffffff;
}

.p-radiobutton .p-radiobutton-box .p-radiobutton-icon {
  width: 10px;
  height: 10px;
  transition-duration: 0;
  background-color: #5627D9;
}

.p-radiobutton:not(.p-disabled):has(.p-radiobutton-input:hover) .p-radiobutton-box {
  border-color: #5627D9;
}

::placeholder {
  color: #ACACAC;
}

.p-inputtext,
textarea {
  box-shadow: none;
}
.p-inputtext:hover, .p-inputtext:focus,
textarea:hover,
textarea:focus {
  border-color: #919191;
}

.form-row {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -10px 25px -10px;
}
.form-row:last-child {
  margin-bottom: 0;
}
.form-row .form-col {
  display: inline-block;
  width: 385px;
  padding: 0 10px;
}
.form-row .form-col .form-label {
  font-size: 14px;
  color: #292929;
  display: inline-block;
  margin-bottom: 8px;
}
.form-row .form-col .form-label i {
  color: #FF5155;
  display: inline-block;
  font-style: normal;
  margin-left: 1px;
}
.form-row .form-col .form-field-wrap {
  width: 100%;
  border: 1px solid #E1E1E1;
  border-radius: 30px;
  height: 38px;
  box-shadow: none;
  outline: none;
  display: flex;
  align-items: center;
}
.form-row .form-col .form-field-wrap.color-container {
  padding: 0 10px;
  display: flex;
  align-items: center;
}
.form-row .form-col .form-field-wrap.color-container .color-palette {
  overflow: hidden;
  height: 16px;
  width: 16px;
  display: inline-flex;
  border-radius: 50%;
  border: 1px solid #E1E1E1;
}
.form-row .form-col .form-field-wrap.color-container .color-palette input[type=color] {
  height: 100%;
  width: 100%;
  padding: 0;
  display: inline-block;
  border: none;
  box-shadow: none;
  outline: none;
  -webkit-appearance: none;
  cursor: pointer;
}
.form-row .form-col .form-field-wrap.color-container .color-palette input[type=color]::-webkit-color-swatch-wrapper {
  padding: 0;
}
.form-row .form-col .form-field-wrap.color-container .color-palette input[type=color]::-webkit-color-swatch {
  border: none;
}
.form-row .form-col .form-field-wrap .file-label {
  font-size: 12px;
  margin-left: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.form-row .form-col .form-field-wrap .file-btn {
  background-color: #E1E1E1;
  border: 0;
  font-size: 12px;
  height: 38px;
  width: 105px;
  border-radius: 30px 0 0 30px;
  margin-left: -1px;
}
.form-row .form-col .p-dropdown {
  width: 100%;
  border: 1px solid #E1E1E1;
  border-radius: 30px;
  height: 38px;
  box-shadow: none;
  outline: none;
}
.form-row .form-col .p-dropdown:focus, .form-row .form-col .p-dropdown:hover {
  border-color: #919191;
}
.form-row .form-col .p-dropdown .p-inputtext {
  border: 0;
}
.form-row .form-col .p-dropdown .p-dropdown-label {
  font-size: 12px;
  line-height: 24px;
  padding: 6px 10px;
  color: #333333;
  font-family: "Inter", sans-serif;
}
.form-row .form-col .p-inputtext {
  width: 100%;
  border: 1px solid #E1E1E1;
  border-radius: 30px;
  box-shadow: none;
  outline: none;
  padding: 5px 10px;
  font-size: 12px;
  background-color: #ffffff;
}
.form-row .form-col .p-inputtext:focus, .form-row .form-col .p-inputtext:hover {
  border-color: #919191;
}
.form-row .form-col .p-inputtextarea {
  width: 100%;
  border: 1px solid #E1E1E1;
  border-radius: 15px;
  height: 80px;
  box-shadow: none;
  outline: none;
  padding: 5px 10px;
  resize: none;
  font-size: 12px;
  background-color: #ffffff;
}
.form-row .form-col .p-inputtextarea:focus, .form-row .form-col .p-inputtextarea:hover {
  border-color: #919191;
}
.form-row .form-col .p-password {
  width: 100%;
}
.form-row .form-col .p-password .p-password-input {
  width: 100%;
  border: 1px solid #E1E1E1;
  border-radius: 30px;
  height: 38px;
  box-shadow: none;
  outline: none;
  padding: 5px 10px;
}
.form-row .form-col .p-password .p-password-input:focus, .form-row .form-col .p-password .p-password-input:hover {
  border-color: #919191;
}

.field-info {
  font-size: 14px;
  display: flex;
  align-items: center;
  margin: 5px 0 0 10px;
  color: #292929;
  font-family: "Inter", sans-serif;
}
.field-info i {
  font-size: 14px;
  font-weight: 600;
  margin-right: 5px;
}

.p-error {
  color: #FF5155;
  font-family: "Inter", sans-serif;
}

.outline-icon-btn, .grey-outline-btn {
  border: 1px solid #5627D9;
  padding: 9px 12px;
  border-radius: 30px;
  font-size: 12px;
  color: #292929;
  font-weight: 500;
  box-shadow: none;
  transition: all 0.3s ease-in-out;
  min-width: 100px;
  background-color: #ffffff;
  font-family: "Inter", sans-serif;
  justify-content: center;
}
.outline-icon-btn span, .grey-outline-btn span {
  font-weight: 500;
}
.outline-icon-btn:hover, .grey-outline-btn:hover {
  background-color: #5627D9;
  color: #ffffff;
}
.outline-icon-btn.active, .active.grey-outline-btn {
  background-color: #5627D9;
  color: #ffffff;
  pointer-events: none;
}
@media (max-width: 575.98px) {
  .outline-icon-btn, .grey-outline-btn {
    min-width: 80px;
  }
}

.outline-icon-btn2 {
  padding: 9px 12px;
  border-radius: 30px;
  font-size: 12px;
  color: #292929;
  font-weight: 500;
  box-shadow: none;
  transition: all 0.3s ease-in-out;
  min-width: 100px;
  background-color: #ffffff;
  font-family: "Inter", sans-serif;
  justify-content: center;
}
.outline-icon-btn2 span {
  font-weight: 500;
}
.outline-icon-btn2:hover {
  background-color: #5627D9;
  color: #ffffff;
}
.outline-icon-btn2.active {
  background-color: #5627D9;
  color: #ffffff;
  pointer-events: none;
}
@media (max-width: 575.98px) {
  .outline-icon-btn2 {
    min-width: 80px;
  }
}

.outline-active-btn {
  border: 1px solid #5627D9;
  padding: 9px 12px;
  border-radius: 30px;
  font-size: 12px;
  color: #ffffff;
  font-weight: 500;
  box-shadow: none;
  transition: all 0.3s ease-in-out;
  min-width: 100px;
  background-color: #5627D9;
  font-family: "Inter", sans-serif;
  justify-content: center;
}
@media (max-width: 575.98px) {
  .outline-active-btn {
    min-width: 80px;
  }
}
.outline-active-btn span {
  font-weight: 500;
}

.btn-primary {
  background-color: #5627D9 !important;
  border-color: #5627D9 !important;
  font-family: "Inter", sans-serif;
  font-size: 1rem;
  color: #ffffff !important;
  font-weight: 500;
  padding: 0.5rem 0.75rem;
  border-radius: 4px;
  box-shadow: none;
  justify-content: center;
}
.btn-primary span {
  font-weight: 500;
}

.grey-outline-btn {
  border-color: #919191;
  color: #919191;
}
.grey-outline-btn.active-btn {
  min-width: 75px;
}
.grey-outline-btn.active-btn:hover {
  background-color: #6FBE46;
  border-color: #6FBE46;
  color: #ffffff;
}
.grey-outline-btn.inactive-btn {
  min-width: 75px;
}
.grey-outline-btn.inactive-btn:hover {
  background-color: #AECA05;
  border-color: #AECA05;
  color: #ffffff;
}
.grey-outline-btn.delete-btn {
  min-width: 75px;
}
.grey-outline-btn.delete-btn:hover {
  background-color: #F01E36;
  border-color: #F01E36;
  color: #ffffff;
}

.btn.btn-outline-dark {
  padding: 8px 10px;
  height: 42px;
  border-radius: 4px;
}

.btn-lg, .btn-group-lg > .btn {
  min-width: 170px;
}
@media (max-width: 991.98px) {
  .btn-lg, .btn-group-lg > .btn {
    min-width: 100px;
  }
}

.outline-select {
  border: 1px solid #ced4da;
  border-radius: 40px;
  height: 38px;
  box-shadow: none;
  overflow: hidden;
}
.outline-select.multi-select {
  min-width: 140px;
}
.outline-select:hover {
  border-color: #919191;
}
.outline-select .p-dropdown-label {
  padding: 11px 12px;
  line-height: normal;
  font-size: 12px;
}
.outline-select .p-multiselect-label {
  padding: 10px 12px;
  line-height: normal;
  font-size: 12px;
}

.p-multiselect-items.p-component {
  padding: 0;
  margin-bottom: 0;
}

.p-multiselect-filter-container .p-inputtext {
  padding: 6px 40px 6px 15px;
  border-radius: 40px;
  font-size: 12px;
  color: #000000;
  width: 265px;
  max-width: 100%;
  box-shadow: none;
}

.p-multiselect-panel .p-multiselect-header .p-multiselect-close:enabled:hover {
  background-color: transparent;
}

.dashboard-submit {
  height: 38px;
}

.refresh-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 38px;
  width: 38px;
  border-radius: 50%;
  border: 1px solid #ced4da;
  cursor: pointer;
}
.refresh-btn:hover {
  border-color: #919191;
}

.p-disabled,
button:disabled {
  background-color: #E1E1E1 !important;
  border-color: #E1E1E1 !important;
  color: #212121;
}
.p-disabled .p-inputtext,
button:disabled .p-inputtext {
  background-color: #E1E1E1 !important;
  border-color: #E1E1E1 !important;
}
.p-disabled.p-radiobutton,
button:disabled.p-radiobutton {
  border-radius: 50%;
}

.p-paginator-element {
  border-radius: 50% !important;
}
.p-paginator-element.p-disabled {
  background-color: transparent !important;
  border-color: transparent !important;
}

.input-section button:disabled {
  background-color: transparent !important;
}

.p-inputswitch.p-disabled {
  border-radius: 30px;
}

.tabs-wrap .p-tabview.p-component .p-tabview-nav {
  margin-bottom: 0;
  padding-left: 0;
  border-bottom: 1px solid #E1E1E1;
  overflow-x: auto;
  overflow-y: hidden;
}
.tabs-wrap .p-tabview.p-component .p-tabview-nav .p-unselectable-text a {
  color: #333333;
  text-decoration: none;
  font-weight: 600;
  font-size: 14px;
  color: #404040;
  border-radius: 8px 8px 0 0;
}
.tabs-wrap .p-tabview.p-component .p-tabview-nav .p-unselectable-text.p-highlight a {
  color: #ffffff;
  border-color: #5627D9;
  background-color: #5627D9;
}
.tabs-wrap .p-tabview.p-component .p-tabview-nav-container {
  margin-bottom: 15px;
}
.tabs-wrap .p-tabview.p-component .p-tabview-panels {
  padding: 0;
}
.tabs-wrap .p-tabview.p-component li .p-tabview-nav-link {
  padding: 11px 40px;
  border-color: #E1E1E1;
}

.p-datatable .p-datatable-thead > tr > th {
  font-family: "Inter", sans-serif;
  font-weight: 500;
  font-size: 12px;
  color: #000000;
  background-color: #F1F1F1;
  padding: 5px;
}
.p-datatable .p-datatable-tbody > tr > td {
  font-family: "Inter", sans-serif;
  font-weight: 400;
  font-size: 12px;
  color: #404040;
  padding: 5px;
}
.p-datatable .p-datatable-tbody > tr > td a {
  text-decoration: none;
  color: #5627D9;
}

.datatable-wrapper .p-datatable-wrapper {
  border: 1px solid #F1F1F1;
  border-radius: 15px;
}
.datatable-wrapper .para-config-table .p-datatable-wrapper {
  height: calc(100vh - 270px);
}
@media (max-width: 991.98px) {
  .datatable-wrapper .para-config-table .p-datatable-wrapper {
    height: auto;
    margin-bottom: 50px;
  }
}

.p-datatable.p-datatable-selectable .p-datatable-tbody > tr.p-selectable-row:not(.p-highlight):not(.p-datatable-emptymessage):hover {
  background: #ffffff;
  color: #404040;
}

.p-datatable.p-datatable-striped .p-datatable-tbody > tr.p-row-odd {
  background: #ffffff;
}

.user-management-section h4, .user-management-section .h4 {
  font-size: 18px;
  color: #000000;
  font-weight: 600;
}
.user-management-section .filter-click {
  margin-right: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  color: #424242;
  text-transform: capitalize;
}
.user-management-section .filter-click img {
  margin-left: 10px;
}
.user-management-section .icon-expand {
  cursor: pointer;
  display: inline-block;
}
.user-management-section .icon-expand i {
  display: inline-block;
  margin-right: 4px;
  line-height: 0;
  vertical-align: middle;
  cursor: pointer;
}
.user-management-section .user-input input.p-inputtext {
  padding: 6px 40px 6px 15px;
  border-radius: 40px;
  font-size: 12px;
  color: #000000;
  width: 265px;
  max-width: 100%;
  box-shadow: none;
}
@media (max-width: 1199.98px) {
  .user-management-section .user-input input.p-inputtext {
    width: 250px;
  }
}
@media (max-width: 767.98px) {
  .user-management-section .user-input input.p-inputtext {
    width: 100%;
  }
}
.user-management-section .user-input input.p-inputtext:focus, .user-management-section .user-input input.p-inputtext:hover {
  border-color: #919191;
}
.user-management-section .user-input .pi-search {
  right: 15px;
}
.user-management-section .p-datatable {
  width: 100%;
}
.user-management-section .p-datatable .p-datatable-wrapper .p-datatable-thead th.p-sortable-column .p-sortable-column-icon {
  max-height: 12px;
  margin-left: 2px;
}
.user-management-section .p-datatable .p-datatable-wrapper .p-datatable-thead th.p-sortable-column.p-highlight {
  color: #5627D9;
}
.user-management-section .p-datatable .p-datatable-wrapper .p-datatable-thead th.p-sortable-column.p-highlight .p-sortable-column-icon {
  color: #5627D9;
  max-height: 14px;
}
.user-management-section .p-datatable .p-datatable-wrapper .p-datatable-thead .p-checkbox .p-checkbox-box.p-highlight {
  background: #5627D9;
  border-color: #5627D9;
}
.user-management-section .p-datatable .p-datatable-wrapper .p-datatable-tbody tr {
  border-bottom: 1px solid #F1F1F1;
}
.user-management-section .p-datatable .p-datatable-wrapper .p-datatable-tbody tr.p-highlight {
  background: rgba(86, 39, 217, 0.095);
  color: #5627D9;
}
.user-management-section .p-datatable .p-datatable-wrapper .p-datatable-tbody .p-datatable-emptymessage td {
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  color: #000000;
}
.user-management-section .p-datatable .p-datatable-wrapper .p-datatable-tbody .p-checkbox .p-checkbox-box.p-highlight {
  background: #5627D9;
  border-color: #5627D9;
}
.user-management-section .p-datatable .p-datatable-wrapper .p-datatable-tbody .p-tag-value {
  font-weight: 600;
  letter-spacing: 0.5px;
}
.user-management-section .p-datatable .p-paginator {
  border: none;
  padding: 20px 10px;
}
@media (max-width: 575.98px) {
  .user-management-section .p-datatable .p-paginator {
    padding: 10px 5px;
  }
}
@media (max-width: 575.98px) {
  .user-management-section .p-datatable .p-paginator button {
    margin: 10px 0;
    height: 1.5rem !important;
    min-width: 1.5rem !important;
    font-size: 12px;
  }
}
.user-management-section .p-datatable .p-paginator .p-paginator-first,
.user-management-section .p-datatable .p-paginator .p-paginator-prev,
.user-management-section .p-datatable .p-paginator .p-paginator-next,
.user-management-section .p-datatable .p-paginator .p-paginator-last {
  height: 2rem;
  min-width: 2rem;
  border-radius: 0.37rem;
}
.user-management-section .p-datatable .p-paginator .p-dropdown {
  height: 32px;
  box-shadow: none;
}
.user-management-section .p-datatable .p-paginator .p-dropdown:hover, .user-management-section .p-datatable .p-paginator .p-dropdown:active, .user-management-section .p-datatable .p-paginator .p-dropdown:focus {
  border-color: #5627D9;
}
.user-management-section .p-datatable .p-paginator .p-dropdown.p-dropdown:not(.p-disabled).p-focus {
  border-color: #5627D9;
}
.user-management-section .p-datatable .p-paginator .p-dropdown .p-dropdown-label {
  padding: 0.5rem;
  line-height: 16px;
}
.user-management-section .p-datatable .p-paginator .p-dropdown .p-dropdown-trigger {
  width: 2rem;
}
.user-management-section .p-datatable .p-paginator .p-paginator-first {
  color: #5627D9;
}
.user-management-section .p-datatable .p-paginator .p-paginator-prev {
  color: #5627D9;
}
.user-management-section .p-datatable .p-paginator .p-paginator-next {
  color: #5627D9;
}
.user-management-section .p-datatable .p-paginator .p-paginator-last {
  color: #5627D9;
}
.user-management-section .p-datatable .p-paginator .p-paginator-pages .p-paginator-page {
  color: #333333;
  min-width: 2rem;
  height: 2rem;
  border-radius: 0.37rem;
  border-radius: 50%;
}
.user-management-section .p-datatable .p-paginator .p-paginator-pages .p-paginator-page.p-highlight {
  background: #5627D9;
  border-color: #5627D9;
  color: #ffffff;
}

.p-dropdown-panel .p-dropdown-header {
  background-color: #ffffff;
}
.p-dropdown-panel .p-dropdown-filter {
  border-color: #E1E1E1;
  border-radius: 30px;
  height: 38px;
  padding: 0 15px;
  font-size: 12px;
}
.p-dropdown-panel .p-dropdown-items {
  padding: 0;
  margin-bottom: 0;
}
.p-dropdown-panel .p-dropdown-items span {
  font-size: 14px;
  color: #404040;
  font-family: "Inter", sans-serif;
  font-weight: 500;
}
.p-dropdown-panel .p-dropdown-items .p-dropdown-empty-message {
  font-size: 14px;
  font-family: "Inter", sans-serif;
}
.p-dropdown-panel .p-dropdown-items .p-dropdown-item .p-dropdown-blank-icon {
  position: absolute;
  right: 15px;
  margin-right: 0;
}
.p-dropdown-panel .p-dropdown-items .p-dropdown-item.p-highlight {
  background: #ffffff;
}
.p-dropdown-panel .p-dropdown-items .p-dropdown-item.p-highlight .p-dropdown-check-icon {
  position: absolute;
  right: 15px;
  color: #5627D9;
  margin-right: 0;
}
.p-dropdown-panel .p-dropdown-items .p-dropdown-item.p-highlight span {
  color: #5627D9;
}

.status-tag {
  border-radius: 20px;
  padding: 4px 15px;
  font-size: 12px;
  font-weight: 500;
}
.status-tag.active {
  color: #6FBE46;
  background-color: rgba(111, 190, 70, 0.1);
}
.status-tag.active_with_border {
  color: #6FBE46;
  background-color: rgba(111, 190, 70, 0.1);
  border: 1px solid #6FBE46;
}
.status-tag.inactive {
  color: #AECA05;
  background-color: rgba(174, 202, 5, 0.1);
}
.status-tag.delete {
  color: #F01E36;
  background-color: rgba(240, 30, 54, 0.1);
}
.status-tag.pending {
  color: #9882D4;
  background-color: rgba(152, 130, 212, 0.1);
}
.status-tag.reject {
  color: #808285;
  background-color: rgba(128, 130, 133, 0.1);
}

.p-dropdown-panel {
  margin-top: 10px;
  border: 1px solid #E1E1E1;
  border-radius: 8px;
  box-shadow: 0 0 40px rgba(0, 0, 0, 0.06);
  overflow: hidden;
}

.expanded-row {
  background-color: rgba(86, 39, 217, 0.1);
}

.p-datepicker-trigger {
  background-color: transparent;
  border-color: transparent;
  box-shadow: none;
  color: #6E6E6E;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}

@media (max-width: 1199.98px) {
  .table-top-row {
    flex-wrap: wrap;
  }
  .table-top-row h4.view-config-heading, .table-top-row .view-config-heading.h4 {
    margin-bottom: 10px !important;
  }
  .table-top-row .table-right-row {
    flex-wrap: wrap;
  }
}
@media (max-width: 767.98px) {
  .table-top-row h4, .table-top-row .h4 {
    margin-bottom: 10px !important;
    width: 100%;
  }
}
@media (max-width: 767.98px) {
  .table-top-row .table-right-row .dasboard-head {
    width: 100%;
  }
  .table-top-row .table-right-first > .table-search {
    width: 100%;
  }
  .table-top-row .table-right-first > .table-search .p-icon-field-right {
    width: 100%;
  }
  .table-top-row .table-right-first .outline-icon-btn, .table-top-row .table-right-first .grey-outline-btn {
    margin-right: 16px !important;
    font-size: 0;
    min-width: 36px;
    width: 36px;
  }
  .table-top-row .table-right-first .outline-icon-btn .p-button-icon, .table-top-row .table-right-first .grey-outline-btn .p-button-icon {
    margin-right: 0;
  }
}

.p-datatable-scrollable-table thead tr {
  background: #F1F1F1;
}

.p-paginator-bottom .p-dropdown .p-dropdown-label {
  padding: 0.4rem 0.75rem;
}

.home-main {
  width: 100%;
  position: relative;
  height: 100%;
}
.home-main .home-wrap {
  width: 100%;
  height: 100%;
}
.home-main .home-wrap .home-content {
  width: 100%;
}
.home-main .home-wrap .home-content .home-content-wrap {
  width: 890px;
  margin: 0 auto;
  max-width: 100%;
  padding: 40px 20px 0 20px;
}
@media (max-width: 1399.98px) {
  .home-main .home-wrap .home-content .home-content-wrap {
    padding: 20px 20px 0 20px;
  }
}
@media (max-width: 1199.98px) {
  .home-main .home-wrap .home-content .home-content-wrap {
    padding: 20px;
  }
}
.home-main .home-wrap .home-content h1, .home-main .home-wrap .home-content .h1 {
  font-size: 28px;
  font-weight: 700;
  line-height: 38px;
  margin-bottom: 30px;
  text-align: center;
  background: linear-gradient(91.16deg, #5627D9 6.8%, rgba(195, 80, 241, 0.8) 58.5%, #291DFF 117.29%);
  background-clip: text;
  color: transparent;
  display: inline-block;
}
.home-main .home-wrap .home-content h1 span, .home-main .home-wrap .home-content .h1 span {
  color: #5627D9;
}
@media (max-width: 1399.98px) {
  .home-main .home-wrap .home-content h1, .home-main .home-wrap .home-content .h1 {
    font-size: 24px;
    margin-bottom: 20px;
  }
}
@media (max-width: 575.98px) {
  .home-main .home-wrap .home-content h1, .home-main .home-wrap .home-content .h1 {
    margin-bottom: 5px;
    line-height: normal;
    font-size: 20px;
  }
}
.home-main .home-wrap .home-content .home-content-list {
  padding-left: 0;
  list-style-type: none;
  display: flex;
  flex-wrap: wrap;
  margin: 0 -25px 70px -25px;
  justify-content: center;
}
.home-main .home-wrap .home-content .home-content-list.single-menu li {
  width: 100%;
}
.home-main .home-wrap .home-content .home-content-list.single-menu li .single-menu-wrap {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
}
.home-main .home-wrap .home-content .home-content-list.single-menu li .single-menu-wrap i {
  display: inline-block;
  margin-right: 20px;
}
@media (max-width: 575.98px) {
  .home-main .home-wrap .home-content .home-content-list.single-menu li .single-menu-wrap i {
    display: none;
  }
}
.home-main .home-wrap .home-content .home-content-list.single-menu li .single-menu-wrap .right-menu-desc {
  width: auto;
  max-width: 100%;
  text-align: left;
}
.home-main .home-wrap .home-content .home-content-list.single-menu li .single-menu-wrap .right-menu-desc strong {
  font-size: 24px;
  font-weight: 700;
}
@media (max-width: 1399.98px) {
  .home-main .home-wrap .home-content .home-content-list {
    margin: 0 -15px 25px -15px;
  }
}
@media (max-width: 575.98px) {
  .home-main .home-wrap .home-content .home-content-list {
    margin: 0 -15px 15px -15px;
  }
}
.home-main .home-wrap .home-content .home-content-list li {
  width: 20%;
  padding: 0 25px;
  text-align: center;
}
@media (max-width: 1399.98px) {
  .home-main .home-wrap .home-content .home-content-list li {
    padding: 0 15px;
  }
}
@media (max-width: 575.98px) {
  .home-main .home-wrap .home-content .home-content-list li {
    width: 50%;
    padding: 15px;
  }
}
.home-main .home-wrap .home-content .home-content-list li a {
  display: flex;
  border: 2px solid rgba(86, 39, 217, 0.095);
  border-radius: 20px;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  text-decoration: none;
  font-size: 16px;
  font-weight: 500;
  color: #404040;
  padding: 15px;
  margin-bottom: 12px;
  transition: all 0.3s ease-in-out;
  width: 130px;
  height: 130px;
}
@media (max-width: 767.98px) {
  .home-main .home-wrap .home-content .home-content-list li a {
    padding: 15px 5px;
    width: 100%;
    height: auto;
  }
}
.home-main .home-wrap .home-content .home-content-list li a:hover, .home-main .home-wrap .home-content .home-content-list li a.home-content-active {
  border-color: #5627D9;
  box-shadow: 3px 3px 20px rgba(80, 90, 214, 0.1);
  background-color: rgba(80, 90, 214, 0.05);
}
.home-main .home-wrap .home-content .home-content-list li a img {
  margin-bottom: 0;
}
@media (max-width: 1399.98px) {
  .home-main .home-wrap .home-content .home-content-list li a img {
    max-height: 40px;
  }
}
.home-main .home-wrap .home-content .home-content-list li span {
  background: linear-gradient(91.16deg, #5627D9 6.8%, rgba(195, 80, 241, 0.8) 58.5%, #291DFF 117.29%);
  background-clip: text;
  color: transparent;
  text-align: center;
  transition: all 0.3s ease-in-out;
  display: inline-block;
  font-weight: 500;
  margin-bottom: 12px;
}
.home-main .home-wrap .home-content .home-content-list li p {
  font-size: 14px;
  color: #292929;
  line-height: 22px;
  margin-bottom: 0;
  text-align: center;
}
.home-main .home-wrap .home-content .marketing-section li {
  padding: 0 15px;
  width: 148px;
}
.home-main .home-wrap .home-content .marketing-section li a span {
  height: 68px;
}
.home-main .home-wrap .home-search {
  position: relative;
  display: flex;
  flex-wrap: wrap;
}
.home-main .home-wrap .home-search .radius-input {
  outline: none;
  box-shadow: none;
  border-radius: 40px;
  border: 1px solid #E1E1E1;
  padding: 20px 95px 20px 20px;
  color: #212121;
  font-size: 14px;
  width: 100%;
  resize: none;
  height: 64px;
}
@media (max-width: 991.98px) {
  .home-main .home-wrap .home-search .radius-input {
    height: 48px;
  }
}
@media (max-width: 767.98px) {
  .home-main .home-wrap .home-search .radius-input {
    height: 38px;
  }
}
.home-main .home-wrap .home-search .radius-input:disabled {
  border-color: #E1E1E1;
  opacity: 1;
  cursor: pointer;
}
.home-main .home-wrap .home-search .radius-input:disabled:hover {
  border-color: #5627D9;
}
.home-main .home-wrap .home-search .radius-input:hover, .home-main .home-wrap .home-search .radius-input:focus {
  border-color: #5627D9;
}
.home-main .home-wrap .home-search i {
  position: absolute;
  right: 55px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  line-height: 0;
}
.home-main .home-wrap .home-search .sec-last-icon {
  right: 50px;
}
@media (max-width: 767.98px) {
  .home-main .home-wrap .home-search .sec-last-icon img {
    max-width: 16px;
    max-height: 20px;
  }
}
.home-main .home-wrap .home-search .last-icon {
  right: 20px;
}
@media (max-width: 767.98px) {
  .home-main .home-wrap .home-search .last-icon img {
    max-width: 16px;
    max-height: 20px;
  }
}
.home-main .home-wrap .helper-text {
  margin-bottom: 0;
  margin-top: 10px;
  font-size: 14px;
  color: #404040;
  padding-left: 22px;
}
@media (max-width: 991.98px) {
  .home-main .home-wrap .helper-text {
    font-size: 12px;
  }
}
@media (max-width: 767.98px) {
  .home-main .home-wrap .helper-text {
    font-size: 12px;
  }
}
.home-main .home-wrap .helper-text i {
  display: inline-block;
  margin-right: 10px;
  vertical-align: middle;
  line-height: 0;
}
.home-main .home-wrap .helper-text2 {
  margin-bottom: 0;
  font-size: 14px;
  color: #404040;
}
.home-main .home-wrap .helper-text2 i {
  display: inline-block;
  margin-right: 10px;
  vertical-align: middle;
  line-height: 0;
}
.home-main .home-wrap .voice-search {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 975px;
}
@media (max-width: 1199.98px) {
  .home-main .home-wrap .voice-search {
    max-width: 100%;
  }
}
.home-main .home-wrap .voice-search .home-search {
  width: 850px;
  max-width: 100%;
}
@media (max-width: 575.98px) {
  .home-main .home-wrap .voice-search .home-search .radius-input {
    padding: 20px 60px 20px 20px;
  }
}
@media (max-width: 1199.98px) {
  .home-main .home-wrap .voice-search .home-search {
    width: calc(100% - 120px);
  }
}
.home-main .home-wrap .voice-search .btn-voice-list {
  margin-left: 15px;
}
.home-main .home-wrap .home-footer {
  width: 100%;
  text-align: center;
  padding: 12px 0;
  position: absolute;
  bottom: 0;
  background-color: #ffffff;
}
@media (max-width: 575.98px) {
  .home-main .home-wrap .home-footer {
    position: static;
    margin-top: 15px;
  }
}
.home-main .home-wrap .home-footer .home-footer-container {
  width: 890px;
  margin: 0 auto;
  max-width: 100%;
  padding: 0 20px;
}
.home-main .home-wrap .home-footer .home-footer-container .home-footer-wrap {
  display: flex;
  justify-content: center;
  font-size: 12px;
}
@media (max-width: 575.98px) {
  .home-main .home-wrap .home-footer .home-footer-container .home-footer-wrap {
    flex-direction: column;
  }
}
.home-main .home-wrap .home-footer .home-footer-container .home-footer-wrap p {
  margin-bottom: 0;
  color: #292929;
}
@media (max-width: 575.98px) {
  .home-main .home-wrap .home-footer .home-footer-container .home-footer-wrap p {
    margin-bottom: 5px;
  }
}
.home-main .home-wrap .home-footer .home-footer-container .home-footer-wrap .footer-links {
  padding-left: 0;
  list-style-type: none;
  margin-bottom: 0;
  display: flex;
  justify-content: center;
}
.home-main .home-wrap .home-footer .home-footer-container .home-footer-wrap .footer-links li {
  padding: 0 10px;
  border-right: 1px solid #5627D9;
}
.home-main .home-wrap .home-footer .home-footer-container .home-footer-wrap .footer-links li:last-child {
  border: 0;
}
.home-main .home-wrap .home-footer .home-footer-container .home-footer-wrap .footer-links li a {
  color: #5627D9;
}

.suggested-que {
  border: 1px solid #E1E1E1;
  border-radius: 12px;
  padding: 20px;
  margin-top: 6px;
}
.suggested-que .suggested-que-heading {
  font-size: 14px;
  color: #292929;
  margin-bottom: 12px;
}
@media (max-width: 1399.98px) {
  .suggested-que .suggested-que-heading {
    margin-bottom: 5px;
  }
}
.suggested-que .suggested-que-list {
  padding-left: 0;
  list-style-type: none;
  margin-bottom: 0;
}
.suggested-que .suggested-que-list li {
  width: 100%;
  margin-bottom: 12px;
}
@media (max-width: 1399.98px) {
  .suggested-que .suggested-que-list li {
    margin-bottom: 5px;
  }
}
.suggested-que .suggested-que-list li:last-child {
  margin-bottom: 0;
}
.suggested-que .suggested-que-list li a {
  color: #292929;
  font-size: 14px;
  text-decoration: none;
  width: 100%;
  display: block;
  position: relative;
  padding-right: 15px;
}
.suggested-que .suggested-que-list li a:hover {
  color: #5627D9;
}
.suggested-que .suggested-que-list li a:hover::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
}
.suggested-que .suggested-que-list li a::after {
  content: "";
  width: 14px;
  height: 11px;
  display: inline-block;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
  background-repeat: no-repeat;
  position: absolute;
  right: 0;
  top: 5px;
}

.lens-overlay {
  box-shadow: none;
  border: 6px solid #F1F1F1;
  border-radius: 12px;
}
.lens-overlay::before {
  left: 15px;
  top: -25px;
  display: none;
}
.lens-overlay::after {
  left: 15px;
  display: none;
}
.lens-overlay .lens-overlay-wrap .lens-overlay-list {
  padding-left: 0;
  margin-bottom: 0;
  list-style-type: none;
  display: flex;
  flex-wrap: wrap;
}
.lens-overlay .lens-overlay-wrap .lens-overlay-list li {
  display: flex;
  justify-content: center;
  text-align: center;
}
.lens-overlay .lens-overlay-wrap .lens-overlay-list li a {
  display: inline-block;
  width: 82px;
  text-decoration: none;
  padding: 10px 5px;
  border: 1px solid transparent;
  border-radius: 8px;
  cursor: pointer;
}
.lens-overlay .lens-overlay-wrap .lens-overlay-list li a:hover span {
  color: #5627D9;
}
.lens-overlay .lens-overlay-wrap .lens-overlay-list li a.active-lens {
  border-color: #5627D9;
  box-shadow: 3px 3px 20px rgba(26, 39, 200, 0.1);
  background-color: rgba(26, 39, 200, 0.05);
}
.lens-overlay .lens-overlay-wrap .lens-overlay-list li a img {
  max-height: 38px;
  margin-bottom: 7px;
}
.lens-overlay .lens-overlay-wrap .lens-overlay-list li a span {
  width: 100%;
  display: block;
  font-size: 12px;
  color: #404040;
  font-weight: 500;
  transition: all 0.3s ease-in-out;
}

.type-image {
  font-size: 18px;
  color: #212121;
  font-weight: 600;
  margin-bottom: 22px;
  padding-left: 22px;
}
@media (max-width: 767.98px) {
  .type-image {
    font-size: 16px;
    margin-bottom: 15px;
  }
}
.type-image i {
  margin-right: 10px;
  display: inline-block;
  vertical-align: top;
  max-width: 24px;
}
.type-image i img {
  width: 100%;
}

.chat-history-btn {
  position: fixed;
  right: 20px;
  bottom: 20px;
  background-color: #ffffff;
  box-shadow: 4px 4px 8px rgba(0, 0, 0, 0.25);
}
@media (max-width: 991.98px) {
  .chat-history-btn {
    font-size: 0;
    min-width: auto;
    width: 36px;
  }
  .chat-history-btn span {
    margin-right: 0;
  }
}

.chat-history-title {
  color: #000000;
  font-size: 16px;
  font-weight: 500;
}

.p-sidebar .p-sidebar-header {
  padding-top: 9px;
  padding-bottom: 9px;
  background-color: #E1E1E1;
}

.p-sidebar-right-history {
  background: transparent !important;
  box-shadow: none !important;
  width: 261px !important;
}

.p-sidebar-right .p-sidebar {
  width: 16rem;
  border-radius: 15px 0 0 15px;
  overflow: hidden;
}

.p-sidebar-content {
  overflow-y: auto;
  height: calc(100vh - 42px);
  padding: 0;
}
.p-sidebar-content .chat-component-right-section {
  height: 100%;
  padding: 0 20px;
}

.p-sidebar-right-history .p-sidebar {
  width: 16rem;
  border-radius: 15px 0 0 15px;
  overflow: hidden;
}

.chat-history-data-section-container {
  padding-top: 1rem;
}
.chat-history-data-section-container .date {
  color: #292929;
  font-size: 14px;
  font-weight: 500;
}
.chat-history-data-section-container .history-container {
  display: flex;
  align-items: center;
  margin-bottom: 18px;
}
.chat-history-data-section-container .history-container p {
  margin-bottom: 0;
  font-size: 14px;
  color: #6E6E6E;
  margin-left: 10px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  display: inline-block;
  width: calc(100% - 40px);
}

.history-container {
  align-items: flex-start;
  display: flex;
  flex-direction: row;
  margin-bottom: 16px;
  position: relative;
  width: 100%;
}
.history-container .edit-section {
  background-color: #ffffff;
  border: 2px solid #969696;
  border-radius: 0.2rem;
  display: flex;
  padding: 2%;
  width: 100%;
}
.history-container .edit-section .editable-text {
  border: none;
  outline: none;
  width: 85%;
  font-family: "Inter", sans-serif;
  font-size: 14px;
}
.history-container .edit-section .save-button {
  background-color: initial;
  border: none;
  margin-left: 5%;
}
.history-container .edit-delete-container {
  background-color: #ffffff;
  border-radius: 4px;
  box-shadow: 2px 2px 4px 1px rgba(0, 0, 0, 0.2);
  display: flex;
  flex-direction: column;
  padding: 6px 0;
  position: absolute;
  right: 0;
  top: 20px;
  width: 100%;
  z-index: 2;
}
.history-container .edit-delete-container .clickable-icon {
  cursor: pointer;
  height: 1.125rem;
  width: 1.125rem;
}
.history-container .edit-delete-container .delete-container,
.history-container .edit-delete-container .edit-container {
  align-items: center;
  display: flex;
  height: 40px;
  padding: 10px 12px;
  width: 100%;
}
.history-container .edit-delete-container .delete-container:hover,
.history-container .edit-delete-container .edit-container:hover {
  background: #F8F8F8;
}
.history-container .edit-delete-container .edit-delete-text {
  background: transparent;
  border: 0;
  color: #333333;
  font-family: "Inter", sans-serif;
  font-size: 15px;
  margin-bottom: 0;
  padding-left: 10px;
  margin-left: 0;
}

.close-history {
  position: fixed;
  z-index: 1111;
  right: 270px;
  bottom: 65px;
  cursor: pointer;
}

.p-sidebar-close.p-sidebar-icon {
  display: none;
}

.disable-icon {
  cursor: default !important;
  opacity: 0.5;
}

.loading-screen {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-left: 4px solid #5627D9;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  animation: spin 1s linear infinite;
  margin: 1rem 0;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.chat-bot-section {
  position: fixed;
  bottom: 90px;
  right: 50px;
  z-index: 11;
}
.chat-bot-section p {
  background: #ffffff;
  color: #000000;
  height: 40px;
  padding: 10px 15px;
  border-radius: 12px 12px 0 12px;
  margin-bottom: 0;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);
  font-size: 14px;
  font-weight: 600;
}
.chat-bot-section .chat-bot-button {
  width: 60px;
  height: 60px;
  position: fixed;
  bottom: 20px;
  right: 20px;
  background-color: #5627D9;
  color: #ffffff;
  border-radius: 38px 38px 4px 35px;
  border: none;
  padding: 16px;
  transition: 0.3s all;
  transition-timing-function: ease-in-out;
  transform: rotate(90deg);
}
.chat-bot-section .chat-bot-button i {
  transform: rotate(-90deg);
  display: inline-block;
}
.chat-bot-section .comments {
  transform: rotate(180deg);
}
.chat-bot-section .preview-bot-button {
  bottom: 10px;
  position: absolute;
}

.preview-chat-bot-section {
  position: absolute;
  right: 7px;
}

.preview-container {
  border-radius: 12px;
}

.section-container {
  width: 96%;
  max-width: 100%;
  position: static;
  bottom: 20px;
  right: 0;
  color: #000000;
  border-radius: 12px;
  z-index: 11;
  left: 0;
  margin: 0 auto;
  top: 20px;
  width: calc(100% - 300px);
}
@media (max-width: 767.98px) {
  .section-container {
    bottom: 100px;
    left: 0;
    right: 0;
    margin: 0 auto;
    width: 90%;
  }
}
.section-container .section-header {
  height: 76px;
  background: #ffffff;
  display: flex;
  color: #ffffff;
  padding: 10px 20px;
  display: flex;
  justify-content: space-between;
  border-radius: 25px 25px 0px 0px;
  align-items: center;
}
@media (max-width: 767.98px) {
  .section-container .section-header {
    padding: 10px 15px;
  }
}
.section-container .section-header .top-head {
  display: flex;
  align-items: center;
}
.section-container .section-header .top-head .chat-avtar {
  border-radius: 50%;
  width: 50px;
  height: 50px;
  border: 1px solid #5627D9;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 14px;
}
@media (max-width: 575.98px) {
  .section-container .section-header .top-head .chat-avtar {
    margin-right: 10px;
  }
}
.section-container .section-header .top-head .preview-logo-heading {
  padding: 0px;
  max-width: 30px;
  max-height: 30px;
}
.section-container .section-header .top-head p {
  display: flex;
  flex: 1 1;
  flex-direction: column;
  margin-top: 0;
  margin-bottom: 0;
  line-height: normal;
}
.section-container .section-header .top-head p :first-child {
  font-weight: 500;
  margin-bottom: 2px;
  font-size: 22px;
  font-weight: 600;
  color: #4f46e5;
}
.section-container .section-header .top-head p :nth-child(2) {
  font-size: 14px;
  color: #292929;
}
.section-container .section-header .button-section {
  display: flex;
  align-items: center;
  padding: 0;
  background: transparent;
  border: none;
  color: #6E6E6E;
}
.section-container .section-header .button-section i {
  font-weight: 600;
}
.section-container .section-body {
  padding: 20px;
  height: calc(100vh - 148px);
  overflow: auto;
  display: flex;
  flex-direction: column;
}
.section-container .section-body .start-suggestion {
  margin-top: 20px;
  position: absolute;
  bottom: 90px;
  left: 0;
  right: 0;
  padding: 0 20px;
}
.section-container .section-body .start-suggestion .suggested-que {
  padding: 0 !important;
  border: none !important;
}
.section-container .section-body .start-suggestion .suggested-que .suggested-que-list li {
  cursor: pointer;
  border-bottom: 1px solid white;
  padding: 5px 0;
  margin-bottom: 0px !important;
}
.section-container .section-body .start-suggestion .suggested-que .suggested-que-list li:hover {
  color: #5627D9 !important;
}
.section-container .section-body .start-suggestion .list {
  background-color: #5627D9;
  color: #ffffff;
  margin: 0 5px 10px 5px;
  border-radius: 25px;
  padding: 5px 10px;
  cursor: pointer;
}
.section-container .section-body .start-suggestion-first {
  margin-top: 20px;
  left: 0;
  right: 0;
}
.section-container .section-body .start-suggestion-first .suggested-que {
  padding: 0 !important;
  border: none !important;
}
.section-container .section-body .start-suggestion-first .suggested-que .suggested-que-list li {
  cursor: pointer;
  border-bottom: 1px solid white;
  padding: 5px 0;
  margin-bottom: 0px !important;
}
.section-container .section-body .start-suggestion-first .suggested-que .suggested-que-list li:hover {
  color: #5627D9 !important;
}
.section-container .section-body .start-suggestion-first .list {
  background-color: #5627D9;
  color: #ffffff;
  margin: 0 5px 10px 5px;
  border-radius: 25px;
  padding: 5px 10px;
  cursor: pointer;
}
.section-container .section-body .output-message-container {
  display: flex;
  flex-wrap: wrap;
  margin-right: 80px;
}
.section-container .section-body .output-message-container p {
  margin-bottom: 0;
  border-radius: 25px !important;
}
.section-container .section-body .output-message-container p a {
  color: #ffffff;
}
.section-container .section-body .output-message-container ol,
.section-container .section-body .output-message-container ul {
  margin: 1rem 0;
}
.section-container .section-body .output-message-container .fa-robot {
  color: #01C324;
  padding: 9px 7px;
  border: 1px solid lightgray;
  border-radius: 32px;
  height: 38px;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.25);
  width: 38px;
  margin-right: 8px;
  font-size: 18px;
  background: #ffffff;
}
.section-container .section-body .output-message-container .chat-img {
  width: 40px;
  height: 40px;
  margin-right: 15px;
  display: inline-block;
}
.section-container .section-body .output-message-container .chat-img img {
  height: 100%;
  width: 100%;
  object-fit: contain;
}
.section-container .section-body .output-message-container > p {
  font-size: 14px;
  background: #F4F4F4;
  border-radius: 4px;
  padding: 10px 15px 10px 15px;
  margin-bottom: 15px;
  border-radius: 0 12px 12px 12px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  color: #000000;
}
.section-container .section-body .output-message-container > p > p {
  margin-bottom: 0;
}
.section-container .section-body .output-message-container .second-message {
  margin-left: 56px;
}
.section-container .section-body .output-message-container .jumping-dots span {
  position: relative;
  margin-left: auto;
  margin-right: auto;
  animation: jump 2s infinite;
  display: inline-block;
  background-color: rgba(207, 207, 207, 0.8901960784);
  width: 5px;
  height: 5px;
  border-radius: 50%;
  margin-right: 3px;
}
.section-container .section-body .output-message-container .jumping-dots .dot-1 {
  animation-delay: 200ms;
  -webkit-animation-delay: 200ms;
}
.section-container .section-body .output-message-container .jumping-dots .dot-2 {
  animation-delay: 400ms;
  -webkit-animation-delay: 400ms;
}
.section-container .section-body .output-message-container .jumping-dots .dot-3 {
  animation-delay: 600ms;
  -webkit-animation-delay: 600ms;
}
.section-container .section-body .second-section .pi-reddit {
  visibility: hidden;
}
.section-container .section-body .input-message-container p {
  font-size: 12px;
  background: #5627D9;
  color: #ffffff;
  border-radius: 4px;
  padding: 10px 15px 10px 15px;
  margin-bottom: 15px;
  float: right;
  margin-left: 80px;
  border-radius: 25px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  word-break: break-word;
}
.section-container .section-footer {
  padding: 0px 20px 20px 20px;
}
.section-container .section-footer .suggestion-nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px;
}
.section-container .section-footer .suggestion-nav .nav-btn {
  position: absolute;
  z-index: 2000;
  background: linear-gradient(270deg, rgba(235, 236, 238, 0) 0%);
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  padding: 0 0.5rem;
  margin-bottom: 5px;
}
.section-container .section-footer .suggestion-nav .nav-btn.left {
  left: -5px;
}
.section-container .section-footer .suggestion-nav .nav-btn.right {
  right: -5px;
}
.section-container .section-footer .suggestion-nav .suggestion {
  overflow-x: scroll;
  display: flex;
  white-space: nowrap;
  scroll-behavior: smooth;
}
.section-container .section-footer .suggestion-nav .suggestion .list {
  background-color: #5627D9;
  color: #ffffff;
  margin: 0 5px;
  border-radius: 25px;
  padding: 5px 10px;
  z-index: 100;
  font-size: 14px;
  cursor: pointer;
}
.section-container .section-footer .input-section {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.section-container .section-footer .input-section .pi-plus-circle {
  color: #5627D9;
  font-size: 21px;
}
.section-container .section-footer .input-section input {
  background: #ffffff;
  border-radius: 40px;
  height: 50px;
  width: 100%;
  border: 1px solid #E1E1E1;
  padding: 15px 70px 15px 20px;
  font-size: 14px;
  color: #6E6E6E;
}
.section-container .section-footer .input-section input:focus {
  outline: none;
}
.section-container .section-footer .input-section button {
  background: none;
  border: none;
  padding: 0px;
  position: absolute;
  right: 38px;
  top: 16px;
  line-height: 0;
}
.section-container .section-footer .input-section button .pi-send {
  font-size: 18px;
  transform: rotate(45deg);
}
.section-container .section-footer .input-section button .active-class {
  opacity: 1;
}
.section-container .section-footer .input-section button .inActive-class {
  opacity: 0.5;
}
.section-container .section-footer .input-section button .last-icon img {
  width: 13px;
}
.section-container .section-footer .input-section .last-icon {
  position: absolute;
  right: -22px;
  cursor: pointer;
}
.section-container .section-footer .input-section .last-icon .active-class {
  opacity: 1;
}
.section-container .section-footer .input-section .last-icon .inActive-class {
  opacity: 0.5;
}
.section-container .section-footer .input-password input {
  padding: 15px 75px 15px 18px;
}
.section-container .section-footer .input-password .password-toggle3 {
  right: 3px;
}
.section-container .section-footer .input-password button {
  right: 16px;
}

.section-body-footer-wrap {
  overflow: hidden;
  box-shadow: -3.01px 3.01px 3.01px 0px rgba(255, 255, 255, 0.3882352941) inset;
  backdrop-filter: blur(74.4293365479px);
  background-color: rgba(240, 240, 240, 0.48);
  position: relative;
}
.section-body-footer-wrap::after {
  content: "";
  box-shadow: 2.01px -2.01px 20px 0px rgba(214, 214, 214, 0.168627451) inset;
  display: inline-block;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: -1;
}

.preview-section-container {
  width: 100%;
  position: static;
}
.preview-section-container .section-body {
  height: calc(100vh - 476px);
}

@keyframes jump {
  0% {
    bottom: 0px;
  }
  20% {
    bottom: 5px;
  }
  40% {
    bottom: 0px;
  }
}
.configuration-section .preview-section {
  height: calc(100vh - 240px);
  width: 540px;
  padding: 25px 30px 30px 30px;
  background: #F8F8F8;
}
@media (max-width: 1199.98px) {
  .configuration-section .preview-section {
    width: 400px;
  }
}
@media (max-width: 991.98px) {
  .configuration-section .preview-section {
    width: 100%;
  }
}
@media (max-width: 767.98px) {
  .configuration-section .preview-section {
    padding: 15px;
    height: auto;
  }
}
.configuration-section .preview-section .preview-header h4, .configuration-section .preview-section .preview-header .h4 {
  font-size: 16px;
  color: #000000;
  font-weight: 500;
  margin-bottom: 15px;
}

.blur-bot::after {
  content: "";
  position: fixed;
  z-index: 1;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(5px);
}

.card.bot-config {
  height: calc(100vh - 230px);
  overflow-y: auto;
}

.configuration-section .card.p-3 {
  height: calc(100vh - 230px);
  overflow-y: auto;
}

.markdown {
  background-color: #ffffff;
}

.configuration-section #RFS-StepButton {
  width: 16px;
  border: none;
  height: 16px;
  margin: 0px;
  display: flex;
  padding: 0px;
  font-size: 1em;
  align-items: center;
  border-radius: 50%;
  justify-content: center;
}
.configuration-section #RFS-StepButton.active, .configuration-section #RFS-StepButton.completed {
  background-color: #5627D9;
}
.configuration-section #RFS-StepMain {
  display: flex;
  align-items: center;
  flex-direction: column;
}
.configuration-section #RFS-ConnectorContainer {
  top: 7.5px;
  left: calc(-50% + 8px);
  right: calc(50% + 8px);
  position: absolute;
}
.configuration-section #RFS-Connector {
  display: block;
  border-color: rgb(189, 189, 189);
  border-top-style: solid;
  border-top-width: 1px;
}
.configuration-section .card {
  border: 0;
}
.configuration-section .card .admin-heading {
  font-size: 18px;
  color: #000000;
  font-weight: 600;
  margin-bottom: 0;
}
.configuration-section #RFS-StepperContainer {
  border-bottom: 1px solid #E1E1E1;
  padding: 20px 20px 40px 20px;
}
.configuration-section #RFS-Label {
  font-size: 12px;
  color: #282828;
  font-family: "Inter", sans-serif;
}
.configuration-section #RFS-StepButton {
  position: relative;
}
.configuration-section #RFS-StepButton > span {
  font-size: 16px;
  color: #282828;
  font-family: "Inter", sans-serif;
  font-weight: 500;
  margin-top: 100px;
  white-space: nowrap;
  display: inline-block;
}
@media (max-width: 767.98px) {
  .configuration-section #RFS-StepButton > span {
    font-size: 10px;
    margin-top: 115px;
    white-space: normal;
    line-height: normal;
  }
}
.configuration-section #RFS-StepButton.active::after, .configuration-section #RFS-StepButton.completed::after {
  border: 1px solid #5627D9;
}
.configuration-section #RFS-StepButton::before {
  content: "";
  position: absolute;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
  background-repeat: no-repeat;
  width: 9px;
  height: 7px;
  top: 5px;
  left: 3px;
  opacity: 0;
  visibility: hidden;
}
.configuration-section #RFS-StepButton::after {
  content: "";
  position: absolute;
  height: 22px;
  width: 22px;
  border-radius: 50%;
  border: 1px solid #C8C8C8;
}
.configuration-section #RFS-StepButton.completed::before {
  opacity: 1;
  visibility: visible;
}

.configuration-section2 #RFS-StepButton {
  width: 16px;
  border: none;
  height: 16px;
  margin: 0px;
  display: flex;
  padding: 0px;
  font-size: 1em;
  align-items: center;
  border-radius: 50%;
  justify-content: center;
}
.configuration-section2 #RFS-StepButton.active, .configuration-section2 #RFS-StepButton.completed {
  background-color: #5627D9;
}
.configuration-section2 #RFS-StepMain {
  display: flex;
  align-items: center;
  flex-direction: column;
}
.configuration-section2 #RFS-ConnectorContainer {
  top: 7.5px;
  left: calc(-50% + 8px);
  right: calc(50% + 8px);
  position: absolute;
}
.configuration-section2 #RFS-Connector {
  display: block;
  border-color: rgb(189, 189, 189);
  border-top-style: solid;
  border-top-width: 1px;
}
.configuration-section2 .card {
  border: 0;
}
.configuration-section2 .card .admin-heading {
  font-size: 18px;
  color: #000000;
  font-weight: 600;
  margin-bottom: 0;
}
.configuration-section2 .card .step-heading {
  font-size: 16px;
  color: #292929;
  font-weight: 500;
  margin-bottom: 0;
}
.configuration-section2 .card .step-span {
  font-size: 14px;
}
.configuration-section2 #RFS-StepperContainer {
  border-bottom: 1px solid #E1E1E1;
  padding: 20px 20px 55px 20px;
}
.configuration-section2 #RFS-Label {
  font-size: 12px;
  color: #282828;
  font-family: "Inter", sans-serif;
}
.configuration-section2 #RFS-StepButton {
  position: relative;
}
.configuration-section2 #RFS-StepButton > span {
  font-size: 16px;
  color: #282828;
  font-family: "Inter", sans-serif;
  font-weight: 500;
  margin-top: 125px;
  white-space: nowrap;
  display: inline-block;
}
.configuration-section2 #RFS-StepButton.active::after, .configuration-section2 #RFS-StepButton.completed::after {
  border: 1px solid #5627D9;
}
.configuration-section2 #RFS-StepButton::before {
  content: "";
  position: absolute;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
  background-repeat: no-repeat;
  width: 9px;
  height: 7px;
  top: 5px;
  left: 3px;
  opacity: 0;
  visibility: hidden;
}
.configuration-section2 #RFS-StepButton::after {
  content: "";
  position: absolute;
  height: 22px;
  width: 22px;
  border-radius: 50%;
  border: 1px solid #C8C8C8;
}
.configuration-section2 #RFS-StepButton.completed::before {
  opacity: 1;
  visibility: visible;
}

.stepper-main {
  width: calc(100% - 540px);
  padding-right: 15px;
}
.stepper-main.stepper-step-2 {
  width: 100%;
  padding-right: 0;
}
@media (max-width: 1199.98px) {
  .stepper-main {
    width: calc(100% - 400px);
  }
  .stepper-main.stepper-step-2 .stepper-wrapper.stepper-wrapper-ft {
    width: 100%;
  }
}
@media (max-width: 991.98px) {
  .stepper-main {
    width: 100%;
    padding-right: 0;
    margin-bottom: 20px;
  }
}
.stepper-main .stepper-form {
  height: calc(100vh - 297px);
  overflow-y: auto;
}
@media (max-width: 991.98px) {
  .stepper-main .stepper-form {
    height: auto;
  }
}
.stepper-main .stepper-form .upload-file-step {
  padding-top: 25px;
}
@media (max-width: 991.98px) {
  .stepper-main .stepper-form .upload-file-step {
    width: 100%;
  }
}
@media (max-width: 767.98px) {
  .stepper-main .stepper-form .upload-file-step {
    padding-top: 15px;
  }
}
.stepper-main .stepper-form .upload-file-step small, .stepper-main .stepper-form .upload-file-step .small {
  font-size: 14px;
  display: inline-block;
  margin-bottom: 25px;
  width: 100%;
}
.stepper-main .stepper-form .upload-file-step small b, .stepper-main .stepper-form .upload-file-step .small b {
  color: #5627D9;
  text-decoration: underline;
}
.stepper-main .stepper-form .upload-file-step .home-search {
  max-width: 400px;
}
.stepper-main .stepper-form .upload-file-step .home-search input {
  height: 54px;
  width: 100%;
  cursor: pointer !important;
  padding: 20px 62px 20px 20px;
}
@media (max-width: 991.98px) {
  .stepper-main .stepper-form .upload-file-step .home-search input {
    height: 48px;
  }
}
@media (max-width: 767.98px) {
  .stepper-main .stepper-form .upload-file-step .home-search input {
    height: 38px;
  }
}
.stepper-main .stepper-wrapper {
  width: 750px;
  max-width: 100%;
}
@media (max-width: 991.98px) {
  .stepper-main .stepper-wrapper {
    width: 100%;
  }
}
@media (max-width: 767.98px) {
  .stepper-main .stepper-wrapper .form-row {
    margin: 0 -10px;
  }
}
.stepper-main .stepper-wrapper .form-row .form-col {
  width: 50%;
}
@media (max-width: 767.98px) {
  .stepper-main .stepper-wrapper .form-row .form-col {
    width: 100%;
    margin-bottom: 10px;
  }
}
.stepper-main .stepper-wrapper .form-row .form-col.full-col {
  width: 100%;
}
.stepper-main .stepper-wrapper .form-row .form-col .p-inputnumber {
  width: 100%;
}
.stepper-main .stepper-wrapper.stepper-wrapper-ft {
  width: 770px;
  max-width: 100%;
}
@media (max-width: 991.98px) {
  .stepper-main .stepper-wrapper.stepper-wrapper-ft {
    width: 100%;
  }
}
.stepper-main .stepper-top {
  width: 100%;
  padding: 20px 40px 25px 20px;
}
.stepper-main .stepper-middle {
  width: 100%;
  padding: 20px 40px 20px 0;
  border-top: 1px solid #E1E1E1;
}
.stepper-main .stepper-middle .p-accordion-header-link {
  background-color: #F8F8F8;
  border: 1px solid #E1E1E1;
  border-radius: 10px;
  padding: 10px 20px;
  text-decoration: none;
}
.stepper-main .stepper-middle .p-accordion-header-link svg {
  display: none;
}
.stepper-main .stepper-middle .p-accordion-header-link .acc-form-header {
  display: inline-block;
  position: relative;
  width: 100%;
}
.stepper-main .stepper-middle .p-accordion-header-link .acc-form-header span {
  font-size: 14px;
  color: #292929;
  font-family: "Inter", sans-serif;
  font-weight: 400;
}
.stepper-main .stepper-middle .p-accordion-header-link .acc-form-header span b {
  font-weight: 600;
  margin-left: 6px;
}
.stepper-main .stepper-middle .p-accordion-header-link .acc-form-header i {
  position: absolute;
  right: 0;
  color: #292929;
  font-size: 14px;
  line-height: 0;
  top: 12px;
  font-weight: bold;
}
.stepper-main .stepper-middle .p-accordion-header-link .acc-form-header i.pi.pi-trash {
  right: -43px;
}
.stepper-main .stepper-middle .p-accordion-header-link .acc-form-header i.pi.pi-trash:hover {
  color: #F01E36;
}
.stepper-main .stepper-middle .p-accordion-tab {
  margin-bottom: 20px;
}
.stepper-main .stepper-middle .p-accordion-tab:last-child {
  margin-bottom: 0;
}
.stepper-main .stepper-middle .p-accordion-content {
  border: 0;
  padding: 0;
}
.stepper-main .stepper-middle .p-accordion-content .stepper-border {
  border: 1px solid #E1E1E1;
  border-radius: 10px;
  padding: 20px;
  margin-top: 20px;
}
.stepper-main .stepper-body {
  padding-right: 40px;
}
.stepper-main .stepper-body .stepper-border-inner {
  border: 1px solid #E1E1E1;
  border-radius: 10px;
  padding: 20px;
}
.stepper-main .stepper-footer {
  display: flex;
  justify-content: space-between;
  width: 100%;
  background-color: #ffffff;
  padding-top: 20px;
}
.stepper-main .stepper-footer .stepper-footer-inner {
  display: flex;
  justify-content: space-between;
}
@media (max-width: 991.98px) {
  .stepper-main .stepper-footer .stepper-footer-inner {
    justify-content: center;
  }
}

.stepper-main_butter_pie {
  width: calc(100% - 100px);
  padding-right: 15px;
}
.stepper-main_butter_pie.stepper-step-2 {
  width: 100%;
  padding-right: 0;
}
@media (max-width: 1199.98px) {
  .stepper-main_butter_pie {
    width: calc(100% - 400px);
  }
  .stepper-main_butter_pie.stepper-step-2 .stepper-wrapper.stepper-wrapper-ft {
    width: 100%;
  }
}
@media (max-width: 991.98px) {
  .stepper-main_butter_pie {
    width: 100%;
    padding-right: 0;
    margin-bottom: 20px;
  }
}
.stepper-main_butter_pie .stepper-form {
  height: calc(100vh - 297px);
  overflow-y: auto;
}
@media (max-width: 991.98px) {
  .stepper-main_butter_pie .stepper-form {
    height: auto;
  }
}
.stepper-main_butter_pie .stepper-form .upload-file-step {
  padding-top: 25px;
}
@media (max-width: 991.98px) {
  .stepper-main_butter_pie .stepper-form .upload-file-step {
    width: 100%;
  }
}
@media (max-width: 767.98px) {
  .stepper-main_butter_pie .stepper-form .upload-file-step {
    padding-top: 15px;
  }
}
.stepper-main_butter_pie .stepper-form .upload-file-step small, .stepper-main_butter_pie .stepper-form .upload-file-step .small {
  font-size: 14px;
  display: inline-block;
  margin-bottom: 25px;
  width: 100%;
}
.stepper-main_butter_pie .stepper-form .upload-file-step small b, .stepper-main_butter_pie .stepper-form .upload-file-step .small b {
  color: #5627D9;
  text-decoration: underline;
}
.stepper-main_butter_pie .stepper-form .upload-file-step .home-search {
  max-width: 400px;
}
.stepper-main_butter_pie .stepper-form .upload-file-step .home-search input {
  height: 54px;
  width: 100%;
  cursor: pointer !important;
  padding: 20px 62px 20px 20px;
}
@media (max-width: 991.98px) {
  .stepper-main_butter_pie .stepper-form .upload-file-step .home-search input {
    height: 48px;
  }
}
@media (max-width: 767.98px) {
  .stepper-main_butter_pie .stepper-form .upload-file-step .home-search input {
    height: 38px;
  }
}
.stepper-main_butter_pie .stepper-wrapper {
  max-width: 100%;
}
@media (max-width: 991.98px) {
  .stepper-main_butter_pie .stepper-wrapper {
    width: 100%;
  }
}
@media (max-width: 767.98px) {
  .stepper-main_butter_pie .stepper-wrapper .form-row {
    margin: 0 -10px;
  }
}
.stepper-main_butter_pie .stepper-wrapper .form-row .form-col {
  width: 50%;
}
@media (max-width: 767.98px) {
  .stepper-main_butter_pie .stepper-wrapper .form-row .form-col {
    width: 100%;
    margin-bottom: 10px;
  }
}
.stepper-main_butter_pie .stepper-wrapper .form-row .form-col.full-col {
  width: 100%;
}
.stepper-main_butter_pie .stepper-wrapper .form-row .form-col .p-inputnumber {
  width: 100%;
}
.stepper-main_butter_pie .stepper-wrapper.stepper-wrapper-ft {
  width: 770px;
  max-width: 100%;
}
@media (max-width: 991.98px) {
  .stepper-main_butter_pie .stepper-wrapper.stepper-wrapper-ft {
    width: 100%;
  }
}
.stepper-main_butter_pie .stepper-top {
  width: 100%;
  padding: 20px 40px 25px 20px;
}
.stepper-main_butter_pie .stepper-middle {
  width: 100%;
  padding: 20px 40px 20px 0;
  border-top: 1px solid #E1E1E1;
}
.stepper-main_butter_pie .stepper-middle .p-accordion-header-link {
  background-color: #F8F8F8;
  border: 1px solid #E1E1E1;
  border-radius: 10px;
  padding: 10px 20px;
  text-decoration: none;
}
.stepper-main_butter_pie .stepper-middle .p-accordion-header-link svg {
  display: none;
}
.stepper-main_butter_pie .stepper-middle .p-accordion-header-link .acc-form-header {
  display: inline-block;
  position: relative;
  width: 100%;
}
.stepper-main_butter_pie .stepper-middle .p-accordion-header-link .acc-form-header span {
  font-size: 14px;
  color: #292929;
  font-family: "Inter", sans-serif;
  font-weight: 400;
}
.stepper-main_butter_pie .stepper-middle .p-accordion-header-link .acc-form-header span b {
  font-weight: 600;
  margin-left: 6px;
}
.stepper-main_butter_pie .stepper-middle .p-accordion-header-link .acc-form-header i {
  position: absolute;
  right: 0;
  color: #292929;
  font-size: 14px;
  line-height: 0;
  top: 12px;
  font-weight: bold;
}
.stepper-main_butter_pie .stepper-middle .p-accordion-header-link .acc-form-header i.pi.pi-trash {
  right: -43px;
}
.stepper-main_butter_pie .stepper-middle .p-accordion-header-link .acc-form-header i.pi.pi-trash:hover {
  color: #F01E36;
}
.stepper-main_butter_pie .stepper-middle .p-accordion-tab {
  margin-bottom: 20px;
}
.stepper-main_butter_pie .stepper-middle .p-accordion-tab:last-child {
  margin-bottom: 0;
}
.stepper-main_butter_pie .stepper-middle .p-accordion-content {
  border: 0;
  padding: 0;
}
.stepper-main_butter_pie .stepper-middle .p-accordion-content .stepper-border {
  border: 1px solid #E1E1E1;
  border-radius: 10px;
  padding: 20px;
  margin-top: 20px;
}
.stepper-main_butter_pie .stepper-body {
  padding-right: 40px;
}
.stepper-main_butter_pie .stepper-body .stepper-border-inner {
  border: 1px solid #E1E1E1;
  border-radius: 10px;
  padding: 20px;
}
.stepper-main_butter_pie .stepper-footer {
  display: flex;
  justify-content: space-between;
  width: 100%;
  background-color: #ffffff;
  padding-top: 20px;
}
.stepper-main_butter_pie .stepper-footer .stepper-footer-inner {
  display: flex;
  justify-content: space-between;
}
@media (max-width: 991.98px) {
  .stepper-main_butter_pie .stepper-footer .stepper-footer-inner {
    justify-content: center;
  }
}

.step-preview-wrap {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.step-preview-wrap .stepper-main .stepper-form {
  padding: 20px;
}

.upload-file-step .form-label {
  width: 100%;
}
.upload-file-step .outline-select {
  width: 100%;
}

.p-accordion-tab .p-accordion-header a {
  text-decoration: none;
  color: #000;
  background-color: #ccc;
  padding: 10px;
  margin-bottom: 10px;
}
.p-accordion-tab .p-accordion-header a svg {
  margin-right: 5px;
}

.chart-table-wrapper {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -15px;
}
.chart-table-wrapper .custom-card1 {
  width: 60%;
  padding: 15px;
}
.chart-table-wrapper .custom-card1 .custom-card-inner {
  padding: 15px;
  background-color: #fff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  height: 100%;
  border-radius: 15px;
}
.chart-table-wrapper .custom-card2 {
  width: 40%;
  padding: 15px;
}
.chart-table-wrapper .custom-card2 .custom-card-inner {
  padding: 15px;
  background-color: #fff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  height: 100%;
  border-radius: 15px;
}

.btn-group {
  display: flex;
}

.btn {
  display: flex;
  align-items: center;
  padding: 8px 16px;
  background: #ffffff;
  border: 1px solid #d0d7de;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  font-family: Arial, sans-serif;
  color: #333;
  transition: 0.2s ease;
}

.btn:hover {
  background: #f5f5f5;
  border-color: #c5cacf;
}

.icon {
  display: flex;
  font-size: 16px;
  margin-right: 4px;
}

.head-btn-top {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 15px;
}
.head-btn-top h4, .head-btn-top .h4 {
  margin-bottom: 0;
}

.modebar.modebar--custom > .modebar-group:nth-child(2),
.modebar.modebar--custom > .modebar-group:nth-child(4) {
  display: none !important;
}

.modebar-group {
  padding-left: 0px !important;
}

.modebar-btn.custom-plotly-btn {
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  padding: 3px !important;
  margin: 0 1px !important;
  border-radius: 3px !important;
  height: 24px !important;
  width: 24px !important;
  vertical-align: middle !important;
}

/* wider, two-column cards like reference */
.quick-grid {
  margin: 40px auto 48px;
  margin-top: auto;
  display: grid;
  grid-template-columns: repeat(2, minmax(320px, 1fr));
  gap: 24px;
  max-width: 1040px;
  width: 100%;
}

.quick-card {
  background: #ffffff;
  border-radius: 22px;
  border: 1px solid #e5e7eb;
  box-shadow: 0 20px 40px rgba(15, 23, 42, 0.06);
  padding: 18px 24px;
  display: flex;
  align-items: center;
  gap: 16px;
  cursor: pointer;
  transition: transform 0.12s ease, box-shadow 0.12s ease, border-color 0.12s;
}

.quick-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 22px 45px rgba(15, 23, 42, 0.09);
  border-color: #c7d2fe;
}

.quick-icon-pill {
  width: 46px;
  height: 46px;
  border-radius: 18px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.quick-icon-pill svg {
  width: 24px;
  height: 24px;
}

.pill-blue {
  background: #eef2ff;
}

.pill-green {
  background: #dcfce7;
}

.pill-purple {
  background: #f5f3ff;
}

.pill-amber {
  background: #fef3c7;
}

.quick-meta {
  text-align: left;
}

.quick-label {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.14em;
  color: #9ca3af;
  margin-bottom: 4px;
}

.quick-question {
  font-size: 14px;
  color: #111827;
}

.vc-heading {
  text-align: center;
  padding: 20px 0;
}
.vc-heading .accent {
  color: #4f46e5;
  font-style: italic;
}
.vc-heading p {
  font-size: 16px;
  color: #6b7280;
}

#root,
body,
.app,
html {
  background-color: transparent;
  font-family: "Inter", sans-serif;
}

body {
  width: 100%;
}

.p-component,
p,
a,
div,
li,
b,
strong,
span {
  font-family: "Inter", sans-serif;
}

.clip-loader {
  position: fixed;
  background-color: rgba(0, 0, 0, 0.7);
  width: 100%;
  height: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.clip-loader-bot {
  position: absolute;
  /* Changed from fixed */
  background-color: rgba(0, 0, 0, 0.7);
  /* Semi-transparent overlay */
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  border-radius: 19px;
}

.loader-spinner {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
  background-size: cover;
  background-repeat: no-repeat;
  width: 100px;
  height: 100px;
}

::-webkit-scrollbar {
  width: 5px;
  height: 5px;
  background-color: transparent;
}

::-webkit-scrollbar-track {
  background-color: transparent;
}

::-webkit-scrollbar-thumb {
  background: #C8C8C8;
  border-radius: 8px;
}

.range-slider-container {
  position: relative;
  width: 100%;
}

.tooltip {
  visibility: hidden;
  background-color: #292929;
  color: #ffffff;
  text-align: center;
  width: 35px;
  height: 18px;
  position: absolute;
  z-index: 1;
  bottom: 110%;
  left: 50%;
  transform: translateX(-50%);
  top: -22px;
  border-radius: 30px;
  font-size: 12px;
  font-family: "Inter", sans-serif;
}

.range-slider-container:hover .tooltip {
  visibility: visible;
  opacity: 1;
}

.wrapper {
  position: relative;
  height: 40px;
  width: 300px;
  overflow: hidden;
  display: flex;
  flex-direction: row;
  border-radius: 4px;
}

.sufix {
  position: relative;
  height: auto;
  width: auto;
  display: flex;
  justify-content: center;
  align-content: center;
  flex-direction: column;
  background: rgb(243, 242, 241);
  color: rgb(96, 94, 92);
  display: flex;
  align-items: center;
  white-space: nowrap;
  flex-shrink: 0;
  padding: 0px 10px;
  box-sizing: border-box;
}

.c-pointer {
  cursor: pointer;
}

#RFS-StepButton:disabled {
  cursor: default;
}

.border-red {
  border: 1px solid #EC292E !important;
}

.p-4.content-wrapper {
  padding: 20px !important;
}
@media (max-width: 767.98px) {
  .p-4.content-wrapper {
    padding: 15px !important;
  }
}

.access-denied {
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.access-denied p {
  font-size: 24px;
}
@media (max-width: 767.98px) {
  .access-denied p {
    font-size: 16px;
  }
}
.access-denied h2, .access-denied .h2,
.access-denied p {
  text-align: center;
}

.Toastify__toast-theme--light {
  background: #F1F1F1 !important;
  color: #000000 !important;
  font-size: 14px !important;
  line-height: 22px !important;
  font-weight: 500 !important;
  font-family: "Inter", sans-serif !important;
  box-shadow: none !important;
  border-radius: 10px !important;
}
.Toastify__toast-theme--light .Toastify__close-button--light {
  color: #404040;
  opacity: 1;
}

.custom-tooltip {
  color: #ffffff;
  padding: 5px 10px;
  font-size: 12px;
}

.p-confirm-popup:after {
  border-width: 8px;
  margin-left: -8px;
  border: none;
}

.p-datepicker table td span.p-highlight {
  color: #5627D9;
  background-color: rgba(86, 39, 217, 0.1);
  box-shadow: none;
}
.p-datepicker table td.p-datepicker-today span.p-highlight,
.p-datepicker table td.p-datepicker-today span {
  background-color: #5627D9;
  color: #ffffff;
  box-shadow: none;
}

.p-datepicker .p-datepicker-header .p-datepicker-title .p-datepicker-year:enabled:hover,
.p-datepicker .p-datepicker-header .p-datepicker-title .p-datepicker-month:enabled:hover {
  color: #5627D9;
}

.temp_span {
  width: 100%;
  display: block;
  font-size: 12px;
  color: #404040;
  font-weight: 500;
  transition: all 0.3s ease-in-out;
}

.temp_a {
  cursor: default !important;
}

.stars_bot {
  display: flex;
  margin-left: 9px;
}

.empty-star_bot {
  color: #ccc;
  font-size: 12px;
  padding: 2px;
}

.full-star_bot {
  color: #ffc107;
  font-size: 12px;
  padding: 2px;
}

.half-star_bot {
  font-size: 12px;
  color: #ccc;
  background: linear-gradient(90deg, #ffc107 50%, #FFFFFF 50%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  padding: 2px;
  -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: #ffc107;
}

.quarter-star_bot {
  font-size: 12px;
  color: #ccc;
  background: linear-gradient(90deg, #ffc107 43%, #FFFFFF 25%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  padding: 2px;
  -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: #ffc107;
}

.three-quarter-star_bot {
  font-size: 12px;
  color: #ccc;
  background: linear-gradient(90deg, #ffc107 61%, white 56%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  padding: 2px;
  -webkit-text-stroke-width: 1px;
  -webkit-text-stroke-color: #ffc107;
}

.passowrd-padding {
  padding-right: 34px !important;
}

.myLabelComponentInSvg {
  height: 70px;
  width: 180px;
  margin: 10px;
}

.temp-height {
  height: calc(100vh - 132px);
}

.item-header-butterpie {
  cursor: pointer;
}
.item-header-butterpie.active {
  pointer-events: none;
  background-color: rgba(137, 43, 44, 0.05);
  color: #5627D9;
}

.item-header-butterpie:hover {
  background-color: rgba(137, 43, 44, 0.05);
  color: #5627D9;
}

.form-field-wrap-bot-con {
  width: 40%;
  border: 1px solid #E1E1E1;
  border-radius: 30px;
  height: 38px;
  box-shadow: none;
  outline: none;
  display: flex;
  align-items: center;
  font-size: 12px;
}
.form-field-wrap-bot-con.color-container {
  padding: 0 10px;
  display: flex;
  align-items: center;
}
.form-field-wrap-bot-con.color-container .color-palette {
  overflow: hidden;
  height: 16px;
  width: 16px;
  display: inline-flex;
  border-radius: 50%;
  border: 1px solid #E1E1E1;
}
.form-field-wrap-bot-con.color-container .color-palette input[type=color] {
  height: 100%;
  width: 100%;
  padding: 0;
  display: inline-block;
  border: none;
  box-shadow: none;
  outline: none;
  -webkit-appearance: none;
  cursor: pointer;
}
.form-field-wrap-bot-con.color-container .color-palette input[type=color]::-webkit-color-swatch-wrapper {
  padding: 0;
}
.form-field-wrap-bot-con.color-container .color-palette input[type=color]::-webkit-color-swatch {
  border: none;
}
.form-field-wrap-bot-con .file-label {
  font-size: 12px;
  margin-left: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.form-field-wrap-bot-con .file-btn {
  background-color: #E1E1E1;
  border: 0;
  font-size: 12px;
  height: 38px;
  width: 105px;
  border-radius: 30px 0 0 30px;
  margin-left: -1px;
}

.date-validation input {
  border: 1px solid #EC292E !important;
}

.text-danger {
  color: #EC292E !important;
  font-size: 12px !important;
}

.my-badge {
  width: 24px;
  height: 24px;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  background-color: #5627D9;
  /* Custom background */
  color: white;
  /* Text color */
}

.my-badge-circle {
  background-color: #5627D9;
  /* Custom background */
  color: white;
  width: 32px;
  height: 32px;
  border-radius: 50% !important;
  display: flex !important;
  align-items: center;
  justify-content: center;
  padding: 0 !important;
  font-size: 14px;
}

.p-toast .p-toast-message .p-toast-message-content {
  padding: 1rem;
}
.p-toast .p-toast-message .p-toast-message-content .p-toast-message-icon.p-icon {
  width: 2rem;
  height: 2rem;
}
.p-toast .p-toast-message .p-toast-message-content .p-toast-message-text {
  margin: 0 0 0 1rem;
}
.p-toast .p-toast-message.p-toast-message-error {
  background: rgba(255, 231, 230, 0.7);
  border: solid #ff5757;
  border-width: 0 0 0 6px;
  color: #ff5757;
}

.bot-header {
  width: 100%;
  border-bottom: 1px solid rgba(255, 255, 255, 0.48);
  padding-bottom: 5px;
  margin-bottom: 15px;
}
.bot-header .bot-head-listing {
  display: flex;
  flex-wrap: wrap;
  list-style-type: none;
  padding-left: 0;
  margin-bottom: 0;
}
.bot-header .bot-head-listing li {
  margin-right: 10px;
  margin-bottom: 10px;
}
.bot-header .bot-head-listing li span {
  font-size: 12px;
  color: #000000;
  border-radius: 25px;
  background-color: #ffffff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
  display: inline-block;
  padding: 10px 15px 10px 15px;
  cursor: pointer;
}
.bot-header .bot-head-listing li span.active {
  background-color: #5627D9;
  color: #ffffff;
}
.bot-header .bot-head-listing li span:hover {
  background-color: #5627D9;
  color: #ffffff;
}
.bot-header .bot-head-listing li span i {
  display: inline-block;
  margin-left: 8px;
}

.product-slider {
  margin-bottom: 15px;
}
.product-slider .product-card {
  padding: 0 5px;
  height: 100%;
}
.product-slider .product-card.active .product-card-wrap {
  border-color: #5627D9;
}
.product-slider .product-card.active .product-card-wrap figure figcaption {
  background-color: #5627D9;
}
.product-slider .product-card .product-card-wrap {
  width: 100%;
  background-color: #ffffff;
  border-radius: 15px;
  height: 100%;
  cursor: pointer;
}
.product-slider .product-card .product-card-wrap figure {
  margin-bottom: 0;
  height: 100%;
  border-radius: 0 0 15px 15px;
  overflow: hidden;
}
.product-slider .product-card .product-card-wrap figure span {
  display: flex;
  min-height: 132px;
  align-items: center;
  justify-content: center;
  border: 1px solid #404040;
  border-radius: 15px 15px 0 0;
}
.product-slider .product-card .product-card-wrap figure span img {
  width: 80px;
  max-width: 100%;
  padding: 5px;
  object-fit: contain;
  max-height: 130px;
}
.product-slider .product-card .product-card-wrap figure figcaption {
  background-color: #404040;
  border-radius: 0 0 15px 15px;
  padding: 10px;
  display: flex;
  height: 100%;
}
.product-slider .product-card .product-card-wrap figure figcaption p {
  font-size: 10px;
  color: #F7F4FF;
  width: calc(100% - 2px);
  padding-right: 5px;
  margin-bottom: 0;
  word-break: break-word;
}
.product-slider .product-card .product-card-wrap figure figcaption i {
  display: inline-block;
}
.product-slider .product-card .product-card-wrap figure figcaption i img {
  padding: 0;
}
.product-slider .p-carousel-indicators {
  display: none;
}
.product-slider .p-carousel-items-container {
  margin: 0 -5px;
}
.product-slider .p-disabled,
.product-slider button:disabled {
  background-color: transparent !important;
  border-color: transparent !important;
}
.product-slider .p-disabled svg,
.product-slider button:disabled svg {
  color: #6E6E6E;
}
.product-slider button {
  background-color: transparent !important;
  border-color: transparent !important;
}
.product-slider button svg {
  color: #141414;
  width: 20px !important;
  height: 20px !important;
}

.product-detail-wrap {
  border-radius: 20px;
  background-color: #ffffff;
  position: absolute;
  top: 20px;
  left: 20px;
  right: 20px;
  bottom: 90px;
  z-index: 1;
}
.product-detail-wrap .product-details {
  height: calc(100vh - 357px);
  overflow-y: auto;
  overflow-x: hidden;
  border-end-start-radius: 22px;
  border-end-end-radius: 22px;
}
.product-detail-wrap .product-details .close-product {
  cursor: pointer;
  position: static;
  line-height: 0;
  background-color: #ffffff;
  padding: 15px;
  border-radius: 0 20px 0 0;
  display: flex;
  justify-content: flex-end;
  border-radius: 20px 20px 0 0;
}
.product-detail-wrap .product-details .product-top {
  padding: 15px;
}
.product-detail-wrap .product-details .product-top figure {
  max-width: 160px;
  margin: 0 auto;
  min-height: 210px;
  display: flex;
  align-items: center;
}
@media (max-width: 575.98px) {
  .product-detail-wrap .product-details .product-top figure {
    max-width: 100px;
  }
}
.product-detail-wrap .product-details .product-top figure img {
  width: 100%;
  object-fit: contain;
}
.product-detail-wrap .product-details .product-bottom {
  padding: 15px 15px 0 15px;
  overflow-y: auto;
  border-top: 1px solid #E1E1E1;
}
.product-detail-wrap .product-details .product-bottom .product-name {
  font-size: 14px;
  font-weight: 500;
  color: #292929;
  display: block;
  margin-bottom: 4px;
}
.product-detail-wrap .product-details .product-bottom strong {
  font-size: 14px;
  display: block;
  color: #292929;
  font-weight: 700;
}
.product-detail-wrap .product-details .product-bottom .star-review {
  display: flex;
}
.product-detail-wrap .product-details .product-bottom .star-review .star-rating {
  list-style-type: none;
  padding-left: 0;
  display: flex;
  align-items: center;
  margin-bottom: 0;
  margin-right: 8px;
}
.product-detail-wrap .product-details .product-bottom .star-review .star-rating li {
  margin-bottom: 0;
}
.product-detail-wrap .product-details .product-bottom .star-review .star-rating li i {
  line-height: 0;
  display: flex;
}
.product-detail-wrap .product-details .product-bottom .star-review .rating {
  color: #919191;
  font-size: 12px;
  margin-right: 16px;
  display: inline-block;
}
.product-detail-wrap .product-details .product-bottom .star-review .review-rating {
  font-size: 12px;
  color: #505AD6;
  cursor: pointer;
  text-decoration: none;
}
.product-detail-wrap .product-details .product-bottom .product-list-details {
  margin-top: 9px;
  list-style-type: none;
  padding-left: 0;
  margin-bottom: 0;
}
.product-detail-wrap .product-details .product-bottom .product-list-details li {
  padding: 9px 0;
  border-bottom: 1px solid #C8C8C8;
}
.product-detail-wrap .product-details .product-bottom .product-list-details li:last-child {
  border-bottom: 0;
}
.product-detail-wrap .product-details .product-bottom .product-list-details li p {
  color: #292929;
  font-size: 12px;
  margin-bottom: 0;
}
.product-detail-wrap .product-details .pro-action-btn {
  list-style-type: none;
  padding-left: 0;
  margin-bottom: 0;
  display: flex;
  padding: 15px;
  margin: 0 -10px;
}
@media (max-width: 575.98px) {
  .product-detail-wrap .product-details .pro-action-btn {
    margin: 0 -5px;
  }
}
.product-detail-wrap .product-details .pro-action-btn li {
  padding: 0 10px;
  width: 50%;
}
@media (max-width: 575.98px) {
  .product-detail-wrap .product-details .pro-action-btn li {
    padding: 0 5px;
  }
}
.product-detail-wrap .product-details .pro-action-btn li button {
  width: 100%;
}
.product-detail-wrap .product-details .active-cart-btn {
  pointer-events: none;
}
.product-detail-wrap .product-details .compare-toast {
  background-color: #F1F9ED;
  border-radius: 30px;
  font-size: 12px;
  color: #303030;
  font-weight: 500;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 15px;
  margin: 0 auto;
  max-width: 148px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #5627D9;
  z-index: 1;
}
.product-detail-wrap .product-details .compare-toast.large-box {
  width: 93%;
  max-width: initial;
}
.product-detail-wrap .product-details .p-carousel-prev,
.product-detail-wrap .product-details .p-carousel-next {
  position: relative;
  z-index: 1;
}
.product-detail-wrap .product-details .p-carousel-prev {
  left: 0;
}
.product-detail-wrap .product-details .p-carousel-next {
  right: 0;
}
.product-detail-wrap .product-details .p-disabled,
.product-detail-wrap .product-details button:disabled {
  background-color: transparent !important;
  border-color: transparent !important;
}
.product-detail-wrap .product-details .p-disabled svg,
.product-detail-wrap .product-details button:disabled svg {
  color: #6E6E6E;
}
.product-detail-wrap .product-details button svg {
  color: #141414;
  width: 20px !important;
  height: 20px !important;
}
.product-detail-wrap .style-section h3, .product-detail-wrap .style-section .h3 {
  font-size: 14px;
  padding: 10px 15px 15px 15px;
}
.product-detail-wrap .style-section .style-recommendation-container {
  width: 100%;
  background: #F8F8F8;
  margin-bottom: 10px;
}
.product-detail-wrap .style-section .style-recommendation-container .style-recommendation {
  display: grid;
  grid-template-columns: 1.4fr 1fr;
  gap: 10px;
}
.product-detail-wrap .style-section .style-recommendation-container .style-recommendation .product-top {
  padding: 15px 0px 11px 16px;
}
.product-detail-wrap .style-section .style-recommendation-container .style-recommendation .product-top figure {
  max-width: 228px;
}
.product-detail-wrap .style-section .style-recommendation-container .style-recommendation .recommendation-section {
  padding: 15px 0px 0px 0px;
  margin-left: 22px;
}
.product-detail-wrap .style-section .style-recommendation-container .style-recommendation .recommendation-section .single-recommendation {
  width: 132px;
  height: 118px;
  cursor: pointer;
  margin-bottom: 4px;
}
.product-detail-wrap .style-section .style-recommendation-container .style-recommendation .recommendation-section .single-recommendation figure {
  margin-bottom: 5px;
}
.product-detail-wrap .style-section .style-recommendation-container .style-recommendation .recommendation-section .single-recommendation figure img {
  width: 60px;
  height: 60px;
}
.product-detail-wrap .style-section .style-recommendation-container .style-recommendation .recommendation-section .single-recommendation p {
  font-size: 10px;
  margin-bottom: 5px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.2;
  max-height: 2.4em;
}
.product-detail-wrap .style-section .style-recommendation-container .style-recommendation .recommendation-section .single-recommendation h6, .product-detail-wrap .style-section .style-recommendation-container .style-recommendation .recommendation-section .single-recommendation .h6 {
  font-size: 11px;
  font-weight: 700;
}
.product-detail-wrap .style-section .style-recommendation-container .p-carousel-indicator button {
  width: 8px;
  border-radius: 6px;
}
.product-detail-wrap .style-section .style-recommendation-container .p-carousel-indicator.p-highlight button {
  background-color: #5627D9;
}
.product-detail-wrap .style-section .style-recommendation-container .p-carousel-indicators {
  margin-bottom: 0px;
}
.product-detail-wrap .product-details-chat {
  display: flex;
  flex-direction: column;
  padding: 15px;
}
.product-detail-wrap.remove-product {
  top: 343px;
  left: 0;
  right: 0;
  bottom: 0;
}
@media (max-width: 575.98px) {
  .product-detail-wrap.remove-product {
    top: 130px;
  }
}
.product-detail-wrap.remove-product .product-details {
  position: relative;
  z-index: 11;
}
.product-detail-wrap.remove-product .product-details::before {
  content: "";
  background-color: rgba(0, 0, 0, 0.2);
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  position: fixed;
  z-index: -1;
}
.product-detail-wrap.remove-product .product-details .product-listing,
.product-detail-wrap.remove-product .product-details .pro-action-btn {
  background-color: #ffffff;
}
.product-detail-wrap.remove-product.similar-product .product-details .product-listing {
  height: calc(100vh - 572px);
}
@media (max-width: 575.98px) {
  .product-detail-wrap.remove-product.similar-product .product-details .product-listing {
    height: calc(100vh - 357px);
  }
}
.product-detail-wrap.remove-product.similar-product .product-details .product-listing-wrap {
  cursor: pointer;
}
.product-detail-wrap.remove-product .product-details .product-heading {
  padding: 15px 30px 0 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #ffffff;
  border-radius: 20px 20px 0 0;
}
.product-detail-wrap.remove-product .product-details .product-heading h5, .product-detail-wrap.remove-product .product-details .product-heading .h5 {
  font-weight: 500;
  font-size: 14px;
  color: #292929;
  margin-bottom: 0;
}
.product-detail-wrap.remove-product .product-details .product-listing {
  height: calc(100vh - 640px);
  overflow-y: auto;
  background-color: #ffffff;
}
@media (max-width: 575.98px) {
  .product-detail-wrap.remove-product .product-details .product-listing {
    height: calc(100vh - 427px);
  }
}
.product-detail-wrap.remove-product .product-details .product-listing-wrap {
  display: flex;
  flex-wrap: wrap;
  padding: 15px 30px;
  border-bottom: 1px solid #E1E1E1;
}
.product-detail-wrap.remove-product .product-details .product-listing-wrap .product-checkbox {
  margin-right: 15px;
}
.product-detail-wrap.remove-product .product-details .product-listing-wrap .product-right {
  display: flex;
  flex-wrap: wrap;
  width: calc(100% - 35px);
}
.product-detail-wrap.remove-product .product-details .product-listing-wrap .product-right figure {
  width: 55px;
  margin-bottom: 0;
  margin-right: 15px;
}
.product-detail-wrap.remove-product .product-details .product-listing-wrap .product-right figure img {
  width: 100%;
}
.product-detail-wrap.remove-product .product-details .product-listing-wrap .product-right .pro-sm-info {
  width: calc(100% - 70px);
}
.product-detail-wrap.remove-product .product-details .product-listing-wrap .product-right .pro-sm-info p {
  font-size: 12px;
  font-weight: 500;
  color: #292929;
  margin-bottom: 0;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.product-detail-wrap.remove-product .product-details .product-listing-wrap .product-right .pro-sm-info strong {
  font-size: 14px;
  color: #292929;
  font-weight: 700;
}
.product-detail-wrap.remove-product .product-details .product-listing-wrap .product-right .pro-sm-info .pro-review {
  font-size: 12px;
  font-weight: 400;
  color: #292929;
  display: flex;
  align-items: center;
}
.product-detail-wrap.remove-product .product-details .product-listing-wrap .product-right .pro-sm-info .pro-review i {
  line-height: 0;
  margin-right: 4px;
  display: flex;
  align-items: center;
}
.product-detail-wrap.remove-product .product-details .pro-action-btn {
  padding: 15px 30px;
}
.product-detail-wrap .compare-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  border-bottom: 1px solid #E1E1E1;
}
.product-detail-wrap .compare-head h5, .product-detail-wrap .compare-head .h5 {
  font-weight: 500;
  font-size: 14px;
  color: #292929;
  margin-bottom: 0;
}
.product-detail-wrap .compare-head .compare-head-right {
  display: flex;
  align-items: center;
}
.product-detail-wrap .compare-head .compare-head-right i {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.product-detail-wrap .compare-head .compare-head-right i.add-product {
  margin-right: 15px;
}
.product-detail-wrap .compare-product {
  display: flex;
  flex-wrap: wrap;
  height: calc(100vh - 365px);
  overflow-y: auto;
}
.product-detail-wrap .compare-product .compare-col {
  border-right: 1px solid #E1E1E1;
  width: 50%;
}
.product-detail-wrap .compare-product .compare-col:last-child {
  border-right: 0;
}
.product-detail-wrap .compare-product .compare-col .compare-top {
  padding: 15px;
  position: relative;
}
.product-detail-wrap .compare-product .compare-col .compare-top .remove-product {
  position: absolute;
  top: 4px;
  right: 4px;
  line-height: 0;
  cursor: pointer;
}
.product-detail-wrap .compare-product .compare-col .compare-top figure {
  width: 90px;
  max-width: 100%;
  margin: 0 auto 15px auto;
}
.product-detail-wrap .compare-product .compare-col .compare-top figure img {
  width: 100%;
}
.product-detail-wrap .compare-product .compare-col .compare-top .pro-sm-info p {
  font-size: 12px;
  font-weight: 500;
  color: #292929;
  margin-bottom: 0;
}
.product-detail-wrap .compare-product .compare-col .compare-top .pro-sm-info p .green-txt {
  color: #6FBE46;
}
.product-detail-wrap .compare-product .compare-col .compare-top .pro-sm-info strong {
  font-size: 14px;
  color: #292929;
  font-weight: 700;
}
.product-detail-wrap .compare-product .compare-col .compare-top .pro-sm-info .pro-review {
  font-size: 12px;
  font-weight: 400;
  color: #292929;
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}
.product-detail-wrap .compare-product .compare-col .compare-top .pro-sm-info .pro-review i {
  line-height: 0;
  margin-right: 4px;
  display: flex;
  align-items: center;
}
.product-detail-wrap .compare-product .compare-col .pro-seprator {
  background-color: #F1F1F1;
  font-size: 12px;
  color: #292929;
  padding: 3px 15px;
}
.product-detail-wrap .compare-product .compare-col .compare-bottom {
  padding: 15px;
}
.product-detail-wrap .compare-product .compare-col .compare-bottom p {
  font-size: 11px;
  margin-bottom: 5px;
}
.product-detail-wrap .compare-product .compare-col .compare-bottom p:last-child {
  margin-bottom: 0;
}
.product-detail-wrap .compare-product .compare-col.add-new-product .compare-top {
  text-align: center;
}
.product-detail-wrap .compare-product .compare-col.add-new-product .compare-top .btn-area {
  margin-bottom: 55px;
}
.product-detail-wrap .compare-product .compare-col.add-new-product .compare-top .btn-area button {
  width: 130px;
  max-width: 100%;
}
.product-detail-wrap .compare-product .compare-col.add-new-product .placeholder-img {
  height: 116px;
  width: 116px;
  background-color: #F1F1F1;
  border-radius: 10px;
  display: inline-block;
  margin-bottom: 10px;
}
.product-detail-wrap .compare-product .compare-col.add-new-product .pro-sm-info p,
.product-detail-wrap .compare-product .compare-col.add-new-product p {
  color: #919191;
  text-align: left;
}
.product-detail-wrap .compare-product.three-col .compare-col {
  width: 33.33%;
}

.suggest-img-wrap {
  padding-left: 0;
  list-style-type: none;
  display: flex;
  flex-wrap: wrap;
  margin: 0 -10px 15px -10px;
}
.suggest-img-wrap li {
  padding: 0 10px;
}
.suggest-img-wrap li figure {
  margin-bottom: 0;
  border: 2px solid #787878;
  border-radius: 10px;
  cursor: pointer;
}
.suggest-img-wrap li figure.active-suggest {
  border-color: #5627D9;
}
.suggest-img-wrap li figure img {
  height: 70px;
  width: 70px;
  object-fit: cover;
}

.choose-file {
  position: absolute;
  right: 15px;
  line-height: 0;
}
.choose-file label {
  cursor: pointer;
}
.choose-file input[type=file] {
  position: absolute;
  height: 0 !important;
  width: 0 !important;
  opacity: 0;
  visibility: hidden;
  padding: 0 !important;
}

.prodct-cart-body .product-detail-wrap {
  bottom: 20px;
  border-radius: 10px;
}
.prodct-cart-body .compare-head {
  padding: 10px;
}

.product-cart {
  overflow-x: auto;
}
.product-cart .p-datatable .p-datatable-wrapper {
  height: calc(100vh - 410px);
}
.product-cart table {
  width: 100%;
}
.product-cart th,
.product-cart td {
  padding: 10px;
  font-size: 14px;
}
.product-cart th .delete-product,
.product-cart td .delete-product {
  display: inline-block;
  cursor: pointer;
}
@media (max-width: 575.98px) {
  .product-cart th,
  .product-cart td {
    font-size: 12px;
  }
}
.product-cart th {
  border-bottom: 1px solid #E1E1E1;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/custom.scss","webpack://./node_modules/bootstrap/scss/mixins/_banner.scss","webpack://./node_modules/bootstrap/scss/_root.scss","webpack://./node_modules/bootstrap/scss/vendor/_rfs.scss","webpack://./node_modules/bootstrap/scss/mixins/_color-mode.scss","webpack://./node_modules/bootstrap/scss/_reboot.scss","webpack://./node_modules/bootstrap/scss/_variables.scss","webpack://./node_modules/bootstrap/scss/mixins/_border-radius.scss","webpack://./node_modules/bootstrap/scss/_type.scss","webpack://./node_modules/bootstrap/scss/mixins/_lists.scss","webpack://./node_modules/bootstrap/scss/_images.scss","webpack://./node_modules/bootstrap/scss/mixins/_image.scss","webpack://./node_modules/bootstrap/scss/_containers.scss","webpack://./node_modules/bootstrap/scss/mixins/_container.scss","webpack://./node_modules/bootstrap/scss/mixins/_breakpoints.scss","webpack://./node_modules/bootstrap/scss/_grid.scss","webpack://./node_modules/bootstrap/scss/mixins/_grid.scss","webpack://./node_modules/bootstrap/scss/_tables.scss","webpack://./node_modules/bootstrap/scss/mixins/_table-variants.scss","webpack://./node_modules/bootstrap/scss/forms/_labels.scss","webpack://./node_modules/bootstrap/scss/forms/_form-text.scss","webpack://./node_modules/bootstrap/scss/forms/_form-control.scss","webpack://./node_modules/bootstrap/scss/mixins/_transition.scss","webpack://./node_modules/bootstrap/scss/mixins/_gradients.scss","webpack://./node_modules/bootstrap/scss/forms/_form-select.scss","webpack://./node_modules/bootstrap/scss/forms/_form-check.scss","webpack://./node_modules/bootstrap/scss/forms/_form-range.scss","webpack://./node_modules/bootstrap/scss/forms/_floating-labels.scss","webpack://./node_modules/bootstrap/scss/forms/_input-group.scss","webpack://./node_modules/bootstrap/scss/mixins/_forms.scss","webpack://./node_modules/bootstrap/scss/_buttons.scss","webpack://./node_modules/bootstrap/scss/mixins/_buttons.scss","webpack://./node_modules/bootstrap/scss/_transitions.scss","webpack://./node_modules/bootstrap/scss/_dropdown.scss","webpack://./node_modules/bootstrap/scss/mixins/_caret.scss","webpack://./node_modules/bootstrap/scss/_button-group.scss","webpack://./node_modules/bootstrap/scss/_nav.scss","webpack://./node_modules/bootstrap/scss/_navbar.scss","webpack://./node_modules/bootstrap/scss/_card.scss","webpack://./node_modules/bootstrap/scss/_accordion.scss","webpack://./node_modules/bootstrap/scss/_breadcrumb.scss","webpack://./node_modules/bootstrap/scss/_pagination.scss","webpack://./node_modules/bootstrap/scss/mixins/_pagination.scss","webpack://./node_modules/bootstrap/scss/_badge.scss","webpack://./node_modules/bootstrap/scss/_alert.scss","webpack://./node_modules/bootstrap/scss/_progress.scss","webpack://./node_modules/bootstrap/scss/_list-group.scss","webpack://./node_modules/bootstrap/scss/_close.scss","webpack://./node_modules/bootstrap/scss/_toasts.scss","webpack://./node_modules/bootstrap/scss/_modal.scss","webpack://./node_modules/bootstrap/scss/mixins/_backdrop.scss","webpack://./node_modules/bootstrap/scss/_tooltip.scss","webpack://./node_modules/bootstrap/scss/mixins/_reset-text.scss","webpack://./node_modules/bootstrap/scss/_popover.scss","webpack://./node_modules/bootstrap/scss/_carousel.scss","webpack://./node_modules/bootstrap/scss/mixins/_clearfix.scss","webpack://./node_modules/bootstrap/scss/_spinners.scss","webpack://./node_modules/bootstrap/scss/_offcanvas.scss","webpack://./node_modules/bootstrap/scss/_placeholders.scss","webpack://./node_modules/bootstrap/scss/helpers/_color-bg.scss","webpack://./node_modules/bootstrap/scss/helpers/_colored-links.scss","webpack://./node_modules/bootstrap/scss/helpers/_focus-ring.scss","webpack://./node_modules/bootstrap/scss/helpers/_icon-link.scss","webpack://./node_modules/bootstrap/scss/helpers/_ratio.scss","webpack://./node_modules/bootstrap/scss/helpers/_position.scss","webpack://./node_modules/bootstrap/scss/helpers/_stacks.scss","webpack://./node_modules/bootstrap/scss/helpers/_visually-hidden.scss","webpack://./node_modules/bootstrap/scss/mixins/_visually-hidden.scss","webpack://./node_modules/bootstrap/scss/helpers/_stretched-link.scss","webpack://./node_modules/bootstrap/scss/helpers/_text-truncation.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-truncate.scss","webpack://./node_modules/bootstrap/scss/helpers/_vr.scss","webpack://./node_modules/bootstrap/scss/mixins/_utilities.scss","webpack://./node_modules/bootstrap/scss/utilities/_api.scss","webpack://./src/assets/styles/base/_type.scss","webpack://./src/assets/styles/base/_colors.scss","webpack://./src/assets/styles/base/_form.scss","webpack://./src/assets/styles/base/_button.scss","webpack://./src/assets/styles/base/_tabs.scss","webpack://./src/assets/styles/components/_data-table.scss","webpack://./src/assets/styles/components/_home.scss","webpack://./src/assets/styles/components/_chat-history.scss","webpack://./src/assets/styles/components/_chatBot.scss","webpack://./src/assets/styles/components/_global.scss","webpack://./src/assets/styles/components/_shopmate.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACCd;;;;EAAA;ACDF;;EASI,kBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,oBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,gBAAA;EAAA,gBAAA;EAAA,kBAAA;EAAA,uBAAA;EAIA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAIA,qBAAA;EAAA,uBAAA;EAAA,qBAAA;EAAA,kBAAA;EAAA,qBAAA;EAAA,oBAAA;EAAA,mBAAA;EAAA,kBAAA;EAIA,8BAAA;EAAA,iCAAA;EAAA,6BAAA;EAAA,2BAAA;EAAA,6BAAA;EAAA,4BAAA;EAAA,6BAAA;EAAA,yBAAA;EAIA,+CAAA;EAAA,iDAAA;EAAA,6CAAA;EAAA,2CAAA;EAAA,+CAAA;EAAA,8CAAA;EAAA,iCAAA;EAAA,gCAAA;EAIA,8CAAA;EAAA,gDAAA;EAAA,4CAAA;EAAA,2CAAA;EAAA,8CAAA;EAAA,6CAAA;EAAA,4CAAA;EAAA,4BAAA;EAIA,kDAAA;EAAA,oDAAA;EAAA,gDAAA;EAAA,+CAAA;EAAA,kDAAA;EAAA,iDAAA;EAAA,iCAAA;EAAA,gCAAA;EAGF,6BAAA;EACA,uBAAA;EAMA,qNAAA;EACA,yGAAA;EACA,yFAAA;EAOA,gDAAA;EC2OI,yBALI;EDpOR,0BAAA;EACA,0BAAA;EAKA,wBAAA;EACA,+BAAA;EACA,kBAAA;EACA,+BAAA;EAEA,yBAAA;EACA,gCAAA;EAEA,4CAAA;EACA,oCAAA;EACA,0BAAA;EACA,oCAAA;EAEA,0CAAA;EACA,mCAAA;EACA,yBAAA;EACA,mCAAA;EAGA,2BAAA;EAEA,wBAAA;EACA,iCAAA;EACA,+BAAA;EAEA,2CAAA;EACA,sCAAA;EAMA,wBAAA;EACA,6BAAA;EACA,yCAAA;EAGA,sBAAA;EACA,wBAAA;EACA,0BAAA;EACA,mDAAA;EAEA,4BAAA;EACA,8BAAA;EACA,6BAAA;EACA,2BAAA;EACA,4BAAA;EACA,mDAAA;EACA,8BAAA;EAGA,kDAAA;EACA,2DAAA;EACA,oDAAA;EACA,2DAAA;EAIA,8BAAA;EACA,6BAAA;EACA,+CAAA;EAIA,8BAAA;EACA,qCAAA;EACA,gCAAA;EACA,uCAAA;AFDF;;AI/GI;EFsHA,kBAAA;EAGA,wBAAA;EACA,kCAAA;EACA,qBAAA;EACA,4BAAA;EAEA,yBAAA;EACA,sCAAA;EAEA,+CAAA;EACA,uCAAA;EACA,0BAAA;EACA,iCAAA;EAEA,6CAAA;EACA,sCAAA;EACA,uCAAA;EACA,gCAAA;EAGE,kDAAA;EAAA,oDAAA;EAAA,gDAAA;EAAA,+CAAA;EAAA,kDAAA;EAAA,iDAAA;EAAA,iCAAA;EAAA,gCAAA;EAIA,0CAAA;EAAA,6CAAA;EAAA,wCAAA;EAAA,uCAAA;EAAA,0CAAA;EAAA,0CAAA;EAAA,6BAAA;EAAA,4BAAA;EAIA,+CAAA;EAAA,iDAAA;EAAA,6CAAA;EAAA,6CAAA;EAAA,gDAAA;EAAA,+CAAA;EAAA,iCAAA;EAAA,gCAAA;EAGF,2BAAA;EAEA,uCAAA;EACA,iDAAA;EACA,kCAAA;EACA,wCAAA;EAEA,yCAAA;EACA,6BAAA;EACA,sCAAA;EAEA,0BAAA;EACA,wDAAA;EAEA,2CAAA;EACA,kDAAA;EACA,+CAAA;EACA,sDAAA;AFDJ;;AKvKA;;;EAGE,sBAAA;AL0KF;;AK3JI;EANJ;IAOM,uBAAA;EL+JJ;AACF;;AKlJA;EACE,SAAA;EACA,uCAAA;EF6OI,mCALI;EEtOR,uCAAA;EACA,uCAAA;EACA,2BAAA;EACA,qCAAA;EACA,mCAAA;EACA,8BAAA;EACA,6CAAA;ALqJF;;AK5IA;EACE,cAAA;EACA,cCmnB4B;EDlnB5B,SAAA;EACA,wCAAA;EACA,aCynB4B;AN1e9B;;AKrIA;EACE,aAAA;EACA,qBCwjB4B;EDrjB5B,gBCwjB4B;EDvjB5B,gBCwjB4B;EDvjB5B,8BAAA;ALsIF;;AKnIA;EFuMQ,iCAAA;AHhER;AG5FI;EE3CJ;IF8MQ,iBAAA;EHnEN;AACF;;AKvIA;EFkMQ,iCAAA;AHvDR;AGrGI;EEtCJ;IFyMQ,eAAA;EH1DN;AACF;;AK3IA;EF6LQ,+BAAA;AH9CR;AG9GI;EEjCJ;IFoMQ,kBAAA;EHjDN;AACF;;AK/IA;EFwLQ,iCAAA;AHrCR;AGvHI;EE5BJ;IF+LQ,iBAAA;EHxCN;AACF;;AKnJA;EF+KM,kBALI;AHnBV;;AKlJA;EF0KM,eALI;AHfV;;AK3IA;EACE,aAAA;EACA,mBCwV0B;AN1M5B;;AKpIA;EACE,yCAAA;UAAA,iCAAA;EACA,YAAA;EACA,8BAAA;ALuIF;;AKjIA;EACE,mBAAA;EACA,kBAAA;EACA,oBAAA;ALoIF;;AK9HA;;EAEE,kBAAA;ALiIF;;AK9HA;;;EAGE,aAAA;EACA,mBAAA;ALiIF;;AK9HA;;;;EAIE,gBAAA;ALiIF;;AK9HA;EACE,gBC6b4B;AN5T9B;;AK5HA;EACE,qBAAA;EACA,cAAA;AL+HF;;AKzHA;EACE,gBAAA;AL4HF;;AKpHA;;EAEE,mBCsa4B;AN/S9B;;AK/GA;EF6EM,kBALI;AH2CV;;AK5GA;EACE,iBCqf4B;EDpf5B,gCAAA;EACA,wCAAA;AL+GF;;AKtGA;;EAEE,kBAAA;EFwDI,iBALI;EEjDR,cAAA;EACA,wBAAA;ALyGF;;AKtGA;EAAM,eAAA;AL0GN;;AKzGA;EAAM,WAAA;AL6GN;;AKxGA;EACE,gEAAA;EACA,0BCgNwC;ANrG1C;AKzGE;EACE,mDAAA;AL2GJ;;AKhGE;EAEE,cAAA;EACA,qBAAA;ALkGJ;;AK3FA;;;;EAIE,qCCgV4B;EHlUxB,cALI;AHsFV;;AKvFA;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EFEI,kBALI;AH8FV;AKtFE;EFHI,kBALI;EEUN,cAAA;EACA,kBAAA;ALwFJ;;AKpFA;EFVM,kBALI;EEiBR,2BAAA;EACA,qBAAA;ALuFF;AKpFE;EACE,cAAA;ALsFJ;;AKlFA;EACE,2BAAA;EFtBI,kBALI;EE6BR,wBC25CkC;ED15ClC,sCC25CkC;EChsDhC,sBAAA;AP2XJ;AKnFE;EACE,UAAA;EF7BE,cALI;AHwHV;;AK3EA;EACE,gBAAA;AL8EF;;AKxEA;;EAEE,sBAAA;AL2EF;;AKnEA;EACE,oBAAA;EACA,yBAAA;ALsEF;;AKnEA;EACE,mBC4X4B;ED3X5B,sBC2X4B;ED1X5B,gCC4Z4B;ED3Z5B,gBAAA;ALsEF;;AK/DA;EAEE,mBAAA;EACA,gCAAA;ALiEF;;AK9DA;;;;;;EAME,qBAAA;EACA,mBAAA;EACA,eAAA;ALiEF;;AKzDA;EACE,qBAAA;AL4DF;;AKtDA;EAEE,gBAAA;ALwDF;;AKhDA;EACE,UAAA;ALmDF;;AK9CA;;;;;EAKE,SAAA;EACA,oBAAA;EF5HI,kBALI;EEmIR,oBAAA;ALiDF;;AK7CA;;EAEE,oBAAA;ALgDF;;AK3CA;EACE,eAAA;AL8CF;;AK3CA;EAGE,iBAAA;AL4CF;AKzCE;EACE,UAAA;AL2CJ;;AKpCA;EACE,wBAAA;ALuCF;;AK/BA;;;;EAIE,0BAAA;ALkCF;AK/BI;;;;EACE,eAAA;ALoCN;;AK7BA;EACE,UAAA;EACA,kBAAA;ALgCF;;AK3BA;EACE,gBAAA;AL8BF;;AKpBA;EACE,YAAA;EACA,UAAA;EACA,SAAA;EACA,SAAA;ALuBF;;AKfA;EACE,WAAA;EACA,WAAA;EACA,UAAA;EACA,qBCmN4B;EDjN5B,oBAAA;EFnNM,iCAAA;AHqOR;AGjYI;EEyWJ;IFtMQ,iBAAA;EHkON;AACF;AKpBE;EACE,WAAA;ALsBJ;;AKfA;;;;;;;EAOE,UAAA;ALkBF;;AKfA;EACE,YAAA;ALkBF;;AKTA;EACE,6BAAA;EACA,oBAAA;ALYF;AKTE;EACE,eAAA;EACA,oBAAA;ALWJ;;AKFA;;;;;;;CAAA;AAWA;EACE,wBAAA;ALEF;;AKGA;EACE,UAAA;ALAF;;AKOA;EACE,aAAA;EACA,0BAAA;ALJF;;AKSA;EACE,qBAAA;ALNF;;AKWA;EACE,SAAA;ALRF;;AKeA;EACE,kBAAA;EACA,eAAA;ALZF;;AKoBA;EACE,wBAAA;ALjBF;;AKyBA;EACE,wBAAA;ALtBF;;AQrjBA;ELmQM,kBALI;EK5PR,gBFwoB4B;ANhF9B;;AQnjBE;EAGE,gBF0nBkB;EEznBlB,gBFymB0B;EH7WtB,iCAAA;AHyTR;AGrdI;EKpGF;ILuQM,eAAA;EHsTN;AACF;;AQ9jBE;EAGE,gBF0nBkB;EEznBlB,gBFymB0B;EH7WtB,iCAAA;AHoUR;AGheI;EKpGF;ILuQM,iBAAA;EHiUN;AACF;;AQzkBE;EAGE,gBF0nBkB;EEznBlB,gBFymB0B;EH7WtB,iCAAA;AH+UR;AG3eI;EKpGF;ILuQM,eAAA;EH4UN;AACF;;AQplBE;EAGE,gBF0nBkB;EEznBlB,gBFymB0B;EH7WtB,iCAAA;AH0VR;AGtfI;EKpGF;ILuQM,iBAAA;EHuVN;AACF;;AQ/lBE;EAGE,gBF0nBkB;EEznBlB,gBFymB0B;EH7WtB,iCAAA;AHqWR;AGjgBI;EKpGF;ILuQM,eAAA;EHkWN;AACF;;AQ1mBE;EAGE,gBF0nBkB;EEznBlB,gBFymB0B;EH7WtB,iCAAA;AHgXR;AG5gBI;EKpGF;ILuQM,iBAAA;EH6WN;AACF;;AQ7lBA;ECvDE,eAAA;EACA,gBAAA;ATwpBF;;AQ7lBA;EC5DE,eAAA;EACA,gBAAA;AT6pBF;;AQ/lBA;EACE,qBAAA;ARkmBF;AQhmBE;EACE,oBFsoB0B;ANpC9B;;AQxlBA;EL8MM,kBALI;EKvMR,yBAAA;AR2lBF;;AQvlBA;EACE,mBFiUO;EH1HH,kBALI;AHyZV;AQxlBE;EACE,gBAAA;AR0lBJ;;AQtlBA;EACE,iBAAA;EACA,mBFuTO;EH1HH,kBALI;EKtLR,cFtFS;AN+qBX;AQvlBE;EACE,aAAA;ARylBJ;;AUzrBA;ECIE,eAAA;EAGA,YAAA;AXurBF;;AUxrBA;EACE,gBJ+jDkC;EI9jDlC,mCJ+jDkC;EI9jDlC,2DAAA;EHGE,sCAAA;EIRF,eAAA;EAGA,YAAA;AXgsBF;;AUlrBA;EAEE,qBAAA;AVorBF;;AUjrBA;EACE,qBAAA;EACA,cAAA;AVorBF;;AUjrBA;EPyPM,kBALI;EOlPR,gCJkjDkC;AN93BpC;;AYttBE;;;;;;;ECHA,qBAAA;EACA,gBAAA;EACA,WAAA;EACA,6CAAA;EACA,4CAAA;EACA,kBAAA;EACA,iBAAA;AbmuBF;;Ac7qBI;EF5CE;IACE,gBNkee;EN2PrB;AACF;AcnrBI;EF5CE;IACE,gBNkee;ENgQrB;AACF;AcxrBI;EF5CE;IACE,gBNkee;ENqQrB;AACF;Ac7rBI;EF5CE;IACE,iBNkee;EN0QrB;AACF;AclsBI;EF5CE;IACE,iBNkee;EN+QrB;AACF;AelwBA;EAEI,qBAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,yBAAA;EAAA,0BAAA;EAAA,2BAAA;AfwwBJ;;AenwBE;ECNA,qBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EAEA,yCAAA;EACA,6CAAA;EACA,4CAAA;AhB4wBF;Ae1wBI;ECOF,cAAA;EACA,WAAA;EACA,eAAA;EACA,6CAAA;EACA,4CAAA;EACA,8BAAA;AhBswBF;;AgBvtBM;EACE,SAAA;AhB0tBR;;AgBvtBM;EApCJ,cAAA;EACA,WAAA;AhB+vBF;;AgBjvBE;EACE,cAAA;EACA,WAAA;AhBovBJ;;AgBtvBE;EACE,cAAA;EACA,UAAA;AhByvBJ;;AgB3vBE;EACE,cAAA;EACA,mBAAA;AhB8vBJ;;AgBhwBE;EACE,cAAA;EACA,UAAA;AhBmwBJ;;AgBrwBE;EACE,cAAA;EACA,UAAA;AhBwwBJ;;AgB1wBE;EACE,cAAA;EACA,mBAAA;AhB6wBJ;;AgB9uBM;EAhDJ,cAAA;EACA,WAAA;AhBkyBF;;AgB7uBU;EAhEN,cAAA;EACA,kBAAA;AhBizBJ;;AgBlvBU;EAhEN,cAAA;EACA,mBAAA;AhBszBJ;;AgBvvBU;EAhEN,cAAA;EACA,UAAA;AhB2zBJ;;AgB5vBU;EAhEN,cAAA;EACA,mBAAA;AhBg0BJ;;AgBjwBU;EAhEN,cAAA;EACA,mBAAA;AhBq0BJ;;AgBtwBU;EAhEN,cAAA;EACA,UAAA;AhB00BJ;;AgB3wBU;EAhEN,cAAA;EACA,mBAAA;AhB+0BJ;;AgBhxBU;EAhEN,cAAA;EACA,mBAAA;AhBo1BJ;;AgBrxBU;EAhEN,cAAA;EACA,UAAA;AhBy1BJ;;AgB1xBU;EAhEN,cAAA;EACA,mBAAA;AhB81BJ;;AgB/xBU;EAhEN,cAAA;EACA,mBAAA;AhBm2BJ;;AgBpyBU;EAhEN,cAAA;EACA,WAAA;AhBw2BJ;;AgBjyBY;EAxDV,wBAAA;AhB61BF;;AgBryBY;EAxDV,yBAAA;AhBi2BF;;AgBzyBY;EAxDV,gBAAA;AhBq2BF;;AgB7yBY;EAxDV,yBAAA;AhBy2BF;;AgBjzBY;EAxDV,yBAAA;AhB62BF;;AgBrzBY;EAxDV,gBAAA;AhBi3BF;;AgBzzBY;EAxDV,yBAAA;AhBq3BF;;AgB7zBY;EAxDV,yBAAA;AhBy3BF;;AgBj0BY;EAxDV,gBAAA;AhB63BF;;AgBr0BY;EAxDV,yBAAA;AhBi4BF;;AgBz0BY;EAxDV,yBAAA;AhBq4BF;;AgBl0BQ;;EAEE,gBAAA;AhBq0BV;;AgBl0BQ;;EAEE,gBAAA;AhBq0BV;;AgB50BQ;;EAEE,sBAAA;AhB+0BV;;AgB50BQ;;EAEE,sBAAA;AhB+0BV;;AgBt1BQ;;EAEE,qBAAA;AhBy1BV;;AgBt1BQ;;EAEE,qBAAA;AhBy1BV;;AgBh2BQ;;EAEE,mBAAA;AhBm2BV;;AgBh2BQ;;EAEE,mBAAA;AhBm2BV;;AgB12BQ;;EAEE,qBAAA;AhB62BV;;AgB12BQ;;EAEE,qBAAA;AhB62BV;;AgBp3BQ;;EAEE,mBAAA;AhBu3BV;;AgBp3BQ;;EAEE,mBAAA;AhBu3BV;;Acj7BI;EEUE;IACE,SAAA;EhB26BN;EgBx6BI;IApCJ,cAAA;IACA,WAAA;EhB+8BA;EgBj8BA;IACE,cAAA;IACA,WAAA;EhBm8BF;EgBr8BA;IACE,cAAA;IACA,UAAA;EhBu8BF;EgBz8BA;IACE,cAAA;IACA,mBAAA;EhB28BF;EgB78BA;IACE,cAAA;IACA,UAAA;EhB+8BF;EgBj9BA;IACE,cAAA;IACA,UAAA;EhBm9BF;EgBr9BA;IACE,cAAA;IACA,mBAAA;EhBu9BF;EgBx7BI;IAhDJ,cAAA;IACA,WAAA;EhB2+BA;EgBt7BQ;IAhEN,cAAA;IACA,kBAAA;EhBy/BF;EgB17BQ;IAhEN,cAAA;IACA,mBAAA;EhB6/BF;EgB97BQ;IAhEN,cAAA;IACA,UAAA;EhBigCF;EgBl8BQ;IAhEN,cAAA;IACA,mBAAA;EhBqgCF;EgBt8BQ;IAhEN,cAAA;IACA,mBAAA;EhBygCF;EgB18BQ;IAhEN,cAAA;IACA,UAAA;EhB6gCF;EgB98BQ;IAhEN,cAAA;IACA,mBAAA;EhBihCF;EgBl9BQ;IAhEN,cAAA;IACA,mBAAA;EhBqhCF;EgBt9BQ;IAhEN,cAAA;IACA,UAAA;EhByhCF;EgB19BQ;IAhEN,cAAA;IACA,mBAAA;EhB6hCF;EgB99BQ;IAhEN,cAAA;IACA,mBAAA;EhBiiCF;EgBl+BQ;IAhEN,cAAA;IACA,WAAA;EhBqiCF;EgB99BU;IAxDV,cAAA;EhByhCA;EgBj+BU;IAxDV,wBAAA;EhB4hCA;EgBp+BU;IAxDV,yBAAA;EhB+hCA;EgBv+BU;IAxDV,gBAAA;EhBkiCA;EgB1+BU;IAxDV,yBAAA;EhBqiCA;EgB7+BU;IAxDV,yBAAA;EhBwiCA;EgBh/BU;IAxDV,gBAAA;EhB2iCA;EgBn/BU;IAxDV,yBAAA;EhB8iCA;EgBt/BU;IAxDV,yBAAA;EhBijCA;EgBz/BU;IAxDV,gBAAA;EhBojCA;EgB5/BU;IAxDV,yBAAA;EhBujCA;EgB//BU;IAxDV,yBAAA;EhB0jCA;EgBv/BM;;IAEE,gBAAA;EhBy/BR;EgBt/BM;;IAEE,gBAAA;EhBw/BR;EgB//BM;;IAEE,sBAAA;EhBigCR;EgB9/BM;;IAEE,sBAAA;EhBggCR;EgBvgCM;;IAEE,qBAAA;EhBygCR;EgBtgCM;;IAEE,qBAAA;EhBwgCR;EgB/gCM;;IAEE,mBAAA;EhBihCR;EgB9gCM;;IAEE,mBAAA;EhBghCR;EgBvhCM;;IAEE,qBAAA;EhByhCR;EgBthCM;;IAEE,qBAAA;EhBwhCR;EgB/hCM;;IAEE,mBAAA;EhBiiCR;EgB9hCM;;IAEE,mBAAA;EhBgiCR;AACF;Ac3lCI;EEUE;IACE,SAAA;EhBolCN;EgBjlCI;IApCJ,cAAA;IACA,WAAA;EhBwnCA;EgB1mCA;IACE,cAAA;IACA,WAAA;EhB4mCF;EgB9mCA;IACE,cAAA;IACA,UAAA;EhBgnCF;EgBlnCA;IACE,cAAA;IACA,mBAAA;EhBonCF;EgBtnCA;IACE,cAAA;IACA,UAAA;EhBwnCF;EgB1nCA;IACE,cAAA;IACA,UAAA;EhB4nCF;EgB9nCA;IACE,cAAA;IACA,mBAAA;EhBgoCF;EgBjmCI;IAhDJ,cAAA;IACA,WAAA;EhBopCA;EgB/lCQ;IAhEN,cAAA;IACA,kBAAA;EhBkqCF;EgBnmCQ;IAhEN,cAAA;IACA,mBAAA;EhBsqCF;EgBvmCQ;IAhEN,cAAA;IACA,UAAA;EhB0qCF;EgB3mCQ;IAhEN,cAAA;IACA,mBAAA;EhB8qCF;EgB/mCQ;IAhEN,cAAA;IACA,mBAAA;EhBkrCF;EgBnnCQ;IAhEN,cAAA;IACA,UAAA;EhBsrCF;EgBvnCQ;IAhEN,cAAA;IACA,mBAAA;EhB0rCF;EgB3nCQ;IAhEN,cAAA;IACA,mBAAA;EhB8rCF;EgB/nCQ;IAhEN,cAAA;IACA,UAAA;EhBksCF;EgBnoCQ;IAhEN,cAAA;IACA,mBAAA;EhBssCF;EgBvoCQ;IAhEN,cAAA;IACA,mBAAA;EhB0sCF;EgB3oCQ;IAhEN,cAAA;IACA,WAAA;EhB8sCF;EgBvoCU;IAxDV,cAAA;EhBksCA;EgB1oCU;IAxDV,wBAAA;EhBqsCA;EgB7oCU;IAxDV,yBAAA;EhBwsCA;EgBhpCU;IAxDV,gBAAA;EhB2sCA;EgBnpCU;IAxDV,yBAAA;EhB8sCA;EgBtpCU;IAxDV,yBAAA;EhBitCA;EgBzpCU;IAxDV,gBAAA;EhBotCA;EgB5pCU;IAxDV,yBAAA;EhButCA;EgB/pCU;IAxDV,yBAAA;EhB0tCA;EgBlqCU;IAxDV,gBAAA;EhB6tCA;EgBrqCU;IAxDV,yBAAA;EhBguCA;EgBxqCU;IAxDV,yBAAA;EhBmuCA;EgBhqCM;;IAEE,gBAAA;EhBkqCR;EgB/pCM;;IAEE,gBAAA;EhBiqCR;EgBxqCM;;IAEE,sBAAA;EhB0qCR;EgBvqCM;;IAEE,sBAAA;EhByqCR;EgBhrCM;;IAEE,qBAAA;EhBkrCR;EgB/qCM;;IAEE,qBAAA;EhBirCR;EgBxrCM;;IAEE,mBAAA;EhB0rCR;EgBvrCM;;IAEE,mBAAA;EhByrCR;EgBhsCM;;IAEE,qBAAA;EhBksCR;EgB/rCM;;IAEE,qBAAA;EhBisCR;EgBxsCM;;IAEE,mBAAA;EhB0sCR;EgBvsCM;;IAEE,mBAAA;EhBysCR;AACF;AcpwCI;EEUE;IACE,SAAA;EhB6vCN;EgB1vCI;IApCJ,cAAA;IACA,WAAA;EhBiyCA;EgBnxCA;IACE,cAAA;IACA,WAAA;EhBqxCF;EgBvxCA;IACE,cAAA;IACA,UAAA;EhByxCF;EgB3xCA;IACE,cAAA;IACA,mBAAA;EhB6xCF;EgB/xCA;IACE,cAAA;IACA,UAAA;EhBiyCF;EgBnyCA;IACE,cAAA;IACA,UAAA;EhBqyCF;EgBvyCA;IACE,cAAA;IACA,mBAAA;EhByyCF;EgB1wCI;IAhDJ,cAAA;IACA,WAAA;EhB6zCA;EgBxwCQ;IAhEN,cAAA;IACA,kBAAA;EhB20CF;EgB5wCQ;IAhEN,cAAA;IACA,mBAAA;EhB+0CF;EgBhxCQ;IAhEN,cAAA;IACA,UAAA;EhBm1CF;EgBpxCQ;IAhEN,cAAA;IACA,mBAAA;EhBu1CF;EgBxxCQ;IAhEN,cAAA;IACA,mBAAA;EhB21CF;EgB5xCQ;IAhEN,cAAA;IACA,UAAA;EhB+1CF;EgBhyCQ;IAhEN,cAAA;IACA,mBAAA;EhBm2CF;EgBpyCQ;IAhEN,cAAA;IACA,mBAAA;EhBu2CF;EgBxyCQ;IAhEN,cAAA;IACA,UAAA;EhB22CF;EgB5yCQ;IAhEN,cAAA;IACA,mBAAA;EhB+2CF;EgBhzCQ;IAhEN,cAAA;IACA,mBAAA;EhBm3CF;EgBpzCQ;IAhEN,cAAA;IACA,WAAA;EhBu3CF;EgBhzCU;IAxDV,cAAA;EhB22CA;EgBnzCU;IAxDV,wBAAA;EhB82CA;EgBtzCU;IAxDV,yBAAA;EhBi3CA;EgBzzCU;IAxDV,gBAAA;EhBo3CA;EgB5zCU;IAxDV,yBAAA;EhBu3CA;EgB/zCU;IAxDV,yBAAA;EhB03CA;EgBl0CU;IAxDV,gBAAA;EhB63CA;EgBr0CU;IAxDV,yBAAA;EhBg4CA;EgBx0CU;IAxDV,yBAAA;EhBm4CA;EgB30CU;IAxDV,gBAAA;EhBs4CA;EgB90CU;IAxDV,yBAAA;EhBy4CA;EgBj1CU;IAxDV,yBAAA;EhB44CA;EgBz0CM;;IAEE,gBAAA;EhB20CR;EgBx0CM;;IAEE,gBAAA;EhB00CR;EgBj1CM;;IAEE,sBAAA;EhBm1CR;EgBh1CM;;IAEE,sBAAA;EhBk1CR;EgBz1CM;;IAEE,qBAAA;EhB21CR;EgBx1CM;;IAEE,qBAAA;EhB01CR;EgBj2CM;;IAEE,mBAAA;EhBm2CR;EgBh2CM;;IAEE,mBAAA;EhBk2CR;EgBz2CM;;IAEE,qBAAA;EhB22CR;EgBx2CM;;IAEE,qBAAA;EhB02CR;EgBj3CM;;IAEE,mBAAA;EhBm3CR;EgBh3CM;;IAEE,mBAAA;EhBk3CR;AACF;Ac76CI;EEUE;IACE,SAAA;EhBs6CN;EgBn6CI;IApCJ,cAAA;IACA,WAAA;EhB08CA;EgB57CA;IACE,cAAA;IACA,WAAA;EhB87CF;EgBh8CA;IACE,cAAA;IACA,UAAA;EhBk8CF;EgBp8CA;IACE,cAAA;IACA,mBAAA;EhBs8CF;EgBx8CA;IACE,cAAA;IACA,UAAA;EhB08CF;EgB58CA;IACE,cAAA;IACA,UAAA;EhB88CF;EgBh9CA;IACE,cAAA;IACA,mBAAA;EhBk9CF;EgBn7CI;IAhDJ,cAAA;IACA,WAAA;EhBs+CA;EgBj7CQ;IAhEN,cAAA;IACA,kBAAA;EhBo/CF;EgBr7CQ;IAhEN,cAAA;IACA,mBAAA;EhBw/CF;EgBz7CQ;IAhEN,cAAA;IACA,UAAA;EhB4/CF;EgB77CQ;IAhEN,cAAA;IACA,mBAAA;EhBggDF;EgBj8CQ;IAhEN,cAAA;IACA,mBAAA;EhBogDF;EgBr8CQ;IAhEN,cAAA;IACA,UAAA;EhBwgDF;EgBz8CQ;IAhEN,cAAA;IACA,mBAAA;EhB4gDF;EgB78CQ;IAhEN,cAAA;IACA,mBAAA;EhBghDF;EgBj9CQ;IAhEN,cAAA;IACA,UAAA;EhBohDF;EgBr9CQ;IAhEN,cAAA;IACA,mBAAA;EhBwhDF;EgBz9CQ;IAhEN,cAAA;IACA,mBAAA;EhB4hDF;EgB79CQ;IAhEN,cAAA;IACA,WAAA;EhBgiDF;EgBz9CU;IAxDV,cAAA;EhBohDA;EgB59CU;IAxDV,wBAAA;EhBuhDA;EgB/9CU;IAxDV,yBAAA;EhB0hDA;EgBl+CU;IAxDV,gBAAA;EhB6hDA;EgBr+CU;IAxDV,yBAAA;EhBgiDA;EgBx+CU;IAxDV,yBAAA;EhBmiDA;EgB3+CU;IAxDV,gBAAA;EhBsiDA;EgB9+CU;IAxDV,yBAAA;EhByiDA;EgBj/CU;IAxDV,yBAAA;EhB4iDA;EgBp/CU;IAxDV,gBAAA;EhB+iDA;EgBv/CU;IAxDV,yBAAA;EhBkjDA;EgB1/CU;IAxDV,yBAAA;EhBqjDA;EgBl/CM;;IAEE,gBAAA;EhBo/CR;EgBj/CM;;IAEE,gBAAA;EhBm/CR;EgB1/CM;;IAEE,sBAAA;EhB4/CR;EgBz/CM;;IAEE,sBAAA;EhB2/CR;EgBlgDM;;IAEE,qBAAA;EhBogDR;EgBjgDM;;IAEE,qBAAA;EhBmgDR;EgB1gDM;;IAEE,mBAAA;EhB4gDR;EgBzgDM;;IAEE,mBAAA;EhB2gDR;EgBlhDM;;IAEE,qBAAA;EhBohDR;EgBjhDM;;IAEE,qBAAA;EhBmhDR;EgB1hDM;;IAEE,mBAAA;EhB4hDR;EgBzhDM;;IAEE,mBAAA;EhB2hDR;AACF;ActlDI;EEUE;IACE,SAAA;EhB+kDN;EgB5kDI;IApCJ,cAAA;IACA,WAAA;EhBmnDA;EgBrmDA;IACE,cAAA;IACA,WAAA;EhBumDF;EgBzmDA;IACE,cAAA;IACA,UAAA;EhB2mDF;EgB7mDA;IACE,cAAA;IACA,mBAAA;EhB+mDF;EgBjnDA;IACE,cAAA;IACA,UAAA;EhBmnDF;EgBrnDA;IACE,cAAA;IACA,UAAA;EhBunDF;EgBznDA;IACE,cAAA;IACA,mBAAA;EhB2nDF;EgB5lDI;IAhDJ,cAAA;IACA,WAAA;EhB+oDA;EgB1lDQ;IAhEN,cAAA;IACA,kBAAA;EhB6pDF;EgB9lDQ;IAhEN,cAAA;IACA,mBAAA;EhBiqDF;EgBlmDQ;IAhEN,cAAA;IACA,UAAA;EhBqqDF;EgBtmDQ;IAhEN,cAAA;IACA,mBAAA;EhByqDF;EgB1mDQ;IAhEN,cAAA;IACA,mBAAA;EhB6qDF;EgB9mDQ;IAhEN,cAAA;IACA,UAAA;EhBirDF;EgBlnDQ;IAhEN,cAAA;IACA,mBAAA;EhBqrDF;EgBtnDQ;IAhEN,cAAA;IACA,mBAAA;EhByrDF;EgB1nDQ;IAhEN,cAAA;IACA,UAAA;EhB6rDF;EgB9nDQ;IAhEN,cAAA;IACA,mBAAA;EhBisDF;EgBloDQ;IAhEN,cAAA;IACA,mBAAA;EhBqsDF;EgBtoDQ;IAhEN,cAAA;IACA,WAAA;EhBysDF;EgBloDU;IAxDV,cAAA;EhB6rDA;EgBroDU;IAxDV,wBAAA;EhBgsDA;EgBxoDU;IAxDV,yBAAA;EhBmsDA;EgB3oDU;IAxDV,gBAAA;EhBssDA;EgB9oDU;IAxDV,yBAAA;EhBysDA;EgBjpDU;IAxDV,yBAAA;EhB4sDA;EgBppDU;IAxDV,gBAAA;EhB+sDA;EgBvpDU;IAxDV,yBAAA;EhBktDA;EgB1pDU;IAxDV,yBAAA;EhBqtDA;EgB7pDU;IAxDV,gBAAA;EhBwtDA;EgBhqDU;IAxDV,yBAAA;EhB2tDA;EgBnqDU;IAxDV,yBAAA;EhB8tDA;EgB3pDM;;IAEE,gBAAA;EhB6pDR;EgB1pDM;;IAEE,gBAAA;EhB4pDR;EgBnqDM;;IAEE,sBAAA;EhBqqDR;EgBlqDM;;IAEE,sBAAA;EhBoqDR;EgB3qDM;;IAEE,qBAAA;EhB6qDR;EgB1qDM;;IAEE,qBAAA;EhB4qDR;EgBnrDM;;IAEE,mBAAA;EhBqrDR;EgBlrDM;;IAEE,mBAAA;EhBorDR;EgB3rDM;;IAEE,qBAAA;EhB6rDR;EgB1rDM;;IAEE,qBAAA;EhB4rDR;EgBnsDM;;IAEE,mBAAA;EhBqsDR;EgBlsDM;;IAEE,mBAAA;EhBosDR;AACF;AiB1zDA;EAEE,8BAAA;EACA,2BAAA;EACA,+BAAA;EACA,4BAAA;EAEA,0CAAA;EACA,gCAAA;EACA,+CAAA;EACA,iCAAA;EACA,kDAAA;EACA,+DAAA;EACA,iDAAA;EACA,6DAAA;EACA,gDAAA;EACA,8DAAA;EAEA,WAAA;EACA,mBXkYO;EWjYP,mBXusB4B;EWtsB5B,0CAAA;AjByzDF;AiBlzDE;EACE,sBAAA;EAEA,qFAAA;EACA,oCAAA;EACA,2CX+sB0B;EW9sB1B,2GAAA;AjBmzDJ;AiBhzDE;EACE,uBAAA;AjBkzDJ;AiB/yDE;EACE,sBAAA;AjBizDJ;;AiB7yDA;EACE,+DAAA;AjBgzDF;;AiBzyDA;EACE,iBAAA;AjB4yDF;;AiBlyDE;EACE,wBAAA;AjBqyDJ;;AiBtxDE;EACE,sCAAA;AjByxDJ;AiBtxDI;EACE,sCAAA;AjBwxDN;;AiBjxDE;EACE,sBAAA;AjBoxDJ;AiBjxDE;EACE,mBAAA;AjBmxDJ;;AiBzwDE;EACE,oDAAA;EACA,8CAAA;AjB4wDJ;;AiBtwDE;EACE,oDAAA;EACA,8CAAA;AjBywDJ;;AiBjwDA;EACE,oDAAA;EACA,8CAAA;AjBowDF;;AiB5vDE;EACE,mDAAA;EACA,6CAAA;AjB+vDJ;;AkB34DE;EAOE,sBAAA;EACA,qCAAA;EACA,mDAAA;EACA,iDAAA;EACA,8BAAA;EACA,gDAAA;EACA,6BAAA;EACA,kDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AlBu4DJ;;AkBz5DE;EAOE,sBAAA;EACA,qCAAA;EACA,mDAAA;EACA,kDAAA;EACA,8BAAA;EACA,gDAAA;EACA,6BAAA;EACA,kDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AlBq5DJ;;AkBv6DE;EAOE,sBAAA;EACA,mCAAA;EACA,kDAAA;EACA,kDAAA;EACA,8BAAA;EACA,+CAAA;EACA,6BAAA;EACA,kDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AlBm6DJ;;AkBr7DE;EAOE,sBAAA;EACA,qCAAA;EACA,mDAAA;EACA,iDAAA;EACA,8BAAA;EACA,gDAAA;EACA,6BAAA;EACA,gDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AlBi7DJ;;AkBn8DE;EAOE,sBAAA;EACA,qCAAA;EACA,iDAAA;EACA,kDAAA;EACA,8BAAA;EACA,gDAAA;EACA,6BAAA;EACA,mDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AlB+7DJ;;AkBj9DE;EAOE,sBAAA;EACA,qCAAA;EACA,mDAAA;EACA,iDAAA;EACA,8BAAA;EACA,gDAAA;EACA,6BAAA;EACA,iDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AlB68DJ;;AkB/9DE;EAOE,sBAAA;EACA,sBAAA;EACA,+CAAA;EACA,gDAAA;EACA,8BAAA;EACA,4CAAA;EACA,6BAAA;EACA,gDAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AlB29DJ;;AkB7+DE;EAOE,sBAAA;EACA,sBAAA;EACA,8CAAA;EACA,4CAAA;EACA,8BAAA;EACA,2CAAA;EACA,6BAAA;EACA,6CAAA;EACA,4BAAA;EAEA,4BAAA;EACA,0CAAA;AlBy+DJ;;AiBx1DI;EACE,gBAAA;EACA,iCAAA;AjB21DN;;Act7DI;EGyFA;IACE,gBAAA;IACA,iCAAA;EjBi2DJ;AACF;Ac77DI;EGyFA;IACE,gBAAA;IACA,iCAAA;EjBu2DJ;AACF;Acn8DI;EGyFA;IACE,gBAAA;IACA,iCAAA;EjB62DJ;AACF;Acz8DI;EGyFA;IACE,gBAAA;IACA,iCAAA;EjBm3DJ;AACF;Ac/8DI;EGyFA;IACE,gBAAA;IACA,iCAAA;EjBy3DJ;AACF;AmB7hEA;EACE,qBbu2BsC;ANwrCxC;;AmBthEA;EACE,oDAAA;EACA,uDAAA;EACA,gBAAA;EhB8QI,kBALI;EgBrQR,gBb+lB4B;ANw7C9B;;AmBnhEA;EACE,kDAAA;EACA,qDAAA;EhBoQI,kBALI;AHwxDV;;AmBnhEA;EACE,mDAAA;EACA,sDAAA;EhB8PI,mBALI;AH8xDV;;AoBpjEA;EACE,mBd+1BsC;EHrkBlC,kBALI;EiBjRR,gCd+1BsC;ANstCxC;;AqB1jEA;EACE,cAAA;EACA,WAAA;EACA,yBAAA;ElBwRI,eALI;EkBhRR,gBfkmB4B;EejmB5B,gBfymB4B;EexmB5B,2Bf43BsC;Ee33BtC,gBAAA;EACA,mCfq3BsC;Eep3BtC,4BAAA;EACA,2DAAA;EdGE,sCAAA;EeHE,wEDMJ;ArBwjEF;AsB1jEM;EDhBN;ICiBQ,gBAAA;EtB6jEN;AACF;AqB3jEE;EACE,gBAAA;ArB6jEJ;AqB3jEI;EACE,eAAA;ArB6jEN;AqBxjEE;EACE,2Bfs2BoC;Eer2BpC,mCfg2BoC;Ee/1BpC,kCf82BoC;Ee72BpC,UAAA;EAKE,kDfkhBkB;ANoiDxB;AqBljEE;EAME,eAAA;EAMA,aAAA;EAKA,SAAA;ArBsiEJ;AqBjiEE;EACE,cAAA;EACA,UAAA;ArBmiEJ;AqB/hEE;EACE,gCf40BoC;Ee10BpC,UAAA;ArBgiEJ;AqBxhEE;EAEE,wCf8yBoC;Ee3yBpC,UAAA;ArBuhEJ;AqBnhEE;EACE,yBAAA;EACA,0BAAA;EACA,0BforB0B;EenrB1B,2BfsyBoC;EiBp4BtC,uCjBqiCgC;Eer8B9B,oBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;EACA,+CfgsB0B;Ee/rB1B,gBAAA;ECzFE,qID0FF;ArBqhEJ;AsB3mEM;ED0EJ;ICzEM,gBAAA;EtB8mEN;AACF;AqBvhEE;EACE,wCf47B8B;AN6lClC;;AqBhhEA;EACE,cAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBfwf4B;Eevf5B,2Bf2xBsC;Ee1xBtC,6BAAA;EACA,yBAAA;EACA,sCAAA;ArBmhEF;AqBjhEE;EACE,UAAA;ArBmhEJ;AqBhhEE;EAEE,gBAAA;EACA,eAAA;ArBihEJ;;AqBtgEA;EACE,mEf4wBsC;Ee3wBtC,uBAAA;ElByII,mBALI;EIvQN,yCAAA;AP8oEJ;AqBvgEE;EACE,uBAAA;EACA,wBAAA;EACA,yBfooB0B;ANq4C9B;;AqBrgEA;EACE,iEfgwBsC;Ee/vBtC,oBAAA;ElB4HI,kBALI;EIvQN,yCAAA;AP0pEJ;AqBtgEE;EACE,oBAAA;EACA,qBAAA;EACA,uBf2nB0B;AN64C9B;;AqBhgEE;EACE,oEf6uBoC;ANsxCxC;AqBhgEE;EACE,mEf0uBoC;ANwxCxC;AqB//DE;EACE,iEfuuBoC;AN0xCxC;;AqB5/DA;EACE,WfquBsC;EepuBtC,gEf8tBsC;Ee7tBtC,iBfilB4B;AN86C9B;AqB7/DE;EACE,eAAA;ArB+/DJ;AqB5/DE;EACE,oBAAA;EdvLA,sCAAA;APsrEJ;AqB3/DE;EACE,oBAAA;Ed5LA,sCAAA;AP0rEJ;AqB1/DE;EAAoB,+Df8sBkB;AN+yCxC;AqB5/DE;EAAoB,6Df8sBkB;ANizCxC;;AwB9sEA;EACE,gEAAA;EAEA,cAAA;EACA,WAAA;EACA,0CAAA;ErBqRI,eALI;EqB7QR,gBlB+lB4B;EkB9lB5B,gBlBsmB4B;EkBrmB5B,2BlBy3BsC;EkBx3BtC,gBAAA;EACA,mClBk3BsC;EkBj3BtC,mFAAA;EACA,4BAAA;EACA,yClB+9BkC;EkB99BlC,0BlB+9BkC;EkB99BlC,2DAAA;EjBHE,sCAAA;EeHE,wEESJ;AxB8sEF;AsBntEM;EEfN;IFgBQ,gBAAA;EtBstEN;AACF;AwBjtEE;EACE,kClBs3BoC;EkBr3BpC,UAAA;EAKE,kDlBi+B4B;AN8uClC;AwB3sEE;EAEE,sBlB6uB0B;EkB5uB1B,sBAAA;AxB4sEJ;AwBzsEE;EAEE,wClBu1BoC;ANm3CxC;AwBrsEE;EACE,kBAAA;EACA,uCAAA;AxBusEJ;;AwBnsEA;EACE,oBlBsuB4B;EkBruB5B,uBlBquB4B;EkBpuB5B,oBlBquB4B;EHlgBxB,mBALI;EIvQN,yCAAA;APivEJ;;AwBnsEA;EACE,mBlBkuB4B;EkBjuB5B,sBlBiuB4B;EkBhuB5B,kBlBiuB4B;EHtgBxB,kBALI;EIvQN,yCAAA;APyvEJ;;AwBjsEI;EACE,gEAAA;AxBosEN;;AyB5wEA;EACE,cAAA;EACA,kBnBq6BwC;EmBp6BxC,mBnBq6BwC;EmBp6BxC,uBnBq6BwC;AN02C1C;AyB7wEE;EACE,WAAA;EACA,mBAAA;AzB+wEJ;;AyB3wEA;EACE,oBnB25BwC;EmB15BxC,eAAA;EACA,iBAAA;AzB8wEF;AyB5wEE;EACE,YAAA;EACA,oBAAA;EACA,cAAA;AzB8wEJ;;AyB1wEA;EACE,qCAAA;EAEA,cAAA;EACA,UnB04BwC;EmBz4BxC,WnBy4BwC;EmBx4BxC,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yCAAA;EACA,+CAAA;EACA,4BAAA;EACA,2BAAA;EACA,wBAAA;EACA,2DnB24BwC;EmB14BxC,yBAAA;AzB4wEF;AyBzwEE;ElB3BE,qBAAA;APuyEJ;AyBxwEE;EAEE,kBnBm4BsC;ANs4C1C;AyBtwEE;EACE,uBnB03BsC;AN84C1C;AyBrwEE;EACE,kCnBs1BoC;EmBr1BpC,UAAA;EACA,kDnB8foB;ANywDxB;AyBpwEE;EACE,yBnB5BM;EmB6BN,qBnB7BM;ANmyEV;AyBpwEI;EAII,iEAAA;AzBmwER;AyB/vEI;EAII,iEAAA;AzB8vER;AyBzvEE;EACE,yBnBjDM;EmBkDN,qBnBlDM;EmBuDJ,iEAAA;AzBuvEN;AyBnvEE;EACE,oBAAA;EACA,YAAA;EACA,YnBk2BuC;ANm5C3C;AyB9uEI;EACE,eAAA;EACA,YnBy1BqC;ANu5C3C;;AyBluEA;EACE,mBnBo1BgC;ANi5ClC;AyBnuEE;EACE,4DAAA;EAEA,UnB80B8B;EmB70B9B,mBAAA;EACA,0CAAA;EACA,gCAAA;ElBjHA,kBAAA;EeHE,iDGsHF;AzBouEJ;AsBt1EM;EG0GJ;IHzGM,gBAAA;EtBy1EN;AACF;AyBvuEI;EACE,4DAAA;AzByuEN;AyBtuEI;EACE,iCnB60B4B;EmBx0B1B,4DAAA;AzBouER;AyB/tEE;EACE,oBnBwzB8B;EmBvzB9B,eAAA;AzBiuEJ;AyB/tEI;EACE,oBAAA;EACA,cAAA;AzBiuEN;;AyB5tEA;EACE,qBAAA;EACA,kBnBsyBgC;ANy7ClC;;AyB5tEA;EACE,kBAAA;EACA,sBAAA;EACA,oBAAA;AzB+tEF;AyB3tEI;EACE,oBAAA;EACA,YAAA;EACA,anBspBwB;ANukD9B;;AyBttEI;EACE,4DAAA;AzBytEN;;A0B54EA;EACE,WAAA;EACA,cAAA;EACA,UAAA;EACA,gBAAA;EACA,6BAAA;A1B+4EF;A0B74EE;EACE,UAAA;A1B+4EJ;A0B34EI;EAA0B,kEpB8gCa;ANg4C3C;A0B74EI;EAA0B,kEpB6gCa;ANm4C3C;A0B74EE;EACE,SAAA;A1B+4EJ;A0B54EE;EACE,WpB+/BuC;EoB9/BvC,YpB8/BuC;EoB7/BvC,oBAAA;EACA,gBAAA;EH1BF,yBjBkCQ;EoBNN,SpB6/BuC;EC1gCvC,mBAAA;EeHE,oHImBF;EJnBE,4GImBF;A1B64EJ;AsB55EM;EIMJ;IJLM,wBAAA;IAAA,gBAAA;EtB+5EN;AACF;A0Bh5EI;EHjCF,0CjB8hCyC;ANs5C3C;A0B94EE;EACE,WpBw+B8B;EoBv+B9B,cpBw+B8B;EoBv+B9B,kBAAA;EACA,epBu+B8B;EoBt+B9B,wCpBu+B8B;EoBt+B9B,yBAAA;EnB7BA,mBAAA;AP86EJ;A0B54EE;EACE,WpBo+BuC;EoBn+BvC,YpBm+BuC;EoBl+BvC,gBAAA;EHpDF,yBjBkCQ;EoBoBN,SpBm+BuC;EC1gCvC,mBAAA;EeHE,iHI6CF;EJ7CE,4GI6CF;A1B64EJ;AsBt7EM;EIiCJ;IJhCM,qBAAA;IAAA,gBAAA;EtBy7EN;AACF;A0Bh5EI;EH3DF,0CjB8hCyC;ANg7C3C;A0B94EE;EACE,WpB88B8B;EoB78B9B,cpB88B8B;EoB78B9B,kBAAA;EACA,epB68B8B;EoB58B9B,wCpB68B8B;EoB58B9B,yBAAA;EnBvDA,mBAAA;APw8EJ;A0B54EE;EACE,oBAAA;A1B84EJ;A0B54EI;EACE,2CpBg9BqC;AN87C3C;A0B34EI;EACE,2CpB48BqC;ANi8C3C;;A2Bp+EA;EACE,kBAAA;A3Bu+EF;A2Br+EE;;;EAGE,uDrBwiCoC;EqBviCpC,2DrBuiCoC;EqBtiCpC,iBrBuiCoC;ANg8CxC;A2Bp+EE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,eAAA;EACA,YAAA;EACA,qBAAA;EACA,gBAAA;EACA,2CAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gDAAA;EACA,qBAAA;ELVE,gEKWF;A3Bs+EJ;AsB7+EM;EKTJ;ILUM,gBAAA;EtBg/EN;AACF;A2Bx+EE;;EAEE,qBAAA;A3B0+EJ;A2Bx+EI;;EACE,kBAAA;A3B2+EN;A2Bx+EI;;;EAEE,qBrB0gCkC;EqBzgClC,wBrB0gCkC;ANi+CxC;A2Bx+EI;;EACE,qBrBqgCkC;EqBpgClC,wBrBqgCkC;ANs+CxC;A2Bv+EE;EACE,qBrB+/BoC;EqB9/BpC,wBrB+/BoC;EqB9/BpC,qBrBguB0B;ANywD9B;A2Bl+EI;;;;EACE,8DrBy/BkC;AN8+CxC;A2Bl+EI;EACE,8DrBm/BkC;ANi/CxC;A2B/9EI;;EACE,kBAAA;EACA,oBAAA;EACA,WAAA;EACA,arBw+BkC;EqBv+BlC,WAAA;EACA,mCrBqzBkC;ECh3BpC,sCAAA;AP8hFJ;A2B/9EE;EACE,wCrBkzBoC;AN+qDxC;A2B79EI;EACE,sCAAA;A3B+9EN;A2B39EE;;EAEE,crBhFO;AN6iFX;;A4BvjFA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;A5B0jFF;A4BxjFE;;;EAGE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;A5B0jFJ;A4BtjFE;;;EAGE,UAAA;A5BwjFJ;A4BljFE;EACE,kBAAA;EACA,UAAA;A5BojFJ;A4BljFI;EACE,UAAA;A5BojFN;;A4BziFA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EzB8OI,eALI;EyBvOR,gBtByjB4B;EsBxjB5B,gBtBgkB4B;EsB/jB5B,2BtBm1BsC;EsBl1BtC,kBAAA;EACA,mBAAA;EACA,uCtB06BsC;EsBz6BtC,2DAAA;ErBtCE,sCAAA;APmlFJ;;A4BniFA;;;;EAIE,oBAAA;EzBwNI,kBALI;EIvQN,yCAAA;AP4lFJ;;A4BniFA;;;;EAIE,uBAAA;EzB+MI,mBALI;EIvQN,yCAAA;APqmFJ;;A4BniFA;;EAEE,mBAAA;A5BsiFF;;A4BzhFI;;;;ErBjEA,0BAAA;EACA,6BAAA;APimFJ;A4BxhFI;;;;ErB1EA,0BAAA;EACA,6BAAA;APwmFJ;A4BlhFE;EACE,8CAAA;ErB1EA,yBAAA;EACA,4BAAA;AP+lFJ;A4BlhFE;;ErB9EE,yBAAA;EACA,4BAAA;APomFJ;;A6B5nFE;EACE,aAAA;EACA,WAAA;EACA,mBvBu0BoC;EHrkBlC,kBALI;E0B1PN,iCvBkjCqB;AN4kDzB;;A6B3nFE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;E1BqPE,mBALI;E0B7ON,WvBqiCqB;EuBpiCrB,mCvBoiCqB;EC/jCrB,sCAAA;APypFJ;;A6BznFI;;;;EAEE,cAAA;A7B8nFN;;A6B7qFI;EAqDE,+CvBuhCmB;EuBphCjB,oCvB81BgC;EuB71BhC,yDAAA;EACA,4BAAA;EACA,2DAAA;EACA,gEAAA;A7B0nFR;A6BvnFM;EACE,+CvB4gCiB;EuBvgCf,2DvBugCe;AN8mDzB;;A6B1rFI;EA+EI,oCvBu0BgC;EuBt0BhC,kFAAA;A7B+mFR;;A6B/rFI;EAuFE,+CvBq/BmB;ANunDzB;A6BzmFQ;EAEE,iEAAA;EACA,uBvBq5B8B;EuBp5B9B,+DAAA;EACA,2EAAA;A7B0mFV;A6BtmFM;EACE,+CvBw+BiB;EuBn+Bf,2DvBm+Be;ANioDzB;;A6B7sFI;EAkHI,yCAAA;A7B+lFR;;A6BjtFI;EAyHE,+CvBm9BmB;ANyoDzB;A6B1lFM;EACE,4CvBg9BiB;AN4oDzB;A6BzlFM;EACE,2DvB48BiB;AN+oDzB;A6BxlFM;EACE,iCvBw8BiB;ANkpDzB;;A6BrlFI;EACE,kBAAA;A7BwlFN;;A6BluFI;;;;;EAoJM,UAAA;A7BslFV;;A6BttFE;EACE,aAAA;EACA,WAAA;EACA,mBvBu0BoC;EHrkBlC,kBALI;E0B1PN,mCvBkjCqB;ANsqDzB;;A6BrtFE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;E1BqPE,mBALI;E0B7ON,WvBqiCqB;EuBpiCrB,kCvBoiCqB;EC/jCrB,sCAAA;APmvFJ;;A6BntFI;;;;EAEE,cAAA;A7BwtFN;;A6BvwFI;EAqDE,iDvBuhCmB;EuBphCjB,oCvB81BgC;EuB71BhC,0DAAA;EACA,4BAAA;EACA,2DAAA;EACA,gEAAA;A7BotFR;A6BjtFM;EACE,iDvB4gCiB;EuBvgCf,0DvBugCe;ANwsDzB;;A6BpxFI;EA+EI,oCvBu0BgC;EuBt0BhC,kFAAA;A7BysFR;;A6BzxFI;EAuFE,iDvBq/BmB;ANitDzB;A6BnsFQ;EAEE,kEAAA;EACA,uBvBq5B8B;EuBp5B9B,+DAAA;EACA,2EAAA;A7BosFV;A6BhsFM;EACE,iDvBw+BiB;EuBn+Bf,0DvBm+Be;AN2tDzB;;A6BvyFI;EAkHI,yCAAA;A7ByrFR;;A6B3yFI;EAyHE,iDvBm9BmB;ANmuDzB;A6BprFM;EACE,8CvBg9BiB;ANsuDzB;A6BnrFM;EACE,0DvB48BiB;ANyuDzB;A6BlrFM;EACE,mCvBw8BiB;AN4uDzB;;A6B/qFI;EACE,kBAAA;A7BkrFN;;A6B5zFI;;;;;EAsJM,UAAA;A7B8qFV;;A8Bt0FA;EAEE,2BAAA;EACA,4BAAA;EACA,sBAAA;E3BuRI,wBALI;E2BhRR,yBAAA;EACA,yBAAA;EACA,oCAAA;EACA,wBAAA;EACA,6CAAA;EACA,kCAAA;EACA,+CAAA;EACA,wCAAA;EACA,4FAAA;EACA,+BAAA;EACA,iFAAA;EAGA,qBAAA;EACA,wDAAA;EACA,sCAAA;E3BsQI,kCALI;E2B/PR,sCAAA;EACA,sCAAA;EACA,0BAAA;EACA,kBAAA;EACA,qBAAA;EAEA,sBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,mEAAA;EvBjBE,0CAAA;EgBfF,kCOkCqB;ERtBjB,qIQwBJ;A9Bo0FF;AsBx1FM;EQhBN;IRiBQ,gBAAA;EtB21FN;AACF;A8Bv0FE;EACE,gCAAA;EAEA,wCAAA;EACA,8CAAA;A9Bw0FJ;A8Br0FE;EAEE,0BAAA;EACA,kCAAA;EACA,wCAAA;A9Bs0FJ;A8Bn0FE;EACE,gCAAA;EPrDF,wCOsDuB;EACrB,8CAAA;EACA,UAAA;EAKE,0CAAA;A9Bi0FN;A8B7zFE;EACE,8CAAA;EACA,UAAA;EAKE,0CAAA;A9B2zFN;A8BvzFE;EAKE,iCAAA;EACA,yCAAA;EAGA,+CAAA;A9BmzFJ;A8BhzFI;EAKI,0CAAA;A9B8yFR;A8BzyFE;EAKI,0CAAA;A9BuyFN;A8BnyFE;EAGE,mCAAA;EACA,oBAAA;EACA,2CAAA;EAEA,iDAAA;EACA,uCAAA;A9BkyFJ;;A8BtxFE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,2CAAA;EACA,iDAAA;EACA,uCAAA;EACA,2BAAA;EACA,wCAAA;EACA,qDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/By4FF;;A8BvyFE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,2CAAA;EACA,iDAAA;EACA,wCAAA;EACA,2BAAA;EACA,wCAAA;EACA,mDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/B05FF;;A8BxzFE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,2CAAA;EACA,+CAAA;EACA,uCAAA;EACA,2BAAA;EACA,sCAAA;EACA,oDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/B26FF;;A8Bz0FE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,4CAAA;EACA,oDAAA;EACA,uCAAA;EACA,2BAAA;EACA,yCAAA;EACA,qDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/B47FF;;A8B11FE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,wCAAA;EACA,kDAAA;EACA,sCAAA;EACA,2BAAA;EACA,yCAAA;EACA,mDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/B68FF;;A8B32FE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,yCAAA;EACA,iDAAA;EACA,sCAAA;EACA,2BAAA;EACA,wCAAA;EACA,oDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/B89FF;;A8B53FE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,4CAAA;EACA,mDAAA;EACA,wCAAA;EACA,2BAAA;EACA,0CAAA;EACA,qDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/B++FF;;A8B74FE;EC/GA,oBAAA;EACA,oBAAA;EACA,8BAAA;EACA,0BAAA;EACA,wCAAA;EACA,kDAAA;EACA,qCAAA;EACA,2BAAA;EACA,yCAAA;EACA,mDAAA;EACA,4DAAA;EACA,6BAAA;EACA,6BAAA;EACA,uCAAA;A/BggGF;;A8Bp4FE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/Bw/FF;;A8Br5FE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/BygGF;;A8Bt6FE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/B0hGF;;A8Bv7FE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,uCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/B2iGF;;A8Bx8FE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/B4jGF;;A8Bz9FE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,sCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/B6kGF;;A8B1+FE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,wCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/B8lGF;;A8B3/FE;EChHA,uBAAA;EACA,8BAAA;EACA,0BAAA;EACA,0BAAA;EACA,oCAAA;EACA,qCAAA;EACA,2BAAA;EACA,2BAAA;EACA,qCAAA;EACA,4DAAA;EACA,gCAAA;EACA,iCAAA;EACA,uCAAA;EACA,mBAAA;A/B+mGF;;A8BhgGA;EACE,yBAAA;EACA,oCAAA;EACA,wBAAA;EACA,kCAAA;EACA,gDAAA;EACA,wCAAA;EACA,iDAAA;EACA,yCAAA;EACA,gCAAA;EACA,2CAAA;EACA,+BAAA;EACA,uCAAA;EAEA,0BxB8QwC;ANovF1C;A8Bx/FE;EACE,0BAAA;A9B0/FJ;A8Bv/FE;EACE,gCAAA;A9By/FJ;;A8B9+FA;ECjJE,0BAAA;EACA,wBAAA;E5B8NI,2BALI;E4BvNR,kDAAA;A/BmoGF;;A8Bj/FA;ECrJE,2BAAA;EACA,0BAAA;E5B8NI,4BALI;E4BvNR,kDAAA;A/B0oGF;;AgC7sGA;EVgBM,gCUfJ;AhCgtGF;AsB7rGM;EUpBN;IVqBQ,gBAAA;EtBgsGN;AACF;AgCntGE;EACE,UAAA;AhCqtGJ;;AgC/sGE;EACE,aAAA;AhCktGJ;;AgC9sGA;EACE,SAAA;EACA,gBAAA;EVDI,6BUEJ;AhCitGF;AsB/sGM;EULN;IVMQ,gBAAA;EtBktGN;AACF;AgCptGE;EACE,QAAA;EACA,YAAA;EVNE,4BUOF;AhCstGJ;AsBztGM;EUAJ;IVCM,gBAAA;EtB4tGN;AACF;;AiCjvGA;;;;;;EAME,kBAAA;AjCovGF;;AiCjvGA;EACE,mBAAA;AjCovGF;AkC5tGI;EACE,qBAAA;EACA,oB5B6hBwB;E4B5hBxB,uB5B2hBwB;E4B1hBxB,WAAA;EArCJ,uBAAA;EACA,qCAAA;EACA,gBAAA;EACA,oCAAA;AlCowGF;AkC1sGI;EACE,cAAA;AlC4sGN;;AiC1vGA;EAEE,0BAAA;EACA,8BAAA;EACA,0BAAA;EACA,+BAAA;EACA,8BAAA;E9BuQI,6BALI;E8BhQR,yCAAA;EACA,mCAAA;EACA,8DAAA;EACA,oDAAA;EACA,kDAAA;EACA,yFAAA;EACA,4DAAA;EACA,sCAAA;EACA,8CAAA;EACA,8CAAA;EACA,oDAAA;EACA,kDAAA;EACA,qCAAA;EACA,qCAAA;EACA,2DAAA;EACA,kCAAA;EACA,qCAAA;EACA,mCAAA;EACA,oCAAA;EACA,sCAAA;EAGA,kBAAA;EACA,kCAAA;EACA,aAAA;EACA,uCAAA;EACA,kEAAA;EACA,SAAA;E9B0OI,uCALI;E8BnOR,+BAAA;EACA,gBAAA;EACA,gBAAA;EACA,uCAAA;EACA,4BAAA;EACA,6EAAA;E1BzCE,+CAAA;APoyGJ;AiCvvGE;EACE,SAAA;EACA,OAAA;EACA,qCAAA;AjCyvGJ;;AiCjuGI;EACE,oBAAA;AjCouGN;AiCluGM;EACE,WAAA;EACA,OAAA;AjCouGR;;AiChuGI;EACE,kBAAA;AjCmuGN;AiCjuGM;EACE,QAAA;EACA,UAAA;AjCmuGR;;Ac7wGI;EmB4BA;IACE,oBAAA;EjCqvGJ;EiCnvGI;IACE,WAAA;IACA,OAAA;EjCqvGN;EiCjvGE;IACE,kBAAA;EjCmvGJ;EiCjvGI;IACE,QAAA;IACA,UAAA;EjCmvGN;AACF;Ac9xGI;EmB4BA;IACE,oBAAA;EjCqwGJ;EiCnwGI;IACE,WAAA;IACA,OAAA;EjCqwGN;EiCjwGE;IACE,kBAAA;EjCmwGJ;EiCjwGI;IACE,QAAA;IACA,UAAA;EjCmwGN;AACF;Ac9yGI;EmB4BA;IACE,oBAAA;EjCqxGJ;EiCnxGI;IACE,WAAA;IACA,OAAA;EjCqxGN;EiCjxGE;IACE,kBAAA;EjCmxGJ;EiCjxGI;IACE,QAAA;IACA,UAAA;EjCmxGN;AACF;Ac9zGI;EmB4BA;IACE,oBAAA;EjCqyGJ;EiCnyGI;IACE,WAAA;IACA,OAAA;EjCqyGN;EiCjyGE;IACE,kBAAA;EjCmyGJ;EiCjyGI;IACE,QAAA;IACA,UAAA;EjCmyGN;AACF;Ac90GI;EmB4BA;IACE,oBAAA;EjCqzGJ;EiCnzGI;IACE,WAAA;IACA,OAAA;EjCqzGN;EiCjzGE;IACE,kBAAA;EjCmzGJ;EiCjzGI;IACE,QAAA;IACA,UAAA;EjCmzGN;AACF;AiC1yGE;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,wCAAA;AjC4yGJ;AkCh4GI;EACE,qBAAA;EACA,oB5B6hBwB;E4B5hBxB,uB5B2hBwB;E4B1hBxB,WAAA;EA9BJ,aAAA;EACA,qCAAA;EACA,0BAAA;EACA,oCAAA;AlCi6GF;AkC92GI;EACE,cAAA;AlCg3GN;;AiChzGE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,sCAAA;AjCmzGJ;AkCr5GI;EACE,qBAAA;EACA,oB5B6hBwB;E4B5hBxB,uB5B2hBwB;E4B1hBxB,WAAA;EAvBJ,mCAAA;EACA,eAAA;EACA,sCAAA;EACA,wBAAA;AlC+6GF;AkCn4GI;EACE,cAAA;AlCq4GN;AiC3zGI;EACE,iBAAA;AjC6zGN;;AiCvzGE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,uCAAA;AjC0zGJ;AkC76GI;EACE,qBAAA;EACA,oB5B6hBwB;E4B5hBxB,uB5B2hBwB;E4B1hBxB,WAAA;AlC+6GN;AkCp6GM;EACE,aAAA;AlCs6GR;AkCn6GM;EACE,qBAAA;EACA,qB5B0gBsB;E4BzgBtB,uB5BwgBsB;E4BvgBtB,WAAA;EAnCN,mCAAA;EACA,yBAAA;EACA,sCAAA;AlCy8GF;AkCn6GI;EACE,cAAA;AlCq6GN;AiC10GI;EACE,iBAAA;AjC40GN;;AiCr0GA;EACE,SAAA;EACA,6CAAA;EACA,gBAAA;EACA,mDAAA;EACA,UAAA;AjCw0GF;;AiCl0GA;EACE,cAAA;EACA,WAAA;EACA,4EAAA;EACA,WAAA;EACA,gB3Byb4B;E2Bxb5B,oCAAA;EACA,mBAAA;EACA,qBAAA;EACA,mBAAA;EACA,6BAAA;EACA,SAAA;E1BtKE,uDAAA;AP4+GJ;AiCn0GE;EAEE,0CAAA;EV1LF,kDU4LuB;AjCm0GzB;AiCh0GE;EAEE,2CAAA;EACA,qBAAA;EVlMF,mDUmMuB;AjCi0GzB;AiC9zGE;EAEE,6CAAA;EACA,oBAAA;EACA,6BAAA;AjC+zGJ;;AiCzzGA;EACE,cAAA;AjC4zGF;;AiCxzGA;EACE,cAAA;EACA,gFAAA;EACA,gBAAA;E9BmEI,mBALI;E8B5DR,sCAAA;EACA,mBAAA;AjC2zGF;;AiCvzGA;EACE,cAAA;EACA,4EAAA;EACA,oCAAA;AjC0zGF;;AiCtzGA;EAEE,4BAAA;EACA,yBAAA;EACA,8DAAA;EACA,0BAAA;EACA,iCAAA;EACA,oCAAA;EACA,4DAAA;EACA,sDAAA;EACA,qCAAA;EACA,qCAAA;EACA,0CAAA;EACA,mCAAA;AjCwzGF;;AmC9iHA;;EAEE,kBAAA;EACA,oBAAA;EACA,sBAAA;AnCijHF;AmC/iHE;;EACE,kBAAA;EACA,cAAA;AnCkjHJ;AmC7iHE;;;;;;;;;;;;EAME,UAAA;AnCqjHJ;;AmChjHA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;AnCmjHF;AmCjjHE;EACE,WAAA;AnCmjHJ;;AmC/iHA;E5BhBI,sCAAA;APmkHJ;AmC/iHE;;EAEE,8CAAA;AnCijHJ;AmC7iHE;;;E5BVE,0BAAA;EACA,6BAAA;AP4jHJ;AmCziHE;;;E5BNE,yBAAA;EACA,4BAAA;APojHJ;;AmC5hHA;EACE,wBAAA;EACA,uBAAA;AnC+hHF;AmC7hHE;EAGE,cAAA;AnC6hHJ;AmC1hHE;EACE,eAAA;AnC4hHJ;;AmCxhHA;EACE,uBAAA;EACA,sBAAA;AnC2hHF;;AmCxhHA;EACE,sBAAA;EACA,qBAAA;AnC2hHF;;AmCvgHA;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;AnC0gHF;AmCxgHE;;EAEE,WAAA;AnC0gHJ;AmCvgHE;;EAEE,6CAAA;AnCygHJ;AmCrgHE;;E5B1FE,6BAAA;EACA,4BAAA;APmmHJ;AmCjgHE;;;E5BjHE,yBAAA;EACA,0BAAA;APunHJ;;AoC/oHA;EAEE,6BAAA;EACA,+BAAA;EAEA,2BAAA;EACA,yCAAA;EACA,qDAAA;EACA,uDAAA;EAGA,aAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;ApC8oHF;;AoC3oHA;EACE,cAAA;EACA,kEAAA;EjCsQI,uCALI;EiC/PR,2CAAA;EACA,+BAAA;EACA,qBAAA;EACA,gBAAA;EACA,SAAA;EdfI,uGcgBJ;ApC8oHF;AsB1pHM;EcGN;IdFQ,gBAAA;EtB6pHN;AACF;AoCjpHE;EAEE,qCAAA;ApCkpHJ;AoC9oHE;EACE,UAAA;EACA,kD9BkhBoB;AN8nGxB;AoC5oHE;EAEE,wCAAA;EACA,oBAAA;EACA,eAAA;ApC6oHJ;;AoCroHA;EAEE,kDAAA;EACA,kDAAA;EACA,oDAAA;EACA,2GAAA;EACA,yDAAA;EACA,+CAAA;EACA,uGAAA;EAGA,oFAAA;ApCqoHF;AoCnoHE;EACE,yDAAA;EACA,yDAAA;E7B7CA,wDAAA;EACA,yDAAA;APmrHJ;AoCpoHI;EAGE,kBAAA;EACA,wDAAA;ApCooHN;AoChoHE;;EAEE,2CAAA;EACA,mDAAA;EACA,yDAAA;ApCkoHJ;AoC/nHE;EAEE,sDAAA;E7BjEA,yBAAA;EACA,0BAAA;APksHJ;;AoCvnHA;EAEE,qDAAA;EACA,sCAAA;EACA,sCAAA;ApCynHF;AoCtnHE;E7B5FE,gDAAA;APqtHJ;AoCrnHE;;EAEE,4CAAA;EbjHF,oDakHuB;ApCunHzB;;AoC9mHA;EAEE,4BAAA;EACA,yCAAA;EACA,8DAAA;EAGA,gCAAA;ApC8mHF;AoC5mHE;EACE,gBAAA;EACA,eAAA;EACA,qEAAA;ApC8mHJ;AoC5mHI;EAEE,iCAAA;ApC6mHN;AoCzmHE;;EAEE,gB9B0d0B;E8Bzd1B,gDAAA;EACA,iCAAA;ApC2mHJ;;AoCjmHE;;EAEE,cAAA;EACA,kBAAA;ApComHJ;;AoC/lHE;;EAEE,YAAA;EACA,aAAA;EACA,kBAAA;ApCkmHJ;;AoC5lHE;;EACE,WAAA;ApCgmHJ;;AoCtlHE;EACE,aAAA;ApCylHJ;AoCvlHE;EACE,cAAA;ApCylHJ;;AqCtxHA;EAEE,wBAAA;EACA,6BAAA;EACA,2DAAA;EACA,gEAAA;EACA,mEAAA;EACA,+DAAA;EACA,sCAAA;EACA,kCAAA;EACA,oCAAA;EACA,8DAAA;EACA,oEAAA;EACA,sCAAA;EACA,sCAAA;EACA,sCAAA;EACA,sCAAA;EACA,qEAAA;EACA,0EAAA;EACA,0DAAA;EACA,wCAAA;EACA,4DAAA;EAGA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,8DAAA;ArCsxHF;AqChxHE;;;;;;;EACE,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,8BAAA;ArCwxHJ;AqCpwHA;EACE,6CAAA;EACA,gDAAA;EACA,+CAAA;ElC4NI,2CALI;EkCrNR,mCAAA;EACA,qBAAA;EACA,mBAAA;ArCswHF;AqCpwHE;EAEE,yCAAA;ArCqwHJ;;AqC3vHA;EAEE,0BAAA;EACA,+BAAA;EAEA,2BAAA;EACA,2CAAA;EACA,uDAAA;EACA,6DAAA;EAGA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;ArC0vHF;AqCvvHI;EAEE,oCAAA;ArCwvHN;AqCpvHE;EACE,gBAAA;ArCsvHJ;;AqC7uHA;EACE,mB/B8gCkC;E+B7gClC,sB/B6gCkC;E+B5gClC,6BAAA;ArCgvHF;AqC9uHE;;;EAGE,oCAAA;ArCgvHJ;;AqCnuHA;EACE,YAAA;EACA,gBAAA;EAGA,mBAAA;ArCouHF;;AqChuHA;EACE,8EAAA;ElCyII,6CALI;EkClIR,cAAA;EACA,6BAAA;EACA,6BAAA;EACA,0EAAA;E9BxIE,qDAAA;EeHE,+Ce6IJ;ArCmuHF;AsB52HM;EeiIN;IfhIQ,gBAAA;EtB+2HN;AACF;AqCtuHE;EACE,qBAAA;ArCwuHJ;AqCruHE;EACE,qBAAA;EACA,UAAA;EACA,sDAAA;ArCuuHJ;;AqCjuHA;EACE,qBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,kDAAA;EACA,4BAAA;EACA,2BAAA;EACA,qBAAA;ArCouHF;;AqCjuHA;EACE,yCAAA;EACA,gBAAA;ArCouHF;;Ac91HI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;ErC2tHN;EqCztHM;IACE,mBAAA;ErC2tHR;EqCztHQ;IACE,kBAAA;ErC2tHV;EqCxtHQ;IACE,kDAAA;IACA,iDAAA;ErC0tHV;EqCttHM;IACE,iBAAA;ErCwtHR;EqCrtHM;IACE,wBAAA;IACA,gBAAA;ErCutHR;EqCptHM;IACE,aAAA;ErCstHR;EqCntHM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;ErCmtHR;EqChtHQ;IACE,aAAA;ErCktHV;EqC/sHQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ErCitHV;AACF;Ac94HI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;ErC0wHN;EqCxwHM;IACE,mBAAA;ErC0wHR;EqCxwHQ;IACE,kBAAA;ErC0wHV;EqCvwHQ;IACE,kDAAA;IACA,iDAAA;ErCywHV;EqCrwHM;IACE,iBAAA;ErCuwHR;EqCpwHM;IACE,wBAAA;IACA,gBAAA;ErCswHR;EqCnwHM;IACE,aAAA;ErCqwHR;EqClwHM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;ErCkwHR;EqC/vHQ;IACE,aAAA;ErCiwHV;EqC9vHQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ErCgwHV;AACF;Ac77HI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;ErCyzHN;EqCvzHM;IACE,mBAAA;ErCyzHR;EqCvzHQ;IACE,kBAAA;ErCyzHV;EqCtzHQ;IACE,kDAAA;IACA,iDAAA;ErCwzHV;EqCpzHM;IACE,iBAAA;ErCszHR;EqCnzHM;IACE,wBAAA;IACA,gBAAA;ErCqzHR;EqClzHM;IACE,aAAA;ErCozHR;EqCjzHM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;ErCizHR;EqC9yHQ;IACE,aAAA;ErCgzHV;EqC7yHQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ErC+yHV;AACF;Ac5+HI;EuBsIA;IAEI,iBAAA;IACA,2BAAA;ErCw2HN;EqCt2HM;IACE,mBAAA;ErCw2HR;EqCt2HQ;IACE,kBAAA;ErCw2HV;EqCr2HQ;IACE,kDAAA;IACA,iDAAA;ErCu2HV;EqCn2HM;IACE,iBAAA;ErCq2HR;EqCl2HM;IACE,wBAAA;IACA,gBAAA;ErCo2HR;EqCj2HM;IACE,aAAA;ErCm2HR;EqCh2HM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;ErCg2HR;EqC71HQ;IACE,aAAA;ErC+1HV;EqC51HQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ErC81HV;AACF;Ac3hII;EuBsIA;IAEI,iBAAA;IACA,2BAAA;ErCu5HN;EqCr5HM;IACE,mBAAA;ErCu5HR;EqCr5HQ;IACE,kBAAA;ErCu5HV;EqCp5HQ;IACE,kDAAA;IACA,iDAAA;ErCs5HV;EqCl5HM;IACE,iBAAA;ErCo5HR;EqCj5HM;IACE,wBAAA;IACA,gBAAA;ErCm5HR;EqCh5HM;IACE,aAAA;ErCk5HR;EqC/4HM;IAEE,gBAAA;IACA,aAAA;IACA,YAAA;IACA,sBAAA;IACA,uBAAA;IACA,8BAAA;IACA,wCAAA;IACA,oBAAA;IACA,0BAAA;If9NJ,gBegOI;ErC+4HR;EqC54HQ;IACE,aAAA;ErC84HV;EqC34HQ;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;ErC64HV;AACF;AqCp8HI;EAEI,iBAAA;EACA,2BAAA;ArCq8HR;AqCn8HQ;EACE,mBAAA;ArCq8HV;AqCn8HU;EACE,kBAAA;ArCq8HZ;AqCl8HU;EACE,kDAAA;EACA,iDAAA;ArCo8HZ;AqCh8HQ;EACE,iBAAA;ArCk8HV;AqC/7HQ;EACE,wBAAA;EACA,gBAAA;ArCi8HV;AqC97HQ;EACE,aAAA;ArCg8HV;AqC77HQ;EAEE,gBAAA;EACA,aAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,8BAAA;EACA,wCAAA;EACA,oBAAA;EACA,0BAAA;Ef9NJ,gBegOI;ArC67HV;AqC17HU;EACE,aAAA;ArC47HZ;AqCz7HU;EACE,aAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;ArC27HZ;;AqC16HA;;EAGE,4CAAA;EACA,kDAAA;EACA,qDAAA;EACA,8BAAA;EACA,6BAAA;EACA,mCAAA;EACA,0DAAA;EACA,qEAAA;ArC46HF;;AqCt6HI;EACE,qEAAA;ArCy6HN;;AsClsIA;EAEE,wBAAA;EACA,wBAAA;EACA,gCAAA;EACA,uBAAA;EACA,0BAAA;EACA,8CAAA;EACA,0DAAA;EACA,gDAAA;EACA,sBAAA;EACA,uFAAA;EACA,+BAAA;EACA,6BAAA;EACA,sDAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,+BAAA;EACA,mCAAA;EACA,+BAAA;EAGA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,6BAAA;EACA,2BAAA;EACA,qBAAA;EACA,mCAAA;EACA,2BAAA;EACA,qEAAA;E/BjBE,2CAAA;APotIJ;AsC/rIE;EACE,eAAA;EACA,cAAA;AtCisIJ;AsC9rIE;EACE,mBAAA;EACA,sBAAA;AtCgsIJ;AsC9rII;EACE,mBAAA;E/BtBF,0DAAA;EACA,2DAAA;APutIJ;AsC9rII;EACE,sBAAA;E/BbF,8DAAA;EACA,6DAAA;AP8sIJ;AsC3rIE;;EAEE,aAAA;AtC6rIJ;;AsCzrIA;EAGE,cAAA;EACA,wDAAA;EACA,2BAAA;AtC0rIF;;AsCvrIA;EACE,4CAAA;EACA,iCAAA;AtC0rIF;;AsCvrIA;EACE,sDAAA;EACA,gBAAA;EACA,oCAAA;AtC0rIF;;AsCvrIA;EACE,gBAAA;AtC0rIF;;AsClrIE;EACE,oCAAA;AtCqrIJ;;AsC7qIA;EACE,kEAAA;EACA,gBAAA;EACA,+BAAA;EACA,uCAAA;EACA,4EAAA;AtCgrIF;AsC9qIE;E/B7FE,wFAAA;AP8wIJ;;AsC5qIA;EACE,kEAAA;EACA,+BAAA;EACA,uCAAA;EACA,yEAAA;AtC+qIF;AsC7qIE;E/BxGE,wFAAA;APwxIJ;;AsCtqIA;EACE,uDAAA;EACA,sDAAA;EACA,sDAAA;EACA,gBAAA;AtCyqIF;AsCvqIE;EACE,mCAAA;EACA,sCAAA;AtCyqIJ;;AsCrqIA;EACE,uDAAA;EACA,sDAAA;AtCwqIF;;AsCpqIA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,2CAAA;E/B1IE,iDAAA;APkzIJ;;AsCpqIA;;;EAGE,WAAA;AtCuqIF;;AsCpqIA;;E/B3II,0DAAA;EACA,2DAAA;APozIJ;;AsCrqIA;;E/BlII,8DAAA;EACA,6DAAA;AP4yIJ;;AsC9pIE;EACE,0CAAA;AtCiqIJ;Ac5xII;EwBuHJ;IAQI,aAAA;IACA,mBAAA;EtCiqIF;EsC9pIE;IACE,SAAA;IACA,gBAAA;EtCgqIJ;EsC9pII;IACE,cAAA;IACA,cAAA;EtCgqIN;EsC3pIM;I/B1KJ,0BAAA;IACA,6BAAA;EPw0IF;EsC5pIQ;;IAGE,0BAAA;EtC6pIV;EsC3pIQ;;IAGE,6BAAA;EtC4pIV;EsCxpIM;I/B3KJ,yBAAA;IACA,4BAAA;EPs0IF;EsCzpIQ;;IAGE,yBAAA;EtC0pIV;EsCxpIQ;;IAGE,4BAAA;EtCypIV;AACF;;AuC73IA;EAEE,0CAAA;EACA,oCAAA;EACA,8KAAA;EACA,mDAAA;EACA,mDAAA;EACA,qDAAA;EACA,4FAAA;EACA,qCAAA;EACA,kCAAA;EACA,8CAAA;EACA,6CAAA;EACA,iEAAA;EACA,sCAAA;EACA,kDAAA;EACA,8DAAA;EACA,wEAAA;EACA,2EAAA;EACA,sCAAA;EACA,mCAAA;EACA,4DAAA;EACA,qDAAA;AvC+3IF;;AuC33IA;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,4EAAA;EpC4PI,eALI;EoCrPR,oCAAA;EACA,gBAAA;EACA,4CAAA;EACA,SAAA;EhCrBE,gBAAA;EgCuBF,qBAAA;EjB1BI,0CiB2BJ;AvC83IF;AsBr5IM;EiBUN;IjBTQ,gBAAA;EtBw5IN;AACF;AuCj4IE;EACE,uCAAA;EACA,+CAAA;EACA,kGAAA;AvCm4IJ;AuCj4II;EACE,qDAAA;EACA,iDAAA;AvCm4IN;AuC93IE;EACE,cAAA;EACA,yCAAA;EACA,0CAAA;EACA,iBAAA;EACA,WAAA;EACA,8CAAA;EACA,4BAAA;EACA,mDAAA;EjBjDE,mDiBkDF;AvCg4IJ;AsB96IM;EiBqCJ;IjBpCM,gBAAA;EtBi7IN;AACF;AuCl4IE;EACE,UAAA;AvCo4IJ;AuCj4IE;EACE,UAAA;EACA,UAAA;EACA,oDAAA;AvCm4IJ;;AuC/3IA;EACE,gBAAA;AvCk4IF;;AuC/3IA;EACE,gCAAA;EACA,wCAAA;EACA,+EAAA;AvCk4IF;AuCh4IE;EhC7DE,yDAAA;EACA,0DAAA;APg8IJ;AuCj4II;EhChEA,+DAAA;EACA,gEAAA;APo8IJ;AuCh4IE;EACE,aAAA;AvCk4IJ;AuC93IE;EhC5DE,6DAAA;EACA,4DAAA;AP67IJ;AuC93IM;EhChEF,mEAAA;EACA,kEAAA;APi8IJ;AuC73II;EhCrEA,6DAAA;EACA,4DAAA;APq8IJ;;AuC33IA;EACE,8EAAA;AvC83IF;;AuCr3IE;EACE,eAAA;EACA,cAAA;EhC9GA,gBAAA;APu+IJ;AuCt3II;EAAgB,aAAA;AvCy3IpB;AuCx3II;EAAe,gBAAA;AvC23InB;AuCx3II;;;EhCrHA,gBAAA;APk/IJ;;AuCl3II;EACE,iEAAA;EACA,wEAAA;AvCq3IN;;AwC1gJA;EAEE,4BAAA;EACA,4BAAA;EACA,mCAAA;EAEA,oBAAA;EACA,+BAAA;EACA,wDAAA;EACA,sCAAA;EACA,4DAAA;EAGA,aAAA;EACA,eAAA;EACA,sEAAA;EACA,iDAAA;ErC+QI,yCALI;EqCxQR,gBAAA;EACA,yCAAA;EjCAE,iDAAA;AP0gJJ;;AwCpgJE;EACE,iDAAA;AxCugJJ;AwCrgJI;EACE,WAAA;EACA,kDAAA;EACA,yCAAA;EACA,uFAAA;AxCugJN;AwCngJE;EACE,6CAAA;AxCqgJJ;;AyC1iJA;EAEE,kCAAA;EACA,mCAAA;EtC4RI,+BALI;EsCrRR,2CAAA;EACA,qCAAA;EACA,oDAAA;EACA,oDAAA;EACA,sDAAA;EACA,uDAAA;EACA,+CAAA;EACA,0DAAA;EACA,uDAAA;EACA,gDAAA;EACA,wEAAA;EACA,kCAAA;EACA,kCAAA;EACA,4CAAA;EACA,yDAAA;EACA,mDAAA;EACA,6DAAA;EAGA,aAAA;EhCpBA,eAAA;EACA,gBAAA;AT+jJF;;AyCxiJA;EACE,kBAAA;EACA,cAAA;EACA,sEAAA;EtCgQI,yCALI;EsCzPR,iCAAA;EACA,qBAAA;EACA,yCAAA;EACA,iFAAA;EnBpBI,qImBqBJ;AzC2iJF;AsB5jJM;EmBQN;InBPQ,gBAAA;EtB+jJN;AACF;AyC9iJE;EACE,UAAA;EACA,uCAAA;EAEA,+CAAA;EACA,qDAAA;AzC+iJJ;AyC5iJE;EACE,UAAA;EACA,uCAAA;EACA,+CAAA;EACA,UnC2uCgC;EmC1uChC,iDAAA;AzC8iJJ;AyC3iJE;EAEE,UAAA;EACA,wCAAA;ElBtDF,gDkBuDuB;EACrB,sDAAA;AzC4iJJ;AyCziJE;EAEE,0CAAA;EACA,oBAAA;EACA,kDAAA;EACA,wDAAA;AzC0iJJ;;AyCriJE;EACE,8CnC8sCgC;AN01GpC;AyCniJM;ElC9BF,0DAAA;EACA,6DAAA;APokJJ;AyCjiJM;ElClDF,2DAAA;EACA,8DAAA;APslJJ;;AyCphJA;EClGE,iCAAA;EACA,kCAAA;EvC0RI,kCALI;EuCnRR,yDAAA;A1C0nJF;;AyCvhJA;ECtGE,iCAAA;EACA,kCAAA;EvC0RI,mCALI;EuCnRR,yDAAA;A1CioJF;;A2CnoJA;EAEE,4BAAA;EACA,4BAAA;ExCuRI,4BALI;EwChRR,2BAAA;EACA,sBAAA;EACA,iDAAA;EAGA,qBAAA;EACA,4DAAA;ExC+QI,oCALI;EwCxQR,wCAAA;EACA,cAAA;EACA,4BAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;EpCJE,4CAAA;APwoJJ;A2C/nJE;EACE,aAAA;A3CioJJ;;A2C5nJA;EACE,kBAAA;EACA,SAAA;A3C+nJF;;A4C/pJA;EAEE,0BAAA;EACA,0BAAA;EACA,0BAAA;EACA,8BAAA;EACA,yBAAA;EACA,oCAAA;EACA,4EAAA;EACA,iDAAA;EACA,8BAAA;EAGA,kBAAA;EACA,4DAAA;EACA,4CAAA;EACA,4BAAA;EACA,oCAAA;EACA,8BAAA;ErCHE,4CAAA;APmqJJ;;A4C3pJA;EAEE,cAAA;A5C6pJF;;A4CzpJA;EACE,gBtC6kB4B;EsC5kB5B,iCAAA;A5C4pJF;;A4CppJA;EACE,mBtCs+C8B;ANirGhC;A4CppJE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,qBAAA;A5CspJJ;;A4C9oJE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A5CipJJ;;A4CrpJE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,wDAAA;A5CwpJJ;;A4C5pJE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A5C+pJJ;;A4CnqJE;EACE,8CAAA;EACA,uCAAA;EACA,qDAAA;EACA,mDAAA;A5CsqJJ;;A4C1qJE;EACE,iDAAA;EACA,0CAAA;EACA,wDAAA;EACA,sDAAA;A5C6qJJ;;A4CjrJE;EACE,gDAAA;EACA,yCAAA;EACA,uDAAA;EACA,qDAAA;A5CorJJ;;A4CxrJE;EACE,+CAAA;EACA,wCAAA;EACA,sDAAA;EACA,oDAAA;A5C2rJJ;;A4C/rJE;EACE,8CAAA;EACA,uCAAA;EACA,qDAAA;EACA,mDAAA;A5CksJJ;;A6C9vJE;EACE;IAAK,gDAAA;E7CkwJP;AACF;A6C9vJA;;EAGE,0BAAA;E1CkRI,gCALI;E0C3QR,wCAAA;EACA,oDAAA;EACA,oDAAA;EACA,6BAAA;EACA,6BAAA;EACA,6CAAA;EAGA,aAAA;EACA,iCAAA;EACA,gBAAA;E1CsQI,uCALI;E0C/PR,uCAAA;EtCRE,+CAAA;APswJJ;;A6CzvJA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mCAAA;EACA,kBAAA;EACA,mBAAA;EACA,2CAAA;EvBxBI,6CuByBJ;A7C4vJF;AsBjxJM;EuBYN;IvBXQ,gBAAA;EtBoxJN;AACF;;A6C9vJA;EtBAE,qMAAA;EsBEA,oEAAA;A7CiwJF;;A6C9vJA;EACE,iBAAA;A7CiwJF;;A6C9vJA;EACE,WAAA;A7CiwJF;;A6C7vJE;EACE,kDAAA;A7CgwJJ;A6C7vJM;EAJJ;IAKM,eAAA;E7CgwJN;AACF;;A8C5zJA;EAEE,2CAAA;EACA,qCAAA;EACA,oDAAA;EACA,oDAAA;EACA,sDAAA;EACA,oCAAA;EACA,sCAAA;EACA,uDAAA;EACA,4DAAA;EACA,sDAAA;EACA,yDAAA;EACA,wDAAA;EACA,yDAAA;EACA,8CAAA;EACA,kCAAA;EACA,kCAAA;EACA,4CAAA;EAGA,aAAA;EACA,sBAAA;EAGA,eAAA;EACA,gBAAA;EvCXE,iDAAA;APs0JJ;;A8CvzJA;EACE,qBAAA;EACA,sBAAA;A9C0zJF;A8CxzJE;EAEE,oCAAA;EACA,0BAAA;A9CyzJJ;;A8CjzJA;EACE,kBAAA;EACA,cAAA;EACA,gFAAA;EACA,iCAAA;EACA,qBAAA;EACA,yCAAA;EACA,iFAAA;A9CozJF;A8ClzJE;EvC9BE,+BAAA;EACA,gCAAA;APm1JJ;A8ClzJE;EvCpBE,mCAAA;EACA,kCAAA;APy0JJ;A8ClzJE;EAEE,0CAAA;EACA,oBAAA;EACA,kDAAA;A9CmzJJ;A8C/yJE;EACE,UAAA;EACA,wCAAA;EACA,gDAAA;EACA,sDAAA;A9CizJJ;A8C7yJE;EACE,mBAAA;A9C+yJJ;A8C7yJI;EACE,wDAAA;EACA,mDAAA;A9C+yJN;;A8CryJA;EACE,WAAA;EACA,wCAAA;EACA,mBAAA;A9CwyJF;A8CpyJI;EAEE,UAAA;EACA,8CAAA;EACA,qBAAA;EACA,sDAAA;A9CqyJN;A8ClyJI;EACE,+CAAA;EACA,uDAAA;A9CoyJN;;A8CvxJI;EACE,mBAAA;A9C0xJN;A8CvxJQ;EvCzDJ,6DAAA;EAZA,0BAAA;APg2JJ;A8CtxJQ;EvC1EJ,2DAAA;EAYA,4BAAA;APw1JJ;A8CrxJQ;EACE,aAAA;A9CuxJV;A8CpxJQ;EACE,mDAAA;EACA,oBAAA;A9CsxJV;A8CpxJU;EACE,yDAAA;EACA,oDAAA;A9CsxJZ;;Ac92JI;EgCgEA;IACE,mBAAA;E9CkzJJ;E8C/yJM;IvCzDJ,6DAAA;IAZA,0BAAA;EPw3JF;E8C9yJM;IvC1EJ,2DAAA;IAYA,4BAAA;EPg3JF;E8C7yJM;IACE,aAAA;E9C+yJR;E8C5yJM;IACE,mDAAA;IACA,oBAAA;E9C8yJR;E8C5yJQ;IACE,yDAAA;IACA,oDAAA;E9C8yJV;AACF;Acv4JI;EgCgEA;IACE,mBAAA;E9C00JJ;E8Cv0JM;IvCzDJ,6DAAA;IAZA,0BAAA;EPg5JF;E8Ct0JM;IvC1EJ,2DAAA;IAYA,4BAAA;EPw4JF;E8Cr0JM;IACE,aAAA;E9Cu0JR;E8Cp0JM;IACE,mDAAA;IACA,oBAAA;E9Cs0JR;E8Cp0JQ;IACE,yDAAA;IACA,oDAAA;E9Cs0JV;AACF;Ac/5JI;EgCgEA;IACE,mBAAA;E9Ck2JJ;E8C/1JM;IvCzDJ,6DAAA;IAZA,0BAAA;EPw6JF;E8C91JM;IvC1EJ,2DAAA;IAYA,4BAAA;EPg6JF;E8C71JM;IACE,aAAA;E9C+1JR;E8C51JM;IACE,mDAAA;IACA,oBAAA;E9C81JR;E8C51JQ;IACE,yDAAA;IACA,oDAAA;E9C81JV;AACF;Acv7JI;EgCgEA;IACE,mBAAA;E9C03JJ;E8Cv3JM;IvCzDJ,6DAAA;IAZA,0BAAA;EPg8JF;E8Ct3JM;IvC1EJ,2DAAA;IAYA,4BAAA;EPw7JF;E8Cr3JM;IACE,aAAA;E9Cu3JR;E8Cp3JM;IACE,mDAAA;IACA,oBAAA;E9Cs3JR;E8Cp3JQ;IACE,yDAAA;IACA,oDAAA;E9Cs3JV;AACF;Ac/8JI;EgCgEA;IACE,mBAAA;E9Ck5JJ;E8C/4JM;IvCzDJ,6DAAA;IAZA,0BAAA;EPw9JF;E8C94JM;IvC1EJ,2DAAA;IAYA,4BAAA;EPg9JF;E8C74JM;IACE,aAAA;E9C+4JR;E8C54JM;IACE,mDAAA;IACA,oBAAA;E9C84JR;E8C54JQ;IACE,yDAAA;IACA,oDAAA;E9C84JV;AACF;A8Cj4JA;EvClJI,gBAAA;APshKJ;A8Cj4JE;EACE,mDAAA;A9Cm4JJ;A8Cj4JI;EACE,sBAAA;A9Cm4JN;;A8Ct3JE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;A9Cy3JJ;;A8Cn4JE;EACE,wDAAA;EACA,iDAAA;EACA,+DAAA;EACA,4DAAA;EACA,kEAAA;EACA,6DAAA;EACA,mEAAA;EACA,2DAAA;EACA,4DAAA;EACA,sEAAA;A9Cs4JJ;;A8Ch5JE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;A9Cm5JJ;;A8C75JE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,8DAAA;EACA,sDAAA;EACA,uDAAA;EACA,iEAAA;A9Cg6JJ;;A8C16JE;EACE,sDAAA;EACA,+CAAA;EACA,6DAAA;EACA,4DAAA;EACA,gEAAA;EACA,6DAAA;EACA,iEAAA;EACA,yDAAA;EACA,0DAAA;EACA,oEAAA;A9C66JJ;;A8Cv7JE;EACE,qDAAA;EACA,8CAAA;EACA,4DAAA;EACA,4DAAA;EACA,+DAAA;EACA,6DAAA;EACA,gEAAA;EACA,wDAAA;EACA,yDAAA;EACA,mEAAA;A9C07JJ;;A8Cp8JE;EACE,oDAAA;EACA,6CAAA;EACA,2DAAA;EACA,4DAAA;EACA,8DAAA;EACA,6DAAA;EACA,+DAAA;EACA,uDAAA;EACA,wDAAA;EACA,kEAAA;A9Cu8JJ;;A8Cj9JE;EACE,mDAAA;EACA,4CAAA;EACA,0DAAA;EACA,4DAAA;EACA,6DAAA;EACA,6DAAA;EACA,8DAAA;EACA,sDAAA;EACA,uDAAA;EACA,iEAAA;A9Co9JJ;;A+ClpKA;EAEE,0BAAA;EACA,2DAAA;EACA,2BAAA;EACA,kCAAA;EACA,mEAAA;EACA,+BAAA;EACA,qCAAA;EAGA,uBAAA;EACA,UzCupD2B;EyCtpD3B,WzCspD2B;EyCrpD3B,sBAAA;EACA,gCAAA;EACA,wEAAA;EACA,kCAAA;EACA,SAAA;ExCJE,uBAAA;EwCMF,oCAAA;A/CkpKF;A+C/oKE;EACE,gCAAA;EACA,qBAAA;EACA,0CAAA;A/CipKJ;A+C9oKE;EACE,UAAA;EACA,4CAAA;EACA,0CAAA;A/CgpKJ;A+C7oKE;EAEE,oBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,6CAAA;A/C8oKJ;;A+CtoKA;EAHE,iEAAA;A/C6oKF;;A+CtoKA;;EAEE,uBAAA;A/CyoKF;;AIprKI;E2CkCF,iEAAA;A/CspKF;;AgDvsKA;EAEE,uBAAA;EACA,6BAAA;EACA,4BAAA;EACA,0BAAA;EACA,2BAAA;E7CyRI,8BALI;E6ClRR,kBAAA;EACA,gDAAA;EACA,+CAAA;EACA,2DAAA;EACA,iDAAA;EACA,2CAAA;EACA,kDAAA;EACA,uDAAA;EACA,kEAAA;EAGA,gCAAA;EACA,eAAA;E7C2QI,oCALI;E6CpQR,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;EACA,sCAAA;EzCRE,4CAAA;APgtKJ;AgDrsKE;EACE,UAAA;AhDusKJ;AgDpsKE;EACE,aAAA;AhDssKJ;;AgDlsKA;EACE,uBAAA;EAEA,kBAAA;EACA,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;AhDosKF;AgDlsKE;EACE,sCAAA;AhDosKJ;;AgDhsKA;EACE,aAAA;EACA,mBAAA;EACA,4DAAA;EACA,mCAAA;EACA,2CAAA;EACA,4BAAA;EACA,qFAAA;EzChCE,0FAAA;EACA,2FAAA;APouKJ;AgDlsKE;EACE,oDAAA;EACA,sCAAA;AhDosKJ;;AgDhsKA;EACE,kCAAA;EACA,qBAAA;AhDmsKF;;AiDjwKA;EAEE,uBAAA;EACA,uBAAA;EACA,wBAAA;EACA,yBAAA;EACA,sCAAA;EACA,gCAAA;EACA,2DAAA;EACA,+CAAA;EACA,oDAAA;EACA,8CAAA;EACA,2FAAA;EACA,iCAAA;EACA,iCAAA;EACA,oCAAA;EACA,sDAAA;EACA,sDAAA;EACA,iCAAA;EACA,6BAAA;EACA,sBAAA;EACA,sDAAA;EACA,sDAAA;EAGA,eAAA;EACA,MAAA;EACA,OAAA;EACA,+BAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EAGA,UAAA;AjD+vKF;;AiDxvKA;EACE,kBAAA;EACA,WAAA;EACA,8BAAA;EAEA,oBAAA;AjD0vKF;AiDvvKE;EACE,8B3Cm8CgC;EgBh/C9B,mC2B8CF;AjDyvKJ;AsBnyKM;E2BwCJ;I3BvCM,gBAAA;EtBsyKN;AACF;AiD5vKE;EACE,e3Cg8CgC;AN8zHpC;AiD1vKE;EACE,sB3C67CgC;AN+zHpC;;AiDxvKA;EACE,+CAAA;AjD2vKF;AiDzvKE;EACE,gBAAA;EACA,gBAAA;AjD2vKJ;AiDxvKE;EACE,gBAAA;AjD0vKJ;;AiDtvKA;EACE,aAAA;EACA,mBAAA;EACA,mDAAA;AjDyvKF;;AiDrvKA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EAEA,4BAAA;EACA,oBAAA;EACA,oCAAA;EACA,4BAAA;EACA,uEAAA;E1CrFE,4CAAA;E0CyFF,UAAA;AjDqvKF;;AiDjvKA;EAEE,0BAAA;EACA,sBAAA;EACA,0BAAA;EClHA,eAAA;EACA,MAAA;EACA,OAAA;EACA,kCDkH0B;ECjH1B,YAAA;EACA,aAAA;EACA,uCD+G4D;AjDuvK9D;AkDn2KE;EAAS,UAAA;AlDs2KX;AkDr2KE;EAAS,mCD2GiF;AjD6vK5F;;AiDxvKA;EACE,aAAA;EACA,cAAA;EACA,mBAAA;EACA,uCAAA;EACA,4FAAA;E1CrGE,2DAAA;EACA,4DAAA;APi2KJ;AiD1vKE;EACE,kGAAA;EAEA,yDAAA;EACA,2DAAA;EACA,4DAAA;EACA,iBAAA;AjD2vKJ;;AiDtvKA;EACE,gBAAA;EACA,8CAAA;AjDyvKF;;AiDpvKA;EACE,kBAAA;EAGA,cAAA;EACA,gCAAA;AjDqvKF;;AiDjvKA;EACE,aAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,yEAAA;EACA,2CAAA;EACA,yFAAA;E1C7HE,+DAAA;EACA,8DAAA;APk3KJ;AiDhvKE;EACE,8CAAA;AjDkvKJ;;Acj2KI;EmCqHF;IACE,0BAAA;IACA,2CAAA;EjDgvKF;EiD5uKA;IACE,gCAAA;IACA,kBAAA;IACA,iBAAA;EjD8uKF;EiD3uKA;IACE,uBAAA;EjD6uKF;AACF;Ach3KI;EmCuIF;;IAEE,uBAAA;EjD4uKF;AACF;Act3KI;EmC8IF;IACE,wBAAA;EjD2uKF;AACF;AiDluKI;EACE,YAAA;EACA,eAAA;EACA,YAAA;EACA,SAAA;AjDouKN;AiDluKM;EACE,YAAA;EACA,SAAA;E1C7MJ,gBAAA;APk7KJ;AiDjuKM;;E1CjNF,gBAAA;APs7KJ;AiDhuKM;EACE,gBAAA;AjDkuKR;;Ach4KI;EmC4IA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EjDwvKJ;EiDtvKI;IACE,YAAA;IACA,SAAA;I1C7MJ,gBAAA;EPs8KF;EiDrvKI;;I1CjNF,gBAAA;EP08KF;EiDpvKI;IACE,gBAAA;EjDsvKN;AACF;Acr5KI;EmC4IA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EjD4wKJ;EiD1wKI;IACE,YAAA;IACA,SAAA;I1C7MJ,gBAAA;EP09KF;EiDzwKI;;I1CjNF,gBAAA;EP89KF;EiDxwKI;IACE,gBAAA;EjD0wKN;AACF;Acz6KI;EmC4IA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EjDgyKJ;EiD9xKI;IACE,YAAA;IACA,SAAA;I1C7MJ,gBAAA;EP8+KF;EiD7xKI;;I1CjNF,gBAAA;EPk/KF;EiD5xKI;IACE,gBAAA;EjD8xKN;AACF;Ac77KI;EmC4IA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EjDozKJ;EiDlzKI;IACE,YAAA;IACA,SAAA;I1C7MJ,gBAAA;EPkgLF;EiDjzKI;;I1CjNF,gBAAA;EPsgLF;EiDhzKI;IACE,gBAAA;EjDkzKN;AACF;Acj9KI;EmC4IA;IACE,YAAA;IACA,eAAA;IACA,YAAA;IACA,SAAA;EjDw0KJ;EiDt0KI;IACE,YAAA;IACA,SAAA;I1C7MJ,gBAAA;EPshLF;EiDr0KI;;I1CjNF,gBAAA;EP0hLF;EiDp0KI;IACE,gBAAA;EjDs0KN;AACF;AmDhjLA;EAEE,yBAAA;EACA,6BAAA;EACA,8BAAA;EACA,+BAAA;EACA,qBAAA;EhDwRI,gCALI;EgDjRR,qCAAA;EACA,yCAAA;EACA,mDAAA;EACA,yBAAA;EACA,gCAAA;EACA,iCAAA;EAGA,iCAAA;EACA,cAAA;EACA,gCAAA;EClBA,sC9C+lB4B;E8C7lB5B,kBAAA;EACA,gB9CwmB4B;E8CvmB5B,gB9C+mB4B;E8C9mB5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EjDgRI,sCALI;EgDhQR,qBAAA;EACA,UAAA;AnDwjLF;AmDtjLE;EAAS,kCAAA;AnDyjLX;AmDvjLE;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;AnDyjLJ;AmDvjLI;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;AnDyjLN;;AmDpjLA;EACE,iDAAA;AnDujLF;AmDrjLE;EACE,SAAA;EACA,wFAAA;EACA,sCAAA;AnDujLJ;;AmDnjLA,qBAAA;AACA;EACE,+CAAA;EACA,qCAAA;EACA,qCAAA;AnDsjLF;AmDpjLE;EACE,WAAA;EACA,kIAAA;EACA,wCAAA;AnDsjLJ;;AmDljLA,mBAAA;AAEA;EACE,8CAAA;AnDojLF;AmDljLE;EACE,YAAA;EACA,wFAAA;EACA,yCAAA;AnDojLJ;;AmDhjLA,qBAAA;AACA;EACE,gDAAA;EACA,qCAAA;EACA,qCAAA;AnDmjLF;AmDjjLE;EACE,UAAA;EACA,kIAAA;EACA,uCAAA;AnDmjLJ;;AmD/iLA,mBAAA;AAkBA;EACE,sCAAA;EACA,gEAAA;EACA,8BAAA;EACA,kBAAA;EACA,sCAAA;E5CjGE,8CAAA;APmoLJ;;AqDtpLA;EAEE,yBAAA;EACA,6BAAA;ElD4RI,gCALI;EkDrRR,kCAAA;EACA,iDAAA;EACA,6DAAA;EACA,sDAAA;EACA,2FAAA;EACA,6CAAA;EACA,mCAAA;EACA,qCAAA;ElDmRI,mCALI;EkD5QR,kCAAA;EACA,8CAAA;EACA,iCAAA;EACA,iCAAA;EACA,6CAAA;EACA,8BAAA;EACA,iCAAA;EACA,yDAAA;EAGA,iCAAA;EACA,cAAA;EACA,sCAAA;EDzBA,sC9C+lB4B;E8C7lB5B,kBAAA;EACA,gB9CwmB4B;E8CvmB5B,gB9C+mB4B;E8C9mB5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EjDgRI,sCALI;EkD1PR,qBAAA;EACA,sCAAA;EACA,4BAAA;EACA,2EAAA;E9ChBE,8CAAA;APirLJ;AqD7pLE;EACE,cAAA;EACA,oCAAA;EACA,sCAAA;ArD+pLJ;AqD7pLI;EAEE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;ArD8pLN;;AqDxpLE;EACE,oFAAA;ArD2pLJ;AqDzpLI;EAEE,wFAAA;ArD0pLN;AqDvpLI;EACE,SAAA;EACA,gDAAA;ArDypLN;AqDtpLI;EACE,sCAAA;EACA,sCAAA;ArDwpLN;;AqDnpLA,qBAAA;AAEE;EACE,kFAAA;EACA,qCAAA;EACA,qCAAA;ArDqpLJ;AqDnpLI;EAEE,kIAAA;ArDopLN;AqDjpLI;EACE,OAAA;EACA,kDAAA;ArDmpLN;AqDhpLI;EACE,oCAAA;EACA,wCAAA;ArDkpLN;;AqD7oLA,mBAAA;AAGE;EACE,iFAAA;ArD8oLJ;AqD5oLI;EAEE,wFAAA;ArD6oLN;AqD1oLI;EACE,MAAA;EACA,mDAAA;ArD4oLN;AqDzoLI;EACE,mCAAA;EACA,yCAAA;ArD2oLN;AqDtoLE;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,cAAA;EACA,oCAAA;EACA,uDAAA;EACA,WAAA;EACA,+EAAA;ArDwoLJ;;AqDpoLA,qBAAA;AAEE;EACE,mFAAA;EACA,qCAAA;EACA,qCAAA;ArDsoLJ;AqDpoLI;EAEE,kIAAA;ArDqoLN;AqDloLI;EACE,QAAA;EACA,iDAAA;ArDooLN;AqDjoLI;EACE,qCAAA;EACA,uCAAA;ArDmoLN;;AqD9nLA,mBAAA;AAkBA;EACE,8EAAA;EACA,gBAAA;ElD2GI,6CALI;EkDpGR,qCAAA;EACA,6CAAA;EACA,kFAAA;E9C5JE,6DAAA;EACA,8DAAA;AP6wLJ;AqD/mLE;EACE,aAAA;ArDinLJ;;AqD7mLA;EACE,0EAAA;EACA,mCAAA;ArDgnLF;;AsDryLA;EACE,kBAAA;AtDwyLF;;AsDryLA;EACE,mBAAA;AtDwyLF;;AsDryLA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;AtDwyLF;AuD9zLE;EACE,cAAA;EACA,WAAA;EACA,WAAA;AvDg0LJ;;AsDzyLA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,2BAAA;EhClBI,sCgCmBJ;AtD4yLF;AsB3zLM;EgCQN;IhCPQ,gBAAA;EtB8zLN;AACF;;AsD9yLA;;;EAGE,cAAA;AtDizLF;;AsD9yLA;;EAEE,2BAAA;AtDizLF;;AsD9yLA;;EAEE,4BAAA;AtDizLF;;AsDxyLE;EACE,UAAA;EACA,4BAAA;EACA,eAAA;AtD2yLJ;AsDxyLE;;;EAGE,UAAA;EACA,UAAA;AtD0yLJ;AsDvyLE;;EAEE,UAAA;EACA,UAAA;EhC5DE,2BgC6DF;AtDyyLJ;AsBl2LM;EgCqDJ;;IhCpDM,gBAAA;EtBs2LN;AACF;;AsDtyLA;;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UhDkhDmC;EgDjhDnC,UAAA;EACA,WhD1FS;EgD2FT,kBAAA;EACA,gBAAA;EACA,8CAAA;EACA,SAAA;EACA,YhD4gDmC;EgBnmD/B,8BgCwFJ;AtDwyLF;AsB53LM;EgCkEN;;IhCjEQ,gBAAA;EtBg4LN;AACF;AsD3yLE;;;EAEE,WhDrGO;EgDsGP,qBAAA;EACA,UAAA;EACA,YhDogDiC;AN0yIrC;;AsD3yLA;EACE,OAAA;AtD8yLF;;AsD3yLA;EACE,QAAA;AtD8yLF;;AsDzyLA;;EAEE,qBAAA;EACA,WhDsgDmC;EgDrgDnC,YhDqgDmC;EgDpgDnC,4BAAA;EACA,wBAAA;EACA,0BAAA;AtD4yLF;;AsDzyLA;EACE,0TAAA;AtD4yLF;;AsD1yLA;EACE,yTAAA;AtD6yLF;;AsDryLA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,UAAA;EAEA,iBhDq9CmC;EgDp9CnC,mBAAA;EACA,gBhDm9CmC;ANo1IrC;AsDryLE;EACE,uBAAA;EACA,cAAA;EACA,WhDo9CiC;EgDn9CjC,WhDo9CiC;EgDn9CjC,UAAA;EACA,iBhDo9CiC;EgDn9CjC,gBhDm9CiC;EgDl9CjC,mBAAA;EACA,eAAA;EACA,wDAAA;EACA,4BAAA;EACA,SAAA;EAEA,kCAAA;EACA,qCAAA;EACA,YhD28CiC;EgB5mD/B,6BgCkKF;AtDsyLJ;AsBp8LM;EgC6IJ;IhC5IM,gBAAA;EtBu8LN;AACF;AsDxyLE;EACE,UhDw8CiC;ANk2IrC;;AsDjyLA;EACE,kBAAA;EACA,UAAA;EACA,ehDk8CmC;EgDj8CnC,SAAA;EACA,oBhD+7CmC;EgD97CnC,uBhD87CmC;EgD77CnC,uCAAA;EACA,kBAAA;AtDoyLF;;AsDzxLA;EALE,uCAAA;EACA,iCAAA;EACA,2DAAA;AtDkyLF;;AsD3xLA;;EAEE,uCAAA;EACA,iCAAA;EACA,mCAAA;AtD8xLF;;AIz+LI;EkD8LF,uCAAA;EACA,iCAAA;EACA,2DAAA;AtD+yLF;;AwD1/LA;;EAEE,qBAAA;EACA,cAAA;EACA,8BAAA;EACA,gCAAA;EACA,gDAAA;EAEA,kBAAA;EACA,6FAAA;AxD4/LF;;AwDx/LA;EACE;IAAK,0CAAA;ExD4/LL;AACF;AwDz/LA;EAEE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,iCAAA;EACA,mCAAA;EACA,2CAAA;EAGA,yDAAA;EACA,+BAAA;AxDw/LF;;AwDr/LA;EAEE,wBAAA;EACA,yBAAA;EACA,gCAAA;AxDu/LF;;AwD9+LA;EACE;IACE,mBAAA;ExDi/LF;EwD/+LA;IACE,UAAA;IACA,eAAA;ExDi/LF;AACF;AwD7+LA;EAEE,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,mCAAA;EACA,yCAAA;EAGA,8BAAA;EACA,UAAA;AxD4+LF;;AwDz+LA;EACE,wBAAA;EACA,yBAAA;AxD4+LF;;AwDx+LE;EACE;;IAEE,kCAAA;ExD2+LJ;AACF;AyD5jMA;EAEE,2BAAA;EACA,2BAAA;EACA,2BAAA;EACA,8BAAA;EACA,8BAAA;EACA,0CAAA;EACA,oCAAA;EACA,mDAAA;EACA,+DAAA;EACA,kDAAA;EACA,qDAAA;EACA,qCAAA;AzD6jMF;;AchgMI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;EzD8iMJ;AACF;AsBzkMM;EmCYJ;InCXM,gBAAA;EtB4kMN;AACF;ActhMI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EzDqjMN;EyDljMI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EzDojMN;EyDjjMI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EzDmjMN;EyDhjMI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EzDkjMN;EyD/iMI;IAEE,eAAA;EzDgjMN;EyD7iMI;IAGE,mBAAA;EzD6iMN;AACF;Ac1kMI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;EzD4iMN;EyD1iMM;IACE,aAAA;EzD4iMR;EyDziMM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;EzD0iMR;AACF;;Ac9kMI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;EzD4nMJ;AACF;AsBvpMM;EmCYJ;InCXM,gBAAA;EtB0pMN;AACF;AcpmMI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EzDmoMN;EyDhoMI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EzDkoMN;EyD/nMI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EzDioMN;EyD9nMI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EzDgoMN;EyD7nMI;IAEE,eAAA;EzD8nMN;EyD3nMI;IAGE,mBAAA;EzD2nMN;AACF;AcxpMI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;EzD0nMN;EyDxnMM;IACE,aAAA;EzD0nMR;EyDvnMM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;EzDwnMR;AACF;;Ac5pMI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;EzD0sMJ;AACF;AsBruMM;EmCYJ;InCXM,gBAAA;EtBwuMN;AACF;AclrMI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EzDitMN;EyD9sMI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EzDgtMN;EyD7sMI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EzD+sMN;EyD5sMI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EzD8sMN;EyD3sMI;IAEE,eAAA;EzD4sMN;EyDzsMI;IAGE,mBAAA;EzDysMN;AACF;ActuMI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;EzDwsMN;EyDtsMM;IACE,aAAA;EzDwsMR;EyDrsMM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;EzDssMR;AACF;;Ac1uMI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;EzDwxMJ;AACF;AsBnzMM;EmCYJ;InCXM,gBAAA;EtBszMN;AACF;AchwMI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EzD+xMN;EyD5xMI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EzD8xMN;EyD3xMI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EzD6xMN;EyD1xMI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EzD4xMN;EyDzxMI;IAEE,eAAA;EzD0xMN;EyDvxMI;IAGE,mBAAA;EzDuxMN;AACF;AcpzMI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;EzDsxMN;EyDpxMM;IACE,aAAA;EzDsxMR;EyDnxMM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;EzDoxMR;AACF;;AcxzMI;E2C5CF;IAEI,eAAA;IACA,SAAA;IACA,mCAAA;IACA,aAAA;IACA,sBAAA;IACA,eAAA;IACA,gCAAA;IACA,kBAAA;IACA,wCAAA;IACA,4BAAA;IACA,UAAA;InC5BA,0CmC8BA;EzDs2MJ;AACF;AsBj4MM;EmCYJ;InCXM,gBAAA;EtBo4MN;AACF;Ac90MI;E2C5BE;IACE,MAAA;IACA,OAAA;IACA,gCAAA;IACA,qFAAA;IACA,4BAAA;EzD62MN;EyD12MI;IACE,MAAA;IACA,QAAA;IACA,gCAAA;IACA,oFAAA;IACA,2BAAA;EzD42MN;EyDz2MI;IACE,MAAA;IACA,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,sFAAA;IACA,4BAAA;EzD22MN;EyDx2MI;IACE,QAAA;IACA,OAAA;IACA,kCAAA;IACA,gBAAA;IACA,mFAAA;IACA,2BAAA;EzD02MN;EyDv2MI;IAEE,eAAA;EzDw2MN;EyDr2MI;IAGE,mBAAA;EzDq2MN;AACF;Acl4MI;E2C/BF;IAiEM,2BAAA;IACA,8BAAA;IACA,wCAAA;EzDo2MN;EyDl2MM;IACE,aAAA;EzDo2MR;EyDj2MM;IACE,aAAA;IACA,YAAA;IACA,UAAA;IACA,mBAAA;IAEA,wCAAA;EzDk2MR;AACF;;AyDl7ME;EAEI,eAAA;EACA,SAAA;EACA,mCAAA;EACA,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gCAAA;EACA,kBAAA;EACA,wCAAA;EACA,4BAAA;EACA,UAAA;EnC5BA,0CmC8BA;AzDm7MN;AsB78MM;EmCYJ;InCXM,gBAAA;EtBg9MN;AACF;AyDt7MM;EACE,MAAA;EACA,OAAA;EACA,gCAAA;EACA,qFAAA;EACA,4BAAA;AzDw7MR;AyDr7MM;EACE,MAAA;EACA,QAAA;EACA,gCAAA;EACA,oFAAA;EACA,2BAAA;AzDu7MR;AyDp7MM;EACE,MAAA;EACA,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,sFAAA;EACA,4BAAA;AzDs7MR;AyDn7MM;EACE,QAAA;EACA,OAAA;EACA,kCAAA;EACA,gBAAA;EACA,mFAAA;EACA,2BAAA;AzDq7MR;AyDl7MM;EAEE,eAAA;AzDm7MR;AyDh7MM;EAGE,mBAAA;AzDg7MR;;AyDr5MA;EPpHE,eAAA;EACA,MAAA;EACA,OAAA;EACA,a5C0mCkC;E4CzmClC,YAAA;EACA,aAAA;EACA,sB5CUS;ANmgNX;AkD1gNE;EAAS,UAAA;AlD6gNX;AkD5gNE;EAAS,Y5Cm+CyB;AN4iKpC;;AyDj6MA;EACE,aAAA;EACA,mBAAA;EACA,oEAAA;AzDo6MF;AyDl6ME;EACE,4FAAA;EAEA,sDAAA;EACA,wDAAA;EACA,yDAAA;EACA,iBAAA;AzDm6MJ;;AyD/5MA;EACE,gBAAA;EACA,kDAAA;AzDk6MF;;AyD/5MA;EACE,YAAA;EACA,oEAAA;EACA,gBAAA;AzDk6MF;;A0DnjNA;EACE,qBAAA;EACA,eAAA;EACA,sBAAA;EACA,YAAA;EACA,8BAAA;EACA,YpDgzCkC;ANswKpC;A0DpjNE;EACE,qBAAA;EACA,WAAA;A1DsjNJ;;A0DjjNA;EACE,iBAAA;A1DojNF;;A0DjjNA;EACE,iBAAA;A1DojNF;;A0DjjNA;EACE,iBAAA;A1DojNF;;A0D/iNE;EACE,mDAAA;A1DkjNJ;;A0D9iNA;EACE;IACE,YpDmxCgC;EN8xKlC;AACF;A0D9iNA;EACE,+EAAA;EACA,oBAAA;EACA,8CAAA;A1DgjNF;;A0D7iNA;EACE;IACE,uBAAA;E1DgjNF;AACF;AuD/lNE;EACE,cAAA;EACA,WAAA;EACA,WAAA;AvDimNJ;;A2DpmNE;EACE,sBAAA;EACA,iFAAA;A3DumNJ;;A2DzmNE;EACE,sBAAA;EACA,mFAAA;A3D4mNJ;;A2D9mNE;EACE,sBAAA;EACA,iFAAA;A3DinNJ;;A2DnnNE;EACE,sBAAA;EACA,8EAAA;A3DsnNJ;;A2DxnNE;EACE,sBAAA;EACA,iFAAA;A3D2nNJ;;A2D7nNE;EACE,sBAAA;EACA,gFAAA;A3DgoNJ;;A2DloNE;EACE,sBAAA;EACA,+EAAA;A3DqoNJ;;A2DvoNE;EACE,sBAAA;EACA,8EAAA;A3D0oNJ;;A4D5oNE;EACE,wEAAA;EACA,kGAAA;A5D+oNJ;A4D5oNM;EAGE,8DAAA;EACA,wFAAA;A5D4oNR;;A4DrpNE;EACE,0EAAA;EACA,oGAAA;A5DwpNJ;A4DrpNM;EAGE,8DAAA;EACA,wFAAA;A5DqpNR;;A4D9pNE;EACE,wEAAA;EACA,kGAAA;A5DiqNJ;A4D9pNM;EAGE,8DAAA;EACA,wFAAA;A5D8pNR;;A4DvqNE;EACE,qEAAA;EACA,+FAAA;A5D0qNJ;A4DvqNM;EAGE,+DAAA;EACA,yFAAA;A5DuqNR;;A4DhrNE;EACE,wEAAA;EACA,kGAAA;A5DmrNJ;A4DhrNM;EAGE,+DAAA;EACA,yFAAA;A5DgrNR;;A4DzrNE;EACE,uEAAA;EACA,iGAAA;A5D4rNJ;A4DzrNM;EAGE,8DAAA;EACA,wFAAA;A5DyrNR;;A4DlsNE;EACE,sEAAA;EACA,gGAAA;A5DqsNJ;A4DlsNM;EAGE,gEAAA;EACA,0FAAA;A5DksNR;;A4D3sNE;EACE,qEAAA;EACA,+FAAA;A5D8sNJ;A4D3sNM;EAGE,6DAAA;EACA,uFAAA;A5D2sNR;;A4DpsNA;EACE,+EAAA;EACA,yGAAA;A5DusNF;A4DpsNI;EAEE,kFAAA;EACA,4GAAA;A5DqsNN;;A6D/tNA;EACE,UAAA;EAEA,kJAAA;A7DiuNF;;A8DpuNA;EACE,oBAAA;EACA,axD6c4B;EwD5c5B,mBAAA;EACA,kFAAA;EACA,6BxD2c4B;EwD1c5B,2BAAA;A9DuuNF;A8DruNE;EACE,cAAA;EACA,UxDuc0B;EwDtc1B,WxDsc0B;EwDrc1B,kBAAA;ExCIE,sCwCHF;A9DuuNJ;AsBhuNM;EwCZJ;IxCaM,gBAAA;EtBmuNN;AACF;;A8DruNI;EACE,mEAAA;A9DwuNN;;A+D3vNA;EACE,kBAAA;EACA,WAAA;A/D8vNF;A+D5vNE;EACE,cAAA;EACA,mCAAA;EACA,WAAA;A/D8vNJ;A+D3vNE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;A/D6vNJ;;A+DxvNE;EACE,uBAAA;A/D2vNJ;;A+D5vNE;EACE,sBAAA;A/D+vNJ;;A+DhwNE;EACE,yBAAA;A/DmwNJ;;A+DpwNE;EACE,iCAAA;A/DuwNJ;;AgE5xNA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,a1DumCkC;ANwrLpC;;AgE5xNA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,a1D+lCkC;ANgsLpC;;AgEvxNI;EACE,gBAAA;EACA,MAAA;EACA,a1DmlC8B;ANusLpC;;AgEvxNI;EACE,gBAAA;EACA,SAAA;EACA,a1D6kC8B;AN6sLpC;;Ac3vNI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1DmlC8B;ENotLlC;EgEpyNE;IACE,gBAAA;IACA,SAAA;IACA,a1D6kC8B;ENytLlC;AACF;AcxwNI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1DmlC8B;ENguLlC;EgEhzNE;IACE,gBAAA;IACA,SAAA;IACA,a1D6kC8B;ENquLlC;AACF;AcpxNI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1DmlC8B;EN4uLlC;EgE5zNE;IACE,gBAAA;IACA,SAAA;IACA,a1D6kC8B;ENivLlC;AACF;AchyNI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1DmlC8B;ENwvLlC;EgEx0NE;IACE,gBAAA;IACA,SAAA;IACA,a1D6kC8B;EN6vLlC;AACF;Ac5yNI;EkDxCA;IACE,gBAAA;IACA,MAAA;IACA,a1DmlC8B;ENowLlC;EgEp1NE;IACE,gBAAA;IACA,SAAA;IACA,a1D6kC8B;ENywLlC;AACF;AiEt3NA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;AjEw3NF;;AiEr3NA;EACE,aAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;AjEw3NF;;AkEh4NA;;ECIE,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,2BAAA;EACA,iCAAA;EACA,8BAAA;EACA,oBAAA;AnEi4NF;AmE93NE;;EACE,6BAAA;AnEi4NJ;AmE73NE;;EACE,2BAAA;AnEg4NJ;;AoEn5NE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,U9DgcsC;E8D/btC,WAAA;ApEs5NJ;;AqE95NA;ECAE,gBAAA;EACA,uBAAA;EACA,mBAAA;AtEk6NF;;AuEx6NA;EACE,qBAAA;EACA,mBAAA;EACA,6BjEisB4B;EiEhsB5B,eAAA;EACA,8BAAA;EACA,ajE2rB4B;ANgvM9B;;AwE/2NQ;EAOI,mCAAA;AxE42NZ;;AwEn3NQ;EAOI,8BAAA;AxEg3NZ;;AwEv3NQ;EAOI,iCAAA;AxEo3NZ;;AwE33NQ;EAOI,iCAAA;AxEw3NZ;;AwE/3NQ;EAOI,sCAAA;AxE43NZ;;AwEn4NQ;EAOI,mCAAA;AxEg4NZ;;AwEv4NQ;EAOI,sBAAA;AxEo4NZ;;AwE34NQ;EAOI,uBAAA;AxEw4NZ;;AwE/4NQ;EAOI,sBAAA;AxE44NZ;;AwEn5NQ;EAOI,8BAAA;AxEg5NZ;;AwEv5NQ;EAOI,4BAAA;AxEo5NZ;;AwE35NQ;EAOI,2BAAA;AxEw5NZ;;AwE/5NQ;EAOI,iCAAA;AxE45NZ;;AwEn6NQ;EAOI,2BAAA;AxEg6NZ;;AwEv6NQ;EAOI,qBAAA;AxEo6NZ;;AwE36NQ;EAOI,wBAAA;AxEw6NZ;;AwE/6NQ;EAOI,uBAAA;AxE46NZ;;AwEn7NQ;EAOI,wBAAA;AxEg7NZ;;AwEv7NQ;EAOI,qBAAA;AxEo7NZ;;AwE37NQ;EAOI,yBAAA;AxEw7NZ;;AwE/7NQ;EAOI,2BAAA;AxE47NZ;;AwEn8NQ;EAOI,4BAAA;AxEg8NZ;;AwEv8NQ;EAOI,2BAAA;AxEo8NZ;;AwE38NQ;EAOI,2BAAA;AxEw8NZ;;AwE/8NQ;EAOI,6BAAA;AxE48NZ;;AwEn9NQ;EAOI,8BAAA;AxEg9NZ;;AwEv9NQ;EAOI,6BAAA;AxEo9NZ;;AwE39NQ;EAOI,2BAAA;AxEw9NZ;;AwE/9NQ;EAOI,6BAAA;AxE49NZ;;AwEn+NQ;EAOI,8BAAA;AxEg+NZ;;AwEv+NQ;EAOI,6BAAA;AxEo+NZ;;AwE3+NQ;EAOI,0BAAA;AxEw+NZ;;AwE/+NQ;EAOI,gCAAA;AxE4+NZ;;AwEn/NQ;EAOI,yBAAA;AxEg/NZ;;AwEv/NQ;EAOI,wBAAA;AxEo/NZ;;AwE3/NQ;EAOI,+BAAA;AxEw/NZ;;AwE//NQ;EAOI,yBAAA;AxE4/NZ;;AwEngOQ;EAOI,6BAAA;AxEggOZ;;AwEvgOQ;EAOI,8BAAA;AxEogOZ;;AwE3gOQ;EAOI,wBAAA;AxEwgOZ;;AwE/gOQ;EAOI,+BAAA;AxE4gOZ;;AwEnhOQ;EAOI,wBAAA;AxEghOZ;;AwEvhOQ;EAOI,2CAAA;AxEohOZ;;AwE3hOQ;EAOI,8CAAA;AxEwhOZ;;AwE/hOQ;EAOI,8CAAA;AxE4hOZ;;AwEniOQ;EAOI,2BAAA;AxEgiOZ;;AwEjjOQ;EACE,gFAAA;AxEojOV;;AwErjOQ;EACE,kFAAA;AxEwjOV;;AwEzjOQ;EACE,gFAAA;AxE4jOV;;AwE7jOQ;EACE,6EAAA;AxEgkOV;;AwEjkOQ;EACE,gFAAA;AxEokOV;;AwErkOQ;EACE,+EAAA;AxEwkOV;;AwEzkOQ;EACE,8EAAA;AxE4kOV;;AwE7kOQ;EACE,6EAAA;AxEglOV;;AwEvkOQ;EAOI,2BAAA;AxEokOZ;;AwE3kOQ;EAOI,6BAAA;AxEwkOZ;;AwE/kOQ;EAOI,6BAAA;AxE4kOZ;;AwEnlOQ;EAOI,0BAAA;AxEglOZ;;AwEvlOQ;EAOI,2BAAA;AxEolOZ;;AwE3lOQ;EAOI,iBAAA;AxEwlOZ;;AwE/lOQ;EAOI,mBAAA;AxE4lOZ;;AwEnmOQ;EAOI,oBAAA;AxEgmOZ;;AwEvmOQ;EAOI,oBAAA;AxEomOZ;;AwE3mOQ;EAOI,sBAAA;AxEwmOZ;;AwE/mOQ;EAOI,uBAAA;AxE4mOZ;;AwEnnOQ;EAOI,kBAAA;AxEgnOZ;;AwEvnOQ;EAOI,oBAAA;AxEonOZ;;AwE3nOQ;EAOI,qBAAA;AxEwnOZ;;AwE/nOQ;EAOI,mBAAA;AxE4nOZ;;AwEnoOQ;EAOI,qBAAA;AxEgoOZ;;AwEvoOQ;EAOI,sBAAA;AxEooOZ;;AwE3oOQ;EAOI,2CAAA;AxEwoOZ;;AwE/oOQ;EAOI,sCAAA;AxE4oOZ;;AwEnpOQ;EAOI,sCAAA;AxEgpOZ;;AwEvpOQ;EAOI,uFAAA;AxEopOZ;;AwE3pOQ;EAOI,oBAAA;AxEwpOZ;;AwE/pOQ;EAOI,2FAAA;AxE4pOZ;;AwEnqOQ;EAOI,wBAAA;AxEgqOZ;;AwEvqOQ;EAOI,6FAAA;AxEoqOZ;;AwE3qOQ;EAOI,0BAAA;AxEwqOZ;;AwE/qOQ;EAOI,8FAAA;AxE4qOZ;;AwEnrOQ;EAOI,2BAAA;AxEgrOZ;;AwEvrOQ;EAOI,4FAAA;AxEorOZ;;AwE3rOQ;EAOI,yBAAA;AxEwrOZ;;AwE/rOQ;EAIQ,sBAAA;EAGJ,8EAAA;AxE6rOZ;;AwEpsOQ;EAIQ,sBAAA;EAGJ,gFAAA;AxEksOZ;;AwEzsOQ;EAIQ,sBAAA;EAGJ,8EAAA;AxEusOZ;;AwE9sOQ;EAIQ,sBAAA;EAGJ,2EAAA;AxE4sOZ;;AwEntOQ;EAIQ,sBAAA;EAGJ,8EAAA;AxEitOZ;;AwExtOQ;EAIQ,sBAAA;EAGJ,6EAAA;AxEstOZ;;AwE7tOQ;EAIQ,sBAAA;EAGJ,4EAAA;AxE2tOZ;;AwEluOQ;EAIQ,sBAAA;EAGJ,2EAAA;AxEguOZ;;AwEvuOQ;EAIQ,sBAAA;EAGJ,4EAAA;AxEquOZ;;AwE5uOQ;EAIQ,sBAAA;EAGJ,4EAAA;AxE0uOZ;;AwEjvOQ;EAOI,wDAAA;AxE8uOZ;;AwErvOQ;EAOI,0DAAA;AxEkvOZ;;AwEzvOQ;EAOI,wDAAA;AxEsvOZ;;AwE7vOQ;EAOI,qDAAA;AxE0vOZ;;AwEjwOQ;EAOI,wDAAA;AxE8vOZ;;AwErwOQ;EAOI,uDAAA;AxEkwOZ;;AwEzwOQ;EAOI,sDAAA;AxEswOZ;;AwE7wOQ;EAOI,qDAAA;AxE0wOZ;;AwEjxOQ;EAOI,4BAAA;AxE8wOZ;;AwErxOQ;EAOI,4BAAA;AxEkxOZ;;AwEzxOQ;EAOI,4BAAA;AxEsxOZ;;AwE7xOQ;EAOI,4BAAA;AxE0xOZ;;AwEjyOQ;EAOI,4BAAA;AxE8xOZ;;AwE/yOQ;EACE,wBAAA;AxEkzOV;;AwEnzOQ;EACE,yBAAA;AxEszOV;;AwEvzOQ;EACE,wBAAA;AxE0zOV;;AwE3zOQ;EACE,yBAAA;AxE8zOV;;AwE/zOQ;EACE,sBAAA;AxEk0OV;;AwEzzOQ;EAOI,qBAAA;AxEszOZ;;AwE7zOQ;EAOI,qBAAA;AxE0zOZ;;AwEj0OQ;EAOI,qBAAA;AxE8zOZ;;AwEr0OQ;EAOI,sBAAA;AxEk0OZ;;AwEz0OQ;EAOI,sBAAA;AxEs0OZ;;AwE70OQ;EAOI,0BAAA;AxE00OZ;;AwEj1OQ;EAOI,uBAAA;AxE80OZ;;AwEr1OQ;EAOI,2BAAA;AxEk1OZ;;AwEz1OQ;EAOI,sBAAA;AxEs1OZ;;AwE71OQ;EAOI,sBAAA;AxE01OZ;;AwEj2OQ;EAOI,sBAAA;AxE81OZ;;AwEr2OQ;EAOI,uBAAA;AxEk2OZ;;AwEz2OQ;EAOI,uBAAA;AxEs2OZ;;AwE72OQ;EAOI,2BAAA;AxE02OZ;;AwEj3OQ;EAOI,wBAAA;AxE82OZ;;AwEr3OQ;EAOI,4BAAA;AxEk3OZ;;AwEz3OQ;EAOI,yBAAA;AxEs3OZ;;AwE73OQ;EAOI,8BAAA;AxE03OZ;;AwEj4OQ;EAOI,iCAAA;AxE83OZ;;AwEr4OQ;EAOI,sCAAA;AxEk4OZ;;AwEz4OQ;EAOI,yCAAA;AxEs4OZ;;AwE74OQ;EAOI,uBAAA;AxE04OZ;;AwEj5OQ;EAOI,uBAAA;AxE84OZ;;AwEr5OQ;EAOI,yBAAA;AxEk5OZ;;AwEz5OQ;EAOI,yBAAA;AxEs5OZ;;AwE75OQ;EAOI,0BAAA;AxE05OZ;;AwEj6OQ;EAOI,4BAAA;AxE85OZ;;AwEr6OQ;EAOI,kCAAA;AxEk6OZ;;AwEz6OQ;EAOI,sCAAA;AxEs6OZ;;AwE76OQ;EAOI,oCAAA;AxE06OZ;;AwEj7OQ;EAOI,kCAAA;AxE86OZ;;AwEr7OQ;EAOI,yCAAA;AxEk7OZ;;AwEz7OQ;EAOI,wCAAA;AxEs7OZ;;AwE77OQ;EAOI,wCAAA;AxE07OZ;;AwEj8OQ;EAOI,kCAAA;AxE87OZ;;AwEr8OQ;EAOI,gCAAA;AxEk8OZ;;AwEz8OQ;EAOI,8BAAA;AxEs8OZ;;AwE78OQ;EAOI,gCAAA;AxE08OZ;;AwEj9OQ;EAOI,+BAAA;AxE88OZ;;AwEr9OQ;EAOI,oCAAA;AxEk9OZ;;AwEz9OQ;EAOI,kCAAA;AxEs9OZ;;AwE79OQ;EAOI,gCAAA;AxE09OZ;;AwEj+OQ;EAOI,uCAAA;AxE89OZ;;AwEr+OQ;EAOI,sCAAA;AxEk+OZ;;AwEz+OQ;EAOI,iCAAA;AxEs+OZ;;AwE7+OQ;EAOI,2BAAA;AxE0+OZ;;AwEj/OQ;EAOI,iCAAA;AxE8+OZ;;AwEr/OQ;EAOI,+BAAA;AxEk/OZ;;AwEz/OQ;EAOI,6BAAA;AxEs/OZ;;AwE7/OQ;EAOI,+BAAA;AxE0/OZ;;AwEjgPQ;EAOI,8BAAA;AxE8/OZ;;AwErgPQ;EAOI,oBAAA;AxEkgPZ;;AwEzgPQ;EAOI,mBAAA;AxEsgPZ;;AwE7gPQ;EAOI,mBAAA;AxE0gPZ;;AwEjhPQ;EAOI,mBAAA;AxE8gPZ;;AwErhPQ;EAOI,mBAAA;AxEkhPZ;;AwEzhPQ;EAOI,mBAAA;AxEshPZ;;AwE7hPQ;EAOI,mBAAA;AxE0hPZ;;AwEjiPQ;EAOI,mBAAA;AxE8hPZ;;AwEriPQ;EAOI,oBAAA;AxEkiPZ;;AwEziPQ;EAOI,0BAAA;AxEsiPZ;;AwE7iPQ;EAOI,yBAAA;AxE0iPZ;;AwEjjPQ;EAOI,uBAAA;AxE8iPZ;;AwErjPQ;EAOI,yBAAA;AxEkjPZ;;AwEzjPQ;EAOI,uBAAA;AxEsjPZ;;AwE7jPQ;EAOI,uBAAA;AxE0jPZ;;AwEjkPQ;EAOI,0BAAA;EAAA,yBAAA;AxE+jPZ;;AwEtkPQ;EAOI,gCAAA;EAAA,+BAAA;AxEokPZ;;AwE3kPQ;EAOI,+BAAA;EAAA,8BAAA;AxEykPZ;;AwEhlPQ;EAOI,6BAAA;EAAA,4BAAA;AxE8kPZ;;AwErlPQ;EAOI,+BAAA;EAAA,8BAAA;AxEmlPZ;;AwE1lPQ;EAOI,6BAAA;EAAA,4BAAA;AxEwlPZ;;AwE/lPQ;EAOI,6BAAA;EAAA,4BAAA;AxE6lPZ;;AwEpmPQ;EAOI,wBAAA;EAAA,2BAAA;AxEkmPZ;;AwEzmPQ;EAOI,8BAAA;EAAA,iCAAA;AxEumPZ;;AwE9mPQ;EAOI,6BAAA;EAAA,gCAAA;AxE4mPZ;;AwEnnPQ;EAOI,2BAAA;EAAA,8BAAA;AxEinPZ;;AwExnPQ;EAOI,6BAAA;EAAA,gCAAA;AxEsnPZ;;AwE7nPQ;EAOI,2BAAA;EAAA,8BAAA;AxE2nPZ;;AwEloPQ;EAOI,2BAAA;EAAA,8BAAA;AxEgoPZ;;AwEvoPQ;EAOI,wBAAA;AxEooPZ;;AwE3oPQ;EAOI,8BAAA;AxEwoPZ;;AwE/oPQ;EAOI,6BAAA;AxE4oPZ;;AwEnpPQ;EAOI,2BAAA;AxEgpPZ;;AwEvpPQ;EAOI,6BAAA;AxEopPZ;;AwE3pPQ;EAOI,2BAAA;AxEwpPZ;;AwE/pPQ;EAOI,2BAAA;AxE4pPZ;;AwEnqPQ;EAOI,0BAAA;AxEgqPZ;;AwEvqPQ;EAOI,gCAAA;AxEoqPZ;;AwE3qPQ;EAOI,+BAAA;AxEwqPZ;;AwE/qPQ;EAOI,6BAAA;AxE4qPZ;;AwEnrPQ;EAOI,+BAAA;AxEgrPZ;;AwEvrPQ;EAOI,6BAAA;AxEorPZ;;AwE3rPQ;EAOI,6BAAA;AxEwrPZ;;AwE/rPQ;EAOI,2BAAA;AxE4rPZ;;AwEnsPQ;EAOI,iCAAA;AxEgsPZ;;AwEvsPQ;EAOI,gCAAA;AxEosPZ;;AwE3sPQ;EAOI,8BAAA;AxEwsPZ;;AwE/sPQ;EAOI,gCAAA;AxE4sPZ;;AwEntPQ;EAOI,8BAAA;AxEgtPZ;;AwEvtPQ;EAOI,8BAAA;AxEotPZ;;AwE3tPQ;EAOI,yBAAA;AxEwtPZ;;AwE/tPQ;EAOI,+BAAA;AxE4tPZ;;AwEnuPQ;EAOI,8BAAA;AxEguPZ;;AwEvuPQ;EAOI,4BAAA;AxEouPZ;;AwE3uPQ;EAOI,8BAAA;AxEwuPZ;;AwE/uPQ;EAOI,4BAAA;AxE4uPZ;;AwEnvPQ;EAOI,4BAAA;AxEgvPZ;;AwEvvPQ;EAOI,qBAAA;AxEovPZ;;AwE3vPQ;EAOI,2BAAA;AxEwvPZ;;AwE/vPQ;EAOI,0BAAA;AxE4vPZ;;AwEnwPQ;EAOI,wBAAA;AxEgwPZ;;AwEvwPQ;EAOI,0BAAA;AxEowPZ;;AwE3wPQ;EAOI,wBAAA;AxEwwPZ;;AwE/wPQ;EAOI,2BAAA;EAAA,0BAAA;AxE6wPZ;;AwEpxPQ;EAOI,iCAAA;EAAA,gCAAA;AxEkxPZ;;AwEzxPQ;EAOI,gCAAA;EAAA,+BAAA;AxEuxPZ;;AwE9xPQ;EAOI,8BAAA;EAAA,6BAAA;AxE4xPZ;;AwEnyPQ;EAOI,gCAAA;EAAA,+BAAA;AxEiyPZ;;AwExyPQ;EAOI,8BAAA;EAAA,6BAAA;AxEsyPZ;;AwE7yPQ;EAOI,yBAAA;EAAA,4BAAA;AxE2yPZ;;AwElzPQ;EAOI,+BAAA;EAAA,kCAAA;AxEgzPZ;;AwEvzPQ;EAOI,8BAAA;EAAA,iCAAA;AxEqzPZ;;AwE5zPQ;EAOI,4BAAA;EAAA,+BAAA;AxE0zPZ;;AwEj0PQ;EAOI,8BAAA;EAAA,iCAAA;AxE+zPZ;;AwEt0PQ;EAOI,4BAAA;EAAA,+BAAA;AxEo0PZ;;AwE30PQ;EAOI,yBAAA;AxEw0PZ;;AwE/0PQ;EAOI,+BAAA;AxE40PZ;;AwEn1PQ;EAOI,8BAAA;AxEg1PZ;;AwEv1PQ;EAOI,4BAAA;AxEo1PZ;;AwE31PQ;EAOI,8BAAA;AxEw1PZ;;AwE/1PQ;EAOI,4BAAA;AxE41PZ;;AwEn2PQ;EAOI,2BAAA;AxEg2PZ;;AwEv2PQ;EAOI,iCAAA;AxEo2PZ;;AwE32PQ;EAOI,gCAAA;AxEw2PZ;;AwE/2PQ;EAOI,8BAAA;AxE42PZ;;AwEn3PQ;EAOI,gCAAA;AxEg3PZ;;AwEv3PQ;EAOI,8BAAA;AxEo3PZ;;AwE33PQ;EAOI,4BAAA;AxEw3PZ;;AwE/3PQ;EAOI,kCAAA;AxE43PZ;;AwEn4PQ;EAOI,iCAAA;AxEg4PZ;;AwEv4PQ;EAOI,+BAAA;AxEo4PZ;;AwE34PQ;EAOI,iCAAA;AxEw4PZ;;AwE/4PQ;EAOI,+BAAA;AxE44PZ;;AwEn5PQ;EAOI,0BAAA;AxEg5PZ;;AwEv5PQ;EAOI,gCAAA;AxEo5PZ;;AwE35PQ;EAOI,+BAAA;AxEw5PZ;;AwE/5PQ;EAOI,6BAAA;AxE45PZ;;AwEn6PQ;EAOI,+BAAA;AxEg6PZ;;AwEv6PQ;EAOI,6BAAA;AxEo6PZ;;AwE36PQ;EAOI,iBAAA;AxEw6PZ;;AwE/6PQ;EAOI,uBAAA;AxE46PZ;;AwEn7PQ;EAOI,sBAAA;AxEg7PZ;;AwEv7PQ;EAOI,oBAAA;AxEo7PZ;;AwE37PQ;EAOI,sBAAA;AxEw7PZ;;AwE/7PQ;EAOI,oBAAA;AxE47PZ;;AwEn8PQ;EAOI,qBAAA;AxEg8PZ;;AwEv8PQ;EAOI,2BAAA;AxEo8PZ;;AwE38PQ;EAOI,0BAAA;AxEw8PZ;;AwE/8PQ;EAOI,wBAAA;AxE48PZ;;AwEn9PQ;EAOI,0BAAA;AxEg9PZ;;AwEv9PQ;EAOI,wBAAA;AxEo9PZ;;AwE39PQ;EAOI,wBAAA;AxEw9PZ;;AwE/9PQ;EAOI,8BAAA;AxE49PZ;;AwEn+PQ;EAOI,6BAAA;AxEg+PZ;;AwEv+PQ;EAOI,2BAAA;AxEo+PZ;;AwE3+PQ;EAOI,6BAAA;AxEw+PZ;;AwE/+PQ;EAOI,2BAAA;AxE4+PZ;;AwEn/PQ;EAOI,gDAAA;AxEg/PZ;;AwEv/PQ;EAOI,4CAAA;AxEo/PZ;;AwE3/PQ;EAOI,4CAAA;AxEw/PZ;;AwE//PQ;EAOI,0CAAA;AxE4/PZ;;AwEngQQ;EAOI,4CAAA;AxEggQZ;;AwEvgQQ;EAOI,6BAAA;AxEogQZ;;AwE3gQQ;EAOI,0BAAA;AxEwgQZ;;AwE/gQQ;EAOI,6BAAA;AxE4gQZ;;AwEnhQQ;EAOI,6BAAA;AxEghQZ;;AwEvhQQ;EAOI,+BAAA;AxEohQZ;;AwE3hQQ;EAOI,2BAAA;AxEwhQZ;;AwE/hQQ;EAOI,2BAAA;AxE4hQZ;;AwEniQQ;EAOI,2BAAA;AxEgiQZ;;AwEviQQ;EAOI,2BAAA;AxEoiQZ;;AwE3iQQ;EAOI,2BAAA;AxEwiQZ;;AwE/iQQ;EAOI,8BAAA;AxE4iQZ;;AwEnjQQ;EAOI,yBAAA;AxEgjQZ;;AwEvjQQ;EAOI,4BAAA;AxEojQZ;;AwE3jQQ;EAOI,2BAAA;AxEwjQZ;;AwE/jQQ;EAOI,yBAAA;AxE4jQZ;;AwEnkQQ;EAOI,2BAAA;AxEgkQZ;;AwEvkQQ;EAOI,4BAAA;AxEokQZ;;AwE3kQQ;EAOI,6BAAA;AxEwkQZ;;AwE/kQQ;EAOI,gCAAA;AxE4kQZ;;AwEnlQQ;EAOI,qCAAA;AxEglQZ;;AwEvlQQ;EAOI,wCAAA;AxEolQZ;;AwE3lQQ;EAOI,oCAAA;AxEwlQZ;;AwE/lQQ;EAOI,oCAAA;AxE4lQZ;;AwEnmQQ;EAOI,qCAAA;AxEgmQZ;;AwEvmQQ;EAOI,8BAAA;AxEomQZ;;AwE3mQQ;EAOI,8BAAA;AxEwmQZ;;AwE7nQQ,qBAAA;AAcA;EAOI,gCAAA;EAAA,iCAAA;AxE8mQZ;;AwE3lQQ,mBAAA;AA1BA;EAIQ,oBAAA;EAGJ,qEAAA;AxEonQZ;;AwE3nQQ;EAIQ,oBAAA;EAGJ,uEAAA;AxEynQZ;;AwEhoQQ;EAIQ,oBAAA;EAGJ,qEAAA;AxE8nQZ;;AwEroQQ;EAIQ,oBAAA;EAGJ,kEAAA;AxEmoQZ;;AwE1oQQ;EAIQ,oBAAA;EAGJ,qEAAA;AxEwoQZ;;AwE/oQQ;EAIQ,oBAAA;EAGJ,oEAAA;AxE6oQZ;;AwEppQQ;EAIQ,oBAAA;EAGJ,mEAAA;AxEkpQZ;;AwEzpQQ;EAIQ,oBAAA;EAGJ,kEAAA;AxEupQZ;;AwE9pQQ;EAIQ,oBAAA;EAGJ,mEAAA;AxE4pQZ;;AwEnqQQ;EAIQ,oBAAA;EAGJ,mEAAA;AxEiqQZ;;AwExqQQ;EAIQ,oBAAA;EAGJ,wEAAA;AxEsqQZ;;AwE7qQQ;EAIQ,oBAAA;EAGJ,2CAAA;AxE2qQZ;;AwElrQQ;EAIQ,oBAAA;EAGJ,oCAAA;AxEgrQZ;;AwEvrQQ;EAIQ,oBAAA;EAGJ,0CAAA;AxEqrQZ;;AwE5rQQ;EAIQ,oBAAA;EAGJ,2CAAA;AxE0rQZ;;AwEjsQQ;EAIQ,oBAAA;EAGJ,0CAAA;AxE+rQZ;;AwEtsQQ;EAIQ,oBAAA;EAGJ,0CAAA;AxEosQZ;;AwE3sQQ;EAIQ,oBAAA;EAGJ,yBAAA;AxEysQZ;;AwE1tQQ;EACE,uBAAA;AxE6tQV;;AwE9tQQ;EACE,sBAAA;AxEiuQV;;AwEluQQ;EACE,uBAAA;AxEquQV;;AwEtuQQ;EACE,oBAAA;AxEyuQV;;AwEhuQQ;EAOI,iDAAA;AxE6tQZ;;AwEpuQQ;EAOI,mDAAA;AxEiuQZ;;AwExuQQ;EAOI,iDAAA;AxEquQZ;;AwE5uQQ;EAOI,8CAAA;AxEyuQZ;;AwEhvQQ;EAOI,iDAAA;AxE6uQZ;;AwEpvQQ;EAOI,gDAAA;AxEivQZ;;AwExvQQ;EAOI,+CAAA;AxEqvQZ;;AwE5vQQ;EAOI,8CAAA;AxEyvQZ;;AwE1wQQ;EACE,sBAAA;AxE6wQV;;AwEzwQU;EACE,sBAAA;AxE4wQZ;;AwElxQQ;EACE,uBAAA;AxEqxQV;;AwEjxQU;EACE,uBAAA;AxEoxQZ;;AwE1xQQ;EACE,sBAAA;AxE6xQV;;AwEzxQU;EACE,sBAAA;AxE4xQZ;;AwElyQQ;EACE,uBAAA;AxEqyQV;;AwEjyQU;EACE,uBAAA;AxEoyQZ;;AwE1yQQ;EACE,oBAAA;AxE6yQV;;AwEzyQU;EACE,oBAAA;AxE4yQZ;;AwExyQQ;EAOI,yCAAA;AxEqyQZ;;AwEhyQU;EAOI,yCAAA;AxE6xQd;;AwEhzQQ;EAOI,wCAAA;AxE6yQZ;;AwExyQU;EAOI,wCAAA;AxEqyQd;;AwExzQQ;EAOI,yCAAA;AxEqzQZ;;AwEhzQU;EAOI,yCAAA;AxE6yQd;;AwEh0QQ;EAIQ,8BAAA;EAGJ,+FAAA;AxE8zQZ;;AwEr0QQ;EAIQ,8BAAA;EAGJ,iGAAA;AxEm0QZ;;AwE10QQ;EAIQ,8BAAA;EAGJ,+FAAA;AxEw0QZ;;AwE/0QQ;EAIQ,8BAAA;EAGJ,4FAAA;AxE60QZ;;AwEp1QQ;EAIQ,8BAAA;EAGJ,+FAAA;AxEk1QZ;;AwEz1QQ;EAIQ,8BAAA;EAGJ,8FAAA;AxEu1QZ;;AwE91QQ;EAIQ,8BAAA;EAGJ,6FAAA;AxE41QZ;;AwEn2QQ;EAIQ,8BAAA;EAGJ,4FAAA;AxEi2QZ;;AwEx2QQ;EAIQ,8BAAA;EAGJ,qGAAA;AxEs2QZ;;AwEv3QQ;EACE,8BAAA;AxE03QV;;AwEt3QU;EACE,8BAAA;AxEy3QZ;;AwE/3QQ;EACE,gCAAA;AxEk4QV;;AwE93QU;EACE,gCAAA;AxEi4QZ;;AwEv4QQ;EACE,iCAAA;AxE04QV;;AwEt4QU;EACE,iCAAA;AxEy4QZ;;AwE/4QQ;EACE,gCAAA;AxEk5QV;;AwE94QU;EACE,gCAAA;AxEi5QZ;;AwEv5QQ;EACE,iCAAA;AxE05QV;;AwEt5QU;EACE,iCAAA;AxEy5QZ;;AwE/5QQ;EACE,8BAAA;AxEk6QV;;AwE95QU;EACE,8BAAA;AxEi6QZ;;AwE75QQ;EAIQ,kBAAA;EAGJ,8EAAA;AxE25QZ;;AwEl6QQ;EAIQ,kBAAA;EAGJ,gFAAA;AxEg6QZ;;AwEv6QQ;EAIQ,kBAAA;EAGJ,8EAAA;AxEq6QZ;;AwE56QQ;EAIQ,kBAAA;EAGJ,2EAAA;AxE06QZ;;AwEj7QQ;EAIQ,kBAAA;EAGJ,8EAAA;AxE+6QZ;;AwEt7QQ;EAIQ,kBAAA;EAGJ,6EAAA;AxEo7QZ;;AwE37QQ;EAIQ,kBAAA;EAGJ,4EAAA;AxEy7QZ;;AwEh8QQ;EAIQ,kBAAA;EAGJ,2EAAA;AxE87QZ;;AwEr8QQ;EAIQ,kBAAA;EAGJ,4EAAA;AxEm8QZ;;AwE18QQ;EAIQ,kBAAA;EAGJ,4EAAA;AxEw8QZ;;AwE/8QQ;EAIQ,kBAAA;EAGJ,8EAAA;AxE68QZ;;AwEp9QQ;EAIQ,kBAAA;EAGJ,wCAAA;AxEk9QZ;;AwEz9QQ;EAIQ,kBAAA;EAGJ,mFAAA;AxEu9QZ;;AwE99QQ;EAIQ,kBAAA;EAGJ,kFAAA;AxE49QZ;;AwE7+QQ;EACE,oBAAA;AxEg/QV;;AwEj/QQ;EACE,qBAAA;AxEo/QV;;AwEr/QQ;EACE,oBAAA;AxEw/QV;;AwEz/QQ;EACE,qBAAA;AxE4/QV;;AwE7/QQ;EACE,kBAAA;AxEggRV;;AwEv/QQ;EAOI,wDAAA;AxEo/QZ;;AwE3/QQ;EAOI,0DAAA;AxEw/QZ;;AwE//QQ;EAOI,wDAAA;AxE4/QZ;;AwEngRQ;EAOI,qDAAA;AxEggRZ;;AwEvgRQ;EAOI,wDAAA;AxEogRZ;;AwE3gRQ;EAOI,uDAAA;AxEwgRZ;;AwE/gRQ;EAOI,sDAAA;AxE4gRZ;;AwEnhRQ;EAOI,qDAAA;AxEghRZ;;AwEvhRQ;EAOI,+CAAA;AxEohRZ;;AwE3hRQ;EAOI,mCAAA;UAAA,2BAAA;AxEwhRZ;;AwE/hRQ;EAOI,oCAAA;UAAA,4BAAA;AxE4hRZ;;AwEniRQ;EAOI,oCAAA;UAAA,4BAAA;AxEgiRZ;;AwEviRQ;EAOI,+BAAA;AxEoiRZ;;AwE3iRQ;EAOI,+BAAA;AxEwiRZ;;AwE/iRQ;EAOI,iDAAA;AxE4iRZ;;AwEnjRQ;EAOI,2BAAA;AxEgjRZ;;AwEvjRQ;EAOI,oDAAA;AxEojRZ;;AwE3jRQ;EAOI,iDAAA;AxEwjRZ;;AwE/jRQ;EAOI,oDAAA;AxE4jRZ;;AwEnkRQ;EAOI,oDAAA;AxEgkRZ;;AwEvkRQ;EAOI,qDAAA;AxEokRZ;;AwE3kRQ;EAOI,6BAAA;AxEwkRZ;;AwE/kRQ;EAOI,sDAAA;AxE4kRZ;;AwEnlRQ;EAOI,0DAAA;EAAA,2DAAA;AxEilRZ;;AwExlRQ;EAOI,oCAAA;EAAA,qCAAA;AxEslRZ;;AwE7lRQ;EAOI,6DAAA;EAAA,8DAAA;AxE2lRZ;;AwElmRQ;EAOI,0DAAA;EAAA,2DAAA;AxEgmRZ;;AwEvmRQ;EAOI,6DAAA;EAAA,8DAAA;AxEqmRZ;;AwE5mRQ;EAOI,6DAAA;EAAA,8DAAA;AxE0mRZ;;AwEjnRQ;EAOI,8DAAA;EAAA,+DAAA;AxE+mRZ;;AwEtnRQ;EAOI,sCAAA;EAAA,uCAAA;AxEonRZ;;AwE3nRQ;EAOI,+DAAA;EAAA,gEAAA;AxEynRZ;;AwEhoRQ;EAOI,2DAAA;EAAA,8DAAA;AxE8nRZ;;AwEroRQ;EAOI,qCAAA;EAAA,wCAAA;AxEmoRZ;;AwE1oRQ;EAOI,8DAAA;EAAA,iEAAA;AxEwoRZ;;AwE/oRQ;EAOI,2DAAA;EAAA,8DAAA;AxE6oRZ;;AwEppRQ;EAOI,8DAAA;EAAA,iEAAA;AxEkpRZ;;AwEzpRQ;EAOI,8DAAA;EAAA,iEAAA;AxEupRZ;;AwE9pRQ;EAOI,+DAAA;EAAA,kEAAA;AxE4pRZ;;AwEnqRQ;EAOI,uCAAA;EAAA,0CAAA;AxEiqRZ;;AwExqRQ;EAOI,gEAAA;EAAA,mEAAA;AxEsqRZ;;AwE7qRQ;EAOI,8DAAA;EAAA,6DAAA;AxE2qRZ;;AwElrRQ;EAOI,wCAAA;EAAA,uCAAA;AxEgrRZ;;AwEvrRQ;EAOI,iEAAA;EAAA,gEAAA;AxEqrRZ;;AwE5rRQ;EAOI,8DAAA;EAAA,6DAAA;AxE0rRZ;;AwEjsRQ;EAOI,iEAAA;EAAA,gEAAA;AxE+rRZ;;AwEtsRQ;EAOI,iEAAA;EAAA,gEAAA;AxEosRZ;;AwE3sRQ;EAOI,kEAAA;EAAA,iEAAA;AxEysRZ;;AwEhtRQ;EAOI,0CAAA;EAAA,yCAAA;AxE8sRZ;;AwErtRQ;EAOI,mEAAA;EAAA,kEAAA;AxEmtRZ;;AwE1tRQ;EAOI,6DAAA;EAAA,0DAAA;AxEwtRZ;;AwE/tRQ;EAOI,uCAAA;EAAA,oCAAA;AxE6tRZ;;AwEpuRQ;EAOI,gEAAA;EAAA,6DAAA;AxEkuRZ;;AwEzuRQ;EAOI,6DAAA;EAAA,0DAAA;AxEuuRZ;;AwE9uRQ;EAOI,gEAAA;EAAA,6DAAA;AxE4uRZ;;AwEnvRQ;EAOI,gEAAA;EAAA,6DAAA;AxEivRZ;;AwExvRQ;EAOI,iEAAA;EAAA,8DAAA;AxEsvRZ;;AwE7vRQ;EAOI,yCAAA;EAAA,sCAAA;AxE2vRZ;;AwElwRQ;EAOI,kEAAA;EAAA,+DAAA;AxEgwRZ;;AwEvwRQ;EAOI,8BAAA;AxEowRZ;;AwE3wRQ;EAOI,6BAAA;AxEwwRZ;;AwE/wRQ;EAOI,sBAAA;AxE4wRZ;;AwEnxRQ;EAOI,qBAAA;AxEgxRZ;;AwEvxRQ;EAOI,qBAAA;AxEoxRZ;;AwE3xRQ;EAOI,qBAAA;AxEwxRZ;;AwE/xRQ;EAOI,qBAAA;AxE4xRZ;;ActyRI;E0DGI;IAOI,sBAAA;ExEiyRV;EwExyRM;IAOI,uBAAA;ExEoyRV;EwE3yRM;IAOI,sBAAA;ExEuyRV;EwE9yRM;IAOI,8BAAA;ExE0yRV;EwEjzRM;IAOI,4BAAA;ExE6yRV;EwEpzRM;IAOI,2BAAA;ExEgzRV;EwEvzRM;IAOI,iCAAA;ExEmzRV;EwE1zRM;IAOI,2BAAA;ExEszRV;EwE7zRM;IAOI,0BAAA;ExEyzRV;EwEh0RM;IAOI,gCAAA;ExE4zRV;EwEn0RM;IAOI,yBAAA;ExE+zRV;EwEt0RM;IAOI,wBAAA;ExEk0RV;EwEz0RM;IAOI,+BAAA;ExEq0RV;EwE50RM;IAOI,yBAAA;ExEw0RV;EwE/0RM;IAOI,6BAAA;ExE20RV;EwEl1RM;IAOI,8BAAA;ExE80RV;EwEr1RM;IAOI,wBAAA;ExEi1RV;EwEx1RM;IAOI,+BAAA;ExEo1RV;EwE31RM;IAOI,wBAAA;ExEu1RV;EwE91RM;IAOI,yBAAA;ExE01RV;EwEj2RM;IAOI,8BAAA;ExE61RV;EwEp2RM;IAOI,iCAAA;ExEg2RV;EwEv2RM;IAOI,sCAAA;ExEm2RV;EwE12RM;IAOI,yCAAA;ExEs2RV;EwE72RM;IAOI,uBAAA;ExEy2RV;EwEh3RM;IAOI,uBAAA;ExE42RV;EwEn3RM;IAOI,yBAAA;ExE+2RV;EwEt3RM;IAOI,yBAAA;ExEk3RV;EwEz3RM;IAOI,0BAAA;ExEq3RV;EwE53RM;IAOI,4BAAA;ExEw3RV;EwE/3RM;IAOI,kCAAA;ExE23RV;EwEl4RM;IAOI,sCAAA;ExE83RV;EwEr4RM;IAOI,oCAAA;ExEi4RV;EwEx4RM;IAOI,kCAAA;ExEo4RV;EwE34RM;IAOI,yCAAA;ExEu4RV;EwE94RM;IAOI,wCAAA;ExE04RV;EwEj5RM;IAOI,wCAAA;ExE64RV;EwEp5RM;IAOI,kCAAA;ExEg5RV;EwEv5RM;IAOI,gCAAA;ExEm5RV;EwE15RM;IAOI,8BAAA;ExEs5RV;EwE75RM;IAOI,gCAAA;ExEy5RV;EwEh6RM;IAOI,+BAAA;ExE45RV;EwEn6RM;IAOI,oCAAA;ExE+5RV;EwEt6RM;IAOI,kCAAA;ExEk6RV;EwEz6RM;IAOI,gCAAA;ExEq6RV;EwE56RM;IAOI,uCAAA;ExEw6RV;EwE/6RM;IAOI,sCAAA;ExE26RV;EwEl7RM;IAOI,iCAAA;ExE86RV;EwEr7RM;IAOI,2BAAA;ExEi7RV;EwEx7RM;IAOI,iCAAA;ExEo7RV;EwE37RM;IAOI,+BAAA;ExEu7RV;EwE97RM;IAOI,6BAAA;ExE07RV;EwEj8RM;IAOI,+BAAA;ExE67RV;EwEp8RM;IAOI,8BAAA;ExEg8RV;EwEv8RM;IAOI,oBAAA;ExEm8RV;EwE18RM;IAOI,mBAAA;ExEs8RV;EwE78RM;IAOI,mBAAA;ExEy8RV;EwEh9RM;IAOI,mBAAA;ExE48RV;EwEn9RM;IAOI,mBAAA;ExE+8RV;EwEt9RM;IAOI,mBAAA;ExEk9RV;EwEz9RM;IAOI,mBAAA;ExEq9RV;EwE59RM;IAOI,mBAAA;ExEw9RV;EwE/9RM;IAOI,oBAAA;ExE29RV;EwEl+RM;IAOI,0BAAA;ExE89RV;EwEr+RM;IAOI,yBAAA;ExEi+RV;EwEx+RM;IAOI,uBAAA;ExEo+RV;EwE3+RM;IAOI,yBAAA;ExEu+RV;EwE9+RM;IAOI,uBAAA;ExE0+RV;EwEj/RM;IAOI,uBAAA;ExE6+RV;EwEp/RM;IAOI,0BAAA;IAAA,yBAAA;ExEi/RV;EwEx/RM;IAOI,gCAAA;IAAA,+BAAA;ExEq/RV;EwE5/RM;IAOI,+BAAA;IAAA,8BAAA;ExEy/RV;EwEhgSM;IAOI,6BAAA;IAAA,4BAAA;ExE6/RV;EwEpgSM;IAOI,+BAAA;IAAA,8BAAA;ExEigSV;EwExgSM;IAOI,6BAAA;IAAA,4BAAA;ExEqgSV;EwE5gSM;IAOI,6BAAA;IAAA,4BAAA;ExEygSV;EwEhhSM;IAOI,wBAAA;IAAA,2BAAA;ExE6gSV;EwEphSM;IAOI,8BAAA;IAAA,iCAAA;ExEihSV;EwExhSM;IAOI,6BAAA;IAAA,gCAAA;ExEqhSV;EwE5hSM;IAOI,2BAAA;IAAA,8BAAA;ExEyhSV;EwEhiSM;IAOI,6BAAA;IAAA,gCAAA;ExE6hSV;EwEpiSM;IAOI,2BAAA;IAAA,8BAAA;ExEiiSV;EwExiSM;IAOI,2BAAA;IAAA,8BAAA;ExEqiSV;EwE5iSM;IAOI,wBAAA;ExEwiSV;EwE/iSM;IAOI,8BAAA;ExE2iSV;EwEljSM;IAOI,6BAAA;ExE8iSV;EwErjSM;IAOI,2BAAA;ExEijSV;EwExjSM;IAOI,6BAAA;ExEojSV;EwE3jSM;IAOI,2BAAA;ExEujSV;EwE9jSM;IAOI,2BAAA;ExE0jSV;EwEjkSM;IAOI,0BAAA;ExE6jSV;EwEpkSM;IAOI,gCAAA;ExEgkSV;EwEvkSM;IAOI,+BAAA;ExEmkSV;EwE1kSM;IAOI,6BAAA;ExEskSV;EwE7kSM;IAOI,+BAAA;ExEykSV;EwEhlSM;IAOI,6BAAA;ExE4kSV;EwEnlSM;IAOI,6BAAA;ExE+kSV;EwEtlSM;IAOI,2BAAA;ExEklSV;EwEzlSM;IAOI,iCAAA;ExEqlSV;EwE5lSM;IAOI,gCAAA;ExEwlSV;EwE/lSM;IAOI,8BAAA;ExE2lSV;EwElmSM;IAOI,gCAAA;ExE8lSV;EwErmSM;IAOI,8BAAA;ExEimSV;EwExmSM;IAOI,8BAAA;ExEomSV;EwE3mSM;IAOI,yBAAA;ExEumSV;EwE9mSM;IAOI,+BAAA;ExE0mSV;EwEjnSM;IAOI,8BAAA;ExE6mSV;EwEpnSM;IAOI,4BAAA;ExEgnSV;EwEvnSM;IAOI,8BAAA;ExEmnSV;EwE1nSM;IAOI,4BAAA;ExEsnSV;EwE7nSM;IAOI,4BAAA;ExEynSV;EwEhoSM;IAOI,qBAAA;ExE4nSV;EwEnoSM;IAOI,2BAAA;ExE+nSV;EwEtoSM;IAOI,0BAAA;ExEkoSV;EwEzoSM;IAOI,wBAAA;ExEqoSV;EwE5oSM;IAOI,0BAAA;ExEwoSV;EwE/oSM;IAOI,wBAAA;ExE2oSV;EwElpSM;IAOI,2BAAA;IAAA,0BAAA;ExE+oSV;EwEtpSM;IAOI,iCAAA;IAAA,gCAAA;ExEmpSV;EwE1pSM;IAOI,gCAAA;IAAA,+BAAA;ExEupSV;EwE9pSM;IAOI,8BAAA;IAAA,6BAAA;ExE2pSV;EwElqSM;IAOI,gCAAA;IAAA,+BAAA;ExE+pSV;EwEtqSM;IAOI,8BAAA;IAAA,6BAAA;ExEmqSV;EwE1qSM;IAOI,yBAAA;IAAA,4BAAA;ExEuqSV;EwE9qSM;IAOI,+BAAA;IAAA,kCAAA;ExE2qSV;EwElrSM;IAOI,8BAAA;IAAA,iCAAA;ExE+qSV;EwEtrSM;IAOI,4BAAA;IAAA,+BAAA;ExEmrSV;EwE1rSM;IAOI,8BAAA;IAAA,iCAAA;ExEurSV;EwE9rSM;IAOI,4BAAA;IAAA,+BAAA;ExE2rSV;EwElsSM;IAOI,yBAAA;ExE8rSV;EwErsSM;IAOI,+BAAA;ExEisSV;EwExsSM;IAOI,8BAAA;ExEosSV;EwE3sSM;IAOI,4BAAA;ExEusSV;EwE9sSM;IAOI,8BAAA;ExE0sSV;EwEjtSM;IAOI,4BAAA;ExE6sSV;EwEptSM;IAOI,2BAAA;ExEgtSV;EwEvtSM;IAOI,iCAAA;ExEmtSV;EwE1tSM;IAOI,gCAAA;ExEstSV;EwE7tSM;IAOI,8BAAA;ExEytSV;EwEhuSM;IAOI,gCAAA;ExE4tSV;EwEnuSM;IAOI,8BAAA;ExE+tSV;EwEtuSM;IAOI,4BAAA;ExEkuSV;EwEzuSM;IAOI,kCAAA;ExEquSV;EwE5uSM;IAOI,iCAAA;ExEwuSV;EwE/uSM;IAOI,+BAAA;ExE2uSV;EwElvSM;IAOI,iCAAA;ExE8uSV;EwErvSM;IAOI,+BAAA;ExEivSV;EwExvSM;IAOI,0BAAA;ExEovSV;EwE3vSM;IAOI,gCAAA;ExEuvSV;EwE9vSM;IAOI,+BAAA;ExE0vSV;EwEjwSM;IAOI,6BAAA;ExE6vSV;EwEpwSM;IAOI,+BAAA;ExEgwSV;EwEvwSM;IAOI,6BAAA;ExEmwSV;EwE1wSM;IAOI,iBAAA;ExEswSV;EwE7wSM;IAOI,uBAAA;ExEywSV;EwEhxSM;IAOI,sBAAA;ExE4wSV;EwEnxSM;IAOI,oBAAA;ExE+wSV;EwEtxSM;IAOI,sBAAA;ExEkxSV;EwEzxSM;IAOI,oBAAA;ExEqxSV;EwE5xSM;IAOI,qBAAA;ExEwxSV;EwE/xSM;IAOI,2BAAA;ExE2xSV;EwElySM;IAOI,0BAAA;ExE8xSV;EwErySM;IAOI,wBAAA;ExEiySV;EwExySM;IAOI,0BAAA;ExEoySV;EwE3ySM;IAOI,wBAAA;ExEuySV;EwE9ySM;IAOI,wBAAA;ExE0ySV;EwEjzSM;IAOI,8BAAA;ExE6ySV;EwEpzSM;IAOI,6BAAA;ExEgzSV;EwEvzSM;IAOI,2BAAA;ExEmzSV;EwE1zSM;IAOI,6BAAA;ExEszSV;EwE7zSM;IAOI,2BAAA;ExEyzSV;EwEh0SM;IAOI,2BAAA;ExE4zSV;EwEn0SM;IAOI,4BAAA;ExE+zSV;EwEt0SM;IAOI,6BAAA;ExEk0SV;AACF;Ac70SI;E0DGI;IAOI,sBAAA;ExEu0SV;EwE90SM;IAOI,uBAAA;ExE00SV;EwEj1SM;IAOI,sBAAA;ExE60SV;EwEp1SM;IAOI,8BAAA;ExEg1SV;EwEv1SM;IAOI,4BAAA;ExEm1SV;EwE11SM;IAOI,2BAAA;ExEs1SV;EwE71SM;IAOI,iCAAA;ExEy1SV;EwEh2SM;IAOI,2BAAA;ExE41SV;EwEn2SM;IAOI,0BAAA;ExE+1SV;EwEt2SM;IAOI,gCAAA;ExEk2SV;EwEz2SM;IAOI,yBAAA;ExEq2SV;EwE52SM;IAOI,wBAAA;ExEw2SV;EwE/2SM;IAOI,+BAAA;ExE22SV;EwEl3SM;IAOI,yBAAA;ExE82SV;EwEr3SM;IAOI,6BAAA;ExEi3SV;EwEx3SM;IAOI,8BAAA;ExEo3SV;EwE33SM;IAOI,wBAAA;ExEu3SV;EwE93SM;IAOI,+BAAA;ExE03SV;EwEj4SM;IAOI,wBAAA;ExE63SV;EwEp4SM;IAOI,yBAAA;ExEg4SV;EwEv4SM;IAOI,8BAAA;ExEm4SV;EwE14SM;IAOI,iCAAA;ExEs4SV;EwE74SM;IAOI,sCAAA;ExEy4SV;EwEh5SM;IAOI,yCAAA;ExE44SV;EwEn5SM;IAOI,uBAAA;ExE+4SV;EwEt5SM;IAOI,uBAAA;ExEk5SV;EwEz5SM;IAOI,yBAAA;ExEq5SV;EwE55SM;IAOI,yBAAA;ExEw5SV;EwE/5SM;IAOI,0BAAA;ExE25SV;EwEl6SM;IAOI,4BAAA;ExE85SV;EwEr6SM;IAOI,kCAAA;ExEi6SV;EwEx6SM;IAOI,sCAAA;ExEo6SV;EwE36SM;IAOI,oCAAA;ExEu6SV;EwE96SM;IAOI,kCAAA;ExE06SV;EwEj7SM;IAOI,yCAAA;ExE66SV;EwEp7SM;IAOI,wCAAA;ExEg7SV;EwEv7SM;IAOI,wCAAA;ExEm7SV;EwE17SM;IAOI,kCAAA;ExEs7SV;EwE77SM;IAOI,gCAAA;ExEy7SV;EwEh8SM;IAOI,8BAAA;ExE47SV;EwEn8SM;IAOI,gCAAA;ExE+7SV;EwEt8SM;IAOI,+BAAA;ExEk8SV;EwEz8SM;IAOI,oCAAA;ExEq8SV;EwE58SM;IAOI,kCAAA;ExEw8SV;EwE/8SM;IAOI,gCAAA;ExE28SV;EwEl9SM;IAOI,uCAAA;ExE88SV;EwEr9SM;IAOI,sCAAA;ExEi9SV;EwEx9SM;IAOI,iCAAA;ExEo9SV;EwE39SM;IAOI,2BAAA;ExEu9SV;EwE99SM;IAOI,iCAAA;ExE09SV;EwEj+SM;IAOI,+BAAA;ExE69SV;EwEp+SM;IAOI,6BAAA;ExEg+SV;EwEv+SM;IAOI,+BAAA;ExEm+SV;EwE1+SM;IAOI,8BAAA;ExEs+SV;EwE7+SM;IAOI,oBAAA;ExEy+SV;EwEh/SM;IAOI,mBAAA;ExE4+SV;EwEn/SM;IAOI,mBAAA;ExE++SV;EwEt/SM;IAOI,mBAAA;ExEk/SV;EwEz/SM;IAOI,mBAAA;ExEq/SV;EwE5/SM;IAOI,mBAAA;ExEw/SV;EwE//SM;IAOI,mBAAA;ExE2/SV;EwElgTM;IAOI,mBAAA;ExE8/SV;EwErgTM;IAOI,oBAAA;ExEigTV;EwExgTM;IAOI,0BAAA;ExEogTV;EwE3gTM;IAOI,yBAAA;ExEugTV;EwE9gTM;IAOI,uBAAA;ExE0gTV;EwEjhTM;IAOI,yBAAA;ExE6gTV;EwEphTM;IAOI,uBAAA;ExEghTV;EwEvhTM;IAOI,uBAAA;ExEmhTV;EwE1hTM;IAOI,0BAAA;IAAA,yBAAA;ExEuhTV;EwE9hTM;IAOI,gCAAA;IAAA,+BAAA;ExE2hTV;EwEliTM;IAOI,+BAAA;IAAA,8BAAA;ExE+hTV;EwEtiTM;IAOI,6BAAA;IAAA,4BAAA;ExEmiTV;EwE1iTM;IAOI,+BAAA;IAAA,8BAAA;ExEuiTV;EwE9iTM;IAOI,6BAAA;IAAA,4BAAA;ExE2iTV;EwEljTM;IAOI,6BAAA;IAAA,4BAAA;ExE+iTV;EwEtjTM;IAOI,wBAAA;IAAA,2BAAA;ExEmjTV;EwE1jTM;IAOI,8BAAA;IAAA,iCAAA;ExEujTV;EwE9jTM;IAOI,6BAAA;IAAA,gCAAA;ExE2jTV;EwElkTM;IAOI,2BAAA;IAAA,8BAAA;ExE+jTV;EwEtkTM;IAOI,6BAAA;IAAA,gCAAA;ExEmkTV;EwE1kTM;IAOI,2BAAA;IAAA,8BAAA;ExEukTV;EwE9kTM;IAOI,2BAAA;IAAA,8BAAA;ExE2kTV;EwEllTM;IAOI,wBAAA;ExE8kTV;EwErlTM;IAOI,8BAAA;ExEilTV;EwExlTM;IAOI,6BAAA;ExEolTV;EwE3lTM;IAOI,2BAAA;ExEulTV;EwE9lTM;IAOI,6BAAA;ExE0lTV;EwEjmTM;IAOI,2BAAA;ExE6lTV;EwEpmTM;IAOI,2BAAA;ExEgmTV;EwEvmTM;IAOI,0BAAA;ExEmmTV;EwE1mTM;IAOI,gCAAA;ExEsmTV;EwE7mTM;IAOI,+BAAA;ExEymTV;EwEhnTM;IAOI,6BAAA;ExE4mTV;EwEnnTM;IAOI,+BAAA;ExE+mTV;EwEtnTM;IAOI,6BAAA;ExEknTV;EwEznTM;IAOI,6BAAA;ExEqnTV;EwE5nTM;IAOI,2BAAA;ExEwnTV;EwE/nTM;IAOI,iCAAA;ExE2nTV;EwEloTM;IAOI,gCAAA;ExE8nTV;EwEroTM;IAOI,8BAAA;ExEioTV;EwExoTM;IAOI,gCAAA;ExEooTV;EwE3oTM;IAOI,8BAAA;ExEuoTV;EwE9oTM;IAOI,8BAAA;ExE0oTV;EwEjpTM;IAOI,yBAAA;ExE6oTV;EwEppTM;IAOI,+BAAA;ExEgpTV;EwEvpTM;IAOI,8BAAA;ExEmpTV;EwE1pTM;IAOI,4BAAA;ExEspTV;EwE7pTM;IAOI,8BAAA;ExEypTV;EwEhqTM;IAOI,4BAAA;ExE4pTV;EwEnqTM;IAOI,4BAAA;ExE+pTV;EwEtqTM;IAOI,qBAAA;ExEkqTV;EwEzqTM;IAOI,2BAAA;ExEqqTV;EwE5qTM;IAOI,0BAAA;ExEwqTV;EwE/qTM;IAOI,wBAAA;ExE2qTV;EwElrTM;IAOI,0BAAA;ExE8qTV;EwErrTM;IAOI,wBAAA;ExEirTV;EwExrTM;IAOI,2BAAA;IAAA,0BAAA;ExEqrTV;EwE5rTM;IAOI,iCAAA;IAAA,gCAAA;ExEyrTV;EwEhsTM;IAOI,gCAAA;IAAA,+BAAA;ExE6rTV;EwEpsTM;IAOI,8BAAA;IAAA,6BAAA;ExEisTV;EwExsTM;IAOI,gCAAA;IAAA,+BAAA;ExEqsTV;EwE5sTM;IAOI,8BAAA;IAAA,6BAAA;ExEysTV;EwEhtTM;IAOI,yBAAA;IAAA,4BAAA;ExE6sTV;EwEptTM;IAOI,+BAAA;IAAA,kCAAA;ExEitTV;EwExtTM;IAOI,8BAAA;IAAA,iCAAA;ExEqtTV;EwE5tTM;IAOI,4BAAA;IAAA,+BAAA;ExEytTV;EwEhuTM;IAOI,8BAAA;IAAA,iCAAA;ExE6tTV;EwEpuTM;IAOI,4BAAA;IAAA,+BAAA;ExEiuTV;EwExuTM;IAOI,yBAAA;ExEouTV;EwE3uTM;IAOI,+BAAA;ExEuuTV;EwE9uTM;IAOI,8BAAA;ExE0uTV;EwEjvTM;IAOI,4BAAA;ExE6uTV;EwEpvTM;IAOI,8BAAA;ExEgvTV;EwEvvTM;IAOI,4BAAA;ExEmvTV;EwE1vTM;IAOI,2BAAA;ExEsvTV;EwE7vTM;IAOI,iCAAA;ExEyvTV;EwEhwTM;IAOI,gCAAA;ExE4vTV;EwEnwTM;IAOI,8BAAA;ExE+vTV;EwEtwTM;IAOI,gCAAA;ExEkwTV;EwEzwTM;IAOI,8BAAA;ExEqwTV;EwE5wTM;IAOI,4BAAA;ExEwwTV;EwE/wTM;IAOI,kCAAA;ExE2wTV;EwElxTM;IAOI,iCAAA;ExE8wTV;EwErxTM;IAOI,+BAAA;ExEixTV;EwExxTM;IAOI,iCAAA;ExEoxTV;EwE3xTM;IAOI,+BAAA;ExEuxTV;EwE9xTM;IAOI,0BAAA;ExE0xTV;EwEjyTM;IAOI,gCAAA;ExE6xTV;EwEpyTM;IAOI,+BAAA;ExEgyTV;EwEvyTM;IAOI,6BAAA;ExEmyTV;EwE1yTM;IAOI,+BAAA;ExEsyTV;EwE7yTM;IAOI,6BAAA;ExEyyTV;EwEhzTM;IAOI,iBAAA;ExE4yTV;EwEnzTM;IAOI,uBAAA;ExE+yTV;EwEtzTM;IAOI,sBAAA;ExEkzTV;EwEzzTM;IAOI,oBAAA;ExEqzTV;EwE5zTM;IAOI,sBAAA;ExEwzTV;EwE/zTM;IAOI,oBAAA;ExE2zTV;EwEl0TM;IAOI,qBAAA;ExE8zTV;EwEr0TM;IAOI,2BAAA;ExEi0TV;EwEx0TM;IAOI,0BAAA;ExEo0TV;EwE30TM;IAOI,wBAAA;ExEu0TV;EwE90TM;IAOI,0BAAA;ExE00TV;EwEj1TM;IAOI,wBAAA;ExE60TV;EwEp1TM;IAOI,wBAAA;ExEg1TV;EwEv1TM;IAOI,8BAAA;ExEm1TV;EwE11TM;IAOI,6BAAA;ExEs1TV;EwE71TM;IAOI,2BAAA;ExEy1TV;EwEh2TM;IAOI,6BAAA;ExE41TV;EwEn2TM;IAOI,2BAAA;ExE+1TV;EwEt2TM;IAOI,2BAAA;ExEk2TV;EwEz2TM;IAOI,4BAAA;ExEq2TV;EwE52TM;IAOI,6BAAA;ExEw2TV;AACF;Acn3TI;E0DGI;IAOI,sBAAA;ExE62TV;EwEp3TM;IAOI,uBAAA;ExEg3TV;EwEv3TM;IAOI,sBAAA;ExEm3TV;EwE13TM;IAOI,8BAAA;ExEs3TV;EwE73TM;IAOI,4BAAA;ExEy3TV;EwEh4TM;IAOI,2BAAA;ExE43TV;EwEn4TM;IAOI,iCAAA;ExE+3TV;EwEt4TM;IAOI,2BAAA;ExEk4TV;EwEz4TM;IAOI,0BAAA;ExEq4TV;EwE54TM;IAOI,gCAAA;ExEw4TV;EwE/4TM;IAOI,yBAAA;ExE24TV;EwEl5TM;IAOI,wBAAA;ExE84TV;EwEr5TM;IAOI,+BAAA;ExEi5TV;EwEx5TM;IAOI,yBAAA;ExEo5TV;EwE35TM;IAOI,6BAAA;ExEu5TV;EwE95TM;IAOI,8BAAA;ExE05TV;EwEj6TM;IAOI,wBAAA;ExE65TV;EwEp6TM;IAOI,+BAAA;ExEg6TV;EwEv6TM;IAOI,wBAAA;ExEm6TV;EwE16TM;IAOI,yBAAA;ExEs6TV;EwE76TM;IAOI,8BAAA;ExEy6TV;EwEh7TM;IAOI,iCAAA;ExE46TV;EwEn7TM;IAOI,sCAAA;ExE+6TV;EwEt7TM;IAOI,yCAAA;ExEk7TV;EwEz7TM;IAOI,uBAAA;ExEq7TV;EwE57TM;IAOI,uBAAA;ExEw7TV;EwE/7TM;IAOI,yBAAA;ExE27TV;EwEl8TM;IAOI,yBAAA;ExE87TV;EwEr8TM;IAOI,0BAAA;ExEi8TV;EwEx8TM;IAOI,4BAAA;ExEo8TV;EwE38TM;IAOI,kCAAA;ExEu8TV;EwE98TM;IAOI,sCAAA;ExE08TV;EwEj9TM;IAOI,oCAAA;ExE68TV;EwEp9TM;IAOI,kCAAA;ExEg9TV;EwEv9TM;IAOI,yCAAA;ExEm9TV;EwE19TM;IAOI,wCAAA;ExEs9TV;EwE79TM;IAOI,wCAAA;ExEy9TV;EwEh+TM;IAOI,kCAAA;ExE49TV;EwEn+TM;IAOI,gCAAA;ExE+9TV;EwEt+TM;IAOI,8BAAA;ExEk+TV;EwEz+TM;IAOI,gCAAA;ExEq+TV;EwE5+TM;IAOI,+BAAA;ExEw+TV;EwE/+TM;IAOI,oCAAA;ExE2+TV;EwEl/TM;IAOI,kCAAA;ExE8+TV;EwEr/TM;IAOI,gCAAA;ExEi/TV;EwEx/TM;IAOI,uCAAA;ExEo/TV;EwE3/TM;IAOI,sCAAA;ExEu/TV;EwE9/TM;IAOI,iCAAA;ExE0/TV;EwEjgUM;IAOI,2BAAA;ExE6/TV;EwEpgUM;IAOI,iCAAA;ExEggUV;EwEvgUM;IAOI,+BAAA;ExEmgUV;EwE1gUM;IAOI,6BAAA;ExEsgUV;EwE7gUM;IAOI,+BAAA;ExEygUV;EwEhhUM;IAOI,8BAAA;ExE4gUV;EwEnhUM;IAOI,oBAAA;ExE+gUV;EwEthUM;IAOI,mBAAA;ExEkhUV;EwEzhUM;IAOI,mBAAA;ExEqhUV;EwE5hUM;IAOI,mBAAA;ExEwhUV;EwE/hUM;IAOI,mBAAA;ExE2hUV;EwEliUM;IAOI,mBAAA;ExE8hUV;EwEriUM;IAOI,mBAAA;ExEiiUV;EwExiUM;IAOI,mBAAA;ExEoiUV;EwE3iUM;IAOI,oBAAA;ExEuiUV;EwE9iUM;IAOI,0BAAA;ExE0iUV;EwEjjUM;IAOI,yBAAA;ExE6iUV;EwEpjUM;IAOI,uBAAA;ExEgjUV;EwEvjUM;IAOI,yBAAA;ExEmjUV;EwE1jUM;IAOI,uBAAA;ExEsjUV;EwE7jUM;IAOI,uBAAA;ExEyjUV;EwEhkUM;IAOI,0BAAA;IAAA,yBAAA;ExE6jUV;EwEpkUM;IAOI,gCAAA;IAAA,+BAAA;ExEikUV;EwExkUM;IAOI,+BAAA;IAAA,8BAAA;ExEqkUV;EwE5kUM;IAOI,6BAAA;IAAA,4BAAA;ExEykUV;EwEhlUM;IAOI,+BAAA;IAAA,8BAAA;ExE6kUV;EwEplUM;IAOI,6BAAA;IAAA,4BAAA;ExEilUV;EwExlUM;IAOI,6BAAA;IAAA,4BAAA;ExEqlUV;EwE5lUM;IAOI,wBAAA;IAAA,2BAAA;ExEylUV;EwEhmUM;IAOI,8BAAA;IAAA,iCAAA;ExE6lUV;EwEpmUM;IAOI,6BAAA;IAAA,gCAAA;ExEimUV;EwExmUM;IAOI,2BAAA;IAAA,8BAAA;ExEqmUV;EwE5mUM;IAOI,6BAAA;IAAA,gCAAA;ExEymUV;EwEhnUM;IAOI,2BAAA;IAAA,8BAAA;ExE6mUV;EwEpnUM;IAOI,2BAAA;IAAA,8BAAA;ExEinUV;EwExnUM;IAOI,wBAAA;ExEonUV;EwE3nUM;IAOI,8BAAA;ExEunUV;EwE9nUM;IAOI,6BAAA;ExE0nUV;EwEjoUM;IAOI,2BAAA;ExE6nUV;EwEpoUM;IAOI,6BAAA;ExEgoUV;EwEvoUM;IAOI,2BAAA;ExEmoUV;EwE1oUM;IAOI,2BAAA;ExEsoUV;EwE7oUM;IAOI,0BAAA;ExEyoUV;EwEhpUM;IAOI,gCAAA;ExE4oUV;EwEnpUM;IAOI,+BAAA;ExE+oUV;EwEtpUM;IAOI,6BAAA;ExEkpUV;EwEzpUM;IAOI,+BAAA;ExEqpUV;EwE5pUM;IAOI,6BAAA;ExEwpUV;EwE/pUM;IAOI,6BAAA;ExE2pUV;EwElqUM;IAOI,2BAAA;ExE8pUV;EwErqUM;IAOI,iCAAA;ExEiqUV;EwExqUM;IAOI,gCAAA;ExEoqUV;EwE3qUM;IAOI,8BAAA;ExEuqUV;EwE9qUM;IAOI,gCAAA;ExE0qUV;EwEjrUM;IAOI,8BAAA;ExE6qUV;EwEprUM;IAOI,8BAAA;ExEgrUV;EwEvrUM;IAOI,yBAAA;ExEmrUV;EwE1rUM;IAOI,+BAAA;ExEsrUV;EwE7rUM;IAOI,8BAAA;ExEyrUV;EwEhsUM;IAOI,4BAAA;ExE4rUV;EwEnsUM;IAOI,8BAAA;ExE+rUV;EwEtsUM;IAOI,4BAAA;ExEksUV;EwEzsUM;IAOI,4BAAA;ExEqsUV;EwE5sUM;IAOI,qBAAA;ExEwsUV;EwE/sUM;IAOI,2BAAA;ExE2sUV;EwEltUM;IAOI,0BAAA;ExE8sUV;EwErtUM;IAOI,wBAAA;ExEitUV;EwExtUM;IAOI,0BAAA;ExEotUV;EwE3tUM;IAOI,wBAAA;ExEutUV;EwE9tUM;IAOI,2BAAA;IAAA,0BAAA;ExE2tUV;EwEluUM;IAOI,iCAAA;IAAA,gCAAA;ExE+tUV;EwEtuUM;IAOI,gCAAA;IAAA,+BAAA;ExEmuUV;EwE1uUM;IAOI,8BAAA;IAAA,6BAAA;ExEuuUV;EwE9uUM;IAOI,gCAAA;IAAA,+BAAA;ExE2uUV;EwElvUM;IAOI,8BAAA;IAAA,6BAAA;ExE+uUV;EwEtvUM;IAOI,yBAAA;IAAA,4BAAA;ExEmvUV;EwE1vUM;IAOI,+BAAA;IAAA,kCAAA;ExEuvUV;EwE9vUM;IAOI,8BAAA;IAAA,iCAAA;ExE2vUV;EwElwUM;IAOI,4BAAA;IAAA,+BAAA;ExE+vUV;EwEtwUM;IAOI,8BAAA;IAAA,iCAAA;ExEmwUV;EwE1wUM;IAOI,4BAAA;IAAA,+BAAA;ExEuwUV;EwE9wUM;IAOI,yBAAA;ExE0wUV;EwEjxUM;IAOI,+BAAA;ExE6wUV;EwEpxUM;IAOI,8BAAA;ExEgxUV;EwEvxUM;IAOI,4BAAA;ExEmxUV;EwE1xUM;IAOI,8BAAA;ExEsxUV;EwE7xUM;IAOI,4BAAA;ExEyxUV;EwEhyUM;IAOI,2BAAA;ExE4xUV;EwEnyUM;IAOI,iCAAA;ExE+xUV;EwEtyUM;IAOI,gCAAA;ExEkyUV;EwEzyUM;IAOI,8BAAA;ExEqyUV;EwE5yUM;IAOI,gCAAA;ExEwyUV;EwE/yUM;IAOI,8BAAA;ExE2yUV;EwElzUM;IAOI,4BAAA;ExE8yUV;EwErzUM;IAOI,kCAAA;ExEizUV;EwExzUM;IAOI,iCAAA;ExEozUV;EwE3zUM;IAOI,+BAAA;ExEuzUV;EwE9zUM;IAOI,iCAAA;ExE0zUV;EwEj0UM;IAOI,+BAAA;ExE6zUV;EwEp0UM;IAOI,0BAAA;ExEg0UV;EwEv0UM;IAOI,gCAAA;ExEm0UV;EwE10UM;IAOI,+BAAA;ExEs0UV;EwE70UM;IAOI,6BAAA;ExEy0UV;EwEh1UM;IAOI,+BAAA;ExE40UV;EwEn1UM;IAOI,6BAAA;ExE+0UV;EwEt1UM;IAOI,iBAAA;ExEk1UV;EwEz1UM;IAOI,uBAAA;ExEq1UV;EwE51UM;IAOI,sBAAA;ExEw1UV;EwE/1UM;IAOI,oBAAA;ExE21UV;EwEl2UM;IAOI,sBAAA;ExE81UV;EwEr2UM;IAOI,oBAAA;ExEi2UV;EwEx2UM;IAOI,qBAAA;ExEo2UV;EwE32UM;IAOI,2BAAA;ExEu2UV;EwE92UM;IAOI,0BAAA;ExE02UV;EwEj3UM;IAOI,wBAAA;ExE62UV;EwEp3UM;IAOI,0BAAA;ExEg3UV;EwEv3UM;IAOI,wBAAA;ExEm3UV;EwE13UM;IAOI,wBAAA;ExEs3UV;EwE73UM;IAOI,8BAAA;ExEy3UV;EwEh4UM;IAOI,6BAAA;ExE43UV;EwEn4UM;IAOI,2BAAA;ExE+3UV;EwEt4UM;IAOI,6BAAA;ExEk4UV;EwEz4UM;IAOI,2BAAA;ExEq4UV;EwE54UM;IAOI,2BAAA;ExEw4UV;EwE/4UM;IAOI,4BAAA;ExE24UV;EwEl5UM;IAOI,6BAAA;ExE84UV;AACF;Acz5UI;E0DGI;IAOI,sBAAA;ExEm5UV;EwE15UM;IAOI,uBAAA;ExEs5UV;EwE75UM;IAOI,sBAAA;ExEy5UV;EwEh6UM;IAOI,8BAAA;ExE45UV;EwEn6UM;IAOI,4BAAA;ExE+5UV;EwEt6UM;IAOI,2BAAA;ExEk6UV;EwEz6UM;IAOI,iCAAA;ExEq6UV;EwE56UM;IAOI,2BAAA;ExEw6UV;EwE/6UM;IAOI,0BAAA;ExE26UV;EwEl7UM;IAOI,gCAAA;ExE86UV;EwEr7UM;IAOI,yBAAA;ExEi7UV;EwEx7UM;IAOI,wBAAA;ExEo7UV;EwE37UM;IAOI,+BAAA;ExEu7UV;EwE97UM;IAOI,yBAAA;ExE07UV;EwEj8UM;IAOI,6BAAA;ExE67UV;EwEp8UM;IAOI,8BAAA;ExEg8UV;EwEv8UM;IAOI,wBAAA;ExEm8UV;EwE18UM;IAOI,+BAAA;ExEs8UV;EwE78UM;IAOI,wBAAA;ExEy8UV;EwEh9UM;IAOI,yBAAA;ExE48UV;EwEn9UM;IAOI,8BAAA;ExE+8UV;EwEt9UM;IAOI,iCAAA;ExEk9UV;EwEz9UM;IAOI,sCAAA;ExEq9UV;EwE59UM;IAOI,yCAAA;ExEw9UV;EwE/9UM;IAOI,uBAAA;ExE29UV;EwEl+UM;IAOI,uBAAA;ExE89UV;EwEr+UM;IAOI,yBAAA;ExEi+UV;EwEx+UM;IAOI,yBAAA;ExEo+UV;EwE3+UM;IAOI,0BAAA;ExEu+UV;EwE9+UM;IAOI,4BAAA;ExE0+UV;EwEj/UM;IAOI,kCAAA;ExE6+UV;EwEp/UM;IAOI,sCAAA;ExEg/UV;EwEv/UM;IAOI,oCAAA;ExEm/UV;EwE1/UM;IAOI,kCAAA;ExEs/UV;EwE7/UM;IAOI,yCAAA;ExEy/UV;EwEhgVM;IAOI,wCAAA;ExE4/UV;EwEngVM;IAOI,wCAAA;ExE+/UV;EwEtgVM;IAOI,kCAAA;ExEkgVV;EwEzgVM;IAOI,gCAAA;ExEqgVV;EwE5gVM;IAOI,8BAAA;ExEwgVV;EwE/gVM;IAOI,gCAAA;ExE2gVV;EwElhVM;IAOI,+BAAA;ExE8gVV;EwErhVM;IAOI,oCAAA;ExEihVV;EwExhVM;IAOI,kCAAA;ExEohVV;EwE3hVM;IAOI,gCAAA;ExEuhVV;EwE9hVM;IAOI,uCAAA;ExE0hVV;EwEjiVM;IAOI,sCAAA;ExE6hVV;EwEpiVM;IAOI,iCAAA;ExEgiVV;EwEviVM;IAOI,2BAAA;ExEmiVV;EwE1iVM;IAOI,iCAAA;ExEsiVV;EwE7iVM;IAOI,+BAAA;ExEyiVV;EwEhjVM;IAOI,6BAAA;ExE4iVV;EwEnjVM;IAOI,+BAAA;ExE+iVV;EwEtjVM;IAOI,8BAAA;ExEkjVV;EwEzjVM;IAOI,oBAAA;ExEqjVV;EwE5jVM;IAOI,mBAAA;ExEwjVV;EwE/jVM;IAOI,mBAAA;ExE2jVV;EwElkVM;IAOI,mBAAA;ExE8jVV;EwErkVM;IAOI,mBAAA;ExEikVV;EwExkVM;IAOI,mBAAA;ExEokVV;EwE3kVM;IAOI,mBAAA;ExEukVV;EwE9kVM;IAOI,mBAAA;ExE0kVV;EwEjlVM;IAOI,oBAAA;ExE6kVV;EwEplVM;IAOI,0BAAA;ExEglVV;EwEvlVM;IAOI,yBAAA;ExEmlVV;EwE1lVM;IAOI,uBAAA;ExEslVV;EwE7lVM;IAOI,yBAAA;ExEylVV;EwEhmVM;IAOI,uBAAA;ExE4lVV;EwEnmVM;IAOI,uBAAA;ExE+lVV;EwEtmVM;IAOI,0BAAA;IAAA,yBAAA;ExEmmVV;EwE1mVM;IAOI,gCAAA;IAAA,+BAAA;ExEumVV;EwE9mVM;IAOI,+BAAA;IAAA,8BAAA;ExE2mVV;EwElnVM;IAOI,6BAAA;IAAA,4BAAA;ExE+mVV;EwEtnVM;IAOI,+BAAA;IAAA,8BAAA;ExEmnVV;EwE1nVM;IAOI,6BAAA;IAAA,4BAAA;ExEunVV;EwE9nVM;IAOI,6BAAA;IAAA,4BAAA;ExE2nVV;EwEloVM;IAOI,wBAAA;IAAA,2BAAA;ExE+nVV;EwEtoVM;IAOI,8BAAA;IAAA,iCAAA;ExEmoVV;EwE1oVM;IAOI,6BAAA;IAAA,gCAAA;ExEuoVV;EwE9oVM;IAOI,2BAAA;IAAA,8BAAA;ExE2oVV;EwElpVM;IAOI,6BAAA;IAAA,gCAAA;ExE+oVV;EwEtpVM;IAOI,2BAAA;IAAA,8BAAA;ExEmpVV;EwE1pVM;IAOI,2BAAA;IAAA,8BAAA;ExEupVV;EwE9pVM;IAOI,wBAAA;ExE0pVV;EwEjqVM;IAOI,8BAAA;ExE6pVV;EwEpqVM;IAOI,6BAAA;ExEgqVV;EwEvqVM;IAOI,2BAAA;ExEmqVV;EwE1qVM;IAOI,6BAAA;ExEsqVV;EwE7qVM;IAOI,2BAAA;ExEyqVV;EwEhrVM;IAOI,2BAAA;ExE4qVV;EwEnrVM;IAOI,0BAAA;ExE+qVV;EwEtrVM;IAOI,gCAAA;ExEkrVV;EwEzrVM;IAOI,+BAAA;ExEqrVV;EwE5rVM;IAOI,6BAAA;ExEwrVV;EwE/rVM;IAOI,+BAAA;ExE2rVV;EwElsVM;IAOI,6BAAA;ExE8rVV;EwErsVM;IAOI,6BAAA;ExEisVV;EwExsVM;IAOI,2BAAA;ExEosVV;EwE3sVM;IAOI,iCAAA;ExEusVV;EwE9sVM;IAOI,gCAAA;ExE0sVV;EwEjtVM;IAOI,8BAAA;ExE6sVV;EwEptVM;IAOI,gCAAA;ExEgtVV;EwEvtVM;IAOI,8BAAA;ExEmtVV;EwE1tVM;IAOI,8BAAA;ExEstVV;EwE7tVM;IAOI,yBAAA;ExEytVV;EwEhuVM;IAOI,+BAAA;ExE4tVV;EwEnuVM;IAOI,8BAAA;ExE+tVV;EwEtuVM;IAOI,4BAAA;ExEkuVV;EwEzuVM;IAOI,8BAAA;ExEquVV;EwE5uVM;IAOI,4BAAA;ExEwuVV;EwE/uVM;IAOI,4BAAA;ExE2uVV;EwElvVM;IAOI,qBAAA;ExE8uVV;EwErvVM;IAOI,2BAAA;ExEivVV;EwExvVM;IAOI,0BAAA;ExEovVV;EwE3vVM;IAOI,wBAAA;ExEuvVV;EwE9vVM;IAOI,0BAAA;ExE0vVV;EwEjwVM;IAOI,wBAAA;ExE6vVV;EwEpwVM;IAOI,2BAAA;IAAA,0BAAA;ExEiwVV;EwExwVM;IAOI,iCAAA;IAAA,gCAAA;ExEqwVV;EwE5wVM;IAOI,gCAAA;IAAA,+BAAA;ExEywVV;EwEhxVM;IAOI,8BAAA;IAAA,6BAAA;ExE6wVV;EwEpxVM;IAOI,gCAAA;IAAA,+BAAA;ExEixVV;EwExxVM;IAOI,8BAAA;IAAA,6BAAA;ExEqxVV;EwE5xVM;IAOI,yBAAA;IAAA,4BAAA;ExEyxVV;EwEhyVM;IAOI,+BAAA;IAAA,kCAAA;ExE6xVV;EwEpyVM;IAOI,8BAAA;IAAA,iCAAA;ExEiyVV;EwExyVM;IAOI,4BAAA;IAAA,+BAAA;ExEqyVV;EwE5yVM;IAOI,8BAAA;IAAA,iCAAA;ExEyyVV;EwEhzVM;IAOI,4BAAA;IAAA,+BAAA;ExE6yVV;EwEpzVM;IAOI,yBAAA;ExEgzVV;EwEvzVM;IAOI,+BAAA;ExEmzVV;EwE1zVM;IAOI,8BAAA;ExEszVV;EwE7zVM;IAOI,4BAAA;ExEyzVV;EwEh0VM;IAOI,8BAAA;ExE4zVV;EwEn0VM;IAOI,4BAAA;ExE+zVV;EwEt0VM;IAOI,2BAAA;ExEk0VV;EwEz0VM;IAOI,iCAAA;ExEq0VV;EwE50VM;IAOI,gCAAA;ExEw0VV;EwE/0VM;IAOI,8BAAA;ExE20VV;EwEl1VM;IAOI,gCAAA;ExE80VV;EwEr1VM;IAOI,8BAAA;ExEi1VV;EwEx1VM;IAOI,4BAAA;ExEo1VV;EwE31VM;IAOI,kCAAA;ExEu1VV;EwE91VM;IAOI,iCAAA;ExE01VV;EwEj2VM;IAOI,+BAAA;ExE61VV;EwEp2VM;IAOI,iCAAA;ExEg2VV;EwEv2VM;IAOI,+BAAA;ExEm2VV;EwE12VM;IAOI,0BAAA;ExEs2VV;EwE72VM;IAOI,gCAAA;ExEy2VV;EwEh3VM;IAOI,+BAAA;ExE42VV;EwEn3VM;IAOI,6BAAA;ExE+2VV;EwEt3VM;IAOI,+BAAA;ExEk3VV;EwEz3VM;IAOI,6BAAA;ExEq3VV;EwE53VM;IAOI,iBAAA;ExEw3VV;EwE/3VM;IAOI,uBAAA;ExE23VV;EwEl4VM;IAOI,sBAAA;ExE83VV;EwEr4VM;IAOI,oBAAA;ExEi4VV;EwEx4VM;IAOI,sBAAA;ExEo4VV;EwE34VM;IAOI,oBAAA;ExEu4VV;EwE94VM;IAOI,qBAAA;ExE04VV;EwEj5VM;IAOI,2BAAA;ExE64VV;EwEp5VM;IAOI,0BAAA;ExEg5VV;EwEv5VM;IAOI,wBAAA;ExEm5VV;EwE15VM;IAOI,0BAAA;ExEs5VV;EwE75VM;IAOI,wBAAA;ExEy5VV;EwEh6VM;IAOI,wBAAA;ExE45VV;EwEn6VM;IAOI,8BAAA;ExE+5VV;EwEt6VM;IAOI,6BAAA;ExEk6VV;EwEz6VM;IAOI,2BAAA;ExEq6VV;EwE56VM;IAOI,6BAAA;ExEw6VV;EwE/6VM;IAOI,2BAAA;ExE26VV;EwEl7VM;IAOI,2BAAA;ExE86VV;EwEr7VM;IAOI,4BAAA;ExEi7VV;EwEx7VM;IAOI,6BAAA;ExEo7VV;AACF;Ac/7VI;E0DGI;IAOI,sBAAA;ExEy7VV;EwEh8VM;IAOI,uBAAA;ExE47VV;EwEn8VM;IAOI,sBAAA;ExE+7VV;EwEt8VM;IAOI,8BAAA;ExEk8VV;EwEz8VM;IAOI,4BAAA;ExEq8VV;EwE58VM;IAOI,2BAAA;ExEw8VV;EwE/8VM;IAOI,iCAAA;ExE28VV;EwEl9VM;IAOI,2BAAA;ExE88VV;EwEr9VM;IAOI,0BAAA;ExEi9VV;EwEx9VM;IAOI,gCAAA;ExEo9VV;EwE39VM;IAOI,yBAAA;ExEu9VV;EwE99VM;IAOI,wBAAA;ExE09VV;EwEj+VM;IAOI,+BAAA;ExE69VV;EwEp+VM;IAOI,yBAAA;ExEg+VV;EwEv+VM;IAOI,6BAAA;ExEm+VV;EwE1+VM;IAOI,8BAAA;ExEs+VV;EwE7+VM;IAOI,wBAAA;ExEy+VV;EwEh/VM;IAOI,+BAAA;ExE4+VV;EwEn/VM;IAOI,wBAAA;ExE++VV;EwEt/VM;IAOI,yBAAA;ExEk/VV;EwEz/VM;IAOI,8BAAA;ExEq/VV;EwE5/VM;IAOI,iCAAA;ExEw/VV;EwE//VM;IAOI,sCAAA;ExE2/VV;EwElgWM;IAOI,yCAAA;ExE8/VV;EwErgWM;IAOI,uBAAA;ExEigWV;EwExgWM;IAOI,uBAAA;ExEogWV;EwE3gWM;IAOI,yBAAA;ExEugWV;EwE9gWM;IAOI,yBAAA;ExE0gWV;EwEjhWM;IAOI,0BAAA;ExE6gWV;EwEphWM;IAOI,4BAAA;ExEghWV;EwEvhWM;IAOI,kCAAA;ExEmhWV;EwE1hWM;IAOI,sCAAA;ExEshWV;EwE7hWM;IAOI,oCAAA;ExEyhWV;EwEhiWM;IAOI,kCAAA;ExE4hWV;EwEniWM;IAOI,yCAAA;ExE+hWV;EwEtiWM;IAOI,wCAAA;ExEkiWV;EwEziWM;IAOI,wCAAA;ExEqiWV;EwE5iWM;IAOI,kCAAA;ExEwiWV;EwE/iWM;IAOI,gCAAA;ExE2iWV;EwEljWM;IAOI,8BAAA;ExE8iWV;EwErjWM;IAOI,gCAAA;ExEijWV;EwExjWM;IAOI,+BAAA;ExEojWV;EwE3jWM;IAOI,oCAAA;ExEujWV;EwE9jWM;IAOI,kCAAA;ExE0jWV;EwEjkWM;IAOI,gCAAA;ExE6jWV;EwEpkWM;IAOI,uCAAA;ExEgkWV;EwEvkWM;IAOI,sCAAA;ExEmkWV;EwE1kWM;IAOI,iCAAA;ExEskWV;EwE7kWM;IAOI,2BAAA;ExEykWV;EwEhlWM;IAOI,iCAAA;ExE4kWV;EwEnlWM;IAOI,+BAAA;ExE+kWV;EwEtlWM;IAOI,6BAAA;ExEklWV;EwEzlWM;IAOI,+BAAA;ExEqlWV;EwE5lWM;IAOI,8BAAA;ExEwlWV;EwE/lWM;IAOI,oBAAA;ExE2lWV;EwElmWM;IAOI,mBAAA;ExE8lWV;EwErmWM;IAOI,mBAAA;ExEimWV;EwExmWM;IAOI,mBAAA;ExEomWV;EwE3mWM;IAOI,mBAAA;ExEumWV;EwE9mWM;IAOI,mBAAA;ExE0mWV;EwEjnWM;IAOI,mBAAA;ExE6mWV;EwEpnWM;IAOI,mBAAA;ExEgnWV;EwEvnWM;IAOI,oBAAA;ExEmnWV;EwE1nWM;IAOI,0BAAA;ExEsnWV;EwE7nWM;IAOI,yBAAA;ExEynWV;EwEhoWM;IAOI,uBAAA;ExE4nWV;EwEnoWM;IAOI,yBAAA;ExE+nWV;EwEtoWM;IAOI,uBAAA;ExEkoWV;EwEzoWM;IAOI,uBAAA;ExEqoWV;EwE5oWM;IAOI,0BAAA;IAAA,yBAAA;ExEyoWV;EwEhpWM;IAOI,gCAAA;IAAA,+BAAA;ExE6oWV;EwEppWM;IAOI,+BAAA;IAAA,8BAAA;ExEipWV;EwExpWM;IAOI,6BAAA;IAAA,4BAAA;ExEqpWV;EwE5pWM;IAOI,+BAAA;IAAA,8BAAA;ExEypWV;EwEhqWM;IAOI,6BAAA;IAAA,4BAAA;ExE6pWV;EwEpqWM;IAOI,6BAAA;IAAA,4BAAA;ExEiqWV;EwExqWM;IAOI,wBAAA;IAAA,2BAAA;ExEqqWV;EwE5qWM;IAOI,8BAAA;IAAA,iCAAA;ExEyqWV;EwEhrWM;IAOI,6BAAA;IAAA,gCAAA;ExE6qWV;EwEprWM;IAOI,2BAAA;IAAA,8BAAA;ExEirWV;EwExrWM;IAOI,6BAAA;IAAA,gCAAA;ExEqrWV;EwE5rWM;IAOI,2BAAA;IAAA,8BAAA;ExEyrWV;EwEhsWM;IAOI,2BAAA;IAAA,8BAAA;ExE6rWV;EwEpsWM;IAOI,wBAAA;ExEgsWV;EwEvsWM;IAOI,8BAAA;ExEmsWV;EwE1sWM;IAOI,6BAAA;ExEssWV;EwE7sWM;IAOI,2BAAA;ExEysWV;EwEhtWM;IAOI,6BAAA;ExE4sWV;EwEntWM;IAOI,2BAAA;ExE+sWV;EwEttWM;IAOI,2BAAA;ExEktWV;EwEztWM;IAOI,0BAAA;ExEqtWV;EwE5tWM;IAOI,gCAAA;ExEwtWV;EwE/tWM;IAOI,+BAAA;ExE2tWV;EwEluWM;IAOI,6BAAA;ExE8tWV;EwEruWM;IAOI,+BAAA;ExEiuWV;EwExuWM;IAOI,6BAAA;ExEouWV;EwE3uWM;IAOI,6BAAA;ExEuuWV;EwE9uWM;IAOI,2BAAA;ExE0uWV;EwEjvWM;IAOI,iCAAA;ExE6uWV;EwEpvWM;IAOI,gCAAA;ExEgvWV;EwEvvWM;IAOI,8BAAA;ExEmvWV;EwE1vWM;IAOI,gCAAA;ExEsvWV;EwE7vWM;IAOI,8BAAA;ExEyvWV;EwEhwWM;IAOI,8BAAA;ExE4vWV;EwEnwWM;IAOI,yBAAA;ExE+vWV;EwEtwWM;IAOI,+BAAA;ExEkwWV;EwEzwWM;IAOI,8BAAA;ExEqwWV;EwE5wWM;IAOI,4BAAA;ExEwwWV;EwE/wWM;IAOI,8BAAA;ExE2wWV;EwElxWM;IAOI,4BAAA;ExE8wWV;EwErxWM;IAOI,4BAAA;ExEixWV;EwExxWM;IAOI,qBAAA;ExEoxWV;EwE3xWM;IAOI,2BAAA;ExEuxWV;EwE9xWM;IAOI,0BAAA;ExE0xWV;EwEjyWM;IAOI,wBAAA;ExE6xWV;EwEpyWM;IAOI,0BAAA;ExEgyWV;EwEvyWM;IAOI,wBAAA;ExEmyWV;EwE1yWM;IAOI,2BAAA;IAAA,0BAAA;ExEuyWV;EwE9yWM;IAOI,iCAAA;IAAA,gCAAA;ExE2yWV;EwElzWM;IAOI,gCAAA;IAAA,+BAAA;ExE+yWV;EwEtzWM;IAOI,8BAAA;IAAA,6BAAA;ExEmzWV;EwE1zWM;IAOI,gCAAA;IAAA,+BAAA;ExEuzWV;EwE9zWM;IAOI,8BAAA;IAAA,6BAAA;ExE2zWV;EwEl0WM;IAOI,yBAAA;IAAA,4BAAA;ExE+zWV;EwEt0WM;IAOI,+BAAA;IAAA,kCAAA;ExEm0WV;EwE10WM;IAOI,8BAAA;IAAA,iCAAA;ExEu0WV;EwE90WM;IAOI,4BAAA;IAAA,+BAAA;ExE20WV;EwEl1WM;IAOI,8BAAA;IAAA,iCAAA;ExE+0WV;EwEt1WM;IAOI,4BAAA;IAAA,+BAAA;ExEm1WV;EwE11WM;IAOI,yBAAA;ExEs1WV;EwE71WM;IAOI,+BAAA;ExEy1WV;EwEh2WM;IAOI,8BAAA;ExE41WV;EwEn2WM;IAOI,4BAAA;ExE+1WV;EwEt2WM;IAOI,8BAAA;ExEk2WV;EwEz2WM;IAOI,4BAAA;ExEq2WV;EwE52WM;IAOI,2BAAA;ExEw2WV;EwE/2WM;IAOI,iCAAA;ExE22WV;EwEl3WM;IAOI,gCAAA;ExE82WV;EwEr3WM;IAOI,8BAAA;ExEi3WV;EwEx3WM;IAOI,gCAAA;ExEo3WV;EwE33WM;IAOI,8BAAA;ExEu3WV;EwE93WM;IAOI,4BAAA;ExE03WV;EwEj4WM;IAOI,kCAAA;ExE63WV;EwEp4WM;IAOI,iCAAA;ExEg4WV;EwEv4WM;IAOI,+BAAA;ExEm4WV;EwE14WM;IAOI,iCAAA;ExEs4WV;EwE74WM;IAOI,+BAAA;ExEy4WV;EwEh5WM;IAOI,0BAAA;ExE44WV;EwEn5WM;IAOI,gCAAA;ExE+4WV;EwEt5WM;IAOI,+BAAA;ExEk5WV;EwEz5WM;IAOI,6BAAA;ExEq5WV;EwE55WM;IAOI,+BAAA;ExEw5WV;EwE/5WM;IAOI,6BAAA;ExE25WV;EwEl6WM;IAOI,iBAAA;ExE85WV;EwEr6WM;IAOI,uBAAA;ExEi6WV;EwEx6WM;IAOI,sBAAA;ExEo6WV;EwE36WM;IAOI,oBAAA;ExEu6WV;EwE96WM;IAOI,sBAAA;ExE06WV;EwEj7WM;IAOI,oBAAA;ExE66WV;EwEp7WM;IAOI,qBAAA;ExEg7WV;EwEv7WM;IAOI,2BAAA;ExEm7WV;EwE17WM;IAOI,0BAAA;ExEs7WV;EwE77WM;IAOI,wBAAA;ExEy7WV;EwEh8WM;IAOI,0BAAA;ExE47WV;EwEn8WM;IAOI,wBAAA;ExE+7WV;EwEt8WM;IAOI,wBAAA;ExEk8WV;EwEz8WM;IAOI,8BAAA;ExEq8WV;EwE58WM;IAOI,6BAAA;ExEw8WV;EwE/8WM;IAOI,2BAAA;ExE28WV;EwEl9WM;IAOI,6BAAA;ExE88WV;EwEr9WM;IAOI,2BAAA;ExEi9WV;EwEx9WM;IAOI,2BAAA;ExEo9WV;EwE39WM;IAOI,4BAAA;ExEu9WV;EwE99WM;IAOI,6BAAA;ExE09WV;AACF;AyEjhXA;ED+CQ;IAOI,4BAAA;ExE+9WV;EwEt+WM;IAOI,0BAAA;ExEk+WV;EwEz+WM;IAOI,6BAAA;ExEq+WV;EwE5+WM;IAOI,4BAAA;ExEw+WV;AACF;AyE5gXA;ED4BQ;IAOI,0BAAA;ExE6+WV;EwEp/WM;IAOI,gCAAA;ExEg/WV;EwEv/WM;IAOI,yBAAA;ExEm/WV;EwE1/WM;IAOI,wBAAA;ExEs/WV;EwE7/WM;IAOI,+BAAA;ExEy/WV;EwEhgXM;IAOI,yBAAA;ExE4/WV;EwEngXM;IAOI,6BAAA;ExE+/WV;EwEtgXM;IAOI,8BAAA;ExEkgXV;EwEzgXM;IAOI,wBAAA;ExEqgXV;EwE5gXM;IAOI,+BAAA;ExEwgXV;EwE/gXM;IAOI,wBAAA;ExE2gXV;AACF;A0ErlXA;EACI,yBCSc;EDRd,mBAAA;EACA,yBAAA;EACA,mDAAA;EACA,kBAAA;A1EulXJ;;A0EplXA;EACI,gCC0CK;EDzCL,mBAAA;EACA,iBAAA;EACA,cCHoB;A3E0lXxB;;A0EnlXI;EACI,yBAAA;A1EslXR;;A0EhlXQ;EACI,qBCvBI;EDwBJ,mBCxBI;A3E2mXhB;;A0E7kXI;EACI,mBAAA;EACA,iBAAA;EACA,yBAAA;EACA,cC1BgB;A3E0mXxB;;A0E3kXI;EACI,mBAAA;EACA,iBAAA;EACA,yBAAA;EACA,cCnCgB;A3EinXxB;;A0EzkXI;EACI,UAAA;A1E4kXR;A0ExkXY;;EAEI,gBAAA;A1E0kXhB;A0ErkXI;EACI,eAAA;A1EukXR;A0ErkXQ;EACI,YAAA;A1EukXZ;A0ErkXY;EACI,WAAA;EACA,YAAA;A1EukXhB;;A0EjkXA;EACI,aAAA;EACA,8BAAA;A1EokXJ;AcrkXI;E4DDJ;IAKQ,cAAA;E1EqkXN;AACF;A0EnkXI;EACI,aAAA;EACA,eAAA;A1EqkXR;Ac9kXI;E4DOA;IAKQ,WAAA;IACA,kBAAA;E1EskXV;AACF;A0EpkXQ;EACI,YAAA;A1EskXZ;A0EpkXY;EACI,UAAA;EACA,eAAA;A1EskXhB;A0EnkXQ;EACI,YAAA;A1EqkXZ;A0EnkXY;EACI,UAAA;EACA,eAAA;EACA,gBAAA;A1EqkXhB;A0E9jXY;EACI,eAAA;EACA,kBAAA;A1EgkXhB;A0E3jXY;EACI,oBAAA;EACA,iBAAA;EACA,kBAAA;A1E6jXhB;;A0EvjXA;EACI,iDAAA;A1E0jXJ;A0ExjXI;EACI,eAAA;EACA,iBAAA;EACA,cCtIQ;EDuIR,gBAAA;EACA,uBAAA;EACA,uBAAA;EACA,SAAA;EACA,gCAAA;A1E0jXR;A0ExjXQ;EACI,cCtIY;A3EgsXxB;;A0ErjXA;EACI,kBAAA;EACA,WAAA;EACA,QAAA;A1EwjXJ;;A0EtjXA;EACI,kBAAA;EACA,WAAA;EACA,eAAA;A1EyjXJ;;A0EtjXA;EACI,WAAA;EACA,YAAA;EACA,eAAA;A1EyjXJ;;A4E3tXA;EACI,kBAAA;EACA,cDSoB;ECRpB,gCDgDK;EC/CL,qBAAA;A5E8tXJ;;A4E3tXA;EACI,qBAAA;EACA,YAAA;EACA,oCAAA;EACA,gCDwCK;ECvCL,mBAAA;EACA,cDJoB;ECKpB,yBAAA;EACA,iBAAA;A5E8tXJ;A4E5tXI;EACI,mBAAA;A5E8tXR;A4E3tXI;EACI,6BAAA;A5E6tXR;A4E1tXI;EACI,oCAAA;EACA,4BAAA;A5E4tXR;;A4EttXI;EACI,gBAAA;A5EytXR;A4EttXI;EACI,yBDpCU;ECqCV,qBDrCU;A3E6vXlB;;A4EntXA;EACI,eAAA;EACA,gBAAA;A5EstXJ;A4EptXI;EACI,eAAA;EACA,gBAAA;A5EstXR;A4EptXQ;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;A5EstXZ;A4EjtXQ;EACI,mBD5DM;A3E+wXlB;A4EjtXY;EACI,mBAAA;EACA,cAAA;A5EmtXhB;;A4E7sXA;EACI,uBAAA;A5EgtXJ;;A4EzsXA;EACI,aAAA;A5EgtXJ;;A4E7sXA;EACI,qBDpFY;ECqFZ,mBDrFY;A3EqyXhB;;A4E7sXA;EACI,qBDzFY;EC0FZ,mBD1FY;A3E0yXhB;;A4E7sXA;EACI,mBD9FY;A3E8yXhB;;A4E7sXA;EACI,cDlGY;A3EkzXhB;;A4E5sXA;EACI,qBDvGY;ECwGZ,mBD/Fc;A3E8yXlB;;A4E5sXA;EACI,WAAA;EACA,YAAA;EACA,sBAAA;EACA,yBD/GY;A3E8zXhB;;A4E5sXA;EACI,qBDnHY;A3Ek0XhB;;A4EvsXA;EACI,cD3GK;A3EyzXT;;A4E3sXA;;EAEI,gBAAA;A5E8sXJ;A4E5sXI;;;EAEI,qBD5GE;A3E2zXV;;A4E3sXA;EACI,aAAA;EACA,eAAA;EACA,0BAAA;A5E8sXJ;A4E5sXI;EACI,gBAAA;A5E8sXR;A4E3sXI;EACI,qBAAA;EACA,YAAA;EACA,eAAA;A5E6sXR;A4E3sXQ;EACI,eAAA;EACA,cD3IH;EC4IG,qBAAA;EACA,kBAAA;A5E6sXZ;A4E3sXY;EACI,cD5HP;EC6HO,qBAAA;EACA,kBAAA;EACA,gBAAA;A5E6sXhB;A4EzsXQ;EACI,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;A5E2sXZ;A4EzsXY;EACI,eAAA;EACA,aAAA;EACA,mBAAA;A5E2sXhB;A4EzsXgB;EACI,gBAAA;EACA,YAAA;EACA,WAAA;EACA,oBAAA;EACA,kBAAA;EACA,yBAAA;A5E2sXpB;A4EzsXoB;EACI,YAAA;EACA,WAAA;EACA,UAAA;EACA,qBAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,wBAAA;EACA,eAAA;A5E2sXxB;A4ExsXoB;EACI,UAAA;A5E0sXxB;A4EvsXoB;EACI,YAAA;A5EysXxB;A4EpsXY;EACI,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;A5EssXhB;A4EnsXY;EACI,yBD5MP;EC6MO,SAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;EACA,4BAAA;EACA,iBAAA;A5EqsXhB;A4EjsXQ;EACI,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;A5EmsXZ;A4EjsXY;EAEI,qBDtNN;A3Ew5XV;A4E/rXY;EACI,SAAA;A5EisXhB;A4E9rXY;EACI,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,cDlPQ;ECmPR,gCDzMP;A3Ey4XT;A4E5rXQ;EACI,WAAA;EACA,yBAAA;EACA,mBAAA;EAEA,gBAAA;EACA,aAAA;EACA,iBAAA;EACA,eAAA;EACA,yBD/PM;A3E47XlB;A4E3rXY;EAEI,qBDnPN;A3E+6XV;A4ExrXQ;EACI,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;EACA,YAAA;EACA,eAAA;EACA,yBDjRM;A3E28XlB;A4ExrXY;EAEI,qBDrQN;A3E87XV;A4ErrXQ;EACI,WAAA;A5EurXZ;A4ErrXY;EACI,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;A5EurXhB;A4ErrXgB;EAEI,qBDvRV;A3E68XV;;A4E/qXA;EACI,eAAA;EACA,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,cD9SK;EC+SL,gCD3QK;A3E67XT;A4EhrXI;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;A5EkrXR;;A4E9qXA;EACI,cDrSK;ECsSL,gCDtRK;A3Eu8XT;;A6E1/XA;EACI,yBAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,cFUK;EETL,gBAAA;EACA,gBAAA;EACA,gCAAA;EACA,gBAAA;EACA,yBAAA;EACA,gCFwCK;EEvCL,uBAAA;A7E6/XJ;A6E3/XI;EACI,gBAAA;A7E6/XR;A6E1/XI;EACI,yBFlBQ;EEmBR,cFVU;A3EsgYlB;A6Ez/XI;EACI,yBFvBQ;EEwBR,cFfU;EEgBV,oBAAA;A7E2/XR;Acz8XI;E+D5EJ;IA8BQ,eAAA;E7E2/XN;AACF;;A6Ex/XA;EAEI,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,cFxBK;EEyBL,gBAAA;EACA,gBAAA;EACA,gCAAA;EACA,gBAAA;EACA,yBFlCc;EEmCd,gCFMK;EELL,uBAAA;A7E0/XJ;A6Ex/XI;EACI,gBAAA;A7E0/XR;A6Ev/XI;EACI,yBFpDQ;EEqDR,cF5CU;A3EqiYlB;A6Et/XI;EACI,yBFzDQ;EE0DR,cFjDU;EEkDV,oBAAA;A7Ew/XR;Acx+XI;E+D1CJ;IA8BQ,eAAA;E7Ew/XN;AACF;;A6Er/XA;EACI,yBAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,cF/Dc;EEgEd,gBAAA;EACA,gBAAA;EACA,gCAAA;EACA,gBAAA;EACA,yBF7EY;EE8EZ,gCF5BK;EE6BL,uBAAA;A7Ew/XJ;Ac5/XI;E+DRJ;IAeQ,eAAA;E7Ey/XN;AACF;A6Ev/XI;EACI,gBAAA;A7Ey/XR;;A6Er/XA;EACI,oCAAA;EACA,gCAAA;EACA,gCF3CK;EE4CL,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;A7Ew/XJ;A6Et/XI;EACI,gBAAA;A7Ew/XR;;A6Ep/XA;EAEI,qBFpFM;EEqFN,cFrFM;A3E2kYV;A6Ep/XI;EACI,eAAA;A7Es/XR;A6Ep/XQ;EACI,yBFrFH;EEsFG,qBFtFH;EEuFG,cF7GM;A3EmmYlB;A6El/XI;EACI,eAAA;A7Eo/XR;A6El/XQ;EACI,yBF9FA;EE+FA,qBF/FA;EEgGA,cFvHM;A3E2mYlB;A6Eh/XI;EACI,eAAA;A7Ek/XR;A6Eh/XQ;EACI,yBFvGH;EEwGG,qBFxGH;EEyGG,cFjIM;A3EmnYlB;;A6E7+XA;EACI,iBAAA;EACA,YAAA;EACA,kBAAA;A7Eg/XJ;;A6E7+XA;EACI,gBAAA;A7Eg/XJ;Ac3jYI;E+D0EJ;IAIQ,gBAAA;E7Ei/XN;AACF;;A6E7+XA;EACI,yBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;A7Eg/XJ;A6E9+XI;EACI,gBAAA;A7Eg/XR;A6E7+XI;EACI,qBFjJE;A3EgoYV;A6E5+XI;EACI,kBAAA;EACA,mBAAA;EACA,eAAA;A7E8+XR;A6E3+XI;EACI,kBAAA;EACA,mBAAA;EACA,eAAA;A7E6+XR;;A6Ev+XI;EAEI,UAAA;EACA,gBAAA;A7Ey+XR;;A6Ep+XI;EACI,0BAAA;EACA,mBAAA;EACA,eAAA;EACA,cFjMU;EEkMV,YAAA;EACA,eAAA;EACA,gBAAA;A7Eu+XR;;A6En+XA;EACI,6BAAA;A7Es+XJ;;A6En+XA;EACI,YAAA;A7Es+XJ;;A6El+XA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;A7Eq+XJ;A6En+XI;EACI,qBF1ME;A3E+qYV;;A6Ej+XA;;EAEI,oCAAA;EACA,gCAAA;EACA,cF3NK;A3E+rYT;A6El+XI;;EACI,oCAAA;EACA,gCAAA;A7Eq+XR;A6En+XI;;EACI,kBAAA;A7Es+XR;;A6El+XA;EACI,6BAAA;A7Eq+XJ;A6En+XI;EACI,wCAAA;EACA,oCAAA;A7Eq+XR;;A6Eh+XI;EACI,wCAAA;A7Em+XR;;A6E/9XA;EACI,mBAAA;A7Ek+XJ;;A8EtuYY;EACI,gBAAA;EACA,eAAA;EACA,gCAAA;EACA,gBAAA;EACA,kBAAA;A9EyuYhB;A8EtuYoB;EACI,cHHA;EGIA,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,cHFf;EGGe,0BAAA;A9EwuYxB;A8EpuYwB;EACI,cHZV;EGaU,qBHtBZ;EGuBY,yBHvBZ;A3E6vYhB;A8EhuYY;EACI,mBAAA;A9EkuYhB;A8E/tYY;EACI,UAAA;A9EiuYhB;A8E7tYgB;EACI,kBAAA;EACA,qBHzBX;A3EwvYT;;A+ErwYY;EACI,gCJ+CP;EI9CO,gBAAA;EACA,eAAA;EACA,cJCE;EIAF,yBJKP;EIJO,YAAA;A/EwwYhB;A+EjwYY;EACI,gCJkCP;EIjCO,gBAAA;EACA,eAAA;EACA,cJNP;EIOO,YAAA;A/EmwYhB;A+EjwYgB;EACI,qBAAA;EACA,cJxBJ;A3E2xYhB;;A+E3vYI;EACI,yBAAA;EACA,mBAAA;A/E8vYR;A+E1vYQ;EACI,2BAAA;A/E4vYZ;AcxtYI;EiErCI;IAIQ,YAAA;IACA,mBAAA;E/E6vYd;AACF;;A+ExvYA;EACI,mBJzCc;EI0Cd,cJtCK;A3EiyYT;;A+ExvYA;EACI,mBJ9Cc;A3EyyYlB;;A+EvvYI;EACI,eAAA;EACA,cJtDU;EIuDV,gBAAA;A/E0vYR;A+EvvYI;EACI,kBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,cJ9CE;EI+CF,0BAAA;A/EyvYR;A+EvvYQ;EACI,iBAAA;A/EyvYZ;A+ErvYI;EACI,eAAA;EACA,qBAAA;A/EuvYR;A+ErvYQ;EACI,qBAAA;EACA,iBAAA;EACA,cAAA;EACA,sBAAA;EACA,eAAA;A/EuvYZ;A+ElvYQ;EACI,0BAAA;EACA,mBAAA;EACA,eAAA;EACA,cJzFM;EI0FN,YAAA;EACA,eAAA;EACA,gBAAA;A/EovYZ;Ac5wYI;EiEiBI;IAUQ,YAAA;E/EqvYd;AACF;AcjxYI;EiEiBI;IAcQ,WAAA;E/EsvYd;AACF;A+EpvYY;EAEI,qBJtFN;A3E20YV;A+EjvYQ;EACI,WAAA;A/EmvYZ;A+E/uYI;EACI,WAAA;A/EivYR;A+E3uYwB;EACI,gBAAA;EACA,gBAAA;A/E6uY5B;A+E1uYwB;EACI,cJrIZ;A3Ei3YhB;A+E1uY4B;EACI,cJxIhB;EIyIgB,gBAAA;A/E4uYhC;A+EpuYwB;EACI,mBJlJZ;EImJY,qBJnJZ;A3Ey3YhB;A+E/tYgB;EACI,gCAAA;A/EiuYpB;A+E/tYoB;EACI,oCAAA;EACA,cJ/JR;A3Eg4YhB;A+E5tYoB;EACI,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cJjKN;A3E+3YlB;A+ExtYwB;EACI,mBJ/KZ;EIgLY,qBJhLZ;A3E04YhB;A+ErtYgB;EACI,gBAAA;EACA,qBAAA;A/EutYpB;A+EltYQ;EACI,YAAA;EACA,kBAAA;A/EotYZ;Acv0YI;EiEiHI;IAKQ,iBAAA;E/EqtYd;AACF;Ac50YI;EiEyHQ;IAEQ,cAAA;IACA,yBAAA;IACA,4BAAA;IACA,eAAA;E/EqtYlB;AACF;A+EltYY;;;;EAII,YAAA;EACA,eAAA;EACA,sBAAA;A/EotYhB;A+EjtYY;EACI,YAAA;EACA,gBAAA;A/EmtYhB;A+EjtYgB;EAGI,qBJ7NJ;A3E86YhB;A+E9sYgB;EACI,qBJjOJ;A3Ei7YhB;A+E7sYgB;EACI,eAAA;EACA,iBAAA;A/E+sYpB;A+E5sYgB;EACI,WAAA;A/E8sYpB;A+E1sYY;EACI,cJ/OA;A3E27YhB;A+EzsYY;EACI,cJnPA;A3E87YhB;A+ExsYY;EACI,cJvPA;A3Ei8YhB;A+EvsYY;EACI,cJ3PA;A3Eo8YhB;A+ErsYgB;EACI,cJxPI;EIyPJ,eAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;A/EusYpB;A+ErsYoB;EACI,mBJvQR;EIwQQ,qBJxQR;EIyQQ,cJhQN;A3Eu8YlB;;A+E9rYI;EACI,yBJ1QU;A3E28YlB;A+E9rYI;EACI,qBJxQC;EIyQD,mBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;A/EgsYR;A+E7rYI;EACI,UAAA;EACA,gBAAA;A/E+rYR;A+E7rYQ;EACI,eAAA;EACA,cJvRH;EIwRG,gCJnPH;EIoPG,gBAAA;A/E+rYZ;A+E5rYQ;EACI,eAAA;EACA,gCJzPH;A3Eu7YT;A+E1rYY;EACI,kBAAA;EACA,WAAA;EACA,eAAA;A/E4rYhB;A+EzrYY;EACI,mBJ7SE;A3Ew+YlB;A+EzrYgB;EACI,kBAAA;EACA,WAAA;EACA,cJ3TJ;EI4TI,eAAA;A/E2rYpB;A+ExrYgB;EACI,cJhUJ;A3E0/YhB;;A+EnrYA;EACI,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;A/EsrYJ;A+EprYI;EACI,cAAA;EACA,yCAAA;A/EsrYR;A+EnrYI;EACI,cAAA;EACA,yCAAA;EACA,yBAAA;A/EqrYR;A+ElrYI;EACI,cAAA;EACA,wCAAA;A/EorYR;A+EjrYI;EACI,cAAA;EACA,wCAAA;A/EmrYR;A+EhrYI;EACI,cAAA;EACA,0CAAA;A/EkrYR;A+E/qYI;EACI,cAAA;EACA,0CAAA;A/EirYR;;A+E7qYA;EACI,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,wCAAA;EACA,gBAAA;A/EgrYJ;;A+E7qYA;EACI,wCAAA;A/EgrYJ;;A+E7qYA;EACI,6BAAA;EACA,yBAAA;EACA,gBAAA;EACA,cJ1WK;EI2WL,kBAAA;EACA,QAAA;EACA,QAAA;EACA,2BAAA;A/EgrYJ;;Act+YI;EiEyTJ;IAEQ,eAAA;E/EgrYN;E+E9qYM;IACI,8BAAA;E/EgrYV;E+E7qYM;IACI,eAAA;E/E+qYV;AACF;Acl/YI;EiEuUI;IACI,8BAAA;IACA,WAAA;E/E8qYV;AACF;Acx/YI;EiE+UQ;IACI,WAAA;E/E4qYd;E+EvqYU;IACI,WAAA;E/EyqYd;E+EvqYc;IACI,WAAA;E/EyqYlB;E+ErqYU;IACI,6BAAA;IACA,YAAA;IACA,eAAA;IACA,WAAA;E/EuqYd;E+ErqYc;IACI,eAAA;E/EuqYlB;AACF;;A+E/pYQ;EACI,mBJ7aH;A3E+kZT;;A+E3pYI;EACI,uBAAA;A/E8pYR;;AgFhmZA;EACI,WAAA;EACA,kBAAA;EACA,YAAA;AhFmmZJ;AgFjmZI;EACI,WAAA;EACA,YAAA;AhFmmZR;AgFjmZQ;EACI,WAAA;AhFmmZZ;AgFjmZY;EACI,YAAA;EACA,cAAA;EACA,eAAA;EACA,yBAAA;AhFmmZhB;AcviZI;EkEhEQ;IAOQ,yBAAA;EhFomZlB;AACF;Ac5iZI;EkEhEQ;IAWQ,aAAA;EhFqmZlB;AACF;AgFlmZY;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mGAAA;EACA,qBAAA;EACA,kBAAA;EACA,qBAAA;AhFomZhB;AgFlmZgB;EACI,cLtCJ;A3E0oZhB;Ac/jZI;EkEjDQ;IAgBQ,eAAA;IACA,mBAAA;EhFomZlB;AACF;AcrkZI;EkEjDQ;IAqBQ,kBAAA;IACA,mBAAA;IACA,eAAA;EhFqmZlB;AACF;AgFlmZY;EACI,eAAA;EACA,qBAAA;EACA,aAAA;EACA,eAAA;EACA,0BAAA;EACA,uBAAA;AhFomZhB;AgFjmZoB;EACI,WAAA;AhFmmZxB;AgFjmZwB;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EAEA,uBAAA;AhFkmZ5B;AgFhmZ4B;EACI,qBAAA;EACA,kBAAA;AhFkmZhC;AcjmZI;EkEHwB;IAKQ,aAAA;EhFmmZlC;AACF;AgFhmZ4B;EAEI,WAAA;EACA,eAAA;EACA,gBAAA;AhFimZhC;AgF/lZgC;EACI,eAAA;EACA,gBAAA;AhFimZpC;Ac/mZI;EkEtBQ;IA4CQ,0BAAA;EhF6lZlB;AACF;AcpnZI;EkEtBQ;IAgDQ,0BAAA;EhF8lZlB;AACF;AgF5lZgB;EACI,UAAA;EACA,eAAA;EACA,kBAAA;AhF8lZpB;Ac9nZI;EkE6BY;IAMQ,eAAA;EhF+lZtB;AACF;AcnoZI;EkE6BY;IAUQ,UAAA;IACA,aAAA;EhFgmZtB;AACF;AgF9lZoB;EACI,aAAA;EACA,0CAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,cLnHf;EKoHe,aAAA;EACA,mBAAA;EACA,gCAAA;EACA,YAAA;EACA,aAAA;AhFgmZxB;Ac1pZI;EkE2CgB;IAkBQ,iBAAA;IACA,WAAA;IACA,YAAA;EhFimZ1B;AACF;AgF/lZwB;EAEI,qBL/IZ;EKgJY,+CAAA;EACA,yCAAA;AhFgmZ5B;AgF7lZwB;EACI,gBAAA;AhF+lZ5B;AczqZI;EkEyEoB;IAIQ,gBAAA;EhFgmZ9B;AACF;AgF5lZoB;EACI,mGAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gCAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;AhF8lZxB;AgFvlZoB;EACI,eAAA;EACA,cLhKf;EKiKe,iBAAA;EACA,gBAAA;EACA,kBAAA;AhFylZxB;AgFnlZgB;EACI,eAAA;EACA,YAAA;AhFqlZpB;AgFllZwB;EACI,YAAA;AhFolZ5B;AgF7kZQ;EACI,kBAAA;EACA,aAAA;EACA,eAAA;AhF+kZZ;AgF7kZY;EACI,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,4BAAA;EACA,cL/LP;EKgMO,eAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AhF+kZhB;AcvtZI;EkE8HQ;IAcQ,YAAA;EhF+kZlB;AACF;Ac5tZI;EkE8HQ;IAkBQ,YAAA;EhFglZlB;AACF;AgF9kZgB;EACI,qBLhNX;EKiNW,UAAA;EACA,eAAA;AhFglZpB;AgF9kZoB;EACI,qBLpOR;A3EozZhB;AgF5kZgB;EAEI,qBL1OJ;A3EuzZhB;AgFzkZY;EACI,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,eAAA;EACA,cAAA;AhF2kZhB;AgFxkZY;EACI,WAAA;AhF0kZhB;AcvvZI;EkE+KY;IAEQ,eAAA;IACA,gBAAA;EhF0kZtB;AACF;AgFtkZY;EACI,WAAA;AhFwkZhB;AchwZI;EkE0LY;IAEQ,eAAA;IACA,gBAAA;EhFwkZtB;AACF;AgFnkZQ;EACI,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,cLrQH;EKsQG,kBAAA;AhFqkZZ;Ac7wZI;EkEmMI;IAQQ,eAAA;EhFskZd;AACF;AclxZI;EkEmMI;IAYQ,eAAA;EhFukZd;AACF;AgFrkZY;EACI,qBAAA;EACA,kBAAA;EACA,sBAAA;EACA,cAAA;AhFukZhB;AgFnkZQ;EACI,gBAAA;EACA,eAAA;EACA,cL3RH;A3Eg2ZT;AgFnkZY;EACI,qBAAA;EACA,kBAAA;EACA,sBAAA;EACA,cAAA;AhFqkZhB;AgFjkZQ;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;AhFmkZZ;Ac9yZI;EkEuOI;IAOQ,eAAA;EhFokZd;AACF;AgFlkZY;EACI,YAAA;EACA,eAAA;AhFokZhB;AcvzZI;EkEqPY;IAEQ,4BAAA;EhFokZtB;AACF;Ac5zZI;EkEiPQ;IAWQ,yBAAA;EhFokZlB;AACF;AgFjkZY;EACI,iBAAA;AhFmkZhB;AgF/jZQ;EACI,WAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,SAAA;EACA,yBL7UM;A3E84ZlB;Ac50ZI;EkEqQI;IASQ,gBAAA;IACA,gBAAA;EhFkkZd;AACF;AgFhkZY;EACI,YAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;AhFkkZhB;AgFhkZgB;EACI,aAAA;EACA,uBAAA;EACA,eAAA;AhFkkZpB;Ac71ZI;EkEwRY;IAMQ,sBAAA;EhFmkZtB;AACF;AgFjkZoB;EACI,gBAAA;EACA,cLhWf;A3Em6ZT;Act2ZI;EkEiSgB;IAKQ,kBAAA;EhFokZ1B;AACF;AgFjkZoB;EACI,eAAA;EACA,qBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;AhFmkZxB;AgFjkZwB;EACI,eAAA;EACA,+BAAA;AhFmkZ5B;AgFjkZ4B;EACI,SAAA;AhFmkZhC;AgFhkZ4B;EACI,cLrYhB;A3Eu8ZhB;;AgFxjZA;EACI,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;AhF2jZJ;AgFzjZI;EACI,eAAA;EACA,cLzYC;EK0YD,mBAAA;AhF2jZR;Acx4ZI;EkE0UA;IAMQ,kBAAA;EhF4jZV;AACF;AgFzjZI;EACI,eAAA;EACA,qBAAA;EACA,gBAAA;AhF2jZR;AgFzjZQ;EACI,WAAA;EACA,mBAAA;AhF2jZZ;Act5ZI;EkEyVI;IAKQ,kBAAA;EhF4jZd;AACF;AgF1jZY;EACI,gBAAA;AhF4jZhB;AgFzjZY;EACI,cLnaP;EKoaO,eAAA;EACA,qBAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AhF2jZhB;AgFzjZgB;EACI,cL1bJ;A3Eq/ZhB;AgFzjZoB;EACI,0DAAA;AhF2jZxB;AgFvjZgB;EACI,WAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,0DAAA;EACA,4BAAA;EACA,kBAAA;EACA,QAAA;EACA,QAAA;AhFyjZpB;;AgFljZA;EACI,gBAAA;EACA,yBAAA;EACA,mBAAA;AhFqjZJ;AgFnjZI;EACI,UAAA;EACA,UAAA;EACA,aAAA;AhFqjZR;AgFljZI;EACI,UAAA;EACA,aAAA;AhFojZR;AgFhjZQ;EACI,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,aAAA;EACA,eAAA;AhFkjZZ;AgFhjZY;EACI,aAAA;EACA,uBAAA;EACA,kBAAA;AhFkjZhB;AgFhjZgB;EACI,qBAAA;EACA,WAAA;EACA,qBAAA;EACA,iBAAA;EACA,6BAAA;EACA,kBAAA;EACA,eAAA;AhFkjZpB;AgF/iZwB;EACI,cLzfZ;A3E0iahB;AgF7iZoB;EACI,qBL9fR;EK+fQ,+CAAA;EACA,yCAAA;AhF+iZxB;AgF5iZoB;EACI,gBAAA;EACA,kBAAA;AhF8iZxB;AgF3iZoB;EACI,WAAA;EACA,cAAA;EACA,eAAA;EACA,cL/ff;EKggBe,gBAAA;EACA,gCAAA;AhF6iZxB;;AgFriZA;EACI,eAAA;EACA,cLxgBK;EKygBL,gBAAA;EACA,mBAAA;EACA,kBAAA;AhFwiZJ;Acx/ZI;EkE2cJ;IAQQ,eAAA;IACA,mBAAA;EhFyiZN;AACF;AgFviZI;EACI,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,eAAA;AhFyiZR;AgFviZQ;EACI,WAAA;AhFyiZZ;;AiFnlaA;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,yBNMc;EMLd,2CAAA;AjFslaJ;Ac/gaI;EmE5EJ;IAQQ,YAAA;IACA,eAAA;IACA,WAAA;EjFulaN;EiFrlaM;IACI,eAAA;EjFulaV;AACF;;AiFnlaA;EACI,cNXc;EMYd,eAAA;EACA,gBAAA;AjFslaJ;;AiFllaI;EACI,gBAAA;EACA,mBAAA;EACA,yBNZC;A3EimaT;;AiFjlaA;EACI,kCAAA;EACA,2BAAA;EACA,uBAAA;AjFolaJ;;AiFjlaA;EACI,YAAA;EACA,4BAAA;EACA,gBAAA;AjFolaJ;;AiFjlaA;EACI,gBAAA;EACA,0BAAA;EACA,UAAA;AjFolaJ;AiFllaI;EACI,YAAA;EACA,eAAA;AjFolaR;;AiFhlaA;EACI,YAAA;EACA,4BAAA;EACA,gBAAA;AjFmlaJ;;AiFhlaA;EACI,iBAAA;AjFmlaJ;AiFjlaI;EACI,cNlDC;EMmDD,eAAA;EACA,gBAAA;AjFmlaR;AiFhlaI;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;AjFklaR;AiFhlaQ;EACI,gBAAA;EACA,eAAA;EACA,cN1DH;EM2DG,iBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,wBAAA;AjFklaZ;;AiFzkaA;EACI,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;AjF4kaJ;AiF1kaI;EACI,yBN5FU;EM6FV,yBAAA;EACA,qBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;AjF4kaR;AiF1kaQ;EACI,YAAA;EACA,aAAA;EACA,UAAA;EACA,gCN9DH;EM+DG,eAAA;AjF4kaZ;AiFzkaQ;EACI,yBAAA;EACA,YAAA;EACA,eAAA;AjF2kaZ;AiFvkaI;EACI,yBNnHU;EMoHV,kBAAA;EACA,8CAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;AjFykaR;AiFvkaQ;EACI,eAAA;EACA,gBAAA;EACA,eAAA;AjFykaZ;AiFtkaQ;;EAEI,mBAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;AjFwkaZ;AiFtkaY;;EACI,mBN5IO;A3EqtavB;AiFrkaQ;EACI,uBAAA;EACA,SAAA;EACA,cNtJY;EMuJZ,gCN7GH;EM8GG,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;AjFukaZ;;AiFlkaA;EACI,eAAA;EACA,aAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;AjFqkaJ;;AiFlkaA;EACI,aAAA;AjFqkaJ;;AiFlkaA;EAEI,0BAAA;EACA,YAAA;AjFokaJ;;AkF5vaA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AlF+vaJ;;AkF5vaA;EACI,oCAAA;EACA,8BAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kCAAA;EACA,cAAA;AlF+vaJ;;AkF5vaA;EACI;IACI,uBAAA;ElF+vaN;EkF5vaE;IACI,yBAAA;ElF8vaN;AACF;AkF3vaA;EACI,eAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;AlF6vaJ;AkF3vaI;EACI,mBPzBU;EO0BV,cP5BU;EO6BV,YAAA;EACA,kBAAA;EACA,+BAAA;EACA,gBAAA;EACA,yCAAA;EACA,eAAA;EACA,gBAAA;AlF6vaR;AkF1vaI;EACI,WAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,yBPnDQ;EOoDR,cP3CU;EO4CV,iCAAA;EACA,YAAA;EACA,aAAA;EACA,oBAAA;EACA,uCAAA;EACA,wBAAA;AlF4vaR;AkF1vaQ;EACI,yBAAA;EACA,qBAAA;AlF4vaZ;AkFxvaI;EAGI,yBAAA;AlF0vaR;AkFvvaI;EACI,YAAA;EACA,kBAAA;AlFyvaR;;AkFrvaA;EACI,kBAAA;EACA,UAAA;AlFwvaJ;;AkFrvaA;EACI,mBAAA;AlFwvaJ;;AkFrvaA;EACI,UAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,QAAA;EACA,cAAA;EACA,mBAAA;EACA,WAAA;EACA,OAAA;EACA,cAAA;EACA,SAAA;EACA,yBAAA;AlFwvaJ;AchxaI;EoEYJ;IAyBQ,aAAA;IACA,OAAA;IACA,QAAA;IACA,cAAA;IACA,UAAA;ElF+uaN;AACF;AkF7uaI;EACI,YAAA;EACA,mBPhHU;EOkHV,aAAA;EACA,cPnHU;EOoHV,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,gCAAA;EACA,mBAAA;AlF8uaR;AcpyaI;EoE4CA;IAaQ,kBAAA;ElF+uaV;AACF;AkF7uaQ;EACI,aAAA;EACA,mBAAA;AlF+uaZ;AkF7uaY;EAEI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AlF8uahB;AcvzaI;EoEgEQ;IAYQ,kBAAA;ElF+ualB;AACF;AkF5uaY;EACI,YAAA;EACA,eAAA;EACA,gBAAA;AlF8uahB;AkF3uaY;EACI,aAAA;EACA,SAAA;EACA,sBAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;AlF6uahB;AkF3uagB;EACI,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AlF6uapB;AkF1uagB;EACI,eAAA;EACA,cPrKX;A3Ei5aT;AkFvuaQ;EACI,aAAA;EACA,mBAAA;EACA,UAAA;EACA,uBAAA;EACA,YAAA;EACA,cP3KH;A3Eo5aT;AkFvuaY;EACI,gBAAA;AlFyuahB;AkFpuaI;EACI,aAAA;EACA,2BAAA;EAGA,cAAA;EACA,aAAA;EACA,sBAAA;AlFouaR;AkFluaQ;EACI,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,OAAA;EACA,QAAA;EACA,eAAA;AlFouaZ;AkFluaY;EACI,qBAAA;EACA,uBAAA;AlFouahB;AkFjuaoB;EACI,eAAA;EACA,8BAAA;EACA,cAAA;EACA,6BAAA;AlFmuaxB;AkFjuawB;EACI,yBAAA;AlFmua5B;AkF7taY;EACI,yBP1OA;EO2OA,cPlOE;EOmOF,sBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;AlF+tahB;AkF3taQ;EACI,gBAAA;EAGA,OAAA;EACA,QAAA;AlF2taZ;AkFxtaY;EACI,qBAAA;EACA,uBAAA;AlF0tahB;AkFvtaoB;EACI,eAAA;EACA,8BAAA;EACA,cAAA;EACA,6BAAA;AlFytaxB;AkFvtawB;EACI,yBAAA;AlFyta5B;AkFntaY;EACI,yBP9QA;EO+QA,cPtQE;EOuQF,sBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;AlFqtahB;AkFjtaQ;EACI,aAAA;EACA,eAAA;EACA,kBAAA;AlFmtaZ;AkFjtaY;EACI,gBAAA;EACA,8BAAA;AlFmtahB;AkFjtagB;EACI,cPxRF;A3E2+alB;AkF/saY;;EAEI,cAAA;AlFitahB;AkF9saY;EACI,cP1SE;EO2SF,gBAAA;EACA,2BAAA;EACA,mBAAA;EACA,YAAA;EACA,+CAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,mBP3SE;A3E2/alB;AkF7saY;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,qBAAA;AlF+sahB;AkF7sagB;EACI,YAAA;EACA,WAAA;EACA,mBAAA;AlF+sapB;AkF3saY;EACI,eAAA;EACA,mBAAA;EAEA,kBAAA;EACA,4BAAA;EACA,mBAAA;EAEA,+BAAA;EACA,wCAAA;EAEA,cPxUE;A3EkhblB;AkFvsagB;EACI,gBAAA;AlFysapB;AkFrsaY;EACI,iBAAA;AlFusahB;AkFpsaY;EACI,kBAAA;EACA,iBAAA;EACA,kBAAA;EAEA,2BAAA;EACA,qBAAA;EACA,mDAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;AlFssahB;AkFnsaY;EACI,sBAAA;EACA,8BAAA;AlFqsahB;AkFlsaY;EACI,sBAAA;EACA,8BAAA;AlFosahB;AkFjsaY;EACI,sBAAA;EACA,8BAAA;AlFmsahB;AkF9raY;EACI,kBAAA;AlFgsahB;AkF3raY;EACI,eAAA;EACA,mBPlYA;EOmYA,cP1XE;EO4XF,kBAAA;EACA,4BAAA;EACA,mBAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,wCAAA;EACA,sBAAA;AlF4rahB;AkFvraI;EACI,2BAAA;AlFyraR;AkFvraQ;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;AlFyraZ;AkFvraY;EACI,kBAAA;EACA,aAAA;EACA,8DAAA;EAEA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AlFwrahB;AkFrraY;EACI,UAAA;AlFurahB;AkFpraY;EACI,WAAA;AlFsrahB;AkFnraY;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AlFqrahB;AkFnragB;EACI,yBPrbJ;EOsbI,cP7aF;EO8aE,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;EAEA,eAAA;EACA,eAAA;AlForapB;AkF9qaQ;EACI,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AlFgraZ;AkF9qaY;EACI,cP1cA;EO2cA,eAAA;AlFgrahB;AkF7qaY;EACI,mBPtcE;EOucF,mBAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,4BAAA;EACA,eAAA;EACA,cPncP;A3EknbT;AkF5qaY;EACI,aAAA;AlF8qahB;AkF3qaY;EACI,gBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EAGA,SAAA;EACA,cAAA;AlF2qahB;AkFzqagB;EACI,eAAA;EACA,wBAAA;AlF2qapB;AkFxqagB;EACI,UAAA;AlF0qapB;AkFvqagB;EACI,YAAA;AlFyqapB;AkFrqaoB;EACI,WAAA;AlFuqaxB;AkFlqaY;EACI,kBAAA;EACA,YAAA;EACA,eAAA;AlFoqahB;AkFlqagB;EACI,UAAA;AlFoqapB;AkFjqagB;EACI,YAAA;AlFmqapB;AkF7paY;EACI,4BAAA;AlF+pahB;AkF5paY;EACI,UAAA;AlF8pahB;AkF3paY;EACI,WAAA;AlF6pahB;;AkFvpaA;EACI,gBAAA;EACA,6EAAA;EACA,sCAAA;EACA,2CAAA;EAEA,kBAAA;AlFypaJ;AkFvpaI;EACI,WAAA;EACA,0EAAA;EACA,qBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,WAAA;AlFypaR;;AkFrpaA;EACI,WAAA;EACA,gBAAA;AlFwpaJ;AkFtpaI;EACI,2BAAA;AlFwpaR;;AkFppaA;EACI;IACI,WAAA;ElFupaN;EkFppaE;IACI,WAAA;ElFspaN;EkFnpaE;IACI,WAAA;ElFqpaN;AACF;AkFjpaI;EACI,2BAAA;EACA,YAAA;EACA,4BAAA;EACA,mBPjkBe;A3EotbvB;AcppbI;EoE6fA;IAOQ,YAAA;ElFopaV;AACF;AczpbI;EoE6fA;IAWQ,WAAA;ElFqpaV;AACF;Ac9pbI;EoE6fA;IAeQ,aAAA;IACA,YAAA;ElFspaV;AACF;AkFnpaY;EACI,eAAA;EACA,cPvlBE;EOwlBF,gBAAA;EACA,mBAAA;AlFqpahB;;AkF9oaI;EACI,WAAA;EACA,eAAA;EACA,UAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,oCAAA;EACA,0BAAA;AlFipaR;;AkF7oaA;EACI,2BAAA;EACA,gBAAA;AlFgpaJ;;AkF5oaI;EACI,2BAAA;EACA,gBAAA;AlF+oaR;;AkF3oaA;EACI,yBPxnBc;A3EswblB;;AkFxoaI;EACI,WAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,uBAAA;AlF2oaR;AkFzoaQ;EAEI,yBPrpBI;A3E+xbhB;AkFtoaI;EACI,aAAA;EACA,mBAAA;EACA,sBAAA;AlFwoaR;AkFroaI;EACI,UAAA;EACA,sBAAA;EACA,sBAAA;EACA,kBAAA;AlFuoaR;AkFpoaI;EACI,cAAA;EACA,gCAAA;EACA,uBAAA;EACA,qBAAA;AlFsoaR;AkFnoaI;EACI,SAAA;AlFqoaR;AkFnoaQ;EACI,eAAA;EACA,cP3qBM;EO4qBN,gBAAA;EACA,gBAAA;AlFqoaZ;AkFjoaI;EACI,gCAAA;EACA,4BAAA;AlFmoaR;AkFhoaI;EACI,eAAA;EACA,cAAA;EACA,gCP9oBC;A3EgxbT;AkF/naI;EACI,kBAAA;AlFioaR;AkF/naQ;EACI,eAAA;EACA,cAAA;EACA,gCPvpBH;EOwpBG,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,qBAAA;AlFioaZ;AcnwbI;EoE2nBI;IAUQ,eAAA;IACA,iBAAA;IACA,mBAAA;IACA,mBAAA;ElFkoad;AACF;AkF7naY;EACI,yBAAA;AlF+nahB;AkF3naQ;EACI,WAAA;EACA,kBAAA;EACA,0DAAA;EAEA,4BAAA;EACA,UAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;AlF4naZ;AkFznaQ;EACI,WAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;AlF2naZ;AkFvnaY;EACI,UAAA;EACA,mBAAA;AlFynahB;;AkFhnaI;EACI,WAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,uBAAA;AlFmnaR;AkFjnaQ;EAEI,yBP/wBI;A3Ei4bhB;AkF9maI;EACI,aAAA;EACA,mBAAA;EACA,sBAAA;AlFgnaR;AkF7maI;EACI,UAAA;EACA,sBAAA;EACA,sBAAA;EACA,kBAAA;AlF+maR;AkF5maI;EACI,cAAA;EACA,gCAAA;EACA,uBAAA;EACA,qBAAA;AlF8maR;AkF3maI;EACI,SAAA;AlF6maR;AkF3maQ;EACI,eAAA;EACA,cPryBM;EOsyBN,gBAAA;EACA,gBAAA;AlF6maZ;AkF1maQ;EACI,eAAA;EACA,cPryBH;EOuyBG,gBAAA;EACA,gBAAA;AlF2maZ;AkFxmaQ;EACI,eAAA;AlF0maZ;AkFtmaI;EACI,gCAAA;EACA,4BAAA;AlFwmaR;AkFrmaI;EACI,eAAA;EACA,cAAA;EACA,gCPpxBC;A3E23bT;AkFpmaI;EACI,kBAAA;AlFsmaR;AkFpmaQ;EACI,eAAA;EACA,cAAA;EACA,gCP7xBH;EO8xBG,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,qBAAA;AlFsmaZ;AkF1laY;EACI,yBAAA;AlF4lahB;AkFxlaQ;EACI,WAAA;EACA,kBAAA;EACA,0DAAA;EACA,4BAAA;EACA,UAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;AlF0laZ;AkFvlaQ;EACI,WAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;AlFylaZ;AkFrlaY;EACI,UAAA;EACA,mBAAA;AlFulahB;;AkFjlaA;EACI,yBAAA;EACA,mBAAA;AlFolaJ;AkFllaI;EACI,WAAA;EACA,gBAAA;AlFolaR;Acl5bI;EoEwzBJ;IAUQ,yBAAA;ElFolaN;EkFhlac;IACI,WAAA;ElFklalB;AACF;Ac15bI;EoEwzBJ;IAsBQ,WAAA;IACA,gBAAA;IACA,mBAAA;ElFglaN;AACF;AkF9kaI;EACI,2BAAA;EACA,gBAAA;AlFglaR;Acr6bI;EoEm1BA;IAKQ,YAAA;ElFilaV;AACF;AkF/kaQ;EACI,iBAAA;AlFilaZ;Ac76bI;EoE21BI;IAIQ,WAAA;ElFklad;AACF;Acl7bI;EoE21BI;IAQQ,iBAAA;ElFmlad;AACF;AkFjlaY;EACI,eAAA;EACA,qBAAA;EACA,mBAAA;EACA,WAAA;AlFmlahB;AkFjlagB;EACI,cPx7BJ;EOy7BI,0BAAA;AlFmlapB;AkF/kaY;EACI,gBAAA;AlFilahB;AkF/kagB;EACI,YAAA;EACA,WAAA;EACA,0BAAA;EACA,4BAAA;AlFilapB;Ac18bI;EoEq3BY;IAOQ,YAAA;ElFklatB;AACF;Ac/8bI;EoEq3BY;IAWQ,YAAA;ElFmlatB;AACF;AkF7kaI;EACI,YAAA;EACA,eAAA;AlF+kaR;Acx9bI;EoEu4BA;IAKQ,WAAA;ElFglaV;AACF;Ac79bI;EoE+4BI;IAEQ,eAAA;ElFglad;AACF;AkF9kaY;EACI,UAAA;AlFglahB;Acr+bI;EoEo5BQ;IAIQ,WAAA;IACA,mBAAA;ElFilalB;AACF;AkF/kagB;EACI,WAAA;AlFilapB;AkF9kagB;EACI,WAAA;AlFglapB;AkF3kaQ;EACI,YAAA;EACA,eAAA;AlF6kaZ;Acr/bI;EoEs6BI;IAKQ,WAAA;ElF8kad;AACF;AkF1kaI;EACI,WAAA;EACA,4BAAA;AlF4kaR;AkFzkaI;EACI,WAAA;EACA,yBAAA;EACA,6BAAA;AlF2kaR;AkFzkaQ;EACI,yBP3/BW;EO4/BX,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,qBAAA;AlF2kaZ;AkFzkaY;EACI,aAAA;AlF2kahB;AkFxkaY;EACI,qBAAA;EACA,kBAAA;EACA,WAAA;AlF0kahB;AkFxkagB;EACI,eAAA;EACA,cPzgCX;EO0gCW,gCPt+BX;EOu+BW,gBAAA;AlF0kapB;AkFxkaoB;EACI,gBAAA;EACA,gBAAA;AlF0kaxB;AkFtkagB;EACI,kBAAA;EACA,QAAA;EACA,cPthCX;EOuhCW,eAAA;EACA,cAAA;EACA,SAAA;EACA,iBAAA;AlFwkapB;AkFtkaoB;EACI,YAAA;AlFwkaxB;AkFtkawB;EACI,cP7gCnB;A3EqlcT;AkFjkaQ;EACI,mBAAA;AlFmkaZ;AkFjkaY;EACI,gBAAA;AlFmkahB;AkF/jaQ;EACI,SAAA;EACA,UAAA;AlFikaZ;AkF/jaY;EACI,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;AlFikahB;AkF5jaI;EACI,mBAAA;AlF8jaR;AkF5jaQ;EACI,yBAAA;EACA,mBAAA;EACA,aAAA;AlF8jaZ;AkF1jaI;EACI,aAAA;EACA,8BAAA;EACA,WAAA;EACA,yBP/kCU;EOglCV,iBAAA;AlF4jaR;AkF1jaQ;EACI,aAAA;EACA,8BAAA;AlF4jaZ;Ac9kcI;EoEghCI;IAKQ,uBAAA;ElF6jad;AACF;;AkFxjaA;EACI,yBAAA;EACA,mBAAA;AlF2jaJ;AkFzjaI;EACI,WAAA;EACA,gBAAA;AlF2jaR;Ac5lcI;EoE2hCJ;IAUQ,yBAAA;ElF2jaN;EkFvjac;IACI,WAAA;ElFyjalB;AACF;AcpmcI;EoE2hCJ;IAsBQ,WAAA;IACA,gBAAA;IACA,mBAAA;ElFujaN;AACF;AkFrjaI;EACI,2BAAA;EACA,gBAAA;AlFujaR;Ac/mcI;EoEsjCA;IAKQ,YAAA;ElFwjaV;AACF;AkFtjaQ;EACI,iBAAA;AlFwjaZ;AcvncI;EoE8jCI;IAIQ,WAAA;ElFyjad;AACF;Ac5ncI;EoE8jCI;IAQQ,iBAAA;ElF0jad;AACF;AkFxjaY;EACI,eAAA;EACA,qBAAA;EACA,mBAAA;EACA,WAAA;AlF0jahB;AkFxjagB;EACI,cP3pCJ;EO4pCI,0BAAA;AlF0japB;AkFtjaY;EACI,gBAAA;AlFwjahB;AkFtjagB;EACI,YAAA;EACA,WAAA;EACA,0BAAA;EACA,4BAAA;AlFwjapB;AcppcI;EoEwlCY;IAOQ,YAAA;ElFyjatB;AACF;AczpcI;EoEwlCY;IAWQ,YAAA;ElF0jatB;AACF;AkFpjaI;EAEI,eAAA;AlFqjaR;AcjqcI;EoE0mCA;IAKQ,WAAA;ElFsjaV;AACF;ActqcI;EoEknCI;IAEQ,eAAA;ElFsjad;AACF;AkFpjaY;EACI,UAAA;AlFsjahB;Ac9qcI;EoEunCQ;IAIQ,WAAA;IACA,mBAAA;ElFujalB;AACF;AkFrjagB;EACI,WAAA;AlFujapB;AkFpjagB;EACI,WAAA;AlFsjapB;AkFjjaQ;EACI,YAAA;EACA,eAAA;AlFmjaZ;Ac9rcI;EoEyoCI;IAKQ,WAAA;ElFojad;AACF;AkFhjaI;EACI,WAAA;EACA,4BAAA;AlFkjaR;AkF/iaI;EACI,WAAA;EACA,yBAAA;EACA,6BAAA;AlFijaR;AkF/iaQ;EACI,yBP9tCW;EO+tCX,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,qBAAA;AlFijaZ;AkF/iaY;EACI,aAAA;AlFijahB;AkF9iaY;EACI,qBAAA;EACA,kBAAA;EACA,WAAA;AlFgjahB;AkF9iagB;EACI,eAAA;EACA,cP5uCX;EO6uCW,gCPzsCX;EO0sCW,gBAAA;AlFgjapB;AkF9iaoB;EACI,gBAAA;EACA,gBAAA;AlFgjaxB;AkF5iagB;EACI,kBAAA;EACA,QAAA;EACA,cPzvCX;EO0vCW,eAAA;EACA,cAAA;EACA,SAAA;EACA,iBAAA;AlF8iapB;AkF5iaoB;EACI,YAAA;AlF8iaxB;AkF5iawB;EACI,cPhvCnB;A3E8xcT;AkFviaQ;EACI,mBAAA;AlFyiaZ;AkFviaY;EACI,gBAAA;AlFyiahB;AkFriaQ;EACI,SAAA;EACA,UAAA;AlFuiaZ;AkFriaY;EACI,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;AlFuiahB;AkFliaI;EACI,mBAAA;AlFoiaR;AkFliaQ;EACI,yBAAA;EACA,mBAAA;EACA,aAAA;AlFoiaZ;AkFhiaI;EACI,aAAA;EACA,8BAAA;EACA,WAAA;EACA,yBPlzCU;EOmzCV,iBAAA;AlFkiaR;AkFhiaQ;EACI,aAAA;EACA,8BAAA;AlFkiaZ;AcvxcI;EoEmvCI;IAKQ,uBAAA;ElFmiad;AACF;;AkF9haA;EACI,aAAA;EACA,eAAA;EACA,8BAAA;AlFiiaJ;AkF9haQ;EACI,aAAA;AlFgiaZ;;AkF1haI;EACI,WAAA;AlF6haR;AkF1haI;EACI,WAAA;AlF4haR;;AkFthaQ;EACI,qBAAA;EACA,WAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;AlFyhaZ;AkFvhaY;EACI,iBAAA;AlFyhahB;;AkFlhaA;EACI,aAAA;EACA,eAAA;EACA,eAAA;AlFqhaJ;AkFnhaI;EACI,UAAA;EACA,aAAA;AlFqhaR;AkFnhaQ;EACI,aAAA;EACA,sBAAA;EACA,uCAAA;EACA,YAAA;EACA,mBAAA;AlFqhaZ;AkFjhaI;EACI,UAAA;EACA,aAAA;AlFmhaR;AkFjhaQ;EACI,aAAA;EACA,sBAAA;EACA,uCAAA;EACA,YAAA;EACA,mBAAA;AlFmhaZ;;AkF9gaA;EACI,aAAA;AlFihaJ;;AkF9gaA;EACI,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,8BAAA;EACA,WAAA;EACA,qBAAA;AlFihaJ;;AkF9gaA;EACI,mBAAA;EACA,qBAAA;AlFihaJ;;AkF9gaA;EACI,aAAA;EACA,eAAA;EACA,iBAAA;AlFihaJ;;AkF9gaA;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,8BAAA;EACA,mBAAA;AlFihaJ;AkF/gaI;EACI,gBAAA;AlFihaR;;AkF5gaA;;EAEI,wBAAA;AlF+gaJ;;AkF5gaA;EACI,4BAAA;AlF+gaJ;;AkF5gaA;EACI,+BAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,wBAAA;EACA,6BAAA;EACA,uBAAA;EACA,sBAAA;EACA,iCAAA;AlF+gaJ;;AkF3gaA,2CAAA;AACA;EACI,sBAAA;EACA,gBAAA;EACA,aAAA;EACA,oDAAA;EACA,SAAA;EACA,iBAAA;EACA,WAAA;AlF8gaJ;;AkF3gaA;EACI,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,8CAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,2EAAA;AlF8gaJ;;AkF3gaA;EACI,2BAAA;EACA,8CAAA;EACA,qBAAA;AlF8gaJ;;AkF3gaA;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;AlF8gaJ;;AkF3gaA;EACI,WAAA;EACA,YAAA;AlF8gaJ;;AkF3gaA;EACI,mBAAA;AlF8gaJ;;AkF3gaA;EACI,mBAAA;AlF8gaJ;;AkF3gaA;EACI,mBAAA;AlF8gaJ;;AkF3gaA;EACI,mBAAA;AlF8gaJ;;AkF3gaA;EACI,gBAAA;AlF8gaJ;;AkF3gaA;EACI,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,kBAAA;AlF8gaJ;;AkF3gaA;EACI,eAAA;EACA,cAAA;AlF8gaJ;;AkF3gaA;EACI,kBAAA;EACA,eAAA;AlF8gaJ;AkF5gaI;EACI,cAAA;EACA,kBAAA;AlF8gaR;AkF3gaI;EACI,eAAA;EACA,cAAA;AlF6gaR;;AmFtjdA;;;;EAII,6BAAA;EACA,gCR8CK;A3E2gdT;;AmFrjdA;EACI,WAAA;AnFwjdJ;;AmFrjdA;;;;;;;;EAQI,gCR8BK;A3E0hdT;;AmFrjdA;EACI,eAAA;EACA,oCAAA;EACA,WAAA;EACA,YAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AnFwjdJ;;AmFrjdA;EACI,kBAAA;EACA,uBAAA;EACA,oCAAA;EACA,6BAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;AnFwjdJ;;AmFpjdA;EACI,0DAAA;EACA,sBAAA;EACA,4BAAA;EACA,YAAA;EACA,aAAA;AnFujdJ;;AmFnjdA;EACI,UAAA;EACA,WAAA;EACA,6BAAA;AnFsjdJ;;AmFnjdA;EACI,6BAAA;AnFsjdJ;;AmFnjdA;EACI,mBAAA;EACA,kBAAA;AnFsjdJ;;AmFnjdA;EACI,kBAAA;EACA,WAAA;AnFsjdJ;;AmFnjdA;EACI,kBAAA;EACA,yBRvEK;EQwEL,cR7Ec;EQ8Ed,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,SAAA;EACA,2BAAA;EACA,UAAA;EACA,mBAAA;EACA,eAAA;EACA,gCRhDK;A3EsmdT;;AmFnjdA;EACI,mBAAA;EACA,UAAA;AnFsjdJ;;AmFnjdA;EACI,kBAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AnFsjdJ;;AmFnjdA;EACI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,qBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,sBAAA;AnFsjdJ;;AmFnjdA;EACI,eAAA;AnFsjdJ;;AmFnjdA;EACI,eAAA;AnFsjdJ;;AmFnjdA;EACI,oCAAA;AnFsjdJ;;AmFnjdA;EACI,wBAAA;AnFsjdJ;Ac9ndI;EqEuEJ;IAIQ,wBAAA;EnFujdN;AACF;;AmFpjdA;EACI,aAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AnFujdJ;AmFrjdI;EACI,eAAA;AnFujdR;Ac9odI;EqEsFA;IAIQ,eAAA;EnFwjdV;AACF;AmFrjdI;;EAEI,kBAAA;AnFujdR;;AmFnjdA;EACI,8BAAA;EACA,yBAAA;EACA,0BAAA;EACA,4BAAA;EACA,2BAAA;EACA,2CAAA;EACA,2BAAA;EACA,8BAAA;AnFsjdJ;AmFpjdI;EACI,cR7KC;EQ8KD,UAAA;AnFsjdR;;AmFljdA;EACI,cRvLc;EQwLd,iBAAA;EACA,eAAA;AnFqjdJ;;AmFljdA;EACI,iBAAA;EACA,iBAAA;EACA,YAAA;AnFqjdJ;;AmF/idY;EACI,cR/MA;EQgNA,wCAAA;EACA,gBAAA;AnFkjdhB;AmF7idgB;;EAEI,yBRxNJ;EQyNI,cRhNF;EQiNE,gBAAA;AnF+idpB;;AmFxidA;;EAEI,cRnOY;A3E8wdhB;;AmFxidA;EACI,WAAA;EACA,cAAA;EACA,eAAA;EACA,cR7NK;EQ8NL,gBAAA;EACA,gCAAA;AnF2idJ;;AmFxidA;EACI,0BAAA;AnF2idJ;;AmFxidA;EACI,aAAA;EACA,gBAAA;AnF2idJ;;AmFxidA;EACI,WAAA;EACA,eAAA;EACA,YAAA;AnF2idJ;;AmFxidA;EACI,cAAA;EACA,eAAA;EACA,YAAA;AnF2idJ;;AmFxidA;EACI,eAAA;EACA,WAAA;EACA,4DAAA;EACA,6BAAA;EACA,oCAAA;EACA,YAAA;EACA,8BAAA;EACA,kCAAA;AnF2idJ;;AmFxidA;EACI,eAAA;EACA,WAAA;EACA,4DAAA;EACA,6BAAA;EACA,oCAAA;EACA,YAAA;EACA,8BAAA;EACA,kCAAA;AnF2idJ;;AmFxidA;EACI,eAAA;EACA,WAAA;EACA,0DAAA;EACA,6BAAA;EACA,oCAAA;EACA,YAAA;EACA,8BAAA;EACA,kCAAA;AnF2idJ;;AmFxidA;EACI,8BAAA;AnF2idJ;;AmFxidA;EACI,YAAA;EACA,YAAA;EACA,YAAA;AnF2idJ;;AmFxidA;EACI,2BAAA;AnF2idJ;;AmFxidA;EACI,eAAA;AnF2idJ;AmFzidI;EACI,oBAAA;EACA,yCAAA;EACA,cRzTQ;A3Eo2dhB;;AmFvidA;EACI,yCAAA;EACA,cR/TY;A3Ey2dhB;;AmFvidA;EACI,UAAA;EACA,yBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AnF0idJ;AmFxidI;EACI,eAAA;EACA,aAAA;EACA,mBAAA;AnF0idR;AmFxidQ;EACI,gBAAA;EACA,YAAA;EACA,WAAA;EACA,oBAAA;EACA,kBAAA;EACA,yBAAA;AnF0idZ;AmFxidY;EACI,YAAA;EACA,WAAA;EACA,UAAA;EACA,qBAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,wBAAA;EACA,eAAA;AnF0idhB;AmFvidY;EACI,UAAA;AnFyidhB;AmFtidY;EACI,YAAA;AnFwidhB;AmFnidI;EACI,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AnFqidR;AmFlidI;EACI,yBR1WC;EQ2WD,SAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;EACA,4BAAA;EACA,iBAAA;AnFoidR;;AmF/hdI;EACI,oCAAA;AnFkidR;;AmF9hdA;EACI,yBAAA;EACA,0BAAA;AnFiidJ;;AmF9hdA;EACI,WAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,yBRtZY;EQuZZ,sBAAA;EACA,YAAA;EAIA,eAAA;AnF8hdJ;;AmF3hdA;EACI,yBRhaY;EQiaZ,sBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;EACA,wBAAA;EACA,mBAAA;EACA,uBAAA;EACA,qBAAA;EACA,eAAA;AnF8hdJ;;AmFxhdQ;EACI,aAAA;AnF2hdZ;AmFxhdgB;EACI,WAAA;EACA,YAAA;AnF0hdpB;AmFthdY;EACI,kBAAA;AnFwhdhB;AmFphdQ;EACI,oCAAA;EACA,qBAAA;EACA,uBAAA;EACA,cAAA;AnFshdZ;;AoF19dA;EACI,WAAA;EACA,kDAAA;EACA,mBAAA;EACA,mBAAA;ApF69dJ;AoF39dI;EACI,aAAA;EACA,eAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;ApF69dR;AoF39dQ;EACI,kBAAA;EACA,mBAAA;ApF69dZ;AoF39dY;EACI,eAAA;EACA,cTXE;ESYF,mBAAA;EACA,yBTXE;ESYF,wCAAA;EACA,qBAAA;EACA,4BAAA;EACA,eAAA;ApF69dhB;AoF39dgB;EACI,yBT3BJ;ES4BI,cTnBF;A3Eg/dlB;AoF19dgB;EACI,yBThCJ;ESiCI,cTxBF;A3Eo/dlB;AoFz9dgB;EACI,qBAAA;EACA,gBAAA;ApF29dpB;;AoFp9dA;EACI,mBAAA;ApFu9dJ;AoFr9dI;EACI,cAAA;EACA,YAAA;ApFu9dR;AoFp9dY;EACI,qBTtDA;A3E4gehB;AoFn9doB;EACI,yBT1DR;A3E+gehB;AoF/8dQ;EACI,WAAA;EACA,yBTzDM;ES0DN,mBAAA;EACA,YAAA;EACA,eAAA;ApFi9dZ;AoF/8dY;EACI,gBAAA;EACA,YAAA;EACA,4BAAA;EACA,gBAAA;ApFi9dhB;AoF/8dgB;EACI,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,4BAAA;ApFi9dpB;AoF/8doB;EACI,WAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;ApFi9dxB;AoF58dgB;EACI,yBTnFX;ESoFW,4BAAA;EACA,aAAA;EACA,aAAA;EACA,YAAA;ApF88dpB;AoF58doB;EACI,eAAA;EACA,cAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;ApF88dxB;AoF38doB;EACI,qBAAA;ApF68dxB;AoF38dwB;EACI,UAAA;ApF68d5B;AoFr8dI;EACI,aAAA;ApFu8dR;AoFp8dI;EACI,cAAA;ApFs8dR;AoFn8dI;;EAEI,wCAAA;EACA,oCAAA;ApFq8dR;AoFn8dQ;;EACI,cAAA;ApFs8dZ;AoFl8dI;EACI,wCAAA;EACA,oCAAA;ApFo8dR;AoFl8dQ;EACI,cAAA;EACA,sBAAA;EACA,uBAAA;ApFo8dZ;;AoF/7dA;EACI,mBAAA;EACA,yBTlJc;ESmJd,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;ApFk8dJ;AoFh8dI;EAGI,2BAAA;EACA,gBAAA;EACA,kBAAA;EACA,6BAAA;EACA,2BAAA;ApFg8dR;AoF97dQ;EACI,eAAA;EACA,gBAAA;EAGA,cAAA;EACA,yBTzKM;ES0KN,aAAA;EACA,yBAAA;EAEA,aAAA;EACA,yBAAA;EACA,4BAAA;ApF67dZ;AoF17dQ;EACI,aAAA;ApF47dZ;AoFr7dY;EACI,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;ApFu7dhB;AcpjeI;EsEwHQ;IAQQ,gBAAA;EpFw7dlB;AACF;AoFt7dgB;EACI,WAAA;EACA,mBAAA;ApFw7dpB;AoFn7dQ;EACI,yBAAA;EAGA,gBAAA;EACA,6BAAA;ApFm7dZ;AoF56dY;EACI,eAAA;EACA,gBAAA;EACA,cTtNP;ESuNO,cAAA;EACA,kBAAA;ApF86dhB;AoF36dY;EACI,eAAA;EACA,cAAA;EACA,cT9NP;ES+NO,gBAAA;ApF66dhB;AoF16dY;EACI,aAAA;ApF46dhB;AoF16dgB;EACI,qBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;ApF46dpB;AoF16doB;EACI,gBAAA;ApF46dxB;AoF16dwB;EACI,cAAA;EACA,aAAA;ApF46d5B;AoFv6dgB;EACI,cT7OV;ES8OU,eAAA;EACA,kBAAA;EACA,qBAAA;ApFy6dpB;AoFt6dgB;EACI,eAAA;EACA,cTjPX;ESkPW,eAAA;EACA,qBAAA;ApFw6dpB;AoFp6dY;EACI,eAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;ApFs6dhB;AoFp6dgB;EACI,cAAA;EACA,gCAAA;ApFs6dpB;AoFp6doB;EACI,gBAAA;ApFs6dxB;AoFn6doB;EACI,cTrRf;ESsRe,eAAA;EACA,gBAAA;ApFq6dxB;AoF/5dQ;EACI,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,aAAA;EACA,eAAA;ApFi6dZ;AcvoeI;EsEgOI;IASQ,cAAA;EpFk6dd;AACF;AoFh6dY;EACI,eAAA;EACA,UAAA;ApFk6dhB;AchpeI;EsE4OQ;IAKQ,cAAA;EpFm6dlB;AACF;AoFj6dgB;EACI,WAAA;ApFm6dpB;AoF95dQ;EACI,oBAAA;ApFg6dZ;AoF75dQ;EACI,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,UAAA;ApF+5dZ;AoF75dY;EACI,UAAA;EACA,kBAAA;ApF+5dhB;AoF35dQ;;EAGI,kBAAA;EACA,UAAA;ApF45dZ;AoFz5dQ;EACI,OAAA;ApF25dZ;AoFx5dQ;EACI,QAAA;ApF05dZ;AoFv5dQ;;EAEI,wCAAA;EACA,oCAAA;ApFy5dZ;AoFv5dY;;EACI,cAAA;ApF05dhB;AoFl5dY;EACI,cAAA;EACA,sBAAA;EACA,uBAAA;ApFo5dhB;AoFx3dQ;EACI,eAAA;EACA,4BAAA;ApF03dZ;AoFv3dQ;EACI,WAAA;EACA,mBAAA;EACA,mBAAA;ApFy3dZ;AoFv3dY;EACI,aAAA;EACA,gCAAA;EACA,SAAA;ApFy3dhB;AoFv3dgB;EACI,2BAAA;ApFy3dpB;AoFv3doB;EACI,gBAAA;ApFy3dxB;AoFr3dgB;EACI,yBAAA;EACA,iBAAA;ApFu3dpB;AoFr3doB;EACI,YAAA;EACA,aAAA;EACA,eAAA;EACA,kBAAA;ApFu3dxB;AoFr3dwB;EACI,kBAAA;ApFu3d5B;AoFr3d4B;EACI,WAAA;EACA,YAAA;ApFu3dhC;AoFn3dwB;EACI,eAAA;EACA,kBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,iBAAA;ApFq3d5B;AoFl3dwB;EACI,eAAA;EACA,gBAAA;ApFo3d5B;AoF72dgB;EACI,UAAA;EACA,kBAAA;ApF+2dpB;AoF12dgB;EACI,yBAAA;ApF42dpB;AoFx2dY;EACI,kBAAA;ApF02dhB;AoFr2dI;EACI,aAAA;EACA,sBAAA;EACA,aAAA;ApFu2dR;AoF11dI;EACI,UAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;ApF41dR;AcpxeI;EsEobA;IAOQ,UAAA;EpF61dV;AACF;AoF31dQ;EACI,kBAAA;EACA,WAAA;ApF61dZ;AoF31dY;EACI,WAAA;EACA,oCAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,eAAA;EACA,WAAA;ApF61dhB;AoF11dY;;EAEI,yBTjhBE;A3E62elB;AoFt1dgB;EACI,2BAAA;ApFw1dpB;Ac9yeI;EsEqdY;IAKQ,2BAAA;EpFw1dtB;AACF;AoFr1dgB;EACI,eAAA;ApFu1dpB;AoFj1dY;EACI,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,yBT5iBE;ES6iBF,4BAAA;ApFm1dhB;AoFj1dgB;EACI,gBAAA;EACA,eAAA;EACA,cT7iBX;ES8iBW,gBAAA;ApFm1dpB;AoF/0dY;EACI,2BAAA;EACA,gBAAA;EACA,yBT1jBE;A3E24elB;Acz0eI;EsEqfQ;IAMQ,2BAAA;EpFk1dlB;AACF;AoF/0dY;EACI,aAAA;EACA,eAAA;EACA,kBAAA;EACA,gCAAA;ApFi1dhB;AoF/0dgB;EACI,kBAAA;ApFi1dpB;AoF90dgB;EACI,aAAA;EACA,eAAA;EACA,wBAAA;ApFg1dpB;AoF90doB;EACI,WAAA;EACA,gBAAA;EACA,kBAAA;ApFg1dxB;AoF90dwB;EACI,WAAA;ApFg1d5B;AoF50doB;EACI,wBAAA;ApF80dxB;AoF50dwB;EACI,eAAA;EACA,gBAAA;EACA,cT3lBnB;ES4lBmB,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;ApF80d5B;AoF30dwB;EACI,eAAA;EACA,cTpmBnB;ESqmBmB,gBAAA;ApF60d5B;AoF10dwB;EACI,eAAA;EACA,gBAAA;EACA,cT3mBnB;ES4mBmB,aAAA;EACA,mBAAA;ApF40d5B;AoF10d4B;EACI,cAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;ApF40dhC;AoFr0dY;EACI,kBAAA;ApFu0dhB;AoFl0dI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,gCAAA;ApFo0dR;AoFl0dQ;EACI,gBAAA;EACA,eAAA;EACA,cT1oBH;ES2oBG,gBAAA;ApFo0dZ;AoFj0dQ;EACI,aAAA;EACA,mBAAA;ApFm0dZ;AoFj0dY;EACI,aAAA;EACA,mBAAA;EACA,eAAA;ApFm0dhB;AoFj0dgB;EACI,kBAAA;ApFm0dpB;AoF7zdI;EACI,aAAA;EACA,eAAA;EACA,2BAAA;EACA,gBAAA;ApF+zdR;AoF7zdQ;EACI,+BAAA;EACA,UAAA;ApF+zdZ;AoF7zdY;EACI,eAAA;ApF+zdhB;AoF5zdY;EACI,aAAA;EACA,kBAAA;ApF8zdhB;AoF5zdgB;EACI,kBAAA;EACA,QAAA;EACA,UAAA;EACA,cAAA;EACA,eAAA;ApF8zdpB;AoF3zdgB;EACI,WAAA;EACA,eAAA;EACA,wBAAA;ApF6zdpB;AoF3zdoB;EACI,WAAA;ApF6zdxB;AoFxzdoB;EACI,eAAA;EACA,gBAAA;EACA,cTtsBf;ESusBe,gBAAA;ApF0zdxB;AoFxzdwB;EACI,cTzrBnB;A3Em/eT;AoFtzdoB;EACI,eAAA;EACA,cThtBf;ESitBe,gBAAA;ApFwzdxB;AoFrzdoB;EACI,eAAA;EACA,gBAAA;EACA,cTvtBf;ESwtBe,aAAA;EACA,mBAAA;EACA,mBAAA;ApFuzdxB;AoFrzdwB;EACI,cAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;ApFuzd5B;AoFjzdY;EACI,yBTzuBP;ES0uBO,eAAA;EACA,cTzuBP;ES0uBO,iBAAA;ApFmzdhB;AoFhzdY;EACI,aAAA;ApFkzdhB;AoFhzdgB;EACI,eAAA;EACA,kBAAA;ApFkzdpB;AoFhzdoB;EACI,gBAAA;ApFkzdxB;AoF5ydgB;EACI,kBAAA;ApF8ydpB;AoF5ydoB;EACI,mBAAA;ApF8ydxB;AoF5ydwB;EACI,YAAA;EACA,eAAA;ApF8yd5B;AoFzydgB;EACI,aAAA;EACA,YAAA;EACA,yBT7wBX;ES8wBW,mBAAA;EACA,qBAAA;EACA,mBAAA;ApF2ydpB;AoFxydgB;;EAEI,cTxwBV;ESywBU,gBAAA;ApF0ydpB;AoFpydY;EACI,aAAA;ApFsydhB;;AoF/xdA;EACI,eAAA;EACA,qBAAA;EACA,aAAA;EACA,eAAA;EACA,0BAAA;ApFkydJ;AoFhydI;EACI,eAAA;ApFkydR;AoFhydQ;EACI,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,eAAA;ApFkydZ;AoFhydY;EACI,qBTj0BA;A3EmmfhB;AoF/xdY;EACI,YAAA;EACA,WAAA;EACA,iBAAA;ApFiydhB;;AoF3xdA;EACI,kBAAA;EACA,WAAA;EACA,cAAA;ApF8xdJ;AoF5xdI;EACI,eAAA;ApF8xdR;AoF3xdI;EACI,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,UAAA;EACA,kBAAA;EACA,qBAAA;ApF6xdR;;AoFvxdI;EACI,YAAA;EACA,mBAAA;ApF0xdR;AoFvxdI;EACI,aAAA;ApFyxdR;;AoFrxdA;EACI,gBAAA;ApFwxdJ;AoFrxdQ;EAGI,2BAAA;ApFqxdZ;AoFjxdI;EACI,WAAA;ApFmxdR;AoFhxdI;;EAEI,aAAA;EACA,eAAA;ApFkxdR;AoFhxdQ;;EACI,qBAAA;EACA,eAAA;ApFmxdZ;Ac1kfI;EsEgzBA;;IAWQ,eAAA;EpFoxdV;AACF;AoFjxdI;EACI,gCAAA;ApFmxdR","sourcesContent":["// Font-family\n@import url('https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap');\n\n// Import Bootstrap and its default variables\n@import 'bootstrap/scss/bootstrap.scss';\n\n// Settings:\n@import 'base/colors';\n@import 'base/type';\n@import 'base/form';\n@import 'base/button';\n@import 'base/tabs';\n\n// components:\n// @import 'components/sidebar';\n// @import 'components/chart';\n@import 'components/data-table';\n// // @import 'components/permission';\n// @import 'components/web-scrapper';\n// @import 'components/param-configuration';\n// @import 'components/voice-interaction.scss';\n// @import 'components/doc-processing.scss';\n// @import 'components/modal.scss';\n// @import 'components/sourceInfo';\n@import 'components/home';\n// @import 'components/header';\n// @import 'components/ai-chatbot';\n@import 'components/chat-history';\n@import 'components/chatBot';\n// @import 'components/login';\n// @import 'components/lens';\n// @import 'components/process-image';\n// @import 'components/form-sidebar';\n// @import 'components/inventory-forecast';\n@import 'components/global';\n@import 'components/shopmate';","@mixin bsBanner($file) {\n  /*!\n   * Bootstrap #{$file} v5.3.8 (https://getbootstrap.com/)\n   * Copyright 2011-2025 The Bootstrap Authors\n   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n   */\n}\n",":root,\n[data-bs-theme=\"light\"] {\n  // Note: Custom variable values only support SassScript inside `#{}`.\n\n  // Colors\n  //\n  // Generate palettes for full colors, grays, and theme colors.\n\n  @each $color, $value in $colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $grays {\n    --#{$prefix}gray-#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-rgb {\n    --#{$prefix}#{$color}-rgb: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-text {\n    --#{$prefix}#{$color}-text-emphasis: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-bg-subtle {\n    --#{$prefix}#{$color}-bg-subtle: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-border-subtle {\n    --#{$prefix}#{$color}-border-subtle: #{$value};\n  }\n\n  --#{$prefix}white-rgb: #{to-rgb($white)};\n  --#{$prefix}black-rgb: #{to-rgb($black)};\n\n  // Fonts\n\n  // Note: Use `inspect` for lists so that quoted items keep the quotes.\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\n  --#{$prefix}font-sans-serif: #{inspect($font-family-sans-serif)};\n  --#{$prefix}font-monospace: #{inspect($font-family-monospace)};\n  --#{$prefix}gradient: #{$gradient};\n\n  // Root and body\n  // scss-docs-start root-body-variables\n  @if $font-size-root != null {\n    --#{$prefix}root-font-size: #{$font-size-root};\n  }\n  --#{$prefix}body-font-family: #{inspect($font-family-base)};\n  @include rfs($font-size-base, --#{$prefix}body-font-size);\n  --#{$prefix}body-font-weight: #{$font-weight-base};\n  --#{$prefix}body-line-height: #{$line-height-base};\n  @if $body-text-align != null {\n    --#{$prefix}body-text-align: #{$body-text-align};\n  }\n\n  --#{$prefix}body-color: #{$body-color};\n  --#{$prefix}body-color-rgb: #{to-rgb($body-color)};\n  --#{$prefix}body-bg: #{$body-bg};\n  --#{$prefix}body-bg-rgb: #{to-rgb($body-bg)};\n\n  --#{$prefix}emphasis-color: #{$body-emphasis-color};\n  --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color)};\n\n  --#{$prefix}secondary-color: #{$body-secondary-color};\n  --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color)};\n  --#{$prefix}secondary-bg: #{$body-secondary-bg};\n  --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg)};\n\n  --#{$prefix}tertiary-color: #{$body-tertiary-color};\n  --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color)};\n  --#{$prefix}tertiary-bg: #{$body-tertiary-bg};\n  --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg)};\n  // scss-docs-end root-body-variables\n\n  --#{$prefix}heading-color: #{$headings-color};\n\n  --#{$prefix}link-color: #{$link-color};\n  --#{$prefix}link-color-rgb: #{to-rgb($link-color)};\n  --#{$prefix}link-decoration: #{$link-decoration};\n\n  --#{$prefix}link-hover-color: #{$link-hover-color};\n  --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color)};\n\n  @if $link-hover-decoration != null {\n    --#{$prefix}link-hover-decoration: #{$link-hover-decoration};\n  }\n\n  --#{$prefix}code-color: #{$code-color};\n  --#{$prefix}highlight-color: #{$mark-color};\n  --#{$prefix}highlight-bg: #{$mark-bg};\n\n  // scss-docs-start root-border-var\n  --#{$prefix}border-width: #{$border-width};\n  --#{$prefix}border-style: #{$border-style};\n  --#{$prefix}border-color: #{$border-color};\n  --#{$prefix}border-color-translucent: #{$border-color-translucent};\n\n  --#{$prefix}border-radius: #{$border-radius};\n  --#{$prefix}border-radius-sm: #{$border-radius-sm};\n  --#{$prefix}border-radius-lg: #{$border-radius-lg};\n  --#{$prefix}border-radius-xl: #{$border-radius-xl};\n  --#{$prefix}border-radius-xxl: #{$border-radius-xxl};\n  --#{$prefix}border-radius-2xl: var(--#{$prefix}border-radius-xxl); // Deprecated in v5.3.0 for consistency\n  --#{$prefix}border-radius-pill: #{$border-radius-pill};\n  // scss-docs-end root-border-var\n\n  --#{$prefix}box-shadow: #{$box-shadow};\n  --#{$prefix}box-shadow-sm: #{$box-shadow-sm};\n  --#{$prefix}box-shadow-lg: #{$box-shadow-lg};\n  --#{$prefix}box-shadow-inset: #{$box-shadow-inset};\n\n  // Focus styles\n  // scss-docs-start root-focus-variables\n  --#{$prefix}focus-ring-width: #{$focus-ring-width};\n  --#{$prefix}focus-ring-opacity: #{$focus-ring-opacity};\n  --#{$prefix}focus-ring-color: #{$focus-ring-color};\n  // scss-docs-end root-focus-variables\n\n  // scss-docs-start root-form-validation-variables\n  --#{$prefix}form-valid-color: #{$form-valid-color};\n  --#{$prefix}form-valid-border-color: #{$form-valid-border-color};\n  --#{$prefix}form-invalid-color: #{$form-invalid-color};\n  --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color};\n  // scss-docs-end root-form-validation-variables\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n    color-scheme: dark;\n\n    // scss-docs-start root-dark-mode-vars\n    --#{$prefix}body-color: #{$body-color-dark};\n    --#{$prefix}body-color-rgb: #{to-rgb($body-color-dark)};\n    --#{$prefix}body-bg: #{$body-bg-dark};\n    --#{$prefix}body-bg-rgb: #{to-rgb($body-bg-dark)};\n\n    --#{$prefix}emphasis-color: #{$body-emphasis-color-dark};\n    --#{$prefix}emphasis-color-rgb: #{to-rgb($body-emphasis-color-dark)};\n\n    --#{$prefix}secondary-color: #{$body-secondary-color-dark};\n    --#{$prefix}secondary-color-rgb: #{to-rgb($body-secondary-color-dark)};\n    --#{$prefix}secondary-bg: #{$body-secondary-bg-dark};\n    --#{$prefix}secondary-bg-rgb: #{to-rgb($body-secondary-bg-dark)};\n\n    --#{$prefix}tertiary-color: #{$body-tertiary-color-dark};\n    --#{$prefix}tertiary-color-rgb: #{to-rgb($body-tertiary-color-dark)};\n    --#{$prefix}tertiary-bg: #{$body-tertiary-bg-dark};\n    --#{$prefix}tertiary-bg-rgb: #{to-rgb($body-tertiary-bg-dark)};\n\n    @each $color, $value in $theme-colors-text-dark {\n      --#{$prefix}#{$color}-text-emphasis: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-bg-subtle-dark {\n      --#{$prefix}#{$color}-bg-subtle: #{$value};\n    }\n\n    @each $color, $value in $theme-colors-border-subtle-dark {\n      --#{$prefix}#{$color}-border-subtle: #{$value};\n    }\n\n    --#{$prefix}heading-color: #{$headings-color-dark};\n\n    --#{$prefix}link-color: #{$link-color-dark};\n    --#{$prefix}link-hover-color: #{$link-hover-color-dark};\n    --#{$prefix}link-color-rgb: #{to-rgb($link-color-dark)};\n    --#{$prefix}link-hover-color-rgb: #{to-rgb($link-hover-color-dark)};\n\n    --#{$prefix}code-color: #{$code-color-dark};\n    --#{$prefix}highlight-color: #{$mark-color-dark};\n    --#{$prefix}highlight-bg: #{$mark-bg-dark};\n\n    --#{$prefix}border-color: #{$border-color-dark};\n    --#{$prefix}border-color-translucent: #{$border-color-translucent-dark};\n\n    --#{$prefix}form-valid-color: #{$form-valid-color-dark};\n    --#{$prefix}form-valid-border-color: #{$form-valid-border-color-dark};\n    --#{$prefix}form-invalid-color: #{$form-invalid-color-dark};\n    --#{$prefix}form-invalid-border-color: #{$form-invalid-border-color-dark};\n    // scss-docs-end root-dark-mode-vars\n  }\n}\n","// stylelint-disable scss/dimension-no-non-numeric-values\n\n// SCSS RFS mixin\n//\n// Automated responsive values for font sizes, paddings, margins and much more\n//\n// Licensed under MIT (https://github.com/twbs/rfs/blob/main/LICENSE)\n\n// Configuration\n\n// Base value\n$rfs-base-value: 1.25rem !default;\n$rfs-unit: rem !default;\n\n@if $rfs-unit != rem and $rfs-unit != px {\n  @error \"`#{$rfs-unit}` is not a valid unit for $rfs-unit. Use `px` or `rem`.\";\n}\n\n// Breakpoint at where values start decreasing if screen width is smaller\n$rfs-breakpoint: 1200px !default;\n$rfs-breakpoint-unit: px !default;\n\n@if $rfs-breakpoint-unit != px and $rfs-breakpoint-unit != em and $rfs-breakpoint-unit != rem {\n  @error \"`#{$rfs-breakpoint-unit}` is not a valid unit for $rfs-breakpoint-unit. Use `px`, `em` or `rem`.\";\n}\n\n// Resize values based on screen height and width\n$rfs-two-dimensional: false !default;\n\n// Factor of decrease\n$rfs-factor: 10 !default;\n\n@if type-of($rfs-factor) != number or $rfs-factor <= 1 {\n  @error \"`#{$rfs-factor}` is not a valid  $rfs-factor, it must be greater than 1.\";\n}\n\n// Mode. Possibilities: \"min-media-query\", \"max-media-query\"\n$rfs-mode: min-media-query !default;\n\n// Generate enable or disable classes. Possibilities: false, \"enable\" or \"disable\"\n$rfs-class: false !default;\n\n// 1 rem = $rfs-rem-value px\n$rfs-rem-value: 16 !default;\n\n// Safari iframe resize bug: https://github.com/twbs/rfs/issues/14\n$rfs-safari-iframe-resize-bug-fix: false !default;\n\n// Disable RFS by setting $enable-rfs to false\n$enable-rfs: true !default;\n\n// Cache $rfs-base-value unit\n$rfs-base-value-unit: unit($rfs-base-value);\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n\n// Remove px-unit from $rfs-base-value for calculations\n@if $rfs-base-value-unit == px {\n  $rfs-base-value: divide($rfs-base-value, $rfs-base-value * 0 + 1);\n}\n@else if $rfs-base-value-unit == rem {\n  $rfs-base-value: divide($rfs-base-value, divide($rfs-base-value * 0 + 1, $rfs-rem-value));\n}\n\n// Cache $rfs-breakpoint unit to prevent multiple calls\n$rfs-breakpoint-unit-cache: unit($rfs-breakpoint);\n\n// Remove unit from $rfs-breakpoint for calculations\n@if $rfs-breakpoint-unit-cache == px {\n  $rfs-breakpoint: divide($rfs-breakpoint, $rfs-breakpoint * 0 + 1);\n}\n@else if $rfs-breakpoint-unit-cache == rem or $rfs-breakpoint-unit-cache == \"em\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, divide($rfs-breakpoint * 0 + 1, $rfs-rem-value));\n}\n\n// Calculate the media query value\n$rfs-mq-value: if($rfs-breakpoint-unit == px, #{$rfs-breakpoint}px, #{divide($rfs-breakpoint, $rfs-rem-value)}#{$rfs-breakpoint-unit});\n$rfs-mq-property-width: if($rfs-mode == max-media-query, max-width, min-width);\n$rfs-mq-property-height: if($rfs-mode == max-media-query, max-height, min-height);\n\n// Internal mixin used to determine which media query needs to be used\n@mixin _rfs-media-query {\n  @if $rfs-two-dimensional {\n    @if $rfs-mode == max-media-query {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}), (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n    @else {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) and (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n  }\n  @else {\n    @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) {\n      @content;\n    }\n  }\n}\n\n// Internal mixin that adds disable classes to the selector if needed.\n@mixin _rfs-rule {\n  @if $rfs-class == disable and $rfs-mode == max-media-query {\n    // Adding an extra class increases specificity, which prevents the media query to override the property\n    &,\n    .disable-rfs &,\n    &.disable-rfs {\n      @content;\n    }\n  }\n  @else if $rfs-class == enable and $rfs-mode == min-media-query {\n    .enable-rfs &,\n    &.enable-rfs {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Internal mixin that adds enable classes to the selector if needed.\n@mixin _rfs-media-query-rule {\n\n  @if $rfs-class == enable {\n    @if $rfs-mode == min-media-query {\n      @content;\n    }\n\n    @include _rfs-media-query () {\n      .enable-rfs &,\n      &.enable-rfs {\n        @content;\n      }\n    }\n  }\n  @else {\n    @if $rfs-class == disable and $rfs-mode == min-media-query {\n      .disable-rfs &,\n      &.disable-rfs {\n        @content;\n      }\n    }\n    @include _rfs-media-query () {\n      @content;\n    }\n  }\n}\n\n// Helper function to get the formatted non-responsive value\n@function rfs-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    }\n    @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      @if $unit == px {\n        // Convert to rem if needed\n        $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $value * 0 + $rfs-rem-value)}rem, $value);\n      }\n      @else if $unit == rem {\n        // Convert to px if needed\n        $val: $val + \" \" + if($rfs-unit == px, #{divide($value, $value * 0 + 1) * $rfs-rem-value}px, $value);\n      } @else {\n        // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n        $val: $val + \" \" + $value;\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// Helper function to get the responsive value calculated by RFS\n@function rfs-fluid-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    } @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n      @if not $unit or $unit != px and $unit != rem {\n        $val: $val + \" \" + $value;\n      } @else {\n        // Remove unit from $value for calculations\n        $value: divide($value, $value * 0 + if($unit == px, 1, divide(1, $rfs-rem-value)));\n\n        // Only add the media query if the value is greater than the minimum value\n        @if abs($value) <= $rfs-base-value or not $enable-rfs {\n          $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $rfs-rem-value)}rem, #{$value}px);\n        }\n        @else {\n          // Calculate the minimum value\n          $value-min: $rfs-base-value + divide(abs($value) - $rfs-base-value, $rfs-factor);\n\n          // Calculate difference between $value and the minimum value\n          $value-diff: abs($value) - $value-min;\n\n          // Base value formatting\n          $min-width: if($rfs-unit == rem, #{divide($value-min, $rfs-rem-value)}rem, #{$value-min}px);\n\n          // Use negative value if needed\n          $min-width: if($value < 0, -$min-width, $min-width);\n\n          // Use `vmin` if two-dimensional is enabled\n          $variable-unit: if($rfs-two-dimensional, vmin, vw);\n\n          // Calculate the variable width between 0 and $rfs-breakpoint\n          $variable-width: #{divide($value-diff * 100, $rfs-breakpoint)}#{$variable-unit};\n\n          // Return the calculated value\n          $val: $val + \" calc(\" + $min-width + if($value < 0, \" - \", \" + \") + $variable-width + \")\";\n        }\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// RFS mixin\n@mixin rfs($values, $property: font-size) {\n  @if $values != null {\n    $val: rfs-value($values);\n    $fluid-val: rfs-fluid-value($values);\n\n    // Do not print the media query if responsive & non-responsive values are the same\n    @if $val == $fluid-val {\n      #{$property}: $val;\n    }\n    @else {\n      @include _rfs-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $val, $fluid-val);\n\n        // Include safari iframe resize fix if needed\n        min-width: if($rfs-safari-iframe-resize-bug-fix, (0 * 1vw), null);\n      }\n\n      @include _rfs-media-query-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $fluid-val, $val);\n      }\n    }\n  }\n}\n\n// Shorthand helper mixins\n@mixin font-size($value) {\n  @include rfs($value);\n}\n\n@mixin padding($value) {\n  @include rfs($value, padding);\n}\n\n@mixin padding-top($value) {\n  @include rfs($value, padding-top);\n}\n\n@mixin padding-right($value) {\n  @include rfs($value, padding-right);\n}\n\n@mixin padding-bottom($value) {\n  @include rfs($value, padding-bottom);\n}\n\n@mixin padding-left($value) {\n  @include rfs($value, padding-left);\n}\n\n@mixin margin($value) {\n  @include rfs($value, margin);\n}\n\n@mixin margin-top($value) {\n  @include rfs($value, margin-top);\n}\n\n@mixin margin-right($value) {\n  @include rfs($value, margin-right);\n}\n\n@mixin margin-bottom($value) {\n  @include rfs($value, margin-bottom);\n}\n\n@mixin margin-left($value) {\n  @include rfs($value, margin-left);\n}\n","// scss-docs-start color-mode-mixin\n@mixin color-mode($mode: light, $root: false) {\n  @if $color-mode-type == \"media-query\" {\n    @if $root == true {\n      @media (prefers-color-scheme: $mode) {\n        :root {\n          @content;\n        }\n      }\n    } @else {\n      @media (prefers-color-scheme: $mode) {\n        @content;\n      }\n    }\n  } @else {\n    [data-bs-theme=\"#{$mode}\"] {\n      @content;\n    }\n  }\n}\n// scss-docs-end color-mode-mixin\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\n\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n\n// Document\n//\n// Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n\n// Root\n//\n// Ability to the value of the root font sizes, affecting the value of `rem`.\n// null by default, thus nothing is generated.\n\n:root {\n  @if $font-size-root != null {\n    @include font-size(var(--#{$prefix}root-font-size));\n  }\n\n  @if $enable-smooth-scroll {\n    @media (prefers-reduced-motion: no-preference) {\n      scroll-behavior: smooth;\n    }\n  }\n}\n\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Prevent adjustments of font size after orientation changes in iOS.\n// 4. Change the default tap highlight to be completely transparent in iOS.\n\n// scss-docs-start reboot-body-rules\nbody {\n  margin: 0; // 1\n  font-family: var(--#{$prefix}body-font-family);\n  @include font-size(var(--#{$prefix}body-font-size));\n  font-weight: var(--#{$prefix}body-font-weight);\n  line-height: var(--#{$prefix}body-line-height);\n  color: var(--#{$prefix}body-color);\n  text-align: var(--#{$prefix}body-text-align);\n  background-color: var(--#{$prefix}body-bg); // 2\n  -webkit-text-size-adjust: 100%; // 3\n  -webkit-tap-highlight-color: rgba($black, 0); // 4\n}\n// scss-docs-end reboot-body-rules\n\n\n// Content grouping\n//\n// 1. Reset Firefox's gray color\n\nhr {\n  margin: $hr-margin-y 0;\n  color: $hr-color; // 1\n  border: 0;\n  border-top: $hr-border-width solid $hr-border-color;\n  opacity: $hr-opacity;\n}\n\n\n// Typography\n//\n// 1. Remove top margins from headings\n//    By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n//    margin for easier control within type scales as it avoids margin collapsing.\n\n%heading {\n  margin-top: 0; // 1\n  margin-bottom: $headings-margin-bottom;\n  font-family: $headings-font-family;\n  font-style: $headings-font-style;\n  font-weight: $headings-font-weight;\n  line-height: $headings-line-height;\n  color: var(--#{$prefix}heading-color);\n}\n\nh1 {\n  @extend %heading;\n  @include font-size($h1-font-size);\n}\n\nh2 {\n  @extend %heading;\n  @include font-size($h2-font-size);\n}\n\nh3 {\n  @extend %heading;\n  @include font-size($h3-font-size);\n}\n\nh4 {\n  @extend %heading;\n  @include font-size($h4-font-size);\n}\n\nh5 {\n  @extend %heading;\n  @include font-size($h5-font-size);\n}\n\nh6 {\n  @extend %heading;\n  @include font-size($h6-font-size);\n}\n\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\n\np {\n  margin-top: 0;\n  margin-bottom: $paragraph-margin-bottom;\n}\n\n\n// Abbreviations\n//\n// 1. Add the correct text decoration in Chrome, Edge, Opera, and Safari.\n// 2. Add explicit cursor to indicate changed behavior.\n// 3. Prevent the text-decoration to be skipped.\n\nabbr[title] {\n  text-decoration: underline dotted; // 1\n  cursor: help; // 2\n  text-decoration-skip-ink: none; // 3\n}\n\n\n// Address\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\n\n// Lists\n\nol,\nul {\n  padding-left: 2rem;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: $dt-font-weight;\n}\n\n// 1. Undo browser default\n\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0; // 1\n}\n\n\n// Blockquote\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\n\n// Strong\n//\n// Add the correct font weight in Chrome, Edge, and Safari\n\nb,\nstrong {\n  font-weight: $font-weight-bolder;\n}\n\n\n// Small\n//\n// Add the correct font size in all browsers\n\nsmall {\n  @include font-size($small-font-size);\n}\n\n\n// Mark\n\nmark {\n  padding: $mark-padding;\n  color: var(--#{$prefix}highlight-color);\n  background-color: var(--#{$prefix}highlight-bg);\n}\n\n\n// Sub and Sup\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n\nsub,\nsup {\n  position: relative;\n  @include font-size($sub-sup-font-size);\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub { bottom: -.25em; }\nsup { top: -.5em; }\n\n\n// Links\n\na {\n  color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, 1));\n  text-decoration: $link-decoration;\n\n  &:hover {\n    --#{$prefix}link-color-rgb: var(--#{$prefix}link-hover-color-rgb);\n    text-decoration: $link-hover-decoration;\n  }\n}\n\n// And undo these styles for placeholder links/named anchors (without href).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]):not([class]) {\n  &,\n  &:hover {\n    color: inherit;\n    text-decoration: none;\n  }\n}\n\n\n// Code\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: $font-family-code;\n  @include font-size(1em); // Correct the odd `em` font sizing in all browsers.\n}\n\n// 1. Remove browser default top margin\n// 2. Reset browser default of `1em` to use `rem`s\n// 3. Don't allow content to break outside\n\npre {\n  display: block;\n  margin-top: 0; // 1\n  margin-bottom: 1rem; // 2\n  overflow: auto; // 3\n  @include font-size($code-font-size);\n  color: $pre-color;\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    @include font-size(inherit);\n    color: inherit;\n    word-break: normal;\n  }\n}\n\ncode {\n  @include font-size($code-font-size);\n  color: var(--#{$prefix}code-color);\n  word-wrap: break-word;\n\n  // Streamline the style when inside anchors to avoid broken underline and more\n  a > & {\n    color: inherit;\n  }\n}\n\nkbd {\n  padding: $kbd-padding-y $kbd-padding-x;\n  @include font-size($kbd-font-size);\n  color: $kbd-color;\n  background-color: $kbd-bg;\n  @include border-radius($border-radius-sm);\n\n  kbd {\n    padding: 0;\n    @include font-size(1em);\n    font-weight: $nested-kbd-font-weight;\n  }\n}\n\n\n// Figures\n//\n// Apply a consistent margin strategy (matches our type styles).\n\nfigure {\n  margin: 0 0 1rem;\n}\n\n\n// Images and content\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\n\n// Tables\n//\n// Prevent double borders\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: $table-cell-padding-y;\n  padding-bottom: $table-cell-padding-y;\n  color: $table-caption-color;\n  text-align: left;\n}\n\n// 1. Removes font-weight bold by inheriting\n// 2. Matches default `<td>` alignment by inheriting `text-align`.\n// 3. Fix alignment for Safari\n\nth {\n  font-weight: $table-th-font-weight; // 1\n  text-align: inherit; // 2\n  text-align: -webkit-match-parent; // 3\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\n\n// Forms\n//\n// 1. Allow labels to use `margin` for spacing.\n\nlabel {\n  display: inline-block; // 1\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n// See https://github.com/twbs/bootstrap/issues/24093\n\nbutton {\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 0;\n}\n\n// Explicitly remove focus outline in Chromium when it shouldn't be\n// visible (e.g. as result of mouse click or touch tap). It already\n// should be doing this automatically, but seems to currently be\n// confused and applies its very visible two-tone outline anyway.\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\n// 1. Remove the margin in Firefox and Safari\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // 1\n  font-family: inherit;\n  @include font-size(inherit);\n  line-height: inherit;\n}\n\n// Remove the inheritance of text transform in Firefox\nbutton,\nselect {\n  text-transform: none;\n}\n// Set the cursor for non-`<button>` buttons\n//\n// Details at https://github.com/twbs/bootstrap/pull/30562\n[role=\"button\"] {\n  cursor: pointer;\n}\n\nselect {\n  // Remove the inheritance of word-wrap in Safari.\n  // See https://github.com/twbs/bootstrap/issues/24990\n  word-wrap: normal;\n\n  // Undo the opacity change from Chrome\n  &:disabled {\n    opacity: 1;\n  }\n}\n\n// Remove the dropdown arrow only from text type inputs built with datalists in Chrome.\n// See https://stackoverflow.com/a/54997118\n\n[list]:not([type=\"date\"]):not([type=\"datetime-local\"]):not([type=\"month\"]):not([type=\"week\"]):not([type=\"time\"])::-webkit-calendar-picker-indicator {\n  display: none !important;\n}\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\n// 3. Opinionated: add \"hand\" cursor to non-disabled button elements.\n\nbutton,\n[type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n\n  @if $enable-button-pointers {\n    &:not(:disabled) {\n      cursor: pointer; // 3\n    }\n  }\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\n// 1. Textareas should really only resize vertically so they don't break their (horizontal) containers.\n\ntextarea {\n  resize: vertical; // 1\n}\n\n// 1. Browsers set a default `min-width: min-content;` on fieldsets,\n//    unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n//    So we reset that to ensure fieldsets behave more like a standard block element.\n//    See https://github.com/twbs/bootstrap/issues/12359\n//    and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n// 2. Reset the default outline behavior of fieldsets so they don't affect page layout.\n\nfieldset {\n  min-width: 0; // 1\n  padding: 0; // 2\n  margin: 0; // 2\n  border: 0; // 2\n}\n\n// 1. By using `float: left`, the legend will behave like a block element.\n//    This way the border of a fieldset wraps around the legend if present.\n// 2. Fix wrapping bug.\n//    See https://github.com/twbs/bootstrap/issues/29712\n\nlegend {\n  float: left; // 1\n  width: 100%;\n  padding: 0;\n  margin-bottom: $legend-margin-bottom;\n  font-weight: $legend-font-weight;\n  line-height: inherit;\n  @include font-size($legend-font-size);\n\n  + * {\n    clear: left; // 2\n  }\n}\n\n// Fix height of inputs with a type of datetime-local, date, month, week, or time\n// See https://github.com/twbs/bootstrap/issues/18842\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n// 1. This overrides the extra rounded corners on search inputs in iOS so that our\n//    `.form-control` class can properly style them. Note that this cannot simply\n//    be added to `.form-control` as it's not specific enough. For details, see\n//    https://github.com/twbs/bootstrap/issues/11586.\n// 2. Correct the outline style in Safari.\n\n[type=\"search\"] {\n  -webkit-appearance: textfield; // 1\n  outline-offset: -2px; // 2\n\n  // 3. Better affordance and consistent appearance for search cancel button\n  &::-webkit-search-cancel-button {\n    cursor: pointer;\n    filter: grayscale(1);\n  }\n}\n\n// 1. A few input types should stay LTR\n// See https://rtlstyling.com/posts/rtl-styling#form-inputs\n// 2. RTL only output\n// See https://rtlcss.com/learn/usage-guide/control-directives/#raw\n\n/* rtl:raw:\n[type=\"tel\"],\n[type=\"url\"],\n[type=\"email\"],\n[type=\"number\"] {\n  direction: ltr;\n}\n*/\n\n// Remove the inner padding in Chrome and Safari on macOS.\n\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n// Remove padding around color pickers in webkit browsers\n\n::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n\n// 1. Inherit font family and line height for file input buttons\n// 2. Correct the inability to style clickable types in iOS and Safari.\n\n::file-selector-button {\n  font: inherit; // 1\n  -webkit-appearance: button; // 2\n}\n\n// Correct element displays\n\noutput {\n  display: inline-block;\n}\n\n// Remove border from iframe\n\niframe {\n  border: 0;\n}\n\n// Summary\n//\n// 1. Add the correct display in all browsers\n\nsummary {\n  display: list-item; // 1\n  cursor: pointer;\n}\n\n\n// Progress\n//\n// Add the correct vertical alignment in Chrome, Firefox, and Opera.\n\nprogress {\n  vertical-align: baseline;\n}\n\n\n// Hidden attribute\n//\n// Always hide an element with the `hidden` HTML attribute.\n\n[hidden] {\n  display: none !important;\n}\n","// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n// scss-docs-start gray-color-variables\n$white:    #fff !default;\n$gray-100: #f8f9fa !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-600: #6c757d !default;\n$gray-700: #495057 !default;\n$gray-800: #343a40 !default;\n$gray-900: #212529 !default;\n$black:    #000 !default;\n// scss-docs-end gray-color-variables\n\n// fusv-disable\n// scss-docs-start gray-colors-map\n$grays: (\n  \"100\": $gray-100,\n  \"200\": $gray-200,\n  \"300\": $gray-300,\n  \"400\": $gray-400,\n  \"500\": $gray-500,\n  \"600\": $gray-600,\n  \"700\": $gray-700,\n  \"800\": $gray-800,\n  \"900\": $gray-900\n) !default;\n// scss-docs-end gray-colors-map\n// fusv-enable\n\n// scss-docs-start color-variables\n$blue:    #0d6efd !default;\n$indigo:  #6610f2 !default;\n$purple:  #6f42c1 !default;\n$pink:    #d63384 !default;\n$red:     #dc3545 !default;\n$orange:  #fd7e14 !default;\n$yellow:  #ffc107 !default;\n$green:   #198754 !default;\n$teal:    #20c997 !default;\n$cyan:    #0dcaf0 !default;\n// scss-docs-end color-variables\n\n// scss-docs-start colors-map\n$colors: (\n  \"blue\":       $blue,\n  \"indigo\":     $indigo,\n  \"purple\":     $purple,\n  \"pink\":       $pink,\n  \"red\":        $red,\n  \"orange\":     $orange,\n  \"yellow\":     $yellow,\n  \"green\":      $green,\n  \"teal\":       $teal,\n  \"cyan\":       $cyan,\n  \"black\":      $black,\n  \"white\":      $white,\n  \"gray\":       $gray-600,\n  \"gray-dark\":  $gray-800\n) !default;\n// scss-docs-end colors-map\n\n// The contrast ratio to reach against white, to determine if color changes from \"light\" to \"dark\". Acceptable values for WCAG 2.2 are 3, 4.5 and 7.\n// See https://www.w3.org/TR/WCAG/#contrast-minimum\n$min-contrast-ratio:   4.5 !default;\n\n// Customize the light and dark text colors for use in our color contrast function.\n$color-contrast-dark:      $black !default;\n$color-contrast-light:     $white !default;\n\n// fusv-disable\n$blue-100: tint-color($blue, 80%) !default;\n$blue-200: tint-color($blue, 60%) !default;\n$blue-300: tint-color($blue, 40%) !default;\n$blue-400: tint-color($blue, 20%) !default;\n$blue-500: $blue !default;\n$blue-600: shade-color($blue, 20%) !default;\n$blue-700: shade-color($blue, 40%) !default;\n$blue-800: shade-color($blue, 60%) !default;\n$blue-900: shade-color($blue, 80%) !default;\n\n$indigo-100: tint-color($indigo, 80%) !default;\n$indigo-200: tint-color($indigo, 60%) !default;\n$indigo-300: tint-color($indigo, 40%) !default;\n$indigo-400: tint-color($indigo, 20%) !default;\n$indigo-500: $indigo !default;\n$indigo-600: shade-color($indigo, 20%) !default;\n$indigo-700: shade-color($indigo, 40%) !default;\n$indigo-800: shade-color($indigo, 60%) !default;\n$indigo-900: shade-color($indigo, 80%) !default;\n\n$purple-100: tint-color($purple, 80%) !default;\n$purple-200: tint-color($purple, 60%) !default;\n$purple-300: tint-color($purple, 40%) !default;\n$purple-400: tint-color($purple, 20%) !default;\n$purple-500: $purple !default;\n$purple-600: shade-color($purple, 20%) !default;\n$purple-700: shade-color($purple, 40%) !default;\n$purple-800: shade-color($purple, 60%) !default;\n$purple-900: shade-color($purple, 80%) !default;\n\n$pink-100: tint-color($pink, 80%) !default;\n$pink-200: tint-color($pink, 60%) !default;\n$pink-300: tint-color($pink, 40%) !default;\n$pink-400: tint-color($pink, 20%) !default;\n$pink-500: $pink !default;\n$pink-600: shade-color($pink, 20%) !default;\n$pink-700: shade-color($pink, 40%) !default;\n$pink-800: shade-color($pink, 60%) !default;\n$pink-900: shade-color($pink, 80%) !default;\n\n$red-100: tint-color($red, 80%) !default;\n$red-200: tint-color($red, 60%) !default;\n$red-300: tint-color($red, 40%) !default;\n$red-400: tint-color($red, 20%) !default;\n$red-500: $red !default;\n$red-600: shade-color($red, 20%) !default;\n$red-700: shade-color($red, 40%) !default;\n$red-800: shade-color($red, 60%) !default;\n$red-900: shade-color($red, 80%) !default;\n\n$orange-100: tint-color($orange, 80%) !default;\n$orange-200: tint-color($orange, 60%) !default;\n$orange-300: tint-color($orange, 40%) !default;\n$orange-400: tint-color($orange, 20%) !default;\n$orange-500: $orange !default;\n$orange-600: shade-color($orange, 20%) !default;\n$orange-700: shade-color($orange, 40%) !default;\n$orange-800: shade-color($orange, 60%) !default;\n$orange-900: shade-color($orange, 80%) !default;\n\n$yellow-100: tint-color($yellow, 80%) !default;\n$yellow-200: tint-color($yellow, 60%) !default;\n$yellow-300: tint-color($yellow, 40%) !default;\n$yellow-400: tint-color($yellow, 20%) !default;\n$yellow-500: $yellow !default;\n$yellow-600: shade-color($yellow, 20%) !default;\n$yellow-700: shade-color($yellow, 40%) !default;\n$yellow-800: shade-color($yellow, 60%) !default;\n$yellow-900: shade-color($yellow, 80%) !default;\n\n$green-100: tint-color($green, 80%) !default;\n$green-200: tint-color($green, 60%) !default;\n$green-300: tint-color($green, 40%) !default;\n$green-400: tint-color($green, 20%) !default;\n$green-500: $green !default;\n$green-600: shade-color($green, 20%) !default;\n$green-700: shade-color($green, 40%) !default;\n$green-800: shade-color($green, 60%) !default;\n$green-900: shade-color($green, 80%) !default;\n\n$teal-100: tint-color($teal, 80%) !default;\n$teal-200: tint-color($teal, 60%) !default;\n$teal-300: tint-color($teal, 40%) !default;\n$teal-400: tint-color($teal, 20%) !default;\n$teal-500: $teal !default;\n$teal-600: shade-color($teal, 20%) !default;\n$teal-700: shade-color($teal, 40%) !default;\n$teal-800: shade-color($teal, 60%) !default;\n$teal-900: shade-color($teal, 80%) !default;\n\n$cyan-100: tint-color($cyan, 80%) !default;\n$cyan-200: tint-color($cyan, 60%) !default;\n$cyan-300: tint-color($cyan, 40%) !default;\n$cyan-400: tint-color($cyan, 20%) !default;\n$cyan-500: $cyan !default;\n$cyan-600: shade-color($cyan, 20%) !default;\n$cyan-700: shade-color($cyan, 40%) !default;\n$cyan-800: shade-color($cyan, 60%) !default;\n$cyan-900: shade-color($cyan, 80%) !default;\n\n$blues: (\n  \"blue-100\": $blue-100,\n  \"blue-200\": $blue-200,\n  \"blue-300\": $blue-300,\n  \"blue-400\": $blue-400,\n  \"blue-500\": $blue-500,\n  \"blue-600\": $blue-600,\n  \"blue-700\": $blue-700,\n  \"blue-800\": $blue-800,\n  \"blue-900\": $blue-900\n) !default;\n\n$indigos: (\n  \"indigo-100\": $indigo-100,\n  \"indigo-200\": $indigo-200,\n  \"indigo-300\": $indigo-300,\n  \"indigo-400\": $indigo-400,\n  \"indigo-500\": $indigo-500,\n  \"indigo-600\": $indigo-600,\n  \"indigo-700\": $indigo-700,\n  \"indigo-800\": $indigo-800,\n  \"indigo-900\": $indigo-900\n) !default;\n\n$purples: (\n  \"purple-100\": $purple-100,\n  \"purple-200\": $purple-200,\n  \"purple-300\": $purple-300,\n  \"purple-400\": $purple-400,\n  \"purple-500\": $purple-500,\n  \"purple-600\": $purple-600,\n  \"purple-700\": $purple-700,\n  \"purple-800\": $purple-800,\n  \"purple-900\": $purple-900\n) !default;\n\n$pinks: (\n  \"pink-100\": $pink-100,\n  \"pink-200\": $pink-200,\n  \"pink-300\": $pink-300,\n  \"pink-400\": $pink-400,\n  \"pink-500\": $pink-500,\n  \"pink-600\": $pink-600,\n  \"pink-700\": $pink-700,\n  \"pink-800\": $pink-800,\n  \"pink-900\": $pink-900\n) !default;\n\n$reds: (\n  \"red-100\": $red-100,\n  \"red-200\": $red-200,\n  \"red-300\": $red-300,\n  \"red-400\": $red-400,\n  \"red-500\": $red-500,\n  \"red-600\": $red-600,\n  \"red-700\": $red-700,\n  \"red-800\": $red-800,\n  \"red-900\": $red-900\n) !default;\n\n$oranges: (\n  \"orange-100\": $orange-100,\n  \"orange-200\": $orange-200,\n  \"orange-300\": $orange-300,\n  \"orange-400\": $orange-400,\n  \"orange-500\": $orange-500,\n  \"orange-600\": $orange-600,\n  \"orange-700\": $orange-700,\n  \"orange-800\": $orange-800,\n  \"orange-900\": $orange-900\n) !default;\n\n$yellows: (\n  \"yellow-100\": $yellow-100,\n  \"yellow-200\": $yellow-200,\n  \"yellow-300\": $yellow-300,\n  \"yellow-400\": $yellow-400,\n  \"yellow-500\": $yellow-500,\n  \"yellow-600\": $yellow-600,\n  \"yellow-700\": $yellow-700,\n  \"yellow-800\": $yellow-800,\n  \"yellow-900\": $yellow-900\n) !default;\n\n$greens: (\n  \"green-100\": $green-100,\n  \"green-200\": $green-200,\n  \"green-300\": $green-300,\n  \"green-400\": $green-400,\n  \"green-500\": $green-500,\n  \"green-600\": $green-600,\n  \"green-700\": $green-700,\n  \"green-800\": $green-800,\n  \"green-900\": $green-900\n) !default;\n\n$teals: (\n  \"teal-100\": $teal-100,\n  \"teal-200\": $teal-200,\n  \"teal-300\": $teal-300,\n  \"teal-400\": $teal-400,\n  \"teal-500\": $teal-500,\n  \"teal-600\": $teal-600,\n  \"teal-700\": $teal-700,\n  \"teal-800\": $teal-800,\n  \"teal-900\": $teal-900\n) !default;\n\n$cyans: (\n  \"cyan-100\": $cyan-100,\n  \"cyan-200\": $cyan-200,\n  \"cyan-300\": $cyan-300,\n  \"cyan-400\": $cyan-400,\n  \"cyan-500\": $cyan-500,\n  \"cyan-600\": $cyan-600,\n  \"cyan-700\": $cyan-700,\n  \"cyan-800\": $cyan-800,\n  \"cyan-900\": $cyan-900\n) !default;\n// fusv-enable\n\n// scss-docs-start theme-color-variables\n$primary:       $blue !default;\n$secondary:     $gray-600 !default;\n$success:       $green !default;\n$info:          $cyan !default;\n$warning:       $yellow !default;\n$danger:        $red !default;\n$light:         $gray-100 !default;\n$dark:          $gray-900 !default;\n// scss-docs-end theme-color-variables\n\n// scss-docs-start theme-colors-map\n$theme-colors: (\n  \"primary\":    $primary,\n  \"secondary\":  $secondary,\n  \"success\":    $success,\n  \"info\":       $info,\n  \"warning\":    $warning,\n  \"danger\":     $danger,\n  \"light\":      $light,\n  \"dark\":       $dark\n) !default;\n// scss-docs-end theme-colors-map\n\n// scss-docs-start theme-text-variables\n$primary-text-emphasis:   shade-color($primary, 60%) !default;\n$secondary-text-emphasis: shade-color($secondary, 60%) !default;\n$success-text-emphasis:   shade-color($success, 60%) !default;\n$info-text-emphasis:      shade-color($info, 60%) !default;\n$warning-text-emphasis:   shade-color($warning, 60%) !default;\n$danger-text-emphasis:    shade-color($danger, 60%) !default;\n$light-text-emphasis:     $gray-700 !default;\n$dark-text-emphasis:      $gray-700 !default;\n// scss-docs-end theme-text-variables\n\n// scss-docs-start theme-bg-subtle-variables\n$primary-bg-subtle:       tint-color($primary, 80%) !default;\n$secondary-bg-subtle:     tint-color($secondary, 80%) !default;\n$success-bg-subtle:       tint-color($success, 80%) !default;\n$info-bg-subtle:          tint-color($info, 80%) !default;\n$warning-bg-subtle:       tint-color($warning, 80%) !default;\n$danger-bg-subtle:        tint-color($danger, 80%) !default;\n$light-bg-subtle:         mix($gray-100, $white) !default;\n$dark-bg-subtle:          $gray-400 !default;\n// scss-docs-end theme-bg-subtle-variables\n\n// scss-docs-start theme-border-subtle-variables\n$primary-border-subtle:   tint-color($primary, 60%) !default;\n$secondary-border-subtle: tint-color($secondary, 60%) !default;\n$success-border-subtle:   tint-color($success, 60%) !default;\n$info-border-subtle:      tint-color($info, 60%) !default;\n$warning-border-subtle:   tint-color($warning, 60%) !default;\n$danger-border-subtle:    tint-color($danger, 60%) !default;\n$light-border-subtle:     $gray-200 !default;\n$dark-border-subtle:      $gray-500 !default;\n// scss-docs-end theme-border-subtle-variables\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n) !default;\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                true !default;\n$enable-rounded:              true !default;\n$enable-shadows:              false !default;\n$enable-gradients:            false !default;\n$enable-transitions:          true !default;\n$enable-reduced-motion:       true !default;\n$enable-smooth-scroll:        true !default;\n$enable-grid-classes:         true !default;\n$enable-container-classes:    true !default;\n$enable-cssgrid:              false !default;\n$enable-button-pointers:      true !default;\n$enable-rfs:                  true !default;\n$enable-validation-icons:     true !default;\n$enable-negative-margins:     false !default;\n$enable-deprecation-messages: true !default;\n$enable-important-utilities:  true !default;\n\n$enable-dark-mode:            true !default;\n$color-mode-type:             data !default; // `data` or `media-query`\n\n// Prefix for :root CSS variables\n\n$variable-prefix:             bs- !default; // Deprecated in v5.2.0 for the shorter `$prefix`\n$prefix:                      $variable-prefix !default;\n\n// Gradient\n//\n// The gradient which is added to components if `$enable-gradients` is `true`\n// This gradient is also added to elements with `.bg-gradient`\n// scss-docs-start variable-gradient\n$gradient: linear-gradient(180deg, rgba($white, .15), rgba($white, 0)) !default;\n// scss-docs-end variable-gradient\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n// scss-docs-start spacer-variables-maps\n$spacer: 1rem !default;\n$spacers: (\n  0: 0,\n  1: $spacer * .25,\n  2: $spacer * .5,\n  3: $spacer,\n  4: $spacer * 1.5,\n  5: $spacer * 3,\n) !default;\n// scss-docs-end spacer-variables-maps\n\n// Position\n//\n// Define the edge positioning anchors of the position utilities.\n\n// scss-docs-start position-map\n$position-values: (\n  0: 0,\n  50: 50%,\n  100: 100%\n) !default;\n// scss-docs-end position-map\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-text-align:           null !default;\n$body-color:                $gray-900 !default;\n$body-bg:                   $white !default;\n\n$body-secondary-color:      rgba($body-color, .75) !default;\n$body-secondary-bg:         $gray-200 !default;\n\n$body-tertiary-color:       rgba($body-color, .5) !default;\n$body-tertiary-bg:          $gray-100 !default;\n\n$body-emphasis-color:       $black !default;\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              $primary !default;\n$link-decoration:                         underline !default;\n$link-shade-percentage:                   20% !default;\n$link-hover-color:                        shift-color($link-color, $link-shade-percentage) !default;\n$link-hover-decoration:                   null !default;\n\n$stretched-link-pseudo-element:           after !default;\n$stretched-link-z-index:                  1 !default;\n\n// Icon links\n// scss-docs-start icon-link-variables\n$icon-link-gap:               .375rem !default;\n$icon-link-underline-offset:  .25em !default;\n$icon-link-icon-size:         1em !default;\n$icon-link-icon-transition:   .2s ease-in-out transform !default;\n$icon-link-icon-transform:    translate3d(.25em, 0, 0) !default;\n// scss-docs-end icon-link-variables\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem !default;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n// scss-docs-start grid-breakpoints\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  xxl: 1400px\n) !default;\n// scss-docs-end grid-breakpoints\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n// scss-docs-start container-max-widths\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px,\n  xxl: 1320px\n) !default;\n// scss-docs-end container-max-widths\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12 !default;\n$grid-gutter-width:           1.5rem !default;\n$grid-row-columns:            6 !default;\n\n// Container padding\n\n$container-padding-x: $grid-gutter-width !default;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n// scss-docs-start border-variables\n$border-width:                1px !default;\n$border-widths: (\n  1: 1px,\n  2: 2px,\n  3: 3px,\n  4: 4px,\n  5: 5px\n) !default;\n$border-style:                solid !default;\n$border-color:                $gray-300 !default;\n$border-color-translucent:    rgba($black, .175) !default;\n// scss-docs-end border-variables\n\n// scss-docs-start border-radius-variables\n$border-radius:               .375rem !default;\n$border-radius-sm:            .25rem !default;\n$border-radius-lg:            .5rem !default;\n$border-radius-xl:            1rem !default;\n$border-radius-xxl:           2rem !default;\n$border-radius-pill:          50rem !default;\n// scss-docs-end border-radius-variables\n// fusv-disable\n$border-radius-2xl:           $border-radius-xxl !default; // Deprecated in v5.3.0\n// fusv-enable\n\n// scss-docs-start box-shadow-variables\n$box-shadow:                  0 .5rem 1rem rgba($black, .15) !default;\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075) !default;\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175) !default;\n$box-shadow-inset:            inset 0 1px 2px rgba($black, .075) !default;\n// scss-docs-end box-shadow-variables\n\n$component-active-color:      $white !default;\n$component-active-bg:         $primary !default;\n\n// scss-docs-start focus-ring-variables\n$focus-ring-width:      .25rem !default;\n$focus-ring-opacity:    .25 !default;\n$focus-ring-color:      rgba($primary, $focus-ring-opacity) !default;\n$focus-ring-blur:       0 !default;\n$focus-ring-box-shadow: 0 0 $focus-ring-blur $focus-ring-width $focus-ring-color !default;\n// scss-docs-end focus-ring-variables\n\n// scss-docs-start caret-variables\n$caret-width:                 .3em !default;\n$caret-vertical-align:        $caret-width * .85 !default;\n$caret-spacing:               $caret-width * .85 !default;\n// scss-docs-end caret-variables\n\n$transition-base:             all .2s ease-in-out !default;\n$transition-fade:             opacity .15s linear !default;\n// scss-docs-start collapse-transition\n$transition-collapse:         height .35s ease !default;\n$transition-collapse-width:   width .35s ease !default;\n// scss-docs-end collapse-transition\n\n// stylelint-disable function-disallowed-list\n// scss-docs-start aspect-ratios\n$aspect-ratios: (\n  \"1x1\": 100%,\n  \"4x3\": calc(3 / 4 * 100%),\n  \"16x9\": calc(9 / 16 * 100%),\n  \"21x9\": calc(9 / 21 * 100%)\n) !default;\n// scss-docs-end aspect-ratios\n// stylelint-enable function-disallowed-list\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// scss-docs-start font-variables\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\n// stylelint-enable value-keyword-case\n$font-family-base:            var(--#{$prefix}font-sans-serif) !default;\n$font-family-code:            var(--#{$prefix}font-monospace) !default;\n\n// $font-size-root affects the value of `rem`, which is used for as well font sizes, paddings, and margins\n// $font-size-base affects the font size of the body text\n$font-size-root:              null !default;\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\n$font-size-sm:                $font-size-base * .875 !default;\n$font-size-lg:                $font-size-base * 1.25 !default;\n\n$font-weight-lighter:         lighter !default;\n$font-weight-light:           300 !default;\n$font-weight-normal:          400 !default;\n$font-weight-medium:          500 !default;\n$font-weight-semibold:        600 !default;\n$font-weight-bold:            700 !default;\n$font-weight-bolder:          bolder !default;\n\n$font-weight-base:            $font-weight-normal !default;\n\n$line-height-base:            1.5 !default;\n$line-height-sm:              1.25 !default;\n$line-height-lg:              2 !default;\n\n$h1-font-size:                $font-size-base * 2.5 !default;\n$h2-font-size:                $font-size-base * 2 !default;\n$h3-font-size:                $font-size-base * 1.75 !default;\n$h4-font-size:                $font-size-base * 1.5 !default;\n$h5-font-size:                $font-size-base * 1.25 !default;\n$h6-font-size:                $font-size-base !default;\n// scss-docs-end font-variables\n\n// scss-docs-start font-sizes\n$font-sizes: (\n  1: $h1-font-size,\n  2: $h2-font-size,\n  3: $h3-font-size,\n  4: $h4-font-size,\n  5: $h5-font-size,\n  6: $h6-font-size\n) !default;\n// scss-docs-end font-sizes\n\n// scss-docs-start headings-variables\n$headings-margin-bottom:      $spacer * .5 !default;\n$headings-font-family:        null !default;\n$headings-font-style:         null !default;\n$headings-font-weight:        500 !default;\n$headings-line-height:        1.2 !default;\n$headings-color:              inherit !default;\n// scss-docs-end headings-variables\n\n// scss-docs-start display-headings\n$display-font-sizes: (\n  1: 5rem,\n  2: 4.5rem,\n  3: 4rem,\n  4: 3.5rem,\n  5: 3rem,\n  6: 2.5rem\n) !default;\n\n$display-font-family: null !default;\n$display-font-style:  null !default;\n$display-font-weight: 300 !default;\n$display-line-height: $headings-line-height !default;\n// scss-docs-end display-headings\n\n// scss-docs-start type-variables\n$lead-font-size:              $font-size-base * 1.25 !default;\n$lead-font-weight:            300 !default;\n\n$small-font-size:             .875em !default;\n\n$sub-sup-font-size:           .75em !default;\n\n// fusv-disable\n$text-muted:                  var(--#{$prefix}secondary-color) !default; // Deprecated in 5.3.0\n// fusv-enable\n\n$initialism-font-size:        $small-font-size !default;\n\n$blockquote-margin-y:         $spacer !default;\n$blockquote-font-size:        $font-size-base * 1.25 !default;\n$blockquote-footer-color:     $gray-600 !default;\n$blockquote-footer-font-size: $small-font-size !default;\n\n$hr-margin-y:                 $spacer !default;\n$hr-color:                    inherit !default;\n\n// fusv-disable\n$hr-bg-color:                 null !default; // Deprecated in v5.2.0\n$hr-height:                   null !default; // Deprecated in v5.2.0\n// fusv-enable\n\n$hr-border-color:             null !default; // Allows for inherited colors\n$hr-border-width:             var(--#{$prefix}border-width) !default;\n$hr-opacity:                  .25 !default;\n\n// scss-docs-start vr-variables\n$vr-border-width:             var(--#{$prefix}border-width) !default;\n// scss-docs-end vr-variables\n\n$legend-margin-bottom:        .5rem !default;\n$legend-font-size:            1.5rem !default;\n$legend-font-weight:          null !default;\n\n$dt-font-weight:              $font-weight-bold !default;\n\n$list-inline-padding:         .5rem !default;\n\n$mark-padding:                .1875em !default;\n$mark-color:                  $body-color !default;\n$mark-bg:                     $yellow-100 !default;\n// scss-docs-end type-variables\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n// scss-docs-start table-variables\n$table-cell-padding-y:        .5rem !default;\n$table-cell-padding-x:        .5rem !default;\n$table-cell-padding-y-sm:     .25rem !default;\n$table-cell-padding-x-sm:     .25rem !default;\n\n$table-cell-vertical-align:   top !default;\n\n$table-color:                 var(--#{$prefix}emphasis-color) !default;\n$table-bg:                    var(--#{$prefix}body-bg) !default;\n$table-accent-bg:             transparent !default;\n\n$table-th-font-weight:        null !default;\n\n$table-striped-color:         $table-color !default;\n$table-striped-bg-factor:     .05 !default;\n$table-striped-bg:            rgba(var(--#{$prefix}emphasis-color-rgb), $table-striped-bg-factor) !default;\n\n$table-active-color:          $table-color !default;\n$table-active-bg-factor:      .1 !default;\n$table-active-bg:             rgba(var(--#{$prefix}emphasis-color-rgb), $table-active-bg-factor) !default;\n\n$table-hover-color:           $table-color !default;\n$table-hover-bg-factor:       .075 !default;\n$table-hover-bg:              rgba(var(--#{$prefix}emphasis-color-rgb), $table-hover-bg-factor) !default;\n\n$table-border-factor:         .2 !default;\n$table-border-width:          var(--#{$prefix}border-width) !default;\n$table-border-color:          var(--#{$prefix}border-color) !default;\n\n$table-striped-order:         odd !default;\n$table-striped-columns-order: even !default;\n\n$table-group-separator-color: currentcolor !default;\n\n$table-caption-color:         var(--#{$prefix}secondary-color) !default;\n\n$table-bg-scale:              -80% !default;\n// scss-docs-end table-variables\n\n// scss-docs-start table-loop\n$table-variants: (\n  \"primary\":    shift-color($primary, $table-bg-scale),\n  \"secondary\":  shift-color($secondary, $table-bg-scale),\n  \"success\":    shift-color($success, $table-bg-scale),\n  \"info\":       shift-color($info, $table-bg-scale),\n  \"warning\":    shift-color($warning, $table-bg-scale),\n  \"danger\":     shift-color($danger, $table-bg-scale),\n  \"light\":      $light,\n  \"dark\":       $dark,\n) !default;\n// scss-docs-end table-loop\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n// scss-docs-start input-btn-variables\n$input-btn-padding-y:         .375rem !default;\n$input-btn-padding-x:         .75rem !default;\n$input-btn-font-family:       null !default;\n$input-btn-font-size:         $font-size-base !default;\n$input-btn-line-height:       $line-height-base !default;\n\n$input-btn-focus-width:         $focus-ring-width !default;\n$input-btn-focus-color-opacity: $focus-ring-opacity !default;\n$input-btn-focus-color:         $focus-ring-color !default;\n$input-btn-focus-blur:          $focus-ring-blur !default;\n$input-btn-focus-box-shadow:    $focus-ring-box-shadow !default;\n\n$input-btn-padding-y-sm:      .25rem !default;\n$input-btn-padding-x-sm:      .5rem !default;\n$input-btn-font-size-sm:      $font-size-sm !default;\n\n$input-btn-padding-y-lg:      .5rem !default;\n$input-btn-padding-x-lg:      1rem !default;\n$input-btn-font-size-lg:      $font-size-lg !default;\n\n$input-btn-border-width:      var(--#{$prefix}border-width) !default;\n// scss-docs-end input-btn-variables\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n// scss-docs-start btn-variables\n$btn-color:                   var(--#{$prefix}body-color) !default;\n$btn-padding-y:               $input-btn-padding-y !default;\n$btn-padding-x:               $input-btn-padding-x !default;\n$btn-font-family:             $input-btn-font-family !default;\n$btn-font-size:               $input-btn-font-size !default;\n$btn-line-height:             $input-btn-line-height !default;\n$btn-white-space:             null !default; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\n$btn-font-size-sm:            $input-btn-font-size-sm !default;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\n$btn-font-size-lg:            $input-btn-font-size-lg !default;\n\n$btn-border-width:            $input-btn-border-width !default;\n\n$btn-font-weight:             $font-weight-normal !default;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\n$btn-focus-width:             $input-btn-focus-width !default;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow !default;\n$btn-disabled-opacity:        .65 !default;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125) !default;\n\n$btn-link-color:              var(--#{$prefix}link-color) !default;\n$btn-link-hover-color:        var(--#{$prefix}link-hover-color) !default;\n$btn-link-disabled-color:     $gray-600 !default;\n$btn-link-focus-shadow-rgb:   to-rgb(mix(color-contrast($link-color), $link-color, 15%)) !default;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           var(--#{$prefix}border-radius) !default;\n$btn-border-radius-sm:        var(--#{$prefix}border-radius-sm) !default;\n$btn-border-radius-lg:        var(--#{$prefix}border-radius-lg) !default;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$btn-hover-bg-shade-amount:       15% !default;\n$btn-hover-bg-tint-amount:        15% !default;\n$btn-hover-border-shade-amount:   20% !default;\n$btn-hover-border-tint-amount:    10% !default;\n$btn-active-bg-shade-amount:      20% !default;\n$btn-active-bg-tint-amount:       20% !default;\n$btn-active-border-shade-amount:  25% !default;\n$btn-active-border-tint-amount:   10% !default;\n// scss-docs-end btn-variables\n\n\n// Forms\n\n// scss-docs-start form-text-variables\n$form-text-margin-top:                  .25rem !default;\n$form-text-font-size:                   $small-font-size !default;\n$form-text-font-style:                  null !default;\n$form-text-font-weight:                 null !default;\n$form-text-color:                       var(--#{$prefix}secondary-color) !default;\n// scss-docs-end form-text-variables\n\n// scss-docs-start form-label-variables\n$form-label-margin-bottom:              .5rem !default;\n$form-label-font-size:                  null !default;\n$form-label-font-style:                 null !default;\n$form-label-font-weight:                null !default;\n$form-label-color:                      null !default;\n// scss-docs-end form-label-variables\n\n// scss-docs-start form-input-variables\n$input-padding-y:                       $input-btn-padding-y !default;\n$input-padding-x:                       $input-btn-padding-x !default;\n$input-font-family:                     $input-btn-font-family !default;\n$input-font-size:                       $input-btn-font-size !default;\n$input-font-weight:                     $font-weight-base !default;\n$input-line-height:                     $input-btn-line-height !default;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n$input-font-size-sm:                    $input-btn-font-size-sm !default;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n$input-font-size-lg:                    $input-btn-font-size-lg !default;\n\n$input-bg:                              var(--#{$prefix}body-bg) !default;\n$input-disabled-color:                  null !default;\n$input-disabled-bg:                     var(--#{$prefix}secondary-bg) !default;\n$input-disabled-border-color:           null !default;\n\n$input-color:                           var(--#{$prefix}body-color) !default;\n$input-border-color:                    var(--#{$prefix}border-color) !default;\n$input-border-width:                    $input-btn-border-width !default;\n$input-box-shadow:                      var(--#{$prefix}box-shadow-inset) !default;\n\n$input-border-radius:                   var(--#{$prefix}border-radius) !default;\n$input-border-radius-sm:                var(--#{$prefix}border-radius-sm) !default;\n$input-border-radius-lg:                var(--#{$prefix}border-radius-lg) !default;\n\n$input-focus-bg:                        $input-bg !default;\n$input-focus-border-color:              tint-color($component-active-bg, 50%) !default;\n$input-focus-color:                     $input-color !default;\n$input-focus-width:                     $input-btn-focus-width !default;\n$input-focus-box-shadow:                $input-btn-focus-box-shadow !default;\n\n$input-placeholder-color:               var(--#{$prefix}secondary-color) !default;\n$input-plaintext-color:                 var(--#{$prefix}body-color) !default;\n\n$input-height-border:                   calc(#{$input-border-width} * 2) !default; // stylelint-disable-line function-disallowed-list\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2) !default;\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y) !default;\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5) !default;\n\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false)) !default;\n$input-height-sm:                       add($input-line-height * 1em, add($input-padding-y-sm * 2, $input-height-border, false)) !default;\n$input-height-lg:                       add($input-line-height * 1em, add($input-padding-y-lg * 2, $input-height-border, false)) !default;\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$form-color-width:                      3rem !default;\n// scss-docs-end form-input-variables\n\n// scss-docs-start form-check-variables\n$form-check-input-width:                  1em !default;\n$form-check-min-height:                   $font-size-base * $line-height-base !default;\n$form-check-padding-start:                $form-check-input-width + .5em !default;\n$form-check-margin-bottom:                .125rem !default;\n$form-check-label-color:                  null !default;\n$form-check-label-cursor:                 null !default;\n$form-check-transition:                   null !default;\n\n$form-check-input-active-filter:          brightness(90%) !default;\n\n$form-check-input-bg:                     $input-bg !default;\n$form-check-input-border:                 var(--#{$prefix}border-width) solid var(--#{$prefix}border-color) !default;\n$form-check-input-border-radius:          .25em !default;\n$form-check-radio-border-radius:          50% !default;\n$form-check-input-focus-border:           $input-focus-border-color !default;\n$form-check-input-focus-box-shadow:       $focus-ring-box-shadow !default;\n\n$form-check-input-checked-color:          $component-active-color !default;\n$form-check-input-checked-bg-color:       $component-active-bg !default;\n$form-check-input-checked-border-color:   $form-check-input-checked-bg-color !default;\n$form-check-input-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-checked-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/></svg>\") !default;\n$form-check-radio-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='#{$form-check-input-checked-color}'/></svg>\") !default;\n\n$form-check-input-indeterminate-color:          $component-active-color !default;\n$form-check-input-indeterminate-bg-color:       $component-active-bg !default;\n$form-check-input-indeterminate-border-color:   $form-check-input-indeterminate-bg-color !default;\n$form-check-input-indeterminate-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-indeterminate-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/></svg>\") !default;\n\n$form-check-input-disabled-opacity:        .5 !default;\n$form-check-label-disabled-opacity:        $form-check-input-disabled-opacity !default;\n$form-check-btn-check-disabled-opacity:    $btn-disabled-opacity !default;\n\n$form-check-inline-margin-end:    1rem !default;\n// scss-docs-end form-check-variables\n\n// scss-docs-start form-switch-variables\n$form-switch-color:               rgba($black, .25) !default;\n$form-switch-width:               2em !default;\n$form-switch-padding-start:       $form-switch-width + .5em !default;\n$form-switch-bg-image:            url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color}'/></svg>\") !default;\n$form-switch-border-radius:       $form-switch-width !default;\n$form-switch-transition:          background-position .15s ease-in-out !default;\n\n$form-switch-focus-color:         $input-focus-border-color !default;\n$form-switch-focus-bg-image:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color}'/></svg>\") !default;\n\n$form-switch-checked-color:       $component-active-color !default;\n$form-switch-checked-bg-image:    url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color}'/></svg>\") !default;\n$form-switch-checked-bg-position: right center !default;\n// scss-docs-end form-switch-variables\n\n// scss-docs-start input-group-variables\n$input-group-addon-padding-y:           $input-padding-y !default;\n$input-group-addon-padding-x:           $input-padding-x !default;\n$input-group-addon-font-weight:         $input-font-weight !default;\n$input-group-addon-color:               $input-color !default;\n$input-group-addon-bg:                  var(--#{$prefix}tertiary-bg) !default;\n$input-group-addon-border-color:        $input-border-color !default;\n// scss-docs-end input-group-variables\n\n// scss-docs-start form-select-variables\n$form-select-padding-y:             $input-padding-y !default;\n$form-select-padding-x:             $input-padding-x !default;\n$form-select-font-family:           $input-font-family !default;\n$form-select-font-size:             $input-font-size !default;\n$form-select-indicator-padding:     $form-select-padding-x * 3 !default; // Extra padding for background-image\n$form-select-font-weight:           $input-font-weight !default;\n$form-select-line-height:           $input-line-height !default;\n$form-select-color:                 $input-color !default;\n$form-select-bg:                    $input-bg !default;\n$form-select-disabled-color:        null !default;\n$form-select-disabled-bg:           $input-disabled-bg !default;\n$form-select-disabled-border-color: $input-disabled-border-color !default;\n$form-select-bg-position:           right $form-select-padding-x center !default;\n$form-select-bg-size:               16px 12px !default; // In pixels because image dimensions\n$form-select-indicator-color:       $gray-800 !default;\n$form-select-indicator:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/></svg>\") !default;\n\n$form-select-feedback-icon-padding-end: $form-select-padding-x * 2.5 + $form-select-indicator-padding !default;\n$form-select-feedback-icon-position:    center right $form-select-indicator-padding !default;\n$form-select-feedback-icon-size:        $input-height-inner-half $input-height-inner-half !default;\n\n$form-select-border-width:        $input-border-width !default;\n$form-select-border-color:        $input-border-color !default;\n$form-select-border-radius:       $input-border-radius !default;\n$form-select-box-shadow:          var(--#{$prefix}box-shadow-inset) !default;\n\n$form-select-focus-border-color:  $input-focus-border-color !default;\n$form-select-focus-width:         $input-focus-width !default;\n$form-select-focus-box-shadow:    0 0 0 $form-select-focus-width $input-btn-focus-color !default;\n\n$form-select-padding-y-sm:        $input-padding-y-sm !default;\n$form-select-padding-x-sm:        $input-padding-x-sm !default;\n$form-select-font-size-sm:        $input-font-size-sm !default;\n$form-select-border-radius-sm:    $input-border-radius-sm !default;\n\n$form-select-padding-y-lg:        $input-padding-y-lg !default;\n$form-select-padding-x-lg:        $input-padding-x-lg !default;\n$form-select-font-size-lg:        $input-font-size-lg !default;\n$form-select-border-radius-lg:    $input-border-radius-lg !default;\n\n$form-select-transition:          $input-transition !default;\n// scss-docs-end form-select-variables\n\n// scss-docs-start form-range-variables\n$form-range-track-width:          100% !default;\n$form-range-track-height:         .5rem !default;\n$form-range-track-cursor:         pointer !default;\n$form-range-track-bg:             var(--#{$prefix}secondary-bg) !default;\n$form-range-track-border-radius:  1rem !default;\n$form-range-track-box-shadow:     var(--#{$prefix}box-shadow-inset) !default;\n\n$form-range-thumb-width:                   1rem !default;\n$form-range-thumb-height:                  $form-range-thumb-width !default;\n$form-range-thumb-bg:                      $component-active-bg !default;\n$form-range-thumb-border:                  0 !default;\n$form-range-thumb-border-radius:           1rem !default;\n$form-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\n$form-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow !default;\n$form-range-thumb-focus-box-shadow-width:  $input-focus-width !default; // For focus box shadow issue in Edge\n$form-range-thumb-active-bg:               tint-color($component-active-bg, 70%) !default;\n$form-range-thumb-disabled-bg:             var(--#{$prefix}secondary-color) !default;\n$form-range-thumb-transition:              background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n// scss-docs-end form-range-variables\n\n// scss-docs-start form-file-variables\n$form-file-button-color:          $input-color !default;\n$form-file-button-bg:             var(--#{$prefix}tertiary-bg) !default;\n$form-file-button-hover-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end form-file-variables\n\n// scss-docs-start form-floating-variables\n$form-floating-height:                  add(3.5rem, $input-height-border) !default;\n$form-floating-line-height:             1.25 !default;\n$form-floating-padding-x:               $input-padding-x !default;\n$form-floating-padding-y:               1rem !default;\n$form-floating-input-padding-t:         1.625rem !default;\n$form-floating-input-padding-b:         .625rem !default;\n$form-floating-label-height:            1.5em !default;\n$form-floating-label-opacity:           .65 !default;\n$form-floating-label-transform:         scale(.85) translateY(-.5rem) translateX(.15rem) !default;\n$form-floating-label-disabled-color:    $gray-600 !default;\n$form-floating-transition:              opacity .1s ease-in-out, transform .1s ease-in-out !default;\n// scss-docs-end form-floating-variables\n\n// Form validation\n\n// scss-docs-start form-feedback-variables\n$form-feedback-margin-top:          $form-text-margin-top !default;\n$form-feedback-font-size:           $form-text-font-size !default;\n$form-feedback-font-style:          $form-text-font-style !default;\n$form-feedback-valid-color:         $success !default;\n$form-feedback-invalid-color:       $danger !default;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color !default;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1'/></svg>\") !default;\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color !default;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\") !default;\n// scss-docs-end form-feedback-variables\n\n// scss-docs-start form-validation-colors\n$form-valid-color:                  $form-feedback-valid-color !default;\n$form-valid-border-color:           $form-feedback-valid-color !default;\n$form-invalid-color:                $form-feedback-invalid-color !default;\n$form-invalid-border-color:         $form-feedback-invalid-color !default;\n// scss-docs-end form-validation-colors\n\n// scss-docs-start form-validation-states\n$form-validation-states: (\n  \"valid\": (\n    \"color\": var(--#{$prefix}form-valid-color),\n    \"icon\": $form-feedback-icon-valid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}success),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}success-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-valid-border-color),\n  ),\n  \"invalid\": (\n    \"color\": var(--#{$prefix}form-invalid-color),\n    \"icon\": $form-feedback-icon-invalid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}danger),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}danger-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-invalid-border-color),\n  )\n) !default;\n// scss-docs-end form-validation-states\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n// scss-docs-start zindex-stack\n$zindex-dropdown:                   1000 !default;\n$zindex-sticky:                     1020 !default;\n$zindex-fixed:                      1030 !default;\n$zindex-offcanvas-backdrop:         1040 !default;\n$zindex-offcanvas:                  1045 !default;\n$zindex-modal-backdrop:             1050 !default;\n$zindex-modal:                      1055 !default;\n$zindex-popover:                    1070 !default;\n$zindex-tooltip:                    1080 !default;\n$zindex-toast:                      1090 !default;\n// scss-docs-end zindex-stack\n\n// scss-docs-start zindex-levels-map\n$zindex-levels: (\n  n1: -1,\n  0: 0,\n  1: 1,\n  2: 2,\n  3: 3\n) !default;\n// scss-docs-end zindex-levels-map\n\n\n// Navs\n\n// scss-docs-start nav-variables\n$nav-link-padding-y:                .5rem !default;\n$nav-link-padding-x:                1rem !default;\n$nav-link-font-size:                null !default;\n$nav-link-font-weight:              null !default;\n$nav-link-color:                    var(--#{$prefix}link-color) !default;\n$nav-link-hover-color:              var(--#{$prefix}link-hover-color) !default;\n$nav-link-transition:               color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out !default;\n$nav-link-disabled-color:           var(--#{$prefix}secondary-color) !default;\n$nav-link-focus-box-shadow:         $focus-ring-box-shadow !default;\n\n$nav-tabs-border-color:             var(--#{$prefix}border-color) !default;\n$nav-tabs-border-width:             var(--#{$prefix}border-width) !default;\n$nav-tabs-border-radius:            var(--#{$prefix}border-radius) !default;\n$nav-tabs-link-hover-border-color:  var(--#{$prefix}secondary-bg) var(--#{$prefix}secondary-bg) $nav-tabs-border-color !default;\n$nav-tabs-link-active-color:        var(--#{$prefix}emphasis-color) !default;\n$nav-tabs-link-active-bg:           var(--#{$prefix}body-bg) !default;\n$nav-tabs-link-active-border-color: var(--#{$prefix}border-color) var(--#{$prefix}border-color) $nav-tabs-link-active-bg !default;\n\n$nav-pills-border-radius:           var(--#{$prefix}border-radius) !default;\n$nav-pills-link-active-color:       $component-active-color !default;\n$nav-pills-link-active-bg:          $component-active-bg !default;\n\n$nav-underline-gap:                 1rem !default;\n$nav-underline-border-width:        .125rem !default;\n$nav-underline-link-active-color:   var(--#{$prefix}emphasis-color) !default;\n// scss-docs-end nav-variables\n\n\n// Navbar\n\n// scss-docs-start navbar-variables\n$navbar-padding-y:                  $spacer * .5 !default;\n$navbar-padding-x:                  null !default;\n\n$navbar-nav-link-padding-x:         .5rem !default;\n\n$navbar-brand-font-size:            $font-size-lg !default;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base !default;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * .5 !default;\n$navbar-brand-margin-end:           1rem !default;\n\n$navbar-toggler-padding-y:          .25rem !default;\n$navbar-toggler-padding-x:          .75rem !default;\n$navbar-toggler-font-size:          $font-size-lg !default;\n$navbar-toggler-border-radius:      $btn-border-radius !default;\n$navbar-toggler-focus-width:        $btn-focus-width !default;\n$navbar-toggler-transition:         box-shadow .15s ease-in-out !default;\n\n$navbar-light-color:                rgba(var(--#{$prefix}emphasis-color-rgb), .65) !default;\n$navbar-light-hover-color:          rgba(var(--#{$prefix}emphasis-color-rgb), .8) !default;\n$navbar-light-active-color:         rgba(var(--#{$prefix}emphasis-color-rgb), 1) !default;\n$navbar-light-disabled-color:       rgba(var(--#{$prefix}emphasis-color-rgb), .3) !default;\n$navbar-light-icon-color:           rgba($body-color, .75) !default;\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-light-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-light-toggler-border-color: rgba(var(--#{$prefix}emphasis-color-rgb), .15) !default;\n$navbar-light-brand-color:          $navbar-light-active-color !default;\n$navbar-light-brand-hover-color:    $navbar-light-active-color !default;\n// scss-docs-end navbar-variables\n\n// scss-docs-start navbar-dark-variables\n$navbar-dark-color:                 rgba($white, .55) !default;\n$navbar-dark-hover-color:           rgba($white, .75) !default;\n$navbar-dark-active-color:          $white !default;\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\n$navbar-dark-icon-color:            $navbar-dark-color !default;\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-dark-toggler-border-color:  rgba($white, .1) !default;\n$navbar-dark-brand-color:           $navbar-dark-active-color !default;\n$navbar-dark-brand-hover-color:     $navbar-dark-active-color !default;\n// scss-docs-end navbar-dark-variables\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n// scss-docs-start dropdown-variables\n$dropdown-min-width:                10rem !default;\n$dropdown-padding-x:                0 !default;\n$dropdown-padding-y:                .5rem !default;\n$dropdown-spacer:                   .125rem !default;\n$dropdown-font-size:                $font-size-base !default;\n$dropdown-color:                    var(--#{$prefix}body-color) !default;\n$dropdown-bg:                       var(--#{$prefix}body-bg) !default;\n$dropdown-border-color:             var(--#{$prefix}border-color-translucent) !default;\n$dropdown-border-radius:            var(--#{$prefix}border-radius) !default;\n$dropdown-border-width:             var(--#{$prefix}border-width) !default;\n$dropdown-inner-border-radius:      calc(#{$dropdown-border-radius} - #{$dropdown-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$dropdown-divider-bg:               $dropdown-border-color !default;\n$dropdown-divider-margin-y:         $spacer * .5 !default;\n$dropdown-box-shadow:               var(--#{$prefix}box-shadow) !default;\n\n$dropdown-link-color:               var(--#{$prefix}body-color) !default;\n$dropdown-link-hover-color:         $dropdown-link-color !default;\n$dropdown-link-hover-bg:            var(--#{$prefix}tertiary-bg) !default;\n\n$dropdown-link-active-color:        $component-active-color !default;\n$dropdown-link-active-bg:           $component-active-bg !default;\n\n$dropdown-link-disabled-color:      var(--#{$prefix}tertiary-color) !default;\n\n$dropdown-item-padding-y:           $spacer * .25 !default;\n$dropdown-item-padding-x:           $spacer !default;\n\n$dropdown-header-color:             $gray-600 !default;\n$dropdown-header-padding-x:         $dropdown-item-padding-x !default;\n$dropdown-header-padding-y:         $dropdown-padding-y !default;\n// fusv-disable\n$dropdown-header-padding:           $dropdown-header-padding-y $dropdown-header-padding-x !default; // Deprecated in v5.2.0\n// fusv-enable\n// scss-docs-end dropdown-variables\n\n// scss-docs-start dropdown-dark-variables\n$dropdown-dark-color:               $gray-300 !default;\n$dropdown-dark-bg:                  $gray-800 !default;\n$dropdown-dark-border-color:        $dropdown-border-color !default;\n$dropdown-dark-divider-bg:          $dropdown-divider-bg !default;\n$dropdown-dark-box-shadow:          null !default;\n$dropdown-dark-link-color:          $dropdown-dark-color !default;\n$dropdown-dark-link-hover-color:    $white !default;\n$dropdown-dark-link-hover-bg:       rgba($white, .15) !default;\n$dropdown-dark-link-active-color:   $dropdown-link-active-color !default;\n$dropdown-dark-link-active-bg:      $dropdown-link-active-bg !default;\n$dropdown-dark-link-disabled-color: $gray-500 !default;\n$dropdown-dark-header-color:        $gray-500 !default;\n// scss-docs-end dropdown-dark-variables\n\n\n// Pagination\n\n// scss-docs-start pagination-variables\n$pagination-padding-y:              .375rem !default;\n$pagination-padding-x:              .75rem !default;\n$pagination-padding-y-sm:           .25rem !default;\n$pagination-padding-x-sm:           .5rem !default;\n$pagination-padding-y-lg:           .75rem !default;\n$pagination-padding-x-lg:           1.5rem !default;\n\n$pagination-font-size:              $font-size-base !default;\n\n$pagination-color:                  var(--#{$prefix}link-color) !default;\n$pagination-bg:                     var(--#{$prefix}body-bg) !default;\n$pagination-border-radius:          var(--#{$prefix}border-radius) !default;\n$pagination-border-width:           var(--#{$prefix}border-width) !default;\n$pagination-margin-start:           calc(-1 * #{$pagination-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$pagination-border-color:           var(--#{$prefix}border-color) !default;\n\n$pagination-focus-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-focus-bg:               var(--#{$prefix}secondary-bg) !default;\n$pagination-focus-box-shadow:       $focus-ring-box-shadow !default;\n$pagination-focus-outline:          0 !default;\n\n$pagination-hover-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$pagination-hover-border-color:     var(--#{$prefix}border-color) !default; // Todo in v6: remove this?\n\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $component-active-bg !default;\n\n$pagination-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$pagination-disabled-bg:            var(--#{$prefix}secondary-bg) !default;\n$pagination-disabled-border-color:  var(--#{$prefix}border-color) !default;\n\n$pagination-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$pagination-border-radius-sm:       var(--#{$prefix}border-radius-sm) !default;\n$pagination-border-radius-lg:       var(--#{$prefix}border-radius-lg) !default;\n// scss-docs-end pagination-variables\n\n\n// Placeholders\n\n// scss-docs-start placeholders\n$placeholder-opacity-max:           .5 !default;\n$placeholder-opacity-min:           .2 !default;\n// scss-docs-end placeholders\n\n// Cards\n\n// scss-docs-start card-variables\n$card-spacer-y:                     $spacer !default;\n$card-spacer-x:                     $spacer !default;\n$card-title-spacer-y:               $spacer * .5 !default;\n$card-title-color:                  null !default;\n$card-subtitle-color:               null !default;\n$card-border-width:                 var(--#{$prefix}border-width) !default;\n$card-border-color:                 var(--#{$prefix}border-color-translucent) !default;\n$card-border-radius:                var(--#{$prefix}border-radius) !default;\n$card-box-shadow:                   null !default;\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width) !default;\n$card-cap-padding-y:                $card-spacer-y * .5 !default;\n$card-cap-padding-x:                $card-spacer-x !default;\n$card-cap-bg:                       rgba(var(--#{$prefix}body-color-rgb), .03) !default;\n$card-cap-color:                    null !default;\n$card-height:                       null !default;\n$card-color:                        null !default;\n$card-bg:                           var(--#{$prefix}body-bg) !default;\n$card-img-overlay-padding:          $spacer !default;\n$card-group-margin:                 $grid-gutter-width * .5 !default;\n// scss-docs-end card-variables\n\n// Accordion\n\n// scss-docs-start accordion-variables\n$accordion-padding-y:                     1rem !default;\n$accordion-padding-x:                     1.25rem !default;\n$accordion-color:                         var(--#{$prefix}body-color) !default;\n$accordion-bg:                            var(--#{$prefix}body-bg) !default;\n$accordion-border-width:                  var(--#{$prefix}border-width) !default;\n$accordion-border-color:                  var(--#{$prefix}border-color) !default;\n$accordion-border-radius:                 var(--#{$prefix}border-radius) !default;\n$accordion-inner-border-radius:           subtract($accordion-border-radius, $accordion-border-width) !default;\n\n$accordion-body-padding-y:                $accordion-padding-y !default;\n$accordion-body-padding-x:                $accordion-padding-x !default;\n\n$accordion-button-padding-y:              $accordion-padding-y !default;\n$accordion-button-padding-x:              $accordion-padding-x !default;\n$accordion-button-color:                  var(--#{$prefix}body-color) !default;\n$accordion-button-bg:                     var(--#{$prefix}accordion-bg) !default;\n$accordion-transition:                    $btn-transition, border-radius .15s ease !default;\n$accordion-button-active-bg:              var(--#{$prefix}primary-bg-subtle) !default;\n$accordion-button-active-color:           var(--#{$prefix}primary-text-emphasis) !default;\n\n// fusv-disable\n$accordion-button-focus-border-color:     $input-focus-border-color !default; // Deprecated in v5.3.3\n// fusv-enable\n$accordion-button-focus-box-shadow:       $btn-focus-box-shadow !default;\n\n$accordion-icon-width:                    1.25rem !default;\n$accordion-icon-color:                    $body-color !default;\n$accordion-icon-active-color:             $primary-text-emphasis !default;\n$accordion-icon-transition:               transform .2s ease-in-out !default;\n$accordion-icon-transform:                rotate(-180deg) !default;\n\n$accordion-button-icon:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='#{$accordion-icon-color}' stroke-linecap='round' stroke-linejoin='round'><path d='m2 5 6 6 6-6'/></svg>\") !default;\n$accordion-button-active-icon:  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='#{$accordion-icon-active-color}' stroke-linecap='round' stroke-linejoin='round'><path d='m2 5 6 6 6-6'/></svg>\") !default;\n// scss-docs-end accordion-variables\n\n// Tooltips\n\n// scss-docs-start tooltip-variables\n$tooltip-font-size:                 $font-size-sm !default;\n$tooltip-max-width:                 200px !default;\n$tooltip-color:                     var(--#{$prefix}body-bg) !default;\n$tooltip-bg:                        var(--#{$prefix}emphasis-color) !default;\n$tooltip-border-radius:             var(--#{$prefix}border-radius) !default;\n$tooltip-opacity:                   .9 !default;\n$tooltip-padding-y:                 $spacer * .25 !default;\n$tooltip-padding-x:                 $spacer * .5 !default;\n$tooltip-margin:                    null !default; // TODO: remove this in v6\n\n$tooltip-arrow-width:               .8rem !default;\n$tooltip-arrow-height:              .4rem !default;\n// fusv-disable\n$tooltip-arrow-color:               null !default; // Deprecated in Bootstrap 5.2.0 for CSS variables\n// fusv-enable\n// scss-docs-end tooltip-variables\n\n// Form tooltips must come after regular tooltips\n// scss-docs-start tooltip-feedback-variables\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y !default;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x !default;\n$form-feedback-tooltip-font-size:     $tooltip-font-size !default;\n$form-feedback-tooltip-line-height:   null !default;\n$form-feedback-tooltip-opacity:       $tooltip-opacity !default;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius !default;\n// scss-docs-end tooltip-feedback-variables\n\n\n// Popovers\n\n// scss-docs-start popover-variables\n$popover-font-size:                 $font-size-sm !default;\n$popover-bg:                        var(--#{$prefix}body-bg) !default;\n$popover-max-width:                 276px !default;\n$popover-border-width:              var(--#{$prefix}border-width) !default;\n$popover-border-color:              var(--#{$prefix}border-color-translucent) !default;\n$popover-border-radius:             var(--#{$prefix}border-radius-lg) !default;\n$popover-inner-border-radius:       calc(#{$popover-border-radius} - #{$popover-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$popover-box-shadow:                var(--#{$prefix}box-shadow) !default;\n\n$popover-header-font-size:          $font-size-base !default;\n$popover-header-bg:                 var(--#{$prefix}secondary-bg) !default;\n$popover-header-color:              $headings-color !default;\n$popover-header-padding-y:          .5rem !default;\n$popover-header-padding-x:          $spacer !default;\n\n$popover-body-color:                var(--#{$prefix}body-color) !default;\n$popover-body-padding-y:            $spacer !default;\n$popover-body-padding-x:            $spacer !default;\n\n$popover-arrow-width:               1rem !default;\n$popover-arrow-height:              .5rem !default;\n// scss-docs-end popover-variables\n\n// fusv-disable\n// Deprecated in Bootstrap 5.2.0 for CSS variables\n$popover-arrow-color:               $popover-bg !default;\n$popover-arrow-outer-color:         var(--#{$prefix}border-color-translucent) !default;\n// fusv-enable\n\n\n// Toasts\n\n// scss-docs-start toast-variables\n$toast-max-width:                   350px !default;\n$toast-padding-x:                   .75rem !default;\n$toast-padding-y:                   .5rem !default;\n$toast-font-size:                   .875rem !default;\n$toast-color:                       null !default;\n$toast-background-color:            rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-border-width:                var(--#{$prefix}border-width) !default;\n$toast-border-color:                var(--#{$prefix}border-color-translucent) !default;\n$toast-border-radius:               var(--#{$prefix}border-radius) !default;\n$toast-box-shadow:                  var(--#{$prefix}box-shadow) !default;\n$toast-spacing:                     $container-padding-x !default;\n\n$toast-header-color:                var(--#{$prefix}secondary-color) !default;\n$toast-header-background-color:     rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-header-border-color:         $toast-border-color !default;\n// scss-docs-end toast-variables\n\n\n// Badges\n\n// scss-docs-start badge-variables\n$badge-font-size:                   .75em !default;\n$badge-font-weight:                 $font-weight-bold !default;\n$badge-color:                       $white !default;\n$badge-padding-y:                   .35em !default;\n$badge-padding-x:                   .65em !default;\n$badge-border-radius:               var(--#{$prefix}border-radius) !default;\n// scss-docs-end badge-variables\n\n\n// Modals\n\n// scss-docs-start modal-variables\n$modal-inner-padding:               $spacer !default;\n\n$modal-footer-margin-between:       .5rem !default;\n\n$modal-dialog-margin:               .5rem !default;\n$modal-dialog-margin-y-sm-up:       1.75rem !default;\n\n$modal-title-line-height:           $line-height-base !default;\n\n$modal-content-color:               var(--#{$prefix}body-color) !default;\n$modal-content-bg:                  var(--#{$prefix}body-bg) !default;\n$modal-content-border-color:        var(--#{$prefix}border-color-translucent) !default;\n$modal-content-border-width:        var(--#{$prefix}border-width) !default;\n$modal-content-border-radius:       var(--#{$prefix}border-radius-lg) !default;\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width) !default;\n$modal-content-box-shadow-xs:       var(--#{$prefix}box-shadow-sm) !default;\n$modal-content-box-shadow-sm-up:    var(--#{$prefix}box-shadow) !default;\n\n$modal-backdrop-bg:                 $black !default;\n$modal-backdrop-opacity:            .5 !default;\n\n$modal-header-border-color:         var(--#{$prefix}border-color) !default;\n$modal-header-border-width:         $modal-content-border-width !default;\n$modal-header-padding-y:            $modal-inner-padding !default;\n$modal-header-padding-x:            $modal-inner-padding !default;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n\n$modal-footer-bg:                   null !default;\n$modal-footer-border-color:         $modal-header-border-color !default;\n$modal-footer-border-width:         $modal-header-border-width !default;\n\n$modal-sm:                          300px !default;\n$modal-md:                          500px !default;\n$modal-lg:                          800px !default;\n$modal-xl:                          1140px !default;\n\n$modal-fade-transform:              translate(0, -50px) !default;\n$modal-show-transform:              none !default;\n$modal-transition:                  transform .3s ease-out !default;\n$modal-scale-transform:             scale(1.02) !default;\n// scss-docs-end modal-variables\n\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n// scss-docs-start alert-variables\n$alert-padding-y:               $spacer !default;\n$alert-padding-x:               $spacer !default;\n$alert-margin-bottom:           1rem !default;\n$alert-border-radius:           var(--#{$prefix}border-radius) !default;\n$alert-link-font-weight:        $font-weight-bold !default;\n$alert-border-width:            var(--#{$prefix}border-width) !default;\n$alert-dismissible-padding-r:   $alert-padding-x * 3 !default; // 3x covers width of x plus default padding on either side\n// scss-docs-end alert-variables\n\n// fusv-disable\n$alert-bg-scale:                -80% !default; // Deprecated in v5.2.0, to be removed in v6\n$alert-border-scale:            -70% !default; // Deprecated in v5.2.0, to be removed in v6\n$alert-color-scale:             40% !default; // Deprecated in v5.2.0, to be removed in v6\n// fusv-enable\n\n// Progress bars\n\n// scss-docs-start progress-variables\n$progress-height:                   1rem !default;\n$progress-font-size:                $font-size-base * .75 !default;\n$progress-bg:                       var(--#{$prefix}secondary-bg) !default;\n$progress-border-radius:            var(--#{$prefix}border-radius) !default;\n$progress-box-shadow:               var(--#{$prefix}box-shadow-inset) !default;\n$progress-bar-color:                $white !default;\n$progress-bar-bg:                   $primary !default;\n$progress-bar-animation-timing:     1s linear infinite !default;\n$progress-bar-transition:           width .6s ease !default;\n// scss-docs-end progress-variables\n\n\n// List group\n\n// scss-docs-start list-group-variables\n$list-group-color:                  var(--#{$prefix}body-color) !default;\n$list-group-bg:                     var(--#{$prefix}body-bg) !default;\n$list-group-border-color:           var(--#{$prefix}border-color) !default;\n$list-group-border-width:           var(--#{$prefix}border-width) !default;\n$list-group-border-radius:          var(--#{$prefix}border-radius) !default;\n\n$list-group-item-padding-y:         $spacer * .5 !default;\n$list-group-item-padding-x:         $spacer !default;\n// fusv-disable\n$list-group-item-bg-scale:          -80% !default; // Deprecated in v5.3.0\n$list-group-item-color-scale:       40% !default; // Deprecated in v5.3.0\n// fusv-enable\n\n$list-group-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$list-group-active-color:           $component-active-color !default;\n$list-group-active-bg:              $component-active-bg !default;\n$list-group-active-border-color:    $list-group-active-bg !default;\n\n$list-group-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$list-group-disabled-bg:            $list-group-bg !default;\n\n$list-group-action-color:           var(--#{$prefix}secondary-color) !default;\n$list-group-action-hover-color:     var(--#{$prefix}emphasis-color) !default;\n\n$list-group-action-active-color:    var(--#{$prefix}body-color) !default;\n$list-group-action-active-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end list-group-variables\n\n\n// Image thumbnails\n\n// scss-docs-start thumbnail-variables\n$thumbnail-padding:                 .25rem !default;\n$thumbnail-bg:                      var(--#{$prefix}body-bg) !default;\n$thumbnail-border-width:            var(--#{$prefix}border-width) !default;\n$thumbnail-border-color:            var(--#{$prefix}border-color) !default;\n$thumbnail-border-radius:           var(--#{$prefix}border-radius) !default;\n$thumbnail-box-shadow:              var(--#{$prefix}box-shadow-sm) !default;\n// scss-docs-end thumbnail-variables\n\n\n// Figures\n\n// scss-docs-start figure-variables\n$figure-caption-font-size:          $small-font-size !default;\n$figure-caption-color:              var(--#{$prefix}secondary-color) !default;\n// scss-docs-end figure-variables\n\n\n// Breadcrumbs\n\n// scss-docs-start breadcrumb-variables\n$breadcrumb-font-size:              null !default;\n$breadcrumb-padding-y:              0 !default;\n$breadcrumb-padding-x:              0 !default;\n$breadcrumb-item-padding-x:         .5rem !default;\n$breadcrumb-margin-bottom:          1rem !default;\n$breadcrumb-bg:                     null !default;\n$breadcrumb-divider-color:          var(--#{$prefix}secondary-color) !default;\n$breadcrumb-active-color:           var(--#{$prefix}secondary-color) !default;\n$breadcrumb-divider:                quote(\"/\") !default;\n$breadcrumb-divider-flipped:        $breadcrumb-divider !default;\n$breadcrumb-border-radius:          null !default;\n// scss-docs-end breadcrumb-variables\n\n// Carousel\n\n// scss-docs-start carousel-variables\n$carousel-control-color:             $white !default;\n$carousel-control-width:             15% !default;\n$carousel-control-opacity:           .5 !default;\n$carousel-control-hover-opacity:     .9 !default;\n$carousel-control-transition:        opacity .15s ease !default;\n$carousel-control-icon-filter:       null !default;\n\n$carousel-indicator-width:           30px !default;\n$carousel-indicator-height:          3px !default;\n$carousel-indicator-hit-area-height: 10px !default;\n$carousel-indicator-spacer:          3px !default;\n$carousel-indicator-opacity:         .5 !default;\n$carousel-indicator-active-bg:       $white !default;\n$carousel-indicator-active-opacity:  1 !default;\n$carousel-indicator-transition:      opacity .6s ease !default;\n\n$carousel-caption-width:             70% !default;\n$carousel-caption-color:             $white !default;\n$carousel-caption-padding-y:         1.25rem !default;\n$carousel-caption-spacer:            1.25rem !default;\n\n$carousel-control-icon-width:        2rem !default;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0'/></svg>\") !default;\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708'/></svg>\") !default;\n\n$carousel-transition-duration:       .6s !default;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n// scss-docs-end carousel-variables\n\n// scss-docs-start carousel-dark-variables\n$carousel-dark-indicator-active-bg:  $black !default; // Deprecated in v5.3.4\n$carousel-dark-caption-color:        $black !default; // Deprecated in v5.3.4\n$carousel-dark-control-icon-filter:  invert(1) grayscale(100) !default; // Deprecated in v5.3.4\n// scss-docs-end carousel-dark-variables\n\n\n// Spinners\n\n// scss-docs-start spinner-variables\n$spinner-width:           2rem !default;\n$spinner-height:          $spinner-width !default;\n$spinner-vertical-align:  -.125em !default;\n$spinner-border-width:    .25em !default;\n$spinner-animation-speed: .75s !default;\n\n$spinner-width-sm:        1rem !default;\n$spinner-height-sm:       $spinner-width-sm !default;\n$spinner-border-width-sm: .2em !default;\n// scss-docs-end spinner-variables\n\n\n// Close\n\n// scss-docs-start close-variables\n$btn-close-width:            1em !default;\n$btn-close-height:           $btn-close-width !default;\n$btn-close-padding-x:        .25em !default;\n$btn-close-padding-y:        $btn-close-padding-x !default;\n$btn-close-color:            $black !default;\n$btn-close-bg:               url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$btn-close-color}'><path d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414'/></svg>\") !default;\n$btn-close-focus-shadow:     $focus-ring-box-shadow !default;\n$btn-close-opacity:          .5 !default;\n$btn-close-hover-opacity:    .75 !default;\n$btn-close-focus-opacity:    1 !default;\n$btn-close-disabled-opacity: .25 !default;\n$btn-close-filter:           null !default;\n$btn-close-white-filter:     invert(1) grayscale(100%) brightness(200%) !default; // Deprecated in v5.3.4\n// scss-docs-end close-variables\n\n\n// Offcanvas\n\n// scss-docs-start offcanvas-variables\n$offcanvas-padding-y:               $modal-inner-padding !default;\n$offcanvas-padding-x:               $modal-inner-padding !default;\n$offcanvas-horizontal-width:        400px !default;\n$offcanvas-vertical-height:         30vh !default;\n$offcanvas-transition-duration:     .3s !default;\n$offcanvas-border-color:            $modal-content-border-color !default;\n$offcanvas-border-width:            $modal-content-border-width !default;\n$offcanvas-title-line-height:       $modal-title-line-height !default;\n$offcanvas-bg-color:                var(--#{$prefix}body-bg) !default;\n$offcanvas-color:                   var(--#{$prefix}body-color) !default;\n$offcanvas-box-shadow:              $modal-content-box-shadow-xs !default;\n$offcanvas-backdrop-bg:             $modal-backdrop-bg !default;\n$offcanvas-backdrop-opacity:        $modal-backdrop-opacity !default;\n// scss-docs-end offcanvas-variables\n\n// Code\n\n$code-font-size:                    $small-font-size !default;\n$code-color:                        $pink !default;\n\n$kbd-padding-y:                     .1875rem !default;\n$kbd-padding-x:                     .375rem !default;\n$kbd-font-size:                     $code-font-size !default;\n$kbd-color:                         var(--#{$prefix}body-bg) !default;\n$kbd-bg:                            var(--#{$prefix}body-color) !default;\n$nested-kbd-font-weight:            null !default; // Deprecated in v5.2.0, removing in v6\n\n$pre-color:                         null !default;\n\n@import \"variables-dark\"; // TODO: can be removed safely in v6, only here to avoid breaking changes in v5.3\n","// stylelint-disable property-disallowed-list\n// Single side border-radius\n\n// Helper function to replace negative values with 0\n@function valid-radius($radius) {\n  $return: ();\n  @each $value in $radius {\n    @if type-of($value) == number {\n      $return: append($return, max($value, 0));\n    } @else {\n      $return: append($return, $value);\n    }\n  }\n  @return $return;\n}\n\n// scss-docs-start border-radius-mixins\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\n  @if $enable-rounded {\n    border-radius: valid-radius($radius);\n  }\n  @else if $fallback-border-radius != false {\n    border-radius: $fallback-border-radius;\n  }\n}\n\n@mixin border-top-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n// scss-docs-end border-radius-mixins\n","//\n// Headings\n//\n.h1 {\n  @extend h1;\n}\n\n.h2 {\n  @extend h2;\n}\n\n.h3 {\n  @extend h3;\n}\n\n.h4 {\n  @extend h4;\n}\n\n.h5 {\n  @extend h5;\n}\n\n.h6 {\n  @extend h6;\n}\n\n\n.lead {\n  @include font-size($lead-font-size);\n  font-weight: $lead-font-weight;\n}\n\n// Type display classes\n@each $display, $font-size in $display-font-sizes {\n  .display-#{$display} {\n    font-family: $display-font-family;\n    font-style: $display-font-style;\n    font-weight: $display-font-weight;\n    line-height: $display-line-height;\n    @include font-size($font-size);\n  }\n}\n\n//\n// Emphasis\n//\n.small {\n  @extend small;\n}\n\n.mark {\n  @extend mark;\n}\n\n//\n// Lists\n//\n\n.list-unstyled {\n  @include list-unstyled();\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  @include list-unstyled();\n}\n.list-inline-item {\n  display: inline-block;\n\n  &:not(:last-child) {\n    margin-right: $list-inline-padding;\n  }\n}\n\n\n//\n// Misc\n//\n\n// Builds on `abbr`\n.initialism {\n  @include font-size($initialism-font-size);\n  text-transform: uppercase;\n}\n\n// Blockquotes\n.blockquote {\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-font-size);\n\n  > :last-child {\n    margin-bottom: 0;\n  }\n}\n\n.blockquote-footer {\n  margin-top: -$blockquote-margin-y;\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-footer-font-size);\n  color: $blockquote-footer-color;\n\n  &::before {\n    content: \"\\2014\\00A0\"; // em dash, nbsp\n  }\n}\n","// Lists\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n@mixin list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n","// Responsive images (ensure images don't scale beyond their parents)\n//\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\n// which weren't expecting the images within themselves to be involuntarily resized.\n// See also https://github.com/twbs/bootstrap/issues/18178\n.img-fluid {\n  @include img-fluid();\n}\n\n\n// Image thumbnails\n.img-thumbnail {\n  padding: $thumbnail-padding;\n  background-color: $thumbnail-bg;\n  border: $thumbnail-border-width solid $thumbnail-border-color;\n  @include border-radius($thumbnail-border-radius);\n  @include box-shadow($thumbnail-box-shadow);\n\n  // Keep them at most 100% wide\n  @include img-fluid();\n}\n\n//\n// Figures\n//\n\n.figure {\n  // Ensures the caption's text aligns with the image.\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: $spacer * .5;\n  line-height: 1;\n}\n\n.figure-caption {\n  @include font-size($figure-caption-font-size);\n  color: $figure-caption-color;\n}\n","// Image Mixins\n// - Responsive image\n// - Retina image\n\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n\n@mixin img-fluid {\n  // Part 1: Set a maximum relative to the parent\n  max-width: 100%;\n  // Part 2: Override the height to auto, otherwise images will be stretched\n  // when setting a width and height attribute on the img element.\n  height: auto;\n}\n","// Container widths\n//\n// Set the container width, and override it for fixed navbars in media queries.\n\n@if $enable-container-classes {\n  // Single container class with breakpoint max-widths\n  .container,\n  // 100% wide container at all breakpoints\n  .container-fluid {\n    @include make-container();\n  }\n\n  // Responsive containers that are 100% wide until a breakpoint\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    .container-#{$breakpoint} {\n      @extend .container-fluid;\n    }\n\n    @include media-breakpoint-up($breakpoint, $grid-breakpoints) {\n      %responsive-container-#{$breakpoint} {\n        max-width: $container-max-width;\n      }\n\n      // Extend each breakpoint which is smaller or equal to the current breakpoint\n      $extend-breakpoint: true;\n\n      @each $name, $width in $grid-breakpoints {\n        @if ($extend-breakpoint) {\n          .container#{breakpoint-infix($name, $grid-breakpoints)} {\n            @extend %responsive-container-#{$breakpoint};\n          }\n\n          // Once the current breakpoint is reached, stop extending\n          @if ($breakpoint == $name) {\n            $extend-breakpoint: false;\n          }\n        }\n      }\n    }\n  }\n}\n","// Container mixins\n\n@mixin make-container($gutter: $container-padding-x) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  width: 100%;\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-right: auto;\n  margin-left: auto;\n}\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl xxl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @if not $n {\n    @error \"breakpoint `#{$name}` not found in `#{$breakpoints}`\";\n  }\n  @return if($n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width.\n// The maximum value is reduced by 0.02px to work around the limitations of\n// `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(md, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $max: map-get($breakpoints, $name);\n  @return if($max and $max > 0, $max - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min:  breakpoint-min($name, $breakpoints);\n  $next: breakpoint-next($name, $breakpoints);\n  $max:  breakpoint-max($next, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($next, $breakpoints) {\n      @content;\n    }\n  }\n}\n","// Row\n//\n// Rows contain your columns.\n\n:root {\n  @each $name, $value in $grid-breakpoints {\n    --#{$prefix}breakpoint-#{$name}: #{$value};\n  }\n}\n\n@if $enable-grid-classes {\n  .row {\n    @include make-row();\n\n    > * {\n      @include make-col-ready();\n    }\n  }\n}\n\n@if $enable-cssgrid {\n  .grid {\n    display: grid;\n    grid-template-rows: repeat(var(--#{$prefix}rows, 1), 1fr);\n    grid-template-columns: repeat(var(--#{$prefix}columns, #{$grid-columns}), 1fr);\n    gap: var(--#{$prefix}gap, #{$grid-gutter-width});\n\n    @include make-cssgrid();\n  }\n}\n\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n@if $enable-grid-classes {\n  @include make-grid-columns();\n}\n","// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n@mixin make-row($gutter: $grid-gutter-width) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  // TODO: Revisit calc order after https://github.com/react-bootstrap/react-bootstrap/issues/6039 is fixed\n  margin-top: calc(-1 * var(--#{$prefix}gutter-y)); // stylelint-disable-line function-disallowed-list\n  margin-right: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n}\n\n@mixin make-col-ready() {\n  // Add box sizing if only the grid is loaded\n  box-sizing: if(variable-exists(include-column-box-sizing) and $include-column-box-sizing, border-box, null);\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\n  // always setting `width: 100%;`. This works because we set the width\n  // later on to override this initial width.\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%; // Prevent `.col-auto`, `.col` (& responsive variants) from breaking out the grid\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-top: var(--#{$prefix}gutter-y);\n}\n\n@mixin make-col($size: false, $columns: $grid-columns) {\n  @if $size {\n    flex: 0 0 auto;\n    width: percentage(divide($size, $columns));\n\n  } @else {\n    flex: 1 1 0;\n    max-width: 100%;\n  }\n}\n\n@mixin make-col-auto() {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n@mixin make-col-offset($size, $columns: $grid-columns) {\n  $num: divide($size, $columns);\n  margin-left: if($num == 0, 0, percentage($num));\n}\n\n// Row columns\n//\n// Specify on a parent element(e.g., .row) to force immediate children into NN\n// number of columns. Supports wrapping to new lines, but does not do a Masonry\n// style grid.\n@mixin row-cols($count) {\n  > * {\n    flex: 0 0 auto;\n    width: percentage(divide(1, $count));\n  }\n}\n\n// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `$grid-columns`.\n\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\n      .col#{$infix} {\n        flex: 1 0 0;\n      }\n\n      .row-cols#{$infix}-auto > * {\n        @include make-col-auto();\n      }\n\n      @if $grid-row-columns > 0 {\n        @for $i from 1 through $grid-row-columns {\n          .row-cols#{$infix}-#{$i} {\n            @include row-cols($i);\n          }\n        }\n      }\n\n      .col#{$infix}-auto {\n        @include make-col-auto();\n      }\n\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .col#{$infix}-#{$i} {\n            @include make-col($i, $columns);\n          }\n        }\n\n        // `$columns - 1` because offsetting by the width of an entire row isn't possible\n        @for $i from 0 through ($columns - 1) {\n          @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n            .offset#{$infix}-#{$i} {\n              @include make-col-offset($i, $columns);\n            }\n          }\n        }\n      }\n\n      // Gutters\n      //\n      // Make use of `.g-*`, `.gx-*` or `.gy-*` utilities to change spacing between the columns.\n      @each $key, $value in $gutters {\n        .g#{$infix}-#{$key},\n        .gx#{$infix}-#{$key} {\n          --#{$prefix}gutter-x: #{$value};\n        }\n\n        .g#{$infix}-#{$key},\n        .gy#{$infix}-#{$key} {\n          --#{$prefix}gutter-y: #{$value};\n        }\n      }\n    }\n  }\n}\n\n@mixin make-cssgrid($columns: $grid-columns, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .g-col#{$infix}-#{$i} {\n            grid-column: auto / span $i;\n          }\n        }\n\n        // Start with `1` because `0` is an invalid value.\n        // Ends with `$columns - 1` because offsetting by the width of an entire row isn't possible.\n        @for $i from 1 through ($columns - 1) {\n          .g-start#{$infix}-#{$i} {\n            grid-column-start: $i;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Basic Bootstrap table\n//\n\n.table {\n  // Reset needed for nesting tables\n  --#{$prefix}table-color-type: initial;\n  --#{$prefix}table-bg-type: initial;\n  --#{$prefix}table-color-state: initial;\n  --#{$prefix}table-bg-state: initial;\n  // End of reset\n  --#{$prefix}table-color: #{$table-color};\n  --#{$prefix}table-bg: #{$table-bg};\n  --#{$prefix}table-border-color: #{$table-border-color};\n  --#{$prefix}table-accent-bg: #{$table-accent-bg};\n  --#{$prefix}table-striped-color: #{$table-striped-color};\n  --#{$prefix}table-striped-bg: #{$table-striped-bg};\n  --#{$prefix}table-active-color: #{$table-active-color};\n  --#{$prefix}table-active-bg: #{$table-active-bg};\n  --#{$prefix}table-hover-color: #{$table-hover-color};\n  --#{$prefix}table-hover-bg: #{$table-hover-bg};\n\n  width: 100%;\n  margin-bottom: $spacer;\n  vertical-align: $table-cell-vertical-align;\n  border-color: var(--#{$prefix}table-border-color);\n\n  // Target th & td\n  // We need the child combinator to prevent styles leaking to nested tables which doesn't have a `.table` class.\n  // We use the universal selectors here to simplify the selector (else we would need 6 different selectors).\n  // Another advantage is that this generates less code and makes the selector less specific making it easier to override.\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y $table-cell-padding-x;\n    // Following the precept of cascades: https://codepen.io/miriamsuzanne/full/vYNgodb\n    color: var(--#{$prefix}table-color-state, var(--#{$prefix}table-color-type, var(--#{$prefix}table-color)));\n    background-color: var(--#{$prefix}table-bg);\n    border-bottom-width: $table-border-width;\n    box-shadow: inset 0 0 0 9999px var(--#{$prefix}table-bg-state, var(--#{$prefix}table-bg-type, var(--#{$prefix}table-accent-bg)));\n  }\n\n  > tbody {\n    vertical-align: inherit;\n  }\n\n  > thead {\n    vertical-align: bottom;\n  }\n}\n\n.table-group-divider {\n  border-top: calc(#{$table-border-width} * 2) solid $table-group-separator-color; // stylelint-disable-line function-disallowed-list\n}\n\n//\n// Change placement of captions with a class\n//\n\n.caption-top {\n  caption-side: top;\n}\n\n\n//\n// Condensed table w/ half padding\n//\n\n.table-sm {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y-sm $table-cell-padding-x-sm;\n  }\n}\n\n\n// Border versions\n//\n// Add or remove borders all around the table and between all the columns.\n//\n// When borders are added on all sides of the cells, the corners can render odd when\n// these borders do not have the same color or if they are semi-transparent.\n// Therefore we add top and border bottoms to the `tr`s and left and right borders\n// to the `td`s or `th`s\n\n.table-bordered {\n  > :not(caption) > * {\n    border-width: $table-border-width 0;\n\n    // stylelint-disable-next-line selector-max-universal\n    > * {\n      border-width: 0 $table-border-width;\n    }\n  }\n}\n\n.table-borderless {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    border-bottom-width: 0;\n  }\n\n  > :not(:first-child) {\n    border-top-width: 0;\n  }\n}\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n// For rows\n.table-striped {\n  > tbody > tr:nth-of-type(#{$table-striped-order}) > * {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// For columns\n.table-striped-columns {\n  > :not(caption) > tr > :nth-child(#{$table-striped-columns-order}) {\n    --#{$prefix}table-color-type: var(--#{$prefix}table-striped-color);\n    --#{$prefix}table-bg-type: var(--#{$prefix}table-striped-bg);\n  }\n}\n\n// Active table\n//\n// The `.table-active` class can be added to highlight rows or cells\n\n.table-active {\n  --#{$prefix}table-color-state: var(--#{$prefix}table-active-color);\n  --#{$prefix}table-bg-state: var(--#{$prefix}table-active-bg);\n}\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover {\n  > tbody > tr:hover > * {\n    --#{$prefix}table-color-state: var(--#{$prefix}table-hover-color);\n    --#{$prefix}table-bg-state: var(--#{$prefix}table-hover-bg);\n  }\n}\n\n\n// Table variants\n//\n// Table variants set the table cell backgrounds, border colors\n// and the colors of the striped, hovered & active tables\n\n@each $color, $value in $table-variants {\n  @include table-variant($color, $value);\n}\n\n// Responsive tables\n//\n// Generate series of `.table-responsive-*` classes for configuring the screen\n// size of where your table will overflow.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n  @include media-breakpoint-down($breakpoint) {\n    .table-responsive#{$infix} {\n      overflow-x: auto;\n      -webkit-overflow-scrolling: touch;\n    }\n  }\n}\n","// scss-docs-start table-variant\n@mixin table-variant($state, $background) {\n  .table-#{$state} {\n    $color: color-contrast(opaque($body-bg, $background));\n    $hover-bg: mix($color, $background, percentage($table-hover-bg-factor));\n    $striped-bg: mix($color, $background, percentage($table-striped-bg-factor));\n    $active-bg: mix($color, $background, percentage($table-active-bg-factor));\n    $table-border-color: mix($color, $background, percentage($table-border-factor));\n\n    --#{$prefix}table-color: #{$color};\n    --#{$prefix}table-bg: #{$background};\n    --#{$prefix}table-border-color: #{$table-border-color};\n    --#{$prefix}table-striped-bg: #{$striped-bg};\n    --#{$prefix}table-striped-color: #{color-contrast($striped-bg)};\n    --#{$prefix}table-active-bg: #{$active-bg};\n    --#{$prefix}table-active-color: #{color-contrast($active-bg)};\n    --#{$prefix}table-hover-bg: #{$hover-bg};\n    --#{$prefix}table-hover-color: #{color-contrast($hover-bg)};\n\n    color: var(--#{$prefix}table-color);\n    border-color: var(--#{$prefix}table-border-color);\n  }\n}\n// scss-docs-end table-variant\n","//\n// Labels\n//\n\n.form-label {\n  margin-bottom: $form-label-margin-bottom;\n  @include font-size($form-label-font-size);\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  color: $form-label-color;\n}\n\n// For use with horizontal and inline forms, when you need the label (or legend)\n// text to align with the form controls.\n.col-form-label {\n  padding-top: add($input-padding-y, $input-border-width);\n  padding-bottom: add($input-padding-y, $input-border-width);\n  margin-bottom: 0; // Override the `<legend>` default\n  @include font-size(inherit); // Override the `<legend>` default\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  line-height: $input-line-height;\n  color: $form-label-color;\n}\n\n.col-form-label-lg {\n  padding-top: add($input-padding-y-lg, $input-border-width);\n  padding-bottom: add($input-padding-y-lg, $input-border-width);\n  @include font-size($input-font-size-lg);\n}\n\n.col-form-label-sm {\n  padding-top: add($input-padding-y-sm, $input-border-width);\n  padding-bottom: add($input-padding-y-sm, $input-border-width);\n  @include font-size($input-font-size-sm);\n}\n","//\n// Form text\n//\n\n.form-text {\n  margin-top: $form-text-margin-top;\n  @include font-size($form-text-font-size);\n  font-style: $form-text-font-style;\n  font-weight: $form-text-font-weight;\n  color: $form-text-color;\n}\n","//\n// General form controls (plus a few specific high-level interventions)\n//\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y $input-padding-x;\n  font-family: $input-font-family;\n  @include font-size($input-font-size);\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  color: $input-color;\n  appearance: none; // Fix appearance for date inputs in Safari\n  background-color: $input-bg;\n  background-clip: padding-box;\n  border: $input-border-width solid $input-border-color;\n\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\n  @include border-radius($input-border-radius, 0);\n\n  @include box-shadow($input-box-shadow);\n  @include transition($input-transition);\n\n  &[type=\"file\"] {\n    overflow: hidden; // prevent pseudo element button overlap\n\n    &:not(:disabled):not([readonly]) {\n      cursor: pointer;\n    }\n  }\n\n  // Customize the `:focus` state to imitate native WebKit styles.\n  &:focus {\n    color: $input-focus-color;\n    background-color: $input-focus-bg;\n    border-color: $input-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($input-box-shadow, $input-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $input-focus-box-shadow;\n    }\n  }\n\n  &::-webkit-date-and-time-value {\n    // On Android Chrome, form-control's \"width: 100%\" makes the input width too small\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    //\n    // On iOS Safari, form-control's \"appearance: none\" + \"width: 100%\" makes the input width too small\n    // Tested under iOS 16.2 / Safari 16.2\n    min-width: 85px; // Seems to be a good minimum safe width\n\n    // Add some height to date inputs on iOS\n    // https://github.com/twbs/bootstrap/issues/23307\n    // TODO: we can remove this workaround once https://bugs.webkit.org/show_bug.cgi?id=198959 is resolved\n    // Multiply line-height by 1em if it has no unit\n    height: if(unit($input-line-height) == \"\", $input-line-height * 1em, $input-line-height);\n\n    // Android Chrome type=\"date\" is taller than the other inputs\n    // because of \"margin: 1px 24px 1px 4px\" inside the shadow DOM\n    // Tested under Android 11 / Chrome 89, Android 12 / Chrome 100, Android 13 / Chrome 109\n    margin: 0;\n  }\n\n  // Prevent excessive date input height in Webkit\n  // https://github.com/twbs/bootstrap/issues/34433\n  &::-webkit-datetime-edit {\n    display: block;\n    padding: 0;\n  }\n\n  // Placeholder\n  &::placeholder {\n    color: $input-placeholder-color;\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\n    opacity: 1;\n  }\n\n  // Disabled inputs\n  //\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\n  // don't honor that edge case; we style them as disabled anyway.\n  &:disabled {\n    color: $input-disabled-color;\n    background-color: $input-disabled-bg;\n    border-color: $input-disabled-border-color;\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\n    opacity: 1;\n  }\n\n  // File input buttons theming\n  &::file-selector-button {\n    padding: $input-padding-y $input-padding-x;\n    margin: (-$input-padding-y) (-$input-padding-x);\n    margin-inline-end: $input-padding-x;\n    color: $form-file-button-color;\n    @include gradient-bg($form-file-button-bg);\n    pointer-events: none;\n    border-color: inherit;\n    border-style: solid;\n    border-width: 0;\n    border-inline-end-width: $input-border-width;\n    border-radius: 0; // stylelint-disable-line property-disallowed-list\n    @include transition($btn-transition);\n  }\n\n  &:hover:not(:disabled):not([readonly])::file-selector-button {\n    background-color: $form-file-button-hover-bg;\n  }\n}\n\n// Readonly controls as plain text\n//\n// Apply class to a readonly input to make it appear like regular plain\n// text (without any border, background color, focus indicator)\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y 0;\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\n  line-height: $input-line-height;\n  color: $input-plaintext-color;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: $input-border-width 0;\n\n  &:focus {\n    outline: 0;\n  }\n\n  &.form-control-sm,\n  &.form-control-lg {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n// Form control sizing\n//\n// Build on `.form-control` with modifier classes to decrease or increase the\n// height and font-size of form controls.\n//\n// Repeated in `_input_group.scss` to avoid Sass extend issues.\n\n.form-control-sm {\n  min-height: $input-height-sm;\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n\n  &::file-selector-button {\n    padding: $input-padding-y-sm $input-padding-x-sm;\n    margin: (-$input-padding-y-sm) (-$input-padding-x-sm);\n    margin-inline-end: $input-padding-x-sm;\n  }\n}\n\n.form-control-lg {\n  min-height: $input-height-lg;\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n\n  &::file-selector-button {\n    padding: $input-padding-y-lg $input-padding-x-lg;\n    margin: (-$input-padding-y-lg) (-$input-padding-x-lg);\n    margin-inline-end: $input-padding-x-lg;\n  }\n}\n\n// Make sure textareas don't shrink too much when resized\n// https://github.com/twbs/bootstrap/pull/29124\n// stylelint-disable selector-no-qualifying-type\ntextarea {\n  &.form-control {\n    min-height: $input-height;\n  }\n\n  &.form-control-sm {\n    min-height: $input-height-sm;\n  }\n\n  &.form-control-lg {\n    min-height: $input-height-lg;\n  }\n}\n// stylelint-enable selector-no-qualifying-type\n\n.form-control-color {\n  width: $form-color-width;\n  height: $input-height;\n  padding: $input-padding-y;\n\n  &:not(:disabled):not([readonly]) {\n    cursor: pointer;\n  }\n\n  &::-moz-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &::-webkit-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &.form-control-sm { height: $input-height-sm; }\n  &.form-control-lg { height: $input-height-lg; }\n}\n","// stylelint-disable property-disallowed-list\n@mixin transition($transition...) {\n  @if length($transition) == 0 {\n    $transition: $transition-base;\n  }\n\n  @if length($transition) > 1 {\n    @each $value in $transition {\n      @if $value == null or $value == none {\n        @warn \"The keyword 'none' or 'null' must be used as a single argument.\";\n      }\n    }\n  }\n\n  @if $enable-transitions {\n    @if nth($transition, 1) != null {\n      transition: $transition;\n    }\n\n    @if $enable-reduced-motion and nth($transition, 1) != null and nth($transition, 1) != none {\n      @media (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n}\n","// Gradients\n\n// scss-docs-start gradient-bg-mixin\n@mixin gradient-bg($color: null) {\n  background-color: $color;\n\n  @if $enable-gradients {\n    background-image: var(--#{$prefix}gradient);\n  }\n}\n// scss-docs-end gradient-bg-mixin\n\n// scss-docs-start gradient-mixins\n// Horizontal gradient, from left to right\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-x($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\n}\n\n// Vertical gradient, from top to bottom\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-y($start-color: $gray-700, $end-color: $gray-800, $start-percent: null, $end-percent: null) {\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\n}\n\n@mixin gradient-directional($start-color: $gray-700, $end-color: $gray-800, $deg: 45deg) {\n  background-image: linear-gradient($deg, $start-color, $end-color);\n}\n\n@mixin gradient-x-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-y-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-radial($inner-color: $gray-700, $outer-color: $gray-800) {\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\n}\n\n@mixin gradient-striped($color: rgba($white, .15), $angle: 45deg) {\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\n}\n// scss-docs-end gradient-mixins\n","// Select\n//\n// Replaces the browser default select with a custom one, mostly pulled from\n// https://primer.github.io/.\n\n.form-select {\n  --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator)};\n\n  display: block;\n  width: 100%;\n  padding: $form-select-padding-y $form-select-indicator-padding $form-select-padding-y $form-select-padding-x;\n  font-family: $form-select-font-family;\n  @include font-size($form-select-font-size);\n  font-weight: $form-select-font-weight;\n  line-height: $form-select-line-height;\n  color: $form-select-color;\n  appearance: none;\n  background-color: $form-select-bg;\n  background-image: var(--#{$prefix}form-select-bg-img), var(--#{$prefix}form-select-bg-icon, none);\n  background-repeat: no-repeat;\n  background-position: $form-select-bg-position;\n  background-size: $form-select-bg-size;\n  border: $form-select-border-width solid $form-select-border-color;\n  @include border-radius($form-select-border-radius, 0);\n  @include box-shadow($form-select-box-shadow);\n  @include transition($form-select-transition);\n\n  &:focus {\n    border-color: $form-select-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($form-select-box-shadow, $form-select-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $form-select-focus-box-shadow;\n    }\n  }\n\n  &[multiple],\n  &[size]:not([size=\"1\"]) {\n    padding-right: $form-select-padding-x;\n    background-image: none;\n  }\n\n  &:disabled {\n    color: $form-select-disabled-color;\n    background-color: $form-select-disabled-bg;\n    border-color: $form-select-disabled-border-color;\n  }\n\n  // Remove outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $form-select-color;\n  }\n}\n\n.form-select-sm {\n  padding-top: $form-select-padding-y-sm;\n  padding-bottom: $form-select-padding-y-sm;\n  padding-left: $form-select-padding-x-sm;\n  @include font-size($form-select-font-size-sm);\n  @include border-radius($form-select-border-radius-sm);\n}\n\n.form-select-lg {\n  padding-top: $form-select-padding-y-lg;\n  padding-bottom: $form-select-padding-y-lg;\n  padding-left: $form-select-padding-x-lg;\n  @include font-size($form-select-font-size-lg);\n  @include border-radius($form-select-border-radius-lg);\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-select {\n      --#{$prefix}form-select-bg-img: #{escape-svg($form-select-indicator-dark)};\n    }\n  }\n}\n","//\n// Check/radio\n//\n\n.form-check {\n  display: block;\n  min-height: $form-check-min-height;\n  padding-left: $form-check-padding-start;\n  margin-bottom: $form-check-margin-bottom;\n\n  .form-check-input {\n    float: left;\n    margin-left: $form-check-padding-start * -1;\n  }\n}\n\n.form-check-reverse {\n  padding-right: $form-check-padding-start;\n  padding-left: 0;\n  text-align: right;\n\n  .form-check-input {\n    float: right;\n    margin-right: $form-check-padding-start * -1;\n    margin-left: 0;\n  }\n}\n\n.form-check-input {\n  --#{$prefix}form-check-bg: #{$form-check-input-bg};\n\n  flex-shrink: 0;\n  width: $form-check-input-width;\n  height: $form-check-input-width;\n  margin-top: ($line-height-base - $form-check-input-width) * .5; // line-height minus check height\n  vertical-align: top;\n  appearance: none;\n  background-color: var(--#{$prefix}form-check-bg);\n  background-image: var(--#{$prefix}form-check-bg-image);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: $form-check-input-border;\n  print-color-adjust: exact; // Keep themed appearance for print\n  @include transition($form-check-transition);\n\n  &[type=\"checkbox\"] {\n    @include border-radius($form-check-input-border-radius);\n  }\n\n  &[type=\"radio\"] {\n    // stylelint-disable-next-line property-disallowed-list\n    border-radius: $form-check-radio-border-radius;\n  }\n\n  &:active {\n    filter: $form-check-input-active-filter;\n  }\n\n  &:focus {\n    border-color: $form-check-input-focus-border;\n    outline: 0;\n    box-shadow: $form-check-input-focus-box-shadow;\n  }\n\n  &:checked {\n    background-color: $form-check-input-checked-bg-color;\n    border-color: $form-check-input-checked-border-color;\n\n    &[type=\"checkbox\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-checked-bg-image)};\n      }\n    }\n\n    &[type=\"radio\"] {\n      @if $enable-gradients {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-check-bg-image: #{escape-svg($form-check-radio-checked-bg-image)};\n      }\n    }\n  }\n\n  &[type=\"checkbox\"]:indeterminate {\n    background-color: $form-check-input-indeterminate-bg-color;\n    border-color: $form-check-input-indeterminate-border-color;\n\n    @if $enable-gradients {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)}, var(--#{$prefix}gradient);\n    } @else {\n      --#{$prefix}form-check-bg-image: #{escape-svg($form-check-input-indeterminate-bg-image)};\n    }\n  }\n\n  &:disabled {\n    pointer-events: none;\n    filter: none;\n    opacity: $form-check-input-disabled-opacity;\n  }\n\n  // Use disabled attribute in addition of :disabled pseudo-class\n  // See: https://github.com/twbs/bootstrap/issues/28247\n  &[disabled],\n  &:disabled {\n    ~ .form-check-label {\n      cursor: default;\n      opacity: $form-check-label-disabled-opacity;\n    }\n  }\n}\n\n.form-check-label {\n  color: $form-check-label-color;\n  cursor: $form-check-label-cursor;\n}\n\n//\n// Switch\n//\n\n.form-switch {\n  padding-left: $form-switch-padding-start;\n\n  .form-check-input {\n    --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image)};\n\n    width: $form-switch-width;\n    margin-left: $form-switch-padding-start * -1;\n    background-image: var(--#{$prefix}form-switch-bg);\n    background-position: left center;\n    @include border-radius($form-switch-border-radius, 0);\n    @include transition($form-switch-transition);\n\n    &:focus {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-focus-bg-image)};\n    }\n\n    &:checked {\n      background-position: $form-switch-checked-bg-position;\n\n      @if $enable-gradients {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)}, var(--#{$prefix}gradient);\n      } @else {\n        --#{$prefix}form-switch-bg: #{escape-svg($form-switch-checked-bg-image)};\n      }\n    }\n  }\n\n  &.form-check-reverse {\n    padding-right: $form-switch-padding-start;\n    padding-left: 0;\n\n    .form-check-input {\n      margin-right: $form-switch-padding-start * -1;\n      margin-left: 0;\n    }\n  }\n}\n\n.form-check-inline {\n  display: inline-block;\n  margin-right: $form-check-inline-margin-end;\n}\n\n.btn-check {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n\n  &[disabled],\n  &:disabled {\n    + .btn {\n      pointer-events: none;\n      filter: none;\n      opacity: $form-check-btn-check-disabled-opacity;\n    }\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .form-switch .form-check-input:not(:checked):not(:focus) {\n      --#{$prefix}form-switch-bg: #{escape-svg($form-switch-bg-image-dark)};\n    }\n  }\n}\n","// Range\n//\n// Style range inputs the same across browsers. Vendor-specific rules for pseudo\n// elements cannot be mixed. As such, there are no shared styles for focus or\n// active states on prefixed selectors.\n\n.form-range {\n  width: 100%;\n  height: add($form-range-thumb-height, $form-range-thumb-focus-box-shadow-width * 2);\n  padding: 0; // Need to reset padding\n  appearance: none;\n  background-color: transparent;\n\n  &:focus {\n    outline: 0;\n\n    // Pseudo-elements must be split across multiple rulesets to have an effect.\n    // No box-shadow() mixin for focus accessibility.\n    &::-webkit-slider-thumb { box-shadow: $form-range-thumb-focus-box-shadow; }\n    &::-moz-range-thumb     { box-shadow: $form-range-thumb-focus-box-shadow; }\n  }\n\n  &::-moz-focus-outer {\n    border: 0;\n  }\n\n  &::-webkit-slider-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    margin-top: ($form-range-track-height - $form-range-thumb-height) * .5; // Webkit specific\n    appearance: none;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-webkit-slider-runnable-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent; // Why?\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent;\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &::-moz-range-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    appearance: none;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-moz-range-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent;\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent; // Firefox specific?\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &:disabled {\n    pointer-events: none;\n\n    &::-webkit-slider-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n\n    &::-moz-range-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n  }\n}\n",".form-floating {\n  position: relative;\n\n  > .form-control,\n  > .form-control-plaintext,\n  > .form-select {\n    height: $form-floating-height;\n    min-height: $form-floating-height;\n    line-height: $form-floating-line-height;\n  }\n\n  > label {\n    position: absolute;\n    top: 0;\n    left: 0;\n    z-index: 2;\n    max-width: 100%;\n    height: 100%; // allow textareas\n    padding: $form-floating-padding-y $form-floating-padding-x;\n    overflow: hidden;\n    color: rgba(var(--#{$prefix}body-color-rgb), #{$form-floating-label-opacity});\n    text-align: start;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    pointer-events: none;\n    border: $input-border-width solid transparent; // Required for aligning label's text with the input as it affects inner box model\n    transform-origin: 0 0;\n    @include transition($form-floating-transition);\n  }\n\n  > .form-control,\n  > .form-control-plaintext {\n    padding: $form-floating-padding-y $form-floating-padding-x;\n\n    &::placeholder {\n      color: transparent;\n    }\n\n    &:focus,\n    &:not(:placeholder-shown) {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n    // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n    &:-webkit-autofill {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n  }\n\n  > .form-select {\n    padding-top: $form-floating-input-padding-t;\n    padding-bottom: $form-floating-input-padding-b;\n    padding-left: $form-floating-padding-x;\n  }\n\n  > .form-control:focus,\n  > .form-control:not(:placeholder-shown),\n  > .form-control-plaintext,\n  > .form-select {\n    ~ label {\n      transform: $form-floating-label-transform;\n    }\n  }\n  // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n  > .form-control:-webkit-autofill {\n    ~ label {\n      transform: $form-floating-label-transform;\n    }\n  }\n  > textarea:focus,\n  > textarea:not(:placeholder-shown) {\n    ~ label::after {\n      position: absolute;\n      inset: $form-floating-padding-y ($form-floating-padding-x * .5);\n      z-index: -1;\n      height: $form-floating-label-height;\n      content: \"\";\n      background-color: $input-bg;\n      @include border-radius($input-border-radius);\n    }\n  }\n  > textarea:disabled ~ label::after {\n    background-color: $input-disabled-bg;\n  }\n\n  > .form-control-plaintext {\n    ~ label {\n      border-width: $input-border-width 0; // Required to properly position label text - as explained above\n    }\n  }\n\n  > :disabled ~ label,\n  > .form-control:disabled ~ label { // Required for `.form-control`s because of specificity\n    color: $form-floating-label-disabled-color;\n  }\n}\n","//\n// Base styles\n//\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // For form validation feedback\n  align-items: stretch;\n  width: 100%;\n\n  > .form-control,\n  > .form-select,\n  > .form-floating {\n    position: relative; // For focus state's z-index\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0; // https://stackoverflow.com/questions/36247140/why-dont-flex-items-shrink-past-content-size\n  }\n\n  // Bring the \"active\" form control to the top of surrounding elements\n  > .form-control:focus,\n  > .form-select:focus,\n  > .form-floating:focus-within {\n    z-index: 5;\n  }\n\n  // Ensure buttons are always above inputs for more visually pleasing borders.\n  // This isn't needed for `.input-group-text` since it shares the same border-color\n  // as our inputs.\n  .btn {\n    position: relative;\n    z-index: 2;\n\n    &:focus {\n      z-index: 5;\n    }\n  }\n}\n\n\n// Textual addons\n//\n// Serves as a catch-all element for any text or radio/checkbox input you wish\n// to prepend or append to an input.\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: $input-group-addon-padding-y $input-group-addon-padding-x;\n  @include font-size($input-font-size); // Match inputs\n  font-weight: $input-group-addon-font-weight;\n  line-height: $input-line-height;\n  color: $input-group-addon-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $input-group-addon-bg;\n  border: $input-border-width solid $input-group-addon-border-color;\n  @include border-radius($input-border-radius);\n}\n\n\n// Sizing\n//\n// Remix the default form control sizing classes into new ones for easier\n// manipulation.\n\n.input-group-lg > .form-control,\n.input-group-lg > .form-select,\n.input-group-lg > .input-group-text,\n.input-group-lg > .btn {\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .form-select,\n.input-group-sm > .input-group-text,\n.input-group-sm > .btn {\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n}\n\n.input-group-lg > .form-select,\n.input-group-sm > .form-select {\n  padding-right: $form-select-padding-x + $form-select-indicator-padding;\n}\n\n\n// Rounded corners\n//\n// These rulesets must come after the sizing ones to properly override sm and lg\n// border-radius values when extending. They're more specific than we'd like\n// with the `.input-group >` part, but without it, we cannot override the sizing.\n\n// stylelint-disable-next-line no-duplicate-selectors\n.input-group {\n  &:not(.has-validation) {\n    > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 3),\n    > .form-floating:not(:last-child) > .form-control,\n    > .form-floating:not(:last-child) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  &.has-validation {\n    > :nth-last-child(n + 3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 4),\n    > .form-floating:nth-last-child(n + 3) > .form-control,\n    > .form-floating:nth-last-child(n + 3) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  $validation-messages: \"\";\n  @each $state in map-keys($form-validation-states) {\n    $validation-messages: $validation-messages + \":not(.\" + unquote($state) + \"-tooltip)\" + \":not(.\" + unquote($state) + \"-feedback)\";\n  }\n\n  > :not(:first-child):not(.dropdown-menu)#{$validation-messages} {\n    margin-left: calc(-1 * #{$input-border-width}); // stylelint-disable-line function-disallowed-list\n    @include border-start-radius(0);\n  }\n\n  > .form-floating:not(:first-child) > .form-control,\n  > .form-floating:not(:first-child) > .form-select {\n    @include border-start-radius(0);\n  }\n}\n","// This mixin uses an `if()` technique to be compatible with Dart Sass\n// See https://github.com/sass/sass/issues/1873#issuecomment-152293725 for more details\n\n// scss-docs-start form-validation-mixins\n@mixin form-validation-state-selector($state) {\n  @if ($state == \"valid\" or $state == \"invalid\") {\n    .was-validated #{if(&, \"&\", \"\")}:#{$state},\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  } @else {\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  }\n}\n\n@mixin form-validation-state(\n  $state,\n  $color,\n  $icon,\n  $tooltip-color: color-contrast($color),\n  $tooltip-bg-color: rgba($color, $form-feedback-tooltip-opacity),\n  $focus-box-shadow: 0 0 $input-btn-focus-blur $input-focus-width rgba($color, $input-btn-focus-color-opacity),\n  $border-color: $color\n) {\n  .#{$state}-feedback {\n    display: none;\n    width: 100%;\n    margin-top: $form-feedback-margin-top;\n    @include font-size($form-feedback-font-size);\n    font-style: $form-feedback-font-style;\n    color: $color;\n  }\n\n  .#{$state}-tooltip {\n    position: absolute;\n    top: 100%;\n    z-index: 5;\n    display: none;\n    max-width: 100%; // Contain to parent when possible\n    padding: $form-feedback-tooltip-padding-y $form-feedback-tooltip-padding-x;\n    margin-top: .1rem;\n    @include font-size($form-feedback-tooltip-font-size);\n    line-height: $form-feedback-tooltip-line-height;\n    color: $tooltip-color;\n    background-color: $tooltip-bg-color;\n    @include border-radius($form-feedback-tooltip-border-radius);\n  }\n\n  @include form-validation-state-selector($state) {\n    ~ .#{$state}-feedback,\n    ~ .#{$state}-tooltip {\n      display: block;\n    }\n  }\n\n  .form-control {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-image: escape-svg($icon);\n        background-repeat: no-repeat;\n        background-position: right $input-height-inner-quarter center;\n        background-size: $input-height-inner-half $input-height-inner-half;\n      }\n\n      &:focus {\n        border-color: $border-color;\n        @if $enable-shadows {\n          @include box-shadow($input-box-shadow, $focus-box-shadow);\n        } @else {\n          // Avoid using mixin so we can pass custom focus shadow properly\n          box-shadow: $focus-box-shadow;\n        }\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  textarea.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-position: top $input-height-inner-quarter right $input-height-inner-quarter;\n      }\n    }\n  }\n\n  .form-select {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        &:not([multiple]):not([size]),\n        &:not([multiple])[size=\"1\"] {\n          --#{$prefix}form-select-bg-icon: #{escape-svg($icon)};\n          padding-right: $form-select-feedback-icon-padding-end;\n          background-position: $form-select-bg-position, $form-select-feedback-icon-position;\n          background-size: $form-select-bg-size, $form-select-feedback-icon-size;\n        }\n      }\n\n      &:focus {\n        border-color: $border-color;\n        @if $enable-shadows {\n          @include box-shadow($form-select-box-shadow, $focus-box-shadow);\n        } @else {\n          // Avoid using mixin so we can pass custom focus shadow properly\n          box-shadow: $focus-box-shadow;\n        }\n      }\n    }\n  }\n\n  .form-control-color {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        width: add($form-color-width, $input-height-inner);\n      }\n    }\n  }\n\n  .form-check-input {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      &:checked {\n        background-color: $color;\n      }\n\n      &:focus {\n        box-shadow: $focus-box-shadow;\n      }\n\n      ~ .form-check-label {\n        color: $color;\n      }\n    }\n  }\n  .form-check-inline .form-check-input {\n    ~ .#{$state}-feedback {\n      margin-left: .5em;\n    }\n  }\n\n  .input-group {\n    > .form-control:not(:focus),\n    > .form-select:not(:focus),\n    > .form-floating:not(:focus-within) {\n      @include form-validation-state-selector($state) {\n        @if $state == \"valid\" {\n          z-index: 3;\n        } @else if $state == \"invalid\" {\n          z-index: 4;\n        }\n      }\n    }\n  }\n}\n// scss-docs-end form-validation-mixins\n","//\n// Base styles\n//\n\n.btn {\n  // scss-docs-start btn-css-vars\n  --#{$prefix}btn-padding-x: #{$btn-padding-x};\n  --#{$prefix}btn-padding-y: #{$btn-padding-y};\n  --#{$prefix}btn-font-family: #{$btn-font-family};\n  @include rfs($btn-font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-font-weight: #{$btn-font-weight};\n  --#{$prefix}btn-line-height: #{$btn-line-height};\n  --#{$prefix}btn-color: #{$btn-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-width: #{$btn-border-width};\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-border-radius: #{$btn-border-radius};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-box-shadow: #{$btn-box-shadow};\n  --#{$prefix}btn-disabled-opacity: #{$btn-disabled-opacity};\n  --#{$prefix}btn-focus-box-shadow: 0 0 0 #{$btn-focus-width} rgba(var(--#{$prefix}btn-focus-shadow-rgb), .5);\n  // scss-docs-end btn-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}btn-padding-y) var(--#{$prefix}btn-padding-x);\n  font-family: var(--#{$prefix}btn-font-family);\n  @include font-size(var(--#{$prefix}btn-font-size));\n  font-weight: var(--#{$prefix}btn-font-weight);\n  line-height: var(--#{$prefix}btn-line-height);\n  color: var(--#{$prefix}btn-color);\n  text-align: center;\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: $btn-white-space;\n  vertical-align: middle;\n  cursor: if($enable-button-pointers, pointer, null);\n  user-select: none;\n  border: var(--#{$prefix}btn-border-width) solid var(--#{$prefix}btn-border-color);\n  @include border-radius(var(--#{$prefix}btn-border-radius));\n  @include gradient-bg(var(--#{$prefix}btn-bg));\n  @include box-shadow(var(--#{$prefix}btn-box-shadow));\n  @include transition($btn-transition);\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}btn-hover-bg);\n    border-color: var(--#{$prefix}btn-hover-border-color);\n  }\n\n  .btn-check + &:hover {\n    // override for the checkbox/radio buttons\n    color: var(--#{$prefix}btn-color);\n    background-color: var(--#{$prefix}btn-bg);\n    border-color: var(--#{$prefix}btn-border-color);\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-hover-color);\n    @include gradient-bg(var(--#{$prefix}btn-hover-bg));\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:focus-visible + & {\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:checked + &,\n  :not(.btn-check) + &:active,\n  &:first-child:active,\n  &.active,\n  &.show {\n    color: var(--#{$prefix}btn-active-color);\n    background-color: var(--#{$prefix}btn-active-bg);\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-active-border-color);\n    @include box-shadow(var(--#{$prefix}btn-active-shadow));\n\n    &:focus-visible {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      @if $enable-shadows {\n        box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n      } @else {\n        box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n      }\n    }\n  }\n\n  .btn-check:checked:focus-visible + & {\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  &:disabled,\n  &.disabled,\n  fieldset:disabled & {\n    color: var(--#{$prefix}btn-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}btn-disabled-bg);\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-disabled-border-color);\n    opacity: var(--#{$prefix}btn-disabled-opacity);\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Alternate buttons\n//\n\n// scss-docs-start btn-variant-loops\n@each $color, $value in $theme-colors {\n  .btn-#{$color} {\n    @if $color == \"light\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: shade-color($value, $btn-hover-bg-shade-amount),\n        $hover-border: shade-color($value, $btn-hover-border-shade-amount),\n        $active-background: shade-color($value, $btn-active-bg-shade-amount),\n        $active-border: shade-color($value, $btn-active-border-shade-amount)\n      );\n    } @else if $color == \"dark\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: tint-color($value, $btn-hover-bg-tint-amount),\n        $hover-border: tint-color($value, $btn-hover-border-tint-amount),\n        $active-background: tint-color($value, $btn-active-bg-tint-amount),\n        $active-border: tint-color($value, $btn-active-border-tint-amount)\n      );\n    } @else {\n      @include button-variant($value, $value);\n    }\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .btn-outline-#{$color} {\n    @include button-outline-variant($value);\n  }\n}\n// scss-docs-end btn-variant-loops\n\n\n//\n// Link buttons\n//\n\n// Make a button look and behave like a link\n.btn-link {\n  --#{$prefix}btn-font-weight: #{$font-weight-normal};\n  --#{$prefix}btn-color: #{$btn-link-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-hover-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-active-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-active-border-color: transparent;\n  --#{$prefix}btn-disabled-color: #{$btn-link-disabled-color};\n  --#{$prefix}btn-disabled-border-color: transparent;\n  --#{$prefix}btn-box-shadow: 0 0 0 #000; // Can't use `none` as keyword negates all values when used with multiple shadows\n  --#{$prefix}btn-focus-shadow-rgb: #{$btn-link-focus-shadow-rgb};\n\n  text-decoration: $link-decoration;\n  @if $enable-gradients {\n    background-image: none;\n  }\n\n  &:hover,\n  &:focus-visible {\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-color);\n  }\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n  }\n\n  // No need for an active state here\n}\n\n\n//\n// Button Sizes\n//\n\n.btn-lg {\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $btn-font-size-lg, $btn-border-radius-lg);\n}\n\n.btn-sm {\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $btn-font-size-sm, $btn-border-radius-sm);\n}\n","// Button variants\n//\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n\n// scss-docs-start btn-variant-mixin\n@mixin button-variant(\n  $background,\n  $border,\n  $color: color-contrast($background),\n  $hover-background: if($color == $color-contrast-light, shade-color($background, $btn-hover-bg-shade-amount), tint-color($background, $btn-hover-bg-tint-amount)),\n  $hover-border: if($color == $color-contrast-light, shade-color($border, $btn-hover-border-shade-amount), tint-color($border, $btn-hover-border-tint-amount)),\n  $hover-color: color-contrast($hover-background),\n  $active-background: if($color == $color-contrast-light, shade-color($background, $btn-active-bg-shade-amount), tint-color($background, $btn-active-bg-tint-amount)),\n  $active-border: if($color == $color-contrast-light, shade-color($border, $btn-active-border-shade-amount), tint-color($border, $btn-active-border-tint-amount)),\n  $active-color: color-contrast($active-background),\n  $disabled-background: $background,\n  $disabled-border: $border,\n  $disabled-color: color-contrast($disabled-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-bg: #{$background};\n  --#{$prefix}btn-border-color: #{$border};\n  --#{$prefix}btn-hover-color: #{$hover-color};\n  --#{$prefix}btn-hover-bg: #{$hover-background};\n  --#{$prefix}btn-hover-border-color: #{$hover-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb(mix($color, $border, 15%))};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$disabled-color};\n  --#{$prefix}btn-disabled-bg: #{$disabled-background};\n  --#{$prefix}btn-disabled-border-color: #{$disabled-border};\n}\n// scss-docs-end btn-variant-mixin\n\n// scss-docs-start btn-outline-variant-mixin\n@mixin button-outline-variant(\n  $color,\n  $color-hover: color-contrast($color),\n  $active-background: $color,\n  $active-border: $color,\n  $active-color: color-contrast($active-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-border-color: #{$color};\n  --#{$prefix}btn-hover-color: #{$color-hover};\n  --#{$prefix}btn-hover-bg: #{$active-background};\n  --#{$prefix}btn-hover-border-color: #{$active-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb($color)};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$color};\n  --#{$prefix}btn-disabled-bg: transparent;\n  --#{$prefix}btn-disabled-border-color: #{$color};\n  --#{$prefix}gradient: none;\n}\n// scss-docs-end btn-outline-variant-mixin\n\n// scss-docs-start btn-size-mixin\n@mixin button-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}btn-padding-y: #{$padding-y};\n  --#{$prefix}btn-padding-x: #{$padding-x};\n  @include rfs($font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-border-radius: #{$border-radius};\n}\n// scss-docs-end btn-size-mixin\n",".fade {\n  @include transition($transition-fade);\n\n  &:not(.show) {\n    opacity: 0;\n  }\n}\n\n// scss-docs-start collapse-classes\n.collapse {\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.collapsing {\n  height: 0;\n  overflow: hidden;\n  @include transition($transition-collapse);\n\n  &.collapse-horizontal {\n    width: 0;\n    height: auto;\n    @include transition($transition-collapse-width);\n  }\n}\n// scss-docs-end collapse-classes\n","// The dropdown wrapper (`<div>`)\n.dropup,\n.dropend,\n.dropdown,\n.dropstart,\n.dropup-center,\n.dropdown-center {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n\n  // Generate the caret automatically\n  @include caret();\n}\n\n// The dropdown menu\n.dropdown-menu {\n  // scss-docs-start dropdown-css-vars\n  --#{$prefix}dropdown-zindex: #{$zindex-dropdown};\n  --#{$prefix}dropdown-min-width: #{$dropdown-min-width};\n  --#{$prefix}dropdown-padding-x: #{$dropdown-padding-x};\n  --#{$prefix}dropdown-padding-y: #{$dropdown-padding-y};\n  --#{$prefix}dropdown-spacer: #{$dropdown-spacer};\n  @include rfs($dropdown-font-size, --#{$prefix}dropdown-font-size);\n  --#{$prefix}dropdown-color: #{$dropdown-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-border-color};\n  --#{$prefix}dropdown-border-radius: #{$dropdown-border-radius};\n  --#{$prefix}dropdown-border-width: #{$dropdown-border-width};\n  --#{$prefix}dropdown-inner-border-radius: #{$dropdown-inner-border-radius};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-divider-bg};\n  --#{$prefix}dropdown-divider-margin-y: #{$dropdown-divider-margin-y};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-link-hover-color};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-link-disabled-color};\n  --#{$prefix}dropdown-item-padding-x: #{$dropdown-item-padding-x};\n  --#{$prefix}dropdown-item-padding-y: #{$dropdown-item-padding-y};\n  --#{$prefix}dropdown-header-color: #{$dropdown-header-color};\n  --#{$prefix}dropdown-header-padding-x: #{$dropdown-header-padding-x};\n  --#{$prefix}dropdown-header-padding-y: #{$dropdown-header-padding-y};\n  // scss-docs-end dropdown-css-vars\n\n  position: absolute;\n  z-index: var(--#{$prefix}dropdown-zindex);\n  display: none; // none by default, but block on \"open\" of the menu\n  min-width: var(--#{$prefix}dropdown-min-width);\n  padding: var(--#{$prefix}dropdown-padding-y) var(--#{$prefix}dropdown-padding-x);\n  margin: 0; // Override default margin of ul\n  @include font-size(var(--#{$prefix}dropdown-font-size));\n  color: var(--#{$prefix}dropdown-color);\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  list-style: none;\n  background-color: var(--#{$prefix}dropdown-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}dropdown-border-width) solid var(--#{$prefix}dropdown-border-color);\n  @include border-radius(var(--#{$prefix}dropdown-border-radius));\n  @include box-shadow(var(--#{$prefix}dropdown-box-shadow));\n\n  &[data-bs-popper] {\n    top: 100%;\n    left: 0;\n    margin-top: var(--#{$prefix}dropdown-spacer);\n  }\n\n  @if $dropdown-padding-y == 0 {\n    > .dropdown-item:first-child,\n    > li:first-child .dropdown-item {\n      @include border-top-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n    > .dropdown-item:last-child,\n    > li:last-child .dropdown-item {\n      @include border-bottom-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n\n  }\n}\n\n// scss-docs-start responsive-breakpoints\n// We deliberately hardcode the `bs-` prefix because we check\n// this custom property in JS to determine Popper's positioning\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .dropdown-menu#{$infix}-start {\n      --bs-position: start;\n\n      &[data-bs-popper] {\n        right: auto;\n        left: 0;\n      }\n    }\n\n    .dropdown-menu#{$infix}-end {\n      --bs-position: end;\n\n      &[data-bs-popper] {\n        right: 0;\n        left: auto;\n      }\n    }\n  }\n}\n// scss-docs-end responsive-breakpoints\n\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\n// Just add .dropup after the standard .dropdown class and you're set.\n.dropup {\n  .dropdown-menu[data-bs-popper] {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(up);\n  }\n}\n\n.dropend {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: auto;\n    left: 100%;\n    margin-top: 0;\n    margin-left: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(end);\n    &::after {\n      vertical-align: 0;\n    }\n  }\n}\n\n.dropstart {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: 100%;\n    left: auto;\n    margin-top: 0;\n    margin-right: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(start);\n    &::before {\n      vertical-align: 0;\n    }\n  }\n}\n\n\n// Dividers (basically an `<hr>`) within the dropdown\n.dropdown-divider {\n  height: 0;\n  margin: var(--#{$prefix}dropdown-divider-margin-y) 0;\n  overflow: hidden;\n  border-top: 1px solid var(--#{$prefix}dropdown-divider-bg);\n  opacity: 1; // Revisit in v6 to de-dupe styles that conflict with <hr> element\n}\n\n// Links, buttons, and more within the dropdown menu\n//\n// `<button>`-specific styles are denoted with `// For <button>s`\n.dropdown-item {\n  display: block;\n  width: 100%; // For `<button>`s\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  clear: both;\n  font-weight: $font-weight-normal;\n  color: var(--#{$prefix}dropdown-link-color);\n  text-align: inherit; // For `<button>`s\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\n  background-color: transparent; // For `<button>`s\n  border: 0; // For `<button>`s\n  @include border-radius(var(--#{$prefix}dropdown-item-border-radius, 0));\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}dropdown-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    @include gradient-bg(var(--#{$prefix}dropdown-link-hover-bg));\n  }\n\n  &.active,\n  &:active {\n    color: var(--#{$prefix}dropdown-link-active-color);\n    text-decoration: none;\n    @include gradient-bg(var(--#{$prefix}dropdown-link-active-bg));\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}dropdown-link-disabled-color);\n    pointer-events: none;\n    background-color: transparent;\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n  }\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n// Dropdown section headers\n.dropdown-header {\n  display: block;\n  padding: var(--#{$prefix}dropdown-header-padding-y) var(--#{$prefix}dropdown-header-padding-x);\n  margin-bottom: 0; // for use with heading elements\n  @include font-size($font-size-sm);\n  color: var(--#{$prefix}dropdown-header-color);\n  white-space: nowrap; // as with > li > a\n}\n\n// Dropdown text\n.dropdown-item-text {\n  display: block;\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  color: var(--#{$prefix}dropdown-link-color);\n}\n\n// Dark dropdowns\n.dropdown-menu-dark {\n  // scss-docs-start dropdown-dark-css-vars\n  --#{$prefix}dropdown-color: #{$dropdown-dark-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-dark-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-dark-border-color};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-dark-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-dark-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-dark-link-hover-color};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-dark-divider-bg};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-dark-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-dark-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-dark-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-dark-link-disabled-color};\n  --#{$prefix}dropdown-header-color: #{$dropdown-dark-header-color};\n  // scss-docs-end dropdown-dark-css-vars\n}\n","// scss-docs-start caret-mixins\n@mixin caret-down($width: $caret-width) {\n  border-top: $width solid;\n  border-right: $width solid transparent;\n  border-bottom: 0;\n  border-left: $width solid transparent;\n}\n\n@mixin caret-up($width: $caret-width) {\n  border-top: 0;\n  border-right: $width solid transparent;\n  border-bottom: $width solid;\n  border-left: $width solid transparent;\n}\n\n@mixin caret-end($width: $caret-width) {\n  border-top: $width solid transparent;\n  border-right: 0;\n  border-bottom: $width solid transparent;\n  border-left: $width solid;\n}\n\n@mixin caret-start($width: $caret-width) {\n  border-top: $width solid transparent;\n  border-right: $width solid;\n  border-bottom: $width solid transparent;\n}\n\n@mixin caret(\n  $direction: down,\n  $width: $caret-width,\n  $spacing: $caret-spacing,\n  $vertical-align: $caret-vertical-align\n) {\n  @if $enable-caret {\n    &::after {\n      display: inline-block;\n      margin-left: $spacing;\n      vertical-align: $vertical-align;\n      content: \"\";\n      @if $direction == down {\n        @include caret-down($width);\n      } @else if $direction == up {\n        @include caret-up($width);\n      } @else if $direction == end {\n        @include caret-end($width);\n      }\n    }\n\n    @if $direction == start {\n      &::after {\n        display: none;\n      }\n\n      &::before {\n        display: inline-block;\n        margin-right: $spacing;\n        vertical-align: $vertical-align;\n        content: \"\";\n        @include caret-start($width);\n      }\n    }\n\n    &:empty::after {\n      margin-left: 0;\n    }\n  }\n}\n// scss-docs-end caret-mixins\n","// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .btn {\n    position: relative;\n    flex: 1 1 auto;\n  }\n\n  // Bring the hover, focused, and \"active\" buttons to the front to overlay\n  // the borders properly\n  > .btn-check:checked + .btn,\n  > .btn-check:focus + .btn,\n  > .btn:hover,\n  > .btn:focus,\n  > .btn:active,\n  > .btn.active {\n    z-index: 1;\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group {\n  @include border-radius($btn-border-radius);\n\n  // Prevent double borders when buttons are next to each other\n  > :not(.btn-check:first-child) + .btn,\n  > .btn-group:not(:first-child) {\n    margin-left: calc(-1 * #{$btn-border-width}); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn.dropdown-toggle-split:first-child,\n  > .btn-group:not(:last-child) > .btn {\n    @include border-end-radius(0);\n  }\n\n  // The left radius should be 0 if the button is:\n  // - the \"third or more\" child\n  // - the second child and the previous element isn't `.btn-check` (making it the first child visually)\n  // - part of a btn-group which isn't the first child\n  > .btn:nth-child(n + 3),\n  > :not(.btn-check) + .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-start-radius(0);\n  }\n}\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .btn { @extend .btn-sm; }\n.btn-group-lg > .btn { @extend .btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x * .75;\n  padding-left: $btn-padding-x * .75;\n\n  &::after,\n  .dropup &::after,\n  .dropend &::after {\n    margin-left: 0;\n  }\n\n  .dropstart &::before {\n    margin-right: 0;\n  }\n}\n\n.btn-sm + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-sm * .75;\n  padding-left: $btn-padding-x-sm * .75;\n}\n\n.btn-lg + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-lg * .75;\n  padding-left: $btn-padding-x-lg * .75;\n}\n\n\n// The clickable button for toggling the menu\n// Set the same inset shadow as the :active state\n.btn-group.show .dropdown-toggle {\n  @include box-shadow($btn-active-box-shadow);\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  > .btn,\n  > .btn-group {\n    width: 100%;\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-top: calc(-1 * #{$btn-border-width}); // stylelint-disable-line function-disallowed-list\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-bottom-radius(0);\n  }\n\n  // The top radius should be 0 if the button is:\n  // - the \"third or more\" child\n  // - the second child and the previous element isn't `.btn-check` (making it the first child visually)\n  // - part of a btn-group which isn't the first child\n  > .btn:nth-child(n + 3),\n  > :not(.btn-check) + .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-top-radius(0);\n  }\n}\n","// Base class\n//\n// Kickstart any navigation component with a set of style resets. Works with\n// `<nav>`s, `<ul>`s or `<ol>`s.\n\n.nav {\n  // scss-docs-start nav-css-vars\n  --#{$prefix}nav-link-padding-x: #{$nav-link-padding-x};\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: #{$nav-link-color};\n  --#{$prefix}nav-link-hover-color: #{$nav-link-hover-color};\n  --#{$prefix}nav-link-disabled-color: #{$nav-link-disabled-color};\n  // scss-docs-end nav-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: var(--#{$prefix}nav-link-padding-y) var(--#{$prefix}nav-link-padding-x);\n  @include font-size(var(--#{$prefix}nav-link-font-size));\n  font-weight: var(--#{$prefix}nav-link-font-weight);\n  color: var(--#{$prefix}nav-link-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background: none;\n  border: 0;\n  @include transition($nav-link-transition);\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}nav-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  &:focus-visible {\n    outline: 0;\n    box-shadow: $nav-link-focus-box-shadow;\n  }\n\n  // Disabled state lightens text\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}nav-link-disabled-color);\n    pointer-events: none;\n    cursor: default;\n  }\n}\n\n//\n// Tabs\n//\n\n.nav-tabs {\n  // scss-docs-start nav-tabs-css-vars\n  --#{$prefix}nav-tabs-border-width: #{$nav-tabs-border-width};\n  --#{$prefix}nav-tabs-border-color: #{$nav-tabs-border-color};\n  --#{$prefix}nav-tabs-border-radius: #{$nav-tabs-border-radius};\n  --#{$prefix}nav-tabs-link-hover-border-color: #{$nav-tabs-link-hover-border-color};\n  --#{$prefix}nav-tabs-link-active-color: #{$nav-tabs-link-active-color};\n  --#{$prefix}nav-tabs-link-active-bg: #{$nav-tabs-link-active-bg};\n  --#{$prefix}nav-tabs-link-active-border-color: #{$nav-tabs-link-active-border-color};\n  // scss-docs-end nav-tabs-css-vars\n\n  border-bottom: var(--#{$prefix}nav-tabs-border-width) solid var(--#{$prefix}nav-tabs-border-color);\n\n  .nav-link {\n    margin-bottom: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    border: var(--#{$prefix}nav-tabs-border-width) solid transparent;\n    @include border-top-radius(var(--#{$prefix}nav-tabs-border-radius));\n\n    &:hover,\n    &:focus {\n      // Prevents active .nav-link tab overlapping focus outline of previous/next .nav-link\n      isolation: isolate;\n      border-color: var(--#{$prefix}nav-tabs-link-hover-border-color);\n    }\n  }\n\n  .nav-link.active,\n  .nav-item.show .nav-link {\n    color: var(--#{$prefix}nav-tabs-link-active-color);\n    background-color: var(--#{$prefix}nav-tabs-link-active-bg);\n    border-color: var(--#{$prefix}nav-tabs-link-active-border-color);\n  }\n\n  .dropdown-menu {\n    // Make dropdown border overlap tab border\n    margin-top: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    // Remove the top rounded corners here since there is a hard edge above the menu\n    @include border-top-radius(0);\n  }\n}\n\n\n//\n// Pills\n//\n\n.nav-pills {\n  // scss-docs-start nav-pills-css-vars\n  --#{$prefix}nav-pills-border-radius: #{$nav-pills-border-radius};\n  --#{$prefix}nav-pills-link-active-color: #{$nav-pills-link-active-color};\n  --#{$prefix}nav-pills-link-active-bg: #{$nav-pills-link-active-bg};\n  // scss-docs-end nav-pills-css-vars\n\n  .nav-link {\n    @include border-radius(var(--#{$prefix}nav-pills-border-radius));\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: var(--#{$prefix}nav-pills-link-active-color);\n    @include gradient-bg(var(--#{$prefix}nav-pills-link-active-bg));\n  }\n}\n\n\n//\n// Underline\n//\n\n.nav-underline {\n  // scss-docs-start nav-underline-css-vars\n  --#{$prefix}nav-underline-gap: #{$nav-underline-gap};\n  --#{$prefix}nav-underline-border-width: #{$nav-underline-border-width};\n  --#{$prefix}nav-underline-link-active-color: #{$nav-underline-link-active-color};\n  // scss-docs-end nav-underline-css-vars\n\n  gap: var(--#{$prefix}nav-underline-gap);\n\n  .nav-link {\n    padding-right: 0;\n    padding-left: 0;\n    border-bottom: var(--#{$prefix}nav-underline-border-width) solid transparent;\n\n    &:hover,\n    &:focus {\n      border-bottom-color: currentcolor;\n    }\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    font-weight: $font-weight-bold;\n    color: var(--#{$prefix}nav-underline-link-active-color);\n    border-bottom-color: currentcolor;\n  }\n}\n\n\n//\n// Justified variants\n//\n\n.nav-fill {\n  > .nav-link,\n  .nav-item {\n    flex: 1 1 auto;\n    text-align: center;\n  }\n}\n\n.nav-justified {\n  > .nav-link,\n  .nav-item {\n    flex-grow: 1;\n    flex-basis: 0;\n    text-align: center;\n  }\n}\n\n.nav-fill,\n.nav-justified {\n  .nav-item .nav-link {\n    width: 100%; // Make sure button will grow\n  }\n}\n\n\n// Tabbable tabs\n//\n// Hide tabbable panes to start, show them when `.active`\n\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n","// Navbar\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  // scss-docs-start navbar-css-vars\n  --#{$prefix}navbar-padding-x: #{if($navbar-padding-x == null, 0, $navbar-padding-x)};\n  --#{$prefix}navbar-padding-y: #{$navbar-padding-y};\n  --#{$prefix}navbar-color: #{$navbar-light-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-light-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-light-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-light-active-color};\n  --#{$prefix}navbar-brand-padding-y: #{$navbar-brand-padding-y};\n  --#{$prefix}navbar-brand-margin-end: #{$navbar-brand-margin-end};\n  --#{$prefix}navbar-brand-font-size: #{$navbar-brand-font-size};\n  --#{$prefix}navbar-brand-color: #{$navbar-light-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-light-brand-hover-color};\n  --#{$prefix}navbar-nav-link-padding-x: #{$navbar-nav-link-padding-x};\n  --#{$prefix}navbar-toggler-padding-y: #{$navbar-toggler-padding-y};\n  --#{$prefix}navbar-toggler-padding-x: #{$navbar-toggler-padding-x};\n  --#{$prefix}navbar-toggler-font-size: #{$navbar-toggler-font-size};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-light-toggler-icon-bg)};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-light-toggler-border-color};\n  --#{$prefix}navbar-toggler-border-radius: #{$navbar-toggler-border-radius};\n  --#{$prefix}navbar-toggler-focus-width: #{$navbar-toggler-focus-width};\n  --#{$prefix}navbar-toggler-transition: #{$navbar-toggler-transition};\n  // scss-docs-end navbar-css-vars\n\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  padding: var(--#{$prefix}navbar-padding-y) var(--#{$prefix}navbar-padding-x);\n  @include gradient-bg();\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  // The `flex-wrap` property is inherited to simplify the expanded navbars\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: inherit;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  > .container,\n  > .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n}\n\n\n// Navbar brand\n//\n// Used for brand, project, or site names.\n\n.navbar-brand {\n  padding-top: var(--#{$prefix}navbar-brand-padding-y);\n  padding-bottom: var(--#{$prefix}navbar-brand-padding-y);\n  margin-right: var(--#{$prefix}navbar-brand-margin-end);\n  @include font-size(var(--#{$prefix}navbar-brand-font-size));\n  color: var(--#{$prefix}navbar-brand-color);\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap;\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}navbar-brand-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n}\n\n\n// Navbar nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.navbar-nav {\n  // scss-docs-start navbar-nav-css-vars\n  --#{$prefix}nav-link-padding-x: 0;\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: var(--#{$prefix}navbar-color);\n  --#{$prefix}nav-link-hover-color: var(--#{$prefix}navbar-hover-color);\n  --#{$prefix}nav-link-disabled-color: var(--#{$prefix}navbar-disabled-color);\n  // scss-docs-end navbar-nav-css-vars\n\n  display: flex;\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    &.active,\n    &.show {\n      color: var(--#{$prefix}navbar-active-color);\n    }\n  }\n\n  .dropdown-menu {\n    position: static;\n  }\n}\n\n\n// Navbar text\n//\n//\n\n.navbar-text {\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n  color: var(--#{$prefix}navbar-color);\n\n  a,\n  a:hover,\n  a:focus  {\n    color: var(--#{$prefix}navbar-active-color);\n  }\n}\n\n\n// Responsive navbar\n//\n// Custom styles for responsive collapsing and toggling of navbar contents.\n// Powered by the collapse Bootstrap JavaScript plugin.\n\n// When collapsed, prevent the toggleable navbar contents from appearing in\n// the default flexbox row orientation. Requires the use of `flex-wrap: wrap`\n// on the `.navbar` parent.\n.navbar-collapse {\n  flex-grow: 1;\n  flex-basis: 100%;\n  // For always expanded or extra full navbars, ensure content aligns itself\n  // properly vertically. Can be easily overridden with flex utilities.\n  align-items: center;\n}\n\n// Button for toggling the navbar when in its collapsed state\n.navbar-toggler {\n  padding: var(--#{$prefix}navbar-toggler-padding-y) var(--#{$prefix}navbar-toggler-padding-x);\n  @include font-size(var(--#{$prefix}navbar-toggler-font-size));\n  line-height: 1;\n  color: var(--#{$prefix}navbar-color);\n  background-color: transparent; // remove default button style\n  border: var(--#{$prefix}border-width) solid var(--#{$prefix}navbar-toggler-border-color); // remove default button style\n  @include border-radius(var(--#{$prefix}navbar-toggler-border-radius));\n  @include transition(var(--#{$prefix}navbar-toggler-transition));\n\n  &:hover {\n    text-decoration: none;\n  }\n\n  &:focus {\n    text-decoration: none;\n    outline: 0;\n    box-shadow: 0 0 0 var(--#{$prefix}navbar-toggler-focus-width);\n  }\n}\n\n// Keep as a separate element so folks can easily override it with another icon\n// or image file as needed.\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  background-image: var(--#{$prefix}navbar-toggler-icon-bg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n.navbar-nav-scroll {\n  max-height: var(--#{$prefix}scroll-height, 75vh);\n  overflow-y: auto;\n}\n\n// scss-docs-start navbar-expand-loop\n// Generate series of `.navbar-expand-*` responsive classes for configuring\n// where your navbar collapses.\n.navbar-expand {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    // stylelint-disable-next-line scss/selector-no-union-class-name\n    &#{$infix} {\n      @include media-breakpoint-up($next) {\n        flex-wrap: nowrap;\n        justify-content: flex-start;\n\n        .navbar-nav {\n          flex-direction: row;\n\n          .dropdown-menu {\n            position: absolute;\n          }\n\n          .nav-link {\n            padding-right: var(--#{$prefix}navbar-nav-link-padding-x);\n            padding-left: var(--#{$prefix}navbar-nav-link-padding-x);\n          }\n        }\n\n        .navbar-nav-scroll {\n          overflow: visible;\n        }\n\n        .navbar-collapse {\n          display: flex !important; // stylelint-disable-line declaration-no-important\n          flex-basis: auto;\n        }\n\n        .navbar-toggler {\n          display: none;\n        }\n\n        .offcanvas {\n          // stylelint-disable declaration-no-important\n          position: static;\n          z-index: auto;\n          flex-grow: 1;\n          width: auto !important;\n          height: auto !important;\n          visibility: visible !important;\n          background-color: transparent !important;\n          border: 0 !important;\n          transform: none !important;\n          @include box-shadow(none);\n          @include transition(none);\n          // stylelint-enable declaration-no-important\n\n          .offcanvas-header {\n            display: none;\n          }\n\n          .offcanvas-body {\n            display: flex;\n            flex-grow: 0;\n            padding: 0;\n            overflow-y: visible;\n          }\n        }\n      }\n    }\n  }\n}\n// scss-docs-end navbar-expand-loop\n\n// Navbar themes\n//\n// Styles for switching between navbars with light or dark background.\n\n.navbar-light {\n  @include deprecate(\"`.navbar-light`\", \"v5.2.0\", \"v6.0.0\", true);\n}\n\n.navbar-dark,\n.navbar[data-bs-theme=\"dark\"] {\n  // scss-docs-start navbar-dark-css-vars\n  --#{$prefix}navbar-color: #{$navbar-dark-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-dark-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-dark-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-dark-active-color};\n  --#{$prefix}navbar-brand-color: #{$navbar-dark-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-dark-brand-hover-color};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-dark-toggler-border-color};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n  // scss-docs-end navbar-dark-css-vars\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .navbar-toggler-icon {\n      --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.card {\n  // scss-docs-start card-css-vars\n  --#{$prefix}card-spacer-y: #{$card-spacer-y};\n  --#{$prefix}card-spacer-x: #{$card-spacer-x};\n  --#{$prefix}card-title-spacer-y: #{$card-title-spacer-y};\n  --#{$prefix}card-title-color: #{$card-title-color};\n  --#{$prefix}card-subtitle-color: #{$card-subtitle-color};\n  --#{$prefix}card-border-width: #{$card-border-width};\n  --#{$prefix}card-border-color: #{$card-border-color};\n  --#{$prefix}card-border-radius: #{$card-border-radius};\n  --#{$prefix}card-box-shadow: #{$card-box-shadow};\n  --#{$prefix}card-inner-border-radius: #{$card-inner-border-radius};\n  --#{$prefix}card-cap-padding-y: #{$card-cap-padding-y};\n  --#{$prefix}card-cap-padding-x: #{$card-cap-padding-x};\n  --#{$prefix}card-cap-bg: #{$card-cap-bg};\n  --#{$prefix}card-cap-color: #{$card-cap-color};\n  --#{$prefix}card-height: #{$card-height};\n  --#{$prefix}card-color: #{$card-color};\n  --#{$prefix}card-bg: #{$card-bg};\n  --#{$prefix}card-img-overlay-padding: #{$card-img-overlay-padding};\n  --#{$prefix}card-group-margin: #{$card-group-margin};\n  // scss-docs-end card-css-vars\n\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0; // See https://github.com/twbs/bootstrap/pull/22740#issuecomment-305868106\n  height: var(--#{$prefix}card-height);\n  color: var(--#{$prefix}body-color);\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}card-bg);\n  background-clip: border-box;\n  border: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n  @include border-radius(var(--#{$prefix}card-border-radius));\n  @include box-shadow(var(--#{$prefix}card-box-shadow));\n\n  > hr {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  > .list-group {\n    border-top: inherit;\n    border-bottom: inherit;\n\n    &:first-child {\n      border-top-width: 0;\n      @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n\n    &:last-child  {\n      border-bottom-width: 0;\n      @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n  }\n\n  // Due to specificity of the above selector (`.card > .list-group`), we must\n  // use a child selector here to prevent double borders.\n  > .card-header + .list-group,\n  > .list-group + .card-footer {\n    border-top: 0;\n  }\n}\n\n.card-body {\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\n  // as much space as possible, ensuring footers are aligned to the bottom.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}card-spacer-y) var(--#{$prefix}card-spacer-x);\n  color: var(--#{$prefix}card-color);\n}\n\n.card-title {\n  margin-bottom: var(--#{$prefix}card-title-spacer-y);\n  color: var(--#{$prefix}card-title-color);\n}\n\n.card-subtitle {\n  margin-top: calc(-.5 * var(--#{$prefix}card-title-spacer-y)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: 0;\n  color: var(--#{$prefix}card-subtitle-color);\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link {\n  &:hover {\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  + .card-link {\n    margin-left: var(--#{$prefix}card-spacer-x);\n  }\n}\n\n//\n// Optional textual caps\n//\n\n.card-header {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-bottom: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:first-child {\n    @include border-radius(var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius) 0 0);\n  }\n}\n\n.card-footer {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-top: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:last-child {\n    @include border-radius(0 0 var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius));\n  }\n}\n\n\n//\n// Header navs\n//\n\n.card-header-tabs {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: calc(-1 * var(--#{$prefix}card-cap-padding-y)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  border-bottom: 0;\n\n  .nav-link.active {\n    background-color: var(--#{$prefix}card-bg);\n    border-bottom-color: var(--#{$prefix}card-bg);\n  }\n}\n\n.card-header-pills {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n}\n\n// Card image\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: var(--#{$prefix}card-img-overlay-padding);\n  @include border-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n}\n\n.card-img,\n.card-img-top {\n  @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-bottom {\n  @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n\n//\n// Card groups\n//\n\n.card-group {\n  // The child selector allows nested `.card` within `.card-group`\n  // to display properly.\n  > .card {\n    margin-bottom: var(--#{$prefix}card-group-margin);\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    // The child selector allows nested `.card` within `.card-group`\n    // to display properly.\n    > .card {\n      flex: 1 0 0;\n      margin-bottom: 0;\n\n      + .card {\n        margin-left: 0;\n        border-left: 0;\n      }\n\n      // Handle rounded corners\n      @if $enable-rounded {\n        &:not(:last-child) {\n          @include border-end-radius(0);\n\n          > .card-img-top,\n          > .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-right-radius: 0;\n          }\n          > .card-img-bottom,\n          > .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-right-radius: 0;\n          }\n        }\n\n        &:not(:first-child) {\n          @include border-start-radius(0);\n\n          > .card-img-top,\n          > .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-left-radius: 0;\n          }\n          > .card-img-bottom,\n          > .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-left-radius: 0;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.accordion {\n  // scss-docs-start accordion-css-vars\n  --#{$prefix}accordion-color: #{$accordion-color};\n  --#{$prefix}accordion-bg: #{$accordion-bg};\n  --#{$prefix}accordion-transition: #{$accordion-transition};\n  --#{$prefix}accordion-border-color: #{$accordion-border-color};\n  --#{$prefix}accordion-border-width: #{$accordion-border-width};\n  --#{$prefix}accordion-border-radius: #{$accordion-border-radius};\n  --#{$prefix}accordion-inner-border-radius: #{$accordion-inner-border-radius};\n  --#{$prefix}accordion-btn-padding-x: #{$accordion-button-padding-x};\n  --#{$prefix}accordion-btn-padding-y: #{$accordion-button-padding-y};\n  --#{$prefix}accordion-btn-color: #{$accordion-button-color};\n  --#{$prefix}accordion-btn-bg: #{$accordion-button-bg};\n  --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon)};\n  --#{$prefix}accordion-btn-icon-width: #{$accordion-icon-width};\n  --#{$prefix}accordion-btn-icon-transform: #{$accordion-icon-transform};\n  --#{$prefix}accordion-btn-icon-transition: #{$accordion-icon-transition};\n  --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon)};\n  --#{$prefix}accordion-btn-focus-box-shadow: #{$accordion-button-focus-box-shadow};\n  --#{$prefix}accordion-body-padding-x: #{$accordion-body-padding-x};\n  --#{$prefix}accordion-body-padding-y: #{$accordion-body-padding-y};\n  --#{$prefix}accordion-active-color: #{$accordion-button-active-color};\n  --#{$prefix}accordion-active-bg: #{$accordion-button-active-bg};\n  // scss-docs-end accordion-css-vars\n}\n\n.accordion-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: var(--#{$prefix}accordion-btn-padding-y) var(--#{$prefix}accordion-btn-padding-x);\n  @include font-size($font-size-base);\n  color: var(--#{$prefix}accordion-btn-color);\n  text-align: left; // Reset button style\n  background-color: var(--#{$prefix}accordion-btn-bg);\n  border: 0;\n  @include border-radius(0);\n  overflow-anchor: none;\n  @include transition(var(--#{$prefix}accordion-transition));\n\n  &:not(.collapsed) {\n    color: var(--#{$prefix}accordion-active-color);\n    background-color: var(--#{$prefix}accordion-active-bg);\n    box-shadow: inset 0 calc(-1 * var(--#{$prefix}accordion-border-width)) 0 var(--#{$prefix}accordion-border-color); // stylelint-disable-line function-disallowed-list\n\n    &::after {\n      background-image: var(--#{$prefix}accordion-btn-active-icon);\n      transform: var(--#{$prefix}accordion-btn-icon-transform);\n    }\n  }\n\n  // Accordion icon\n  &::after {\n    flex-shrink: 0;\n    width: var(--#{$prefix}accordion-btn-icon-width);\n    height: var(--#{$prefix}accordion-btn-icon-width);\n    margin-left: auto;\n    content: \"\";\n    background-image: var(--#{$prefix}accordion-btn-icon);\n    background-repeat: no-repeat;\n    background-size: var(--#{$prefix}accordion-btn-icon-width);\n    @include transition(var(--#{$prefix}accordion-btn-icon-transition));\n  }\n\n  &:hover {\n    z-index: 2;\n  }\n\n  &:focus {\n    z-index: 3;\n    outline: 0;\n    box-shadow: var(--#{$prefix}accordion-btn-focus-box-shadow);\n  }\n}\n\n.accordion-header {\n  margin-bottom: 0;\n}\n\n.accordion-item {\n  color: var(--#{$prefix}accordion-color);\n  background-color: var(--#{$prefix}accordion-bg);\n  border: var(--#{$prefix}accordion-border-width) solid var(--#{$prefix}accordion-border-color);\n\n  &:first-of-type {\n    @include border-top-radius(var(--#{$prefix}accordion-border-radius));\n\n    > .accordion-header .accordion-button {\n      @include border-top-radius(var(--#{$prefix}accordion-inner-border-radius));\n    }\n  }\n\n  &:not(:first-of-type) {\n    border-top: 0;\n  }\n\n  // Only set a border-radius on the last item if the accordion is collapsed\n  &:last-of-type {\n    @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n\n    > .accordion-header .accordion-button {\n      &.collapsed {\n        @include border-bottom-radius(var(--#{$prefix}accordion-inner-border-radius));\n      }\n    }\n\n    > .accordion-collapse {\n      @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n    }\n  }\n}\n\n.accordion-body {\n  padding: var(--#{$prefix}accordion-body-padding-y) var(--#{$prefix}accordion-body-padding-x);\n}\n\n\n// Flush accordion items\n//\n// Remove borders and border-radius to keep accordion items edge-to-edge.\n\n.accordion-flush {\n  > .accordion-item {\n    border-right: 0;\n    border-left: 0;\n    @include border-radius(0);\n\n    &:first-child { border-top: 0; }\n    &:last-child { border-bottom: 0; }\n\n    // stylelint-disable selector-max-class\n    > .accordion-collapse,\n    > .accordion-header .accordion-button,\n    > .accordion-header .accordion-button.collapsed {\n      @include border-radius(0);\n    }\n    // stylelint-enable selector-max-class\n  }\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark) {\n    .accordion-button::after {\n      --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon-dark)};\n      --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon-dark)};\n    }\n  }\n}\n",".breadcrumb {\n  // scss-docs-start breadcrumb-css-vars\n  --#{$prefix}breadcrumb-padding-x: #{$breadcrumb-padding-x};\n  --#{$prefix}breadcrumb-padding-y: #{$breadcrumb-padding-y};\n  --#{$prefix}breadcrumb-margin-bottom: #{$breadcrumb-margin-bottom};\n  @include rfs($breadcrumb-font-size, --#{$prefix}breadcrumb-font-size);\n  --#{$prefix}breadcrumb-bg: #{$breadcrumb-bg};\n  --#{$prefix}breadcrumb-border-radius: #{$breadcrumb-border-radius};\n  --#{$prefix}breadcrumb-divider-color: #{$breadcrumb-divider-color};\n  --#{$prefix}breadcrumb-item-padding-x: #{$breadcrumb-item-padding-x};\n  --#{$prefix}breadcrumb-item-active-color: #{$breadcrumb-active-color};\n  // scss-docs-end breadcrumb-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding: var(--#{$prefix}breadcrumb-padding-y) var(--#{$prefix}breadcrumb-padding-x);\n  margin-bottom: var(--#{$prefix}breadcrumb-margin-bottom);\n  @include font-size(var(--#{$prefix}breadcrumb-font-size));\n  list-style: none;\n  background-color: var(--#{$prefix}breadcrumb-bg);\n  @include border-radius(var(--#{$prefix}breadcrumb-border-radius));\n}\n\n.breadcrumb-item {\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\n  + .breadcrumb-item {\n    padding-left: var(--#{$prefix}breadcrumb-item-padding-x);\n\n    &::before {\n      float: left; // Suppress inline spacings and underlining of the separator\n      padding-right: var(--#{$prefix}breadcrumb-item-padding-x);\n      color: var(--#{$prefix}breadcrumb-divider-color);\n      content: var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider)) #{\"/* rtl:\"} var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider-flipped)) #{\"*/\"};\n    }\n  }\n\n  &.active {\n    color: var(--#{$prefix}breadcrumb-item-active-color);\n  }\n}\n",".pagination {\n  // scss-docs-start pagination-css-vars\n  --#{$prefix}pagination-padding-x: #{$pagination-padding-x};\n  --#{$prefix}pagination-padding-y: #{$pagination-padding-y};\n  @include rfs($pagination-font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-color: #{$pagination-color};\n  --#{$prefix}pagination-bg: #{$pagination-bg};\n  --#{$prefix}pagination-border-width: #{$pagination-border-width};\n  --#{$prefix}pagination-border-color: #{$pagination-border-color};\n  --#{$prefix}pagination-border-radius: #{$pagination-border-radius};\n  --#{$prefix}pagination-hover-color: #{$pagination-hover-color};\n  --#{$prefix}pagination-hover-bg: #{$pagination-hover-bg};\n  --#{$prefix}pagination-hover-border-color: #{$pagination-hover-border-color};\n  --#{$prefix}pagination-focus-color: #{$pagination-focus-color};\n  --#{$prefix}pagination-focus-bg: #{$pagination-focus-bg};\n  --#{$prefix}pagination-focus-box-shadow: #{$pagination-focus-box-shadow};\n  --#{$prefix}pagination-active-color: #{$pagination-active-color};\n  --#{$prefix}pagination-active-bg: #{$pagination-active-bg};\n  --#{$prefix}pagination-active-border-color: #{$pagination-active-border-color};\n  --#{$prefix}pagination-disabled-color: #{$pagination-disabled-color};\n  --#{$prefix}pagination-disabled-bg: #{$pagination-disabled-bg};\n  --#{$prefix}pagination-disabled-border-color: #{$pagination-disabled-border-color};\n  // scss-docs-end pagination-css-vars\n\n  display: flex;\n  @include list-unstyled();\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}pagination-padding-y) var(--#{$prefix}pagination-padding-x);\n  @include font-size(var(--#{$prefix}pagination-font-size));\n  color: var(--#{$prefix}pagination-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}pagination-bg);\n  border: var(--#{$prefix}pagination-border-width) solid var(--#{$prefix}pagination-border-color);\n  @include transition($pagination-transition);\n\n  &:hover {\n    z-index: 2;\n    color: var(--#{$prefix}pagination-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}pagination-hover-bg);\n    border-color: var(--#{$prefix}pagination-hover-border-color);\n  }\n\n  &:focus {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-focus-color);\n    background-color: var(--#{$prefix}pagination-focus-bg);\n    outline: $pagination-focus-outline;\n    box-shadow: var(--#{$prefix}pagination-focus-box-shadow);\n  }\n\n  &.active,\n  .active > & {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-active-color);\n    @include gradient-bg(var(--#{$prefix}pagination-active-bg));\n    border-color: var(--#{$prefix}pagination-active-border-color);\n  }\n\n  &.disabled,\n  .disabled > & {\n    color: var(--#{$prefix}pagination-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}pagination-disabled-bg);\n    border-color: var(--#{$prefix}pagination-disabled-border-color);\n  }\n}\n\n.page-item {\n  &:not(:first-child) .page-link {\n    margin-left: $pagination-margin-start;\n  }\n\n  @if $pagination-margin-start == calc(-1 * #{$pagination-border-width}) {\n    &:first-child {\n      .page-link {\n        @include border-start-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n\n    &:last-child {\n      .page-link {\n        @include border-end-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n  } @else {\n    // Add border-radius to all pageLinks in case they have left margin\n    .page-link {\n      @include border-radius(var(--#{$prefix}pagination-border-radius));\n    }\n  }\n}\n\n\n//\n// Sizing\n//\n\n.pagination-lg {\n  @include pagination-size($pagination-padding-y-lg, $pagination-padding-x-lg, $font-size-lg, $pagination-border-radius-lg);\n}\n\n.pagination-sm {\n  @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $pagination-border-radius-sm);\n}\n","// Pagination\n\n// scss-docs-start pagination-mixin\n@mixin pagination-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}pagination-padding-x: #{$padding-x};\n  --#{$prefix}pagination-padding-y: #{$padding-y};\n  @include rfs($font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-border-radius: #{$border-radius};\n}\n// scss-docs-end pagination-mixin\n","// Base class\n//\n// Requires one of the contextual, color modifier classes for `color` and\n// `background-color`.\n\n.badge {\n  // scss-docs-start badge-css-vars\n  --#{$prefix}badge-padding-x: #{$badge-padding-x};\n  --#{$prefix}badge-padding-y: #{$badge-padding-y};\n  @include rfs($badge-font-size, --#{$prefix}badge-font-size);\n  --#{$prefix}badge-font-weight: #{$badge-font-weight};\n  --#{$prefix}badge-color: #{$badge-color};\n  --#{$prefix}badge-border-radius: #{$badge-border-radius};\n  // scss-docs-end badge-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}badge-padding-y) var(--#{$prefix}badge-padding-x);\n  @include font-size(var(--#{$prefix}badge-font-size));\n  font-weight: var(--#{$prefix}badge-font-weight);\n  line-height: 1;\n  color: var(--#{$prefix}badge-color);\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  @include border-radius(var(--#{$prefix}badge-border-radius));\n  @include gradient-bg();\n\n  // Empty badges collapse automatically\n  &:empty {\n    display: none;\n  }\n}\n\n// Quick fix for badges in buttons\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n","//\n// Base styles\n//\n\n.alert {\n  // scss-docs-start alert-css-vars\n  --#{$prefix}alert-bg: transparent;\n  --#{$prefix}alert-padding-x: #{$alert-padding-x};\n  --#{$prefix}alert-padding-y: #{$alert-padding-y};\n  --#{$prefix}alert-margin-bottom: #{$alert-margin-bottom};\n  --#{$prefix}alert-color: inherit;\n  --#{$prefix}alert-border-color: transparent;\n  --#{$prefix}alert-border: #{$alert-border-width} solid var(--#{$prefix}alert-border-color);\n  --#{$prefix}alert-border-radius: #{$alert-border-radius};\n  --#{$prefix}alert-link-color: inherit;\n  // scss-docs-end alert-css-vars\n\n  position: relative;\n  padding: var(--#{$prefix}alert-padding-y) var(--#{$prefix}alert-padding-x);\n  margin-bottom: var(--#{$prefix}alert-margin-bottom);\n  color: var(--#{$prefix}alert-color);\n  background-color: var(--#{$prefix}alert-bg);\n  border: var(--#{$prefix}alert-border);\n  @include border-radius(var(--#{$prefix}alert-border-radius));\n}\n\n// Headings for larger alerts\n.alert-heading {\n  // Specified to prevent conflicts of changing $headings-color\n  color: inherit;\n}\n\n// Provide class for links that match alerts\n.alert-link {\n  font-weight: $alert-link-font-weight;\n  color: var(--#{$prefix}alert-link-color);\n}\n\n\n// Dismissible alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n.alert-dismissible {\n  padding-right: $alert-dismissible-padding-r;\n\n  // Adjust close link position\n  .btn-close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: $stretched-link-z-index + 1;\n    padding: $alert-padding-y * 1.25 $alert-padding-x;\n  }\n}\n\n\n// scss-docs-start alert-modifiers\n// Generate contextual modifier classes for colorizing the alert\n@each $state in map-keys($theme-colors) {\n  .alert-#{$state} {\n    --#{$prefix}alert-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}alert-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}alert-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}alert-link-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end alert-modifiers\n","// Disable animation if transitions are disabled\n\n// scss-docs-start progress-keyframes\n@if $enable-transitions {\n  @keyframes progress-bar-stripes {\n    0% { background-position-x: var(--#{$prefix}progress-height); }\n  }\n}\n// scss-docs-end progress-keyframes\n\n.progress,\n.progress-stacked {\n  // scss-docs-start progress-css-vars\n  --#{$prefix}progress-height: #{$progress-height};\n  @include rfs($progress-font-size, --#{$prefix}progress-font-size);\n  --#{$prefix}progress-bg: #{$progress-bg};\n  --#{$prefix}progress-border-radius: #{$progress-border-radius};\n  --#{$prefix}progress-box-shadow: #{$progress-box-shadow};\n  --#{$prefix}progress-bar-color: #{$progress-bar-color};\n  --#{$prefix}progress-bar-bg: #{$progress-bar-bg};\n  --#{$prefix}progress-bar-transition: #{$progress-bar-transition};\n  // scss-docs-end progress-css-vars\n\n  display: flex;\n  height: var(--#{$prefix}progress-height);\n  overflow: hidden; // force rounded corners by cropping it\n  @include font-size(var(--#{$prefix}progress-font-size));\n  background-color: var(--#{$prefix}progress-bg);\n  @include border-radius(var(--#{$prefix}progress-border-radius));\n  @include box-shadow(var(--#{$prefix}progress-box-shadow));\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: var(--#{$prefix}progress-bar-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--#{$prefix}progress-bar-bg);\n  @include transition(var(--#{$prefix}progress-bar-transition));\n}\n\n.progress-bar-striped {\n  @include gradient-striped();\n  background-size: var(--#{$prefix}progress-height) var(--#{$prefix}progress-height);\n}\n\n.progress-stacked > .progress {\n  overflow: visible;\n}\n\n.progress-stacked > .progress > .progress-bar {\n  width: 100%;\n}\n\n@if $enable-transitions {\n  .progress-bar-animated {\n    animation: $progress-bar-animation-timing progress-bar-stripes;\n\n    @if $enable-reduced-motion {\n      @media (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n  }\n}\n","// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n\n.list-group {\n  // scss-docs-start list-group-css-vars\n  --#{$prefix}list-group-color: #{$list-group-color};\n  --#{$prefix}list-group-bg: #{$list-group-bg};\n  --#{$prefix}list-group-border-color: #{$list-group-border-color};\n  --#{$prefix}list-group-border-width: #{$list-group-border-width};\n  --#{$prefix}list-group-border-radius: #{$list-group-border-radius};\n  --#{$prefix}list-group-item-padding-x: #{$list-group-item-padding-x};\n  --#{$prefix}list-group-item-padding-y: #{$list-group-item-padding-y};\n  --#{$prefix}list-group-action-color: #{$list-group-action-color};\n  --#{$prefix}list-group-action-hover-color: #{$list-group-action-hover-color};\n  --#{$prefix}list-group-action-hover-bg: #{$list-group-hover-bg};\n  --#{$prefix}list-group-action-active-color: #{$list-group-action-active-color};\n  --#{$prefix}list-group-action-active-bg: #{$list-group-action-active-bg};\n  --#{$prefix}list-group-disabled-color: #{$list-group-disabled-color};\n  --#{$prefix}list-group-disabled-bg: #{$list-group-disabled-bg};\n  --#{$prefix}list-group-active-color: #{$list-group-active-color};\n  --#{$prefix}list-group-active-bg: #{$list-group-active-bg};\n  --#{$prefix}list-group-active-border-color: #{$list-group-active-border-color};\n  // scss-docs-end list-group-css-vars\n\n  display: flex;\n  flex-direction: column;\n\n  // No need to set list-style: none; since .list-group-item is block level\n  padding-left: 0; // reset padding because ul and ol\n  margin-bottom: 0;\n  @include border-radius(var(--#{$prefix}list-group-border-radius));\n}\n\n.list-group-numbered {\n  list-style-type: none;\n  counter-reset: section;\n\n  > .list-group-item::before {\n    // Increments only this instance of the section counter\n    content: counters(section, \".\") \". \";\n    counter-increment: section;\n  }\n}\n\n// Individual list items\n//\n// Use on `li`s or `div`s within the `.list-group` parent.\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}list-group-item-padding-y) var(--#{$prefix}list-group-item-padding-x);\n  color: var(--#{$prefix}list-group-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}list-group-bg);\n  border: var(--#{$prefix}list-group-border-width) solid var(--#{$prefix}list-group-border-color);\n\n  &:first-child {\n    @include border-top-radius(inherit);\n  }\n\n  &:last-child {\n    @include border-bottom-radius(inherit);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}list-group-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}list-group-disabled-bg);\n  }\n\n  // Include both here for `<a>`s and `<button>`s\n  &.active {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-active-color);\n    background-color: var(--#{$prefix}list-group-active-bg);\n    border-color: var(--#{$prefix}list-group-active-border-color);\n  }\n\n  // stylelint-disable-next-line scss/selector-no-redundant-nesting-selector\n  & + .list-group-item {\n    border-top-width: 0;\n\n    &.active {\n      margin-top: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n      border-top-width: var(--#{$prefix}list-group-border-width);\n    }\n  }\n}\n\n// Interactive list items\n//\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\n// list items. Includes an extra `.active` modifier class for selected items.\n\n.list-group-item-action {\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\n  color: var(--#{$prefix}list-group-action-color);\n  text-align: inherit; // For `<button>`s (anchors inherit)\n\n  &:not(.active) {\n    // Hover state\n    &:hover,\n    &:focus {\n      z-index: 1; // Place hover/focus items above their siblings for proper border styling\n      color: var(--#{$prefix}list-group-action-hover-color);\n      text-decoration: none;\n      background-color: var(--#{$prefix}list-group-action-hover-bg);\n    }\n\n    &:active {\n      color: var(--#{$prefix}list-group-action-active-color);\n      background-color: var(--#{$prefix}list-group-action-active-bg);\n    }\n  }\n}\n\n// Horizontal\n//\n// Change the layout of list group items from vertical (default) to horizontal.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .list-group-horizontal#{$infix} {\n      flex-direction: row;\n\n      > .list-group-item {\n        &:first-child:not(:last-child) {\n          @include border-bottom-start-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-top-end-radius(0);\n        }\n\n        &:last-child:not(:first-child) {\n          @include border-top-end-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-bottom-start-radius(0);\n        }\n\n        &.active {\n          margin-top: 0;\n        }\n\n        + .list-group-item {\n          border-top-width: var(--#{$prefix}list-group-border-width);\n          border-left-width: 0;\n\n          &.active {\n            margin-left: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n            border-left-width: var(--#{$prefix}list-group-border-width);\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Flush list items\n//\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\n// useful within other components (e.g., cards).\n\n.list-group-flush {\n  @include border-radius(0);\n\n  > .list-group-item {\n    border-width: 0 0 var(--#{$prefix}list-group-border-width);\n\n    &:last-child {\n      border-bottom-width: 0;\n    }\n  }\n}\n\n\n// scss-docs-start list-group-modifiers\n// List group contextual variants\n//\n// Add modifier classes to change text and background color on individual items.\n// Organizationally, this must come after the `:hover` states.\n\n@each $state in map-keys($theme-colors) {\n  .list-group-item-#{$state} {\n    --#{$prefix}list-group-color: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-bg: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-border-color: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-hover-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-hover-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-action-active-color: var(--#{$prefix}emphasis-color);\n    --#{$prefix}list-group-action-active-bg: var(--#{$prefix}#{$state}-border-subtle);\n    --#{$prefix}list-group-active-color: var(--#{$prefix}#{$state}-bg-subtle);\n    --#{$prefix}list-group-active-bg: var(--#{$prefix}#{$state}-text-emphasis);\n    --#{$prefix}list-group-active-border-color: var(--#{$prefix}#{$state}-text-emphasis);\n  }\n}\n// scss-docs-end list-group-modifiers\n","// Transparent background and border properties included for button version.\n// iOS requires the button element instead of an anchor tag.\n// If you want the anchor version, it requires `href=\"#\"`.\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n\n.btn-close {\n  // scss-docs-start close-css-vars\n  --#{$prefix}btn-close-color: #{$btn-close-color};\n  --#{$prefix}btn-close-bg: #{ escape-svg($btn-close-bg) };\n  --#{$prefix}btn-close-opacity: #{$btn-close-opacity};\n  --#{$prefix}btn-close-hover-opacity: #{$btn-close-hover-opacity};\n  --#{$prefix}btn-close-focus-shadow: #{$btn-close-focus-shadow};\n  --#{$prefix}btn-close-focus-opacity: #{$btn-close-focus-opacity};\n  --#{$prefix}btn-close-disabled-opacity: #{$btn-close-disabled-opacity};\n  // scss-docs-end close-css-vars\n\n  box-sizing: content-box;\n  width: $btn-close-width;\n  height: $btn-close-height;\n  padding: $btn-close-padding-y $btn-close-padding-x;\n  color: var(--#{$prefix}btn-close-color);\n  background: transparent var(--#{$prefix}btn-close-bg) center / $btn-close-width auto no-repeat; // include transparent for button elements\n  filter: var(--#{$prefix}btn-close-filter);\n  border: 0; // for button elements\n  @include border-radius();\n  opacity: var(--#{$prefix}btn-close-opacity);\n\n  // Override <a>'s hover style\n  &:hover {\n    color: var(--#{$prefix}btn-close-color);\n    text-decoration: none;\n    opacity: var(--#{$prefix}btn-close-hover-opacity);\n  }\n\n  &:focus {\n    outline: 0;\n    box-shadow: var(--#{$prefix}btn-close-focus-shadow);\n    opacity: var(--#{$prefix}btn-close-focus-opacity);\n  }\n\n  &:disabled,\n  &.disabled {\n    pointer-events: none;\n    user-select: none;\n    opacity: var(--#{$prefix}btn-close-disabled-opacity);\n  }\n}\n\n@mixin btn-close-white() {\n  --#{$prefix}btn-close-filter: #{$btn-close-filter-dark};\n}\n\n.btn-close-white {\n  @include btn-close-white();\n}\n\n:root,\n[data-bs-theme=\"light\"] {\n  --#{$prefix}btn-close-filter: #{$btn-close-filter};\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n    @include btn-close-white();\n  }\n}\n",".toast {\n  // scss-docs-start toast-css-vars\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n  --#{$prefix}toast-padding-x: #{$toast-padding-x};\n  --#{$prefix}toast-padding-y: #{$toast-padding-y};\n  --#{$prefix}toast-spacing: #{$toast-spacing};\n  --#{$prefix}toast-max-width: #{$toast-max-width};\n  @include rfs($toast-font-size, --#{$prefix}toast-font-size);\n  --#{$prefix}toast-color: #{$toast-color};\n  --#{$prefix}toast-bg: #{$toast-background-color};\n  --#{$prefix}toast-border-width: #{$toast-border-width};\n  --#{$prefix}toast-border-color: #{$toast-border-color};\n  --#{$prefix}toast-border-radius: #{$toast-border-radius};\n  --#{$prefix}toast-box-shadow: #{$toast-box-shadow};\n  --#{$prefix}toast-header-color: #{$toast-header-color};\n  --#{$prefix}toast-header-bg: #{$toast-header-background-color};\n  --#{$prefix}toast-header-border-color: #{$toast-header-border-color};\n  // scss-docs-end toast-css-vars\n\n  width: var(--#{$prefix}toast-max-width);\n  max-width: 100%;\n  @include font-size(var(--#{$prefix}toast-font-size));\n  color: var(--#{$prefix}toast-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}toast-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-border-color);\n  box-shadow: var(--#{$prefix}toast-box-shadow);\n  @include border-radius(var(--#{$prefix}toast-border-radius));\n\n  &.showing {\n    opacity: 0;\n  }\n\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.toast-container {\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n\n  position: absolute;\n  z-index: var(--#{$prefix}toast-zindex);\n  width: max-content;\n  max-width: 100%;\n  pointer-events: none;\n\n  > :not(:last-child) {\n    margin-bottom: var(--#{$prefix}toast-spacing);\n  }\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}toast-padding-y) var(--#{$prefix}toast-padding-x);\n  color: var(--#{$prefix}toast-header-color);\n  background-color: var(--#{$prefix}toast-header-bg);\n  background-clip: padding-box;\n  border-bottom: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-header-border-color);\n  @include border-top-radius(calc(var(--#{$prefix}toast-border-radius) - var(--#{$prefix}toast-border-width)));\n\n  .btn-close {\n    margin-right: calc(-.5 * var(--#{$prefix}toast-padding-x)); // stylelint-disable-line function-disallowed-list\n    margin-left: var(--#{$prefix}toast-padding-x);\n  }\n}\n\n.toast-body {\n  padding: var(--#{$prefix}toast-padding-x);\n  word-wrap: break-word;\n}\n","// stylelint-disable function-disallowed-list\n\n// .modal-open      - body class for killing the scroll\n// .modal           - container to scroll within\n// .modal-dialog    - positioning shell for the actual modal\n// .modal-content   - actual modal w/ bg and corners and stuff\n\n\n// Container that the modal scrolls within\n.modal {\n  // scss-docs-start modal-css-vars\n  --#{$prefix}modal-zindex: #{$zindex-modal};\n  --#{$prefix}modal-width: #{$modal-md};\n  --#{$prefix}modal-padding: #{$modal-inner-padding};\n  --#{$prefix}modal-margin: #{$modal-dialog-margin};\n  --#{$prefix}modal-color: #{$modal-content-color};\n  --#{$prefix}modal-bg: #{$modal-content-bg};\n  --#{$prefix}modal-border-color: #{$modal-content-border-color};\n  --#{$prefix}modal-border-width: #{$modal-content-border-width};\n  --#{$prefix}modal-border-radius: #{$modal-content-border-radius};\n  --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-xs};\n  --#{$prefix}modal-inner-border-radius: #{$modal-content-inner-border-radius};\n  --#{$prefix}modal-header-padding-x: #{$modal-header-padding-x};\n  --#{$prefix}modal-header-padding-y: #{$modal-header-padding-y};\n  --#{$prefix}modal-header-padding: #{$modal-header-padding}; // Todo in v6: Split this padding into x and y\n  --#{$prefix}modal-header-border-color: #{$modal-header-border-color};\n  --#{$prefix}modal-header-border-width: #{$modal-header-border-width};\n  --#{$prefix}modal-title-line-height: #{$modal-title-line-height};\n  --#{$prefix}modal-footer-gap: #{$modal-footer-margin-between};\n  --#{$prefix}modal-footer-bg: #{$modal-footer-bg};\n  --#{$prefix}modal-footer-border-color: #{$modal-footer-border-color};\n  --#{$prefix}modal-footer-border-width: #{$modal-footer-border-width};\n  // scss-docs-end modal-css-vars\n\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--#{$prefix}modal-zindex);\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\n  // https://github.com/twbs/bootstrap/pull/10951.\n  outline: 0;\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\n  // See also https://github.com/twbs/bootstrap/issues/17695\n}\n\n// Shell div to position the modal with bottom padding\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: var(--#{$prefix}modal-margin);\n  // allow clicks to pass through for custom click handling to close modal\n  pointer-events: none;\n\n  // When fading in the modal, animate it to slide down\n  .modal.fade & {\n    transform: $modal-fade-transform;\n    @include transition($modal-transition);\n  }\n  .modal.show & {\n    transform: $modal-show-transform;\n  }\n\n  // When trying to close, animate focus to scale\n  .modal.modal-static & {\n    transform: $modal-scale-transform;\n  }\n}\n\n.modal-dialog-scrollable {\n  height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n\n  .modal-content {\n    max-height: 100%;\n    overflow: hidden;\n  }\n\n  .modal-body {\n    overflow-y: auto;\n  }\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n}\n\n// Actual modal\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\n  // counteract the pointer-events: none; in the .modal-dialog\n  color: var(--#{$prefix}modal-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}modal-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}modal-border-width) solid var(--#{$prefix}modal-border-color);\n  @include border-radius(var(--#{$prefix}modal-border-radius));\n  @include box-shadow(var(--#{$prefix}modal-box-shadow));\n  // Remove focus outline from opened modal\n  outline: 0;\n}\n\n// Modal background\n.modal-backdrop {\n  // scss-docs-start modal-backdrop-css-vars\n  --#{$prefix}backdrop-zindex: #{$zindex-modal-backdrop};\n  --#{$prefix}backdrop-bg: #{$modal-backdrop-bg};\n  --#{$prefix}backdrop-opacity: #{$modal-backdrop-opacity};\n  // scss-docs-end modal-backdrop-css-vars\n\n  @include overlay-backdrop(var(--#{$prefix}backdrop-zindex), var(--#{$prefix}backdrop-bg), var(--#{$prefix}backdrop-opacity));\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.modal-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  padding: var(--#{$prefix}modal-header-padding);\n  border-bottom: var(--#{$prefix}modal-header-border-width) solid var(--#{$prefix}modal-header-border-color);\n  @include border-top-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}modal-header-padding-y) * .5) calc(var(--#{$prefix}modal-header-padding-x) * .5);\n    // Split properties to avoid invalid calc() function if value is 0\n    margin-top: calc(-.5 * var(--#{$prefix}modal-header-padding-y));\n    margin-right: calc(-.5 * var(--#{$prefix}modal-header-padding-x));\n    margin-bottom: calc(-.5 * var(--#{$prefix}modal-header-padding-y));\n    margin-left: auto;\n  }\n}\n\n// Title text within header\n.modal-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}modal-title-line-height);\n}\n\n// Modal body\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\n.modal-body {\n  position: relative;\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\n  // when there should be a fixed height on `.modal-dialog`.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}modal-padding);\n}\n\n// Footer (for actions)\n.modal-footer {\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  align-items: center; // vertically center\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\n  padding: calc(var(--#{$prefix}modal-padding) - var(--#{$prefix}modal-footer-gap) * .5);\n  background-color: var(--#{$prefix}modal-footer-bg);\n  border-top: var(--#{$prefix}modal-footer-border-width) solid var(--#{$prefix}modal-footer-border-color);\n  @include border-bottom-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  // Place margin between footer elements\n  // This solution is far from ideal because of the universal selector usage,\n  // but is needed to fix https://github.com/twbs/bootstrap/issues/24800\n  > * {\n    margin: calc(var(--#{$prefix}modal-footer-gap) * .5); // Todo in v6: replace with gap on parent class\n  }\n}\n\n// Scale up the modal\n@include media-breakpoint-up(sm) {\n  .modal {\n    --#{$prefix}modal-margin: #{$modal-dialog-margin-y-sm-up};\n    --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-sm-up};\n  }\n\n  // Automatically set modal's width for larger viewports\n  .modal-dialog {\n    max-width: var(--#{$prefix}modal-width);\n    margin-right: auto;\n    margin-left: auto;\n  }\n\n  .modal-sm {\n    --#{$prefix}modal-width: #{$modal-sm};\n  }\n}\n\n@include media-breakpoint-up(lg) {\n  .modal-lg,\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-lg};\n  }\n}\n\n@include media-breakpoint-up(xl) {\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-xl};\n  }\n}\n\n// scss-docs-start modal-fullscreen-loop\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n  $postfix: if($infix != \"\", $infix + \"-down\", \"\");\n\n  @include media-breakpoint-down($breakpoint) {\n    .modal-fullscreen#{$postfix} {\n      width: 100vw;\n      max-width: none;\n      height: 100%;\n      margin: 0;\n\n      .modal-content {\n        height: 100%;\n        border: 0;\n        @include border-radius(0);\n      }\n\n      .modal-header,\n      .modal-footer {\n        @include border-radius(0);\n      }\n\n      .modal-body {\n        overflow-y: auto;\n      }\n    }\n  }\n}\n// scss-docs-end modal-fullscreen-loop\n","// Shared between modals and offcanvases\n@mixin overlay-backdrop($zindex, $backdrop-bg, $backdrop-opacity) {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex;\n  width: 100vw;\n  height: 100vh;\n  background-color: $backdrop-bg;\n\n  // Fade for backdrop\n  &.fade { opacity: 0; }\n  &.show { opacity: $backdrop-opacity; }\n}\n","// Base class\n.tooltip {\n  // scss-docs-start tooltip-css-vars\n  --#{$prefix}tooltip-zindex: #{$zindex-tooltip};\n  --#{$prefix}tooltip-max-width: #{$tooltip-max-width};\n  --#{$prefix}tooltip-padding-x: #{$tooltip-padding-x};\n  --#{$prefix}tooltip-padding-y: #{$tooltip-padding-y};\n  --#{$prefix}tooltip-margin: #{$tooltip-margin};\n  @include rfs($tooltip-font-size, --#{$prefix}tooltip-font-size);\n  --#{$prefix}tooltip-color: #{$tooltip-color};\n  --#{$prefix}tooltip-bg: #{$tooltip-bg};\n  --#{$prefix}tooltip-border-radius: #{$tooltip-border-radius};\n  --#{$prefix}tooltip-opacity: #{$tooltip-opacity};\n  --#{$prefix}tooltip-arrow-width: #{$tooltip-arrow-width};\n  --#{$prefix}tooltip-arrow-height: #{$tooltip-arrow-height};\n  // scss-docs-end tooltip-css-vars\n\n  z-index: var(--#{$prefix}tooltip-zindex);\n  display: block;\n  margin: var(--#{$prefix}tooltip-margin);\n  @include deprecate(\"`$tooltip-margin`\", \"v5\", \"v5.x\", true);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}tooltip-font-size));\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\n  word-wrap: break-word;\n  opacity: 0;\n\n  &.show { opacity: var(--#{$prefix}tooltip-opacity); }\n\n  .tooltip-arrow {\n    display: block;\n    width: var(--#{$prefix}tooltip-arrow-width);\n    height: var(--#{$prefix}tooltip-arrow-height);\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-tooltip-top .tooltip-arrow {\n  bottom: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    top: -1px;\n    border-width: var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-top-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-end .tooltip-arrow {\n  left: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    right: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-right-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-bottom .tooltip-arrow {\n  top: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n\n  &::before {\n    bottom: -1px;\n    border-width: 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-bottom-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-start .tooltip-arrow {\n  right: calc(-1 * var(--#{$prefix}tooltip-arrow-height)); // stylelint-disable-line function-disallowed-list\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    left: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-left-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-tooltip-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-tooltip-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-tooltip-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-tooltip-start;\n  }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: var(--#{$prefix}tooltip-max-width);\n  padding: var(--#{$prefix}tooltip-padding-y) var(--#{$prefix}tooltip-padding-x);\n  color: var(--#{$prefix}tooltip-color);\n  text-align: center;\n  background-color: var(--#{$prefix}tooltip-bg);\n  @include border-radius(var(--#{$prefix}tooltip-border-radius));\n}\n","@mixin reset-text {\n  font-family: $font-family-base;\n  // We deliberately do NOT reset font-size or overflow-wrap / word-wrap.\n  font-style: normal;\n  font-weight: $font-weight-normal;\n  line-height: $line-height-base;\n  text-align: left; // Fallback for where `start` is not supported\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n}\n",".popover {\n  // scss-docs-start popover-css-vars\n  --#{$prefix}popover-zindex: #{$zindex-popover};\n  --#{$prefix}popover-max-width: #{$popover-max-width};\n  @include rfs($popover-font-size, --#{$prefix}popover-font-size);\n  --#{$prefix}popover-bg: #{$popover-bg};\n  --#{$prefix}popover-border-width: #{$popover-border-width};\n  --#{$prefix}popover-border-color: #{$popover-border-color};\n  --#{$prefix}popover-border-radius: #{$popover-border-radius};\n  --#{$prefix}popover-inner-border-radius: #{$popover-inner-border-radius};\n  --#{$prefix}popover-box-shadow: #{$popover-box-shadow};\n  --#{$prefix}popover-header-padding-x: #{$popover-header-padding-x};\n  --#{$prefix}popover-header-padding-y: #{$popover-header-padding-y};\n  @include rfs($popover-header-font-size, --#{$prefix}popover-header-font-size);\n  --#{$prefix}popover-header-color: #{$popover-header-color};\n  --#{$prefix}popover-header-bg: #{$popover-header-bg};\n  --#{$prefix}popover-body-padding-x: #{$popover-body-padding-x};\n  --#{$prefix}popover-body-padding-y: #{$popover-body-padding-y};\n  --#{$prefix}popover-body-color: #{$popover-body-color};\n  --#{$prefix}popover-arrow-width: #{$popover-arrow-width};\n  --#{$prefix}popover-arrow-height: #{$popover-arrow-height};\n  --#{$prefix}popover-arrow-border: var(--#{$prefix}popover-border-color);\n  // scss-docs-end popover-css-vars\n\n  z-index: var(--#{$prefix}popover-zindex);\n  display: block;\n  max-width: var(--#{$prefix}popover-max-width);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}popover-font-size));\n  // Allow breaking very long words so they don't overflow the popover's bounds\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}popover-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-radius(var(--#{$prefix}popover-border-radius));\n  @include box-shadow(var(--#{$prefix}popover-box-shadow));\n\n  .popover-arrow {\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    height: var(--#{$prefix}popover-arrow-height);\n\n    &::before,\n    &::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n      border-width: 0;\n    }\n  }\n}\n\n.bs-popover-top {\n  > .popover-arrow {\n    bottom: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      bottom: 0;\n      border-top-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      bottom: var(--#{$prefix}popover-border-width);\n      border-top-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-end {\n  > .popover-arrow {\n    left: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      left: 0;\n      border-right-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      left: var(--#{$prefix}popover-border-width);\n      border-right-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-bottom {\n  > .popover-arrow {\n    top: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      top: 0;\n      border-bottom-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      top: var(--#{$prefix}popover-border-width);\n      border-bottom-color: var(--#{$prefix}popover-bg);\n    }\n  }\n\n  // This will remove the popover-header's border just below the arrow\n  .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    margin-left: calc(-.5 * var(--#{$prefix}popover-arrow-width)); // stylelint-disable-line function-disallowed-list\n    content: \"\";\n    border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-header-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-start {\n  > .popover-arrow {\n    right: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      right: 0;\n      border-left-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      right: var(--#{$prefix}popover-border-width);\n      border-left-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-popover-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-popover-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-popover-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-popover-start;\n  }\n}\n\n// Offset the popover to account for the popover arrow\n.popover-header {\n  padding: var(--#{$prefix}popover-header-padding-y) var(--#{$prefix}popover-header-padding-x);\n  margin-bottom: 0; // Reset the default from Reboot\n  @include font-size(var(--#{$prefix}popover-header-font-size));\n  color: var(--#{$prefix}popover-header-color);\n  background-color: var(--#{$prefix}popover-header-bg);\n  border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-top-radius(var(--#{$prefix}popover-inner-border-radius));\n\n  &:empty {\n    display: none;\n  }\n}\n\n.popover-body {\n  padding: var(--#{$prefix}popover-body-padding-y) var(--#{$prefix}popover-body-padding-x);\n  color: var(--#{$prefix}popover-body-color);\n}\n","// Notes on the classes:\n//\n// 1. .carousel.pointer-event should ideally be pan-y (to allow for users to scroll vertically)\n//    even when their scroll action started on a carousel, but for compatibility (with Firefox)\n//    we're preventing all actions instead\n// 2. The .carousel-item-start and .carousel-item-end is used to indicate where\n//    the active slide is heading.\n// 3. .active.carousel-item is the current slide.\n// 4. .active.carousel-item-start and .active.carousel-item-end is the current\n//    slide in its in-transition state. Only one of these occurs at a time.\n// 5. .carousel-item-next.carousel-item-start and .carousel-item-prev.carousel-item-end\n//    is the upcoming slide in transition.\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  @include clearfix();\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  @include transition($carousel-transition);\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-start),\n.active.carousel-item-end {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-end),\n.active.carousel-item-start {\n  transform: translateX(-100%);\n}\n\n\n//\n// Alternate transitions\n//\n\n.carousel-fade {\n  .carousel-item {\n    opacity: 0;\n    transition-property: opacity;\n    transform: none;\n  }\n\n  .carousel-item.active,\n  .carousel-item-next.carousel-item-start,\n  .carousel-item-prev.carousel-item-end {\n    z-index: 1;\n    opacity: 1;\n  }\n\n  .active.carousel-item-start,\n  .active.carousel-item-end {\n    z-index: 0;\n    opacity: 0;\n    @include transition(opacity 0s $carousel-transition-duration);\n  }\n}\n\n\n//\n// Left/right controls for nav\n//\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  // Use flex for alignment (1-3)\n  display: flex; // 1. allow flex styles\n  align-items: center; // 2. vertically center contents\n  justify-content: center; // 3. horizontally center contents\n  width: $carousel-control-width;\n  padding: 0;\n  color: $carousel-control-color;\n  text-align: center;\n  background: none;\n  filter: var(--#{$prefix}carousel-control-icon-filter);\n  border: 0;\n  opacity: $carousel-control-opacity;\n  @include transition($carousel-control-transition);\n\n  // Hover/focus state\n  &:hover,\n  &:focus {\n    color: $carousel-control-color;\n    text-decoration: none;\n    outline: 0;\n    opacity: $carousel-control-hover-opacity;\n  }\n}\n.carousel-control-prev {\n  left: 0;\n  background-image: if($enable-gradients, linear-gradient(90deg, rgba($black, .25), rgba($black, .001)), null);\n}\n.carousel-control-next {\n  right: 0;\n  background-image: if($enable-gradients, linear-gradient(270deg, rgba($black, .25), rgba($black, .001)), null);\n}\n\n// Icons for within\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: $carousel-control-icon-width;\n  height: $carousel-control-icon-width;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: 100% 100%;\n}\n\n.carousel-control-prev-icon {\n  background-image: escape-svg($carousel-control-prev-icon-bg) #{\"/*rtl:\" + escape-svg($carousel-control-next-icon-bg) + \"*/\"};\n}\n.carousel-control-next-icon {\n  background-image: escape-svg($carousel-control-next-icon-bg) #{\"/*rtl:\" + escape-svg($carousel-control-prev-icon-bg) + \"*/\"};\n}\n\n// Optional indicator pips/controls\n//\n// Add a container (such as a list) with the following class and add an item (ideally a focusable control,\n// like a button) with data-bs-target for each slide your carousel holds.\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  // Use the .carousel-control's width as margin so we don't overlay those\n  margin-right: $carousel-control-width;\n  margin-bottom: 1rem;\n  margin-left: $carousel-control-width;\n\n  [data-bs-target] {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: $carousel-indicator-width;\n    height: $carousel-indicator-height;\n    padding: 0;\n    margin-right: $carousel-indicator-spacer;\n    margin-left: $carousel-indicator-spacer;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: var(--#{$prefix}carousel-indicator-active-bg);\n    background-clip: padding-box;\n    border: 0;\n    // Use transparent borders to increase the hit area by 10px on top and bottom.\n    border-top: $carousel-indicator-hit-area-height solid transparent;\n    border-bottom: $carousel-indicator-hit-area-height solid transparent;\n    opacity: $carousel-indicator-opacity;\n    @include transition($carousel-indicator-transition);\n  }\n\n  .active {\n    opacity: $carousel-indicator-active-opacity;\n  }\n}\n\n\n// Optional captions\n//\n//\n\n.carousel-caption {\n  position: absolute;\n  right: (100% - $carousel-caption-width) * .5;\n  bottom: $carousel-caption-spacer;\n  left: (100% - $carousel-caption-width) * .5;\n  padding-top: $carousel-caption-padding-y;\n  padding-bottom: $carousel-caption-padding-y;\n  color: var(--#{$prefix}carousel-caption-color);\n  text-align: center;\n}\n\n// Dark mode carousel\n\n@mixin carousel-dark() {\n  --#{$prefix}carousel-indicator-active-bg: #{$carousel-indicator-active-bg-dark};\n  --#{$prefix}carousel-caption-color: #{$carousel-caption-color-dark};\n  --#{$prefix}carousel-control-icon-filter: #{$carousel-control-icon-filter-dark};\n}\n\n.carousel-dark {\n  @include carousel-dark();\n}\n\n:root,\n[data-bs-theme=\"light\"] {\n  --#{$prefix}carousel-indicator-active-bg: #{$carousel-indicator-active-bg};\n  --#{$prefix}carousel-caption-color: #{$carousel-caption-color};\n  --#{$prefix}carousel-control-icon-filter: #{$carousel-control-icon-filter};\n}\n\n@if $enable-dark-mode {\n  @include color-mode(dark, true) {\n    @include carousel-dark();\n  }\n}\n","// scss-docs-start clearfix\n@mixin clearfix() {\n  &::after {\n    display: block;\n    clear: both;\n    content: \"\";\n  }\n}\n// scss-docs-end clearfix\n","//\n// Rotating border\n//\n\n.spinner-grow,\n.spinner-border {\n  display: inline-block;\n  flex-shrink: 0;\n  width: var(--#{$prefix}spinner-width);\n  height: var(--#{$prefix}spinner-height);\n  vertical-align: var(--#{$prefix}spinner-vertical-align);\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  animation: var(--#{$prefix}spinner-animation-speed) linear infinite var(--#{$prefix}spinner-animation-name);\n}\n\n// scss-docs-start spinner-border-keyframes\n@keyframes spinner-border {\n  to { transform: rotate(360deg) #{\"/* rtl:ignore */\"}; }\n}\n// scss-docs-end spinner-border-keyframes\n\n.spinner-border {\n  // scss-docs-start spinner-border-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-border;\n  // scss-docs-end spinner-border-css-vars\n\n  border: var(--#{$prefix}spinner-border-width) solid currentcolor;\n  border-right-color: transparent;\n}\n\n.spinner-border-sm {\n  // scss-docs-start spinner-border-sm-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width-sm};\n  // scss-docs-end spinner-border-sm-css-vars\n}\n\n//\n// Growing circle\n//\n\n// scss-docs-start spinner-grow-keyframes\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n// scss-docs-end spinner-grow-keyframes\n\n.spinner-grow {\n  // scss-docs-start spinner-grow-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-grow;\n  // scss-docs-end spinner-grow-css-vars\n\n  background-color: currentcolor;\n  opacity: 0;\n}\n\n.spinner-grow-sm {\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n}\n\n@if $enable-reduced-motion {\n  @media (prefers-reduced-motion: reduce) {\n    .spinner-border,\n    .spinner-grow {\n      --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed * 2};\n    }\n  }\n}\n","// stylelint-disable function-disallowed-list\n\n%offcanvas-css-vars {\n  // scss-docs-start offcanvas-css-vars\n  --#{$prefix}offcanvas-zindex: #{$zindex-offcanvas};\n  --#{$prefix}offcanvas-width: #{$offcanvas-horizontal-width};\n  --#{$prefix}offcanvas-height: #{$offcanvas-vertical-height};\n  --#{$prefix}offcanvas-padding-x: #{$offcanvas-padding-x};\n  --#{$prefix}offcanvas-padding-y: #{$offcanvas-padding-y};\n  --#{$prefix}offcanvas-color: #{$offcanvas-color};\n  --#{$prefix}offcanvas-bg: #{$offcanvas-bg-color};\n  --#{$prefix}offcanvas-border-width: #{$offcanvas-border-width};\n  --#{$prefix}offcanvas-border-color: #{$offcanvas-border-color};\n  --#{$prefix}offcanvas-box-shadow: #{$offcanvas-box-shadow};\n  --#{$prefix}offcanvas-transition: #{transform $offcanvas-transition-duration ease-in-out};\n  --#{$prefix}offcanvas-title-line-height: #{$offcanvas-title-line-height};\n  // scss-docs-end offcanvas-css-vars\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @extend %offcanvas-css-vars;\n  }\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @include media-breakpoint-down($next) {\n      position: fixed;\n      bottom: 0;\n      z-index: var(--#{$prefix}offcanvas-zindex);\n      display: flex;\n      flex-direction: column;\n      max-width: 100%;\n      color: var(--#{$prefix}offcanvas-color);\n      visibility: hidden;\n      background-color: var(--#{$prefix}offcanvas-bg);\n      background-clip: padding-box;\n      outline: 0;\n      @include box-shadow(var(--#{$prefix}offcanvas-box-shadow));\n      @include transition(var(--#{$prefix}offcanvas-transition));\n\n      &.offcanvas-start {\n        top: 0;\n        left: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-right: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(-100%);\n      }\n\n      &.offcanvas-end {\n        top: 0;\n        right: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-left: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(100%);\n      }\n\n      &.offcanvas-top {\n        top: 0;\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-bottom: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(-100%);\n      }\n\n      &.offcanvas-bottom {\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-top: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(100%);\n      }\n\n      &.showing,\n      &.show:not(.hiding) {\n        transform: none;\n      }\n\n      &.showing,\n      &.hiding,\n      &.show {\n        visibility: visible;\n      }\n    }\n\n    @if not ($infix == \"\") {\n      @include media-breakpoint-up($next) {\n        --#{$prefix}offcanvas-height: auto;\n        --#{$prefix}offcanvas-border-width: 0;\n        background-color: transparent !important; // stylelint-disable-line declaration-no-important\n\n        .offcanvas-header {\n          display: none;\n        }\n\n        .offcanvas-body {\n          display: flex;\n          flex-grow: 0;\n          padding: 0;\n          overflow-y: visible;\n          // Reset `background-color` in case `.bg-*` classes are used in offcanvas\n          background-color: transparent !important; // stylelint-disable-line declaration-no-important\n        }\n      }\n    }\n  }\n}\n\n.offcanvas-backdrop {\n  @include overlay-backdrop($zindex-offcanvas-backdrop, $offcanvas-backdrop-bg, $offcanvas-backdrop-opacity);\n}\n\n.offcanvas-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}offcanvas-padding-y) * .5) calc(var(--#{$prefix}offcanvas-padding-x) * .5);\n    // Split properties to avoid invalid calc() function if value is 0\n    margin-top: calc(-.5 * var(--#{$prefix}offcanvas-padding-y));\n    margin-right: calc(-.5 * var(--#{$prefix}offcanvas-padding-x));\n    margin-bottom: calc(-.5 * var(--#{$prefix}offcanvas-padding-y));\n    margin-left: auto;\n  }\n}\n\n.offcanvas-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}offcanvas-title-line-height);\n}\n\n.offcanvas-body {\n  flex-grow: 1;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n  overflow-y: auto;\n}\n",".placeholder {\n  display: inline-block;\n  min-height: 1em;\n  vertical-align: middle;\n  cursor: wait;\n  background-color: currentcolor;\n  opacity: $placeholder-opacity-max;\n\n  &.btn::before {\n    display: inline-block;\n    content: \"\";\n  }\n}\n\n// Sizing\n.placeholder-xs {\n  min-height: .6em;\n}\n\n.placeholder-sm {\n  min-height: .8em;\n}\n\n.placeholder-lg {\n  min-height: 1.2em;\n}\n\n// Animation\n.placeholder-glow {\n  .placeholder {\n    animation: placeholder-glow 2s ease-in-out infinite;\n  }\n}\n\n@keyframes placeholder-glow {\n  50% {\n    opacity: $placeholder-opacity-min;\n  }\n}\n\n.placeholder-wave {\n  mask-image: linear-gradient(130deg, $black 55%, rgba(0, 0, 0, (1 - $placeholder-opacity-min)) 75%, $black 95%);\n  mask-size: 200% 100%;\n  animation: placeholder-wave 2s linear infinite;\n}\n\n@keyframes placeholder-wave {\n  100% {\n    mask-position: -200% 0%;\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .text-bg-#{$color} {\n    color: color-contrast($value) if($enable-important-utilities, !important, null);\n    background-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}bg-opacity, 1)) if($enable-important-utilities, !important, null);\n  }\n}\n","// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  .link-#{$color} {\n    color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n    text-decoration-color: RGBA(var(--#{$prefix}#{$color}-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n    @if $link-shade-percentage != 0 {\n      &:hover,\n      &:focus {\n        $hover-color: if(color-contrast($value) == $color-contrast-light, shade-color($value, $link-shade-percentage), tint-color($value, $link-shade-percentage));\n        color: RGBA(#{to-rgb($hover-color)}, var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n        text-decoration-color: RGBA(to-rgb($hover-color), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n      }\n    }\n  }\n}\n\n// One-off special link helper as a bridge until v6\n.link-body-emphasis {\n  color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, 1)) if($enable-important-utilities, !important, null);\n  text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, 1)) if($enable-important-utilities, !important, null);\n\n  @if $link-shade-percentage != 0 {\n    &:hover,\n    &:focus {\n      color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-opacity, .75)) if($enable-important-utilities, !important, null);\n      text-decoration-color: RGBA(var(--#{$prefix}emphasis-color-rgb), var(--#{$prefix}link-underline-opacity, .75)) if($enable-important-utilities, !important, null);\n    }\n  }\n}\n",".focus-ring:focus {\n  outline: 0;\n  // By default, there is no `--bs-focus-ring-x`, `--bs-focus-ring-y`, or `--bs-focus-ring-blur`, but we provide CSS variables with fallbacks to initial `0` values\n  box-shadow: var(--#{$prefix}focus-ring-x, 0) var(--#{$prefix}focus-ring-y, 0) var(--#{$prefix}focus-ring-blur, 0) var(--#{$prefix}focus-ring-width) var(--#{$prefix}focus-ring-color);\n}\n",".icon-link {\n  display: inline-flex;\n  gap: $icon-link-gap;\n  align-items: center;\n  text-decoration-color: rgba(var(--#{$prefix}link-color-rgb), var(--#{$prefix}link-opacity, .5));\n  text-underline-offset: $icon-link-underline-offset;\n  backface-visibility: hidden;\n\n  > .bi {\n    flex-shrink: 0;\n    width: $icon-link-icon-size;\n    height: $icon-link-icon-size;\n    fill: currentcolor;\n    @include transition($icon-link-icon-transition);\n  }\n}\n\n.icon-link-hover {\n  &:hover,\n  &:focus-visible {\n    > .bi {\n      transform: var(--#{$prefix}icon-link-transform, $icon-link-icon-transform);\n    }\n  }\n}\n","// Credit: Nicolas Gallagher and SUIT CSS.\n\n.ratio {\n  position: relative;\n  width: 100%;\n\n  &::before {\n    display: block;\n    padding-top: var(--#{$prefix}aspect-ratio);\n    content: \"\";\n  }\n\n  > * {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n}\n\n@each $key, $ratio in $aspect-ratios {\n  .ratio-#{$key} {\n    --#{$prefix}aspect-ratio: #{$ratio};\n  }\n}\n","// Shorthand\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n// Responsive sticky top and bottom\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .sticky#{$infix}-top {\n      position: sticky;\n      top: 0;\n      z-index: $zindex-sticky;\n    }\n\n    .sticky#{$infix}-bottom {\n      position: sticky;\n      bottom: 0;\n      z-index: $zindex-sticky;\n    }\n  }\n}\n","// scss-docs-start stacks\n.hstack {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n}\n\n.vstack {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-self: stretch;\n}\n// scss-docs-end stacks\n","//\n// Visually hidden\n//\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n  @include visually-hidden();\n}\n","// stylelint-disable declaration-no-important\n\n// Hide content visually while keeping it accessible to assistive technologies\n//\n// See: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// See: https://kittygiraudel.com/2016/10/13/css-hide-and-seek/\n\n@mixin visually-hidden() {\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important; // Fix for https://github.com/twbs/bootstrap/issues/25686\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n\n  // Fix for positioned table caption that could become anonymous cells\n  &:not(caption) {\n    position: absolute !important;\n  }\n\n  // Fix to prevent overflowing children to become focusable\n  * {\n    overflow: hidden !important;\n  }\n}\n\n// Use to only display content when it's focused, or one of its child elements is focused\n// (i.e. when focus is within the element/container that the class was applied to)\n//\n// Useful for \"Skip to main content\" links; see https://www.w3.org/WAI/WCAG22/Techniques/general/G1.html\n\n@mixin visually-hidden-focusable() {\n  &:not(:focus):not(:focus-within) {\n    @include visually-hidden();\n  }\n}\n","//\n// Stretched link\n//\n\n.stretched-link {\n  &::#{$stretched-link-pseudo-element} {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: $stretched-link-z-index;\n    content: \"\";\n  }\n}\n","//\n// Text truncation\n//\n\n.text-truncate {\n  @include text-truncate();\n}\n","// Text truncate\n// Requires inline-block or block for proper styling\n\n@mixin text-truncate() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n",".vr {\n  display: inline-block;\n  align-self: stretch;\n  width: $vr-border-width;\n  min-height: 1em;\n  background-color: currentcolor;\n  opacity: $hr-opacity;\n}\n","// Utility generator\n// Used to generate utilities & print utilities\n@mixin generate-utility($utility, $infix: \"\", $is-rfs-media-query: false) {\n  $values: map-get($utility, values);\n\n  // If the values are a list or string, convert it into a map\n  @if type-of($values) == \"string\" or type-of(nth($values, 1)) != \"list\" {\n    $values: zip($values, $values);\n  }\n\n  @each $key, $value in $values {\n    $properties: map-get($utility, property);\n\n    // Multiple properties are possible, for example with vertical or horizontal margins or paddings\n    @if type-of($properties) == \"string\" {\n      $properties: append((), $properties);\n    }\n\n    // Use custom class if present\n    $property-class: if(map-has-key($utility, class), map-get($utility, class), nth($properties, 1));\n    $property-class: if($property-class == null, \"\", $property-class);\n\n    // Use custom CSS variable name if present, otherwise default to `class`\n    $css-variable-name: if(map-has-key($utility, css-variable-name), map-get($utility, css-variable-name), map-get($utility, class));\n\n    // State params to generate pseudo-classes\n    $state: if(map-has-key($utility, state), map-get($utility, state), ());\n\n    $infix: if($property-class == \"\" and str-slice($infix, 1, 1) == \"-\", str-slice($infix, 2), $infix);\n\n    // Don't prefix if value key is null (e.g. with shadow class)\n    $property-class-modifier: if($key, if($property-class == \"\" and $infix == \"\", \"\", \"-\") + $key, \"\");\n\n    @if map-get($utility, rfs) {\n      // Inside the media query\n      @if $is-rfs-media-query {\n        $val: rfs-value($value);\n\n        // Do not render anything if fluid and non fluid values are the same\n        $value: if($val == rfs-fluid-value($value), null, $val);\n      }\n      @else {\n        $value: rfs-fluid-value($value);\n      }\n    }\n\n    $is-css-var: map-get($utility, css-var);\n    $is-local-vars: map-get($utility, local-vars);\n    $is-rtl: map-get($utility, rtl);\n\n    @if $value != null {\n      @if $is-rtl == false {\n        /* rtl:begin:remove */\n      }\n\n      @if $is-css-var {\n        .#{$property-class + $infix + $property-class-modifier} {\n          --#{$prefix}#{$css-variable-name}: #{$value};\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            --#{$prefix}#{$css-variable-name}: #{$value};\n          }\n        }\n      } @else {\n        .#{$property-class + $infix + $property-class-modifier} {\n          @each $property in $properties {\n            @if $is-local-vars {\n              @each $local-var, $variable in $is-local-vars {\n                --#{$prefix}#{$local-var}: #{$variable};\n              }\n            }\n            #{$property}: $value if($enable-important-utilities, !important, null);\n          }\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            @each $property in $properties {\n              @if $is-local-vars {\n                @each $local-var, $variable in $is-local-vars {\n                  --#{$prefix}#{$local-var}: #{$variable};\n                }\n              }\n              #{$property}: $value if($enable-important-utilities, !important, null);\n            }\n          }\n        }\n      }\n\n      @if $is-rtl == false {\n        /* rtl:end:remove */\n      }\n    }\n  }\n}\n","// Loop over each breakpoint\n@each $breakpoint in map-keys($grid-breakpoints) {\n\n  // Generate media query if needed\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    // Loop over each utility property\n    @each $key, $utility in $utilities {\n      // The utility can be disabled with `false`, thus check if the utility is a map first\n      // Only proceed if responsive media queries are enabled or if it's the base media query\n      @if type-of($utility) == \"map\" and (map-get($utility, responsive) or $infix == \"\") {\n        @include generate-utility($utility, $infix);\n      }\n    }\n  }\n}\n\n// RFS rescaling\n@media (min-width: $rfs-mq-value) {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @if (map-get($grid-breakpoints, $breakpoint) < $rfs-breakpoint) {\n      // Loop over each utility property\n      @each $key, $utility in $utilities {\n        // The utility can be disabled with `false`, thus check if the utility is a map first\n        // Only proceed if responsive media queries are enabled or if it's the base media query\n        @if type-of($utility) == \"map\" and map-get($utility, rfs) and (map-get($utility, responsive) or $infix == \"\") {\n          @include generate-utility($utility, $infix, true);\n        }\n      }\n    }\n  }\n}\n\n\n// Print utilities\n@media print {\n  @each $key, $utility in $utilities {\n    // The utility can be disabled with `false`, thus check if the utility is a map first\n    // Then check if the utility needs print styles\n    @if type-of($utility) == \"map\" and map-get($utility, print) == true {\n      @include generate-utility($utility, \"-print\");\n    }\n  }\n}\n",".round-bg {\n    background-color: $interface-white;\n    border-radius: 10px;\n    border: 1px solid $interface-silver;\n    box-shadow: 0px 0px 10px 0px rgba(51, 51, 51, 0.15);\n    padding: 20px 16px;\n}\n\n.p-inputtext {\n    font-family: $fonts;\n    font-size: 0.875rem;\n    line-height: 24px;\n    color: $interface-light-black;\n}\n\n.p-checkbox {\n    .p-checkbox-box {\n        border: 1px solid $grey-4;\n    }\n}\n\n.p-radiobutton {\n    .p-radiobutton-box {\n        &.p-highlight {\n            border-color: $primary-color;\n            background: $primary-color;\n        }\n    }\n}\n\n.p-dropdown {\n    .p-dropdown-label {\n        font-size: 0.875rem;\n        line-height: 24px;\n        padding: 0.688rem 0.75rem;\n        color: $interface-light-black;\n    }\n}\n\n.p-multiselect {\n    .p-multiselect-label {\n        font-size: 0.875rem;\n        line-height: 24px;\n        padding: 0.688rem 0.75rem;\n        color: $interface-light-black;\n    }\n}\n\n.p-datepicker {\n    .p-datepicker-header {\n        padding: 0;\n\n        .p-datepicker-title {\n\n            .p-datepicker-year,\n            .p-datepicker-month {\n                padding-block: 0;\n            }\n        }\n    }\n\n    table {\n        font-size: 14px;\n\n        td {\n            padding: 5px;\n\n            >span {\n                width: 26px;\n                height: 26px;\n            }\n        }\n    }\n}\n\n.mycalls-head {\n    display: flex;\n    justify-content: space-between;\n\n    @include media-breakpoint-down(xl) {\n        display: block;\n    }\n\n    .mycalls-head-right {\n        display: flex;\n        flex-wrap: wrap;\n        \n        @include media-breakpoint-down(xl) {\n            width: 100%;\n            margin-top: 0.5rem;\n        }\n\n        .p-dropdown {\n            border: none;\n\n            .p-dropdown-label {\n                padding: 0;\n                font-size: 12px;\n            }\n        }\n        .p-multiselect {\n            border: none;\n\n            .p-multiselect-label {\n                padding: 0;\n                font-size: 12px;\n                max-width: 100px;\n            }\n        }\n    }\n\n    .mycalls-head-right {\n        .p-input-icon-left {\n            .card {\n                padding: 0.5rem;\n                border-radius: 4px;\n            }\n        }\n\n        .p-calendar {\n            .p-inputtext {\n                padding-inline: 1rem;\n                line-height: 16px;\n                border-radius: 4px;\n            }\n        }\n    }\n}\n\n.common-tabnav {\n    border-bottom: 1px solid rgba(150, 150, 150, 0.2);\n\n    h5 {\n        font-size: 1rem;\n        line-height: 18px;\n        color: $primary-color;\n        font-weight: 600;\n        padding-block: 0.813rem;\n        padding-inline: 1.25rem;\n        margin: 0;\n        border-bottom: 2px solid $primary-color;\n\n        &.active {\n            color: $interface-light-black;\n        }\n    }\n}\n\n.password-toggle2 {\n    position: absolute;\n    right: 12px;\n    top: 5px;\n}\n.password-toggle3 {\n    position: absolute;\n    right: 12px;\n    cursor: pointer;\n}\n\n.password-toggle2 img {\n    width: 20px;\n    height: auto;\n    cursor: pointer;\n}\n","// Colour variables\n$primary-color: #5627D9;\n$secondary-color: #01C324;\n$interface-green-white: #EAEAEA;\n$interface-green-dark: #17A471;\n$interface-water: #EEF2FF;\n$interface-porcelain: #EEF0F8;\n$interface-silver: #C9C9C9;\n$interface-black: #000000;\n$interface-light-black: #333333;\n$interface-white: #ffffff;\n$interface-smokey-grey: #717171;\n$interface-light-grey: #F8F8F8;\n$grey-1: #F1F1F1;\n$grey-2: #404040;\n$grey-3: #292929;\n$grey-4: #E1E1E1;\n$grey-5: #212121;\n$grey-6: #ACACAC;\n$grey-7: #969696;\n$grey-8: #6E6E6E;\n$grey-9: #f3f3f3;\n$grey-10: #888888;\n$grey-11: #CCCCCC;\n$grey-12: #e9f0f6;\n$grey-13: #424242;\n$grey-14: #919191;\n$grey-15: #ced4da;\n$grey-16: #e9ecef;\n$grey-17: #C8C8C8;\n$purple: #505AD6;\n\n$active: #6FBE46;\n$in-active: #AECA05;\n$delete: #F01E36;\n$danger: #FF5155;\n\n//emotions\n$joy: #4AB847;\n$sad: #013DB9;\n$natural: #505AD6;\n$anger: #9E0B0B;\n$fear: #F6911F;\n$surprise: #FBE925;\n$love: #D80B8F;\n\n//sentiments\n$joy-sentiment: #498D67;\n$natural-sentiment: #0D73F8;\n$anger-sentiment: #DB3447;\n \n$fonts : 'Inter', sans-serif;\n    ",".form-label {\n    font-size: 0.87rem;\n    color: $interface-smokey-grey;\n    font-family: $fonts;\n    margin-bottom: 0.3rem;\n}\n\n.form-control {\n    border-radius: 0.3rem;\n    border: none;\n    background: rgba(201, 201, 201, 0.2);\n    font-family: $fonts;\n    font-size: 0.875rem;\n    color: $interface-light-black;\n    padding: 0.688rem 0.75rem;\n    line-height: 24px;\n\n    &[type=\"password\"] {\n        padding-right: 30px;\n    }\n\n    &:focus {\n        box-shadow: 0 0 0 1px $primary-color;\n    }\n\n    &:disabled {\n        background: rgba(201, 201, 201, 0.2);\n        color: rgba(51, 51, 51, 0.6);\n    }\n}\n\n.form-check-input {\n\n    &:focus {\n        box-shadow: none;\n    }\n\n    &:checked {\n        background-color: $secondary-color;\n        border-color: $secondary-color;\n    }\n}\n\n// Switch button scss\n.p-inputswitch {\n    width: 2.625rem;\n    height: 1.375rem;\n\n    .p-inputswitch-slider {\n        width: 2.625rem;\n        height: 1.375rem;\n\n        &::before {\n            width: 1rem;\n            height: 1rem;\n            margin-top: -0.5rem;\n            left: 0.15rem;\n        }\n    }\n\n    &.p-inputswitch-checked {\n        .p-inputswitch-slider {\n            background: $secondary-color;\n\n            &::before {\n                margin-top: -0.5rem;\n                margin-left: 0;\n            }\n        }\n    }\n}\n\n.form-control[type='file'] {\n    color: rgba(0, 0, 0, 0)\n}\n\n.form-control[type='file']::-webkit-file-upload-button {\n    display: none;\n}\n\n.form-control[type='file']::file-selector-button {\n    display: none;\n}\n\n.p-checkbox.p-highlight .p-checkbox-box {\n    border-color: $primary-color;\n    background: $primary-color;\n}\n\n.p-radiobutton.p-highlight .p-radiobutton-box {\n    border-color: $primary-color;\n    background: $primary-color;\n}\n\n.p-inputswitch.p-highlight .p-inputswitch-slider {\n    background: $primary-color;\n}\n\n.p-datatable .p-sortable-column.p-highlight .p-sortable-column-icon {\n    color: $primary-color ;\n}\n\n//radio\n.p-radiobutton.p-highlight .p-radiobutton-box {\n    border-color: $primary-color;\n    background: $interface-white;\n}\n\n.p-radiobutton .p-radiobutton-box .p-radiobutton-icon {\n    width: 10px;\n    height: 10px;\n    transition-duration: 0;\n    background-color: $primary-color;\n}\n\n.p-radiobutton:not(.p-disabled):has(.p-radiobutton-input:hover) .p-radiobutton-box {\n    border-color: $primary-color;\n}\n\n// placeholder color\n::-ms-input-placeholder {\n    color: $grey-6;\n}\n\n::placeholder {\n    color: $grey-6;\n}\n\n.p-inputtext,\ntextarea {\n    box-shadow: none;\n\n    &:hover,\n    &:focus {\n        border-color: $grey-14;\n    }\n}\n\n.form-row {\n    display: flex;\n    flex-wrap: wrap;\n    margin: 0 -10px 25px -10px;\n\n    &:last-child {\n        margin-bottom: 0;\n    }\n\n    .form-col {\n        display: inline-block;\n        width: 385px;\n        padding: 0 10px;\n\n        .form-label {\n            font-size: 14px;\n            color: $grey-3;\n            display: inline-block;\n            margin-bottom: 8px;\n\n            i {\n                color: $danger;\n                display: inline-block;\n                font-style: normal;\n                margin-left: 1px;\n            }\n        }\n\n        .form-field-wrap {\n            width: 100%;\n            border: 1px solid $grey-4;\n            border-radius: 30px;\n            height: 38px;\n            box-shadow: none;\n            outline: none;\n            display: flex;\n            align-items: center;\n\n            &.color-container {\n                padding: 0 10px;\n                display: flex;\n                align-items: center;\n\n                .color-palette {\n                    overflow: hidden;\n                    height: 16px;\n                    width: 16px;\n                    display: inline-flex;\n                    border-radius: 50%;\n                    border: 1px solid $grey-4;\n\n                    input[type=\"color\"] {\n                        height: 100%;\n                        width: 100%;\n                        padding: 0;\n                        display: inline-block;\n                        border: none;\n                        box-shadow: none;\n                        outline: none;\n                        -webkit-appearance: none;\n                        cursor: pointer;\n                    }\n\n                    input[type=\"color\"]::-webkit-color-swatch-wrapper {\n                        padding: 0;\n                    }\n\n                    input[type=\"color\"]::-webkit-color-swatch {\n                        border: none;\n                    }\n                }\n            }\n\n            .file-label {\n                font-size: 12px;\n                margin-left: 12px;\n                white-space: nowrap;\n                overflow: hidden;\n                text-overflow: ellipsis;\n            }\n\n            .file-btn {\n                background-color: $grey-4;\n                border: 0;\n                font-size: 12px;\n                height: 38px;\n                width: 105px;\n                border-radius: 30px 0 0 30px;\n                margin-left: -1px;\n            }\n        }\n\n        .p-dropdown {\n            width: 100%;\n            border: 1px solid $grey-4;\n            border-radius: 30px;\n            height: 38px;\n            box-shadow: none;\n            outline: none;\n\n            &:focus,\n            &:hover {\n                border-color: $grey-14;\n            }\n\n            .p-inputtext {\n                border: 0;\n            }\n\n            .p-dropdown-label {\n                font-size: 12px;\n                line-height: 24px;\n                padding: 6px 10px;\n                color: $interface-light-black;\n                font-family: $fonts;\n            }\n        }\n\n        .p-inputtext {\n            width: 100%;\n            border: 1px solid $grey-4;\n            border-radius: 30px;\n            // height: 38px;\n            box-shadow: none;\n            outline: none;\n            padding: 5px 10px;\n            font-size: 12px;\n            background-color: $interface-white;\n\n            &:focus,\n            &:hover {\n                border-color: $grey-14;\n            }\n        }\n\n        .p-inputtextarea {\n            width: 100%;\n            border: 1px solid $grey-4;\n            border-radius: 15px;\n            height: 80px;\n            box-shadow: none;\n            outline: none;\n            padding: 5px 10px;\n            resize: none;\n            font-size: 12px;\n            background-color: $interface-white;\n\n            &:focus,\n            &:hover {\n                border-color: $grey-14;\n            }\n        }\n\n        .p-password {\n            width: 100%;\n\n            .p-password-input {\n                width: 100%;\n                border: 1px solid $grey-4;\n                border-radius: 30px;\n                height: 38px;\n                box-shadow: none;\n                outline: none;\n                padding: 5px 10px;\n\n                &:focus,\n                &:hover {\n                    border-color: $grey-14;\n                }\n            }\n        }\n    }\n}\n\n.field-info {\n    font-size: 14px;\n    display: flex;\n    align-items: center;\n    margin: 5px 0 0 10px;\n    color: $grey-3;\n    font-family: $fonts;\n    \n    i {\n        font-size: 14px;\n        font-weight: 600;\n        margin-right: 5px;\n    }\n}\n\n.p-error {\n    color: $danger;\n    font-family: $fonts;\n}",".outline-icon-btn {\n    border: 1px solid $primary-color;\n    padding: 9px 12px;\n    border-radius: 30px;\n    font-size: 12px;\n    color: $grey-3;\n    font-weight: 500;\n    box-shadow: none;\n    transition: all 0.3s ease-in-out;\n    min-width: 100px;\n    background-color: $interface-white;\n    font-family: $fonts;\n    justify-content: center;\n\n    span {\n        font-weight: 500;\n    }\n\n    &:hover {\n        background-color: $primary-color;\n        color: $interface-white;\n    }\n\n    &.active {\n        background-color: $primary-color;\n        color: $interface-white;\n        pointer-events: none;\n    }\n\n    @include media-breakpoint-down(sm) {\n        min-width: 80px;\n    }\n}\n\n.outline-icon-btn2 {\n    // border: 1px solid $primary-color;\n    padding: 9px 12px;\n    border-radius: 30px;\n    font-size: 12px;\n    color: $grey-3;\n    font-weight: 500;\n    box-shadow: none;\n    transition: all 0.3s ease-in-out;\n    min-width: 100px;\n    background-color: $interface-white;\n    font-family: $fonts;\n    justify-content: center;\n\n    span {\n        font-weight: 500;\n    }\n\n    &:hover {\n        background-color: $primary-color;\n        color: $interface-white;\n    }\n\n    &.active {\n        background-color: $primary-color;\n        color: $interface-white;\n        pointer-events: none;\n    }\n\n    @include media-breakpoint-down(sm) {\n        min-width: 80px;\n    }\n}\n\n.outline-active-btn {\n    border: 1px solid $primary-color;\n    padding: 9px 12px;\n    border-radius: 30px;\n    font-size: 12px;\n    color: $interface-white;\n    font-weight: 500;\n    box-shadow: none;\n    transition: all 0.3s ease-in-out;\n    min-width: 100px;\n    background-color: $primary-color;\n    font-family: $fonts;\n    justify-content: center;\n\n    @include media-breakpoint-down(sm) {\n        min-width: 80px;\n    }\n\n    span {\n        font-weight: 500;\n    }\n}\n\n.btn-primary {\n    background-color: $primary-color !important;\n    border-color: $primary-color !important;\n    font-family: $fonts;\n    font-size: 1rem;\n    color: $interface-white !important;\n    font-weight: 500;\n    padding: 0.5rem 0.75rem;\n    border-radius: 4px;\n    box-shadow: none;\n    justify-content: center;\n\n    span {\n        font-weight: 500;\n    }\n}\n\n.grey-outline-btn {\n    @extend .outline-icon-btn;\n    border-color: $grey-14;\n    color: $grey-14;\n\n    &.active-btn {\n        min-width: 75px;\n\n        &:hover {\n            background-color: $active;\n            border-color: $active;\n            color: $interface-white;\n        }\n    }\n\n    &.inactive-btn {\n        min-width: 75px;\n\n        &:hover {\n            background-color: $in-active;\n            border-color: $in-active;\n            color: $interface-white;\n        }\n    }\n\n    &.delete-btn {\n        min-width: 75px;\n\n        &:hover {\n            background-color: $delete;\n            border-color: $delete;\n            color: $interface-white;\n        }\n    }\n}\n\n.btn.btn-outline-dark {\n    padding: 8px 10px;\n    height: 42px;\n    border-radius: 4px;\n}\n\n.btn-lg {\n    min-width: 170px;\n\n    @include media-breakpoint-down(lg) {\n        min-width: 100px;\n    }\n}\n\n// dropdown common\n.outline-select {\n    border: 1px solid $grey-15;\n    border-radius: 40px;\n    height: 38px;\n    box-shadow: none;\n    overflow: hidden;\n\n    &.multi-select {\n        min-width: 140px;\n    }\n\n    &:hover {\n        border-color: $grey-14;\n    }\n\n    .p-dropdown-label {\n        padding: 11px 12px;\n        line-height: normal;\n        font-size: 12px;\n    }\n\n    .p-multiselect-label {\n        padding: 10px 12px;\n        line-height: normal;\n        font-size: 12px;\n    }\n}\n\n// multi dropdown common\n.p-multiselect-items {\n    &.p-component {\n        // padding-left: 0;\n        padding: 0;\n        margin-bottom: 0;\n    }\n}\n\n.p-multiselect-filter-container {\n    .p-inputtext {\n        padding: 6px 40px 6px 15px;\n        border-radius: 40px;\n        font-size: 12px;\n        color: $interface-black;\n        width: 265px;\n        max-width: 100%;\n        box-shadow: none;\n    }\n}\n\n.p-multiselect-panel .p-multiselect-header .p-multiselect-close:enabled:hover {\n    background-color: transparent;\n}\n\n.dashboard-submit {\n    height: 38px;\n}\n\n//refresh-btn\n.refresh-btn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 38px;\n    width: 38px;\n    border-radius: 50%;\n    border: 1px solid $grey-15;\n    cursor: pointer;\n\n    &:hover {\n        border-color: $grey-14;\n    }\n}\n\n.p-disabled,\nbutton:disabled {\n    background-color: $grey-4 !important;\n    border-color: $grey-4 !important;\n    color: $grey-5;\n\n    .p-inputtext {\n        background-color: $grey-4 !important;\n        border-color: $grey-4 !important;\n    }\n    &.p-radiobutton {\n        border-radius: 50%;\n    }\n}\n\n.p-paginator-element {\n    border-radius: 50% !important;\n\n    &.p-disabled {\n        background-color: transparent !important;\n        border-color: transparent !important;\n    }\n}\n\n.input-section {\n    button:disabled {\n        background-color: transparent !important;\n    }\n}\n\n.p-inputswitch.p-disabled {\n    border-radius: 30px;\n}",".tabs-wrap {\n    .p-tabview {\n        &.p-component {\n            .p-tabview-nav {\n                margin-bottom: 0;\n                padding-left: 0;\n                border-bottom: 1px solid $grey-4;\n                overflow-x: auto;\n                overflow-y: hidden;\n\n                .p-unselectable-text {\n                    a {\n                        color: $interface-light-black;\n                        text-decoration: none;\n                        font-weight: 600;\n                        font-size: 14px;\n                        color: $grey-2;\n                        border-radius: 8px 8px 0 0;\n                    }\n\n                    &.p-highlight {\n                        a {\n                            color: $interface-white;\n                            border-color: $primary-color;\n                            background-color: $primary-color;\n                        }\n                    }\n                }\n            }\n\n            .p-tabview-nav-container {\n                margin-bottom: 15px;\n            }\n\n            .p-tabview-panels {\n                padding: 0;\n            }\n\n            li {\n                .p-tabview-nav-link {\n                    padding: 11px 40px;\n                    border-color: $grey-4;\n                }\n            }\n        }\n    }\n}\n",".p-datatable {\n    .p-datatable-thead {\n        >tr {\n            >th {\n                font-family: $fonts;\n                font-weight: 500;\n                font-size: 12px;\n                color: $interface-black;\n                background-color: $grey-1;\n                padding: 5px;\n            }\n        }\n    }\n\n    .p-datatable-tbody {\n        >tr {\n            >td {\n                font-family: $fonts;\n                font-weight: 400;\n                font-size: 12px;\n                color: $grey-2;\n                padding: 5px;\n                \n                a {\n                    text-decoration: none;\n                    color: $primary-color;\n                }\n            }\n        }\n    }\n}\n\n.datatable-wrapper {\n    .p-datatable-wrapper {\n        border: 1px solid $grey-1;\n        border-radius: 15px;\n    }\n\n    .para-config-table {\n        .p-datatable-wrapper {\n            height: calc(100vh - 270px);\n\n            @include media-breakpoint-down(lg) {\n                height: auto;\n                margin-bottom: 50px;\n            }\n        }\n    }\n}\n\n.p-datatable.p-datatable-selectable .p-datatable-tbody>tr.p-selectable-row:not(.p-highlight):not(.p-datatable-emptymessage):hover {\n    background: $interface-white;\n    color: $grey-2\n}\n\n.p-datatable.p-datatable-striped .p-datatable-tbody>tr.p-row-odd {\n    background: $interface-white;\n}\n\n.user-management-section {\n    h4 {\n        font-size: 18px;\n        color: $interface-black;\n        font-weight: 600;\n    }\n\n    .filter-click {\n        margin-right: 20px;\n        cursor: pointer;\n        display: flex;\n        align-items: center;\n        color: $grey-13;\n        text-transform: capitalize;\n\n        img {\n            margin-left: 10px;\n        }\n    }\n\n    .icon-expand {\n        cursor: pointer;\n        display: inline-block;\n\n        i {\n            display: inline-block;\n            margin-right: 4px;\n            line-height: 0;\n            vertical-align: middle;\n            cursor: pointer;\n        }\n    }\n\n    .user-input {\n        input.p-inputtext {\n            padding: 6px 40px 6px 15px;\n            border-radius: 40px;\n            font-size: 12px;\n            color: $interface-black;\n            width: 265px;\n            max-width: 100%;\n            box-shadow: none;\n\n            @include media-breakpoint-down(xl) {\n                width: 250px;\n            }\n\n            @include media-breakpoint-down(md) {\n                width: 100%;\n            }\n\n            &:focus,\n            &:hover {\n                border-color: $grey-14;\n            }\n        }\n\n        .pi-search {\n            right: 15px;\n        }\n    }\n\n    .p-datatable {\n        width: 100%;\n\n        .p-datatable-wrapper {\n            .p-datatable-thead {\n                th {\n                    &.p-sortable-column {\n                        .p-sortable-column-icon {\n                            max-height: 12px;\n                            margin-left: 2px;\n                        }\n\n                        &.p-highlight {\n                            color: $primary-color;\n\n                            .p-sortable-column-icon {\n                                color: $primary-color;\n                                max-height: 14px;\n                            }\n                        }\n                    }\n                }\n\n                .p-checkbox {\n                    .p-checkbox-box {\n                        &.p-highlight {\n                            background: $primary-color;\n                            border-color: $primary-color;\n                        }\n                    }\n                }\n            }\n\n            .p-datatable-tbody {\n                tr {\n                    border-bottom: 1px solid $grey-1;\n\n                    &.p-highlight {\n                        background: rgba($primary-color, 0.095);\n                        color: $primary-color;\n                    }\n                }\n\n                .p-datatable-emptymessage {\n                    td {\n                        text-align: center;\n                        font-size: 18px;\n                        font-weight: 600;\n                        color: $interface-black;\n                    }\n                }\n\n                .p-checkbox {\n                    .p-checkbox-box {\n                        &.p-highlight {\n                            background: $primary-color;\n                            border-color: $primary-color;\n                        }\n                    }\n                }\n\n                .p-tag-value {\n                    font-weight: 600;\n                    letter-spacing: 0.5px;\n                }\n            }\n        }\n\n        .p-paginator {\n            border: none;\n            padding: 20px 10px;\n\n            @include media-breakpoint-down(sm) {\n                padding: 10px 5px;\n            }\n\n            button {\n                @include media-breakpoint-down(sm) {\n                    margin: 10px 0;\n                    height: 1.5rem !important;\n                    min-width: 1.5rem !important;\n                    font-size: 12px;\n                }\n            }\n\n            .p-paginator-first,\n            .p-paginator-prev,\n            .p-paginator-next,\n            .p-paginator-last {\n                height: 2rem;\n                min-width: 2rem;\n                border-radius: 0.37rem;\n            }\n\n            .p-dropdown {\n                height: 32px;\n                box-shadow: none;\n\n                &:hover,\n                &:active,\n                &:focus {\n                    border-color: $primary-color;\n                }\n\n                &.p-dropdown:not(.p-disabled).p-focus {\n                    border-color: $primary-color;\n                }\n\n                .p-dropdown-label {\n                    padding: 0.5rem;\n                    line-height: 16px;\n                }\n\n                .p-dropdown-trigger {\n                    width: 2rem;\n                }\n            }\n\n            .p-paginator-first {\n                color: $primary-color;\n            }\n\n            .p-paginator-prev {\n                color: $primary-color;\n            }\n\n            .p-paginator-next {\n                color: $primary-color;\n            }\n\n            .p-paginator-last {\n                color: $primary-color;\n            }\n\n            .p-paginator-pages {\n                .p-paginator-page {\n                    color: $interface-light-black;\n                    min-width: 2rem;\n                    height: 2rem;\n                    border-radius: 0.37rem;\n                    border-radius: 50%;\n\n                    &.p-highlight {\n                        background: $primary-color;\n                        border-color: $primary-color;\n                        color: $interface-white;\n                    }\n                }\n            }\n        }\n    }\n}\n\n.p-dropdown-panel {\n    .p-dropdown-header {\n        background-color: $interface-white;\n    }\n\n    .p-dropdown-filter {\n        border-color: $grey-4;\n        border-radius: 30px;\n        height: 38px;\n        padding: 0 15px;\n        font-size: 12px;\n    }\n\n    .p-dropdown-items {\n        padding: 0;\n        margin-bottom: 0;\n\n        span {\n            font-size: 14px;\n            color: $grey-2;\n            font-family: $fonts;\n            font-weight: 500;\n        }\n\n        .p-dropdown-empty-message {\n            font-size: 14px;\n            font-family: $fonts;\n        }\n\n        .p-dropdown-item {\n            .p-dropdown-blank-icon {\n                position: absolute;\n                right: 15px;\n                margin-right: 0;\n            }\n\n            &.p-highlight {\n                background: $interface-white;\n\n                .p-dropdown-check-icon {\n                    position: absolute;\n                    right: 15px;\n                    color: $primary-color;\n                    margin-right: 0;\n                }\n\n                span {\n                    color: $primary-color;\n                }\n            }\n        }\n    }\n}\n\n.status-tag {\n    border-radius: 20px;\n    padding: 4px 15px;\n    font-size: 12px;\n    font-weight: 500;\n\n    &.active {\n        color: #6FBE46;\n        background-color: rgba(111, 190, 70, 0.1);\n    }\n\n    &.active_with_border {\n        color: #6FBE46;\n        background-color: rgba(111, 190, 70, 0.1);\n        border: 1px solid #6FBE46;\n    }\n\n    &.inactive {\n        color: #AECA05;\n        background-color: rgba(174, 202, 5, 0.1);\n    }\n\n    &.delete {\n        color: #F01E36;\n        background-color: rgba(240, 30, 54, 0.1);\n    }\n\n    &.pending {\n        color: #9882D4;\n        background-color: rgba(152, 130, 212, 0.1);\n    }\n\n    &.reject {\n        color: #808285;\n        background-color: rgba(128, 130, 133, 0.1);\n    }\n}\n\n.p-dropdown-panel {\n    margin-top: 10px;\n    border: 1px solid $grey-4;\n    border-radius: 8px;\n    box-shadow: 0 0 40px rgba(0, 0, 0, 0.06);\n    overflow: hidden;\n}\n\n.expanded-row {\n    background-color: rgba($primary-color, 0.1);\n}\n\n.p-datepicker-trigger {\n    background-color: transparent;\n    border-color: transparent;\n    box-shadow: none;\n    color: $grey-8;\n    position: absolute;\n    right: 0;\n    top: 50%;\n    transform: translateY(-50%);\n}\n\n.table-top-row {\n    @include media-breakpoint-down(xl) {\n        flex-wrap: wrap;\n\n        h4.view-config-heading {\n            margin-bottom: 10px !important;\n        }\n\n        .table-right-row {\n            flex-wrap: wrap;\n        }\n    }\n\n    @include media-breakpoint-down(md) {\n        h4 {\n            margin-bottom: 10px !important;\n            width: 100%;\n        }\n    }\n\n    @include media-breakpoint-down(md) {\n        .table-right-row {\n            .dasboard-head {\n                width: 100%;\n            }\n        }\n\n        .table-right-first {\n            >.table-search {\n                width: 100%;\n\n                .p-icon-field-right {\n                    width: 100%;\n                }\n            }\n\n            .outline-icon-btn {\n                margin-right: 16px !important;\n                font-size: 0;\n                min-width: 36px;\n                width: 36px;\n\n                .p-button-icon {\n                    margin-right: 0;\n                }\n            }\n        }\n    }\n}\n\n.p-datatable-scrollable-table {\n    thead {\n        tr {\n            background: $grey-1;\n        }\n    }\n}\n\n\n.p-paginator-bottom {\n    .p-dropdown .p-dropdown-label {\n        padding: 0.4rem 0.75rem;\n    }\n}",".home-main {\n    width: 100%;\n    position: relative;\n    height: 100%;\n\n    .home-wrap {\n        width: 100%;\n        height: 100%;\n\n        .home-content {\n            width: 100%;\n\n            .home-content-wrap {\n                width: 890px;\n                margin: 0 auto;\n                max-width: 100%;\n                padding: 40px 20px 0 20px;\n\n                @include media-breakpoint-down(xxl) {\n                    padding: 20px 20px 0 20px;\n                }\n\n                @include media-breakpoint-down(xl) {\n                    padding: 20px;\n                }\n            }\n\n            h1 {\n                font-size: 28px;\n                font-weight: 700;\n                line-height: 38px;\n                margin-bottom: 30px;\n                text-align: center;\n                background: linear-gradient(91.16deg, #5627D9 6.8%, rgba(195, 80, 241, 0.8) 58.5%, #291DFF 117.29%);\n                background-clip: text;\n                color: transparent;\n                display: inline-block;\n\n                span {\n                    color: $primary-color;\n                }\n\n                @include media-breakpoint-down(xxl) {\n                    font-size: 24px;\n                    margin-bottom: 20px;\n                }\n\n                @include media-breakpoint-down(sm) {\n                    margin-bottom: 5px;\n                    line-height: normal;\n                    font-size: 20px;\n                }\n            }\n\n            .home-content-list {\n                padding-left: 0;\n                list-style-type: none;\n                display: flex;\n                flex-wrap: wrap;\n                margin: 0 -25px 70px -25px;\n                justify-content: center;\n\n                &.single-menu {\n                    li {\n                        width: 100%;\n\n                        .single-menu-wrap {\n                            display: flex;\n                            align-items: center;\n                            flex-wrap: wrap;\n                            // justify-content: space-between;\n                            justify-content: center;\n\n                            i {\n                                display: inline-block;\n                                margin-right: 20px;\n\n                                @include media-breakpoint-down(sm) {\n                                    display: none;\n                                }\n                            }\n\n                            .right-menu-desc {\n                                // width: calc(100% - 103px);\n                                width: auto;\n                                max-width: 100%;\n                                text-align: left;\n\n                                strong {\n                                    font-size: 24px;\n                                    font-weight: 700;\n                                }\n                            }\n                        }\n                    }\n                }\n\n                @include media-breakpoint-down(xxl) {\n                    margin: 0 -15px 25px -15px;\n                }\n\n                @include media-breakpoint-down(sm) {\n                    margin: 0 -15px 15px -15px;\n                }\n\n                li {\n                    width: 20%;\n                    padding: 0 25px;\n                    text-align: center;\n\n                    @include media-breakpoint-down(xxl) {\n                        padding: 0 15px;\n                    }\n\n                    @include media-breakpoint-down(sm) {\n                        width: 50%;\n                        padding: 15px;\n                    }\n\n                    a {\n                        display: flex;\n                        border: 2px solid rgba($primary-color, 0.095);\n                        border-radius: 20px;\n                        justify-content: center;\n                        align-items: center;\n                        flex-wrap: wrap;\n                        text-decoration: none;\n                        font-size: 16px;\n                        font-weight: 500;\n                        color: $grey-2;\n                        padding: 15px;\n                        margin-bottom: 12px;\n                        transition: all 0.3s ease-in-out;\n                        width: 130px;\n                        height: 130px;\n\n                        @include media-breakpoint-down(md) {\n                            padding: 15px 5px;\n                            width: 100%;\n                            height: auto;\n                        }\n\n                        &:hover,\n                        &.home-content-active {\n                            border-color: $primary-color;\n                            box-shadow: 3px 3px 20px rgba(80, 90, 214, 0.1);\n                            background-color: rgba(80, 90, 214, 0.05);\n                        }\n\n                        img {\n                            margin-bottom: 0;\n\n                            @include media-breakpoint-down(xxl) {\n                                max-height: 40px;\n                            }\n                        }\n                    }\n\n                    span {\n                        background: linear-gradient(91.16deg, #5627D9 6.8%, rgba(195, 80, 241, 0.8) 58.5%, #291DFF 117.29%);\n                        background-clip: text;\n                        color: transparent;\n                        text-align: center;\n                        transition: all 0.3s ease-in-out;\n                        display: inline-block;\n                        font-weight: 500;\n                        margin-bottom: 12px;\n\n                        // @include media-breakpoint-down(md) {\n                        //     font-size: 14px;\n                        // }\n                    }\n\n                    p {\n                        font-size: 14px;\n                        color: $grey-3;\n                        line-height: 22px;\n                        margin-bottom: 0;\n                        text-align: center;\n                    }\n                }\n            }\n\n            .marketing-section {\n                li {\n                    padding: 0 15px;\n                    width: 148px;\n\n                    a {\n                        span {\n                            height: 68px;\n                        }\n                    }\n                }\n            }\n        }\n\n        .home-search {\n            position: relative;\n            display: flex;\n            flex-wrap: wrap;\n\n            .radius-input {\n                outline: none;\n                box-shadow: none;\n                border-radius: 40px;\n                border: 1px solid $grey-4;\n                padding: 20px 95px 20px 20px;\n                color: $grey-5;\n                font-size: 14px;\n                width: 100%;\n                resize: none;\n                height: 64px;\n                // cursor: pointer;\n\n                @include media-breakpoint-down(lg) {\n                    height: 48px;\n                }\n\n                @include media-breakpoint-down(md) {\n                    height: 38px;\n                }\n\n                &:disabled {\n                    border-color: $grey-4;\n                    opacity: 1;\n                    cursor: pointer;\n\n                    &:hover {\n                        border-color: $primary-color;\n                    }\n                }\n\n                &:hover,\n                &:focus {\n                    border-color: $primary-color;\n                }\n            }\n\n            i {\n                position: absolute;\n                right: 55px;\n                top: 50%;\n                transform: translateY(-50%);\n                cursor: pointer;\n                line-height: 0;\n            }\n\n            .sec-last-icon {\n                right: 50px;\n\n                img {\n                    @include media-breakpoint-down(md) {\n                        max-width: 16px;\n                        max-height: 20px;\n                    }\n                }\n            }\n\n            .last-icon {\n                right: 20px;\n\n                img {\n                    @include media-breakpoint-down(md) {\n                        max-width: 16px;\n                        max-height: 20px;\n                    }\n                }\n            }\n        }\n\n        .helper-text {\n            margin-bottom: 0;\n            margin-top: 10px;\n            font-size: 14px;\n            color: $grey-2;\n            padding-left: 22px;\n\n            @include media-breakpoint-down(lg) {\n                font-size: 12px;\n            }\n\n            @include media-breakpoint-down(md) {\n                font-size: 12px;\n            }\n\n            i {\n                display: inline-block;\n                margin-right: 10px;\n                vertical-align: middle;\n                line-height: 0;\n            }\n        }\n\n        .helper-text2 {\n            margin-bottom: 0;\n            font-size: 14px;\n            color: $grey-2;\n\n            i {\n                display: inline-block;\n                margin-right: 10px;\n                vertical-align: middle;\n                line-height: 0;\n            }\n        }\n\n        .voice-search {\n            display: flex;\n            justify-content: space-between;\n            align-items: center;\n            width: 975px;\n\n            @include media-breakpoint-down(xl) {\n                max-width: 100%;\n            }\n\n            .home-search {\n                width: 850px;\n                max-width: 100%;\n\n                .radius-input {\n                    @include media-breakpoint-down(sm) {\n                        padding: 20px 60px 20px 20px;\n                    }\n                }\n\n                @include media-breakpoint-down(xl) {\n                    width: calc(100% - 120px);\n                }\n            }\n\n            .btn-voice-list {\n                margin-left: 15px;\n            }\n        }\n\n        .home-footer {\n            width: 100%;\n            text-align: center;\n            padding: 12px 0;\n            position: absolute;\n            bottom: 0;\n            background-color: $interface-white;\n\n            @include media-breakpoint-down(sm) {\n                position: static;\n                margin-top: 15px;\n            }\n\n            .home-footer-container {\n                width: 890px;\n                margin: 0 auto;\n                max-width: 100%;\n                padding: 0 20px;\n\n                .home-footer-wrap {\n                    display: flex;\n                    justify-content: center;\n                    font-size: 12px;\n\n                    @include media-breakpoint-down(sm) {\n                        flex-direction: column;\n                    }\n\n                    p {\n                        margin-bottom: 0;\n                        color: $grey-3;\n\n                        @include media-breakpoint-down(sm) {\n                            margin-bottom: 5px;\n                        }\n                    }\n\n                    .footer-links {\n                        padding-left: 0;\n                        list-style-type: none;\n                        margin-bottom: 0;\n                        display: flex;\n                        justify-content: center;\n\n                        li {\n                            padding: 0 10px;\n                            border-right: 1px solid $primary-color;\n\n                            &:last-child {\n                                border: 0;\n                            }\n\n                            a {\n                                color: $primary-color;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n\n.suggested-que {\n    border: 1px solid $grey-4;\n    border-radius: 12px;\n    padding: 20px;\n    margin-top: 6px;\n\n    .suggested-que-heading {\n        font-size: 14px;\n        color: $grey-3;\n        margin-bottom: 12px;\n\n        @include media-breakpoint-down(xxl) {\n            margin-bottom: 5px;\n        }\n    }\n\n    .suggested-que-list {\n        padding-left: 0;\n        list-style-type: none;\n        margin-bottom: 0;\n\n        li {\n            width: 100%;\n            margin-bottom: 12px;\n\n            @include media-breakpoint-down(xxl) {\n                margin-bottom: 5px;\n            }\n\n            &:last-child {\n                margin-bottom: 0;\n            }\n\n            a {\n                color: $grey-3;\n                font-size: 14px;\n                text-decoration: none;\n                width: 100%;\n                display: block;\n                position: relative;\n                padding-right: 15px;\n\n                &:hover {\n                    color: $primary-color;\n\n                    &::after {\n                        background-image: url(\"../../icons/external-link.svg\");\n                    }\n                }\n\n                &::after {\n                    content: \"\";\n                    width: 14px;\n                    height: 11px;\n                    display: inline-block;\n                    background-image: url(\"../../icons/external-link-grey.svg\");\n                    background-repeat: no-repeat;\n                    position: absolute;\n                    right: 0;\n                    top: 5px;\n                }\n            }\n        }\n    }\n}\n\n.lens-overlay {\n    box-shadow: none;\n    border: 6px solid $grey-1;\n    border-radius: 12px;\n\n    &::before {\n        left: 15px;\n        top: -25px;\n        display: none;\n    }\n\n    &::after {\n        left: 15px;\n        display: none;\n    }\n\n    .lens-overlay-wrap {\n        .lens-overlay-list {\n            padding-left: 0;\n            margin-bottom: 0;\n            list-style-type: none;\n            display: flex;\n            flex-wrap: wrap;\n\n            li {\n                display: flex;\n                justify-content: center;\n                text-align: center;\n\n                a {\n                    display: inline-block;\n                    width: 82px;\n                    text-decoration: none;\n                    padding: 10px 5px;\n                    border: 1px solid transparent;\n                    border-radius: 8px;\n                    cursor: pointer;\n\n                    &:hover {\n                        span {\n                            color: $primary-color;\n                        }\n                    }\n\n                    &.active-lens {\n                        border-color: $primary-color;\n                        box-shadow: 3px 3px 20px rgba(26, 39, 200, 0.1);\n                        background-color: rgba(26, 39, 200, 0.05);\n                    }\n\n                    img {\n                        max-height: 38px;\n                        margin-bottom: 7px;\n                    }\n\n                    span {\n                        width: 100%;\n                        display: block;\n                        font-size: 12px;\n                        color: $grey-2;\n                        font-weight: 500;\n                        transition: all 0.3s ease-in-out;\n                    }\n                }\n            }\n        }\n    }\n}\n\n.type-image {\n    font-size: 18px;\n    color: $grey-5;\n    font-weight: 600;\n    margin-bottom: 22px;\n    padding-left: 22px;\n\n    @include media-breakpoint-down(md) {\n        font-size: 16px;\n        margin-bottom: 15px;\n    }\n\n    i {\n        margin-right: 10px;\n        display: inline-block;\n        vertical-align: top;\n        max-width: 24px;\n\n        img {\n            width: 100%;\n        }\n    }\n}",".chat-history-btn {\n    position: fixed;\n    right: 20px;\n    bottom: 20px;\n    background-color: $interface-white;\n    box-shadow: 4px 4px 8px rgba($interface-black, 0.25);\n\n    @include media-breakpoint-down(lg) {\n        font-size: 0;\n        min-width: auto;\n        width: 36px;\n\n        span {\n            margin-right: 0;\n        }\n    }\n}\n\n.chat-history-title {\n    color: $interface-black;\n    font-size: 16px;\n    font-weight: 500;\n}\n\n.p-sidebar {\n    .p-sidebar-header {\n        padding-top: 9px;\n        padding-bottom: 9px;\n        background-color: $grey-4;\n    }\n}\n\n.p-sidebar-right-history {\n    background: transparent !important;\n    box-shadow: none !important;\n    width: 261px !important;\n}\n\n.p-sidebar-right .p-sidebar {\n    width: 16rem;\n    border-radius: 15px 0 0 15px;\n    overflow: hidden;\n}\n\n.p-sidebar-content {\n    overflow-y: auto;\n    height: calc(100vh - 42px);\n    padding: 0;\n\n    .chat-component-right-section {\n        height: 100%;\n        padding: 0 20px;\n    }\n}\n\n.p-sidebar-right-history .p-sidebar {\n    width: 16rem;\n    border-radius: 15px 0 0 15px;\n    overflow: hidden;\n}\n\n.chat-history-data-section-container {\n    padding-top: 1rem;\n\n    .date {\n        color: $grey-3;\n        font-size: 14px;\n        font-weight: 500;\n    }\n\n    .history-container {\n        display: flex;\n        align-items: center;\n        margin-bottom: 18px;\n\n        p {\n            margin-bottom: 0;\n            font-size: 14px;\n            color: $grey-8;\n            margin-left: 10px;\n            text-overflow: ellipsis;\n            overflow: hidden;\n            white-space: nowrap;\n            display: inline-block;\n            width: calc(100% - 40px);\n\n            // &:hover {\n            //     color: $interface-black;\n            // }\n        }\n    }\n}\n\n.history-container {\n    align-items: flex-start;\n    display: flex;\n    flex-direction: row;\n    margin-bottom: 16px;\n    position: relative;\n    width: 100%;\n\n    .edit-section {\n        background-color: $interface-white;\n        border: 2px solid $grey-7;\n        border-radius: 0.2rem;\n        display: flex;\n        padding: 2%;\n        width: 100%;\n\n        .editable-text {\n            border: none;\n            outline: none;\n            width: 85%;\n            font-family: $fonts;\n            font-size: 14px;\n        }\n\n        .save-button {\n            background-color: initial;\n            border: none;\n            margin-left: 5%;\n        }\n    }\n\n    .edit-delete-container {\n        background-color: $interface-white;\n        border-radius: 4px;\n        box-shadow: 2px 2px 4px 1px rgba($interface-black, 0.2);\n        display: flex;\n        flex-direction: column;\n        padding: 6px 0;\n        position: absolute;\n        right: -0;\n        top: 20px;\n        width: 100%;\n        z-index: 2;\n\n        .clickable-icon {\n            cursor: pointer;\n            height: 1.125rem;\n            width: 1.125rem;\n        }\n\n        .delete-container,\n        .edit-container {\n            align-items: center;\n            display: flex;\n            height: 40px;\n            padding: 10px 12px;\n            width: 100%;\n\n            &:hover {\n                background: $interface-light-grey;\n            }\n        }\n\n        .edit-delete-text {\n            background: transparent;\n            border: 0;\n            color: $interface-light-black;\n            font-family: $fonts;\n            font-size: 15px;\n            margin-bottom: 0;\n            padding-left: 10px;\n            margin-left: 0;\n        }\n    }\n}\n\n.close-history {\n    position: fixed;\n    z-index: 1111;\n    right: 270px;\n    bottom: 65px;\n    cursor: pointer;\n}\n\n.p-sidebar-close.p-sidebar-icon {\n    display: none;\n}\n\n.disable-icon {\n    // pointer-events: none;\n    cursor: default !important;\n    opacity: 0.5;\n}",".loading-screen {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    height: 100%;\n}\n\n.spinner {\n    border: 4px solid rgba($interface-black, 0.1);\n    border-left: 4px solid $primary-color;\n    border-radius: 50%;\n    width: 30px;\n    height: 30px;\n    animation: spin 1s linear infinite;\n    margin: 1rem 0;\n}\n\n@keyframes spin {\n    0% {\n        transform: rotate(0deg);\n    }\n\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\n.chat-bot-section {\n    position: fixed;\n    bottom: 90px;\n    right: 50px;\n    z-index: 11;\n\n    p {\n        background: $interface-white;\n        color: $interface-black;\n        height: 40px;\n        padding: 10px 15px;\n        border-radius: 12px 12px 0 12px;\n        margin-bottom: 0;\n        box-shadow: 0 1px 4px rgba($interface-black, 0.15);\n        font-size: 14px;\n        font-weight: 600;\n    }\n\n    .chat-bot-button {\n        width: 60px;\n        height: 60px;\n        position: fixed;\n        bottom: 20px;\n        right: 20px;\n        background-color: $primary-color;\n        color: $interface-white;\n        border-radius: 38px 38px 4px 35px;\n        border: none;\n        padding: 16px;\n        transition: 0.3s all;\n        transition-timing-function: ease-in-out;\n        transform: rotate(90deg);\n\n        i {\n            transform: rotate(-90deg);\n            display: inline-block;\n        }\n    }\n\n    .comments {\n        -webkit-transform: rotate(90deg);\n        -ms-transform: rotate(90deg);\n        transform: rotate(180deg);\n    }\n\n    .preview-bot-button {\n        bottom: 10px;\n        position: absolute;\n    }\n}\n\n.preview-chat-bot-section {\n    position: absolute;\n    right: 7px;\n}\n\n.preview-container {\n    border-radius: 12px;\n}\n\n.section-container {\n    width: 96%;\n    max-width: 100%;\n    position: static;\n    bottom: 20px;\n    right: 0;\n    color: #000000;\n    border-radius: 12px;\n    z-index: 11;\n    left: 0;\n    margin: 0 auto;\n    top: 20px;\n    width: calc(100% - 300px);\n    // width: 480px;\n    // max-width: 100%;\n    // position: fixed;\n    // bottom: 20px;\n    // right: 93px;\n    // color: $interface-black;\n    // border-radius: 12px;\n    // z-index: 11;\n\n\n\n    @include media-breakpoint-down(md) {\n        bottom: 100px;\n        left: 0;\n        right: 0;\n        margin: 0 auto;\n        width: 90%;\n    }\n\n    .section-header {\n        height: 76px;\n        background: $interface-white;\n        // background: linear-gradient(90.09deg, $primary-color 0.68%, #01C324 113.22%), linear-gradient(0deg, $interface-silver, $interface-silver);\n        display: flex;\n        color: $interface-white;\n        padding: 10px 20px;\n        display: flex;\n        justify-content: space-between;\n        border-radius: 25px 25px 0px 0px;\n        align-items: center;\n\n        @include media-breakpoint-down(md) {\n            padding: 10px 15px;\n        }\n\n        .top-head {\n            display: flex;\n            align-items: center;\n\n            .chat-avtar {\n                // background-color: $primary-color;\n                border-radius: 50%;\n                width: 50px;\n                height: 50px;\n                border: 1px solid $primary-color;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                margin-right: 14px;\n\n                @include media-breakpoint-down(sm) {\n                    margin-right: 10px;\n                }\n            }\n\n            .preview-logo-heading {\n                padding: 0px;\n                max-width: 30px;\n                max-height: 30px;\n            }\n\n            p {\n                display: flex;\n                flex: 1;\n                flex-direction: column;\n                margin-top: 0;\n                margin-bottom: 0;\n                line-height: normal;\n\n                :first-child {\n                    font-weight: 500;\n                    margin-bottom: 2px;\n                    font-size: 22px;\n                    font-weight: 600;\n                    color: #4f46e5;\n                }\n\n                :nth-child(2) {\n                    font-size: 14px;\n                    color: $grey-3;\n                }\n            }\n        }\n\n        .button-section {\n            display: flex;\n            align-items: center;\n            padding: 0;\n            background: transparent;\n            border: none;\n            color: $grey-8;\n\n            i {\n                font-weight: 600;\n            }\n        }\n    }\n\n    .section-body {\n        padding: 20px;\n        height: calc(100vh - 148px);\n        // height: calc(100vh - 307px);\n        // height: calc(100vh - 267px);\n        overflow: auto;\n        display: flex;\n        flex-direction: column;\n\n        .start-suggestion {\n            margin-top: 20px;\n            position: absolute;\n            bottom: 90px;\n            left: 0;\n            right: 0;\n            padding: 0 20px;\n\n            .suggested-que {\n                padding: 0 !important;\n                border: none !important;\n\n                .suggested-que-list {\n                    li {\n                        cursor: pointer;\n                        border-bottom: 1px solid white;\n                        padding: 5px 0;\n                        margin-bottom: 0px !important;\n\n                        &:hover {\n                            color: $primary-color !important;\n                        }\n                    }\n                }\n            }\n\n            .list {\n                background-color: $primary-color;\n                color: $interface-white;\n                margin: 0 5px 10px 5px;\n                border-radius: 25px;\n                padding: 5px 10px;\n                cursor: pointer;\n            }\n        }\n\n        .start-suggestion-first {\n            margin-top: 20px;\n            // position: absolute;\n            // bottom: 90px;\n            left: 0;\n            right: 0;\n            // padding: 0 20px;\n\n            .suggested-que {\n                padding: 0 !important;\n                border: none !important;\n\n                .suggested-que-list {\n                    li {\n                        cursor: pointer;\n                        border-bottom: 1px solid white;\n                        padding: 5px 0;\n                        margin-bottom: 0px !important;\n\n                        &:hover {\n                            color: $primary-color !important;\n                        }\n                    }\n                }\n            }\n\n            .list {\n                background-color: $primary-color;\n                color: $interface-white;\n                margin: 0 5px 10px 5px;\n                border-radius: 25px;\n                padding: 5px 10px;\n                cursor: pointer;\n            }\n        }\n\n        .output-message-container {\n            display: flex;\n            flex-wrap: wrap;\n            margin-right: 80px;\n\n            p {\n                margin-bottom: 0;\n                border-radius: 25px !important;\n\n                a {\n                    color: $interface-white;\n                }\n            }\n\n            ol,\n            ul {\n                margin: 1rem 0;\n            }\n\n            .fa-robot {\n                color: $secondary-color;\n                padding: 9px 7px;\n                border: 1px solid lightgray;\n                border-radius: 32px;\n                height: 38px;\n                box-shadow: 0px 0px 4px 0px rgba($interface-black, 0.25);\n                width: 38px;\n                margin-right: 8px;\n                font-size: 18px;\n                background: $interface-white;\n            }\n\n            .chat-img {\n                width: 40px;\n                height: 40px;\n                margin-right: 15px;\n                display: inline-block;\n\n                img {\n                    height: 100%;\n                    width: 100%;\n                    object-fit: contain;\n                }\n            }\n\n            >p {\n                font-size: 14px;\n                background: #F4F4F4;\n                // background: #F2F2F2;\n                border-radius: 4px;\n                padding: 10px 15px 10px 15px;\n                margin-bottom: 15px;\n                $interface-white-space: break-spaces;\n                border-radius: 0 12px 12px 12px;\n                box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);\n                // word-break: break-word;\n                color: $interface-black;\n                // color: $interface-white;\n\n                >p {\n                    margin-bottom: 0;\n                }\n            }\n\n            .second-message {\n                margin-left: 56px;\n            }\n\n            .jumping-dots span {\n                position: relative;\n                margin-left: auto;\n                margin-right: auto;\n                -webkit-animation: jump 1500ms infinite;\n                animation: jump 2s infinite;\n                display: inline-block;\n                background-color: #cfcfcfe3;\n                width: 5px;\n                height: 5px;\n                border-radius: 50%;\n                margin-right: 3px;\n            }\n\n            .jumping-dots .dot-1 {\n                animation-delay: 200ms;\n                -webkit-animation-delay: 200ms;\n            }\n\n            .jumping-dots .dot-2 {\n                animation-delay: 400ms;\n                -webkit-animation-delay: 400ms;\n            }\n\n            .jumping-dots .dot-3 {\n                animation-delay: 600ms;\n                -webkit-animation-delay: 600ms;\n            }\n        }\n\n        .second-section {\n            .pi-reddit {\n                visibility: hidden;\n            }\n        }\n\n        .input-message-container {\n            p {\n                font-size: 12px;\n                background: $primary-color;\n                color: $interface-white;\n                // color: $interface-black;\n                border-radius: 4px;\n                padding: 10px 15px 10px 15px;\n                margin-bottom: 15px;\n                float: right;\n                margin-left: 80px;\n                border-radius: 25px;\n                box-shadow: 0 1px 4px rgba($interface-black, 0.1);\n                word-break: break-word;\n            }\n        }\n    }\n\n    .section-footer {\n        padding: 0px 20px 20px 20px;\n\n        .suggestion-nav {\n            display: flex;\n            justify-content: space-between;\n            align-items: center;\n            margin-bottom: 5px;\n\n            .nav-btn {\n                position: absolute;\n                z-index: 2000;\n                background: linear-gradient(270deg, rgba(235, 236, 238, 0) 0%);\n                // background: white;\n                border: none;\n                font-size: 1.5rem;\n                cursor: pointer;\n                padding: 0 0.5rem;\n                margin-bottom: 5px;\n            }\n\n            .nav-btn.left {\n                left: -5px;\n            }\n\n            .nav-btn.right {\n                right: -5px;\n            }\n\n            .suggestion {\n                overflow-x: scroll;\n                display: flex;\n                white-space: nowrap;\n                scroll-behavior: smooth;\n\n                .list {\n                    background-color: $primary-color;\n                    color: $interface-white;\n                    margin: 0 5px;\n                    border-radius: 25px;\n                    padding: 5px 10px;\n                    z-index: 100;\n                    // width: 100%;\n                    font-size: 14px;\n                    cursor: pointer;\n                }\n            }\n        }\n\n\n        .input-section {\n            position: relative;\n            display: flex;\n            justify-content: space-between;\n            align-items: center;\n\n            .pi-plus-circle {\n                color: $primary-color;\n                font-size: 21px;\n            }\n\n            input {\n                background: $interface-white;\n                border-radius: 40px;\n                height: 50px;\n                width: 100%;\n                border: 1px solid $grey-4;\n                padding: 15px 70px 15px 20px;\n                font-size: 14px;\n                color: $grey-8;\n            }\n\n            input:focus {\n                outline: none;\n            }\n\n            button {\n                background: none;\n                border: none;\n                padding: 0px;\n                position: absolute;\n                right: 38px;\n                // right: 15px;\n                // right: 50px;\n                top: 16px;\n                line-height: 0;\n\n                .pi-send {\n                    font-size: 18px;\n                    transform: rotate(45deg);\n                }\n\n                .active-class {\n                    opacity: 1;\n                }\n\n                .inActive-class {\n                    opacity: 0.5;\n                }\n\n                .last-icon {\n                    img {\n                        width: 13px;\n                    }\n                }\n            }\n\n            .last-icon {\n                position: absolute;\n                right: -22px;\n                cursor: pointer;\n\n                .active-class {\n                    opacity: 1;\n                }\n\n                .inActive-class {\n                    opacity: 0.5;\n                }\n            }\n        }\n\n        .input-password {\n            input {\n                padding: 15px 75px 15px 18px;\n            }\n\n            .password-toggle3 {\n                right: 3px;\n            }\n\n            button {\n                right: 16px;\n            }\n        }\n    }\n}\n\n.section-body-footer-wrap {\n    overflow: hidden;\n    box-shadow: -3.01px 3.01px 3.01px 0px #FFFFFF63 inset;\n    backdrop-filter: blur(74.42933654785156px);\n    background-color: rgba(240, 240, 240, 0.48);\n    // border-radius: 0 0 25px 25px;\n    position: relative;\n\n    &::after {\n        content: \"\";\n        box-shadow: 2.01px -2.01px 20px 0px #D6D6D62B inset;\n        display: inline-block;\n        position: absolute;\n        left: 0;\n        right: 0;\n        top: 0;\n        bottom: 0;\n        z-index: -1;\n    }\n}\n\n.preview-section-container {\n    width: 100%;\n    position: static;\n\n    .section-body {\n        height: calc(100vh - 476px);\n    }\n}\n\n@keyframes jump {\n    0% {\n        bottom: 0px;\n    }\n\n    20% {\n        bottom: 5px;\n    }\n\n    40% {\n        bottom: 0px;\n    }\n}\n\n.configuration-section {\n    .preview-section {\n        height: calc(100vh - 240px);\n        width: 540px;\n        padding: 25px 30px 30px 30px;\n        background: $interface-light-grey;\n\n        @include media-breakpoint-down(xl) {\n            width: 400px;\n        }\n\n        @include media-breakpoint-down(lg) {\n            width: 100%;\n        }\n\n        @include media-breakpoint-down(md) {\n            padding: 15px;\n            height: auto;\n        }\n\n        .preview-header {\n            h4 {\n                font-size: 16px;\n                color: $interface-black;\n                font-weight: 500;\n                margin-bottom: 15px;\n            }\n        }\n    }\n}\n\n.blur-bot {\n    &::after {\n        content: \"\";\n        position: fixed;\n        z-index: 1;\n        left: 0;\n        right: 0;\n        top: 0;\n        bottom: 0;\n        background-color: rgba($interface-black, 0.3);\n        backdrop-filter: blur(5px);\n    }\n}\n\n.card.bot-config {\n    height: calc(100vh - 230px);\n    overflow-y: auto;\n}\n\n.configuration-section {\n    .card.p-3 {\n        height: calc(100vh - 230px);\n        overflow-y: auto;\n    }\n}\n\n.markdown {\n    background-color: $interface-white;\n}\n\n// bot config\n.configuration-section {\n\n    #RFS-StepButton {\n        width: 16px;\n        border: none;\n        height: 16px;\n        margin: 0px;\n        display: flex;\n        padding: 0px;\n        font-size: 1em;\n        align-items: center;\n        border-radius: 50%;\n        justify-content: center;\n\n        &.active,\n        &.completed {\n            background-color: $primary-color;\n        }\n    }\n\n    #RFS-StepMain {\n        display: flex;\n        align-items: center;\n        flex-direction: column;\n    }\n\n    #RFS-ConnectorContainer {\n        top: calc(7.5px);\n        left: calc(-50% + 8px);\n        right: calc(50% + 8px);\n        position: absolute;\n    }\n\n    #RFS-Connector {\n        display: block;\n        border-color: rgb(189, 189, 189);\n        border-top-style: solid;\n        border-top-width: 1px;\n    }\n\n    .card {\n        border: 0;\n\n        .admin-heading {\n            font-size: 18px;\n            color: $interface-black;\n            font-weight: 600;\n            margin-bottom: 0;\n        }\n    }\n\n    #RFS-StepperContainer {\n        border-bottom: 1px solid $grey-4;\n        padding: 20px 20px 40px 20px;\n    }\n\n    #RFS-Label {\n        font-size: 12px;\n        color: #282828;\n        font-family: $fonts;\n    }\n\n    #RFS-StepButton {\n        position: relative;\n\n        >span {\n            font-size: 16px;\n            color: #282828;\n            font-family: $fonts;\n            font-weight: 500;\n            margin-top: 100px;\n            white-space: nowrap;\n            display: inline-block;\n\n            @include media-breakpoint-down(md) {\n                font-size: 10px;\n                margin-top: 115px;\n                white-space: normal;\n                line-height: normal;\n            }\n        }\n\n        &.active,\n        &.completed {\n            &::after {\n                border: 1px solid $primary-color;\n            }\n        }\n\n        &::before {\n            content: \"\";\n            position: absolute;\n            background-image: url(\"../../images/complete-check.svg\");\n            // background-image: url(\"../../../images/complete-check.svg\");\n            background-repeat: no-repeat;\n            width: 9px;\n            height: 7px;\n            top: 5px;\n            left: 3px;\n            opacity: 0;\n            visibility: hidden;\n        }\n\n        &::after {\n            content: \"\";\n            position: absolute;\n            height: 22px;\n            width: 22px;\n            border-radius: 50%;\n            border: 1px solid #C8C8C8;\n        }\n\n        &.completed {\n            &::before {\n                opacity: 1;\n                visibility: visible;\n            }\n        }\n    }\n}\n\n//ButterPie\n.configuration-section2 {\n\n    #RFS-StepButton {\n        width: 16px;\n        border: none;\n        height: 16px;\n        margin: 0px;\n        display: flex;\n        padding: 0px;\n        font-size: 1em;\n        align-items: center;\n        border-radius: 50%;\n        justify-content: center;\n\n        &.active,\n        &.completed {\n            background-color: $primary-color;\n        }\n    }\n\n    #RFS-StepMain {\n        display: flex;\n        align-items: center;\n        flex-direction: column;\n    }\n\n    #RFS-ConnectorContainer {\n        top: calc(7.5px);\n        left: calc(-50% + 8px);\n        right: calc(50% + 8px);\n        position: absolute;\n    }\n\n    #RFS-Connector {\n        display: block;\n        border-color: rgb(189, 189, 189);\n        border-top-style: solid;\n        border-top-width: 1px;\n    }\n\n    .card {\n        border: 0;\n\n        .admin-heading {\n            font-size: 18px;\n            color: $interface-black;\n            font-weight: 600;\n            margin-bottom: 0;\n        }\n\n        .step-heading {\n            font-size: 16px;\n            color: $grey-3;\n            // color: $interface-black;\n            font-weight: 500;\n            margin-bottom: 0;\n        }\n\n        .step-span {\n            font-size: 14px;\n        }\n    }\n\n    #RFS-StepperContainer {\n        border-bottom: 1px solid $grey-4;\n        padding: 20px 20px 55px 20px;\n    }\n\n    #RFS-Label {\n        font-size: 12px;\n        color: #282828;\n        font-family: $fonts;\n    }\n\n    #RFS-StepButton {\n        position: relative;\n\n        >span {\n            font-size: 16px;\n            color: #282828;\n            font-family: $fonts;\n            font-weight: 500;\n            margin-top: 125px;\n            white-space: nowrap;\n            display: inline-block;\n\n            // @include media-breakpoint-down(md) {\n            //     font-size: 10px;\n            //     margin-top: 115px;\n            //     white-space: normal;\n            //     line-height: normal;\n            // }\n        }\n\n        &.active,\n        &.completed {\n            &::after {\n                border: 1px solid $primary-color;\n            }\n        }\n\n        &::before {\n            content: \"\";\n            position: absolute;\n            background-image: url(\"../../images/complete-check.svg\");\n            background-repeat: no-repeat;\n            width: 9px;\n            height: 7px;\n            top: 5px;\n            left: 3px;\n            opacity: 0;\n            visibility: hidden;\n        }\n\n        &::after {\n            content: \"\";\n            position: absolute;\n            height: 22px;\n            width: 22px;\n            border-radius: 50%;\n            border: 1px solid #C8C8C8;\n        }\n\n        &.completed {\n            &::before {\n                opacity: 1;\n                visibility: visible;\n            }\n        }\n    }\n}\n\n.stepper-main {\n    width: calc(100% - 540px);\n    padding-right: 15px;\n\n    &.stepper-step-2 {\n        width: 100%;\n        padding-right: 0;\n    }\n\n    @include media-breakpoint-down(xl) {\n        width: calc(100% - 400px);\n\n        &.stepper-step-2 {\n            .stepper-wrapper {\n                &.stepper-wrapper-ft {\n                    width: 100%;\n                }\n            }\n        }\n    }\n\n    @include media-breakpoint-down(lg) {\n        width: 100%;\n        padding-right: 0;\n        margin-bottom: 20px;\n    }\n\n    .stepper-form {\n        height: calc(100vh - 297px);\n        overflow-y: auto;\n\n        @include media-breakpoint-down(lg) {\n            height: auto;\n        }\n\n        .upload-file-step {\n            padding-top: 25px;\n\n            @include media-breakpoint-down(lg) {\n                width: 100%;\n            }\n\n            @include media-breakpoint-down(md) {\n                padding-top: 15px;\n            }\n\n            small {\n                font-size: 14px;\n                display: inline-block;\n                margin-bottom: 25px;\n                width: 100%;\n\n                b {\n                    color: $primary-color;\n                    text-decoration: underline;\n                }\n            }\n\n            .home-search {\n                max-width: 400px;\n\n                input {\n                    height: 54px;\n                    width: 100%;\n                    cursor: pointer !important;\n                    padding: 20px 62px 20px 20px;\n\n                    @include media-breakpoint-down(lg) {\n                        height: 48px;\n                    }\n\n                    @include media-breakpoint-down(md) {\n                        height: 38px;\n                    }\n                }\n            }\n        }\n    }\n\n    .stepper-wrapper {\n        width: 750px;\n        max-width: 100%;\n\n        @include media-breakpoint-down(lg) {\n            width: 100%;\n        }\n\n        .form-row {\n            @include media-breakpoint-down(md) {\n                margin: 0 -10px;\n            }\n\n            .form-col {\n                width: 50%;\n\n                @include media-breakpoint-down(md) {\n                    width: 100%;\n                    margin-bottom: 10px;\n                }\n\n                &.full-col {\n                    width: 100%;\n                }\n\n                .p-inputnumber {\n                    width: 100%;\n                }\n            }\n        }\n\n        &.stepper-wrapper-ft {\n            width: 770px;\n            max-width: 100%;\n\n            @include media-breakpoint-down(lg) {\n                width: 100%;\n            }\n        }\n    }\n\n    .stepper-top {\n        width: 100%;\n        padding: 20px 40px 25px 20px;\n    }\n\n    .stepper-middle {\n        width: 100%;\n        padding: 20px 40px 20px 0;\n        border-top: 1px solid $grey-4;\n\n        .p-accordion-header-link {\n            background-color: $interface-light-grey;\n            border: 1px solid $grey-4;\n            border-radius: 10px;\n            padding: 10px 20px;\n            text-decoration: none;\n\n            svg {\n                display: none;\n            }\n\n            .acc-form-header {\n                display: inline-block;\n                position: relative;\n                width: 100%;\n\n                span {\n                    font-size: 14px;\n                    color: $grey-3;\n                    font-family: $fonts;\n                    font-weight: 400;\n\n                    b {\n                        font-weight: 600;\n                        margin-left: 6px;\n                    }\n                }\n\n                i {\n                    position: absolute;\n                    right: 0;\n                    color: $grey-3;\n                    font-size: 14px;\n                    line-height: 0;\n                    top: 12px;\n                    font-weight: bold;\n\n                    &.pi.pi-trash {\n                        right: -43px;\n\n                        &:hover {\n                            color: $delete;\n                        }\n                    }\n                }\n            }\n        }\n\n        .p-accordion-tab {\n            margin-bottom: 20px;\n\n            &:last-child {\n                margin-bottom: 0;\n            }\n        }\n\n        .p-accordion-content {\n            border: 0;\n            padding: 0;\n\n            .stepper-border {\n                border: 1px solid $grey-4;\n                border-radius: 10px;\n                padding: 20px;\n                margin-top: 20px;\n            }\n        }\n    }\n\n    .stepper-body {\n        padding-right: 40px;\n\n        .stepper-border-inner {\n            border: 1px solid $grey-4;\n            border-radius: 10px;\n            padding: 20px;\n        }\n    }\n\n    .stepper-footer {\n        display: flex;\n        justify-content: space-between;\n        width: 100%;\n        background-color: $interface-white;\n        padding-top: 20px;\n\n        .stepper-footer-inner {\n            display: flex;\n            justify-content: space-between;\n\n            @include media-breakpoint-down(lg) {\n                justify-content: center;\n            }\n        }\n    }\n}\n\n.stepper-main_butter_pie {\n    width: calc(100% - 100px);\n    padding-right: 15px;\n\n    &.stepper-step-2 {\n        width: 100%;\n        padding-right: 0;\n    }\n\n    @include media-breakpoint-down(xl) {\n        width: calc(100% - 400px);\n\n        &.stepper-step-2 {\n            .stepper-wrapper {\n                &.stepper-wrapper-ft {\n                    width: 100%;\n                }\n            }\n        }\n    }\n\n    @include media-breakpoint-down(lg) {\n        width: 100%;\n        padding-right: 0;\n        margin-bottom: 20px;\n    }\n\n    .stepper-form {\n        height: calc(100vh - 297px);\n        overflow-y: auto;\n\n        @include media-breakpoint-down(lg) {\n            height: auto;\n        }\n\n        .upload-file-step {\n            padding-top: 25px;\n\n            @include media-breakpoint-down(lg) {\n                width: 100%;\n            }\n\n            @include media-breakpoint-down(md) {\n                padding-top: 15px;\n            }\n\n            small {\n                font-size: 14px;\n                display: inline-block;\n                margin-bottom: 25px;\n                width: 100%;\n\n                b {\n                    color: $primary-color;\n                    text-decoration: underline;\n                }\n            }\n\n            .home-search {\n                max-width: 400px;\n\n                input {\n                    height: 54px;\n                    width: 100%;\n                    cursor: pointer !important;\n                    padding: 20px 62px 20px 20px;\n\n                    @include media-breakpoint-down(lg) {\n                        height: 48px;\n                    }\n\n                    @include media-breakpoint-down(md) {\n                        height: 38px;\n                    }\n                }\n            }\n        }\n    }\n\n    .stepper-wrapper {\n        // width: 750px;\n        max-width: 100%;\n\n        @include media-breakpoint-down(lg) {\n            width: 100%;\n        }\n\n        .form-row {\n            @include media-breakpoint-down(md) {\n                margin: 0 -10px;\n            }\n\n            .form-col {\n                width: 50%;\n\n                @include media-breakpoint-down(md) {\n                    width: 100%;\n                    margin-bottom: 10px;\n                }\n\n                &.full-col {\n                    width: 100%;\n                }\n\n                .p-inputnumber {\n                    width: 100%;\n                }\n            }\n        }\n\n        &.stepper-wrapper-ft {\n            width: 770px;\n            max-width: 100%;\n\n            @include media-breakpoint-down(lg) {\n                width: 100%;\n            }\n        }\n    }\n\n    .stepper-top {\n        width: 100%;\n        padding: 20px 40px 25px 20px;\n    }\n\n    .stepper-middle {\n        width: 100%;\n        padding: 20px 40px 20px 0;\n        border-top: 1px solid $grey-4;\n\n        .p-accordion-header-link {\n            background-color: $interface-light-grey;\n            border: 1px solid $grey-4;\n            border-radius: 10px;\n            padding: 10px 20px;\n            text-decoration: none;\n\n            svg {\n                display: none;\n            }\n\n            .acc-form-header {\n                display: inline-block;\n                position: relative;\n                width: 100%;\n\n                span {\n                    font-size: 14px;\n                    color: $grey-3;\n                    font-family: $fonts;\n                    font-weight: 400;\n\n                    b {\n                        font-weight: 600;\n                        margin-left: 6px;\n                    }\n                }\n\n                i {\n                    position: absolute;\n                    right: 0;\n                    color: $grey-3;\n                    font-size: 14px;\n                    line-height: 0;\n                    top: 12px;\n                    font-weight: bold;\n\n                    &.pi.pi-trash {\n                        right: -43px;\n\n                        &:hover {\n                            color: $delete;\n                        }\n                    }\n                }\n            }\n        }\n\n        .p-accordion-tab {\n            margin-bottom: 20px;\n\n            &:last-child {\n                margin-bottom: 0;\n            }\n        }\n\n        .p-accordion-content {\n            border: 0;\n            padding: 0;\n\n            .stepper-border {\n                border: 1px solid $grey-4;\n                border-radius: 10px;\n                padding: 20px;\n                margin-top: 20px;\n            }\n        }\n    }\n\n    .stepper-body {\n        padding-right: 40px;\n\n        .stepper-border-inner {\n            border: 1px solid $grey-4;\n            border-radius: 10px;\n            padding: 20px;\n        }\n    }\n\n    .stepper-footer {\n        display: flex;\n        justify-content: space-between;\n        width: 100%;\n        background-color: $interface-white;\n        padding-top: 20px;\n\n        .stepper-footer-inner {\n            display: flex;\n            justify-content: space-between;\n\n            @include media-breakpoint-down(lg) {\n                justify-content: center;\n            }\n        }\n    }\n}\n\n.step-preview-wrap {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-between;\n\n    .stepper-main {\n        .stepper-form {\n            padding: 20px;\n        }\n    }\n}\n\n.upload-file-step {\n    .form-label {\n        width: 100%;\n    }\n\n    .outline-select {\n        width: 100%;\n    }\n}\n\n.p-accordion-tab {\n    .p-accordion-header {\n        a {\n            text-decoration: none;\n            color: #000;\n            background-color: #ccc;\n            padding: 10px;\n            margin-bottom: 10px;\n\n            svg {\n                margin-right: 5px;\n            }\n        }\n    }\n}\n\n\n.chart-table-wrapper {\n    display: flex;\n    flex-wrap: wrap;\n    margin: 0 -15px;\n\n    .custom-card1 {\n        width: 60%;\n        padding: 15px;\n\n        .custom-card-inner {\n            padding: 15px;\n            background-color: #fff;\n            box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n            height: 100%;\n            border-radius: 15px;\n        }\n    }\n\n    .custom-card2 {\n        width: 40%;\n        padding: 15px;\n\n        .custom-card-inner {\n            padding: 15px;\n            background-color: #fff;\n            box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n            height: 100%;\n            border-radius: 15px;\n        }\n    }\n}\n\n.btn-group {\n    display: flex;\n}\n\n.btn {\n    display: flex;\n    align-items: center;\n    padding: 8px 16px;\n    background: #ffffff;\n    border: 1px solid #d0d7de;\n    border-radius: 6px;\n    font-size: 14px;\n    cursor: pointer;\n    font-family: Arial, sans-serif;\n    color: #333;\n    transition: 0.2s ease;\n}\n\n.btn:hover {\n    background: #f5f5f5;\n    border-color: #c5cacf;\n}\n\n.icon {\n    display: flex;\n    font-size: 16px;\n    margin-right: 4px;\n}\n\n.head-btn-top {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    margin-bottom: 15px;\n\n    h4 {\n        margin-bottom: 0;\n    }\n}\n\n// .modebar-container\n.modebar.modebar--custom>.modebar-group:nth-child(2),\n.modebar.modebar--custom>.modebar-group:nth-child(4) {\n    display: none !important;\n}\n\n.modebar-group {\n    padding-left: 0px !important;\n}\n\n.modebar-btn.custom-plotly-btn {\n    display: inline-flex !important;\n    align-items: center;\n    justify-content: center;\n    padding: 3px !important;\n    margin: 0 1px !important;\n    border-radius: 3px !important;\n    height: 24px !important;\n    width: 24px !important;\n    vertical-align: middle !important;\n}\n\n// new\n/* wider, two-column cards like reference */\n.quick-grid {\n    margin: 40px auto 48px;\n    margin-top: auto;\n    display: grid;\n    grid-template-columns: repeat(2, minmax(320px, 1fr));\n    gap: 24px;\n    max-width: 1040px;\n    width: 100%;\n}\n\n.quick-card {\n    background: #ffffff;\n    border-radius: 22px;\n    border: 1px solid #e5e7eb;\n    box-shadow: 0 20px 40px rgba(15, 23, 42, 0.06);\n    padding: 18px 24px;\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    cursor: pointer;\n    transition: transform 0.12s ease, box-shadow 0.12s ease, border-color 0.12s;\n}\n\n.quick-card:hover {\n    transform: translateY(-3px);\n    box-shadow: 0 22px 45px rgba(15, 23, 42, 0.09);\n    border-color: #c7d2fe;\n}\n\n.quick-icon-pill {\n    width: 46px;\n    height: 46px;\n    border-radius: 18px;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.quick-icon-pill svg {\n    width: 24px;\n    height: 24px;\n}\n\n.pill-blue {\n    background: #eef2ff;\n}\n\n.pill-green {\n    background: #dcfce7;\n}\n\n.pill-purple {\n    background: #f5f3ff;\n}\n\n.pill-amber {\n    background: #fef3c7;\n}\n\n.quick-meta {\n    text-align: left;\n}\n\n.quick-label {\n    font-size: 11px;\n    text-transform: uppercase;\n    letter-spacing: 0.14em;\n    color: #9ca3af;\n    margin-bottom: 4px;\n}\n\n.quick-question {\n    font-size: 14px;\n    color: #111827;\n}\n\n.vc-heading {\n    text-align: center;\n    padding: 20px 0;\n\n    .accent {\n        color: #4f46e5;\n        font-style: italic;\n    }\n\n    p {\n        font-size: 16px;\n        color: #6b7280;\n    }\n}","#root,\nbody,\n.app,\nhtml {\n    background-color: transparent;\n    font-family: $fonts;\n\n}\n\nbody {\n    width: 100%;\n}\n\n.p-component,\np,\na,\ndiv,\nli,\nb,\nstrong,\nspan {\n    font-family: $fonts;\n}\n\n.clip-loader {\n    position: fixed;\n    background-color: rgba($interface-black, 0.7);\n    width: 100%;\n    height: 100%;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 9999;\n}\n\n.clip-loader-bot {\n    position: absolute;\n    /* Changed from fixed */\n    background-color: rgba(0, 0, 0, 0.7);\n    /* Semi-transparent overlay */\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 9999;\n    border-radius: 19px;\n}\n\n\n.loader-spinner {\n    background-image: url(\"../../images/RON-loader.gif\");\n    background-size: cover;\n    background-repeat: no-repeat;\n    width: 100px;\n    height: 100px;\n}\n\n\n::-webkit-scrollbar {\n    width: 5px;\n    height: 5px;\n    background-color: transparent;\n}\n\n::-webkit-scrollbar-track {\n    background-color: transparent;\n}\n\n::-webkit-scrollbar-thumb {\n    background: #C8C8C8;\n    border-radius: 8px;\n}\n\n.range-slider-container {\n    position: relative;\n    width: 100%;\n}\n\n.tooltip {\n    visibility: hidden;\n    background-color: $grey-3;\n    color: $interface-white;\n    text-align: center;\n    width: 35px;\n    height: 18px;\n    position: absolute;\n    z-index: 1;\n    bottom: 110%;\n    left: 50%;\n    transform: translateX(-50%);\n    top: -22px;\n    border-radius: 30px;\n    font-size: 12px;\n    font-family: $fonts;\n}\n\n.range-slider-container:hover .tooltip {\n    visibility: visible;\n    opacity: 1;\n}\n\n.wrapper {\n    position: relative;\n    height: 40px;\n    width: 300px;\n    overflow: hidden;\n    display: flex;\n    flex-direction: row;\n    border-radius: 4px;\n}\n\n.sufix {\n    position: relative;\n    height: auto;\n    width: auto;\n    display: flex;\n    justify-content: center;\n    align-content: center;\n    flex-direction: column;\n    background: rgb(243, 242, 241);\n    color: rgb(96, 94, 92);\n    display: flex;\n    align-items: center;\n    white-space: nowrap;\n    flex-shrink: 0;\n    padding: 0px 10px;\n    box-sizing: border-box;\n}\n\n.c-pointer {\n    cursor: pointer;\n}\n\n#RFS-StepButton:disabled {\n    cursor: default;\n}\n\n.border-red {\n    border: 1px solid #EC292E !important;\n}\n\n.p-4.content-wrapper {\n    padding: 20px !important;\n\n    @include media-breakpoint-down(md) {\n        padding: 15px !important;\n    }\n}\n\n.access-denied {\n    padding: 20px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n\n    p {\n        font-size: 24px;\n\n        @include media-breakpoint-down(md) {\n            font-size: 16px;\n        }\n    }\n\n    h2,\n    p {\n        text-align: center;\n    }\n}\n\n.Toastify__toast-theme--light {\n    background: $grey-1 !important;\n    color: #000000 !important;\n    font-size: 14px !important;\n    line-height: 22px !important;\n    font-weight: 500 !important;\n    font-family: 'Inter', sans-serif !important;\n    box-shadow: none !important;\n    border-radius: 10px !important;\n\n    .Toastify__close-button--light {\n        color: $grey-2;\n        opacity: 1;\n    }\n}\n\n.custom-tooltip {\n    color: $interface-white;\n    padding: 5px 10px;\n    font-size: 12px;\n}\n\n.p-confirm-popup:after {\n    border-width: 8px;\n    margin-left: -8px;\n    border: none;\n}\n\n.p-datepicker {\n    table {\n        td {\n            span.p-highlight {\n                color: $primary-color;\n                background-color: rgba($primary-color, 0.1);\n                box-shadow: none;\n            }\n\n            &.p-datepicker-today {\n\n                span.p-highlight,\n                span {\n                    background-color: $primary-color;\n                    color: $interface-white;\n                    box-shadow: none;\n                }\n            }\n        }\n    }\n}\n\n.p-datepicker .p-datepicker-header .p-datepicker-title .p-datepicker-year:enabled:hover,\n.p-datepicker .p-datepicker-header .p-datepicker-title .p-datepicker-month:enabled:hover {\n    color: $primary-color;\n}\n\n.temp_span {\n    width: 100%;\n    display: block;\n    font-size: 12px;\n    color: $grey-2;\n    font-weight: 500;\n    transition: all 0.3s ease-in-out;\n}\n\n.temp_a {\n    cursor: default !important;\n}\n\n.stars_bot {\n    display: flex;\n    margin-left: 9px;\n}\n\n.empty-star_bot {\n    color: #ccc;\n    font-size: 12px;\n    padding: 2px;\n}\n\n.full-star_bot {\n    color: #ffc107;\n    font-size: 12px;\n    padding: 2px;\n}\n\n.half-star_bot {\n    font-size: 12px;\n    color: #ccc;\n    background: linear-gradient(90deg, #ffc107 50%, #FFFFFF 50%);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    padding: 2px;\n    -webkit-text-stroke-width: 1px;\n    -webkit-text-stroke-color: #ffc107;\n}\n\n.quarter-star_bot {\n    font-size: 12px;\n    color: #ccc;\n    background: linear-gradient(90deg, #ffc107 43%, #FFFFFF 25%);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    padding: 2px;\n    -webkit-text-stroke-width: 1px;\n    -webkit-text-stroke-color: #ffc107;\n}\n\n.three-quarter-star_bot {\n    font-size: 12px;\n    color: #ccc;\n    background: linear-gradient(90deg, #ffc107 61%, white 56%);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    padding: 2px;\n    -webkit-text-stroke-width: 1px;\n    -webkit-text-stroke-color: #ffc107;\n}\n\n.passowrd-padding {\n    padding-right: 34px !important;\n}\n\n.myLabelComponentInSvg {\n    height: 70px;\n    width: 180px;\n    margin: 10px;\n}\n\n.temp-height {\n    height: calc(100vh - 132px);\n}\n\n.item-header-butterpie {\n    cursor: pointer;\n\n    &.active {\n        pointer-events: none;\n        background-color: rgba(137, 43, 44, 0.05);\n        color: $primary-color;\n    }\n}\n\n.item-header-butterpie:hover {\n    background-color: rgba(137, 43, 44, 0.05);\n    color: $primary-color;\n}\n\n.form-field-wrap-bot-con {\n    width: 40%;\n    border: 1px solid $grey-4;\n    border-radius: 30px;\n    height: 38px;\n    box-shadow: none;\n    outline: none;\n    display: flex;\n    align-items: center;\n    font-size: 12px;\n\n    &.color-container {\n        padding: 0 10px;\n        display: flex;\n        align-items: center;\n\n        .color-palette {\n            overflow: hidden;\n            height: 16px;\n            width: 16px;\n            display: inline-flex;\n            border-radius: 50%;\n            border: 1px solid $grey-4;\n\n            input[type=\"color\"] {\n                height: 100%;\n                width: 100%;\n                padding: 0;\n                display: inline-block;\n                border: none;\n                box-shadow: none;\n                outline: none;\n                -webkit-appearance: none;\n                cursor: pointer;\n            }\n\n            input[type=\"color\"]::-webkit-color-swatch-wrapper {\n                padding: 0;\n            }\n\n            input[type=\"color\"]::-webkit-color-swatch {\n                border: none;\n            }\n        }\n    }\n\n    .file-label {\n        font-size: 12px;\n        margin-left: 12px;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n    }\n\n    .file-btn {\n        background-color: $grey-4;\n        border: 0;\n        font-size: 12px;\n        height: 38px;\n        width: 105px;\n        border-radius: 30px 0 0 30px;\n        margin-left: -1px;\n    }\n}\n\n.date-validation {\n    input {\n        border: 1px solid #EC292E !important;\n    }\n}\n\n.text-danger {\n    color: #EC292E !important;\n    font-size: 12px !important;\n}\n\n.my-badge {\n    width: 24px;\n    height: 24px;\n    font-size: 14px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: 700;\n    background-color: $primary-color;\n    /* Custom background */\n    color: white;\n    // border-radius: 10px;\n    // /* default pill shape */\n    // padding: 0.25rem 0.5rem;\n    /* Text color */\n}\n\n.my-badge-circle {\n    background-color: $primary-color;\n    /* Custom background */\n    color: white;\n    width: 32px;\n    height: 32px;\n    border-radius: 50% !important;\n    display: flex !important;\n    align-items: center;\n    justify-content: center;\n    padding: 0 !important;\n    font-size: 14px;\n}\n\n// toast\n.p-toast {\n    .p-toast-message {\n        .p-toast-message-content {\n            padding: 1rem;\n\n            .p-toast-message-icon {\n                &.p-icon {\n                    width: 2rem;\n                    height: 2rem;\n                }\n            }\n\n            .p-toast-message-text {\n                margin: 0 0 0 1rem;\n            }\n        }\n\n        &.p-toast-message-error {\n            background: rgba(255, 231, 230, 0.7);\n            border: solid #ff5757;\n            border-width: 0 0 0 6px;\n            color: #ff5757;\n        }\n    }\n}",".bot-header {\n    width: 100%;\n    border-bottom: 1px solid rgba($interface-white, 0.48);\n    padding-bottom: 5px;\n    margin-bottom: 15px;\n\n    .bot-head-listing {\n        display: flex;\n        flex-wrap: wrap;\n        list-style-type: none;\n        padding-left: 0;\n        margin-bottom: 0;\n\n        li {\n            margin-right: 10px;\n            margin-bottom: 10px;\n\n            span {\n                font-size: 12px;\n                color: $interface-black;\n                border-radius: 25px;\n                background-color: $interface-white;\n                box-shadow: 0 1px 4px rgba($interface-black, 0.1);\n                display: inline-block;\n                padding: 10px 15px 10px 15px;\n                cursor: pointer;\n\n                &.active {\n                    background-color: $primary-color;\n                    color: $interface-white;\n                }\n\n                &:hover {\n                    background-color: $primary-color;\n                    color: $interface-white;\n                }\n\n                i {\n                    display: inline-block;\n                    margin-left: 8px;\n                }\n            }\n        }\n    }\n}\n\n.product-slider {\n    margin-bottom: 15px;\n\n    .product-card {\n        padding: 0 5px;\n        height: 100%;\n\n        &.active {\n            .product-card-wrap {\n                border-color: $primary-color;\n\n                figure {\n                    figcaption {\n                        background-color: $primary-color;\n                    }\n                }\n            }\n        }\n\n        .product-card-wrap {\n            width: 100%;\n            background-color: $interface-white;\n            border-radius: 15px;\n            height: 100%;\n            cursor: pointer;\n\n            figure {\n                margin-bottom: 0;\n                height: 100%;\n                border-radius: 0 0 15px 15px;\n                overflow: hidden;\n\n                span {\n                    display: flex;\n                    min-height: 132px;\n                    align-items: center;\n                    justify-content: center;\n                    border: 1px solid #404040;\n                    border-radius: 15px 15px 0 0;\n\n                    img {\n                        width: 80px;\n                        max-width: 100%;\n                        padding: 5px;\n                        object-fit: contain;\n                        max-height: 130px;\n                    }\n\n                }\n\n                figcaption {\n                    background-color: $grey-2;\n                    border-radius: 0 0 15px 15px;\n                    padding: 10px;\n                    display: flex;\n                    height: 100%;\n\n                    p {\n                        font-size: 10px;\n                        color: #F7F4FF;\n                        width: calc(100% - 2px);\n                        padding-right: 5px;\n                        margin-bottom: 0;\n                        word-break: break-word;\n                    }\n\n                    i {\n                        display: inline-block;\n\n                        img {\n                            padding: 0;\n                        }\n                    }\n                }\n            }\n        }\n    }\n\n    .p-carousel-indicators {\n        display: none;\n    }\n\n    .p-carousel-items-container {\n        margin: 0 -5px;\n    }\n\n    .p-disabled,\n    button:disabled {\n        background-color: transparent !important;\n        border-color: transparent !important;\n\n        svg {\n            color: #6E6E6E;\n        }\n    }\n\n    button {\n        background-color: transparent !important;\n        border-color: transparent !important;\n\n        svg {\n            color: #141414;\n            width: 20px !important;\n            height: 20px !important;\n        }\n    }\n}\n\n.product-detail-wrap {\n    border-radius: 20px;\n    background-color: $interface-white;\n    position: absolute;\n    top: 20px;\n    left: 20px;\n    right: 20px;\n    bottom: 90px;\n    z-index: 1;\n\n    .product-details {\n        // height: calc(100vh - 307px);\n        // height: calc(100vh - 347px);\n        height: calc(100vh - 357px);\n        overflow-y: auto;\n        overflow-x: hidden;\n        border-end-start-radius: 22px;\n        border-end-end-radius: 22px;\n\n        .close-product {\n            cursor: pointer;\n            position: static;\n            // right: 0;\n            // top: 0;\n            line-height: 0;\n            background-color: $interface-white;\n            padding: 15px;\n            border-radius: 0 20px 0 0;\n            // z-index: 11;\n            display: flex;\n            justify-content: flex-end;\n            border-radius: 20px 20px 0 0;\n        }\n\n        .product-top {\n            padding: 15px;\n            // border-bottom: 1px solid $grey-4;\n\n            // @include media-breakpoint-down(sm) {\n            //     padding: 15px;\n            // }\n\n            figure {\n                max-width: 160px;\n                margin: 0 auto;\n                min-height: 210px;\n                display: flex;\n                align-items: center;\n\n                @include media-breakpoint-down(sm) {\n                    max-width: 100px;\n                }\n\n                img {\n                    width: 100%;\n                    object-fit: contain;\n                }\n            }\n        }\n\n        .product-bottom {\n            padding: 15px 15px 0 15px;\n            // height: calc(100vh - 670px);\n            // height: calc(100vh - 630px);\n            overflow-y: auto;\n            border-top: 1px solid $grey-4;\n\n            @include media-breakpoint-down(sm) {\n                // height: calc(100vh - 540px);\n                // height: calc(100vh - 470px);\n            }\n\n            .product-name {\n                font-size: 14px;\n                font-weight: 500;\n                color: $grey-3;\n                display: block;\n                margin-bottom: 4px;\n            }\n\n            strong {\n                font-size: 14px;\n                display: block;\n                color: $grey-3;\n                font-weight: 700;\n            }\n\n            .star-review {\n                display: flex;\n\n                .star-rating {\n                    list-style-type: none;\n                    padding-left: 0;\n                    display: flex;\n                    align-items: center;\n                    margin-bottom: 0;\n                    margin-right: 8px;\n\n                    li {\n                        margin-bottom: 0;\n\n                        i {\n                            line-height: 0;\n                            display: flex;\n                        }\n                    }\n                }\n\n                .rating {\n                    color: $grey-14;\n                    font-size: 12px;\n                    margin-right: 16px;\n                    display: inline-block;\n                }\n\n                .review-rating {\n                    font-size: 12px;\n                    color: $purple;\n                    cursor: pointer;\n                    text-decoration: none;\n                }\n            }\n\n            .product-list-details {\n                margin-top: 9px;\n                list-style-type: none;\n                padding-left: 0;\n                margin-bottom: 0;\n\n                li {\n                    padding: 9px 0;\n                    border-bottom: 1px solid $grey-17;\n\n                    &:last-child {\n                        border-bottom: 0;\n                    }\n\n                    p {\n                        color: $grey-3;\n                        font-size: 12px;\n                        margin-bottom: 0;\n                    }\n                }\n            }\n        }\n\n        .pro-action-btn {\n            list-style-type: none;\n            padding-left: 0;\n            margin-bottom: 0;\n            display: flex;\n            padding: 15px;\n            margin: 0 -10px;\n\n            @include media-breakpoint-down(sm) {\n                margin: 0 -5px;\n            }\n\n            li {\n                padding: 0 10px;\n                width: 50%;\n\n                @include media-breakpoint-down(sm) {\n                    padding: 0 5px;\n                }\n\n                button {\n                    width: 100%;\n                }\n            }\n        }\n\n        .active-cart-btn {\n            pointer-events: none;\n        }\n\n        .compare-toast {\n            background-color: #F1F9ED;\n            border-radius: 30px;\n            font-size: 12px;\n            color: #303030;\n            font-weight: 500;\n            position: absolute;\n            left: 0;\n            right: 0;\n            bottom: 15px;\n            margin: 0 auto;\n            max-width: 148px;\n            height: 38px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            border: 1px solid $primary-color;\n            z-index: 1;\n\n            &.large-box {\n                width: 93%;\n                max-width: initial;\n            }\n        }\n\n        .p-carousel-prev,\n        .p-carousel-next {\n            // position: absolute;\n            position: relative;\n            z-index: 1;\n        }\n\n        .p-carousel-prev {\n            left: 0;\n        }\n\n        .p-carousel-next {\n            right: 0;\n        }\n\n        .p-disabled,\n        button:disabled {\n            background-color: transparent !important;\n            border-color: transparent !important;\n\n            svg {\n                color: #6E6E6E;\n            }\n        }\n\n        button {\n            // background-color: transparent !important;\n            // border-color: transparent !important;\n\n            svg {\n                color: #141414;\n                width: 20px !important;\n                height: 20px !important;\n            }\n        }\n    }\n\n    // .product-details {\n    //     height: auto;\n    //     .p-carousel-items-container {\n    //         height: 142px;\n    //     }\n    //     figure {\n    //         min-height: 113px !important;\n    //         img {\n    //             height: 115px !important;\n    //         }\n    //     }\n    //     .product-bottom {\n    //         height: 60px;\n    //     }\n    //     .pro-action-btn {\n    //         padding: 6px;\n    //         button {\n    //             font-size: 11px;\n    //         }\n    //     }\n    // }\n\n    .style-section {\n        h3 {\n            font-size: 14px;\n            padding: 10px 15px 15px 15px;\n        }\n\n        .style-recommendation-container {\n            width: 100%;\n            background: #F8F8F8;\n            margin-bottom: 10px;\n\n            .style-recommendation {\n                display: grid;\n                grid-template-columns: 1.4fr 1fr;\n                gap: 10px;\n\n                .product-top {\n                    padding: 15px 0px 11px 16px;\n\n                    figure {\n                        max-width: 228px;\n                    }\n                }\n\n                .recommendation-section {\n                    padding: 15px 0px 0px 0px;\n                    margin-left: 22px;\n\n                    .single-recommendation {\n                        width: 132px;\n                        height: 118px;\n                        cursor: pointer;\n                        margin-bottom: 4px;\n\n                        figure {\n                            margin-bottom: 5px;\n\n                            img {\n                                width: 60px;\n                                height: 60px;\n                            }\n                        }\n\n                        p {\n                            font-size: 10px;\n                            margin-bottom: 5px;\n                            display: -webkit-box;\n                            -webkit-line-clamp: 2;\n                            -webkit-box-orient: vertical;\n                            overflow: hidden;\n                            text-overflow: ellipsis;\n                            line-height: 1.2;\n                            max-height: 2.4em;\n                        }\n\n                        h6 {\n                            font-size: 11px;\n                            font-weight: 700\n                        }\n                    }\n                }\n            }\n\n            .p-carousel-indicator {\n                button {\n                    width: 8px;\n                    border-radius: 6px;\n                }\n            }\n\n            .p-carousel-indicator.p-highlight {\n                button {\n                    background-color: #5627D9;\n                }\n            }\n\n            .p-carousel-indicators {\n                margin-bottom: 0px;\n            }\n        }\n    }\n\n    .product-details-chat {\n        display: flex;\n        flex-direction: column;\n        padding: 15px;\n        // height: 173px;\n        // overflow: auto;\n        // background: #d3d3d354;\n        // padding: 11px;\n        // .input-message-container, .output-message-container {\n        //     p {\n        //         font-size: 10px;\n        //         padding: 8px;\n        //     }\n        // }\n    }\n\n    &.remove-product {\n        top: 343px;\n        left: 0;\n        right: 0;\n        bottom: 0;\n\n        @include media-breakpoint-down(sm) {\n            top: 130px;\n        }\n\n        .product-details {\n            position: relative;\n            z-index: 11;\n\n            &::before {\n                content: \"\";\n                background-color: rgba(0, 0, 0, 0.2);\n                left: 0;\n                right: 0;\n                top: 0;\n                bottom: 0;\n                position: fixed;\n                z-index: -1;\n            }\n\n            .product-listing,\n            .pro-action-btn {\n                background-color: $interface-white;\n            }\n        }\n\n        &.similar-product {\n            .product-details {\n                .product-listing {\n                    height: calc(100vh - 572px);\n\n\n                    @include media-breakpoint-down(sm) {\n                        height: calc(100vh - 357px);\n                    }\n                }\n\n                .product-listing-wrap {\n                    cursor: pointer;\n                }\n            }\n        }\n\n        .product-details {\n            .product-heading {\n                padding: 15px 30px 0 30px;\n                display: flex;\n                align-items: center;\n                justify-content: space-between;\n                background-color: $interface-white;\n                border-radius: 20px 20px 0 0;\n\n                h5 {\n                    font-weight: 500;\n                    font-size: 14px;\n                    color: $grey-3;\n                    margin-bottom: 0;\n                }\n            }\n\n            .product-listing {\n                height: calc(100vh - 640px);\n                overflow-y: auto;\n                background-color: $interface-white;\n\n                @include media-breakpoint-down(sm) {\n                    height: calc(100vh - 427px);\n                }\n            }\n\n            .product-listing-wrap {\n                display: flex;\n                flex-wrap: wrap;\n                padding: 15px 30px;\n                border-bottom: 1px solid $grey-4;\n\n                .product-checkbox {\n                    margin-right: 15px;\n                }\n\n                .product-right {\n                    display: flex;\n                    flex-wrap: wrap;\n                    width: calc(100% - 35px);\n\n                    figure {\n                        width: 55px;\n                        margin-bottom: 0;\n                        margin-right: 15px;\n\n                        img {\n                            width: 100%;\n                        }\n                    }\n\n                    .pro-sm-info {\n                        width: calc(100% - 70px);\n\n                        p {\n                            font-size: 12px;\n                            font-weight: 500;\n                            color: $grey-3;\n                            margin-bottom: 0;\n                            white-space: nowrap;\n                            text-overflow: ellipsis;\n                            overflow: hidden;\n                        }\n\n                        strong {\n                            font-size: 14px;\n                            color: $grey-3;\n                            font-weight: 700;\n                        }\n\n                        .pro-review {\n                            font-size: 12px;\n                            font-weight: 400;\n                            color: $grey-3;\n                            display: flex;\n                            align-items: center;\n\n                            i {\n                                line-height: 0;\n                                margin-right: 4px;\n                                display: flex;\n                                align-items: center;\n                            }\n                        }\n                    }\n                }\n            }\n\n            .pro-action-btn {\n                padding: 15px 30px;\n            }\n        }\n    }\n\n    .compare-head {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        padding: 15px;\n        border-bottom: 1px solid $grey-4;\n\n        h5 {\n            font-weight: 500;\n            font-size: 14px;\n            color: $grey-3;\n            margin-bottom: 0;\n        }\n\n        .compare-head-right {\n            display: flex;\n            align-items: center;\n\n            i {\n                display: flex;\n                align-items: center;\n                cursor: pointer;\n\n                &.add-product {\n                    margin-right: 15px;\n                }\n            }\n        }\n    }\n\n    .compare-product {\n        display: flex;\n        flex-wrap: wrap;\n        height: calc(100vh - 365px);\n        overflow-y: auto;\n\n        .compare-col {\n            border-right: 1px solid $grey-4;\n            width: 50%;\n\n            &:last-child {\n                border-right: 0;\n            }\n\n            .compare-top {\n                padding: 15px;\n                position: relative;\n\n                .remove-product {\n                    position: absolute;\n                    top: 4px;\n                    right: 4px;\n                    line-height: 0;\n                    cursor: pointer;\n                }\n\n                figure {\n                    width: 90px;\n                    max-width: 100%;\n                    margin: 0 auto 15px auto;\n\n                    img {\n                        width: 100%;\n                    }\n                }\n\n                .pro-sm-info {\n                    p {\n                        font-size: 12px;\n                        font-weight: 500;\n                        color: $grey-3;\n                        margin-bottom: 0;\n\n                        .green-txt {\n                            color: $active;\n                        }\n                    }\n\n                    strong {\n                        font-size: 14px;\n                        color: $grey-3;\n                        font-weight: 700;\n                    }\n\n                    .pro-review {\n                        font-size: 12px;\n                        font-weight: 400;\n                        color: $grey-3;\n                        display: flex;\n                        align-items: center;\n                        margin-bottom: 12px;\n\n                        i {\n                            line-height: 0;\n                            margin-right: 4px;\n                            display: flex;\n                            align-items: center;\n                        }\n                    }\n                }\n            }\n\n            .pro-seprator {\n                background-color: $grey-1;\n                font-size: 12px;\n                color: $grey-3;\n                padding: 3px 15px;\n            }\n\n            .compare-bottom {\n                padding: 15px;\n\n                p {\n                    font-size: 11px;\n                    margin-bottom: 5px;\n\n                    &:last-child {\n                        margin-bottom: 0;\n                    }\n                }\n            }\n\n            &.add-new-product {\n                .compare-top {\n                    text-align: center;\n\n                    .btn-area {\n                        margin-bottom: 55px;\n\n                        button {\n                            width: 130px;\n                            max-width: 100%;\n                        }\n                    }\n                }\n\n                .placeholder-img {\n                    height: 116px;\n                    width: 116px;\n                    background-color: $grey-1;\n                    border-radius: 10px;\n                    display: inline-block;\n                    margin-bottom: 10px;\n                }\n\n                .pro-sm-info p,\n                p {\n                    color: $grey-14;\n                    text-align: left;\n                }\n            }\n        }\n\n        &.three-col {\n            .compare-col {\n                width: 33.33%;\n            }\n        }\n    }\n}\n\n// suggest image\n.suggest-img-wrap {\n    padding-left: 0;\n    list-style-type: none;\n    display: flex;\n    flex-wrap: wrap;\n    margin: 0 -10px 15px -10px;\n\n    li {\n        padding: 0 10px;\n\n        figure {\n            margin-bottom: 0;\n            border: 2px solid #787878;\n            border-radius: 10px;\n            cursor: pointer;\n\n            &.active-suggest {\n                border-color: $primary-color;\n            }\n\n            img {\n                height: 70px;\n                width: 70px;\n                object-fit: cover;\n            }\n        }\n    }\n}\n\n.choose-file {\n    position: absolute;\n    right: 15px;\n    line-height: 0;\n\n    label {\n        cursor: pointer;\n    }\n\n    input[type=\"file\"] {\n        position: absolute;\n        height: 0 !important;\n        width: 0 !important;\n        opacity: 0;\n        visibility: hidden;\n        padding: 0 !important;\n    }\n}\n\n// product cart\n.prodct-cart-body {\n    .product-detail-wrap {\n        bottom: 20px;\n        border-radius: 10px;\n    }\n\n    .compare-head {\n        padding: 10px;\n    }\n}\n\n.product-cart {\n    overflow-x: auto;\n\n    .p-datatable {\n        .p-datatable-wrapper {\n            // height: calc(100vh - 360px);\n            // height: calc(100vh - 400px);\n            height: calc(100vh - 410px);\n        }\n    }\n\n    table {\n        width: 100%;\n    }\n\n    th,\n    td {\n        padding: 10px;\n        font-size: 14px;\n\n        .delete-product {\n            display: inline-block;\n            cursor: pointer;\n        }\n\n        @include media-breakpoint-down(sm) {\n            font-size: 12px;\n        }\n    }\n\n    th {\n        border-bottom: 1px solid #E1E1E1;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
